webpackJsonp([6],{

/***/ "+4gK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),(_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre(s)")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.Nombre),expression:"item_usuariosValidations.Nombre"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.Nombre),expression:"item_usuarios.Nombre"}],staticClass:"form-control",attrs:{"type":"text","name":"Nombre","placeholder":"Nombre(s)"},domProps:{"value":(_vm.item_usuarios.Nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "Nombre", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.Nombre.invalid),expression:"Nombre.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('Nombre'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Apellido Paterno")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.Paterno),expression:"item_usuariosValidations.Paterno"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.Paterno),expression:"item_usuarios.Paterno"}],staticClass:"form-control",attrs:{"type":"text","name":"Paterno","placeholder":"Apellido Paterno"},domProps:{"value":(_vm.item_usuarios.Paterno)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "Paterno", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.Paterno.invalid),expression:"Paterno.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('Paterno'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Apellido Materno")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.Materno),expression:"item_usuariosValidations.Materno"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.Materno),expression:"item_usuarios.Materno"}],staticClass:"form-control",attrs:{"type":"text","name":"Materno","placeholder":"Apellido Materno"},domProps:{"value":(_vm.item_usuarios.Materno)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "Materno", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Correo")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.User),expression:"item_usuariosValidations.User"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.User),expression:"item_usuarios.User"}],staticClass:"form-control",attrs:{"type":"text","name":"User","placeholder":"test@email.com"},domProps:{"value":(_vm.item_usuarios.User)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "User", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.User.invalid),expression:"User.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('User'))+"\n              ")])]),_vm._v(" "),(_vm.edit_item == null)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.Password),expression:"item_usuariosValidations.Password"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.Password),expression:"item_usuarios.Password"}],key:'contraseña',ref:"Password",staticClass:"form-control",attrs:{"type":"password","name":"Password","placeholder":"*****"},domProps:{"value":(_vm.item_usuarios.Password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "Password", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.Password.invalid),expression:"Password.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('Password'))+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.edit_item == null)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Confirmar contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:Password'),expression:"'required|confirmed:Password'"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.Confirmar),expression:"item_usuarios.Confirmar"}],key:'confirmacion',staticClass:"form-control",attrs:{"type":"password","name":"Confirmar","placeholder":"*****"},domProps:{"value":(_vm.item_usuarios.Confirmar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "Confirmar", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.Confirmar.invalid),expression:"Confirmar.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('Confirmar'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Usuario")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.tipo_id),expression:"item_usuariosValidations.tipo_id"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"tipo_id"},model:{value:(_vm.item_usuarios.tipo_id),callback:function ($$v) {_vm.$set(_vm.item_usuarios, "tipo_id", $$v)},expression:"item_usuarios.tipo_id"}},_vm._l((_vm.tipos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_id.invalid),expression:"tipo_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('tipo_id'))+"\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Dependencia")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.ID_Dependencia),expression:"item_usuariosValidations.ID_Dependencia"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"ID_Dependencia"},model:{value:(_vm.item_usuarios.ID_Dependencia),callback:function ($$v) {_vm.$set(_vm.item_usuarios, "ID_Dependencia", $$v)},expression:"item_usuarios.ID_Dependencia"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.ID_Dependencia.invalid),expression:"ID_Dependencia.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('ID_Dependencia'))+"\n              ")])],1)]),_vm._v(" "),(_vm.edit_item != null)?_c('div',{staticClass:"row"},[_c('legend',[_vm._v(" Modificar Contraseña")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" Modificar constraseña: ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p-radio',{attrs:{"name":"modificar","inline":true,"label":"0"},model:{value:(_vm.item_usuarios.modificar),callback:function ($$v) {_vm.$set(_vm.item_usuarios, "modificar", $$v)},expression:"item_usuarios.modificar"}},[_vm._v("Sí")]),_vm._v(" "),_c('p-radio',{attrs:{"name":"modificar","inline":true,"label":"1"},model:{value:(_vm.item_usuarios.modificar),callback:function ($$v) {_vm.$set(_vm.item_usuarios, "modificar", $$v)},expression:"item_usuarios.modificar"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.item_usuarios.modificar=='0')?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.Password),expression:"item_usuariosValidations.Password"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.Password),expression:"item_usuarios.Password"}],key:'contraseña2',ref:"Password",staticClass:"form-control",attrs:{"type":"password","name":"Password","placeholder":"*****"},domProps:{"value":(_vm.item_usuarios.Password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "Password", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.Password.invalid),expression:"Password.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('Password'))+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.item_usuarios.modificar=='0')?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Confirmar contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:Password'),expression:"'required|confirmed:Password'"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.Confirmar),expression:"item_usuarios.Confirmar"}],key:'confirmacion2',staticClass:"form-control",attrs:{"type":"password","name":"Confirmar","placeholder":"*****"},domProps:{"value":(_vm.item_usuarios.Confirmar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "Confirmar", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.Confirmar.invalid),expression:"Confirmar.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('Confirmar'))+"\n              ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_usuarios,"items-per-page":5,"search":_vm.filter,"fixed-header":true,"custom-filter":_vm.buscaPers},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.ID_Dependencia",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getDependencias(item.ID_Dependencia)))])]}},{key:"item.Nombre",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.Nombre + ' '+ item.Paterno+ ' '+ item.Materno))])]}},{key:"item.tipo_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getTipoUsuarios(item.tipo_id)))])]}}],null,false,1829494563)})],1)])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Usuarios del sistema ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("28jc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+O+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Decisiones_vue__ = __webpack_require__("xJsz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6ad7d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Decisiones_vue__ = __webpack_require__("yQnO");
function injectStyle (ssrContext) {
  __webpack_require__("lyMx")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Decisiones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6ad7d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Decisiones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+QDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TipoDec_vue__ = __webpack_require__("2ZW9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_1__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_2__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_3__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */],
    TipoDec: __WEBPACK_IMPORTED_MODULE_0__TipoDec_vue__["a" /* default */]
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "+Ubx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_VueComment_vue__ = __webpack_require__("RZuv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c37cf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_VueComment_vue__ = __webpack_require__("XfDT");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_VueComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c37cf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_VueComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+VGi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  props: ["data"],
  data: function data() {
    return {
      filter: null,
      list_servidores: [],
      headers: [{
        text: 'Nombre completo',
        value: 'nombres',
        align: 'left'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'ente_publico_id',
        align: 'left'
      }, {
        text: 'Fecha de presentación de declaración',
        value: 'fecha',
        align: 'center'
      }, {
        text: 'Tipo de declaración',
        value: 'tipo',
        align: 'left'
      }]
    };
  },

  methods: {
    buscaServ: function buscaServ(value, search, item) {},
    getNombre: function getNombre(item) {
      var resp = (item.nombres || '') + " " + (item.primer_apellido || '') + " " + (item.segundo_apellido || '');

      return resp;
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get("getConflictos").then(function (response) {

      _this.list_servidores = response.data.usuarios;
      console.log(_this.list_servidores);
    }, function (error) {
      _this.Err(error);
    });

    this.$http.get("cat_ente_publico").then(function (response) {
      _this.dependencias = response.data.entes_publicos;
    }, function (error) {
      _this.Err(error);
    });
  }
});

/***/ }),

/***/ "+ZXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Domicilio_vue__ = __webpack_require__("Ta4m");







var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'Domicilio', __WEBPACK_IMPORTED_MODULE_6__Domicilio_vue__["a" /* default */]), _components), inject: ['$validator'],
  computed: {},
  data: function data() {
    return {
      mostrarCampos: false,
      validaciones: {
        curp: false,
        rfc: false
      },
      datePicker: '',
      ip_id: null,
      regexp: {
        mail: ''
      },
      paisesnac: {},
      nacionalidadArr: [150],
      estadosCi: {},
      regimenMat: {},
      n_domicilio: {
        pais_id: 150,
        entidadF: 11,
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      },
      model: { pais_nacimiento_id: 150 }

    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getEstadosC: function getEstadosC() {
      var _this = this;

      this.$http.get('edocivil').then(function (response) {
        _this.estadosCi = response.data.estadoCivil;
      }, function (error) {
        _this.StepError(error);
        console.log(error);
      });
    },
    getRegimenMat: function getRegimenMat() {
      var _this2 = this;

      this.$http.get('regmatrimonial').then(function (response) {
        _this2.regimenMat = response.data.regimen;
      }, function (error) {
        _this2.StepError(error);
        console.log(error);
      });
    },
    getDatosP: function getDatosP() {
      var _this3 = this;

      var v = this;
      this.$http.get('infpersonal/' + this.ip_id).then(function (response) {

        _this3.model = response.data.informacion;

        _this3.model.pais_nacimiento_id = _this3.model.pais_nacimiento_id == null ? 150 : _this3.model.pais_nacimiento_id;

        if (response.data.informacion.nac.length > 0) {
          var nacionalidadArr = [];
          $.each(response.data.informacion.nac, function (key, value) {
            nacionalidadArr.push(value.nac_id);
          });
        }

        _this3.model.nac = nacionalidadArr;

        _this3.editDomicilio();
      }, function (error) {
        _this3.StepError(error);
        console.log(error);
      });
    },
    actuali: function actuali() {
      var _this4 = this;

      this.$http.put('infpersonal/' + this.ip_id, this.model).then(function (response) {
        _this4.model = response.data.informacion;
      }, function (error) {
        _this4.StepError(error);
        console.log(error);
      });
    },
    getSafe: function getSafe(fn, defaultVal) {
      try {
        return fn();
      } catch (e) {
        return defaultVal;
      }
    },
    valida: function valida() {
      return this.$validator.validateAll();

      return response;
    },
    editDomicilio: function editDomicilio() {
      if (this.model) {
        this.n_domicilio = { 'pais_id': this.model.domicilio_pais_id,
          'entidadF': this.model.domicilio_entidad_federativa_id,
          'municipio': this.model.domicilio_municipio_id,
          'colonia': this.model.domicilio_colonia,
          'cp': this.model.domicilio_cp,
          'localidad': this.model.domicilio_localidad_id,
          'ext': this.model.domicilio_numext,
          'int': this.model.domicilio_numint,
          'vialidad': this.model.domicilio_vialidad_tipo,
          'vialidad_nombre': this.model.domicilio_vialidad_nombre,
          'domicilio_observaciones': this.model.domicilio_observaciones
        };
      }
    },
    initDomicilio: function initDomicilio() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: 11,
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
    }
  },
  watch: {
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.model.domicilio_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
          this.model.domicilio_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.model.domicilio_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.model.domicilio_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.model.domicilio_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.model.domicilio_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.model.domicilio_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.model.domicilio_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.model.domicilio_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
          this.model.domicilio_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.model.domicilio_observaciones = this.n_domicilio.domicilio_observaciones ? this.n_domicilio.domicilio_observaciones : "";
        }
      },
      deep: true
    }
  },

  created: function created() {
    this.ip_id = this.getId();
    this.getEstadosC();
    this.getRegimenMat();

    this.getDatosP();
  },
  mounted: function mounted() {
    this.checkCatalogs();
    this.model.pais_nacimiento_id = 150;
  }
});

/***/ }),

/***/ "+iyP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+njH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+tTX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+uue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("Dhe7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("zHPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("SaMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_excel_export__ = __webpack_require__("VdFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Domicilio_vue__ = __webpack_require__("Ta4m");






















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_excel_export__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a),
  props: ["data"],
  data: function data() {
    var _lista_campos;

    return {
      expanded: [],
      filtro: null,
      filter: null,
      isLoading: false,
      currentPage: 1,
      perPage: 50,
      rol: "",
      rows: null,
      id: 1,
      dependencias: null,
      item_usuarios: {},
      lista_correcciones: [],
      lista_correcciones2: [],
      headers: [{
        text: '',
        value: 'data-table-expand'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'left'
      },, {
        text: 'Fecha',
        value: 'created_at',
        align: 'center'
      }],
      meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      lista_campos: (_lista_campos = {
        'Nombres': 'nombres',
        'RFC': 'rfc',
        'CURP': 'curp',
        'Origen': 'origen',
        'Cambio': 'cambio',
        'Declaración Origen': 'origen_dec',
        'Declaración Cambio': 'cambio_dec',
        'Observaciones': 'observaciones',
        'Creador': 'creador',
        'Correo Creador': 'creador_mail',
        'Dependencia Creador': 'creador_dependencia',
        'Fecha': 'fecha'
      }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_lista_campos, 'Fecha', 'periodo'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_lista_campos, 'Tipo declaración', 'tipo_declaracion'), _lista_campos)

    };
  },

  computed: {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.lista_correcciones.length;

      return this.lista_correcciones.length;
    },

    fullName: {
      get: function get() {
        return this.item_usuarios.nombres + ' ' + this.item_usuarios.primer_apellido + ' ' + this.item_usuarios.segundo_apellido;
      },
      set: function set(newValue) {
        var m = newValue.match(/(\S*)\s+(.*)/);

        this.nombres = m[1];
        this.primer_apellido = m[2];
        this.segundo_apellido = m[3];
      }
    }
  },
  methods: {
    tipoDecCat: function tipoDecCat(tipo) {
      var t = '';
      switch (tipo) {
        case 1:
          t = 'Inicial';
          break;
        case 2:
          t = 'Anual';
          break;
        case 3:
          t = 'Final';
          break;

      }
      return t;
    },
    customFilter: function customFilter(value, search, item) {
      search = search.toString().toLowerCase();
      var filter = this.flat(item, {});

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(filter).some(function (v) {
        return v && v.toString().toLowerCase().includes(search);
      });
    },
    flat: function flat(obj, out) {
      var _this = this;

      if (obj) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[key]) == 'object') {
            out = _this.flat(obj[key], out);
          } else {
            out[key] = obj[key];
          }
        });
      }
      return out;
    },
    rowClick: function rowClick(item, row) {
      var indexRow = item.index;
      var indexExpanded = this.expanded.findIndex(function (i) {
        return i === item;
      });

      if (indexExpanded > -1) {
        this.expanded = [];
        row.select(false);
      } else {
        this.expanded = [item];
        row.select(true);
      }
    },
    initItem: function initItem() {
      this.item_usuarios = {
        acciones: "",
        nombres: "",
        Paterno: "",
        Materno: "",
        User: "",
        Password: ""
      };
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getcorrecciones: function getcorrecciones() {
      var _this2 = this;

      this.lista_correcciones2 = [];

      this.isLoading = true;
      this.$http.get("bitacoracorreccion").then(function (response) {
        _this2.lista_correcciones = response.data.bitacora;

        _this2.lista_correcciones.forEach(function (value, key) {

          _this2.isLoading = false;

          var usuario = {
            Nombre: '',
            Paterno: '',
            Materno: '',
            User: '',
            ID_Dependencia: ''
          };

          if (value.usuario) {
            usuario = value.usuario;
          }

          value.origen = JSON.parse(value.origen);
          value.cambio = JSON.parse(value.cambio);

          var origen = _this2.flatData(value.origen.datos_encargo_actual, 'ente');
          var cambio = _this2.flatData(value.cambio.datos_encargo_actual, 'ente');

          var dec_origen = {
            tipo_declaracion: value.orgen_declaracion.Tipo_Dec,
            periodo: value.orgen_declaracion.periodo
          };

          var dec_cambio = {
            tipo_declaracion: value.cambio_declaracion.Tipo_Dec,
            periodo: value.cambio_declaracion.periodo
          };

          _this2.lista_correcciones2.push({
            'nombres': value.servidor.nombres + ' ' + value.servidor.primer_apellido + ' ' + value.servidor.segundo_apellido,
            'rfc': value.servidor.rfc,
            'curp': value.servidor.curp,
            'origen': origen ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(origen).join(', ') : '',
            'cambio': cambio ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(cambio).join(', ') : '',
            'origen_dec': dec_origen ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(dec_origen).join(', ') : '',
            'cambio_dec': dec_cambio ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(dec_cambio).join(', ') : '',
            'observaciones': value.observaciones ? value.observaciones : 'Sin observaciones.',
            'creador': usuario.Nombre + ' ' + usuario.Paterno + ' ' + usuario.Materno,
            'creador_mail': usuario.User,
            'creador_dependencia': _this2.getDependencias(usuario.ID_Dependencia),
            'fecha': _this2.dateFormat(value.created_at),
            'periodo': value.periodo,
            'tipo_declaracion': _this2.tipoDecCat(value.tipo_declaracion_id)
          });
        });
      }, function (error) {
        _this2.isLoading = false;
        _this2.Err(error);
      });
    },

    dateFormat: function dateFormat(date) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (date) {
        if (time) {
          return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format('DD/MM/YYYY HH:mm:ss');
        } else {
          return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
      }
    },
    returnValueKey: function returnValueKey(v, k) {
      var resp = "";
      if (k == "dependencia") {
        resp = this.getDependencias(v);
      } else if (k == "honorarios") {
        console.log(typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(v));
        resp = v == 1 ? "HONORARIOS" : "BASE";
      } else if (k == "fecha_posesion") {
        resp = this.formato(v);
      } else if (k == "titular") {
        resp = v == 0 ? "NO" : "SI";
      } else if (k == "simplificada") {
        resp = v == '0' ? "NO" : "SI";
      } else {
        resp = v;
      }
      return resp;
    },
    flatData: function flatData(value, key) {
      var resp = [];
      var json_ = JSON.parse(value);
      if (json_[0]) {
        var obj = json_[0];
        if (obj.hasOwnProperty(key)) {
          var resp = obj[key];
          delete resp.created_by;
          delete resp.deleted_by;
          delete resp.updated_by;
          delete resp.created_at;
          delete resp.deleted_at;
          delete resp.updated_at;
          delete resp.id;
        }
      }
      return resp;
    }
  },
  created: function created() {
    var _this3 = this;

    this.initItem();
    this.getcorrecciones();
    this.rol = this.getKey("role");

    this.$http.get("cat_ente_publico").then(function (response) {
      _this3.dependencias = response.data.entes_publicos;
    }, function (error) {
      _this3.Err(error);
    });
  }
});

/***/ }),

/***/ "+vyg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rol: null,
      ip_id: null,
      el_archivo: "",
      wizardModel: {},
      fiscal: [],
      entes: [],
      xlsx: 0,
      currentYear: '',
      add_item: false,
      edit_item: false,
      search: '',
      form_item: {},
      table_list: [],
      headers: [{
        text: 'Año',
        value: 'anio',
        align: 'center',
        class: '',
        width: "200px"
      }, {
        text: 'Declaración Patrimonial y de intereses',
        value: 'patrimonial',
        align: 'center',
        class: ''
      }, {
        text: 'Tipo',
        value: 'Tipo_Dec',
        align: 'center',
        class: ''
      }, {
        text: 'Acuse',
        value: 'acuse',
        align: 'center',
        class: ''
      }, {
        text: 'Declaración fiscal',
        value: 'fiscal',
        align: 'center',
        class: ''
      }, {
        text: 'Entidad / Dependencia',
        value: 'entidad',
        align: 'center',
        class: ''
      }]
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["FormWizard"]
  },
  computed: {
    fileExist: function fileExist() {
      var _this = this;

      var obj = this.table_list.find(function (o) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(o.created_at, 'YYYY-MM-DD').format('YYYY') === _this.currentYear;
      });
      if (obj) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkAnio: function checkAnio(item) {
      if (item.periodo) {
        return item.periodo;
      } else {
        return this.filterAnio(item.created_at);
      }
    },
    descargaResumen: function descargaResumen(id) {
      var _this2 = this;

      this.$http.get('getDeclaracion2/pdf/' + id + "/" + this.ip_id, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this2.downloadFile(response, 'Declaración');
      }, function (error) {
        _this2.StepError(error);
      });
    },
    descargaAcuse: function descargaAcuse(id) {
      var _this3 = this;

      this.$http.get(this.$apiUrl + 'getAcuse/' + id, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this3.downloadFile(response, 'Acuse');
      }, function (error) {
        _this3.StepError(error);
      });
    },
    downloadFile: function downloadFile(response, filename) {
      var newBlob = new Blob([response.body], {
        type: 'application/pdf'
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      var data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = data;
      link.download = filename + '.pdf';
      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    descargaFiscal: function descargaFiscal(file) {
      var obj = JSON.parse(file);
      if (obj[0]) {
        var url = this.$rootUrl + '/declaraciones_fiscales/' + obj[0].file;
        window.open(url, '_blank');
      } else {
        this.StepW("No tiene declaración fiscal");
      }
    },
    entidadHistorico: function entidadHistorico(item) {
      var obj = JSON.parse(item)[0];
      return this.filterCatalog(obj.ente_publico_id, this.entes);
    },
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    }
  },
  created: function created() {
    var _this4 = this;

    this.currentYear = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY');

    this.ip_id = this.getId();

    this.$http.get("bitacoraDeclaracion/" + this.ip_id).then(function (response) {
      _this4.table_list = response.data.response;
    }, function (error) {
      _this4.Err(error);
    });

    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.StepError(error);
      console.log(error);
    });
  }
});

/***/ }),

/***/ "/4iE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rol: null,
      cargando: true,
      wizardModel: {},
      incorrectos: [],
      periodos: [],
      periodo: null,
      correctos: 0,
      grupo: 2,
      tipo_dec: 1,
      xlsx: 0,
      simplificadafl: false,
      entes: null,
      ente_publico_id: null,
      simplificada: '0',
      tipo_declaracion: [{
        'id': 1,
        'valor': 'Inicial'
      }, {
        'id': 2,
        'valor': 'Anual'
      }, {
        'id': 3,
        'valor': 'Final'
      }],
      fields_list: [{
        key: "Renglon",
        label: "Renglon",
        tdClass: "text-left"
      }, {
        key: "Columna",
        label: "Columna(s)",
        tdClass: "text-left"
      }, {
        key: "Nombre",
        label: "Nombre",
        tdClass: "text-left"
      }, {
        key: "RFC",
        label: "RFC",
        tdClass: "text-left"
      }, {
        key: "Mensaje",
        label: "Mensaje",
        tdClass: "text-left",
        formatter: "emptyFields"
      }]
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"]
  },
  watch: {
    '$route': 'checkPermissions',
    'grupo': function grupo(val) {
      if (val == 3) {
        this.simplificada = '1';
        this.simplificadafl = true;
      } else this.simplificadafl = false;
    },
    'simplificada': function simplificada(val) {
      if (val == '1') this.grupo = 3;else this.grupo = 2;
    }
  },
  methods: {
    checkPermissions: function checkPermissions() {
      var permiso = [13];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    saveComprobante: function saveComprobante() {
      var _this = this;

      var preg = "";

      if (this.simplificada == '1') {
        preg = 'Éstos registros se agregaran para presentar la declaración simplificada';
      } else {
        preg = 'Éstos registros se agregaran para presentar la declaración completa en el grupo ' + this.grupo;
      }
      this.Ask(preg + ", ¿desea continuar?", function () {
        _this.cargando = true;

        var formData = new FormData();
        formData.append("grupo", _this.grupo);
        formData.append("ente_publico_id", _this.ente_publico_id);
        formData.append("simplificada", _this.simplificada);
        formData.append("tipo_dec", _this.tipo_dec);
        formData.append("periodo", _this.periodo);

        formData.append("xlsx", _this.xlsx);
        _this.$http.post("Excel", formData).then(function (response) {
          _this.incorrectos = response.data.incorrectos;
          _this.correctos = response.data.correctos;
          _this.cargando = false;
        }, function (error) {
          _this.cargando = false;
          _this.Err(error);
        });
      });
    },
    addFile: function addFile(tipo) {
      this.xlsx = this.$refs.xlsx.files[0];
    },
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.datosPersonales.model, this.$refs.firstStep.model, this.$refs.DatosCurriculares.model, this.$refs.DatosConyuge.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()("Good job!", "You clicked the finish button!", "success");
    },
    getPeriodos: function getPeriodos() {
      var _this2 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        var anios = response.data.periodos;

        anios.forEach(function (y) {
          if (y.year) {
            _this2.periodos.push(y);
          }
        });
        _this2.periodo = _this2.periodos[0].year;
      }, function (error) {
        _this2.StepError(error);
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.checkPermissions();
    this.getPeriodos();

    this.rol = this.getKey("grupo");

    this.$http.get("cat_ente_publico").then(function (response) {
      _this3.entes = response.data.entes_publicos;
    }, function (error) {
      _this3.Err(error);
    });

    this.cargando = false;
  }
});

/***/ }),

/***/ "/5hs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/7XH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_TableroDec_vue__ = __webpack_require__("7gjw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_06765912_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_TableroDec_vue__ = __webpack_require__("bk6e");
function injectStyle (ssrContext) {
  __webpack_require__("/uOo")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_TableroDec_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_06765912_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_TableroDec_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/ObX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/R45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),(_vm.add_item)?_c('div',[_c('div',{staticClass:"row m-3 mt-0"},[_c('div',{staticClass:"col-md-12 form-group pt-0 mb-0",staticStyle:{"text-align":"left"}},[_vm._v("\n          Seleccione archivo en formato PDF\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 custom-file"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"xlsx",staticClass:"custom-file-input",attrs:{"id":"xlsx","name":"file","type":"file"},on:{"change":function($event){return _vm.addFile('xlsx')}}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":"xlsx"}},[_vm._v("Archivo seleccionado: "+_vm._s(_vm.xlsx ? _vm.xlsx.name : ''))]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('file')))])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(!_vm.edit_item )?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"row justify-content-end ml-3 mr-3"},[(!_vm.add_item && _vm.fileExist)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargaAclaracion(item.file)}}},[_c('i',{staticClass:"far fa-file-pdf"})]),_vm._v(" "),_c('br')],1)]}},{key:"item.eliminar",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.anio",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("Declaración "+_vm._s(_vm.filterAnio(item.created_at)))])]}},{key:"item.file",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat(item.created_at, true)))])]}}])})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row m-3 mb-0"},[_c('legend',[_vm._v("Subir aclaraciones")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row "},[_c('hr',{staticClass:" bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/cqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":_vm.id,"tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",class:[_vm.scrollable,_vm.size],attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body p-0"},[_c(_vm.comp,{key:_vm.title,tag:"component",attrs:{"data":_vm.data}})],1),_vm._v(" "),(_vm.footer)?_c('div',{staticClass:"modal-footer p-1"},[_c(_vm.footerComp,{tag:"component",attrs:{"data":_vm.data}})],1):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"closebtn",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/h5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"row",attrs:{"id":"loading"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/uOo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0981":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0MaE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0bCk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0doD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("s/F+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("yrbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_StatsCard2_vue__ = __webpack_require__("ARNM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chartist_plugin_tooltips__ = __webpack_require__("pZqB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chartist_plugin_tooltips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_chartist_plugin_tooltips__);











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    StatsCard2: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_StatsCard2_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      $Chartist: null,
      obligados: '',
      min: 0,
      max: 0,
      faltantes: '',
      porcentaje: 0,
      declaraciones: '',
      plugins: null,
      rinicial: 0,
      ranual: 0,
      rfinal: 0,
      obligadosIn: 0,
      obligadosAn: 0,
      obligadosFi: 0,
      faltantesIn: 0,
      faltantesAn: 0,
      faltantesFi: 0
    };
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') != 0)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    initStockChart: function initStockChart() {
      var _this = this;

      var dataStock = {
        labels: [],
        series: [[]]

      };
      var optionsStock = {
        lineSmooth: false,
        axisY: {
          offset: 40,
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return '' + value;
          }
        },
        low: this.min,
        height: '260px',
        high: this.max,
        classNames: {
          point: 'ct-point ct-green',
          line: 'ct-line ct-green'
        },
        plugins: [this.$Chartist.plugins.tooltip()]
      };
      var temp = [];
      this.$http.get("semana").then(function (response) {
        $.each(response.data, function (key, value) {
          dataStock.labels.push(value.date);
          temp.push(value.total);
        });
        dataStock.series[0] = temp;
        dataStock.labels.reverse();
        dataStock.series[0].reverse();
        _this.$Chartist.Line('#chartStock', dataStock, optionsStock);
      }, function (error) {
        _this.StepError(error);
      });
    },
    getDatos: function getDatos() {
      var _this2 = this;

      this.$http.get("tableroGlobales2").then(function (response) {
        _this2.faltantes = _this2.group1k(response.data.faltantes);
        _this2.declaraciones = _this2.group1k(response.data.declaraciones);
        _this2.obligados = _this2.group1k(response.data.declarantes);
        _this2.porcentaje = parseFloat(response.data.porcentaje.toString().substring(0, 5));
        _this2.rinicial = _this2.group1k(response.data.desglosado[2].count);
        _this2.rfinal = _this2.group1k(response.data.desglosado[1].count);
        _this2.ranual = _this2.group1k(response.data.desglosado[0].count);
        _this2.faltantesIn = _this2.group1k(response.data.decIni - response.data.desglosado[2].count);
        _this2.faltantesAn = _this2.group1k(response.data.decAn - response.data.desglosado[0].count);
        _this2.faltantesFi = _this2.group1k(response.data.decFin - response.data.desglosado[1].count);
        _this2.obligadosIn = _this2.group1k(response.data.decIni);
        _this2.obligadosAn = _this2.group1k(response.data.decAn);
        _this2.obligadosFi = _this2.group1k(response.data.decFin);
      }, function (error) {
        _this2.StepError(error);
      });
    },
    cumplimiento: function cumplimiento() {
      this.$router.push('/reportes/cumplimiento');
    }
  },
  created: function created() {
    this.checkPermissions();
    this.getDatos();
    if (this.getKey('permisos').includes(18)) {
      this.min = 10;
      this.max = 1600;
    } else {
      this.min = 0;
      this.max = 500;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "c83R"));

            case 2:
              Chartist = _context.sent;

              _this3.$Chartist = Chartist;
              _this3.initStockChart();
              _this3.plugins = [_this3.$Chartist.plugins.tooltip()];

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),

/***/ "0gvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);









__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ultima_dec: null,
      ip_id: null,
      fecha: '',
      hora: '',
      dpersonales: [],
      encargo: null,
      intereses: null,
      activos: null,
      sueldos: null,
      rate: {
        rate: 0,
        observaciones: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    this.ip_id = this.getKey('uid');

    this.$http.get("historicolst/" + this.ip_id).then(function (response) {
      if (response.data.response.length > 0) {
        _this.ultima_dec = true;
      } else {
        _this.ultima_dec = false;
      }
    }, function (error) {
      _this.ultima_dec = false;
      _this.Err(error);
    });

    this.checkPermissions();
  },

  methods: {
    cerrarSesion: function cerrarSesion() {
      localStorage.clear();
      eventBus.$emit('cerro');
      this.$router.push('/login');
    },
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') == 0)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    descarga: function descarga(id) {
      var _this2 = this;

      id = 20514;

      this.$http.get(this.$apiUrl + 'getDeclaracion2/pdf/' + 1 + "/" + this.ip_id, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this2.downloadFile(response, 'Declaración');
      }, function (error) {
        _this2.StepError(error);
      });
    },
    descargaAcuse: function descargaAcuse() {

      var token = localStorage.getItem('app-token-declaranet');
      var auth = 'Bearer ' + (token ? token.hash : "");

      var url = this.$apiUrl + 'pdf/' + this.ip_id;
      window.open(url, '_blank');
    },
    downloadFile: function downloadFile(response, filename) {
      var newBlob = new Blob([response.body], {
        type: 'application/pdf'
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      var data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = data;
      link.download = filename + '.pdf';
      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    test: function test(item) {
      this.modalTitle = "Es importante tu opinión";
      this.modalComponent = "rating";
      this.Modal("#modal");
    }
  }
});

/***/ }),

/***/ "0hPu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0mUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-5"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-7"},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-12"},[_vm._t("footer")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "16wy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("tS/P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__("iGCS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);








__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.directive);
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "1EEh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RepDeclaraciones2_vue__ = __webpack_require__("UHWF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebc6bc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RepDeclaraciones2_vue__ = __webpack_require__("hSiF");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RepDeclaraciones2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebc6bc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RepDeclaraciones2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1FAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["data"],
  data: function data() {
    return {};
  },

  methods: {
    send: function send() {
      console.log("ok");
    }
  }
});

/***/ }),

/***/ "1HUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('v-overlay',{staticClass:"text-center",attrs:{"value":_vm.overlay,"absolute":""}},[_c('h3',{staticClass:"card-title mb-3 text-white font-weight-bold"},[_vm._v("El proceso puede tardar un par de minutos, por favor espere.")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"mt-3",attrs:{"indeterminate":"","size":"100"}})],1),_vm._v(" "),_c('div',{staticClass:"card-content pl-4 pr-4"},[_c('v-row',{staticClass:"pa-4",attrs:{"justify":"space-between"}},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("Activación Anual ")]),_vm._v(" "),_c('v-btn',{staticClass:"mt-2 mb-0",attrs:{"color":"primary","outlined":"","small":""},on:{"click":function($event){$event.preventDefault();return _vm.runCron.apply(null, arguments)}}},[_vm._v("\n          Ejecutar\n        ")])],1),_vm._v(" "),_c('v-row',{staticClass:"pa-4 mt-0",attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-sheet',{staticClass:"pa-4 primary "},[_c('v-text-field',{attrs:{"label":"Buscar dependencia","dark":"","flat":"","solo-inverted":"","hide-details":"","clearable":"","clear-icon":"mdi-close-circle-outline"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)],1),_vm._v(" "),_c('v-row',{staticClass:"pa-4 mt-0",attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"6"}},[_c('v-treeview',{attrs:{"active":_vm.active,"filter":_vm.filter,"activatable":"","items":_vm.items,"search":_vm.search,"loading-icon":"fas fa-circle-notch fa-spin","open":_vm.open,"color":"primary","open-on-click":"","transition":"","return-object":""},on:{"update:active":[function($event){_vm.active=$event},_vm.getJsonFile],"update:open":function($event){_vm.open=$event}},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
var active = ref.active;
return [(!item.children)?_c('v-icon',{attrs:{"color":active ? 'primary':''}},[_vm._v("\n                all_inbox\n              ")]):_vm._e()]}},{key:"label",fn:function(ref){
var item = ref.item;
var leaf = ref.leaf;
return [(leaf)?_c('div',[_vm._v("\n                "+_vm._s(_vm.removeslash(item.name))+"\n              ")]):_c('div',[_vm._v("\n                "+_vm._s(item.name)+"\n              ")])]}}])})],1),_vm._v(" "),_c('v-divider',{attrs:{"vertical":""}}),_vm._v(" "),_c('v-col',{staticClass:"d-flex text-center"},[_c('v-scroll-y-transition',{attrs:{"mode":"out-in"}},[(!_vm.selected)?_c('v-card',{staticClass:"pt-6 mx-auto",attrs:{"flat":"","outlined":"","width":"100%"}},[(_vm.loaddata)?_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-h6 grey--text text--lighten-1 font-weight-light",staticStyle:{"align-self":"center"}},[_vm._v("\n                Seleccione un elemento\n              ")])],1):_c('v-card',{key:_vm.selected.id,staticClass:"pt-0 mx-auto",attrs:{"flat":"","outlined":"","width":"100%"}},[(_vm.loaddata)?_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}}):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('h3',{staticClass:"text-h5 mb-2 mt-2"},[_vm._v("\n                  "+_vm._s(_vm.filterCatalog(_vm.fileInfo.ente_publico_id, _vm.dependencias))+"\n                ")])]),_vm._v(" "),_c('v-divider',{staticClass:"m-0 p-0 mb-2"}),_vm._v(" "),_c('v-row',{staticClass:"text-left m-0 p-0",attrs:{"tag":"v-card-text"}},[_c('v-col',{staticClass:"text-left m-0",attrs:{"tag":"strong","cols":"12"}},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.dataExcelRegistro,"meta":_vm.meta,"fields":_vm.campos_excel,"worksheet":"Padron","name":_vm.file_name+'_registro.xls'}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                    Registros\n                  ")])],1),_vm._v(" "),_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.fileInfo.registros,"items-per-page":10},scopedSlots:_vm._u([{key:"item.rfc",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(item.rfc)+" ")])]}}])})],1),_vm._v(" "),_c('v-col',{staticClass:"text-left m-0",attrs:{"tag":"strong","cols":"12"}},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.dataExcelSinMovimientos,"meta":_vm.meta,"fields":_vm.campos_excel,"worksheet":"Padron","name":_vm.file_name+'_sin_movimientos.xls'}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                    Sin Movimientos\n                  ")])],1),_vm._v(" "),_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.fileInfo.sinMovimientos,"items-per-page":10},scopedSlots:_vm._u([{key:"item.rfc",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(item.rfc)+" ")])]}}])})],1),_vm._v(" "),_c('v-col',{staticClass:"text-left m-0",attrs:{"tag":"strong","cols":"12"}},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.dataExcelErrores,"meta":_vm.meta,"fields":_vm.campos_excel,"worksheet":"Padron","name":_vm.file_name+'_errores.xls'}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                    Errores\n                  ")])],1),_vm._v(" "),_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.fileInfo.errores,"items-per-page":10},scopedSlots:_vm._u([{key:"item.rfc",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(item.rfc)+" ")])]}}])})],1)],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Q+l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Aclaraciones_vue__ = __webpack_require__("b+YB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc10bc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Aclaraciones_vue__ = __webpack_require__("KNgp");
function injectStyle (ssrContext) {
  __webpack_require__("52dV")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Aclaraciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc10bc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Aclaraciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1TUu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1huq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_CambiaPass_vue__ = __webpack_require__("kzbf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3cb2876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_CambiaPass_vue__ = __webpack_require__("jCiL");
function injectStyle (ssrContext) {
  __webpack_require__("SWlE")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_CambiaPass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3cb2876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_CambiaPass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1s+0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,

      plazos: [],
      actividades: [],
      sectores: null,
      n_domicilio: null,

      entidadFed: null,
      municipios: null,
      localidades: null,
      localidad: null,
      paises: null,
      isnum: null,

      item_ingresos: {},
      list_ingresos: [],
      fields_list: [{
        key: "acciones",
        label: "Acciones",
        tdClass: "text-center"
      }, {
        key: "nombre_denominacion_razon_social",
        label: "Denominación o razón social",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "rfc",
        label: "RFC",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "curp",
        label: "CURP",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "sector_industria_id",
        label: "Sector",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "tipo_actividad_servicio_id",
        label: "Tipo de actividad ",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "descripcion_actividad",
        label: "Descripción de la actividad",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "ingreso_bruto_anual",
        label: "Ingreso bruto anual ",
        tdClass: "text-right",
        formatter: 'emptyFields'
      }, {
        key: "moneda_id",
        label: "Moneda",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "duracion_frecuencia",
        label: "Duración / Frecuencia",
        tdClass: "text-center",
        formatter: 'emptyFields'
      }, {
        key: "unidad_temporal_id",
        label: "Unidad temporal",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "fecha_transaccion",
        label: "Fecha de transacción",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "observaciones",
        label: "Observaciones",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "pais_id",
        label: "País",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "entidad_federativa_id",
        label: "Entidad federativa",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "municipio_id",
        label: "Municipio",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "localidad_id",
        label: "Localidad",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "colonia",
        label: "Colonia",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "vialidad_tipo_vial",
        label: "Tipo vialidad",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "vialidad_nom_vial",
        label: "Nombre vialidad",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "cp",
        label: "CP",
        tdClass: "text-right",
        formatter: 'emptyFields'
      }, {
        key: "numExt",
        label: "Número exterior",
        tdClass: "text-right",
        formatter: 'emptyFields'
      }, {
        key: "numInt",
        label: "Número interior",
        tdClass: "text-right",
        formatter: 'emptyFields'
      }]
    };
  },

  computed: {
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.item_ingresos.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.item_ingresos.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {
    list_ingresos: {
      handler: function handler() {
        if (this.list_ingresos) {
          this.setLocalidades();
          if (this.list_ingresos.length == 0) {
            this.bandera = '0';
          } else {
            this.bandera = '1';
          }
        }
      },
      deep: true
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_ingresos.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_ingresos.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_ingresos.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_ingresos.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_ingresos.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_ingresos.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_ingresos.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_ingresos.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_ingresos.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_ingresos.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    }
  },
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMoneda: function getMoneda(index) {
      var resp = "";
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getActividad: function getActividad(index) {
      var resp = " ";
      if (this.sectores) {
        this.actividades.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUnidades: function getUnidades(index) {
      var resp = " ";
      if (this.plazos) {
        this.plazos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: '',
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
      this.item_ingresos = {
        acciones: "",
        rfc_quien_adquirio: "",
        ingreso_bruto_anual: "",
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: "",
        entidad_federativa_id: "",
        municipio_id: "",
        localidad_id: "",
        colonia: "",
        cp: "",
        numExt: "",
        numInt: "",
        vialidad_nom_vial: "",
        vialidad_tipo_vial: "",
        observaciones: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      if (this.item_ingresos) {
        this.item_ingresos.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post("otros_ingresos", this.item_ingresos).then(function (response) {
          _this.StepOk("Guardado");
          if (_this.edit_item === undefined || _this.edit_item === null) {
            _this.list_ingresos.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.actividad));
          } else {
            _this.list_ingresos.splice(_this.edit_item.index, 1, _this.item_ingresos);
            _this.edit_item.item._rowVariant = "";
          }
          _this.showItem();
          _this.initItem();
          _this.edit_item = null;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW("Hay campos sin completar");
      }
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_ingresos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_ingresos[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_ingresos[indice].id !== null) {
        var item = this.list_ingresos[indice];

        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("otros_ingresos/" + item.id).then(function (response) {
            _this2.list_ingresos.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_ingresos.pais_id ? this.item_ingresos.pais_id : 150;
      this.n_domicilio.entidadF = this.item_ingresos.entidad_federativa_id ? this.item_ingresos.entidad_federativa_id : '';
      this.n_domicilio.municipio = this.item_ingresos.municipio_id ? this.item_ingresos.municipio_id : '';
      this.n_domicilio.localidad = this.item_ingresos.localidad_id ? this.item_ingresos.localidad_id : '';
      this.n_domicilio.cp = this.item_ingresos.cp ? this.item_ingresos.cp : '';
      this.n_domicilio.colonia = this.item_ingresos.colonia ? this.item_ingresos.colonia : '';
      this.n_domicilio.vialidad = this.item_ingresos.vialidad_tipo_vial ? this.item_ingresos.vialidad_tipo_vial : '';
      this.n_domicilio.vialidad_nombre = this.item_ingresos.vialidad_nom_vial ? this.item_ingresos.vialidad_nom_vial : '';
      this.n_domicilio.ext = this.item_ingresos.numExt ? this.item_ingresos.numExt : '';
      this.n_domicilio.int = this.item_ingresos.numInt ? this.item_ingresos.numInt : '';
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      this.list_ingresos.forEach(function (item) {
        if (item.localidad_id) {
          _this3.$http.get('localidades/localidad/' + item.localidad_id).then(function (response) {
            _this3.localidades.push(response.data.localidad);
          }, function (error) {
            _this3.Err(error);
          });
        }
      });
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("otros_ingresos/" + this.ip_id).then(function (response) {
      _this4.list_ingresos = response.data.actividades;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_unidad_medida_plazo").then(function (response) {
      _this4.plazos = response.data.unidades;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_actividad").then(function (response) {
      _this4.actividades = response.data.actividad;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "2+a/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2I78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);












var _components;







/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a), _components),
  data: function data() {
    return {
      model: { tipo_declaracion: '', dependencia_id: '', periodo: '' },
      dependencias: {},
      rol: '',
      filter: null,
      currentPage: 1,
      perPage: 10,
      periodos: [],
      rows: null,
      declarantes: true,
      declaracionesT: false,
      tiposDeclaracion: [],
      list_funcionarios: [],
      list_declaraciones: [],
      filtro_usuarios: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      fields_list: [{
        key: "acciones",
        label: "Ver Declaraciones",
        thClass: "td-small",
        tdClass: "text-center td-small"
      }, {
        key: "id",
        label: "Id",
        thClass: 'd-none', tdClass: 'd-none'
      }, {
        key: "nombre",
        label: "Nombre",
        thClass: "td-small",
        tdClass: "text-center td-small",
        sortable: true
      }, {
        key: "dependencia",
        label: "Dependencia",
        thClass: "td-small",
        tdClass: "text-left td-small",
        sortable: true
      }],
      fields_list2: [{
        key: "acciones",
        label: "Descargar",
        thClass: "td-small",
        tdClass: "text-center td-small"
      }, {
        key: "id",
        label: "Id",
        thClass: 'd-none', tdClass: 'd-none'
      }, {
        key: "dependencia",
        label: "Dependencia",
        thClass: "td-small",
        tdClass: "text-left td-small",
        sortable: true
      }, {
        key: "tipo",
        label: "Tipo Declaración",
        thClass: "td-small",
        tdClass: "text-center td-small",
        sortable: true
      }, {
        key: "fecha",
        label: "Fecha Envío",
        thClass: "td-small",
        tdClass: "text-center td-small",
        sortable: true,
        formatter: function formatter(value) {
          if (value) return __WEBPACK_IMPORTED_MODULE_13_moment___default()(String(value)).format('DD/MM/YYYY');else return '';
        }
      }],
      propsToSearch: ['rfc', 'nombres']
    };
  },

  methods: {
    busqueda: function busqueda() {
      var _this = this;

      this.declaracionesT = false;
      this.declarantes = true;
      this.$http.get("busqueda/" + this.model.busqueda).then(function (response) {
        var v = _this;
        v.list_funcionarios = [];
        $.each(response.data.usuarios, function (key, value) {

          v.list_funcionarios.push({
            'id': value.id,
            'nombre': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
            'dependencia': value.valor
          });
        });
      }, function (error) {
        _this.StepError(error);
        console.log(error);
      });
    },
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    declaraciones: function declaraciones(item) {
      var _this2 = this;

      this.declarantes = false;
      this.declaracionesT = true;

      this.$http.get("declaraciones/" + item.id).then(function (response) {
        var v = _this2;
        v.list_declaraciones = [];
        $.each(response.data.declaraciones, function (key, value) {
          v.list_declaraciones.push({
            'dependencia': value.declarante[0].encargo.ente.valor,
            'tipo': value.tipo_dec.tipo_declaracion,
            'fecha': value.created_at,
            'id': value.id
          });
        });
      }, function (error) {
        _this2.StepError(error);
        console.log(error);
      });
    },
    descargar: function descargar(row) {
      var url = this.$apiUrl + 'getDeclaracion/busqueda/pdf/' + row.id;
      window.open(url, '_blank');
    }
  },
  computed: {
    pagedData: function pagedData() {
      return this.list_funcionarios.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this3 = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_funcionarios.length;
        return this.pagedData;
      }
      var result = this.list_funcionarios.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this3.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this3.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_funcionarios.length;

      return this.list_funcionarios.length;
    }
  }
});

/***/ }),

/***/ "2ZW9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_TipoDec_vue__ = __webpack_require__("uHgF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4300e010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_TipoDec_vue__ = __webpack_require__("HWiE");
function injectStyle (ssrContext) {
  __webpack_require__("4CJV")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_TipoDec_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4300e010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_TipoDec_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("v3Mv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbe9a168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("9NCP");
function injectStyle (ssrContext) {
  __webpack_require__("WMHG")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbe9a168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2auz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    title: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    comp: {
      type: [String, Object]
    },
    size: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    data: {
      type: [String, Object]
    },
    scroll: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    footer: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    footerComp: {
      type: [String, Object]
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    scrollable: function scrollable() {
      return this.scroll ? 'modal-dialog-scrollable' : '';
    }
  },
  created: function created() {
    console.log(this.size);
  }
});

/***/ }),

/***/ "2cpp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Declaraciones_vue__ = __webpack_require__("ISTY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_03dc92b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Declaraciones_vue__ = __webpack_require__("TkYh");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Declaraciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_03dc92b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Declaraciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2eYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RepBajasDefuncion_vue__ = __webpack_require__("fJjp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c645276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RepBajasDefuncion_vue__ = __webpack_require__("CR90");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RepBajasDefuncion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c645276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RepBajasDefuncion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2sub":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3+PJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("kDzH");










var _components;


/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), _components),
  props: ["data"],
  data: function data() {
    return {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      form_item: {},
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Participación en fideicomisos',
        value: 'participante',
        align: 'center'
      }, {
        text: 'Tipo de fideicomiso',
        value: 'tipo_fideicomiso_id',
        align: 'center'
      }, {
        text: 'Tipo de participación',
        value: 'tipo_participacion_id',
        align: 'center'
      }, {
        text: 'RFC del fideicomiso',
        value: 'rfc_fideicomiso',
        align: 'center'
      }, {
        text: 'Nombre del fideicomitente',
        value: 'nombre_fideicomitente',
        align: 'center'
      }, {
        text: 'RFC fideicomitente',
        value: 'rfc_fideicomitente',
        align: 'center'
      }, {
        text: 'Nombre del fiduciario',
        value: 'nombre_fiduciario',
        align: 'center'
      }, {
        text: 'RFC fideicomitente',
        value: 'rfc_fideicomitente',
        align: 'center'
      }, {
        text: 'Nombre del fideicomisario',
        value: 'nombre_fideicomisario',
        align: 'center'
      }, {
        text: 'RFC fideicomisario',
        value: 'rfc_fideicomisario',
        align: 'center'
      }, {
        text: 'Sector',
        value: 'sector_industria_id',
        align: 'center'
      }],
      info: {
        fideicomisos: 'Este apartado solo lo llenaran las personas servidoras públicas que tengan participación en un fideicomiso, ya sea en el carácter de fideicomitente, fiduciario, fideicomisario o dentro del consejo técnico. Deberá reportar hasta los últimos dos años.',
        participante: 'Elegir quien es el participante en el fideicomiso, el Declarante, Pareja o dependiente económico.',
        tipo_fideicomiso_id: 'Seleccionar si es público, privado o mixto.',
        tipo_participacion_id: 'Seleccionar su participación como fideicomitente, fiduciario, fideicomisario o dentro del Comité Técnico.',
        rfc_fideicomiso: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomiso.',
        fideicomitente: 'Seleccionar si es persona física o persona moral.',
        nombre_fideicomitente: 'Proporcionar nombre completo.',
        rfc_fideicomitente: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomitente.',
        nombre_fiduciario: 'Proporcionar nombre completo.',
        rfc_fiduciario: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fiduciario.',
        fideicomisario: 'Seleccionar si es persona física o persona moral.',
        nombre_fideicomisario: 'Proporcionar nombre completo.',
        rfc_fideicomisario: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomisario.',
        sector: 'Elegir el sector al que pertenece.',
        lugar: 'Seleccionar en México o en el extranjero.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      if (!this.form_item.pais_id) {
        this.form_item.pais_id = 150;
      }
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = null;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("fideicomisos", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
          _this.$el.querySelector("[aria-invalid=true]").scrollIntoView({
            block: "center",
            behavior: "smooth"
          });
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = item;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.edit_item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("fideicomisos/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');

    this.$http.get("fideicomisos/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    }, function (error) {
      _this3.Err(error);
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();

    this.form_item.pais_id = 150;
  }
});

/***/ }),

/***/ "30hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿Realiza alguna actividad lucrativa independiente al empleo, cargo o comisión? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.clientes),expression:"info.clientes",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Datos de quien realiza la actividad")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Señalar quien realiza la actividad "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.propietario),expression:"info.propietario",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"propietario","label":"1"},model:{value:(_vm.form_item.propietario),callback:function ($$v) {_vm.$set(_vm.form_item, "propietario", $$v)},expression:"form_item.propietario"}},[_vm._v("Declarante")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"propietario","label":"2"},model:{value:(_vm.form_item.propietario),callback:function ($$v) {_vm.$set(_vm.form_item, "propietario", $$v)},expression:"form_item.propietario"}},[_vm._v("Pareja")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"propietario","label":"3"},model:{value:(_vm.form_item.propietario),callback:function ($$v) {_vm.$set(_vm.form_item, "propietario", $$v)},expression:"form_item.propietario"}},[_vm._v("Dependiente Económico")])],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('propietario')))]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre de la empresa o servicio que proporciona "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre),expression:"info.nombre",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre),expression:"form_item.nombre"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre","placeholder":"Nombre de la actividad comercial"},domProps:{"value":(_vm.form_item.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc),expression:"info.rfc",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc),expression:"form_item.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Cliente principal "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_persona),expression:"info.tipo_persona",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tipo_persona","label":"1"},model:{value:(_vm.form_item.tipo_persona),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_persona", $$v)},expression:"form_item.tipo_persona"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tipo_persona","label":"2"},model:{value:(_vm.form_item.tipo_persona),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_persona", $$v)},expression:"form_item.tipo_persona"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo_persona')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Señale el nombre o razón social del cliente principal "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_cliente),expression:"info.nombre_cliente",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_cliente),expression:"form_item.nombre_cliente"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_cliente","placeholder":"Nombre del cliente principal del negocio"},domProps:{"value":(_vm.form_item.nombre_cliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_cliente", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_cliente')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" RFC del cliente principal "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_cliente),expression:"info.rfc_cliente",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_cliente),expression:"form_item.rfc_cliente"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_cliente","placeholder":"RFC del Cliente"},domProps:{"value":(_vm.form_item.rfc_cliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_cliente", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_cliente')))]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.validaciones.rfc),expression:"validaciones.rfc"}],staticClass:"text-danger"},[_vm._v(" El formato de la CURP no es válido, verifica la información ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector productivo al que pertenece "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.sector),expression:"info.sector",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"sector","filterable":"","placeholder":"Sector"},model:{value:(_vm.form_item.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.form_item, "sector_industria_id", $$v)},expression:"form_item.sector_industria_id"}},_vm._l((_vm.sectores_industria),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('sector')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Monto aproximado del beneficio o ganancia mensual que obtiene del cliente principal "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.monto),expression:"info.monto",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:0'),expression:"'required|decimal:0'"},{name:"model",rawName:"v-model",value:(_vm.form_item.monto),expression:"form_item.monto"}],attrs:{"type":"number","name":"monto","controls-position":"right","min":0},domProps:{"value":(_vm.form_item.monto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "monto", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('monto')))])]),_vm._v(" "),_c('legend',[_vm._v("Lugar donde se ubica "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.lugar),expression:"info.lugar",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" País ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"pais","filterable":"","placeholder":"País"},model:{value:(_vm.form_item.pais_id),callback:function ($$v) {_vm.$set(_vm.form_item, "pais_id", $$v)},expression:"form_item.pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('pais')))])],1),_vm._v(" "),(_vm.form_item.pais_id==150)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" Entidad Federativa ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"entidad","filterable":"","placeholder":"Entidad"},model:{value:(_vm.form_item.entidad_federativa_id),callback:function ($$v) {_vm.$set(_vm.form_item, "entidad_federativa_id", $$v)},expression:"form_item.entidad_federativa_id"}},_vm._l((_vm.entidades),function(option){return _c('el-option',{key:option.nom_ent,staticClass:"select-default",attrs:{"value":option.id,"label":option.nom_ent}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('entidad')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.propietario",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterDeclarante(item.propietario)))])]}},{key:"item.tipo_persona",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipoPersona(item.tipo_persona)))])]}},{key:"item.sector_industria_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterSector(item.sector_industria_id)))])]}},{key:"item.monto",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("$ "+_vm._s(_vm._f("currency")(item.monto)))])]}}],null,false,250194295)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("CLIENTES PRINCIPALES (HASTA LOS 2 ÚLTIMOS AÑOS) ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de clientes principales de la pareja o dependientes económicos no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "38s3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"tag":"li","title":"5 Notificaitons","icon":"ti-bell"}},[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"slot":"title","href":"javascript:void(0)","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5")]),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Notifications\n        "),_c('b',{staticClass:"caret"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 3")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 4")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another notification")])])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"dropdown-toggle btn-magnify",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown"}},[_c('i',{staticClass:"ti-panel"}),_vm._v(" "),_c('p',[_vm._v("Stats")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"btn-rotate",attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Settings\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3K6u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3RWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BeneficiosPrivados_vue__ = __webpack_require__("7YfK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe6a674_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BeneficiosPrivados_vue__ = __webpack_require__("y3hG");
function injectStyle (ssrContext) {
  __webpack_require__("3K6u")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BeneficiosPrivados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe6a674_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BeneficiosPrivados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3bdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ListDeclaraciones_vue__ = __webpack_require__("xYbJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c7440d1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ListDeclaraciones_vue__ = __webpack_require__("56y6");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ListDeclaraciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c7440d1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ListDeclaraciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "45qv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Recibió ingresos por enajenación de bienes ?\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre, denominación o razón social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_enajenaciones.nombre_denominacion_razon_social),expression:"item_enajenaciones.nombre_denominacion_razon_social"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre, denominación o razón social de quien se adquirió el inmueble:"},domProps:{"value":(_vm.item_enajenaciones.nombre_denominacion_razon_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_enajenaciones, "nombre_denominacion_razon_social", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_enajenaciones.rfc),expression:"item_enajenaciones.rfc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RFC"},domProps:{"value":(_vm.item_enajenaciones.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_enajenaciones, "rfc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("CURP (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_enajenaciones.curp),expression:"item_enajenaciones.curp"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CURP"},domProps:{"value":(_vm.item_enajenaciones.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_enajenaciones, "curp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector / Industria (si aplica)")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_enajenaciones.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.item_enajenaciones, "sector_industria_id", $$v)},expression:"item_enajenaciones.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de actividad o servicio que produjo el ingreso")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_enajenaciones.tipo_actividad_servicio_id),callback:function ($$v) {_vm.$set(_vm.item_enajenaciones, "tipo_actividad_servicio_id", $$v)},expression:"item_enajenaciones.tipo_actividad_servicio_id"}},_vm._l((_vm.actividades),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Descripción del bien")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_enajenaciones.descripcion_bien),expression:"item_enajenaciones.descripcion_bien"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción de la actividad"},domProps:{"value":(_vm.item_enajenaciones.descripcion_bien)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_enajenaciones, "descripcion_bien", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 customCurrency"},[_c('label',{staticClass:"control-label"},[_vm._v("Ingreso bruto anual recibido por la enajenación del bien")]),_vm._v(" "),_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{staticClass:"text-right",attrs:{"type":"number","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.item_enajenaciones.ingreso_bruto_anual),callback:function ($$v) {_vm.$set(_vm.item_enajenaciones, "ingreso_bruto_anual", $$v)},expression:"item_enajenaciones.ingreso_bruto_anual"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.item_enajenaciones.moneda_id),callback:function ($$v) {_vm.$set(_vm.item_enajenaciones, "moneda_id", $$v)},expression:"item_enajenaciones.moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.item_enajenaciones.moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Duración o frecuencia ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_enajenaciones.duracion_frecuencia),expression:"item_enajenaciones.duracion_frecuencia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Frecuencia"},domProps:{"value":(_vm.item_enajenaciones.duracion_frecuencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_enajenaciones, "duracion_frecuencia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Unidad temporal")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_enajenaciones.unidad_temporal_id),callback:function ($$v) {_vm.$set(_vm.item_enajenaciones, "unidad_temporal_id", $$v)},expression:"item_enajenaciones.unidad_temporal_id"}},_vm._l((_vm.plazos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.item_enajenaciones.unidad_temporal_id == 4)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de transacción")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.item_enajenaciones.fecha_transaccion),callback:function ($$v) {_vm.$set(_vm.item_enajenaciones, "fecha_transaccion", $$v)},expression:"item_enajenaciones.fecha_transaccion"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones / Comentarios")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_enajenaciones.observaciones),expression:"item_enajenaciones.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Observaciones / Comentarios"},domProps:{"value":(_vm.item_enajenaciones.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_enajenaciones, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":""},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_enajenaciones","responsive":"","hover":"","items":_vm.list_enajenaciones,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.entidad_federativa_id)))]}},{key:"localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.localidad_id))+"\n            ")]}},{key:"municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.municipio_id)))]}},{key:"pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_id)))]}},{key:"sector_industria_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSector(row.item.sector_industria_id)))]}},{key:"tipo_actividad_servicio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getActividad(row.item.tipo_actividad_servicio_id)))]}},{key:"ingreso_bruto_anual",fn:function(row){return [_vm._v(_vm._s((_vm.getSignoDos(row.item.moneda_id)))+"\n              "+_vm._s(_vm._f("currency")(row.item.ingreso_bruto_anual)))]}},{key:"moneda_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getMoneda(row.item.moneda_id)))]}},{key:"unidad_temporal_id",fn:function(row){return [_vm._v(_vm._s(_vm.getUnidades(row.item.unidad_temporal_id)))]}}],null,false,2722672800)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Enajenación de bienes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4CJV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4SKm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_excel_export__ = __webpack_require__("VdFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");























__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);

__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_excel_export__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    PPagination: __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: 0,
        periodo: '',
        estatus: 1
      },
      dependencias: {},
      rol: '',
      periodos: [],
      mostrar: false,
      tiposDeclaracion: [{
        'id': 1,
        'tipo_declaracion': 'Inicial'
      }, {
        'id': 2,
        'tipo_declaracion': 'Anual'
      }, {
        'id': 3,
        'tipo_declaracion': 'Final'
      }, {
        'id': 4,
        'tipo_declaracion': 'Todas'
      }],
      estatus: [{
        'id': 1,
        'estatus': 'Activos'
      }, {
        'id': 2,
        'estatus': 'Bajas'
      }, {
        'id': 3,
        'estatus': 'Todos'
      }],
      list_cumplimiento: [],
      json_fields: {
        'Dependencia': 'dependencia',
        'Obligados': 'obligados',
        'Cumplidos': 'cumplidos',
        'Individual': 'individual',
        'Faltantes': 'faltante',
        'Total': 'total'
      },
      json_data: [],
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      pagination: {
        perPage: 15,
        currentPage: 1,
        perPageOptions: [15, 30, 45, 60],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['rfc', 'nombres', 'cargo'],
      tableColumns: [{
        prop: 'dependencia',
        label: 'Dependencia',
        minWidth: 200,
        class: 'text-left'
      }, {
        prop: 'obligados',
        label: 'Obligados',
        minWidth: 70,
        class: 'text-right'
      }, {
        prop: 'cumplidos',
        label: 'Cumplidos',
        minWidth: 70,
        class: 'text-right'
      }, {
        prop: 'faltante',
        label: 'Faltantes',
        minWidth: 75,
        class: 'text-right'
      }, {
        prop: 'individual',
        label: '% Individual',
        minWidth: 70,
        class: 'text-right'
      }, {
        prop: 'total',
        label: 'Total',
        minWidth: 75,
        class: 'text-right'
      }]
    };
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_cumplimiento;
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_cumplimiento.length;
        return this.pagedData;
      }
      var result = this.list_cumplimiento.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    }
  },
  created: function created() {
    this.checkPermissions();
    this.getDependencias();
    this.getTipoDeclaracion();
    this.getPeriodos();
    this.rol = this.getKey('role');
    if (this.getKey('permisos').includes(16)) {
      this.model = {
        tipo_declaracion: 2,
        dependencia_id: 0,
        periodo: 2020,
        estatus: 3
      };
    }
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      var permiso = [12, 16];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      if (row.dependencia === "TOTAL") return 'text-right totales';else return 'text-right';
    },
    getDependencias: function getDependencias() {
      var _this2 = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this2.dependencias = response.data.entes_publicos;
        _this2.dependencias.push({
          'codigo': 'T',
          'id': 0,
          'valor': 'TODAS'
        });
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getTipoDeclaracion: function getTipoDeclaracion() {},
    getPeriodos: function getPeriodos() {
      var _this3 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this3.periodos = response.data.periodos;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    getCumplimiento: function getCumplimiento() {
      var _this4 = this;

      if (!this.getKey('permisos').includes(16)) this.model.dependencia_id = this.getKey('ente_publico_id');

      var url = void 0;

      if (this.model.estatus == 1) url = "cumplimientoAct2";else if (this.model.estatus == 2) url = "cumplimientoBj2";else url = "cumplimiento2";

      this.$http.post(url, this.model).then(function (response) {

        _this4.mostrar = true;
        var v = _this4;
        v.list_cumplimiento = [];
        v.list_cumplimiento.push({
          'dependencia': 'Dependencia',
          'obligados': 'Obligados',
          'cumplidos': 'Cumplidos',
          'faltante': 'Faltantes',
          'individual': '% Individual',
          'total': 'Total'

        });
        $.each(response.data, function (key, value) {
          v.list_cumplimiento.push({
            'dependencia': value.entidad['valor'],
            'obligados': v.group1k(value.obligados),
            'cumplidos': v.group1k(value.cumplidos),
            'faltante': v.group1k(value.faltantes),
            'individual': v.group1k(value.individual) + '%',
            'total': v.group1k(value.total) + '%'

          });
          v.json_data.push({
            'dependencia': value.entidad['valor'],
            'obligados': v.group1k(value.obligados),
            'cumplidos': v.group1k(value.cumplidos),
            'faltante': v.group1k(value.faltantes),
            'individual': v.group1k(value.individual) + '%',
            'total': v.group1k(value.total) + '%'

          });
        });
      }, function (error) {
        _this4.StepError(error);
      });
    }
  }
});

/***/ }),

/***/ "4wA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_HCorrecciones_vue__ = __webpack_require__("WRLi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8b03ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_HCorrecciones_vue__ = __webpack_require__("LIgc");
function injectStyle (ssrContext) {
  __webpack_require__("VVNl")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_HCorrecciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8b03ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_HCorrecciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4wr1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      ip_id: null,
      add_item: false,
      edit_item: null,
      bandera: '0',
      form_item: {},
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Dado de baja',
        value: 'motivo_baja',
        align: 'center'
      }, {
        text: 'Tipo de bien',
        value: 'tipo_bien_id',
        align: 'center'
      }, {
        text: 'Titular del bien',
        value: 'titular_id',
        align: 'center'
      }, {
        text: 'Descripción general del bien',
        value: 'descripcion',
        align: 'center'
      }, {
        text: 'Aclaraciones / Observaciones',
        value: 'observaciones',
        align: 'center'
      }],
      info: {
        bienes: 'Para la declaración de inicio reportar la situación de los vehículos a la fecha de ingreso al empleo, cargo o comisión. Para la declaración de modificación reportar la situación de los vehículos del año inmediato anterior. Para la declaración de conclusión reportar la situación de los vehículos a la fecha de conclusión del empleo, cargo o comisión.',
        tipo_bien: 'Seleccionar el tipo de vehículo del listado desplegable: automóvil/motocicleta, aeronave, barco/yate, otro, especifique.',
        titular: 'Seleccionar alguna de las opciones del catálogo desplegable.',
        tercero: 'En caso de copropiedad con un tercero, seleccionar si es persona física o persona moral.',
        nombre_tercero: 'En caso de copropiedad, escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
        rfc_tercero: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
        transmisor: 'Seleccionar si es persona física o persona moral.',
        nombre_transmisor: 'Escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
        rfc_transmisor: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
        relacion: 'Elegir del catálogo qué relación tiene el titular del vehículo con el transmisor.',
        descripcion: 'Elegir la marca del catálogo desplegable.',
        forma_adquisicion: 'Seleccionar alguna de las opciones del catálogo.',
        forma_pago: 'Seleccionar la forma en que realizó el pago para adquirir el vehículo, en caso de que no haya pagado por el mismo, indicará no aplica.',
        precio_adquisicion_valor: 'Proporcionar el monto de adquisición, conforme al documento con el que se acredita la propiedad.',
        precio_adquisicion_moneda_id: 'Seleccionar la moneda relativa al valor de adquisición.',
        fecha_adquisicion: 'Señalar la fecha de adquisición del vehículo, conforme al documento con el que se acredita la propiedad.',
        motivo_baja: 'Elegir la razón por la cual se da de baja: venta, donación, siniestro, otro. Especifique.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },


  computed: {
    terceros: function terceros() {
      if (this.form_item) {
        if (this.form_item.titular_id) {
          var arr = [3, 4, 5, 8, 10, 13, 15, 18, 19, 24, 25];
          return arr.includes(this.form_item.titular_id);
        }
      }
      return false;
    },
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.form_item.precio_adquisicion_moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.form_item.precio_adquisicion_moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      if (!this.form_item.pais_id) {
        this.form_item.pais_id = 150;
      }
      this.form_item.precio_adquisicion_moneda_id = 97;
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = false;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("bienes_muebles_no_registrados", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");

              if (!_this.edit_item) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
          _this.scrolling();
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = true;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("bienes_muebles_no_registrados/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    checkDomicilio: function checkDomicilio() {
      if (this.n_domicilio) {
        this.form_item.pais_id = this.n_domicilio.pais;
        this.form_item.entidad_federativa_id = this.n_domicilio.entidadF;
        this.form_item.municipio_id = this.n_domicilio.municipio;
        this.form_item.localidad_id = this.n_domicilio.localidad;
        this.form_item.cp = this.n_domicilio.cp;
        this.form_item.vialidad_nombre = this.n_domicilio.vialidad_nombre;
        this.form_item.vialidad_tipo = this.n_domicilio.vialidad;
        this.form_item.numext = this.n_domicilio.ext;
        this.form_item.numint = this.n_domicilio.int;
        this.form_item.colonia = this.n_domicilio.colonia;
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');
    this.$http.get("bienes_muebles_no_registrados/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();
    this.form_item.pais_id = 150;
  }
});

/***/ }),

/***/ "4x0F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "51Y3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52dV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52yL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "56y6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Lista de Declaraciones")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Declaración ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"declaracion","placeholder":"Declaracion"},model:{value:(_vm.model.tipo_declaracion),callback:function ($$v) {_vm.$set(_vm.model, "tipo_declaracion", $$v)},expression:"model.tipo_declaracion"}},_vm._l((_vm.tiposDeclaracion),function(option){return _c('el-option',{key:option.tipo_declaracion,staticClass:"select-default",attrs:{"value":option.id,"label":option.tipo_declaracion}})}),1)],1),_vm._v(" "),(_vm.rol===4 || _vm.rol===5 || _vm.rol === 14)?_c('div'):_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Año")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.model.periodo),callback:function ($$v) {_vm.$set(_vm.model, "periodo", $$v)},expression:"model.periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success pull-right",on:{"click":_vm.getDeclaraciones}},[_vm._v("\n        Buscar\n      ")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"offset-md-6 col-sm-6 col-md-6 col-lg-6"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[(_vm.rol!=4)?_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.filtro_usuarios,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([(this.getKey('permisos').includes(25))?{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Descargar Declaración Completa'),expression:"'Descargar Declaración Completa'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.descargar1(item)}}},[_c('i',{staticClass:"ti-download"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Descargar Declaración Pública'),expression:"'Descargar Declaración Pública'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item)}}},[_c('i',{staticClass:"ti-download"})])],1)]}}:{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Descargar Declaración Completa'),expression:"'Descargar Declaración Completa'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.descargar1(item)}}},[_c('i',{staticClass:"ti-download"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Descargar Declaración Pública'),expression:"'Descargar Declaración Pública'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item)}}},[_c('i',{staticClass:"ti-download"})])],1)]}},{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat(item.fecha)))])]}},{key:"item.titular_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.titular_id,_vm.titular_adeudo)))])]}}],null,true)}):_c('v-data-table',{attrs:{"headers":_vm.headers2,"items":_vm.filtro_usuarios,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([(this.getKey('permisos').includes(25))?{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Descargar Declaración Completa'),expression:"'Descargar Declaración Completa'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.descargar1(item)}}},[_c('i',{staticClass:"ti-download"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Descargar Declaración Pública'),expression:"'Descargar Declaración Pública'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item)}}},[_c('i',{staticClass:"ti-download"})])],1)]}}:null,{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat(item.fecha)))])]}},{key:"item.titular_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.titular_id,_vm.titular_adeudo)))])]}}],null,true)})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("L4gl");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c53c3e62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("RuSy");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c53c3e62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "5Lim":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_excel_export__ = __webpack_require__("VdFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");





















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_excel_export__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    PPagination: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        periodo: ''
      },
      dependencias: {},
      rol: '',
      periodos: [],
      loading_bar: false,
      dependenciaT: '',
      mostrar: false,
      perPage: 5,
      rows: null,
      currentPage: 1,
      filter: null,
      perPage2: 5,
      rows2: null,
      currentPage2: 1,
      filter2: null,
      list_declarantes: [],
      avance: 0,
      avanced: '',
      totald: '',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      cumplidos_campos: {
        'Tipo': 'tipo',
        'RFC': 'rfc',
        'Nombres': 'nombres',
        'Fecha': 'fecha',
        'Fecha Posesion': 'fecha_posesion',
        'Fecha Termino': 'fecha_termino',
        'Limite': 'limite'
      },
      nombreC: '',
      nombreF: '',
      cumplidos_data: [],
      meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      fecha: '',
      propsToSearch: ['rfc', 'nombres', 'cargo'],
      propsToSearch2: ['rfc', 'nombres', 'cargo', 'correo1', 'correo2', 'tel1', 'tel2'],
      headers: [{
        text: 'Tipo',
        align: 'center',
        value: 'tipo',
        class: '',
        width: 150
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombres',
        value: 'nombres',
        align: 'left'
      }, {
        text: 'Fecha Ingreso/Baja',
        value: 'fecha',
        align: 'center'
      }, {
        text: 'Fecha Limite',
        value: 'fechaLimite',
        align: 'center'
      }, {
        text: 'Limite',
        value: 'prog',
        align: 'center'
      }]

    };
  },

  computed: {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_declarantes.length;

      return this.list_declarantes.length;
    }
  },
  created: function created() {
    this.checkPermissions();
    this.getDependencias();
    this.getPeriodos();
    this.rol = this.getKey('role');
    var myDate = new Date();
    var mes = ('0' + (myDate.getMonth() + 1)).slice(-2);
    var dia = ('0' + myDate.getDate()).slice(-2);
    var anio = myDate.getFullYear();
    this.fecha = dia + '/' + mes + '/' + anio;

    this.nombreC = "Omisos" + this.fecha + ".xls";
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [6, 21];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
      if (!this.getKey('permisos').includes(21)) this.getOmisos();
    },
    getDependencias: function getDependencias() {
      var _this = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this.dependencias = response.data.entes_publicos;
        _this.dependencias.push({
          'codigo': 'T',
          'id': 0,
          'valor': 'Todas'
        });
      }, function (error) {
        _this.StepError(error);
      });
    },
    getPeriodos: function getPeriodos() {
      var _this2 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this2.periodos = response.data.periodos;
      }, function (error) {
        _this2.StepError(error);
      });
    },

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    getOmisos: function getOmisos() {
      var _this3 = this;

      if (!this.getKey('permisos').includes(21)) this.model.dependencia_id = this.getKey('ente_publico_id');
      if (this.model.dependencia_id >= 0) {
        this.loading_bar = true;
        this.$http.post("getOmisos2", this.model).then(function (response) {
          _this3.list_declarantes = response.data.omisos;
          console.log(response.data.id_error);
          _this3.loading_bar = false;
        }, function (error) {
          _this3.StepError(error);
          _this3.loading_bar = false;
        });
      } else {
        this.StepW('Llena todos los campos');
      }
    }
  }
});

/***/ }),

/***/ "5mre":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Declaraciones2_vue__ = __webpack_require__("s5oc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afe9e40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Declaraciones2_vue__ = __webpack_require__("NnYs");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Declaraciones2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afe9e40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Declaraciones2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5wbZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "5yFB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",function(){return [_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]}),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Mai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SueldosSalariosOtros_vue__ = __webpack_require__("JOhr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_01bce3c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SueldosSalariosOtros_vue__ = __webpack_require__("Nn4I");
function injectStyle (ssrContext) {
  __webpack_require__("OP2K")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SueldosSalariosOtros_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_01bce3c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SueldosSalariosOtros_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6P6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("s/F+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("yrbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'DeclaraNET 2019'
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'white',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'info',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/background/icon_logo.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: null,
      isClosed: true,
      permisos: []
    };
  },

  watch: {
    visible: function visible() {},
    $sidebar: {
      handler: function handler(val, oldval) {},
      deep: true
    }
  },
  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    }
  },
  methods: {
    tablero: function tablero() {
      console.log(this.getKey('role'));
      if (this.getKey('role') == '0') {
        this.$router.push('/forms/tablero');
      } else {
        this.$router.push('/admin/tablero');
      }
    },
    initScrollBarAsync: function initScrollBarAsync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "ryUE"));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "mua9"));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cerrarSesion: function cerrarSesion() {
      localStorage.clear();
      this.$router.push('/');
    },
    checaPermisos: function checaPermisos(permisoLink) {
      return this.permisos.some(function (r) {
        return permisoLink.includes(r);
      });
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.initScrollBarAsync();
    this.visible = document.querySelector('.sidebar-normal');
    var rol = 0;
    var stats = 0;
    var uid = 0;
    var simplificada = '0';
    if (this.getKey('role') != 0) this.permisos = this.getKey('permisos');else {
      this.permisos = [1];
    }
    if (localStorage.getItem('app-token-declaranet')) {
      simplificada = this.getKey('simplificada');
      rol = this.getKey('role');
      uid = this.getKey('uid');
      stats = this.getKey('status_dec');
    }
    var declaracion = void 0;
    var menu = void 0;
    var declaraciones = void 0;
    var fiscal = void 0;
    var interes = void 0;


    var historial = [{
      name: 'Declaraciones',
      path: '/forms/historico',
      icon: 'fas fa-list',
      permiso: [1]
    }, {
      name: 'Aclaraciones',
      path: '/forms/aclaraciones',
      icon: 'fas fa-info',
      permiso: [1]
    }];

    if (stats == 1) {
      if (simplificada == '1') {
        declaracion = [{
          name: 'Información Personal',
          path: '/forms/infpersonal',
          permiso: [1],
          icon: 'fas fa-user-cog'
        }, {
          name: 'Intereses',
          path: '/forms/intereses',
          permiso: [1],
          icon: 'fas fa-file-invoice-dollar'
        }, {
          name: 'Ingresos',
          path: '/forms/ingresos',
          permiso: [1],
          icon: 'fas fa-dollar-sign'
        }];
      } else {
        declaracion = [{
          name: 'Información Personal',
          path: '/forms/infpersonal',
          icon: 'fas fa-user-cog',
          permiso: [1]
        }, {
          name: 'Intereses',
          path: '/forms/intereses',
          permiso: [1],
          icon: 'fas fa-file-invoice-dollar'
        }, {
          name: 'Ingresos',
          path: '/forms/ingresos',
          permiso: [1],
          icon: 'fas fa-dollar-sign'
        }, {
          name: 'Activos',
          path: '/forms/activos',
          permiso: [1],
          icon: 'fas fa-hand-holding-usd'
        }, {
          name: 'Pasivos',
          path: '/forms/pasivos',
          permiso: [1],
          icon: 'fas fa-money-bill'
        }, {
          name: 'Resumen',
          path: '/forms/resumen',
          icon: 'fas fa-file-invoice',
          permiso: [1]
        }];
      }
      declaraciones = [];
    } else {
      declaracion = [{
        name: 'Enviada',
        path: '/forms/enviada',
        icon: 'fas fa-user-cog',
        permiso: [1]
      }];
      fiscal = [{
        name: 'Acuse de Declaración Fiscal',
        path: '/forms/fiscal',
        icon: 'fas fa-balance-scale',
        permiso: [1]
      }];
      interes = [{
        name: 'Manifestación de actualización de Conflicto de Intereses',
        path: '/forms/intereses',
        icon: 'fas fa-file-invoice-dollar',
        permiso: [1]
      }];
      declaraciones = [{
        name: 'Declaración 2019',
        path: '/forms/enviada',
        icon: 'fas fa-angle-right',
        permiso: [1]
      }];
    }
    if (rol != 0) {
      if (uid == 89) {
        menu = [{
          name: 'Declaraciones',
          icon: 'ti-clipboard',
          collapsed: false,
          children: [{
            name: 'Lista Declaraciones',
            path: '/reportes/ldeclaraciones',
            icon: 'fas fa-clipboard-list',
            permiso: [1, 25]
          }, {
            name: 'Historico Declaraciones',
            path: '/reportes/hdecl',
            icon: 'fas fa-history',
            permiso: [1, 25]
          }]
        }, {
          name: 'Padrón',
          icon: 'ti-agenda',
          collapsed: false,
          children: [{
            name: 'Altas de personal',
            path: '/admin/altapersonal',
            icon: 'fas fa-user-plus',
            permiso: [3]
          }, {
            name: 'Movimientos',
            path: '/admin/movimientos',
            icon: 'fas fa-user-edit',
            permiso: [4]
          }, {
            name: 'Plantilla',
            path: '/admin/plantilla',
            icon: 'fas fa-file-excel',
            permiso: [13]
          }, {
            name: 'Plantilla de Ingresos',
            path: '/admin/plantilla_ingresos',
            icon: 'fas fa-file-excel',
            permiso: [5]
          }, {
            name: 'Plantilla para bajas',
            path: '/admin/plantilla_bajas',
            icon: 'fas fa-file-excel',
            permiso: [5, 13]
          }]
        }, {
          name: 'Procedimientos',
          icon: 'ti-write',
          collapsed: false,
          children: [{
            name: 'Casos omisos',
            path: '/reportes/omisos',
            icon: 'fas fa-eye-slash',
            permiso: [6, 21]
          }]
        }, {
          name: 'Configuración',
          icon: 'ti-settings',
          collapsed: false,
          children: [{
            name: 'Usuarios',
            path: '/admin/usuarios',
            icon: 'fas fa-users-cog',
            permiso: [8]
          }, {
            name: 'Permisos',
            path: '/admin/permisos',
            icon: 'fas fa-key',
            permiso: [9]
          }]
        }, {
          name: 'Reportes',
          icon: 'ti-printer',
          children: [{
            name: 'Declaraciones',
            path: '/reportes/declaraciones',
            icon: 'fas fa-clipboard-list',
            permiso: [10, 14]
          }, {
            name: 'Movimientos',
            path: '/reportes/movimientos',
            icon: 'fas fa-arrows-alt',
            permiso: [11, 15]
          }, {
            name: 'Cumplimiento',
            path: '/reportes/cumplimiento',
            icon: 'fas fa-tasks',
            permiso: [12, 16]
          }, {
            name: 'Reporte declaraciones',
            path: '/reportes/RepDeclaraciones',
            icon: 'fas fa-check-double',
            permiso: [1]
          }, {
            name: 'No de Declaraciones',
            path: '/reportes/reporteDeclaraciones2',
            icon: 'fas fa-calendar',
            permiso: [1]
          }, {
            name: 'Conflicto de Interés ',
            path: '/reportes/reporteConflictoInt',
            icon: 'fas fa-balance-scale',
            permiso: [1]
          }, {
            name: 'Bajas por defunción ',
            path: '/reportes/reporteBajasDefuncion',
            icon: 'fas fa-archive',
            permiso: [1]
          }, {
            name: 'Accesos a balanza',
            path: '/reportes/reporteAccesosBalanza',
            icon: 'fas fa-archive',
            permiso: [1]
          }]
        }];
      } else menu = [{
        name: 'Declaraciones',
        icon: 'ti-clipboard',
        collapsed: false,
        children: [{
          name: 'Lista Declaraciones',
          path: '/reportes/ldeclaraciones',
          icon: 'fas fa-clipboard-list',
          permiso: [1, 25]
        }, {
          name: 'Historico Declaraciones',
          path: '/reportes/hdecl',
          icon: 'fas fa-history',
          permiso: [1, 25]
        }]
      }, {
        name: 'Padrón',
        icon: 'ti-agenda',
        collapsed: false,
        children: [{
          name: 'Altas de personal',
          path: '/admin/altapersonal',
          icon: 'fas fa-user-plus',
          permiso: [3]
        }, {
          name: 'Movimientos',
          path: '/admin/movimientos',
          icon: 'fas fa-user-edit',
          permiso: [4]
        }, {
          name: 'Plantilla',
          path: '/admin/plantilla',
          icon: 'fas fa-file-excel',
          permiso: [13]
        }, {
          name: 'Plantilla de Ingresos',
          path: '/admin/plantilla_ingresos',
          icon: 'fas fa-file-excel',
          permiso: [5]
        }]
      }, {
        name: 'Procedimientos',
        icon: 'ti-write',
        collapsed: false,
        children: [{
          name: 'Casos omisos',
          path: '/reportes/omisos',
          icon: 'fas fa-eye-slash',
          permiso: [6, 21]
        }]
      }, {
        name: 'Act. Programadas',
        icon: 'ti-timer',
        collapsed: false,
        children: [{
          name: 'Activación Anual',
          path: '/admin/cronanual',
          icon: 'ti-loop',
          permiso: [27]
        }]
      }, {
        name: 'Configuración',
        icon: 'ti-settings',
        collapsed: false,
        children: [{
          name: 'Usuarios',
          path: '/admin/usuarios',
          icon: 'fas fa-users-cog',
          permiso: [8]
        }, {
          name: 'Permisos',
          path: '/admin/permisos',
          icon: 'fas fa-key',
          permiso: [9]
        }]
      }, {
        name: 'Reportes',
        icon: 'ti-printer',
        children: [{
          name: 'Declaraciones',
          path: '/reportes/declaraciones',
          icon: 'fas fa-clipboard-list',
          permiso: [10, 14]
        }, {
          name: 'Movimientos',
          path: '/reportes/movimientos',
          icon: 'fas fa-arrows-alt',
          permiso: [11, 15]
        }, {
          name: 'Cumplimiento',
          path: '/reportes/cumplimiento',
          icon: 'fas fa-tasks',
          permiso: [12, 16]
        }, {
          name: 'Reporte declaraciones',
          path: '/reportes/RepDeclaraciones',
          icon: 'fas fa-check-double',
          permiso: [1]
        }, {
          name: 'No de Declaraciones',
          path: '/reportes/reporteDeclaraciones2',
          icon: 'fas fa-calendar',
          permiso: [1]
        }, {
          name: 'Conflicto de Interés ',
          path: '/reportes/reporteConflictoInt',
          icon: 'fas fa-balance-scale',
          permiso: [26]
        }, {
          name: 'Bajas por defunción ',
          path: '/reportes/reporteBajasDefuncion',
          icon: 'fas fa-archive',
          permiso: [1]
        }, {
          name: 'Accesos a balanza',
          path: '/reportes/reporteAccesosBalanza',
          icon: 'fas fa-archive',
          permiso: [1]
        }]
      }];
    } else {
      menu = [{
        name: 'Historial declaraciones',
        icon: 'ti-archive',
        children: historial
      }, {
        name: 'Declaración patrimonial',
        icon: 'ti-clipboard',
        children: declaracion
      }, {
        name: 'Declaración Fiscal',
        icon: 'ti-file',
        children: fiscal
      }, {
        name: 'Intereses',
        icon: 'ti-file',
        children: interes
      }, {
        name: 'Guía de llenado',
        path: this.$rootUrl + '/Guia.pdf',
        icon: 'far fa-file-pdf',
        target: '_blank',
        children: ''

      }, {
        name: 'Guía rápida',
        path: 'https://www.powtoon.com/embed/fBmXjPtRPNP/',
        icon: 'fas fa-film',
        target: '_blank',
        children: ''

      }];
    }
    this.$sidebar.sidebarLinks = menu;
  },
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "6PUv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),(_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('legend',[_vm._v("Nombre del rol")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"},{name:"model",rawName:"v-model",value:(_vm.item_permisos.Rol),expression:"item_permisos.Rol"}],staticClass:"form-control",attrs:{"type":"text","name":"Rol","placeholder":""},domProps:{"value":(_vm.item_permisos.Rol)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_permisos, "Rol", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.Rol.invalid),expression:"Rol.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('Rol'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('legend',[_vm._v("Permisos del rol")]),_vm._v(" "),_c('el-transfer',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"d-flex justify-content-center",attrs:{"name":"permisos","titles":['Lista de permisos', 'Permisos activos'],"data":_vm.list_cat_permisos,"props":{key: 'id',label: 'permiso'}},model:{value:(_vm.item_permisos.Permisos),callback:function ($$v) {_vm.$set(_vm.item_permisos, "Permisos", $$v)},expression:"item_permisos.Permisos"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('permisos')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_permisos,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}}],null,false,2076588974)})],1)])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Permisos y Roles")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6QVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ActividadEmpresarial_vue__ = __webpack_require__("viuf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aba568c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ActividadEmpresarial_vue__ = __webpack_require__("NUVx");
function injectStyle (ssrContext) {
  __webpack_require__("YYqw")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ActividadEmpresarial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aba568c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ActividadEmpresarial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6aVB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6b8M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ultima_dec)?_c('div',{staticClass:"row"},[_c('app-modal',{attrs:{"id":"modal","title":_vm.modalTitle,"comp":_vm.modalComponent,"size":_vm.modalSize,"hideClose":false},model:{value:(_vm.rate),callback:function ($$v) {_vm.rate=$$v},expression:"rate"}}),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-2 container-fluid"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center alert-success"},[_c('h3',[_vm._v("Declaración Enviada Exitosamente")]),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"teal darken-2"},on:{"click":function($event){$event.preventDefault();return _vm.cerrarSesion.apply(null, arguments)}}},[_vm._v("\n          No olvides "),_c('u',{staticClass:"pl-2"},[_vm._v("Cerrar Sesión")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-md-offset-3 container-fluid text-center"},[_c('button',{staticClass:"btn btn-wd btn-info",attrs:{"type":"button"},on:{"click":_vm.descarga}},[_vm._m(0),_vm._v("\n      Descargar declaración\n    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-md-offset-3 container-fluid text-center"},[_c('button',{staticClass:"btn btn-wd btn-info",attrs:{"type":"button"},on:{"click":_vm.descargaAcuse}},[_vm._m(1),_vm._v("\n      Descargar Acuse\n    ")])])],1):_c('div',{staticClass:"row"},[_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-save"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-save"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-10 col-md-offset-2 container-fluid"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center alert-warning"},[_c('h3',[_vm._v("No cuenta con declaraciones realizadas.")]),_c('br')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6mlm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_usuarios,"expanded":_vm.expanded,"single-expand":_vm.singleExpand},on:{"update:expanded":function($event){_vm.expanded=$event}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var expand = ref.expand;
var isExpanded = ref.isExpanded;
return [_c('tr',[_c('td',[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){return expand(!isExpanded)}}},[_c('i',{staticClass:"fas fa-angle-down"})])],1),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(item.created_at)+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(item.usuarios.rfc)+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(item.usuarios.nombres)+" "+_vm._s(item.usuarios.primer_apellido)+" "+_vm._s(item.usuarios.segundo_apellido)+"\n                    ")])])]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('div',{staticClass:"row p-4"},[_c('div',{staticClass:" col-12"},[_c('div',{staticClass:"card "},[_c('div',{staticClass:"card-body"},[_c('p',[_c('strong',[_vm._v(" Motivo ")]),_vm._v(": "+_vm._s(item.motivo)+"\n                            ")]),_vm._v(" "),_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(" Cambios realizados por ")]),_vm._v(": "+_vm._s(_vm.getUsuario(item.created_by))+"\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Datos originales")]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((item.origen),function(value,key){return _c('li',{key:key,staticClass:"list-group-item"},[_c('strong',[_vm._v(_vm._s(key.replace("_", " ")))]),_vm._v(" : "+_vm._s(_vm.returnValueKey(value,key)))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Datos actualizados")]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((item.cambio),function(value,key){return _c('li',{key:key,staticClass:"list-group-item"},[_c('strong',[_vm._v(_vm._s(key.replace("_", " ")))]),_vm._v(" : "+_vm._s(_vm.returnValueKey(value,key)))])}),0)])])])]),_vm._v(" "),(_vm.validarp && item.status===0)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimiento.observaciones),expression:"movimiento.observaciones"},{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.observaciones),expression:"item_usuariosValidations.observaciones"}],staticClass:"form-control",attrs:{"type":"text","name":"observaciones","placeholder":"Motivos/Observaciones"},domProps:{"value":(_vm.movimiento.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimiento, "observaciones", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.observaciones.invalid),expression:"observaciones.invalid"}],staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('observaciones'))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.validar(item)}}},[_c('span',[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Validar\n                          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.rechazar(item)}}},[_c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Rechazar\n                          ")])])])]):_vm._e()])]}}],null,false,1722370823)})],1)])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Correciones")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7/DJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("l+io");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Domicilio_vue__ = __webpack_require__("Ta4m");









var _components, _methods;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'Domicilio', __WEBPACK_IMPORTED_MODULE_8__Domicilio_vue__["a" /* default */]), _components),

  data: function data() {
    return {
      opciones: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      },
      validaciones: {
        curp: false,
        rfc: false
      },
      ip_id: null,
      muestraCampos: true,
      datePicker: '',
      model: {
        curp: ''
      },
      list_dependientes: [],
      edit_item: null,
      add_item: false,
      paisesnac: {},
      n_domicilio: {},
      nacionalidadArr: [],
      sectores: {},
      tiposRelacion: {},
      tiposApoyo: {},
      ambitos: [{ id: 1, valor: "Público" }, { id: 2, valor: "Privado" }, { id: 3, valor: "Otro" }, { id: 4, valor: "Ninguno" }],
      poderes: [],
      niveles: [],
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Tipo Relacion',
        value: 'tipo_relacion_dep_id',
        align: 'left'
      }, {
        text: 'CURP',
        value: 'curp',
        align: 'left'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'left'
      }]

    };
  },

  watch: {
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.model.domicilio_pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.model.domicilio_entidad_federativa = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.model.domicilio_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.model.domicilio_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.model.domicilio_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.model.domicilio_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.model.domicilio_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.model.domicilio_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
          this.model.domicilio_nombre_vialidad = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.model.domicilio_tipo_vialidad = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
        }
      },
      deep: true
    }
  },
  methods: (_methods = {
    getAmbito: function getAmbito(index) {
      var resp = "";
      if (this.ambitos) {
        this.ambitos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getPoder: function getPoder(index) {
      var resp = "";
      if (this.poderes) {
        this.poderes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getNivel: function getNivel(index) {
      var resp = "";
      if (this.niveles) {
        this.niveles.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getPoderes: function getPoderes() {
      var _this = this;

      this.$http.get('poderJuridico').then(function (response) {
        _this.poderes = response.data.poderJuridico;
      }, function (error) {
        _this.StepError(error);
        console.log(error);
      });
    },
    getNivelesG: function getNivelesG() {
      var _this2 = this;

      this.$http.get('nivelGobierno').then(function (response) {
        _this2.niveles = response.data.nivelGobierno;
      }, function (error) {
        _this2.StepError(error);
        console.log(error);
      });
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.model.domicilio_pais_id;
      this.n_domicilio.entidadF = this.model.domicilio_entidad_federativa;
      this.n_domicilio.municipio = this.model.domicilio_municipio_id;
      this.n_domicilio.localidad = this.model.domicilio_localidad_id;
      this.n_domicilio.cp = this.model.domicilio_cp;
      this.n_domicilio.colonia = this.model.domicilio_colonia;
      this.n_domicilio.vialidad = this.model.domicilio_tipo_vialidad;
      this.n_domicilio.vialidad_nombre = this.model.domicilio_nombre_vialidad;
      this.n_domicilio.ext = this.model.domicilio_numext;
      this.n_domicilio.int = this.model.domicilio_numint;
    },
    limpiaCampos: function limpiaCampos() {
      this.nacionalidadArr = null;
      this.nacionalidadArr = [];
      this.model = {
        tipo_relacion_dep_id: '',
        nombres: '',
        primer_apellido: '',
        segundo_apellido: '',
        nac: '',
        curp: '',
        rfc: '',
        fecha_nacimiento: '',
        proveedor_contratista_gobierno: '',
        habita_domicilio_declarante: '',
        medio_contacto: '',
        ingresos_propios: '',
        ocupacion_profesion: '',
        sector_industria_id: '',
        tiene_intereses_mismo_sector_declarante: '',
        desarrolla_cabildeo_sector_declarante: '',
        beneficiario_programa_publico: '',
        observaciones: '',
        nom_vial: '',
        tipo_vial: ''
      };
    },
    editItem: function editItem(indice) {
      this.limpiaCampos();
      this.showItem();
      this.model = indice;


      var v = this;
      $.each(this.model.nac, function (key, value) {
        v.nacionalidadArr.push(value.nac_id);
      });
      this.model.nac = v.nacionalidadArr;
      this.editDomicilio();

      if (this.model.desempenia_admon_pub == '1') {
        this.model.nombre_dependencia = this.model.entidad.nombre_dependencia;
        this.model.fecha_inicio = this.model.entidad.fecha_inicio;
        this.model.fecha_fin = this.model.entidad.fecha_fin;
      }

      $(".main-panel").animate({
        scrollTop: 1300
      }, 500, "swing");
    },
    addItem: function addItem() {
      var _this3 = this;

      this.model.domicilio_pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
      this.model.domicilio_entidad_federativa = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
      this.model.domicilio_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
      this.model.domicilio_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
      this.model.domicilio_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
      this.model.domicilio_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
      this.model.domicilio_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
      this.model.domicilio_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
      this.model.domicilio_nombre_vialidad = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
      this.model.domicilio_tipo_vialidad = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";

      this.$validator.validateAll().then(function (response) {
        if (response) {
          _this3.loadButton(_this3.$refs.btnSave);

          _this3.$http.put('dependientesEc/' + _this3.ip_id, _this3.model).then(function (response) {
            _this3.StepOk("Guardado");

            if (_this3.edit_item === undefined || _this3.edit_item === null) {
              _this3.list_dependientes.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.model));
            } else {
              _this3.list_dependientes.splice(_this3.edit_item.index, 1, _this3.model);
            }

            _this3.showItem();
            _this3.limpiaCampos();
            _this3.edit_item = null;
            _this3.getDependientes();
          }, function (error) {
            _this3.StepError(error);
          });
        } else {
          _this3.StepW("Hay campos sin completar");
        }
      });
    },
    getSafe: function getSafe(fn, defaultVal) {
      try {
        return fn();
      } catch (e) {
        return defaultVal;
      }
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {}

      this.showItem();
      this.edit_item = null;
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    getDependientes: function getDependientes() {
      var _this4 = this;

      var v = this;
      this.$http.get('dependientesEc/' + this.ip_id).then(function (response) {
        _this4.list_dependientes = response.data.dependientes;
      }, function (error) {
        _this4.StepError(error);
        console.log(error);
      });
    },
    removeItem: function removeItem(item) {
      var _this5 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this5.$http.delete("dependientesEc/" + item.id).then(function (response) {
            var index = _this5.list_dependientes.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this5.list_dependientes.splice(index, 1);
            _this5.StepOk('Registro eliminado');
          }, function (error) {
            _this5.Err(error);
          });
        });
      }
    },
    getSectores: function getSectores() {
      var _this6 = this;

      this.$http.get('cat_sector_industria').then(function (response) {
        _this6.sectores = response.data.sectores;
      }, function (error) {
        _this6.StepError(error);
        console.log(error);
      });
    },
    getTipoRel: function getTipoRel(index) {
      var resp = "";
      if (this.tiposRelacion) {
        this.tiposRelacion.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getTipoApoyo: function getTipoApoyo() {
      var _this7 = this;

      this.$http.get('tipoApoyo').then(function (response) {
        _this7.tiposApoyo = response.data.tipos_apoyos;
      }, function (error) {
        _this7.StepError(error);
        console.log(error);
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var v = this;
      this.validaciones = {
        curp: false
      };

      var validacurp = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (v.add_item && !v.curpValida(v.getSafe(function () {
          return v.model.curp;
        }, ''))) {
          v.validaciones.curp = true;
          reject(false);
        } else {
          resolve(true);
        }
      });
      var ddependiente = this.$validator.validateAll();

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([ddependiente, validacurp]);
    },
    valida: function valida() {
      return this.$validator.validateAll();
    },
    getPaises: function getPaises() {
      var _this8 = this;

      this.$http.get('paises').then(function (response) {
        _this8.paisesnac = response.data.pais;
      }, function (error) {
        _this8.StepError(error);
        console.log(error);
      });
    },
    getTiposR: function getTiposR() {
      var _this9 = this;

      this.$http.get('tipoRelacDep').then(function (response) {
        _this9.tiposRelacion = response.data.tipos;
      }, function (error) {
        _this9.StepError(error);
        console.log(error);
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tags.inputValue;
      if (inputValue) {
        this.tags.dynamicTags.push(inputValue);
      }
      this.tags.inputVisible = false;
      this.tags.inputValue = '';
    }
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'getTipoRel', function getTipoRel(index) {
    var resp = "";
    if (this.tiposRelacion) {
      this.tiposRelacion.forEach(function (item) {
        if (item.id == index) {
          resp = item.valor;
          return resp;
        }
      });
    }
    return resp;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'getNombre', function getNombre(item) {
    var resp = (item.nombres || '') + " " + (item.primer_apellido || '') + " " + (item.segundo_apellido || '');

    return resp;
  }), _methods),
  mounted: function mounted() {

    this.ip_id = this.getId();
    this.getSectores();
    this.getPaises();
    this.getTiposR();
    this.getDependientes();
    this.getPoderes();
    this.getNivelesG();
  }
});

/***/ }),

/***/ "78GY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[(_vm.cargando)?_c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{attrs:{"id":"loader"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('a',{staticClass:"btn btn-wd btn-info pull-right mr-3",attrs:{"target":"_blanc","href":_vm.$rootUrl+'/PlantillaCargaIngresos.xlsx',"alt":"Plantilla XLSX"}},[_vm._m(1),_vm._v("\n                Descargar Plantilla\n              ")])])]),_vm._v(" "),_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveComprobante.apply(null, arguments)}}},[_c('table',{staticClass:"table"},[_c('tbody',[(_vm.getKey('permisos').includes(5) )?_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Seleccionar el archivo excel")]),_vm._v(" "),_c('td',[_c('input',{ref:"xlsx",staticClass:"form-control",attrs:{"id":"xlsx","accept":".xlsx","required":"","type":"file"},on:{"change":function($event){return _vm.addFile('xlsx')}}})])]):_vm._e(),_vm._v(" "),(_vm.grupo!=0 && _vm.xlsx!=0)?_c('tr',[_c('td',{attrs:{"colspan":"2","align":"center"}},[_c('button',{ref:"btnSave",staticClass:"btn btn-primary"},[_c('i',{staticClass:"fa fa-send"}),_vm._v(" Guardar")])])]):_vm._e()])])]),_vm._v(" "),(Object.entries(_vm.incorrectos).length > 0 )?_c('h3',{staticClass:"bg-info text-white",attrs:{"align":"center"}},[_vm._v("\n            Los siguientes registros cuentan con errores, favor de corregirlos y volver a cargar la plantilla. No se ha cargado ningún registro.\n          ")]):_vm._e(),_vm._v(" "),(Object.entries(_vm.incorrectos).length > 0 )?_c('b-table',{attrs:{"id":"tbl_incorrectos","responsive":"","hover":"","items":_vm.incorrectos,"fields":_vm.fields_list},scopedSlots:_vm._u([{key:"Renglon",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Renglon))])])]}},{key:"Columna",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Columna))])])]}},{key:"Nombre",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Nombre))])])]}},{key:"RFC",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.RFC))])])]}},{key:"Mensaje",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Mensaje))])])]}}],null,false,3672104190)},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2):_vm._e(),_vm._v(" "),(_vm.correctos>0)?_c('table',{staticClass:"table"},[_vm._m(2),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('label',{staticStyle:{"color":"#212529"}},[_vm._v("\n                    "+_vm._s(this.correctos)+" registros han sido importados correctamente, en un tiempo de carga: "+_vm._s(_vm.tiempo)+"\n                  ")])])])])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"card card-wizard"},[_c('div',{staticClass:"row p-3 m-0"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 "},[_c('v-text-field',{attrs:{"label":"Buscar","single-line":"","hide-details":""},on:{"keyup":_vm.uppercase},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('i',{staticClass:"fas fa-search"})]},proxy:true}]),model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.sinIngresos,"fixed-header":true,"footer-props":_vm.listSize,"options":_vm.pagination,"server-items-length":_vm.totalItems,"loading":_vm.loading,"item-key":"id"},on:{"update:options":[function($event){_vm.pagination=$event},_vm.getSinIngresos]}})],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8"},[_c('legend',[_vm._v("Importar ingresos del padrón de servidores públicos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("El archivo se importó correctamente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0 m-0"},[_c('legend',{staticClass:"p-0 m-0"},[_vm._v("Padrón sin ingresos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Hg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_usuarios,"search":_vm.filter,"items-per-page":5,"fixed-header":true,"custom-filter":_vm.buscaPers},scopedSlots:_vm._u([(_vm.rol==4 || _vm.rol == 1)?{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.reactivar(item)}}},[_c('i',{staticClass:"fas fa-unlock-alt"})])],1)]}}:null,{key:"item.rfc",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.usuarios.rfc)+" ")])]}},{key:"item.nombres",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.usuarios.nombres + ' '+ item.usuarios.primer_apellido +' '+item.usuarios.segundo_apellido)+" ")])]}},{key:"item.area",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.encargo.area_adscripcion))])]}},{key:"item.inicia",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm._f("dateFormat")(item.inicia)))])]}},{key:"item.nombreUsuario",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.usuario.Nombre + ' '+ item.usuario.Paterno +' '+item.usuario.Materno)+" ")])]}}],null,true)})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Servidores Inactivos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Jul":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7YfK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("kDzH");










var _components;


/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), _components),
  props: ["data"],
  data: function data() {
    return {
      validaciones: {
        rfc_parte: false
      },
      ip_id: 1,
      add_item: false,
      edit_item: null,
      pagado: null,
      bandera: '0',
      isnum: null,
      form_item: {},
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Beneficiario',
        value: 'beneficiario',
        align: 'center'
      }, {
        text: 'Tipo de Beneficio',
        value: 'tipo_beneficio',
        align: 'center'
      }, {
        text: 'Otorgante',
        value: 'otorgante',
        align: 'center'
      }, {
        text: 'Nombre o razón social',
        value: 'nombre',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Forma de recepción del beneficio',
        value: 'forma',
        align: 'center'
      }, {
        text: 'Tipo de moneda',
        value: 'tipo_moneda',
        align: 'center'
      }, {
        text: 'Monto mensual aproximado',
        value: 'monto',
        align: 'center'
      }, {
        text: 'Sector',
        value: 'sector_industria_id',
        align: 'center'
      }],
      info: {
        beneficios: 'Es la contribución monetaria o en especie que otorga una persona física o moral con recursos privados al Declarante o alguna de las personas señaladas en el catálogo. El apoyo en especie refiere a cualquier contribución, utilizando bienes o beneficios de naturaleza diferente al dinero. Deberá reportar hasta los últimos dos años.',
        beneficiario: 'Son las personas que reciben el apoyo o beneficio privado. De las opciones del catálogo indicar quien o quienes son los beneficiarios, señalar las veces que sean necesarias.',
        tipo_beneficio: 'Seleccionar del listado el tipo de beneficio sorteo, concurso, donación u otro (especifique).',
        otorgante: 'Seleccionar si es persona física o moral.',
        nombre: 'Proporcionar el nombre o razón social completos de quien otorga el beneficio.',
        rfc: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del otorgante del beneficio.',
        forma: 'Señalar si el apoyo recibido es monetario o en especie.',
        beneficio: 'En caso de haber seleccionado en especie deberá describir en que consiste el beneficio.',
        monto: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda.',
        tipo_moneda: 'Señalar tipo de moneda en que se recibe el beneficio.',
        sector: 'Elegir el sector al que pertenece.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },

  computed: {
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.form_item.tipo_moneda;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.form_item.tipo_moneda;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
      if (!this.form_item.tipo_moneda) {
        this.form_item.tipo_moneda = 97;
      }
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = null;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("beneficios_privados", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = item;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.edit_item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("beneficios_privados/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');
    this.$http.get("beneficios_privados/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    }, function (error) {
      _this3.Err(error);
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();

    this.form_item.pais_id = 150;
  }
});

/***/ }),

/***/ "7apm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rol: null,
      cargando: true,
      wizardModel: {},
      incorrectos: [],
      correctos: 0,
      grupo: 2,
      xlsx: 0,
      simplificadafl: false,
      entes: null,
      ente_publico_id: null,
      simplificada: '0',
      fields_list: [{
        key: "Renglon",
        label: "Renglon",
        tdClass: "text-left"
      }, {
        key: "Columna",
        label: "Columna(s)",
        tdClass: "text-left"
      }, {
        key: "Nombre",
        label: "Nombre",
        tdClass: "text-left"
      }, {
        key: "RFC",
        label: "RFC",
        tdClass: "text-left"
      }, {
        key: "Mensaje",
        label: "Mensaje",
        tdClass: "text-left",
        formatter: "emptyFields"
      }]
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"]
  },
  watch: {
    '$route': 'checkPermissions',
    'grupo': function grupo(val) {
      if (val == 3) {
        this.simplificada = '1';
        this.simplificadafl = true;
      } else this.simplificadafl = false;
    },
    'simplificada': function simplificada(val) {
      if (val == '1') this.grupo = 3;else this.grupo = 2;
    }
  },
  methods: {
    checkPermissions: function checkPermissions() {
      var permiso = [5, 13];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    saveComprobante: function saveComprobante() {
      var _this = this;

      var preg = "";

      this.Ask(preg + "¿Desea continuar?", function () {
        _this.cargando = true;
        _this.loadButton(_this.$refs.btnSave);
        var formData = new FormData();
        formData.append("ente_publico_id", _this.ente_publico_id);
        formData.append("xlsx", _this.xlsx);

        _this.$http.post("ExcelBajas", formData).then(function (response) {
          _this.incorrectos = response.data.incorrectos;
          _this.correctos = response.data.correctos;
          _this.cargando = false;
        }, function (error) {
          _this.cargando = false;
          _this.Err(error);
        });
      });
    },
    addFile: function addFile(tipo) {
      this.xlsx = this.$refs.xlsx.files[0];
    },
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.datosPersonales.model, this.$refs.firstStep.model, this.$refs.DatosCurriculares.model, this.$refs.DatosConyuge.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()("Good job!", "You clicked the finish button!", "success");
    }
  },
  created: function created() {
    var _this2 = this;

    this.checkPermissions();
    this.rol = this.getKey("grupo");

    this.$http.get("cat_ente_publico").then(function (response) {
      _this2.entes = response.data.entes_publicos;
    }, function (error) {
      _this2.Err(error);
    });

    this.cargando = false;
  }
});

/***/ }),

/***/ "7gjw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartist_plugin_tooltips__ = __webpack_require__("pZqB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartist_plugin_tooltips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_chartist_plugin_tooltips__);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      $Chartist: null,
      obligados: '',
      min: 0,
      max: 0,
      faltantes: '',
      porcentaje: 0,
      declaraciones: '',
      plugins: null,
      hasfiscal: false,
      dependencias_: []
    };
  },

  methods: {
    tipoD: function tipoD(tipo) {
      switch (tipo) {
        case 1:
          return 'Inicial';
        case 2:
          return 'Anual';
        case 3:
          return 'Final';
      }
    },
    getDep: function getDep(id) {
      var dep = this.dependencias_.find(function (m) {
        return m.id == id;
      });
      if (dep) {
        return dep.valor;
      }
      return '';
    },
    irLlenado: function irLlenado() {
      this.$router.push('/forms/infPersonal');
    },
    fiscal: function fiscal() {
      this.$router.push('fiscal');
    },
    aclaraciones: function aclaraciones() {
      this.$router.push('/forms/aclaraciones');
    },
    irHistorico: function irHistorico() {
      this.$router.push('/forms/historico');
    }
  },
  created: function created() {
    var _this = this;

    if (!this.getKey('status_dec') == 1) {
      localStorage.setItem('std', 0);
    }

    this.$http.get("hasfiscal/" + this.getKey('uid')).then(function (response) {
      if (response.data.files) {
        _this.hasfiscal = true;
      }
    }, function (error) {
      _this.Err(error);
    });

    this.$http.get("cat/dec").then(function (response) {
      _this.dependencias_ = response.data.entes_publicos;
    }, function (error) {
      _this.Err(error);
    });
  }
});

/***/ }),

/***/ "7kBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("s/F+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("yrbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "c83R"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "899R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_CurrencyNumber_vue__ = __webpack_require__("ySqg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf98b0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_CurrencyNumber_vue__ = __webpack_require__("O+mI");
function injectStyle (ssrContext) {
  __webpack_require__("JTc9")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_CurrencyNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf98b0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_CurrencyNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8b7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");












__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  props: ["data"],
  data: function data() {
    return {
      id: 1,
      add_item: false,
      edit_item: null,
      tipos: null,

      perPage: 10,
      rows: null,
      currentPage: 1,
      filter: null,
      dependencias: null,
      item_usuarios: {
        id: 0
      },
      list_usuarios: [],
      item_usuariosValidations: {
        Nombre: {
          required: true
        },
        Paterno: {
          required: true
        },
        User: {
          required: true
        },
        Password: {
          required: true
        },
        tipo_id: {
          required: true
        },
        ID_Dependencia: {
          required: true
        },
        Confirmar: {}
      },

      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Nombre completo',
        value: 'Nombre',
        align: 'center'
      }, {
        text: 'Usuario',
        value: 'User',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'ID_Dependencia',
        align: 'center'
      }, {
        text: 'Tipo',
        value: 'tipo_id',
        align: 'center'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["c" /* mapFields */])(["Nombre", "Paterno", "User", "Password", "tipo_id", "ID_Dependencia", "Confirmar"]), {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_usuarios.length;
      return this.list_usuarios.length;
    }
  }),
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      var permiso = [8];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    initItem: function initItem() {
      this.item_usuarios = {
        acciones: "",
        Nombre: "",
        Paterno: "",
        User: "",
        Password: "",
        Confirmar: "",
        modificar: "0",
        id: 0
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
      if (this.add_item) {
        this.$validator.resume();
      } else {
        this.$validator.pause();
      }
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.item_usuarios) {
            _this.loadButton(_this.$refs.btnSave);

            _this.$http.post("usuarios", _this.item_usuarios).then(function (response) {
              if (response.data.usuario) {
                _this.StepOk("Guardado");

                if (_this.edit_item === undefined || _this.edit_item === null) {
                  _this.list_usuarios.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.usuario));
                } else {
                  var index = _this.list_usuarios.map(function (u) {
                    return u.id;
                  }).indexOf(response.data.usuario.id);
                  _this.list_usuarios.splice(index, 1, response.data.usuario);

                  _this.edit_item._rowVariant = "";
                }
                _this.initItem();
                _this.showItem();
                _this.edit_item = null;
              } else {
                _this.StepW("El correo ya se encuentra dado de alta");
              }
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;

      this.item_usuarios = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.edit_item);
      this.edit_item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("usuarios/" + item.id).then(function (response) {
            var index = _this2.list_usuarios.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.list_usuarios.splice(index, 1);
            _this2.StepOk('Usuario Eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getTipoUsuarios: function getTipoUsuarios(index) {
      var resp = " ";
      if (this.tipos) {
        this.tipos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    buscaPers: function buscaPers(value, search, item) {
      if (typeof value === 'string') {
        var nombre = ((item.Nombre || '') + ' ' + (item.Paterno || '') + ' ' + (item.Materno || '')).toLowerCase();
        var user = (item.User || '').toLowerCase();
        return nombre.indexOf(search) !== -1 || user.indexOf(search) !== -1;
      }
      return false;
    }
  },
  created: function created() {
    var _this3 = this;

    this.checkPermissions();
    this.initItem();
    this.$http.get("usuarios").then(function (response) {

      _this3.list_usuarios = response.data.usuarios;
    }, function (error) {
      _this3.Err(error);
    });
    this.$http.get("getTipoUsuarios").then(function (response) {
      _this3.tipos = response.data.tipos;
    }, function (error) {
      _this3.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this3.dependencias = response.data.entes_publicos;
    }, function (error) {
      _this3.Err(error);
    });
  }
});

/***/ }),

/***/ "8hMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BitacoraB_vue__ = __webpack_require__("ywIa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_59585d68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BitacoraB_vue__ = __webpack_require__("G1un");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BitacoraB_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_59585d68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BitacoraB_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8kY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("r5gK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__ = __webpack_require__("yPee");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_locale_es__ = __webpack_require__("LO7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_es5_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors__ = __webpack_require__("WCe5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors__);







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    primary: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.purple,
    secondary: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.grey.darken1,
    accent: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.shades.black,
    error: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.red.accent3
  },
  lang: {
    locales: {
      es: __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_locale_es___default.a
    },
    current: 'es'
  }
}));

/***/ }),

/***/ "8rWp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_HistoricoDeclaraciones_vue__ = __webpack_require__("Uz+4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e566e44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_HistoricoDeclaraciones_vue__ = __webpack_require__("cYKf");
function injectStyle (ssrContext) {
  __webpack_require__("ECXt")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_HistoricoDeclaraciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e566e44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_HistoricoDeclaraciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8rzW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8zQz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "90m7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("HkQL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("zHPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__("M0zo");




var mix = {
  data: function data() {
    return {
      ip_id: "",
      modalComponent: "",
      modalTitle: "",
      modalData: "",
      modalSize: "",
      modalScroll: false,
      modalFooterComp: "",
      tableButtons: [],
      excelTitle: ""
    };
  },

  stored: {
    checkedlog: {
      type: JSON,
      key: function key() {
        return "log";
      },
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    checkedlog: function checkedlog() {
      if (this.$router) {
        for (var j = 0; j < this.$router.options.routes.length; ++j) {
          var ruta = this.$router.options.routes[j];
          if (ruta.path = "/busqueda") {
            return "";
          }
        }
        this.$router.push("/login");
      }
    }
  },

  methods: {
    OK: function OK(msg) {
      this.$swal({
        title: "OK",
        html: msg,
        type: "success"
      });
    },
    StepOk: function StepOk(msg) {
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        type: "success",
        title: msg
      });
    },
    StepInfo: function StepInfo(msg) {
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        type: "info",
        title: msg
      });
    },
    StepError: function StepError(error) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.onReady();
      this.$Progress.fail();
      var e = new Array();
      if (error.status && error.status == 401) {
        this.$router.push("/login");
        return;
      } else if (error.data && error.data.errors) {
        for (var x in error.data.errors) {
          e.push(error.data.errors[x]);
        }
      } else if (error.data && error.data.message) {
        e.push(error.data.message);
      } else {
        e.push(error);
      }
      var close = true;
      if (time > 0) {
        close = false;
      }
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        type: "error",
        title: "Error",
        showCloseButton: close,
        timer: time,
        html: e.join("<br>")
      });
    },
    StepW: function StepW(error) {
      this.onReady();
      this.$Progress.fail();
      var e = new Array();
      if (error.status && error.status == 401) {
        this.$router.push("/login");
        return;
      } else if (error.data && error.data.errors) {
        for (var x in error.data.errors) {
          e.push(error.data.errors[x]);
        }
      } else if (error.data && error.data.message) {
        e.push(error.data.message);
      } else {
        e.push(error);
      }
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        type: "warning",
        title: "Verifica",
        showCloseButton: close,
        timer: 5000,
        html: e.join("<br>")
      });
      if (this.$el.querySelector("[aria-invalid=true]")) {
        this.$el.querySelector("[aria-invalid=true]").scrollIntoView({
          block: "center",
          behavior: "smooth"
        });
      }
    },
    getToken: function getToken() {
      var token = localStorage.getItem("app-token-declaranet");
      return token ? token : null;
    },
    hasToken: function hasToken() {
      return !!localStorage.getItem("app-token-declaranet");
    },
    Err: function Err(error) {
      this.onReady();
      this.$Progress.fail();
      var e = new Array();
      if (error.status && error.status == 401) {
        this.$router.push("/login");
        return;
      } else if (error.data && error.data.errors) {
        for (var x in error.data.errors) {
          e.push(error.data.errors[x]);
        }
      } else if (error.data && error.data.message) {
        e.push(error.data.message);
      } else {
        e.push(error);
      }
      this.$swal({
        title: "Error",
        html: e.join("<br>"),
        type: "error"
      });
    },
    Ask: function Ask(msg, fn) {
      this.$swal({
        title: "Confirme",
        html: msg,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar"
      }).then(function (result) {
        if (result.value) {
          fn();
        }
      });
    },
    AskMessage: function AskMessage(title, msg) {
      var okbtn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'OK';
      var fn = arguments[3];

      this.$swal({
        title: title,
        width: 650,
        html: '<div class="text-left pt-3">' + msg + '</div>',

        input: 'textarea',
        inputLabel: 'Observaciones',
        inputPlaceholder: 'Escribe tus observaciones aquí...',
        inputAttributes: {
          'aria-label': 'Escribe tus observaciones aquí'
        },
        inputValidator: function inputValidator(value) {
          if (!value) {
            return 'Debe escribir una observación';
          }
        },
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: okbtn,
        cancelButtonText: "Cancelar"
      }).then(function (result) {
        if (result.value) {
          fn(result.value);
        }
      });
    },
    Ask2: function Ask2(msg, fn, fn2) {
      this.$swal({
        title: "Confirme",
        html: msg,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#F4B468",
        confirmButtonText: "Filtrar",
        cancelButtonText: "Trae Todo"
      }).then(function (result) {
        if (result.value) {
          fn();
        } else {
          fn2();
        }
      });
    },
    Modal: function Modal(selector) {
      var _this = this;

      $(selector ? selector : ".modal").modal("show").on("hidden.bs.modal", function () {
        _this.modalComponent = "";
        _this.modalFooterComp = "";
      });
    },
    getId: function getId() {
      var ip_id = this.getKey("uid");
      if (ip_id) {
        return ip_id;
      }
      return false;
    },
    getKey: function getKey(campo) {
      var rawToken = localStorage.getItem("app-token-declaranet");
      if (!rawToken) return null;
      var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__["a" /* default */])(rawToken);
      return token[campo];
    },
    setSession: function setSession(declarante) {
      localStorage.setItem("app-token-declaranet", declarante.token);
    },
    makeDataTable: function makeDataTable(selector) {
      $(selector).DataTable({
        retrieve: true,
        dom: "Bfrtip",
        ordering: false,

        buttons: this.tableButtons,
        oClasses: {
          sFilterInput: "form-control",
          sLengthSelect: "form-control"
        },
        pageLength: 50,
        autoWidth: false,

        language: {
          sProcessing: "Procesando...",
          sLengthMenu: "Mostrar _MENU_ registros",
          sZeroRecords: "No se encontraron resultados",
          sEmptyTable: "Ningún registro encontrado",
          sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty: "0 registros",
          sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
          sInfoPostFix: "",
          sSearch: "Filtrar:",
          sUrl: "",
          sInfoThousands: ",",
          sLoadingRecords: "Cargando...",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior"
          },
          oAria: {
            sSortAscending: ": Activar para ordenar la columna de manera ascendente",
            sSortDescending: ": Activar para ordenar la columna de manera descendente"
          }
        }
      });
    },
    makeDataInfo: function makeDataInfo(selector) {
      $(selector).DataTable({
        retrieve: true,
        dom: "Bfrtip",

        buttons: [{
          text: '<i class="fa fa-lg fa-file-excel-o"></i>',
          extend: "excel",
          className: "btn btn-success float-right shadow-sm ml-3 mr-3 mb-2 excel-button",
          title: this.excelTitle
        }],
        paging: false,
        autoWidth: false,
        ordering: false,
        info: false,
        searching: false
      });
    },
    getFormData: function getFormData(obj) {
      var formData = new FormData();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
        if (Array.isArray(obj[key])) {
          obj[key].forEach(function (item, i) {
            if (item instanceof File) {
              formData.append(key + "[" + i + "]", item);
            } else {
              formData.append(key + "[" + i + "]", item);
            }
          });
        } else {
          formData.append(key, obj[key]);
        }
      });
      return formData;
    },
    loadButton: function loadButton(obj) {
      var icon = $(obj).find("i").attr("class");
      $(obj).html('<i class = "fa fa-spinner fa-spin" action = "' + icon + '"></i> ' + $(obj).text());
      $(obj).attr("disabled", "disabled");
      $(obj).addClass("disabled");
    },
    onReady: function onReady() {
      var icon = $(".fa-spin").attr("action");
      $(".fa-spin").parents("button").removeAttr("disabled").removeClass("disabled");
      $(".fa-spin").parents("a").removeAttr("disabled").removeClass("disabled");
      if (icon) $(".fa-spin").parent().html('<i class = "' + icon + '"></i> ' + $(".fa-spin").parent().text());
      $(".fa-spin").remove();
    },
    compareArrays: function compareArrays(o, n) {
      var temp = [];
      var dif = [];

      var oldkeys = $.map(o, function (value, key) {
        return "" + value;
      });
      var newkeys = $.map(n, function (value, key) {
        return "" + value;
      });

      for (var i = 0; i < oldkeys.length; i++) {
        if (!newkeys.includes(oldkeys[i])) {
          temp.push(oldkeys[i]);
        }
      }
      for (var i = 0; i < newkeys.length; i++) {
        if (!oldkeys.includes(newkeys[i])) {
          dif.push(newkeys[i]);
        }
      }

      console.log(temp);
      console.log(dif);

      if (temp.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    jsonEqual: function jsonEqual(o, n) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(o, this.replacer) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(n, this.replacer);
    },
    replacer: function replacer(key, value) {
      if (typeof value === "number") {
        return value.toString();
      }
      if (typeof value === "boolean") {
        return value ? "1" : "0";
      }
      return value;
    },
    curpValida: function curpValida(curp) {
      var re = /^[A-Z][A,E,I,O,U,X][A-Z]{2}[0-9]{2}[0-1][0-9][0-3][0-9][M,H][A-Z]{2}[B,C,D,F,G,H,J,K,L,M,N,Ñ,P,Q,R,S,T,V,W,X,Y,Z]{3}[0-9,A-Z][0-9]$/,
          validado = curp.match(re);

      if (!validado) {
        return false;
      }


      return true;
    },
    rfcValido: function rfcValido(rfc) {
      var aceptarGenerico = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var re = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]?[A-Z,0-9]?[0-9,A-Z]?$/;

      var validado = rfc.match(re);

      if (!validado) {
        return false;
      }


      return true;
    },
    checkPermisos: function checkPermisos(v) {
      var p = this.getKey('permisos');

      if (!p.includes(v)) {
        this.$router.push('/admin/tablero');
      }
    },
    group1k: function group1k(s) {
      var s1 = s.toString();
      if (s1.length > 3) {
        if (s1.length == 6) {
          s1 = s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('');
          return s1.substring(1, s1.length);
        } else {
          return s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('');
        }
      } else return s1;
    }
  }

};

/***/ }),

/***/ "99u0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RecuperaPass_vue__ = __webpack_require__("rtTw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e82356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RecuperaPass_vue__ = __webpack_require__("k17A");
function injectStyle (ssrContext) {
  __webpack_require__("vLLw")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RecuperaPass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e82356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RecuperaPass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9DQD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "khTA"));
__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "8upu"));
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9NCP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar-default"},[_c('div',{staticClass:"row mr-3 ml-3 pt-3 mb-3 barra"},[_c('div',{staticClass:"navbar-minimize col-1"},[_c('button',{staticClass:"btn btn-fill btn-icon",on:{"click":_vm.minimizeSidebar}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'})])]),_vm._v(" "),_c('div',{staticClass:"navbar-header col-3"},[_c('a',{staticClass:"navbar-brand"},[_vm._v(_vm._s(this.$route.name))])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"nombre"},[_c('h5',[_vm._v(_vm._s(this.nombre))])]),_vm._v(" "),_c('div',{staticClass:"nombre"},[_c('p',{staticClass:"text-muted ente"},[_vm._v(_vm._s(this.ente))])]),_vm._v(" "),_c('div',{staticClass:"notificaciones"},[_c('v-badge',{attrs:{"color":(this.lngth>0) ? 'red' : 'white',"content":this.lngth}},[_c('v-icon',{attrs:{"color":"white","large":"","small":""},on:{"click":function($event){_vm.menu=!_vm.menu}}},[_vm._v("\n            ti-bell\n          ")])],1),_vm._v(" "),_c('ul',{class:_vm.menu ? 'dropdown-menu show' : 'dropdown-menu'},[(this.lngth>0)?_c('v-list',{attrs:{"three-line":""}},[_vm._l((_vm.notificaciones),function(item,index){return [_c('v-list-item',{key:item.title,on:{"click":function($event){}}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"innerHTML":_vm._s(item.texto)}}),_vm._v(" "),(item.id_tipo!=1)?_c('v-list-item-subtitle',{domProps:{"innerHTML":_vm._s(item.movimiento.servidor.rfc)}}):_vm._e()],1)],1)]}),_vm._v(" "),_c('a',{staticClass:"dnotif",on:{"click":function($event){return _vm.irNot()}}},[_vm._v("Ver más")])],2):[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-subtitle',[_vm._v("Sin Notificaciones")])],1)],1)]],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-2 position-relative"},[_c('v-btn',{staticClass:"ml-2 mr-2",attrs:{"text":"","color":"white","small":""},on:{"click":function($event){$event.preventDefault();return _vm.cerrarSesion.apply(null, arguments)}}},[_vm._v("\n        Cerrar Sesión\n      ")]),_vm._v(" "),(_vm.$rootUrl == '//localhost:8000' || _vm.$rootUrl == '/declaranet/')?_c('div',{staticClass:"ribbon ribbon-top-right"}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9NlO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",staticClass:"menu-li",class:{active: _vm.isActive},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name)+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav mt-2 ml-2"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",function(){return [(_vm.link.target)?_c('a',{attrs:{"target":"_blank","href":_vm.link.path}},[(_vm.link.target)?_c('a',{staticClass:"guia",staticStyle:{"line-height":"30px"},attrs:{"target":"_blank","href":_vm.$rootUrl + '/Guia.pdf'}},[_c('span',{staticClass:"themifyIcon"},[_c('i',{class:_vm.link.icon})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]):_vm._e()]):_c(_vm.elementType(_vm.link, false),{tag:"component",attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini "},[_c('i',{class:_vm.link.icon})]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.link.name))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]],2)]}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9SJ6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9aQq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Rating_component_vue__ = __webpack_require__("1FAm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_742743be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Rating_component_vue__ = __webpack_require__("lcZF");
function injectStyle (ssrContext) {
  __webpack_require__("RunB")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Rating_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_742743be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Rating_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9bmF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Domicilio_vue__ = __webpack_require__("Ta4m");



















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a),
  props: ["data"],
  data: function data() {
    return {
      options: [{
        id: 1,
        label: "foo"
      }, {
        id: 3,
        label: "bar"
      }, {
        id: 2,
        label: "baz"
      }],
      filter: null,

      currentPage: 1,
      perPage: 50,
      rol: "",
      rows: null,
      id: 1,
      add_item: false,
      edit_item: null,
      tipos: null,
      n_domicilio: null,
      dependencias: null,
      item_usuarios: {},
      list_usuarios: [],
      item_usuariosValidations: {
        rfc: {
          required: true
        },
        nombres: {
          required: true
        },
        primer_apellido: {
          required: true
        },
        segundo_apellido: {
          required: true
        },
        ente_publico_id: {
          required: true
        },
        direccion_cargo: {
          required: true
        },
        nivel: {
          required: true
        },
        area_adscripcion: {
          required: true
        },
        honorarios: {
          required: true
        },
        AG172: {
          required: true
        },
        fecha_inicio: {
          required: true
        },
        tipo_baja: {
          required: true
        },
        termina: {
          required: true
        },
        inicia: {
          required: true
        },
        tipo_lic: {
          required: true
        },
        observaciones: {
          required: true
        },
        empleo_cargo_comision: {
          required: true
        }
      },
      headers: [{
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Área',
        value: 'area',
        align: 'center'
      }, {
        text: 'Tipo de Licencia',
        value: 'tipo_licencia',
        align: 'center'
      }, {
        text: 'Motivo',
        value: 'motivo',
        align: 'center'
      }, {
        text: 'Inicio',
        value: 'inicia',
        align: 'center'
      },, {
        text: 'Termino',
        value: 'termina',
        align: 'center'
      }],
      fields_list: [{
        key: "usuarios.rfc",
        label: "RFC",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: "emptyFields"
      }, {
        key: "usuarios.nombres usuarios.primer_apellido usuarios.segundo_apellido",
        label: "Nombre",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "encargo.area_adscripcion",
        label: "Área",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "tipo_licencia",
        label: "Tipo de Licencia",
        thClass: "td-medium",
        tdClass: "text-left td-medium",
        formatter: "empty-fields"
      }, {
        key: "motivo",
        label: "Motivo ",
        tdClass: "text-left",
        formatter: "empty-fields"
      }, {
        key: "inicia",
        label: "Inicio",
        thClass: "td-small",
        tdClass: "text-center td-small",
        formatter: function formatter(value) {
          if (value) return __WEBPACK_IMPORTED_MODULE_10_moment___default()(String(value)).format('DD/MM/YYYY');else return '';
        }
      }, {
        key: "termina",
        label: "Fin",
        thClass: "td-small",
        tdClass: "text-center td-small",
        formatter: function formatter(value) {
          if (value) return __WEBPACK_IMPORTED_MODULE_10_moment___default()(String(value)).format('DD/MM/YYYY');else return '';
        }
      }],
      selects: {
        simple: "",
        movimientos: [{
          value: "1",
          label: "Desactivar servidor"
        }, {
          value: "2",
          label: "Crear baja "
        }, {
          value: "3",
          label: "Crear licencia"
        }, {
          value: "4",
          label: "Crear promoción"
        }, {
          value: "5",
          label: "Realizar corrección"
        }, {
          value: "6",
          label: "Cambiar contraseña"
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vee_validate__["c" /* mapFields */])(["rfc", "nombres", "primer_apellido", "segundo_apellido", "ente_publico_id", "direccion_cargo", "nivel", "area_adscripcion", "honorarios", "AG172", "Password", "Confirmar", "fecha_inicio", "tipo_baja", "termina", "inicia", "tipo_lic", "observaciones", "empleo_cargo_comision"]), {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_usuarios.length;

      return this.list_usuarios.length;
    },

    fullName: {
      get: function get() {
        return this.item_usuarios.nombres + " " + this.item_usuarios.primer_apellido + " " + this.item_usuarios.segundo_apellido;
      },
      set: function set(newValue) {
        var m = newValue.match(/(\S*)\s+(.*)/);

        this.nombres = m[1];
        this.primer_apellido = m[2];
        this.segundo_apellido = m[3];
      }
    }
  }),
  methods: {
    initItem: function initItem() {
      this.item_usuarios = {
        acciones: "",
        nombres: "",
        Paterno: "",
        Materno: "",
        User: "",
        Password: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.item_usuarios) {
            _this.loadButton(_this.$refs.btnSave);
            _this.$http.post("usuarios", _this.item_usuarios).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.list_usuarios.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.usuario));
              } else {
                _this.list_usuarios.splice(_this.edit_item.index, 1, _this.item_usuarios);
                _this.edit_item.item._rowVariant = "";
              }
              _this.initItem();
              _this.showItem();
              _this.edit_item = null;
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_usuarios = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_usuarios[this.edit_item.index]);
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_usuarios[indice].id !== null) {
        var item = this.list_usuarios[indice];
        this.list_usuarios.splice(indice, 1);
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("usuarios/" + item.id).then(function (response) {
            _this2.list_usuarios.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    }
  },
  created: function created() {
    var _this3 = this;

    this.initItem();
    this.rol = this.getKey("role");
    if (this.rol == 4) {
      this.filtro = this.getKey("ente_publico_id");
    }

    this.$http.get("servidores").then(function (response) {
      _this3.list_usuarios = response.data.usuarios;
    }, function (error) {
      _this3.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this3.dependencias = response.data.entes_publicos;
    }, function (error) {
      _this3.Err(error);
    });
  }
});

/***/ }),

/***/ "9lTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_servidores,"items-per-page":5,"search":_vm.filter,"fixed-header":true,"custom-filter":_vm.buscaServ},scopedSlots:_vm._u([{key:"item.nombres",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getNombre(item)))])]}},{key:"item.ente_publico_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getDependencias(item.ente_publico_id)))])]}},{key:"item.fecha",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat(item.declaracion.Fecha_Dec)))])]}},{key:"item.tipo",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.declaracion.Tipo_Dec))])]}}])})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Reporte Conflicto de Interés ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A/Ac":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ARNM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard2_vue__ = __webpack_require__("5wbZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b3c314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard2_vue__ = __webpack_require__("Dz4c");
function injectStyle (ssrContext) {
  __webpack_require__("52yL")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56b3c314"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b3c314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "At0/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Licencias_vue__ = __webpack_require__("9bmF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd85e16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Licencias_vue__ = __webpack_require__("CiiL");
function injectStyle (ssrContext) {
  __webpack_require__("JK9A")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Licencias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd85e16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Licencias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B27g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Domicilio_vue__ = __webpack_require__("Ta4m");








var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'inject', ['$validator']), _components),

  data: function data() {
    return {
      DatePicker: '',
      muestraCampos: false,
      ip_id: null,
      estudios_sn: '2',
      list_escolaridad: [],
      edit_item: null,
      add_item: false,
      model: {
        lugar_institucion_ext: '1'

      },
      opciones: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      },
      gradoesc: [],
      documentos: {},
      estatusC: {},
      periodosC: {},
      form_item: {},
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Grado Escolaridad',
        value: 'grado_maximo_escolaridad_id',
        align: 'center'
      }, {
        text: 'Institución Educativa',
        value: 'institucion_educativa',
        align: 'center'
      }, {
        text: 'Carrera',
        value: 'carrera',
        align: 'center'
      }, {
        text: 'Cédula Profesional',
        value: 'cedula_profesional',
        align: 'center'
      }],
      info: {
        grado_maximo_escolaridad_id: 'Este apartado solo lo llenaran las personas servidoras públicas que tengan participación en un fideicomiso, ya sea en el carácter de fideicomitente, fiduciario, fideicomisario o dentro del consejo técnico. Deberá reportar hasta los últimos dos años.',
        institucion_educativa: 'Elegir quien es el participante en el fideicomiso, el Declarante, Pareja o dependiente económico.',
        carrera: 'Seleccionar si es público, privado o mixto.',
        cedula_profesional: 'Seleccionar su participación como fideicomitente, fiduciario, fideicomisario o dentro del Comité Técnico.',
        rfc_fideicomiso: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomiso.',
        fideicomitente: 'Seleccionar si es persona física o persona moral.',
        nombre_fideicomitente: 'Proporcionar nombre completo.',
        rfc_fideicomitente: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomitente.',
        nombre_fiduciario: 'Proporcionar nombre completo.',
        rfc_fiduciario: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fiduciario.',
        fideicomisario: 'Seleccionar si es persona física o persona moral.',
        nombre_fideicomisario: 'Proporcionar nombre completo.',
        rfc_fideicomisario: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomisario.',
        sector: 'Elegir el sector al que pertenece.',
        lugar: 'Seleccionar en México o en el extranjero.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }

    };
  },
  mounted: function mounted() {
    this.model.lugar_institucion_ext = '1';
    this.ip_id = this.getId();
    this.gradosEsc();
    this.getDatosC();
    this.documentoObt();
    this.getEstatusCarr();
    this.periodosCursados();
    this.model.fecha_obtencion = '';
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    getDatosC: function getDatosC() {
      var _this = this;

      var v = this;
      this.$http.get('datosCurric/' + this.ip_id).then(function (response) {
        if (response.data.datosCurr.length > 0) {
          _this.list_escolaridad = response.data.datosCurr;
          _this.estudios_sn = '1';
        } else {
          _this.estudios_sn = '2';
        }
      }, function (error) {
        _this.StepError(error);
        console.log(error);
      });
    },
    documentoObt: function documentoObt() {
      var _this2 = this;

      this.$http.get('doctoObt').then(function (response) {
        _this2.documentos = response.data.documentoOb;
      }, function (error) {
        _this2.StepError(error);
        console.log(error);
      });
    },
    gradosEsc: function gradosEsc() {
      var _this3 = this;

      this.$http.get('gradoesc').then(function (response) {
        _this3.gradoesc = response.data.grado;
      }, function (error) {
        _this3.StepError(error);
        console.log(error);
      });
    },
    periodosCursados: function periodosCursados() {
      var _this4 = this;

      this.$http.get('periodosC').then(function (response) {
        _this4.periodosC = response.data.periodos;
      }, function (error) {
        _this4.StepError(error);
        console.log(error);
      });
    },
    getEstatusCarr: function getEstatusCarr() {
      var _this5 = this;

      this.$http.get('estatuscarr').then(function (response) {
        _this5.estatusC = response.data.estatusC;
      }, function (error) {
        _this5.StepError(error);
        console.log(error);
      });
    },
    cancelEdit: function cancelEdit() {

      this.limpiaCampos();
      this.showItem();
      this.edit_item = null;
    },
    editItem: function editItem(item) {
      this.showItem();
      this.model = item;

      var v = this;

      $(".main-panel").animate({
        scrollTop: 1300
      }, 500, "swing");
    },
    getGrado: function getGrado(index) {
      var resp = "";
      if (this.gradoesc) {
        this.gradoesc.forEach(function (item) {
          if (item.id == index) {
            resp = item.grado_escolaridad;
            return resp;
          }
        });
      }
      return resp;
    },
    addItem: function addItem() {
      var _this6 = this;

      console.log(1);
      console.log(this.$validator.validateAll());
      this.$validator.validateAll().then(function (response) {
        console.log(2);
        console.log(response);
        if (response) {
          _this6.loadButton(_this6.$refs.btnSave);
          _this6.$http.put('datosCurric/' + _this6.ip_id, _this6.model).then(function (response) {
            _this6.StepOk("Guardado");

            if (_this6.edit_item === undefined || _this6.edit_item === null) {
              _this6.list_escolaridad.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this6.model));
            } else {
              _this6.list_escolaridad.splice(_this6.edit_item.index, 1, _this6.model);
            }

            _this6.showItem();
            _this6.limpiaCampos();
            _this6.edit_item = null;
            _this6.getDatosC();
          }, function (error) {
            _this6.StepError(error);
          });
        } else {
          _this6.StepW("Hay campos sin completar");
        }
      });
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    removeItem: function removeItem(item) {
      var _this7 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this7.$http.delete("datosCurric/" + item.id).then(function (response) {
            var index = _this7.list_escolaridad.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this7.list_escolaridad.splice(index, 1);
            _this7.StepOk('Registro eliminado');
          }, function (error) {
            _this7.Err(error);
          });
        });
      }
    },
    limpiaCampos: function limpiaCampos() {
      this.model = {
        grado_maximo_escolaridad_id: '',
        grado_obtenido: '',
        institucion_educativa: '',
        lugar_institucion_ext: '1',
        lugar_institucion_educativa_entidad_id: '',
        carrera: '',
        periodos_cursados_id: '',
        estatus_id: '',
        cedula_profesional: '',
        fecha_obtencion: ''

      };
    }
  }
});

/***/ }),

/***/ "B8af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Movimientos_vue__ = __webpack_require__("dY1p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9f9968_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Movimientos_vue__ = __webpack_require__("nV12");
function injectStyle (ssrContext) {
  __webpack_require__("CIgy")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Movimientos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9f9968_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Movimientos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BFX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mixCat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("uaGE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




var mixCat = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(["entidades", "paises", "tipos_instituciones", "tipos_apoyos", "nivel_gobierno", "sectores_industria", "tipos_representacion", "tipos_beneficios", "monedas", "tipos_fideicomisos", "tipos_fideicomisos_part", "tipos_participaciones", "beneficiarios", "tipos_inmuebles", "tipos_vehiculos", "titular_adeudo", "tipos_adeudos", "adquisiciones", "relaciones", "pagos", "valores_inmueble", "bajas_inmueble", "transmisores", "tipos_mueble", "inversiones", "inv_bancarias", "inv_fondos", "inv_organizaciones", "inv_monedas", "inv_seguros", "inv_valores", "inv_afores"])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["getEntidades", "getPaises", "getTipoInstitucion", "getTipoApoyos", "getNivelGobierno", "getSectoresIndustria", "getTipoRepresentacion", "getTipoBeneficio", "getMonedas", "getTipoFideicomiso", "getTipoFideicomisoPart", "getTipoParticipaciones", "getBeneficiario", "getTipoVehiculo", "getTipoInmueble", "getTitularAdeudo", "getTipoAdeudo", "getAdquisiciones", "getRelaciones", "getPagos", "getValorInmueble", "getBajaInmueble", "getTransmisor", "getMueble", "getInversiones", "getInvBancaria", "getInvFondos", "getInvOrganizaciones", "getInvMoneda", "getInvSeguros", "getInvValores", "getInvAfores"]), {
    getEntidadesCatalog: function getEntidadesCatalog() {
      var _this = this;

      this.$http.get("entidadFed").then(function (response) {
        _this.getEntidades(response.data.entidadfed);
      }, function (error) {
        _this.Err(error);
      });
    },
    getPaisesCatalog: function getPaisesCatalog() {
      var _this2 = this;

      this.$http.get("paises").then(function (response) {
        _this2.getPaises(response.data.pais);
      }, function (error) {
        _this2.Err(error);
      });
    },
    getTipoInsCatalog: function getTipoInsCatalog() {
      var _this3 = this;

      this.$http.get("cat_tipo_institucion").then(function (response) {
        _this3.getTipoInstitucion(response.data.institucion);
      }, function (error) {
        _this3.Err(error);
      });
    },
    getTipoApoyoCatalog: function getTipoApoyoCatalog() {
      var _this4 = this;

      this.$http.get("cat_tipo_apoyo").then(function (response) {
        _this4.getTipoApoyos(response.data.response);
      }, function (error) {
        _this4.Err(error);
      });
    },
    getNivelGobiernoCatalog: function getNivelGobiernoCatalog() {
      var _this5 = this;

      this.$http.get("nivelGobierno").then(function (response) {
        _this5.getNivelGobierno(response.data.nivelGobierno);
      }, function (error) {
        _this5.Err(error);
      });
    },
    getSectoresCatalog: function getSectoresCatalog() {
      var _this6 = this;

      this.$http.get("cat_sector_industria").then(function (response) {
        _this6.getSectoresIndustria(response.data.sectores);
      }, function (error) {
        _this6.Err(error);
      });
    },
    getTipoRepCatalog: function getTipoRepCatalog() {
      var _this7 = this;

      this.$http.get("cat_tipo_representacion").then(function (response) {
        _this7.getTipoRepresentacion(response.data.tipos);
      }, function (error) {
        _this7.Err(error);
      });
    },
    getTipoBeneficiosCatalog: function getTipoBeneficiosCatalog() {
      var _this8 = this;

      this.$http.get("cat_tipo_beneficio").then(function (response) {
        _this8.getTipoBeneficio(response.data.response);
      }, function (error) {
        _this8.Err(error);
      });
    },
    getMonedasCatalog: function getMonedasCatalog() {
      var _this9 = this;

      this.$http.get("monedas").then(function (response) {
        _this9.getMonedas(response.data.monedas);
      }, function (error) {
        _this9.Err(error);
      });
    },
    getTipoFideicomisoCatalog: function getTipoFideicomisoCatalog() {
      var _this10 = this;

      this.$http.get("cat_tipo_fideicomiso").then(function (response) {
        _this10.getTipoFideicomiso(response.data.tipos);
      }, function (error) {
        _this10.Err(error);
      });
    },
    getTipoFideicomisoPartCatalog: function getTipoFideicomisoPartCatalog() {
      var _this11 = this;

      this.$http.get("cat_tipo_fideicomiso_part").then(function (response) {
        _this11.getTipoFideicomisoPart(response.data.tipos);
      }, function (error) {
        _this11.Err(error);
      });
    },
    getTipoParticipacionesCatalog: function getTipoParticipacionesCatalog() {
      var _this12 = this;

      this.$http.get("tipoparticipacion").then(function (response) {
        _this12.getTipoParticipaciones(response.data.tiposp);
      }, function (error) {
        _this12.Err(error);
      });
    },
    getBeneficiarioCatalog: function getBeneficiarioCatalog() {
      var _this13 = this;

      this.$http.get("cat_beneficiario").then(function (response) {
        _this13.getBeneficiario(response.data.response);
      }, function (error) {
        _this13.Err(error);
      });
    },
    getTipoVehiculoCatalog: function getTipoVehiculoCatalog() {
      var _this14 = this;

      this.$http.get("cat_tipo_bien_mueble").then(function (response) {
        _this14.getTipoVehiculo(response.data.tipos);
      }, function (error) {
        _this14.Err(error);
      });
    },
    getTipoInmuebleCatalog: function getTipoInmuebleCatalog() {
      var _this15 = this;

      this.$http.get("cat_tipo_bien").then(function (response) {
        _this15.getTipoInmueble(response.data.tipos);
      }, function (error) {
        _this15.Err(error);
      });
    },
    getTitularAdeudoCatalog: function getTitularAdeudoCatalog() {
      var _this16 = this;

      this.$http.get("cat_titular_adeudo").then(function (response) {
        _this16.getTitularAdeudo(response.data.response);
      }, function (error) {
        _this16.Err(error);
      });
    },
    getTipoAdeudoCatalog: function getTipoAdeudoCatalog() {
      var _this17 = this;

      this.$http.get("cat_tipo_adeudo").then(function (response) {
        _this17.getTipoAdeudo(response.data.tipos);
      }, function (error) {
        _this17.Err(error);
      });
    },
    getAdquisicionesCatalog: function getAdquisicionesCatalog() {
      var _this18 = this;

      this.$http.get("cat_forma_adquisicion").then(function (response) {
        _this18.getAdquisiciones(response.data.response);
      }, function (error) {
        _this18.Err(error);
      });
    },
    getRelacionesCatalog: function getRelacionesCatalog() {
      var _this19 = this;

      this.$http.get("cat_relacion_persona_adquirio").then(function (response) {
        _this19.getRelaciones(response.data.relaciones);
      }, function (error) {
        _this19.Err(error);
      });
    },
    getPagosCatalog: function getPagosCatalog() {
      var _this20 = this;

      this.$http.get("cat_forma_pago").then(function (response) {
        _this20.getPagos(response.data.pagos);
      }, function (error) {
        _this20.Err(error);
      });
    },
    getValorInmuebleCatalog: function getValorInmuebleCatalog() {
      var _this21 = this;

      this.$http.get("cat_valor_inmueble").then(function (response) {
        _this21.getValorInmueble(response.data.response);
      }, function (error) {
        _this21.Err(error);
      });
    },
    getBajaInmuebleCatalog: function getBajaInmuebleCatalog() {
      var _this22 = this;

      this.$http.get("cat_baja_inmueble").then(function (response) {
        _this22.getBajaInmueble(response.data.response);
      }, function (error) {
        _this22.Err(error);
      });
    },
    getTransmisoresCatalog: function getTransmisoresCatalog() {
      var _this23 = this;

      this.$http.get("cat_relacion_transmisor").then(function (response) {
        _this23.getTransmisor(response.data.response);
      }, function (error) {
        _this23.Err(error);
      });
    },
    getMueblesCatalog: function getMueblesCatalog() {
      var _this24 = this;

      this.$http.get("cat_tipo_bien_mueble_nr").then(function (response) {
        _this24.getMueble(response.data.tipos);
      }, function (error) {
        _this24.Err(error);
      });
    },
    getInversionesCatalog: function getInversionesCatalog() {
      var _this25 = this;

      this.$http.get("cat_tipo_inversion").then(function (response) {
        _this25.getInversiones(response.data.tipos);
      }, function (error) {
        _this25.Err(error);
      });
    },
    getInvBancariaCatalog: function getInvBancariaCatalog() {
      var _this26 = this;

      this.$http.get("cat_bancaria").then(function (response) {
        _this26.getInvBancaria(response.data.bancarias);
      }, function (error) {
        _this26.Err(error);
      });
    },
    getInvFondosCatalog: function getInvFondosCatalog() {
      var _this27 = this;

      this.$http.get("cat_fondo_inversion").then(function (response) {
        _this27.getInvFondos(response.data.fondos);
      }, function (error) {
        _this27.Err(error);
      });
    },
    getInvOrgCatalog: function getInvOrgCatalog() {
      var _this28 = this;

      this.$http.get("cat_organizacionespym").then(function (response) {
        _this28.getInvOrganizaciones(response.data.organizaciones);
      }, function (error) {
        _this28.Err(error);
      });
    },
    getInvMonedaCatalog: function getInvMonedaCatalog() {
      var _this29 = this;

      this.$http.get("cat_tipo_moneda_metales").then(function (response) {
        _this29.getInvMoneda(response.data.metales);
      }, function (error) {
        _this29.Err(error);
      });
    },
    getInvSegurosCatalog: function getInvSegurosCatalog() {
      var _this30 = this;

      this.$http.get("cat_seguros").then(function (response) {
        _this30.getInvSeguros(response.data.seguros);
      }, function (error) {
        _this30.Err(error);
      });
    },
    getInvValoresCatalog: function getInvValoresCatalog() {
      var _this31 = this;

      this.$http.get("cat_tipo_valores").then(function (response) {
        _this31.getInvValores(response.data.valores);
      }, function (error) {
        _this31.Err(error);
      });
    },
    getInvAforesCatalog: function getInvAforesCatalog() {
      var _this32 = this;

      this.$http.get("cat_afores").then(function (response) {
        _this32.getInvAfores(response.data.afores);
      }, function (error) {
        _this32.Err(error);
      });
    },
    checkCatalogs: function checkCatalogs() {
      if (!(this.tipos_apoyos.length > 0)) {
        this.getTipoApoyoCatalog();
      }
      if (!(this.nivel_gobierno.length > 0)) {
        this.getNivelGobiernoCatalog();
      }
      if (!(this.entidades.length > 0)) {
        this.getEntidadesCatalog();
      }
      if (!(this.paises.length > 0)) {
        this.getPaisesCatalog();
      }
      if (!(this.tipos_instituciones.length > 0)) {
        this.getTipoInsCatalog();
      }
      if (!(this.sectores_industria.length > 0)) {
        this.getSectoresCatalog();
      }
      if (!(this.tipos_representacion.length > 0)) {
        this.getTipoRepCatalog();
      }
      if (!(this.tipos_beneficios.length > 0)) {
        this.getTipoBeneficiosCatalog();
      }
      if (!(this.monedas.length > 0)) {
        this.getMonedasCatalog();
      }
      if (!(this.tipos_fideicomisos.length > 0)) {
        this.getTipoFideicomisoCatalog();
      }
      if (!(this.tipos_fideicomisos_part.length > 0)) {
        this.getTipoFideicomisoPartCatalog();
      }
      if (!(this.tipos_participaciones.length > 0)) {
        this.getTipoParticipacionesCatalog();
      }
      if (!(this.beneficiarios.length > 0)) {
        this.getBeneficiarioCatalog();
      }
      if (!(this.tipos_vehiculos.length > 0)) {
        this.getTipoVehiculoCatalog();
      }
      if (!(this.tipos_inmuebles.length > 0)) {
        this.getTipoInmuebleCatalog();
      }
      if (!(this.titular_adeudo.length > 0)) {
        this.getTitularAdeudoCatalog();
      }
      if (!(this.tipos_adeudos.length > 0)) {
        this.getTipoAdeudoCatalog();
      }
      if (!(this.adquisiciones.length > 0)) {
        this.getAdquisicionesCatalog();
      }
      if (!(this.relaciones.length > 0)) {
        this.getRelacionesCatalog();
      }
      if (!(this.pagos.length > 0)) {
        this.getPagosCatalog();
      }
      if (!(this.valores_inmueble.length > 0)) {
        this.getValorInmuebleCatalog();
      }
      if (!(this.bajas_inmueble.length > 0)) {
        this.getBajaInmuebleCatalog();
      }
      if (!(this.transmisores.length > 0)) {
        this.getTransmisoresCatalog();
      }
      if (!(this.tipos_mueble.length > 0)) {
        this.getMueblesCatalog();
      }
      if (!(this.inversiones.length > 0)) {
        this.getInversionesCatalog();
      }

      if (!(this.inv_bancarias.length > 0)) {
        this.getInvBancariaCatalog();
      }
      if (!(this.inv_fondos.length > 0)) {
        this.getInvFondosCatalog();
      }
      if (!(this.inv_organizaciones.length > 0)) {
        this.getInvOrgCatalog();
      }
      if (!(this.inv_monedas.length > 0)) {
        this.getInvMonedaCatalog();
      }
      if (!(this.inv_seguros.length > 0)) {
        this.getInvSegurosCatalog();
      }
      if (!(this.inv_valores.length > 0)) {
        this.getInvValoresCatalog();
      }
      if (!(this.inv_afores.length > 0)) {
        this.getInvAforesCatalog();
      }
    },
    filterAnio: function filterAnio(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('YYYY');
    },
    filterDeclarante: function filterDeclarante(index) {
      var resp = " ";
      if (index == '1') {
        resp = "Declarante";
      } else if (index == '2') {
        resp = "Pareja";
      } else {
        resp = "Dependiente Económico";
      }
      return resp;
    },
    filterBeneficiario: function filterBeneficiario(id) {
      var resp = " ";
      if (this.beneficiarios) {
        this.beneficiarios.forEach(function (item) {
          if (item.id == id) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterCatalog: function filterCatalog(id, list) {
      var resp = "-";
      if (list) {
        list.forEach(function (item) {
          if (item.id == id) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterNivel: function filterNivel(id) {
      var resp = " ";
      if (this.nivel_gobierno) {
        this.nivel_gobierno.forEach(function (item) {
          if (item.id == id) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterApoyo: function filterApoyo(id) {
      var resp = " ";
      if (this.tipos_apoyos) {
        this.tipos_apoyos.forEach(function (item) {
          if (item.id == id) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterSector: function filterSector(index) {
      var resp = " ";
      if (this.sectores_industria) {
        this.sectores_industria.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterBool: function filterBool(index) {
      var resp = "No";
      if (index == 1 || index == "1") {
        resp = "Si";
        return resp;
      }
      return resp;
    },
    filterTipoPersona: function filterTipoPersona(index) {
      var resp = " ";
      if (index == '1') {
        resp = "Persona física";
      } else if (index == '2') {
        resp = "Persona moral";
      }
      return resp;
    },
    filterTipoRepresentacion: function filterTipoRepresentacion(index) {
      var resp = " ";
      if (this.tipos_representacion) {
        this.tipos_representacion.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterTipoRepresentante: function filterTipoRepresentante(index) {
      var resp = " ";
      if (index == '1') {
        resp = "Representante";
      } else if (index == '2') {
        resp = "Representado";
      }
      return resp;
    },
    filterTipoMoneda: function filterTipoMoneda(index) {
      var resp = " ";
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
            return resp;
          }
        });
      }
      return resp;
    },
    filterForma: function filterForma(index) {
      var resp = " ";
      if (index == '1') {
        resp = "Monetario";
      } else if (index == '2') {
        resp = "Especie";
      }
      return resp;
    },
    filterTipoBeneficio: function filterTipoBeneficio(index) {
      var resp = " ";
      if (this.tipos_beneficios) {
        this.tipos_beneficios.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterTipofideicomiso: function filterTipofideicomiso(index) {
      var resp = " ";
      if (this.tipos_fideicomisos) {
        this.tipos_fideicomisos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterTipoFideicomisoPart: function filterTipoFideicomisoPart(index) {
      var resp = " ";
      if (this.tipos_fideicomisos_part) {
        this.tipos_fideicomisos_part.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterTipoParticipacion: function filterTipoParticipacion(index) {
      var resp = " ";
      if (this.tipos_participaciones) {
        this.tipos_participaciones.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterTipoBien: function filterTipoBien(item) {
      if (item == '1') {
        return "Inmueble";
      } else {
        return "Vehiculo";
      }
    },
    filterInmueble: function filterInmueble(index) {
      var resp = " ";
      if (this.tipos_inmuebles) {
        this.tipos_inmuebles.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    filterMueble: function filterMueble(index) {
      var resp = " ";
      if (this.tipos_vehiculos) {
        this.tipos_vehiculos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    },
    filterSignoDos: function filterSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    scrolling: function scrolling() {
      this.$el.querySelector("[aria-invalid=true]").scrollIntoView({
        block: "center",
        behavior: "smooth"
      });
    }
  })
};

/***/ }),

/***/ "BKtA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("jj2E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("38s3");
function injectStyle (ssrContext) {
  __webpack_require__("vKxx")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BcA1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BqYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Verificación (Evolución Patrimonial)")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shlista),expression:"shlista"}],staticClass:"row"},[(_vm.rol!=4)?_c('div',{staticClass:"col-md-8"},[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.rol!=4)?_c('div',{staticClass:"col-md-4 pull-left"},[_c('button',{staticClass:"btn btn-fill btn-success",attrs:{"disabled":_vm.loading_bar},on:{"click":_vm.getDeclaraciones}},[_vm._v("\n            "+_vm._s(_vm.loading_bar? 'Buscando datos':'Buscar')+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shlista),expression:"shlista"}]},[_c('br'),_vm._v(" "),_c('div',{staticClass:"offset-md-6 col-sm-6 col-md-6 col-lg-6"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.filtro_usuarios,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Ver'),expression:"'Ver'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.historico(item)}}},[_c('i',{staticClass:"fas fa-search"})])],1)]}},{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat(item.fecha)))])]}}])}),_vm._v(" "),_c('v-data-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.shhistorico),expression:"shhistorico"}],attrs:{"headers":_vm.headers2,"items":_vm.table_list,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.anio",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterAnio(item.created_at)))])]}},{key:"item.patrimonial",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item.id)}}},[_c('i',{staticClass:"far fa-file-pdf"})])]}}])})],1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shhistorico),expression:"shhistorico"}],staticClass:"card-content"},[_c('button',{staticClass:"btn btn-fill btn-success pull-right",on:{"click":_vm.regresar}},[_vm._v("\n        Regresar\n      ")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-chip',{staticClass:"ma-2",attrs:{"color":"primary","label":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fas fa-user")]),_vm._v("\n            "+_vm._s(this.nombre)+"\n          ")],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers2,"items":_vm.table_list,"items-per-page":5,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Ver'),expression:"'Ver'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.historico1(item)}}},[_c('i',{staticClass:"fas fa-search"})])],1)]}},{key:"item.declaracion_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.Tipo_Dec))])]}},{key:"item.entidad",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.entidad))])]}},{key:"item.anio",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat3(item.created_at)))])]}}])})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.balanza),expression:"balanza"}],staticClass:"card-content"},[_c('button',{staticClass:"btn btn-fill btn-success pull-right",on:{"click":_vm.regresar1}},[_vm._v("\n        Regresar\n      ")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div'),_vm._v(" "),[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"error-color":"#EB5E28","color":"#1e94fd","title":"Consulta general del servidor público","subtitle":""}},[_c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Generales","active":""}},[_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Nombres")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Dependencia")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Cargo")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.nombres))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.datos_encargo_actual.dependencia))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.datos_encargo_actual.cargo))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Correo oficial")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Correo alternativo")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.ce_laboral))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.ce_personal))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Calle")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("No. Ext")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("No. Int")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.calle))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.numext))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.numint))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Colonia")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Ciudad")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Estado")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("CP")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.colonia))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.municipio))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.entidad))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.cp))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Teléfono")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("Estado civil")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","color":"navy","font-weight":"900"}},[_vm._v("CURP")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.tel_particular))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.edoCivil))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.informacion_personal.curp))])])])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Gráfica"},on:{"click":function($event){return _vm.fillData()}}},[[_c('div',[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-circle-chart"},[_c('div',{staticClass:"card-content position-relative"},[_c('GChart',{attrs:{"type":"LineChart","data":_vm.chartData,"options":_vm.chartOptions,"resizeDebounce":850}})],1)])])])]],2),_vm._v(" "),_c('b-tab',{attrs:{"title":"Balanza"}},[_c('table',{staticClass:"table table-striped table-hover"},[_c('thead',{staticClass:"thead-green"},[_c('tr',[_c('th',{attrs:{"width":"75%"}},[_vm._v("ACTIVOS")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Sueldos y salarios")]),_vm._v(" "),(_vm.datosDeclaracion.tipo_declaracion_id == 1)?_c('td',{staticClass:"text-right",staticStyle:{"color":"green"}},[_vm._v("\n                                "+_vm._s(_vm.totalingresos.total)+"\n                              ")]):_c('td',{staticClass:"text-right",staticStyle:{"color":"green"}},[_vm._v("\n                                "+_vm._s(_vm.totalingresosant.total)+"\n                              ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Inmuebles")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.totalbinmuebles))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Vehículos")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.totalbmuebles))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Muebles")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"color":"green"}},[_vm._v("\n                                "+_vm._s(_vm.totalbmueblesnr)+"\n                              ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Inversiones")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"color":"green"}},[_vm._v("\n                                "+_vm._s(_vm.totalinversiones)+"\n                              ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Total Activos")]),_vm._v(" "),(_vm.datosDeclaracion.tipo_declaracion_id == 1)?_c('td',{staticClass:"text-right",staticStyle:{"color":"green"}},[_vm._v("\n                                "+_vm._s(_vm.totalactivos)+"\n                              ")]):_c('td',{staticClass:"text-right",staticStyle:{"color":"green"}},[_vm._v("\n                                "+_vm._s(_vm.totalactivosant)+"\n                              ")])])])]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-hover"},[_c('thead',{staticClass:"thead-red"},[_c('tr',[_c('th',{attrs:{"width":"75%"}},[_vm._v("PASIVOS")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Adeudos")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"color":"red"}},[_vm._v("\n                                "+_vm._s(_vm.totalpendiente)+"\n                              ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Depósito en inversiones")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"color":"red"}},[_vm._v("\n                                "+_vm._s(_vm.totalmontooriginal)+"\n                              ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Total Pasivos")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.totalpasivos))])])])]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-hover"},[_c('thead',{staticClass:"thead-blue"},[_c('tr',[_c('th',{attrs:{"width":"75%"}},[_vm._v("BALANCE GENERAL")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),(_vm.datosDeclaracion.tipo_declaracion_id == 1)?_c('td',{staticClass:"text-right",staticStyle:{"color":"green"}},[_vm._v("\n                                "+_vm._s(_vm.totalbalanza)+"\n                              ")]):_c('td',{staticClass:"text-right"},[_vm._v("\n                                "+_vm._s(_vm.totalbalanzaant)+"\n                              ")])])])])])],1)],1),_vm._v(" "),_c('button',{staticClass:"d-none",attrs:{"slot":"next"},slot:"next"},[_vm._v("Siguiente")]),_vm._v(" "),_c('button',{staticClass:"d-none",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Siguientes")])])],1)])])])]],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CDCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Tablero_vue__ = __webpack_require__("VLq0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a0c3ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Tablero_vue__ = __webpack_require__("f7oI");
function injectStyle (ssrContext) {
  __webpack_require__("xIGm")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Tablero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a0c3ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Tablero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CIgy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CNTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_usuarios,"expanded":_vm.expanded,"single-expand":_vm.singleExpand},on:{"update:expanded":function($event){_vm.expanded=$event}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var expand = ref.expand;
var isExpanded = ref.isExpanded;
return [_c('tr',[_c('td',[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){return expand(!isExpanded)}}},[_c('i',{staticClass:"fas fa-search"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(item.updated_at)+" ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(item.rfc)+" ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(item.nombre)+" ")])])]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('div',{staticClass:"row p-4"},[_c('div',{staticClass:" col-12"},[_c('div',{staticClass:"card "},[_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(" Cambio solicitado por ")]),_vm._v(": "+_vm._s(item.usuario.Nombre+' '+item.usuario.Paterno+' '+item.usuario.Materno)+"\n                          ")]),_vm._v(" "),_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(" Cambio ")]),_vm._v(": "+_vm._s(_vm.getStatus(item.status))+"\n                          ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Datos Actuales")]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((item.datos_actuales),function(value,key){return _c('li',{key:key,staticClass:"list-group-item"},[_c('strong',[_vm._v(_vm._s(key.replace("_", " ")))]),_vm._v(" : "+_vm._s(_vm.returnValueKey(value,key)))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Datos de Transferencia")]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((item.datos_cambio),function(value,key){return _c('li',{key:key,staticClass:"list-group-item"},[_c('strong',[_vm._v(_vm._s(key.replace("_", " ")))]),_vm._v(" : "+_vm._s(_vm.returnValueKey(value,key)))])}),0)])])])])])]}}],null,false,2329540488)})],1)])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Solicitudes de transferencia de Personal")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CQa9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CR90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_servidores,"items-per-page":5,"search":_vm.filter,"fixed-header":true,"custom-filter":_vm.buscaServ},scopedSlots:_vm._u([{key:"item.nombres",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getNombre(item)))])]}},{key:"item.ente_publico_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getDependencias(item.ente_publico_id)))])]}},{key:"item.fecha",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat(item.encargo.fecha_termino)))])]}},{key:"item.tipo",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.declaracion.Tipo_Dec))])]}}])})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v(" Bajas por defunción ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CiiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),(_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Seleccione el movimiento a realizar")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Selecciona una opción"},model:{value:(_vm.selects.simple),callback:function ($$v) {_vm.$set(_vm.selects, "simple", $$v)},expression:"selects.simple"}},_vm._l((_vm.selects.movimientos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.value,"label":option.label}})}),1)],1)]),_vm._v(" "),(_vm.selects.simple ==1)?_c('div',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.selects.simple ==2)?_c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Crear baja ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha baja")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"type":"date","name":"fecha_inicio","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.item_usuarios.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.item_usuarios, "fecha_inicio", $$v)},expression:"item_usuarios.fecha_inicio"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.fecha_inicio.invalid),expression:"fecha_inicio.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('fecha_inicio'))+"\n                  ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de baja")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.tipo_baja),expression:"item_usuariosValidations.tipo_baja"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"tipo_baja"},model:{value:(_vm.item_usuarios.tipo_baja),callback:function ($$v) {_vm.$set(_vm.item_usuarios, "tipo_baja", $$v)},expression:"item_usuarios.tipo_baja"}},[_c('el-option',{attrs:{"value":"Normal"}}),_vm._v(" "),_c('el-option',{attrs:{"value":"Defunción"}})],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.selects.simple == 3)?_c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v(" Crear licencia")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de inicio")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.inicia),expression:"item_usuariosValidations.inicia"}],attrs:{"type":"date","name":"inicia","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.item_usuarios.inicia),callback:function ($$v) {_vm.$set(_vm.item_usuarios, "inicia", $$v)},expression:"item_usuarios.inicia"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicia.invalid),expression:"inicia.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('inicia'))+"\n                  ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de Termino")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.termina),expression:"item_usuariosValidations.termina"}],attrs:{"type":"date","name":"termina","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.item_usuarios.termina),callback:function ($$v) {_vm.$set(_vm.item_usuarios, "termina", $$v)},expression:"item_usuarios.termina"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.termina.invalid),expression:"termina.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('termina'))+"\n                  ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Licencia")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuarios.tipo_lic),expression:"item_usuarios.tipo_lic"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"tipo_lic"},model:{value:(_vm.item_usuarios.encargo.tipo_lic),callback:function ($$v) {_vm.$set(_vm.item_usuarios.encargo, "tipo_lic", $$v)},expression:"item_usuarios.encargo.tipo_lic"}},[_c('el-option',{attrs:{"value":null}},[_vm._v("Selecciona una opción")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1"}},[_vm._v("Médica")]),_vm._v(" "),_c('el-option',{attrs:{"value":"2"}},[_vm._v("Trabajo")])],1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_lic.invalid),expression:"tipo_lic.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('tipo_lic'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones")]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.observaciones),expression:"item_usuariosValidations.observaciones"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.observaciones),expression:"item_usuarios.observaciones"}],staticClass:"form-control",attrs:{"type":"text","name":"observaciones","placeholder":"Observaciones"},domProps:{"value":(_vm.item_usuarios.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "observaciones", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.observaciones.invalid),expression:"observaciones.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('observaciones'))+"\n                ")])])])]):_vm._e(),_vm._v(" "),(_vm.selects.simple == 4)?_c('div',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Servidor público")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.nombres),expression:"item_usuariosValidations.nombres"},{name:"model",rawName:"v-model",value:(_vm.fullName),expression:"fullName"}],staticClass:"form-control",attrs:{"type":"text","name":"nombres","placeholder":"Servidor Público","readonly":""},domProps:{"value":(_vm.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fullName=$event.target.value}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombres.invalid),expression:"nombres.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('nombres'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Empleo, Cargo o Comisión")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.empleo_cargo_comision),expression:"item_usuariosValidations.empleo_cargo_comision"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.encargo.empleo_cargo_comision),expression:"item_usuarios.encargo.empleo_cargo_comision"}],staticClass:"form-control",attrs:{"type":"text","name":"empleo_cargo_comision","placeholder":"Dirección"},domProps:{"value":(_vm.item_usuarios.encargo.empleo_cargo_comision)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios.encargo, "empleo_cargo_comision", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.empleo_cargo_comision.invalid),expression:"empleo_cargo_comision.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('empleo_cargo_comision'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Área de adscripción")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.area_adscripcion),expression:"item_usuariosValidations.area_adscripcion"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.encargo.area_adscripcion),expression:"item_usuarios.encargo.area_adscripcion"}],staticClass:"form-control",attrs:{"type":"text","name":"area_adscripcion","placeholder":"Área de adscripción"},domProps:{"value":(_vm.item_usuarios.encargo.area_adscripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios.encargo, "area_adscripcion", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.area_adscripcion.invalid),expression:"area_adscripcion.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('area_adscripcion'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nivel del Encargo")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.nivel),expression:"item_usuariosValidations.nivel"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.encargo.nivel_encargo),expression:"item_usuarios.encargo.nivel_encargo"}],staticClass:"form-control",attrs:{"type":"text","name":"nivel","placeholder":"Nivel tabular"},domProps:{"value":(_vm.item_usuarios.encargo.nivel_encargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios.encargo, "nivel_encargo", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nivel.invalid),expression:"nivel.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('nivel'))+"\n                ")])])])]):_vm._e(),_vm._v(" "),(_vm.selects.simple == 5)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.rfc),expression:"item_usuariosValidations.rfc"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.rfc),expression:"item_usuarios.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.item_usuarios.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "rfc", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.rfc.invalid),expression:"rfc.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('rfc'))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre(s)")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.nombres),expression:"item_usuariosValidations.nombres"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.nombres),expression:"item_usuarios.nombres"}],staticClass:"form-control",attrs:{"type":"text","name":"nombres","placeholder":"Nombre(s)"},domProps:{"value":(_vm.item_usuarios.nombres)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "nombres", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombres.invalid),expression:"nombres.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('nombres'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Apellido Paterno")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.primer_apellido),expression:"item_usuariosValidations.primer_apellido"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.primer_apellido),expression:"item_usuarios.primer_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"primer_apellido","placeholder":"Especificar"},domProps:{"value":(_vm.item_usuarios.primer_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "primer_apellido", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.primer_apellido.invalid),expression:"primer_apellido.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('primer_apellido'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Apellido Materno")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.segundo_apellido),expression:"item_usuariosValidations.segundo_apellido"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.segundo_apellido),expression:"item_usuarios.segundo_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"segundo_apellido","placeholder":"Especificar"},domProps:{"value":(_vm.item_usuarios.segundo_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "segundo_apellido", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.segundo_apellido.invalid),expression:"segundo_apellido.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('segundo_apellido'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Dependencia")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.ente_publico_id),expression:"item_usuariosValidations.ente_publico_id"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"ente_publico_id"},model:{value:(_vm.item_usuarios.encargo.ente_publico_id),callback:function ($$v) {_vm.$set(_vm.item_usuarios.encargo, "ente_publico_id", $$v)},expression:"item_usuarios.encargo.ente_publico_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.ente_publico_id.invalid),expression:"ente_publico_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('ente_publico_id'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Empleo, Cargo o Comisión")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.direccion_cargo),expression:"item_usuariosValidations.direccion_cargo"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.encargo.empleo_cargo_comision),expression:"item_usuarios.encargo.empleo_cargo_comision"}],staticClass:"form-control",attrs:{"type":"text","name":"direccion_cargo","placeholder":"Dirección"},domProps:{"value":(_vm.item_usuarios.encargo.empleo_cargo_comision)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios.encargo, "empleo_cargo_comision", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.direccion_cargo.invalid),expression:"direccion_cargo.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('direccion_cargo'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Contrado por honorarios")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.honorarios),expression:"item_usuariosValidations.honorarios"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"honorarios"},model:{value:(_vm.item_usuarios.encargo.contratado_honorarios),callback:function ($$v) {_vm.$set(_vm.item_usuarios.encargo, "contratado_honorarios", $$v)},expression:"item_usuarios.encargo.contratado_honorarios"}},[_c('el-option',{attrs:{"value":"1"}},[_vm._v("Si")]),_vm._v(" "),_c('el-option',{attrs:{"value":"2"}},[_vm._v("No")])],1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.honorarios.invalid),expression:"honorarios.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('honorarios'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Nivel del Encargo")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.nivel),expression:"item_usuariosValidations.nivel"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.encargo.nivel_encargo),expression:"item_usuarios.encargo.nivel_encargo"}],staticClass:"form-control",attrs:{"type":"text","name":"nivel","placeholder":"Nivel tabular"},domProps:{"value":(_vm.item_usuarios.encargo.nivel_encargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios.encargo, "nivel_encargo", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nivel.invalid),expression:"nivel.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('nivel'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Área de adscripción")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.area_adscripcion),expression:"item_usuariosValidations.area_adscripcion"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.encargo.area_adscripcion),expression:"item_usuarios.encargo.area_adscripcion"}],staticClass:"form-control",attrs:{"type":"text","name":"area_adscripcion","placeholder":"Área de adscripción"},domProps:{"value":(_vm.item_usuarios.encargo.area_adscripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios.encargo, "area_adscripcion", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.area_adscripcion.invalid),expression:"area_adscripcion.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('area_adscripcion'))+"\n                ")])])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.selects.simple == 6)?_c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v(" Modificar contraseña")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_usuariosValidations.Password),expression:"item_usuariosValidations.Password"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.password),expression:"item_usuarios.password"}],ref:"Password",staticClass:"form-control",attrs:{"type":"password","name":"Password","placeholder":"*****"},domProps:{"value":(_vm.item_usuarios.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "password", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.Password.invalid),expression:"Password.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('Password'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Confirmar contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:Password'),expression:"'required|confirmed:Password'"},{name:"model",rawName:"v-model",value:(_vm.item_usuarios.Confirmar),expression:"item_usuarios.Confirmar"}],staticClass:"form-control",attrs:{"type":"password","name":"Confirmar","placeholder":"*****"},domProps:{"value":(_vm.item_usuarios.Confirmar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_usuarios, "Confirmar", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.Confirmar.invalid),expression:"Confirmar.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('Confirmar'))+"\n                ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n              ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(4)])]),_vm._v(" "),_vm._m(5)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_usuarios,"search":_vm.filter,"items-per-page":5,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br')],1)]}},{key:"item.rfc",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.usuarios.rfc)+" ")])]}},{key:"item.nombres",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.usuarios.nombres + ' '+ item.usuarios.primer_apellido +' '+item.usuarios.segundo_apellido)+" ")])]}},{key:"item.area",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.encargo.area_adscripcion))])]}},{key:"item.inicia",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm._f("dateFormat")(item.inicia)))])]}},{key:"item.termina",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm._f("dateFormat")(item.termina)))])]}}],null,false,2698631355)})],1)])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Licencias ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Seguro que desea desactivar este registro?")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Motivos/Observaciones"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v(" Crear Promoción")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Motivo de corrección")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Área de adscripción"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CjQB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cp7P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "DQoI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DaS8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Denf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading_bar),expression:"loading_bar"}],staticClass:"row p-3 pt-0"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"cyan"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',[_c('div',{staticClass:"card col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Omisos")]),_vm._v(" "),(_vm.getKey('permisos').includes(21))?_c('div',{staticClass:"card-content form-group"},[_c('div',{staticClass:"row"},[(_vm.getKey('permisos').includes(14))?_c('div',{staticClass:"col-9"},[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-3 text-left d-flex align-items-end"},[_c('button',{staticClass:"btn btn-success btn-wd pull-right",attrs:{"disabled":_vm.loading_bar},on:{"click":_vm.getOmisos}},[_vm._v("\n                "+_vm._s(_vm.loading_bar? 'Buscando datos':'Buscar')+"\n              ")])])])]):_vm._e(),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.list_declarantes,"meta":_vm.meta,"fields":_vm.cumplidos_campos,"worksheet":"Cumplidos","name":_vm.nombreC}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n              Descargar Reporte\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_declarantes,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.prog",fn:function(ref){
var item = ref.item;
return [(item.limite>=1)?_c('v-progress-circular',{attrs:{"rotate":360,"size":60,"width":5,"value":item.limite,"color":"teal"}},[_vm._v("\n                  "+_vm._s(item.limite)+"\n\n                ")]):_vm._e(),_vm._v(" "),(item.limite<1)?_c('v-progress-circular',{attrs:{"rotate":360,"size":60,"width":5,"value":100,"color":"red"}},[_vm._v("\n                  "+_vm._s(item.limite *-1)+"\n\n                ")]):_vm._e()]}}])})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dg23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Resumen_vue__ = __webpack_require__("dbHI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b895249_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Resumen_vue__ = __webpack_require__("tyH6");
function injectStyle (ssrContext) {
  __webpack_require__("KyzE")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Resumen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b895249_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Resumen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DoFW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DsGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("Dhe7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("zHPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("SaMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_excel_export__ = __webpack_require__("VdFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Domicilio_vue__ = __webpack_require__("Ta4m");






















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_excel_export__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a),
  props: ["data"],
  data: function data() {
    return {
      expanded: [],
      filtro: null,
      filter: null,
      isLoading: false,
      currentPage: 1,
      perPage: 50,
      rol: "",
      rows: null,
      id: 1,
      dependencias: null,
      item_usuarios: {},
      lista_movimientos: [],
      lista_movimientos2: [],
      cat_movimientos: [],
      headers: [{
        text: '',
        value: 'data-table-expand'
      }, {
        text: 'Tipo movimiento',
        value: 'tipo_mov',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'left'
      }, {
        text: 'Inicio',
        value: 'inicia',
        align: 'center'
      },, {
        text: 'Termino',
        value: 'termina',
        align: 'center'
      }],
      meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      lista_campos: {
        'Nombres': 'nombres',
        'RFC': 'rfc',
        'CURP': 'curp',
        'Tipo Movimiento': 'tipo_movimiento',
        'Inicia': 'inicia',
        'Termina': 'termina',
        'Origen': 'origen',
        'Cambio': 'cambio',
        'Observaciones': 'observaciones',
        'Creador': 'creador',
        'Correo Creador': 'creador_mail',
        'Dependencia Creador': 'creador_dependencia',
        'Aprobación': 'aprobacion',
        'Correo Aprobación': 'aprobacion_mail',
        'Dependencia Aprobación': 'aprobacion_dependencia'
      }
    };
  },

  computed: {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.lista_movimientos.length;

      return this.lista_movimientos.length;
    },

    fullName: {
      get: function get() {
        return this.item_usuarios.nombres + ' ' + this.item_usuarios.primer_apellido + ' ' + this.item_usuarios.segundo_apellido;
      },
      set: function set(newValue) {
        var m = newValue.match(/(\S*)\s+(.*)/);

        this.nombres = m[1];
        this.primer_apellido = m[2];
        this.segundo_apellido = m[3];
      }
    }
  },
  methods: {
    customFilter: function customFilter(value, search, item) {
      search = search.toString().toLowerCase();
      var filter = this.flat(item, {});

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(filter).some(function (v) {
        return v && v.toString().toLowerCase().includes(search);
      });
    },
    flat: function flat(obj, out) {
      var _this = this;

      if (obj) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[key]) == 'object') {
            out = _this.flat(obj[key], out);
          } else {
            out[key] = obj[key];
          }
        });
      }
      return out;
    },
    rowClick: function rowClick(item, row) {
      var indexRow = item.index;
      var indexExpanded = this.expanded.findIndex(function (i) {
        return i === item;
      });

      if (indexExpanded > -1) {
        this.expanded = [];
        row.select(false);
      } else {
        this.expanded = [item];
        row.select(true);
      }
    },
    initItem: function initItem() {
      this.item_usuarios = {
        acciones: "",
        nombres: "",
        Paterno: "",
        Materno: "",
        User: "",
        Password: ""
      };
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getmovimientos: function getmovimientos() {
      var _this2 = this;

      this.lista_movimientos2 = [];
      var params = {
        params: {
          ente_publico_id: this.filtro
        }
      };
      this.isLoading = true;
      this.$http.get("movimientos", params).then(function (response) {
        _this2.lista_movimientos = response.data.movimientos;
        _this2.lista_movimientos.forEach(function (value, key) {
          _this2.isLoading = false;
          var aprobacion = {
            Nombre: '',
            Paterno: '',
            Materno: '',
            User: '',
            ID_Dependencia: ''
          };
          var usuario = {
            Nombre: '',
            Paterno: '',
            Materno: '',
            User: '',
            ID_Dependencia: ''
          };

          if (value.aprobacion) {
            aprobacion = value.aprobacion;
          }
          if (value.usuario) {
            usuario = value.usuario;
          }

          _this2.lista_movimientos2.push({
            'nombres': value.servidor.nombres + ' ' + value.servidor.primer_apellido + ' ' + value.servidor.segundo_apellido,
            'rfc': value.servidor.rfc,
            'curp': value.servidor.curp,
            'tipo_movimiento': _this2.setMovimiento(value.tipo_mov),
            'inicia': value.inicia,
            'termina': value.termina,
            'origen': value.origen ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(value.origen).join(', ') : '',
            'cambio': value.cambio ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(value.cambio).join(', ') : '',
            'observaciones': value.motivo,
            'creador': usuario.Nombre + ' ' + usuario.Paterno + ' ' + usuario.Materno,
            'creador_mail': usuario.User,
            'creador_dependencia': _this2.getDependencias(usuario.ID_Dependencia),
            'aprobacion': aprobacion.Nombre + ' ' + aprobacion.Paterno + ' ' + aprobacion.Materno,
            'aprobacion_mail': aprobacion.User,
            'aprobacion_dependencia': _this2.getDependencias(aprobacion.ID_Dependencia)
          });
        });
      }, function (error) {
        _this2.isLoading = false;
        _this2.Err(error);
      });
    },
    getCatMovimientos: function getCatMovimientos() {
      var _this3 = this;

      this.$http.get("cat_movimientos").then(function (response) {
        _this3.cat_movimientos = response.data.movimientos;

        _this3.cat_movimientos.push({
          id: 10,
          tipo: 'Reactivación'
        });

        _this3.getmovimientos();
      }, function (error) {
        _this3.Err(error);
      });
    },
    setMovimiento: function setMovimiento(index) {
      var resp = " ";
      if (index) {
        if (this.cat_movimientos) {
          this.cat_movimientos.forEach(function (item) {
            if (item.id == index) {
              resp = item.tipo;
              return resp;
            }
          });
        }
      }
      return resp;
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();
    this.filtro = this.getKey("ente_publico_id");

    this.rol = this.getKey("role");

    this.getCatMovimientos();

    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.dependencias = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "DtR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");














var _components;





/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), _components),
  data: function data() {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        periodo: ''
      },
      dependencias: {},
      rol: '',
      filter: null,
      currentPage: 1,
      perPage: 50,
      periodos: [],
      rows: null,
      tiposDeclaracion: [],
      list_cumplimiento: [],

      filtro_usuarios: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Id',
        value: 'id',
        align: 'center'
      }, {
        text: 'Tipo de Declaración',
        value: 'tipoDec',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Correo Laboral',
        value: 'correo',
        align: 'center'
      }],

      propsToSearch: ['rfc', 'nombres'],
      tableColumns: [{
        prop: 'id',
        label: 'Dec',
        minWidth: 150,
        vif: false
      }, {
        prop: 'rfc',
        label: 'RFC',
        minWidth: 150,
        vif: true
      }, {
        prop: 'nombres',
        label: 'Nombre',
        minWidth: 100,
        vif: true
      }]
    };
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_cumplimiento.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_cumplimiento.length;
        return this.pagedData;
      }
      var result = this.list_cumplimiento.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_cumplimiento.length;

      return this.list_cumplimiento.length;
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [1];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getDependencias: function getDependencias() {
      var _this2 = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this2.dependencias = response.data.entes_publicos;
        _this2.dependencias.unshift({
          'codigo': 'T',
          'id': 0,
          'valor': 'Todas'
        });
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getTipoDeclaracion: function getTipoDeclaracion() {
      var _this3 = this;

      var v = this;
      this.$http.get("tiposDeclaracion").then(function (response) {
        _this3.tiposDeclaracion = response.data.tipoDeclaracion;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    getPeriodos: function getPeriodos() {
      var _this4 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this4.periodos = response.data.periodos;
      }, function (error) {
        _this4.StepError(error);
      });
    },
    dateFormat: function dateFormat(date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    getDeclaracionesPorFecha: function getDeclaracionesPorFecha() {
      var _this5 = this;

      this.$http.post("rdeclaraciones", this.model).then(function (response) {
        _this5.list_cumplimiento = [];
        response.data.declarantes.forEach(function (value, key) {
          _this5.list_cumplimiento.push({
            'id': value.decid,
            'rfc': value.rfc,
            'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
            'entidad': value.ente,
            'correo': value.correo,
            'tipoDec': value.tipoDec
          });
          console.log(_this5.list_cumplimiento);
        });
        _this5.filtro_usuarios = _this5.list_cumplimiento;
      }, function (error) {
        _this5.StepError(error);
      });
    },
    descargar: function descargar(row) {
      var url = this.$apiUrl + 'getDeclaracion1/pdf/' + row.id + '/' + this.getKey('uid');
      window.open(url, '_blank');
    }
  },
  created: function created() {
    this.getDependencias();
    this.getTipoDeclaracion();
    this.getPeriodos();
    this.rol = this.getKey('role');
    this.checkPermissions();
  }
});

/***/ }),

/***/ "Dyuf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿ Tiene inversiones ? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.inversiones),expression:"info.inversiones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Inversión "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_inversion),expression:"info.tipo_inversion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"tipo_inversion","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.tipo_inversion_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_inversion_id", $$v)},expression:"form_item.tipo_inversion_id"}},_vm._l((_vm.inversiones),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo_inversion')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Titular de la inversion, cuentas bancarias y otro tipo de valores "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.titular),expression:"info.titular",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción","name":"titular_id"},model:{value:(_vm.form_item.titular_id),callback:function ($$v) {_vm.$set(_vm.form_item, "titular_id", $$v)},expression:"form_item.titular_id"}},_vm._l((_vm.titular_adeudo),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('titular_id')))])],1),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tercero "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tercero),expression:"info.tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"1"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"2"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tercero')))])],1):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre del tercero o terceros "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_tercero),expression:"info.nombre_tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_tercero),expression:"form_item.nombre_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_tercero","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.form_item.nombre_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_tercero')))])]):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC del tercero "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_tercero),expression:"info.rfc_tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_tercero),expression:"form_item.rfc_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_tercero","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_tercero')))])]):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_inversion_id == 1)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Bancaria "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.bancaria),expression:"info.bancaria",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"bancaria","filterable":"","placeholder":"Bancaria"},model:{value:(_vm.form_item.bancaria_id),callback:function ($$v) {_vm.$set(_vm.form_item, "bancaria_id", $$v)},expression:"form_item.bancaria_id"}},_vm._l((_vm.inv_bancarias),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('bancaria')))])],1):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_inversion_id == 3)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fondos de inversión "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fondo),expression:"info.fondo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"fondo_inversion_id","filterable":"","placeholder":"Fondo de Inversión"},model:{value:(_vm.form_item.fondo_inversion_id),callback:function ($$v) {_vm.$set(_vm.form_item, "fondo_inversion_id", $$v)},expression:"form_item.fondo_inversion_id"}},_vm._l((_vm.inv_fondos),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('fondo_inversion_id')))])],1):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_inversion_id == 4)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Organizaciones privadas y/o mercantiles "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.organizaciones),expression:"info.organizaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"organizacionespym_id","filterable":"","placeholder":"Organizaciones privadas y/o mercantiles"},model:{value:(_vm.form_item.organizacionespym_id),callback:function ($$v) {_vm.$set(_vm.form_item, "organizacionespym_id", $$v)},expression:"form_item.organizacionespym_id"}},_vm._l((_vm.inv_organizaciones),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('organizacionespym_id')))])],1):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_inversion_id == 5)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Posesión de monedas y/o metales "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.monedas_metales),expression:"info.monedas_metales",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"moneda_metales_id","filterable":"","placeholder":"Posesión de monedas y/o metales"},model:{value:(_vm.form_item.moneda_metales_id),callback:function ($$v) {_vm.$set(_vm.form_item, "moneda_metales_id", $$v)},expression:"form_item.moneda_metales_id"}},_vm._l((_vm.inv_monedas),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('moneda_metales_id')))])],1):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_inversion_id == 6)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Seguros "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.seguros),expression:"info.seguros",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"seguro_id","filterable":"","placeholder":"Seguros"},model:{value:(_vm.form_item.seguro_id),callback:function ($$v) {_vm.$set(_vm.form_item, "seguro_id", $$v)},expression:"form_item.seguro_id"}},_vm._l((_vm.inv_seguros),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('seguro_id')))])],1):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_inversion_id == 2)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Valores bursátiles "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.valores),expression:"info.valores",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"valores_id","filterable":"","placeholder":"Valores bursátiles"},model:{value:(_vm.form_item.valores_id),callback:function ($$v) {_vm.$set(_vm.form_item, "valores_id", $$v)},expression:"form_item.valores_id"}},_vm._l((_vm.inv_valores),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('valores_id')))])],1):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_inversion_id == 7)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Afores y otros "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.afores),expression:"info.afores",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"afore_id","filterable":"","placeholder":"Afores y otros"},model:{value:(_vm.form_item.afore_id),callback:function ($$v) {_vm.$set(_vm.form_item, "afore_id", $$v)},expression:"form_item.afore_id"}},_vm._l((_vm.inv_afores),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('afore_id')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Número de cuenta, contrato o póliza "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.cuenta),expression:"info.cuenta",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"},{name:"model",rawName:"v-model",value:(_vm.form_item.numero_cuenta),expression:"form_item.numero_cuenta"}],staticClass:"form-control",attrs:{"name":"numero_cuenta","type":"text","placeholder":"Especificar"},domProps:{"value":(_vm.form_item.numero_cuenta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "numero_cuenta", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('numero_cuenta')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6 "},[_c('label',{staticClass:"control-label"},[_vm._v("Saldo a la fecha (Situación actual) "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.monto_original+' '+_vm.info.moneda_id),expression:"info.monto_original+' '+info.moneda_id",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"customCurrency"},[_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"text-right",attrs:{"name":"monto_original","type":"number","min":"0","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.form_item.monto_original),callback:function ($$v) {_vm.$set(_vm.form_item, "monto_original", $$v)},expression:"form_item.monto_original"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.form_item.moneda_id),callback:function ($$v) {_vm.$set(_vm.form_item, "moneda_id", $$v)},expression:"form_item.moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.form_item.moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('monto_original')))])]),_vm._v(" "),_c('legend',[_vm._v("¿Donde se localiza la inversion, cuentas bancarias y otro tipo de valores? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.lugar),expression:"info.lugar",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" País ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"pais","filterable":"","placeholder":"País"},model:{value:(_vm.form_item.domicilio_institucion_pais_id),callback:function ($$v) {_vm.$set(_vm.form_item, "domicilio_institucion_pais_id", $$v)},expression:"form_item.domicilio_institucion_pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('pais')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Institución o razón social "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_institucion),expression:"info.nombre_institucion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_institucion),expression:"form_item.nombre_institucion"}],staticClass:"form-control",attrs:{"name":"nombre_institucion","type":"text","placeholder":"Nombre de la institución"},domProps:{"value":(_vm.form_item.nombre_institucion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_institucion", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_institucion')))])]),_vm._v(" "),(_vm.form_item.domicilio_institucion_pais_id==150)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC de la institución "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.frc_institucion),expression:"info.frc_institucion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_institucion),expression:"form_item.rfc_institucion"}],staticClass:"form-control",attrs:{"name":"rfc_institucion","type":"text","placeholder":"RFC de la institución"},domProps:{"value":(_vm.form_item.rfc_institucion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_institucion", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_institucion')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(!_vm.edit_item )?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(3)])]),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.titular_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.titular_id,_vm.titular_adeudo)))])]}},{key:"item.tipo_inversion_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.tipo_inversion_id,_vm.inversiones)))])]}}],null,false,3254605959)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("INVERSIONES, CUENTAS BANCARIAS Y OTRO TIPO DE VALORES / ACTIVOS (SITUACIÓN ACTUAL)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de las inversiones, cuentas bancarias y otro tipo de valores / activos a nombre la pareja, dependientes económicos y/o terceros o que sean en copropiedad con el declarante no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Inversiones, cuentas bancarias y otro tipo de valores del declarante, pareja y/o dependientes económicos ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dz4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-5"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 col-md-4 he"},[_vm._v("\n        Inicial\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-4 he"},[_vm._v("\n        Anual\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-4 he"},[_vm._v("\n        Final\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-4 he"},[_vm._t("inicial")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-4 he"},[_vm._t("anual")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-4 he"},[_vm._t("final")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E5Hk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BienesMueblesNR_vue__ = __webpack_require__("4wr1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_081058a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BienesMueblesNR_vue__ = __webpack_require__("Pn1p");
function injectStyle (ssrContext) {
  __webpack_require__("lfMN")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BienesMueblesNR_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_081058a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BienesMueblesNR_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E5OV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");
















__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a),
  props: ["data"],
  data: function data() {
    return {
      movimiento: {},
      options: [{
        id: 1,
        label: "foo"
      }, {
        id: 3,
        label: "bar"
      }, {
        id: 2,
        label: "baz"
      }],
      currentPage: 1,
      perPage: 50,
      rows: null,
      rol: "",
      filter: null,
      id: 1,
      add_item: false,
      edit_item: null,
      tipos: null,
      dependencias: null,
      usuarios: null,
      item_usuarios: {},
      list_usuarios: [],
      expanded: [],
      singleExpand: true,
      headers: [{
        text: 'Acciones',
        value: 'acciones',
        align: 'center'
      }, {
        text: 'Fecha',
        value: 'updated_at ',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombre',
        align: 'center'
      }],
      fields_list: [{
        key: "acciones",
        label: "Acciones",
        thClass: "td-small",
        tdClass: "text-center td-small"
      }, {
        key: "updated_at",
        label: "Fecha",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: function formatter(value) {
          if (value) return __WEBPACK_IMPORTED_MODULE_9_moment___default()(String(value)).format('DD/MM/YYYY');else return '';
        }
      }, {
        key: "rfc",
        label: "RFC",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: "emptyFields"
      }, {
        key: "nombre",
        label: "Nombre",
        tdClass: "text-left",
        formatter: "emptyFields"
      }]
    };
  },

  computed: {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_usuarios.length;
      return this.list_usuarios.length;
    },

    fullName: {
      get: function get() {
        return this.item_usuarios.nombres + " " + this.item_usuarios.primer_apellido + " " + this.item_usuarios.segundo_apellido;
      },
      set: function set(newValue) {
        var m = newValue.match(/(\S*)\s+(.*)/);

        this.nombres = m[1];
        this.primer_apellido = m[2];
        this.segundo_apellido = m[3];
      }
    }
  },
  methods: {
    formato: function formato(fecha) {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(String(value)).format('DD/MM/YYYY');
    },
    returnValueKey: function returnValueKey(v, k) {
      return v;
    },
    initItem: function initItem() {
      this.item_usuarios = {
        acciones: "",
        nombres: "",
        Paterno: "",
        Materno: "",
        User: "",
        Password: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    validar: function validar(item) {
      var _this = this;

      this.Ask("¿Deseas aplicar los cambios?", function () {

        _this.$http.get("solicitudes/aprobar/" + item.id).then(function (response) {
          _this.StepOk("Transferencia aprobada");
          _this.getSolicitudes();
          _this.expanded = [];
        }, function (error) {
          _this.StepError(error);
        });
      });
    },
    rechazar: function rechazar(item) {
      var _this2 = this;

      this.Ask("¿Deseas rechazar los cambios?", function () {
        _this2.$http.get("solicitudes/rechazar/" + item.id).then(function (response) {
          _this2.StepOk("Transferencia rechazada");
          _this2.getSolicitudes();
          _this2.expanded = [];
        }, function (error) {
          _this2.StepError(error);
        });
      });
    },
    getStatus: function getStatus(status) {
      if (status === 0) {
        return "Solicitado";
      }if (status === 2) {
        return "Aprobado";
      } else {
        return "Rechazado";
      }
    },
    getSolicitudes: function getSolicitudes() {
      var _this3 = this;

      this.$http.get("getSolicitudes").then(function (response) {
        var v = _this3;
        _this3.list_usuarios = [];
        $.each(response.data.solicitudes, function (key, value) {
          var dependencia_destino = 'Sin Datos';
          if (value.dependencia_destino) dependencia_destino = value.dependencia_destino.valor;
          v.list_usuarios.push({
            'updated_at': value.updated_at,
            'rfc': value.datos_actuales.rfc,
            'id': value.id,
            'status': value.status,
            'usuario': value.usuario,
            'nombre': value.datos_actuales.nombres + ' ' + value.datos_actuales.primer_apellido + ' ' + value.datos_actuales.segundo_apellido,
            'datos_actuales': {
              'dependencia': value.dependencia_origen.valor,
              'rfc': value.datos_actuales.rfc,
              'curp': value.datos_actuales.curp,
              'nombres': value.datos_actuales.nombres,
              'primer_apellido': value.datos_actuales.primer_apellido,
              'segundo_apellido': value.datos_actuales.segundo_apellido,
              'area_adscripcion': value.datos_actuales.area_adscripcion,
              'correo_laboral': value.datos_actuales.correo_laboral,
              'cargo': value.datos_actuales.empleo_cargo_comision,
              'toma_posesion': value.datos_actuales.fecha_posesion,
              'nivel_encargo': value.datos_actuales.nivel_encargo
            },
            'datos_cambio': {
              'dependencia': dependencia_destino,
              'rfc': value.datos_cambio.rfc,
              'curp': value.datos_cambio.curp,
              'nombres': value.datos_cambio.nombres,
              'primer_apellido': value.datos_cambio.primer_apellido,
              'segundo_apellido': value.datos_cambio.segundo_apellido,
              'area_adscripcion': value.datos_cambio.area_adscripcion,
              'correo_laboral': value.datos_cambio.correo_laboral,
              'cargo': value.datos_cambio.empleo_cargo_comision,
              'toma_posesion': value.datos_cambio.fecha_posesion,
              'nivel_encargo': value.datos_cambio.nivel_encargo

            }
          });
        });
      }, function (error) {
        _this3.Err(error);
      });
    }
  },
  created: function created() {
    this.initItem();
    this.getSolicitudes();
  }
});

/***/ }),

/***/ "ECXt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ETVs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EXM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "EXZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Inversiones_vue__ = __webpack_require__("jEOz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4083c758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Inversiones_vue__ = __webpack_require__("Dyuf");
function injectStyle (ssrContext) {
  __webpack_require__("ZiqW")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Inversiones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4083c758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Inversiones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EY+3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EYv4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rol: null,
      ip_id: null,
      el_archivo: "",
      wizardModel: {},
      fiscal: [],
      obligado: '',
      xlsx: 0,
      currentYear: '',
      add_item: false,
      edit_item: false,
      search: '',
      form_item: {},
      table_list: [],
      headers: [{
        text: 'Año',
        value: 'anio',
        align: 'center',
        class: '',
        width: "200px"
      }, {
        text: 'Documentos',
        align: 'center',
        sortable: false,
        value: 'acciones',
        width: "200px"

      }, {
        text: 'Declaración fiscal',
        value: 'file',
        align: 'center',
        class: ''
      }, {
        text: 'Fecha presentación',
        value: 'fecha',
        align: 'center',
        class: '',
        width: "200px"
      }]
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"]
  },
  computed: {
    fileExist: function fileExist() {
      var _this = this;

      var obj = this.table_list.find(function (o) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(o.created_at, 'YYYY-MM-DD').format('YYYY') === _this.currentYear;
      });
      if (obj) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    descargaFiscal: function descargaFiscal(file) {
      var token = localStorage.getItem('app-token-declaranet');
      var auth = 'Bearer ' + (token ? token : "");

      var url = this.$rootUrl + '/declaraciones_fiscales/' + file;

      window.open(url, '_blank');
    },
    hideButtons: function hideButtons(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD').format('YYYY');
    },

    dateFormat3: function dateFormat3(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
    },
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.edit_item = false;
      this.form_item = {};
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this2 = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          var formData = new FormData();
          formData.append("upload_file", _this2.xlsx);
          _this2.Ask("Esta apunto de subir el Acuse de la presentación de su declaración fiscal, si NO es el archivo correcto, después de subirlo deberá solicitar permiso para cualquier tipo de cambio ¿desea continuar?", function () {
            _this2.$http.post("fiscal", formData).then(function (response) {
              _this2.StepOk("Guardado");
              if (!_this2.edit_item) {
                _this2.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this2.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this2.table_list.splice(index, 1, response.data.response);
              }
              _this2.cancelEdit();
            }, function (error) {
              _this2.Err(error);
            });
          });
        }
      });
    },
    removeItem: function removeItem(item) {
      var _this3 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this3.$http.delete("fiscal/" + item.id).then(function (response) {
            var index = _this3.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this3.table_list.splice(index, 1);
            _this3.StepOk('Registro eliminado');
          }, function (error) {
            _this3.Err(error);
          });
        });
      }
    },
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') == 0)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    addFile: function addFile(tipo) {
      this.xlsx = this.$refs.xlsx.files[0];
    },
    siguente: function siguente() {
      this.$router.push("observaciones");
    }
  },
  created: function created() {
    var _this4 = this;

    this.currentYear = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY');

    this.checkPermissions();
    this.ip_id = this.getId();

    this.status_dec = this.getKey('status_dec');

    this.$http.get("fiscal/" + this.ip_id).then(function (response) {
      _this4.table_list = response.data.files;
    }, function (error) {
      _this4.Err(error);
    });


    this.$http.get("oblfiscal/" + this.ip_id).then(function (response) {
      _this4.obligado = response.data.obligado;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "EdBk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      showForm: false,
      rol: null,
      formItem: {
        periodo: new Date().getFullYear(),
        tipo_dec: 1
      },
      utdeclaraciones: [],
      periodos: [],
      tipo_declaracion: [{
        'id': 1,
        'valor': 'Inicial'
      }, {
        'id': 2,
        'valor': 'Anual'
      }, {
        'id': 3,
        'valor': 'Final'
      }],
      headers: [{
        text: 'Pendiente',
        value: 'pendiente',
        align: 'center'
      }, {
        text: 'Tipo declaración',
        value: 'tipo_dec_id',
        align: 'center'
      }, {
        text: 'Periodo',
        value: 'periodo',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'ente',
        align: 'center'
      }, {
        text: 'Fecha posesión',
        value: 'fecha_posesion',
        align: 'center'
      }, {
        text: 'Fecha término',
        value: 'fecha_termino',
        align: 'center'
      }, {
        text: 'Fecha declaración',
        value: 'fecha_declaracion',
        align: 'center'
      }]
    };
  },

  methods: {
    dateFormat: function dateFormat(date) {
      if (date) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      }
      return '';
    },
    getPeriodos: function getPeriodos() {
      var _this = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        var anios = response.data.periodos;

        anios.forEach(function (y) {
          if (y.year) {
            _this.periodos.push(y);
          }
        });
        _this.formItem.periodo = _this.periodos[0].year;
      }, function (error) {
        _this.StepError(error);
      });
    },
    tipoDecCat: function tipoDecCat(tipo) {
      var t = '';
      switch (tipo) {
        case 1:
          t = 'Inicial';
          break;
        case 2:
          t = 'Anual';
          break;
        case 3:
          t = 'Final';
          break;

      }
      return t;
    },
    save: function save() {
      var _this2 = this;

      this.formItem.ip_id = this.data.id;

      this.$http.post('tipo_dec_agregar', this.formItem).then(function (response) {
        _this2.utdeclaraciones.push(response.data.tipo_dec);
        _this2.showForm = false;
      }, function (error) {
        _this2.Err(error);
      });
    },
    addItem: function addItem() {
      this.showForm = true;
    },
    edit: function edit() {},
    remove: function remove(item) {
      var _this3 = this;

      this.Ask("Desea borrar este registro", function () {
        _this3.$http.delete('tipo_dec_delete/' + item.id).then(function (response) {
          var index = _this3.utdeclaraciones.map(function (u) {
            return u.id;
          }).indexOf(item.id);
          _this3.utdeclaraciones.splice(index, 1);
        }, function (error) {
          _this3.Err(error);
        });
      });
    }
  },
  created: function created() {
    this.rol = this.getKey('role');

    if (this.rol == 1) {
      this.headers.unshift({
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      });
    }
    this.getPeriodos();
    if (this.data) {
      this.utdeclaraciones = this.data.utdeclaraciones;
    }
  }
});

/***/ }),

/***/ "EwoZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ez/C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FGOB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Omisos_vue__ = __webpack_require__("5Lim");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7c1046_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Omisos_vue__ = __webpack_require__("Denf");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Omisos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7c1046_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Omisos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FJKp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿Es beneficiario de algún programa público? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.apoyo),expression:"info.apoyo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Beneficiario de algún programa público "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.beneficiario),expression:"info.beneficiario",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Señalar quien recibe los beneficios "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.beneficiario),expression:"info.beneficiario",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción","name":"participante"},model:{value:(_vm.form_item.beneficiario),callback:function ($$v) {_vm.$set(_vm.form_item, "beneficiario", $$v)},expression:"form_item.beneficiario"}},_vm._l((_vm.beneficiarios),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('participante')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre del programa "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.programa),expression:"info.programa",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.programa),expression:"form_item.programa"}],staticClass:"form-control",attrs:{"type":"text","name":"programa","placeholder":"Nombre del programa"},domProps:{"value":(_vm.form_item.programa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "programa", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('programa')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Institución que otorga el apoyo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.institucion),expression:"info.institucion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.institucion_otorgante),expression:"form_item.institucion_otorgante"}],staticClass:"form-control",attrs:{"type":"text","name":"institucion_otorgante","placeholder":"Institución que otorga el apoyo"},domProps:{"value":(_vm.form_item.institucion_otorgante)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "institucion_otorgante", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('institucion_otorgante')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nivel u orden de Gobierno "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nivel),expression:"info.nivel",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción","filterable":"","name":"nivel_orden_gobierno_id"},model:{value:(_vm.form_item.nivel_orden_gobierno_id),callback:function ($$v) {_vm.$set(_vm.form_item, "nivel_orden_gobierno_id", $$v)},expression:"form_item.nivel_orden_gobierno_id"}},_vm._l((_vm.nivel_gobierno),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nivel_orden_gobierno_id')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Apoyo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo),expression:"info.tipo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"tipo_apoyo_id"},model:{value:(_vm.form_item.tipo_apoyo_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_apoyo_id", $$v)},expression:"form_item.tipo_apoyo_id"}},_vm._l((_vm.tipos_apoyos),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo_apoyo_id')))])],1),_vm._v(" "),( _vm.form_item.tipo_apoyo_id == 4)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especificar_tipo_apoyo),expression:"form_item.especificar_tipo_apoyo"}],staticClass:"form-control",attrs:{"type":"text","name":"especificar","placeholder":"Especificar"},domProps:{"value":(_vm.form_item.especificar_tipo_apoyo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especificar_tipo_apoyo", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especificar')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Forma de recepción del apoyo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.forma),expression:"info.forma",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"forma","label":"1"},model:{value:(_vm.form_item.forma),callback:function ($$v) {_vm.$set(_vm.form_item, "forma", $$v)},expression:"form_item.forma"}},[_vm._v("Monetario")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"forma","label":"2"},model:{value:(_vm.form_item.forma),callback:function ($$v) {_vm.$set(_vm.form_item, "forma", $$v)},expression:"form_item.forma"}},[_vm._v("Especie")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forma')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Monto aproximado del apoyo mensual "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.monto),expression:"info.monto",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-input-number',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:0'),expression:"'required|decimal:0'"}],attrs:{"name":"monto","controls-position":"right","min":0},model:{value:(_vm.form_item.monto),callback:function ($$v) {_vm.$set(_vm.form_item, "monto", $$v)},expression:"form_item.monto"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('monto')))])],1),_vm._v(" "),(_vm.form_item.forma == '2')?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique el apoyol "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.especificar_apoyo),expression:"info.especificar_apoyo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especificar_apoyo),expression:"form_item.especificar_apoyo"}],staticClass:"form-control",attrs:{"type":"text","name":"especificar_apoyo","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especificar_apoyo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especificar_apoyo", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especificar_apoyo')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones/observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones/observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.beneficiario",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterBeneficiario(item.beneficiario)))])]}},{key:"item.nivel_orden_gobierno_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterNivel(item.nivel_orden_gobierno_id)))])]}},{key:"item.tipo_apoyo_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterApoyo(item.tipo_apoyo_id)))])]}},{key:"item.monto",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("$"+_vm._s(_vm._f("currency")(item.monto)))])]}}],null,false,3676392850)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("APOYOS O BENEFICIOS PÚBLICOS (HASTA LOS ÚLTIMOS 2 AÑOS) ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de la participación en alguna institución de la pareja o dependientes económicos no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FP3N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fbn6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "FeKx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BienesInmuebles_vue__ = __webpack_require__("XYFI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e72fa88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BienesInmuebles_vue__ = __webpack_require__("Gn5p");
function injectStyle (ssrContext) {
  __webpack_require__("rhaJ")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BienesInmuebles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e72fa88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BienesInmuebles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G/Yq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tag__);





/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],

  props: {
    value: {
      type: Object,
      default: function _default() {}
    },
    titulo: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    vista: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    popover: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },

  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tag___default.a),
  data: function data() {
    return {
      municipios: {},
      localidades: {},

      lugar: "1"
    };
  },

  watch: {
    lugar: function lugar() {
      if (this.lugar == "1") {
        this.domicilio.pais_id = 150;
      }
    },
    "domicilio.entidadF": function domicilioEntidadF(val) {
      this.municipios = {};
      this.domicilio.municipio = '';

      if (this.domicilio.entidadF) {

        this.getMunicipios();
      }
    },
    "domicilio.municipio": function domicilioMunicipio(val) {
      if (this.domicilio.municipio) {}
    },
    "domicilio.pais_id": function domicilioPais_id(val) {
      if (this.domicilio.pais_id != 150 && this.domicilio.pais_id) {
        this.lugar = "2";
        this.domicilio.municipio = "";
        this.domicilio.entidadF = "";
        this.domicilio.localidad = "";
      } else {
        this.lugar = "1";
      }
    }
  },
  computed: {
    domicilio: {
      get: function get() {
        return this.value ? this.value : {
          type: "Object"
        };
      },
      set: function set(domicilio) {
        this.$emit("input", domicilio);
      }
    }
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getPaises: function getPaises() {},
    getEntidades: function getEntidades() {
      if (this.domicilio.entidadF) {
        this.getMunicipios();
      }
    },
    getMunicipios: function getMunicipios() {
      var _this = this;

      this.municipios = {};
      if (this.domicilio.entidadF) {
        this.$http.get("municipios/" + this.domicilio.entidadF).then(function (response) {
          _this.municipios = response.data.municipios;
          if (_this.domicilio.municipio) {
            _this.getLocalidades();
          }
        }, function (error) {
          _this.StepError(error);
        });
      }
    },
    getLocalidades: function getLocalidades() {}
  },
  created: function created() {
    this.getEntidades();
    if (this.domicilio.pais_id != 150 && this.domicilio.pais_id) {
      this.lugar = "2";
      this.domicilio.municipio = "";
      this.domicilio.entidadF = "";
      this.domicilio.localidad = "";
    }
  },
  mounted: function mounted() {
    this.checkCatalogs();
  }
});

/***/ }),

/***/ "G1un":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Bitácora de consultas Balanza")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                            Desde\n                        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"name":"fecha_inicio","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.model, "fecha_inicio", $$v)},expression:"model.fecha_inicio"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                            Hasta\n                        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"name":"fecha_fin","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_fin),callback:function ($$v) {_vm.$set(_vm.model, "fecha_fin", $$v)},expression:"model.fecha_fin"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success",on:{"click":_vm.getBitacora}},[_vm._v("\n                                Buscar\n                        ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"offset-md-6 col-sm-6 col-md-6 col-lg-6"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.fields_list,"items":_vm.list_bitacora,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"edit mr-2",attrs:{"id":'d'+item.id,"variant":"success","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item)}}},[_c('i',{staticClass:"ti-download"})]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'d'+item.id,"title":"Descargar Declaración"}}),_vm._v(" "),_c('b-button',{staticClass:"edit mr-2",attrs:{"id":'r'+item.id,"variant":"danger","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.reactivar(item)}}},[_c('i',{staticClass:"ti-unlock"})]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'r'+item.id,"title":"Reactivar declaración"}})]}},{key:"item.fecha_declaracion",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat(item.fecha_declaracion)))])]}},{key:"item.fecha",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat(item.fecha)))])]}}])})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GjgZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ "Gju0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿ Tiene adeudos / pasivos? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.adeudos),expression:"info.adeudos",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Titular del adeudo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.titular),expression:"info.titular",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción","name":"titular"},model:{value:(_vm.form_item.titular),callback:function ($$v) {_vm.$set(_vm.form_item, "titular", $$v)},expression:"form_item.titular"}},_vm._l((_vm.titular_adeudo),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('titular')))])],1),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tercero "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tercero),expression:"info.tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"1"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"2"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tercero')))])],1):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre del tercero o terceros "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre),expression:"info.nombre",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_tercero),expression:"form_item.nombre_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.form_item.nombre_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre')))])]):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc),expression:"info.rfc",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13'),expression:"'required|uppercase|max:13'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_tercero),expression:"form_item.rfc_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de adeudo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_adeudo),expression:"info.tipo_adeudo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"tipo_adeudo","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.cat_tipo_adeudo_id),callback:function ($$v) {_vm.$set(_vm.form_item, "cat_tipo_adeudo_id", $$v)},expression:"form_item.cat_tipo_adeudo_id"}},_vm._l((_vm.tipos_adeudos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo_adeudo')))])],1),_vm._v(" "),(_vm.form_item.tipo_adeudo == 6)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique),expression:"form_item.especifique"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Número de identificador deuda o contrato "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.identificador_deuda),expression:"info.identificador_deuda",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.identificador_deuda),expression:"form_item.identificador_deuda"}],staticClass:"form-control",attrs:{"name":"identificador_deuda","type":"text","placeholder":"Número de identificador_deuda o contrato"},domProps:{"value":(_vm.form_item.identificador_deuda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "identificador_deuda", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('identificador_deuda'))+" ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de adquisición del adeudo/pasivo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fecha),expression:"info.fecha",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"fecha","type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.form_item.fecha_adeudo),callback:function ($$v) {_vm.$set(_vm.form_item, "fecha_adeudo", $$v)},expression:"form_item.fecha_adeudo"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('fecha')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6 "},[_c('label',{staticClass:"control-label"},[_vm._v("Monto original del adeudo/pasivo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.monto_original+' '+_vm.info.cat_tipo_moneda_id),expression:"info.monto_original+' '+info.cat_tipo_moneda_id",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"customCurrency"},[_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getVMonto()),expression:"getVMonto()"}],staticClass:"text-right",attrs:{"name":"monto_original","type":"number","min":"0","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)},"blur":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.form_item.monto_original),callback:function ($$v) {_vm.$set(_vm.form_item, "monto_original", $$v)},expression:"form_item.monto_original"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.form_item.cat_tipo_moneda_id),callback:function ($$v) {_vm.$set(_vm.form_item, "cat_tipo_moneda_id", $$v)},expression:"form_item.cat_tipo_moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.form_item.cat_tipo_moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('monto_original')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Saldo insoluto "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.saldo_pendiente),expression:"info.saldo_pendiente",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"customCurrency"},[_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"text-right",attrs:{"name":"saldo_pendiente","type":"number","min":"0","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)},"blur":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.form_item.saldo_pendiente),callback:function ($$v) {_vm.$set(_vm.form_item, "saldo_pendiente", $$v)},expression:"form_item.saldo_pendiente"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.form_item.saldo_cat_tipo_moneda_id),callback:function ($$v) {_vm.$set(_vm.form_item, "saldo_cat_tipo_moneda_id", $$v)},expression:"form_item.saldo_cat_tipo_moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.form_item.saldo_cat_tipo_moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('saldo_pendiente')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Otorgante del crédito "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.otorgante),expression:"info.otorgante",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"otorgante","label":"1"},model:{value:(_vm.form_item.otorgante),callback:function ($$v) {_vm.$set(_vm.form_item, "otorgante", $$v)},expression:"form_item.otorgante"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"otorgante","label":"2"},model:{value:(_vm.form_item.otorgante),callback:function ($$v) {_vm.$set(_vm.form_item, "otorgante", $$v)},expression:"form_item.otorgante"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('otorgante')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre, Institución o razón social (si aplica) "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_acreedor),expression:"info.nombre_acreedor",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_acreedor),expression:"form_item.nombre_acreedor"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_acreedor","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.form_item.nombre_acreedor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_acreedor", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_acreedor')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_acreedor),expression:"info.rfc_acreedor",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:13'),expression:"'required|max:13'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_acreedor),expression:"form_item.rfc_acreedor"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_acreedor","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_acreedor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_acreedor", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_acreedor')))])]),_vm._v(" "),_c('legend',[_vm._v("¿Dónde se localiza el adeudo? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.lugar),expression:"info.lugar",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" País ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"pais","filterable":"","placeholder":"País"},model:{value:(_vm.form_item.domicilio_acreedor_cat_pais_id),callback:function ($$v) {_vm.$set(_vm.form_item, "domicilio_acreedor_cat_pais_id", $$v)},expression:"form_item.domicilio_acreedor_cat_pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('pais')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(!_vm.edit_item )?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(3)])]),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.titular",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.titular,_vm.titular_adeudo)))])]}},{key:"item.cat_tipo_adeudo_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.cat_tipo_adeudo_id,_vm.tipos_adeudos)))])]}},{key:"item.monto_original",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("$"+_vm._s(_vm._f("currency")(item.monto_original)))])]}},{key:"item.saldo_pendiente",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("$"+_vm._s(_vm._f("currency")(item.saldo_pendiente)))])]}}],null,false,2118788271)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12 m-0"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',[_vm._v("ADEUDOS DEL DECLARANTE, CÓNYUGE, CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS (SITUACIÓN ACTUAL)"),_c('br')])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_vm._v(" En el caso de tarjeta de crédito no llenar monto_original original del adeudo y plazo del adeudo. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de los Adeudos / Pasivos a nombre de la pareja o dependientes económicos y/o terceros o que sean en copropiedad con el declarante no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gn5p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("¿ Tiene bienes inmuebles ? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.inmuebles),expression:"info.inmuebles",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Bienes del declarante, pareja y/o dependientes económicos")]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de inmueble "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_bien_id),expression:"info.tipo_bien_id",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"inmueble","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.tipo_bien_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_bien_id", $$v)},expression:"form_item.tipo_bien_id"}},_vm._l((_vm.tipos_inmuebles),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('inmueble')))])],1),_vm._v(" "),(_vm.form_item.tipo_bien_id == 4)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique_inmueble),expression:"form_item.especifique_inmueble"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique_inmueble","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique_inmueble)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique_inmueble", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique_inmueble')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Titular del inmueble "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.titular_id),expression:"info.titular_id",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción","name":"titular_id"},model:{value:(_vm.form_item.titular_id),callback:function ($$v) {_vm.$set(_vm.form_item, "titular_id", $$v)},expression:"form_item.titular_id"}},_vm._l((_vm.titular_adeudo),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('titular_id')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Porcentaje de propiedad del declarante conforme a escrituración o contrato "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.porcentaje_propiedad),expression:"info.porcentaje_propiedad",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-input-number',{directives:[{name:"validate",rawName:"v-validate",value:('required|between:0,100'),expression:"'required|between:0,100'"}],attrs:{"name":"porcentaje_propiedad_propiedad","controls-position":"right","step":5,"min":0,"max":100},model:{value:(_vm.form_item.porcentaje_propiedad),callback:function ($$v) {_vm.$set(_vm.form_item, "porcentaje_propiedad", $$v)},expression:"form_item.porcentaje_propiedad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('porcentaje_propiedad_propiedad')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Superficie del terreno ( m"),_c('sup',[_vm._v("2")]),_vm._v(" ) "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.superficie_terreno),expression:"info.superficie_terreno",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-input-number',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:0'),expression:"'required|decimal:0'"}],attrs:{"name":"superficie_terreno","controls-position":"right","min":0},model:{value:(_vm.form_item.superficie_terreno),callback:function ($$v) {_vm.$set(_vm.form_item, "superficie_terreno", $$v)},expression:"form_item.superficie_terreno"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('superficie_terreno')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Superficie de construcción ( m"),_c('sup',[_vm._v("2")]),_vm._v(" ) "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.superficie_construccion),expression:"info.superficie_construccion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-input-number',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:0'),expression:"'required|decimal:0'"}],attrs:{"name":"superficie_construccion","controls-position":"right","min":0},model:{value:(_vm.form_item.superficie_construccion),callback:function ($$v) {_vm.$set(_vm.form_item, "superficie_construccion", $$v)},expression:"form_item.superficie_construccion"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('superficie_construccion')))])],1),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tercero "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tercero),expression:"info.tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"1"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"2"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tercero')))])],1):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre del tercero o terceros "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_tercero),expression:"info.nombre_tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_tercero),expression:"form_item.nombre_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_tercero","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.form_item.nombre_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_tercero')))])]):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC del tercero "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_tercero),expression:"info.rfc_tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_tercero),expression:"form_item.rfc_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_tercero","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_tercero')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Forma de adquisición "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.forma_adquisicion_id),expression:"info.forma_adquisicion_id",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"forma_adquisicion_id","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.forma_adquisicion_id),callback:function ($$v) {_vm.$set(_vm.form_item, "forma_adquisicion_id", $$v)},expression:"form_item.forma_adquisicion_id"}},_vm._l((_vm.adquisiciones),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forma_adquisicion_id')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Forma de pago "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.forma_pago),expression:"info.forma_pago",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"forma_pago","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.forma_pago),callback:function ($$v) {_vm.$set(_vm.form_item, "forma_pago", $$v)},expression:"form_item.forma_pago"}},_vm._l((_vm.pagos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forma_pago')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Transmisor "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.transmisor),expression:"info.transmisor",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"transmisor","label":"1"},model:{value:(_vm.form_item.transmisor),callback:function ($$v) {_vm.$set(_vm.form_item, "transmisor", $$v)},expression:"form_item.transmisor"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"transmisor","label":"2"},model:{value:(_vm.form_item.transmisor),callback:function ($$v) {_vm.$set(_vm.form_item, "transmisor", $$v)},expression:"form_item.transmisor"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('transmisor')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre del transmisor "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_denominacion_quien_adquirio),expression:"info.nombre_denominacion_quien_adquirio",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_denominacion_quien_adquirio),expression:"form_item.nombre_denominacion_quien_adquirio"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_denominacion_quien_adquirio","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.form_item.nombre_denominacion_quien_adquirio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_denominacion_quien_adquirio", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_denominacion_quien_adquirio')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC del transmisor "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_quien_adquirio),expression:"info.rfc_quien_adquirio",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13'),expression:"'required|uppercase|max:13'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_quien_adquirio),expression:"form_item.rfc_quien_adquirio"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_quien_adquirio","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_quien_adquirio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_quien_adquirio", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_quien_adquirio')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Relación del transmisor de la propiedad con el titular del inmueble "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.relacion),expression:"info.relacion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"relacion","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.relacion_persona_adquirio_id),callback:function ($$v) {_vm.$set(_vm.form_item, "relacion_persona_adquirio_id", $$v)},expression:"form_item.relacion_persona_adquirio_id"}},_vm._l((_vm.transmisores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('relacion')))])],1),_vm._v(" "),(_vm.form_item.relacion_persona_adquirio_id == 20)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.relacion_especificar),expression:"form_item.relacion_especificar"}],staticClass:"form-control",attrs:{"type":"text","name":"relacion_especificar","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.relacion_especificar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "relacion_especificar", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('relacion_especificar')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6 "},[_c('label',{staticClass:"control-label"},[_vm._v("Valor de adquisición "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.valor_adquisicion+' '+_vm.info.tipo_moneda),expression:"info.valor_adquisicion+' '+info.tipo_moneda",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"customCurrency"},[_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"text-right",attrs:{"name":"valor_adquisicion","type":"number","min":"0","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.form_item.precio_adquisicion_valor),callback:function ($$v) {_vm.$set(_vm.form_item, "precio_adquisicion_valor", $$v)},expression:"form_item.precio_adquisicion_valor"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.form_item.precio_adquisicion_moneda_id),callback:function ($$v) {_vm.$set(_vm.form_item, "precio_adquisicion_moneda_id", $$v)},expression:"form_item.precio_adquisicion_moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.form_item.precio_adquisicion_moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('valor_adquisicion')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("¿El valor de adquisición conforme a? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.valor_conforme),expression:"info.valor_conforme",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"valor_conforme","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.valor_conforme),callback:function ($$v) {_vm.$set(_vm.form_item, "valor_conforme", $$v)},expression:"form_item.valor_conforme"}},_vm._l((_vm.valores_inmueble),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('valor_conforme')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de Adquisición del inmueble "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fecha_adquisicion),expression:"info.fecha_adquisicion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],attrs:{"name":"fecha_adquisicion","type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.form_item.fecha_adquisicion),callback:function ($$v) {_vm.$set(_vm.form_item, "fecha_adquisicion", $$v)},expression:"form_item.fecha_adquisicion"}})],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('fecha_adquisicion')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Datos del registro público de la propiedad: Folio real u otro dato que permita su identificación "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.numero_registro_publico),expression:"info.numero_registro_publico",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"},{name:"model",rawName:"v-model",value:(_vm.form_item.numero_registro_publico),expression:"form_item.numero_registro_publico"}],staticClass:"form-control",attrs:{"name":"numero_registro_publico","type":"text","placeholder":"Número de registro público"},domProps:{"value":(_vm.form_item.numero_registro_publico)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "numero_registro_publico", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('numero_registro_publico')))])]),_vm._v(" "),_c('domicilio',{attrs:{"vista":false,"popover":_vm.info.lugar,"titulo":"/ Ubicación del Inmueble"},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("En caso de baja del inmueble incluir motivo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.motivo_baja),expression:"info.motivo_baja",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","name":"motivo_baja","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.motivo_baja),callback:function ($$v) {_vm.$set(_vm.form_item, "motivo_baja", $$v)},expression:"form_item.motivo_baja"}},_vm._l((_vm.bajas_inmueble),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.form_item.motivo_baja == 4)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique_baja),expression:"form_item.especifique_baja"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique_baja","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique_baja)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique_baja", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique_baja')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])],1),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(!_vm.edit_item )?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.titular_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.titular_id,_vm.titular_adeudo)))])]}},{key:"item.tipo_bien_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.tipo_bien_id,_vm.tipos_inmuebles)))])]}}],null,false,3360465824)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("BIENES INMUEBLES (SITUACIÓN ACTUAL) ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de bienes declarados a nombre la pareja, dependientes económicos y/o terceros o que sean en copropiedad con el declarante no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gv4n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H13J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Reporte de Cumplimiento")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 form-group"},[_c('label',[_vm._v("Estatus")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"estatus","placeholder":"Estatus"},model:{value:(_vm.model.estatus),callback:function ($$v) {_vm.$set(_vm.model, "estatus", $$v)},expression:"model.estatus"}},_vm._l((_vm.estatus),function(option){return _c('el-option',{key:option.estatus,staticClass:"select-default",attrs:{"value":option.id,"label":option.estatus}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Declaración ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"declaracion","placeholder":"Declaracion"},model:{value:(_vm.model.tipo_declaracion),callback:function ($$v) {_vm.$set(_vm.model, "tipo_declaracion", $$v)},expression:"model.tipo_declaracion"}},_vm._l((_vm.tiposDeclaracion),function(option){return _c('el-option',{key:option.tipo_declaracion,staticClass:"select-default",attrs:{"value":option.id,"label":option.tipo_declaracion}})}),1)],1),_vm._v(" "),(_vm.getKey('permisos').includes(16))?_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Año")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.model.periodo),callback:function ($$v) {_vm.$set(_vm.model, "periodo", $$v)},expression:"model.periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success pull-right",on:{"click":_vm.getCumplimiento}},[_vm._v("\n        Buscar\n      ")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),(_vm.mostrar)?_c('div',[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title text-center"},[_vm._v("Cumplimiento")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.json_data,"meta":_vm.json_meta,"fields":_vm.json_fields,"worksheet":"My Worksheet","name":"Cumplimiento.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n              Descargar Reporte\n            ")]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Buscar","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('el-table',{staticClass:"table-striped table-responsive",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":"","row-class-name":_vm.tableRowClassName}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"class-name":column.class}})}),1)],1)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HKXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rol: null,
      ip_id: null,
      el_archivo: "",
      wizardModel: {},
      fiscal: [],
      obligado: '',
      xlsx: 0,
      status_dec: 0,
      currentYear: '',
      add_item: false,
      edit_item: false,
      search: '',
      form_item: {},
      table_list: [],
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'eliminar',
        class: ''
      }, {
        text: 'Documentos',
        align: 'center',
        sortable: false,
        value: 'acciones',
        width: "200px"

      }, {
        text: 'Año',
        value: 'anio',
        align: 'center',
        class: '',
        width: "200px"
      }, {
        text: 'Fecha y hora',
        value: 'file',
        align: 'center',
        class: ''
      }]
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"]
  },
  computed: {
    fileExist: function fileExist() {
      var _this = this;

      var obj = this.table_list.find(function (o) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(o.created_at, 'YYYY-MM-DD').format('YYYY') === _this.currentYear;
      });
      if (obj) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    '$route': 'checkP'
  },
  methods: {
    enabledelete: function enabledelete(item) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.created_at, 'YYYY-MM-DD').format('YYYY') === this.currentYear;
    },

    dateFormat: function dateFormat(date) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (date) {
        if (time) {
          return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('DD/MM/YYYY HH:mm:ss');
        } else {
          return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
      }
    },
    descargaAclaracion: function descargaAclaracion(file) {
      var token = localStorage.getItem('app-token-declaranet');
      var auth = 'Bearer ' + (token ? token.hash : "");

      var url = this.$rootUrl + '/declaraciones_aclaraciones/' + file;

      window.open(url, '_blank');
    },
    hideButtons: function hideButtons(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD').format('YYYY');
    },
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.edit_item = false;
      this.form_item = {};
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this2 = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          var formData = new FormData();
          formData.append("upload_file", _this2.xlsx);

          _this2.$http.post("aclaracion", formData).then(function (response) {
            _this2.StepOk("Guardado");
            if (!_this2.edit_item) {
              _this2.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
            } else {
              var index = _this2.table_list.map(function (u) {
                return u.id;
              }).indexOf(response.data.response.id);
              _this2.table_list.splice(index, 1, response.data.response);
            }
            _this2.cancelEdit();
          }, function (error) {
            _this2.Err(error);
          });
        }
      });
    },
    removeItem: function removeItem(item) {
      var _this3 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this3.$http.delete("aclaracion/" + item.id).then(function (response) {
            var index = _this3.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this3.table_list.splice(index, 1);
            _this3.StepOk('Registro eliminado');
          }, function (error) {
            _this3.Err(error);
          });
        });
      }
    },
    checkP: function checkP() {},
    addFile: function addFile(tipo) {
      this.xlsx = this.$refs.xlsx.files[0];
    },
    siguente: function siguente() {
      this.$router.push("observaciones");
    }
  },
  created: function created() {
    var _this4 = this;

    this.currentYear = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY');

    this.checkP();
    this.ip_id = this.getId();
    this.status_dec = this.getKey('status_dec');

    this.$http.get("aclaracion/" + this.ip_id).then(function (response) {
      _this4.table_list = response.data.files;
    }, function (error) {
      _this4.Err(error);
    });
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("N4Wg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_610c0dc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("9NlO");
function injectStyle (ssrContext) {
  __webpack_require__("0MaE")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_610c0dc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HWiE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tipoDec)?_c('div',{staticClass:"row p-1 d-flex justify-content-center text-center tipo-dec"},[_c('b',[_vm._v("Declaración "+_vm._s(_vm.tipoDec?_vm.tipoDec:'')+" / "+_vm._s(_vm.anio? _vm.anio:''))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hg2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hpgc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Lista de Declaraciones")]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.rol!=4)?_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Año")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.model.periodo),callback:function ($$v) {_vm.$set(_vm.model, "periodo", $$v)},expression:"model.periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left"}},[_c('button',{staticClass:"btn btn-fill btn-success ",on:{"click":_vm.getDeclaracionesR}},[_vm._v("\n              Buscar\n            ")])])])]),_vm._v(" "),(_vm.list_cumplimiento.length >0)?_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Resumen de declaraciones")]),_vm._v(" "),_vm._l((_vm.list_cumplimiento),function(e){return _c('div',[_c('p',{staticClass:"datos"},[_c('strong',[_vm._v(_vm._s(e.tipo_declaracion))]),_vm._v(" "+_vm._s(_vm.group1k(e.count)))])])})],2)])]):_c('div',[_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Seleccionar una dependencia y un año")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I3Ow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Realiza actividades economicas ?\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre, denominación o razón social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.nombre_denominacion_razon_social),expression:"item_actividades.nombre_denominacion_razon_social"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre, denominación o razón social de quien se adquirió el inmueble:"},domProps:{"value":(_vm.item_actividades.nombre_denominacion_razon_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "nombre_denominacion_razon_social", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.rfc),expression:"item_actividades.rfc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RFC"},domProps:{"value":(_vm.item_actividades.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "rfc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("CURP (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.curp),expression:"item_actividades.curp"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CURP"},domProps:{"value":(_vm.item_actividades.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "curp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector / Industria (si aplica)")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "sector_industria_id", $$v)},expression:"item_actividades.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de actividad o servicio que produjo el ingreso")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.tipo_actividad_servicio_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "tipo_actividad_servicio_id", $$v)},expression:"item_actividades.tipo_actividad_servicio_id"}},_vm._l((_vm.actividades),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Descripción de la actividad que produce el ingreso")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.descripcion_actividad_servicio),expression:"item_actividades.descripcion_actividad_servicio"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción de la actividad"},domProps:{"value":(_vm.item_actividades.descripcion_actividad_servicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "descripcion_actividad_servicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 customCurrency"},[_c('label',{staticClass:"control-label"},[_vm._v("Ingreso bruto anual recibido por la actividad")]),_vm._v(" "),_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{staticClass:"text-right",attrs:{"type":"number","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.item_actividades.ingreso_bruto_anual),callback:function ($$v) {_vm.$set(_vm.item_actividades, "ingreso_bruto_anual", $$v)},expression:"item_actividades.ingreso_bruto_anual"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.item_actividades.moneda_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "moneda_id", $$v)},expression:"item_actividades.moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.item_actividades.moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Duración o frecuencia ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.duracion_frecuencia),expression:"item_actividades.duracion_frecuencia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Frecuencia"},domProps:{"value":(_vm.item_actividades.duracion_frecuencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "duracion_frecuencia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Unidad temporal")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.unidad_temporal_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "unidad_temporal_id", $$v)},expression:"item_actividades.unidad_temporal_id"}},_vm._l((_vm.plazos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.item_actividades.unidad_temporal_id == 4)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de transacción")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.item_actividades.fecha_transaccion),callback:function ($$v) {_vm.$set(_vm.item_actividades, "fecha_transaccion", $$v)},expression:"item_actividades.fecha_transaccion"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones / Comentarios")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.observaciones),expression:"item_actividades.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Observaciones / Comentarios"},domProps:{"value":(_vm.item_actividades.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":""},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_actividades","responsive":"","hover":"","items":_vm.list_actividades,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.entidad_federativa_id)))]}},{key:"localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.localidad_id))+"\n            ")]}},{key:"municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.municipio_id)))]}},{key:"pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_id)))]}},{key:"sector_industria_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSector(row.item.sector_industria_id)))]}},{key:"tipo_actividad_servicio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getActividad(row.item.tipo_actividad_servicio_id)))]}},{key:"ingreso_bruto_anual",fn:function(row){return [_vm._v(_vm._s((_vm.getSignoDos(row.item.moneda_id)))+"\n              "+_vm._s(_vm._f("currency")(row.item.ingreso_bruto_anual)))]}},{key:"moneda_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getMoneda(row.item.moneda_id)))]}},{key:"unidad_temporal_id",fn:function(row){return [_vm._v(_vm._s(_vm.getUnidades(row.item.unidad_temporal_id)))]}}],null,false,2722672800)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Actividad económica menor")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ID6N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SueldosSalarios_vue__ = __webpack_require__("fLAN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7f6376_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SueldosSalarios_vue__ = __webpack_require__("uZH7");
function injectStyle (ssrContext) {
  __webpack_require__("A/Ac")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SueldosSalarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7f6376_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SueldosSalarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IQfv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_excel_export__ = __webpack_require__("VdFE");














var _components, _methods;








/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), _components),
  data: function data() {
    var _ref;

    return _ref = {
      model: {},
      dependencias: {},
      rol: '',
      filter: null,
      currentPage: 1,
      perPage: 50,
      periodos: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'model', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'rows', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tiposDeclaracion', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'list_bitacora', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'filtro_usuarios', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pagination', {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      total: 0
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'meta', [[{
      'key': 'charset',
      'value': 'utf-8'
    }]]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'faltantes_campos', {
      'Tipo Movimiento': 'movimiento',
      'Fecha Solicitud': 'fecha',
      'Usuario': 'usuario',
      'RFC': 'rfc',
      'CURP': 'curp',
      'Nombre': 'nombre',
      'Dependencia': 'dependencia',
      'Area': 'area',
      'Cargo': 'cargo',
      'Inicio': 'iniio',
      'Termino': 'termino'

    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'movimientos', [{
      value: "1",
      label: "Todos"
    }, {
      value: "0",
      label: "Desactivar servidor"
    }, {
      value: "2",
      label: "Bajas "
    }, {
      value: "4",
      label: "Licencias"
    }, {
      value: "3",
      label: "Promociones"
    }, {
      value: "5",
      label: "Correcciones"
    }, {
      value: "6",
      label: "Cambiar contraseña"
    }, {
      value: "7",
      label: "Eliminar del Padrón"
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'searchQuery', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'headers', [{
      text: 'Tipo Movimiento',
      align: 'center',
      sortable: false,
      value: 'movimiento',
      class: '',
      width: 150
    }, {
      text: 'Fecha de Solicitud',
      value: 'fecha',
      align: 'center'
    }, {
      text: 'Validó',
      value: 'usuario',
      align: 'center'
    }, {
      text: 'RFC',
      value: 'rfc',
      align: 'center'
    }, {
      text: 'CURP',
      value: 'curp',
      align: 'center'
    }, {
      text: 'Servidor Público',
      value: 'nombre',
      align: 'center'
    }, {
      text: 'Dependencia',
      value: 'dependencia',
      align: 'center'
    }, {
      text: 'Área',
      value: 'area',
      align: 'center'
    }, {
      text: 'Cargo',
      value: 'cargo',
      align: 'center'
    }, {
      text: 'Inicio',
      value: 'inicio',
      align: 'center'
    }, {
      text: 'Termino',
      value: 'termino',
      align: 'center'
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fields_list', [{
      key: "movimiento", label: "Tipo Movimiento", thClass: "td-small", tdClass: "text-center td-small" }, {
      key: "fecha", label: "Fecha", thClass: "td-small", tdClass: "text-center td-small"
    }, {
      key: "usuario", label: "Usuario", thClass: "td-small", tdClass: "text-center td-small"
    }, {
      key: "rfc", label: "RFC", thClass: "td-small", tdClass: "text-center td-small"
    }, {
      key: "curp", label: "CURP", thClass: "td-small", tdClass: "text-left td-small"
    }, {
      key: "nombre", label: "Nombre", thClass: "td-small", tdClass: "text-left td-small"
    }, {
      key: "dependencia", label: "Dependencia", thClass: "td-small", tdClass: "text-left td-small"
    }, {
      key: "area", label: "Area", thClass: "td-small", tdClass: "text-left td-small" }, {
      key: "cargo", label: "Cargo", thClass: "td-small", tdClass: "text-left td-small"
    }, {
      key: "inicio", label: "Inicio", thClass: "td-small", tdClass: "text-left td-small"
    }, {
      key: "termino", label: "Termino", thClass: "td-small", tdClass: "text-left td-small"
    }]), _ref;
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_bitacora.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_bitacora.length;
        return this.pagedData;
      }
      var result = this.list_bitacora.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_bitacora.length;

      return this.list_bitacora.length;
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: (_methods = {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [11, 17];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getDependencias: function getDependencias(index) {
      var _this2 = this;

      this.$http.get("cat_ente_publico").then(function (response) {
        _this2.dependencias = response.data.entes_publicos;
      }, function (error) {
        _this2.StepError(error);
        console.log(error);
      });
    },
    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(fecha, 'DD/MM/YYYY').format('DD/MM/YYYY');
    },
    getMovimiento: function getMovimiento(tipo) {
      switch (tipo) {
        case 0:
          return "Desactivar servidor";
          break;
        case 2:
          return "Bajas";
          break;
        case 4:
          return "Licencias";
          break;
        case 3:
          return "Promociones";
          break;
        case 5:
          return "Correccion";
          break;
        case 6:
          return "Cambiar Contraseña";
          break;
        case 7:
          return "Eliminar del Padrón";
          break;

      }
    },
    getBitacora: function getBitacora() {
      var _this3 = this;

      if (!(this.model.tipomov != '' && this.model.dependencia != '' && this.model.fecha_inicio != '' && this.model.fecha_fin)) {
        this.StepW('Llena todos los campos');
        return;
      }

      this.$http.get("movimientos/" + this.model.tipomov + '/' + this.model.dependencia + '/' + this.model.fecha_inicio + '/' + this.model.fecha_fin).then(function (response) {
        var v = _this3;
        v.list_bitacora = [];
        console.log(response.data.movimiento);
        $.each(response.data.movimiento, function (key, value) {
          v.list_bitacora.push({ 'rfc': value.usuarios.rfc,
            'fecha': v.dateFormat(value.created_at),
            'curp': value.usuarios.curp,
            'nombre': value.usuarios.nombres + ' ' + value.usuarios.primer_apellido + ' ' + value.usuarios.segundo_apellido,
            'dependencia': value.encargo.ente.valor,
            'area': value.encargo.area_adscripcion,
            'cargo': value.encargo.empleo_cargo_comision,
            'usuario': value.usuario,
            'movimiento': v.getMovimiento(value.tipo_mov),
            'inicio': v.dateFormat(value.inicia),
            'termino': v.dateFormat(value.termina)
          });
        });
      }, function (error) {
        _this3.StepError(error);
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'dateFormat', function dateFormat(date) {
    return __WEBPACK_IMPORTED_MODULE_15_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'getNombre', function getNombre(usuario) {
    if (usuario) return usuario.Nombre + ' ' + usuario.Paterno + ' ' + usuario.Materno;else return "Sin aprobar";
  }), _methods),
  created: function created() {
    this.rol = this.getKey('role');
    this.checkPermissions();
    this.getDependencias();
    if (!this.getKey('permisos').includes(17)) this.model.dependencia = this.getKey('ente_publico_id');
  }
});

/***/ }),

/***/ "ISTY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_excel_export__ = __webpack_require__("VdFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");





















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_excel_export__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    PPagination: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        periodo: ''
      },
      loading_bar: false,
      dependencias: {},
      rol: '',
      periodos: [],
      dependenciaT: '',
      mostrar: false,
      perPage: 5,
      rows: null,
      currentPage: 1,
      filter: null,
      perPage2: 5,
      rows2: null,
      currentPage2: 1,
      filter2: null,
      tiposDeclaracion: [{
        'id': 1,
        'tipo_declaracion': 'Inicial'
      }, {
        'id': 2,
        'tipo_declaracion': 'Anual'
      }, {
        'id': 3,
        'tipo_declaracion': 'Final'
      }],
      estatus: [{
        'id': 1,
        'estatus': 'Activos'
      }, {
        'id': 2,
        'estatus': 'Bajas'
      }, {
        'id': 3,
        'estatus': 'Todos'
      }],
      tiposReporte: [{
        'id': 1,
        'tipo_reporte': 'Declaraciones Realizadas'
      }, {
        'id': 2,
        'tipo_reporte': 'Declaraciones Faltantes'
      }, {
        'id': 3,
        'tipo_reporte': 'Todos'
      }],
      list_declarantes: [],
      list_declarantes2: [],
      avance: 0,
      avanced: '',
      totald: '',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      pagination2: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      searchQuery2: '',
      cumplidos_campos: {
        'RFC': 'rfc',
        'Nombres': 'nombres',
        'Dependencia': 'dependencia',
        'Àrea': 'area',
        'Cargo': 'cargo',
        'Fecha': 'fecha',
        'Sexo': 'sexo'
      },
      nombreC: '',
      nombreF: '',
      cumplidos_data: [],
      faltantes_campos: {
        'RFC': 'rfc',
        'Nombres': 'nombres',
        'Dependencia': 'dependencia',
        'Àrea': 'area',
        'Cargo': 'cargo',
        'Correo Personal': 'correo1',
        'Correo Laboral': 'correo2',
        'Teléfono Personal': 'tel1',
        'Teléfono Laboral': 'tel2',
        'Fecha Creación': 'fecha1',
        'Fecha Posesión': 'fecha2',
        'Tipo': 'tipo',
        'Sexo': 'sexo'
      },
      faltantes_data: [],
      meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      fecha: '',
      propsToSearch: ['rfc', 'nombres', 'cargo'],
      propsToSearch2: ['rfc', 'nombres', 'cargo', 'correo1', 'correo2', 'tel1', 'tel2'],
      headers: [{
        text: 'RFC',
        align: 'center',
        sortable: false,
        value: 'rfc',
        class: '',
        width: 150
      }, {
        text: 'Nombres',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'dependencia',
        align: 'center'
      }, {
        text: 'Área',
        value: 'area',
        align: 'center'
      }, {
        text: 'Cargo',
        value: 'cargo',
        align: 'center'
      }, {
        text: 'Declaración Fiscal',
        value: 'fiscal',
        align: 'center'
      }, {
        text: 'Declaración de Intereses',
        value: 'intereses',
        align: 'center'
      }, {
        text: 'Fecha de presentación',
        value: 'fecha',
        align: 'center'
      }, {
        text: 'Sexo',
        value: 'sexo',
        align: 'center'
      }],
      fields_list: [{
        key: "rfc",
        label: "RFC",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "nombres",
        label: "Nombres",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "dependencia",
        label: "Dependencia",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "area",
        label: "Àrea",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "cargo",
        label: "Cargo",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "fiscal",
        label: "Declaración Fiscal",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "intereses",
        label: "Declaración de Intereses",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "fecha",
        label: "Fecha",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "sexo",
        label: "Sexo",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }],
      headers2: [{
        text: 'RFC',
        align: 'center',
        sortable: false,
        value: 'rfc',
        class: '',
        width: 150
      }, {
        text: 'Nombres',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'dependencia',
        align: 'center'
      }, {
        text: 'Àrea',
        value: 'area',
        align: 'center'
      }, {
        text: 'Cargo',
        value: 'cargo',
        align: 'center'
      }, {
        text: 'Correo Personal',
        value: 'correo1',
        align: 'center'
      }, {
        text: 'Correo Laboral',
        value: 'correo2',
        align: 'center'
      }, {
        text: 'Tel Personal',
        value: 'tel1',
        align: 'center'
      }, {
        text: 'Tel Laboral',
        value: 'tel2',
        align: 'center'
      }, {
        text: 'Sexo',
        value: 'sexo',
        align: 'center'
      }],
      fields_list2: [{
        key: "rfc",
        label: "RFC",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "nombres",
        label: "Nombres",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "dependencia",
        label: "Dependencia",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "area",
        label: "Área",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "cargo",
        label: "Cargo",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "correo1",
        label: "Correo Personal",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "correo2",
        label: "Correo Laboral",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "tel1",
        label: "Tel Personal",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "tel2",
        label: "Tel Laboral",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }, {
        key: "sexo",
        label: "Sexo",
        tdClass: 'cump text-left',
        thClass: 'cump text-center'
      }]
    };
  },

  computed: {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_declarantes.length;

      return this.list_declarantes.length;
    },
    to2: function to2() {
      var highBound = this.from2 + this.perPage2;
      if (this.total2 < highBound) {
        highBound = this.total2;
      }
      return highBound;
    },
    from2: function from2() {
      return this.perPage2 * (this.currentPage2 - 1);
    },
    total2: function total2() {
      this.rows2 = this.list_declarantes2.length;

      return this.list_declarantes2.length;
    }
  },
  created: function created() {
    this.checkPermissions();
    this.getDependencias();

    this.getPeriodos();
    this.rol = this.getKey('role');
    var myDate = new Date();
    var mes = ('0' + (myDate.getMonth() + 1)).slice(-2);
    var dia = ('0' + myDate.getDate()).slice(-2);
    var anio = myDate.getFullYear();
    this.fecha = dia + '/' + mes + '/' + anio;

    this.nombreC = "Cumplidos" + this.fecha + ".xls";
    this.nombreF = "Faltantes" + this.fecha + ".xls";

    if (!this.getKey('permisos').includes(14)) this.model.dependencia_id = this.getKey('ente_publico_id');
  },
  mounted: function mounted() {},

  watch: {
    '$route': 'checkPermissions',
    'model.dependencia_id': function modelDependencia_id(newValue, oldValue) {
      var _this = this;

      console.log(newValue);
      var dep = this.dependencias.find(function (dep) {
        return dep.id == _this.model.dependencia_id;
      });
      this.dependenciaT = dep.valor ? dep.valor : '';
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered2: function onFiltered2(filteredItems) {
      this.rows2 = filteredItems.length;
      this.currentPage2 = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [10, 14];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getDependencias: function getDependencias() {
      var _this2 = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this2.dependencias = response.data.entes_publicos;
        _this2.dependencias.push({
          'codigo': 'T',
          'id': 0,
          'valor': 'TODAS'
        });
      }, function (error) {
        _this2.StepError(error);
      });
    },

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },

    getPeriodos: function getPeriodos() {
      var _this3 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this3.periodos = response.data.periodos;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    formatTipo: function formatTipo(tipo) {
      if (tipo == 1) return 'Simplificada';else return 'Completa';
    },
    getDeclarantes: function getDeclarantes() {
      var _this4 = this;

      var url = void 0;
      if (this.model.estatus != '' && this.model.tipo_declaracion != '' && this.model.dependencia_id >= 0 && this.model.periodo != '' && this.model.tipo_reporte >= 0) {
        if (this.model.tipo_reporte == 1) {
          if (this.model.estatus == 1) url = "getDeclarantesAct";else if (this.model.estatus == 2) url = "getDeclarantesBj";else url = "getDeclarantes";

          if (this.model.dependencia_id == 'T') url = "getDeclarantesT";

          this.list_declarantes2 = [];
          this.list_declarantes = [];
          this.avance = 0;
          this.avanced = '0';
          this.totald = '0';

          this.loading_bar = true;

          this.$http.post('repdeclarantes', this.model).then(function (response) {
            _this4.avance = Number(response.data.avance.toString().substring(0, 5));

            _this4.avanced = _this4.group1k(response.data.total);

            _this4.totald = _this4.group1k(response.data.porcentaje);

            _this4.mostrar = true;
            var v = _this4;
            v.list_declarantes = [];
            var fiscal = void 0;
            var intereses = void 0;
            $.each(response.data.declarantes, function (key, value) {
              fiscal = 'NO';
              intereses = 'NO';
              if (value.declaracion_fiscal.length > 5) {
                fiscal = 'SI';
              }
              if (value.intereses.length > 5) {
                intereses = 'SI';
              }
              v.list_declarantes.push({
                'rfc': value.rfc,
                'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'dependencia': value.dependencia,
                'area': value.area_adscripcion,
                'cargo': value.empleo_cargo_comision,
                'fiscal': fiscal,
                'intereses': intereses,
                'fecha': v.dateFormat(value.fecha_declaracion),
                'sexo': value.sexo
              });
            });
            _this4.loading_bar = false;
          }, function (error) {
            _this4.StepError(error);
            _this4.loading_bar = false;
          });
        } else if (this.model.tipo_reporte == 2) {
          if (this.model.estatus == 1) url = "getDeclarantesAct";else if (this.model.estatus == 2) url = "getDeclarantesBj";else url = "getDeclarantes";

          if (this.model.dependencia_id == 'T') url = "getDeclarantesT";

          this.list_declarantes2 = [];
          this.list_declarantes = [];
          this.avance = 0;
          this.avanced = '0';
          this.totald = '0';

          this.loading_bar = true;

          this.$http.post('repdeclarantes', this.model).then(function (response) {
            _this4.avance = Number(response.data.avance.toString().substring(0, 5));

            _this4.avanced = _this4.group1k(response.data.total);

            _this4.totald = _this4.group1k(response.data.porcentaje);

            _this4.mostrar = true;
            var v = _this4;
            v.list_declarantes = [];
            v.list_declarantes2 = [];
            $.each(response.data.faltantes, function (key, value) {
              v.list_declarantes2.push({
                'rfc': value.rfc,
                'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'dependencia': value.dependencia,
                'area': value.area_adscripcion,
                'cargo': value.empleo_cargo_comision,
                'correo1': value.correo_electronico_personal || '',
                'correo2': value.correo_electronico_laboral || '',
                'tel1': value.telefono_particular || '',
                'tel2': value.telefono_laboral || '',
                'tipo': v.formatTipo(value.simplificada),
                'fecha1': value.created_at,
                'fecha2': value.fecha_posesion,
                'sexo': value.sexo
              });
            });

            _this4.loading_bar = false;
          }, function (error) {
            _this4.StepError(error);
            _this4.loading_bar = false;
          });
        } else {
          if (this.model.estatus == 1) url = "getDeclarantesAct";else if (this.model.estatus == 2) url = "getDeclarantesBj";else url = "getDeclarantes";

          if (this.model.dependencia_id == 'T') url = "getDeclarantesT";

          this.list_declarantes2 = [];
          this.list_declarantes = [];
          this.avance = 0;
          this.avanced = '0';
          this.totald = '0';

          this.loading_bar = true;

          this.$http.post('repdeclarantes', this.model).then(function (response) {
            _this4.avance = Number(response.data.avance.toString().substring(0, 5));

            _this4.avanced = _this4.group1k(response.data.total);

            _this4.totald = _this4.group1k(response.data.porcentaje);

            _this4.mostrar = true;
            var v = _this4;
            v.list_declarantes = [];
            var fiscal = void 0;
            var intereses = void 0;
            $.each(response.data.declarantes, function (key, value) {
              fiscal = 'NO';
              intereses = 'NO';
              if (value.declaracion_fiscal.length > 5) {
                fiscal = 'SI';
              }
              if (value.intereses.length > 5) {
                intereses = 'SI';
              }
              v.list_declarantes.push({
                'rfc': value.rfc,
                'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'dependencia': value.dependencia,
                'area': value.area_adscripcion,
                'cargo': value.empleo_cargo_comision,
                'fiscal': fiscal,
                'intereses': intereses,
                'fecha': v.dateFormat(value.fecha_declaracion),
                'sexo': value.sexo
              });
            });
            v.list_declarantes2 = [];
            $.each(response.data.faltantes, function (key, value) {
              v.list_declarantes2.push({
                'rfc': value.rfc,
                'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'dependencia': value.dependencia,
                'area': value.area_adscripcion,
                'cargo': value.empleo_cargo_comision,
                'correo1': value.correo_electronico_personal || '',
                'correo2': value.correo_electronico_laboral || '',
                'tel1': value.telefono_particular || '',
                'tel2': value.telefono_laboral || '',
                'tipo': v.formatTipo(value.simplificada),
                'fecha1': value.created_at,
                'fecha2': value.fecha_posesion,
                'sexo': value.sexo
              });
            });

            _this4.loading_bar = false;
          }, function (error) {
            _this4.StepError(error);
            _this4.loading_bar = false;
          });
        }
      } else {
        this.StepW('Llena todos los campos');
        this.loading_bar = false;
      }
    }
  }
});

/***/ }),

/***/ "IY/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienciaLaboral_vue__ = __webpack_require__("wF53");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_196ff716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienciaLaboral_vue__ = __webpack_require__("Lvs1");
function injectStyle (ssrContext) {
  __webpack_require__("wElS")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienciaLaboral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_196ff716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienciaLaboral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ib5s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IeF3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("l+io");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formularios_Personal_DatosPersonales_vue__ = __webpack_require__("iCjR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Formularios_Personal_DatosCurriculares_vue__ = __webpack_require__("miw9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Formularios_Personal_ExperienciaLaboral_vue__ = __webpack_require__("IY/K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Formularios_Personal_EncargoActual_vue__ = __webpack_require__("uFJU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Formularios_Personal_DatosConyuge_vue__ = __webpack_require__("f+wu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {},
      dPersonales: {},
      dCurriculares: {},
      domicilio: {},


      loadingWizard: false
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["TabContent"],
    DatosPersonales: __WEBPACK_IMPORTED_MODULE_3__Formularios_Personal_DatosPersonales_vue__["a" /* default */],
    DatosCurriculares: __WEBPACK_IMPORTED_MODULE_4__Formularios_Personal_DatosCurriculares_vue__["a" /* default */],
    ExperienciaLaboral: __WEBPACK_IMPORTED_MODULE_5__Formularios_Personal_ExperienciaLaboral_vue__["a" /* default */],
    DatosConyuge: __WEBPACK_IMPORTED_MODULE_7__Formularios_Personal_DatosConyuge_vue__["a" /* default */],
    EncargoActual: __WEBPACK_IMPORTED_MODULE_6__Formularios_Personal_EncargoActual_vue__["a" /* default */]
  },
  created: function created() {
    this.checkPermissions();
    this.getKey('email');
  },

  watch: {
    '$route': 'checkPermissions'
  },
  mounted: function mounted() {
    this.$refs.wizard.activateAll();
  },

  methods: {
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },

    setLoading: function setLoading(value) {
      this.loadingWizard = value;
    },
    guardaDatosPersonales: function guardaDatosPersonales() {
      var _this = this;

      this.checkPermissions();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$refs.DatosPersonales.valida().then(function (response) {

          if (response) {
            _this.dPersonales = _this.$refs.DatosPersonales.model;

            _this.$http.put('infpersonal/' + _this.$refs.DatosPersonales.ip_id, _this.dPersonales).then(function (response) {
              _this.StepOk("Guardado");
            }, function (error) {
              _this.StepError(error);
              console.log(error);
            });

            return resolve(true);
          } else return resolve(false);
        });
      });
    },
    guardaDatosCurric: function guardaDatosCurric() {
      var _this2 = this;

      this.checkPermissions();
      this.$refs.DatosCurriculares.validate().then(function (response) {
        if (response) {

          _this2.StepOk("Guardado");
        } else {
          _this2.StepW("Hay campos sin completar");
        }
      });
      return this.$refs.DatosCurriculares.validate();
    },
    guardaExperienciaLaboral: function guardaExperienciaLaboral() {
      var _this3 = this;

      this.checkPermissions();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$refs.ExperienciaLaboral.validate().then(function (response) {
          if (response) {
            return resolve(true);
          } else {
            _this3.StepW("Hay campos sin completar");
            return reject(false);
          }
        }).catch(function (e) {
          reject(false);
        });
      });
    },
    terminaDependientes: function terminaDependientes() {
      var _this4 = this;

      this.checkPermissions();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$refs.DatosConyuge.validate().then(function (response) {
          if (response.every(_this4.isTrue)) {
            _this4.StepOk("Guardado");
            return resolve(true);
          } else {
            console.log(response);
            return reject(false);
          }
        }).catch(function (e) {
          reject(false);
        });
      });
    },
    terminaActual: function terminaActual() {
      var _this5 = this;

      this.checkPermissions();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.$refs.EncargoActual.validate().then(function (response) {
          if (response) {
            _this5.$http.put('encargoAct/' + _this5.$refs.EncargoActual.ip_id, _this5.$refs.EncargoActual.model).then(function (response) {
              if (_this5.$refs.EncargoActual.bandera == '1') {
                _this5.$http.put('otroEncargo/' + _this5.$refs.EncargoActual.ip_id, _this5.$refs.EncargoActual.model2).then(function (response) {
                  _this5.StepOk("Guardado");

                  _this5.$router.push('intereses');
                }, function (error) {
                  _this5.StepError(error);
                  console.log(error);
                });
              } else {
                _this5.$http.delete('otroEncargo/' + _this5.$refs.EncargoActual.ip_id).then(function (response) {
                  _this5.StepOk("Guardado");

                  _this5.$router.push('intereses');
                }, function (error) {
                  _this5.StepError(error);
                  console.log(error);
                });
              }
            }, function (error) {
              _this5.StepError(error);
              console.log(error);
            });
          } else {
            _this5.StepW("Hay campos sin completar");
            return reject(false);
          }
        }).catch(function (e) {
          reject(false);
        });
      });
    },
    isTrue: function isTrue(currentValue) {
      return currentValue;
    }
  }

});

/***/ }),

/***/ "IjRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_vm._v("Todos los datos relativos a dependendientes económicos (menores de edad, cónyugue, concubina, concubinario, etc) no seran públicos. ")]),_vm._v(" "),(_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Nombre(s)\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.nombres),expression:"model.nombres"}],staticClass:"form-control",attrs:{"type":"text","name":"nombres","placeholder":"Nombre(s)"},domProps:{"value":(_vm.model.nombres)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nombres", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('nombres'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Primer apellido\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.primer_apellido),expression:"model.primer_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"primer_apellido","placeholder":"Primer apellido"},domProps:{"value":(_vm.model.primer_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "primer_apellido", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('primer_apellido'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Segundo apellido\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.segundo_apellido),expression:"model.segundo_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"segundo_apellido","placeholder":"Segundo apellido"},domProps:{"value":(_vm.model.segundo_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "segundo_apellido", $event.target.value)}}})]),_vm._v(" "),(_vm.muestraCampos)?_c('div',{staticClass:"col-md-2 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Fecha de Nacimiento\n        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","name":"fecha_posesion","picker-options":_vm.opciones,"type":"date","placeholder":"Selecciona"},model:{value:(_vm.model.fecha_nacimiento),callback:function ($$v) {_vm.$set(_vm.model, "fecha_nacimiento", $$v)},expression:"model.fecha_nacimiento"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('fechanac'))+"\n          ")])],1)]):_vm._e(),_vm._v(" "),(_vm.muestraCampos)?_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            RFC:\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.rfc),expression:"model.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.model.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('rfc'))+"\n          ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Relación con el declarante\n        ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Tipo de relación","name":"tipo_relacion","filterable":""},model:{value:(_vm.model.tipo_relacion_dep_id),callback:function ($$v) {_vm.$set(_vm.model, "tipo_relacion_dep_id", $$v)},expression:"model.tipo_relacion_dep_id"}},_vm._l((_vm.tiposRelacion),function(option){return _c('el-option',{key:option.codigo,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('tipo_relacion'))+"\n        ")])],1),_vm._v(" "),(_vm.model.tipo_relacion_dep_id ==5)?_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Tipo de Relación\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.otra_relacion),expression:"model.otra_relacion"}],staticClass:"form-control",attrs:{"type":"text","name":"tipoRelacion","placeholder":"Otra Relación"},domProps:{"value":(_vm.model.otra_relacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "otra_relacion", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Nacionalidad\n        ")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","multiple":"","placeholder":"Nacionalidades","filterable":""},model:{value:(_vm.model.nac),callback:function ($$v) {_vm.$set(_vm.model, "nac", $$v)},expression:"model.nac"}},_vm._l((_vm.paisesnac),function(option){return _c('el-option',{key:option.id,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            CURP\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.curp),expression:"model.curp"}],staticClass:"form-control",attrs:{"type":"text","name":"curp","placeholder":"CURP"},domProps:{"value":(_vm.model.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "curp", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('curp'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            ¿Es dependiente económico?\n          ")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"ingresos_propios","inline":true,"label":"1"},model:{value:(_vm.model.ingresos_propios),callback:function ($$v) {_vm.$set(_vm.model, "ingresos_propios", $$v)},expression:"model.ingresos_propios"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"ingresos_propios","inline":true,"label":"2"},model:{value:(_vm.model.ingresos_propios),callback:function ($$v) {_vm.$set(_vm.model, "ingresos_propios", $$v)},expression:"model.ingresos_propios"}},[_vm._v("NO")])],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('ingresos_propios'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            ¿Habita en el domicilio del declarante?\n          ")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"habita_domicilio_declarante","inline":true,"label":"1"},model:{value:(_vm.model.habita_domicilio_declarante),callback:function ($$v) {_vm.$set(_vm.model, "habita_domicilio_declarante", $$v)},expression:"model.habita_domicilio_declarante"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"habita_domicilio_declarante","inline":true,"label":"2"},model:{value:(_vm.model.habita_domicilio_declarante),callback:function ($$v) {_vm.$set(_vm.model, "habita_domicilio_declarante", $$v)},expression:"model.habita_domicilio_declarante"}},[_vm._v("NO")])],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('habita_domicilio_declarante'))+"\n        ")])])]),_vm._v(" "),(_vm.model.habita_domicilio_declarante == 2)?_c('div',[_c('domicilio',{ref:"Domicilio",attrs:{"titulo":" del Conyuge/ Dependiente"},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}})],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"cass":"col-md-4"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Actividad laboral")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","width":"100%","name":"ambitoexp","placeholder":"Ámbitos"},model:{value:(_vm.model.ambito_id),callback:function ($$v) {_vm.$set(_vm.model, "ambito_id", $$v)},expression:"model.ambito_id"}},_vm._l((_vm.ambitos),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('ambitoexp'))+"\n          ")])],1)]),_vm._v(" "),(_vm.model.ambito_id == 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Nivel/Orden de Gobierno ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Nivel"},model:{value:(_vm.model.nivel_gobierno_id),callback:function ($$v) {_vm.$set(_vm.model, "nivel_gobierno_id", $$v)},expression:"model.nivel_gobierno_id"}},_vm._l((_vm.niveles),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Ambito público\n            ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Poder"},model:{value:(_vm.model.poder_ente_id),callback:function ($$v) {_vm.$set(_vm.model, "poder_ente_id", $$v)},expression:"model.poder_ente_id"}},_vm._l((_vm.poderes),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre del ente público")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nombre_dependencia),expression:"model.nombre_dependencia"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_dependencia","placeholder":"Nombre del ente público"},domProps:{"value":(_vm.model.nombre_dependencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nombre_dependencia", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('nombre_dependencia'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Área de adscripción")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.area_adscripcion),expression:"model.area_adscripcion"}],staticClass:"form-control",attrs:{"type":"text","name":"area_adscripcion","placeholder":"Área de adscripción"},domProps:{"value":(_vm.model.area_adscripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "area_adscripcion", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('area_adscripcion'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Empleo, cargo o comisión")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.empleo_cargo_comision),expression:"model.empleo_cargo_comision"}],staticClass:"form-control",attrs:{"type":"text","name":"empleo_cargo_comision","placeholder":"Empleo, cargo o comisión"},domProps:{"value":(_vm.model.empleo_cargo_comision)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "empleo_cargo_comision", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('empleo_cargo_comision'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique función principal")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.funcion_principal),expression:"model.funcion_principal"}],staticClass:"form-control",attrs:{"type":"text","name":"funcion_principal","placeholder":"Especifique función principal"},domProps:{"value":(_vm.model.funcion_principal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "funcion_principal", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('funcion_principal'))+"\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.model.ambito_id != 4)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre de la empresa, sociedad o asociación")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nombre_empresa),expression:"model.nombre_empresa"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_empresa","placeholder":"Nombre de la empresa, sociedad o asociación"},domProps:{"value":(_vm.model.nombre_empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nombre_empresa", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('nombre_empresa'))+"\n            ")])]),_vm._v(" "),(_vm.muestraCampos)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              RFC:\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.rfcempresa),expression:"model.rfcempresa"}],staticClass:"form-control",attrs:{"type":"text","name":"rfcempresa","placeholder":"RFC"},domProps:{"value":(_vm.model.rfcempresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "rfcempresa", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('rfcempresa'))+"\n            ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Empleo cargo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.empleo_cargo),expression:"model.empleo_cargo"}],staticClass:"form-control",attrs:{"type":"text","name":"empleo_cargo","placeholder":"Empleo cargo"},domProps:{"value":(_vm.model.empleo_cargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "empleo_cargo", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('empleo_cargo'))+"\n            ")])])])]):_vm._e(),_vm._v(" "),(_vm.model.ambito_id != 4)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Salario mensual neto")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.salario_mensual),expression:"model.salario_mensual"}],staticClass:"form-control",attrs:{"type":"number","name":"salario_mensual","placeholder":"Salario mensual neto"},domProps:{"value":(_vm.model.salario_mensual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "salario_mensual", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('salario_mensual'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Fecha de ingreso al empleo\n          ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","name":"fecha_posesion","picker-options":_vm.opciones,"type":"date","placeholder":"Selecciona"},model:{value:(_vm.model.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.model, "fecha_inicio", $$v)},expression:"model.fecha_inicio"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('fecha_inicio'))+"\n            ")])],1)])]):_vm._e(),_vm._v(" "),(_vm.model.ambito_id != 4)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group  d-inline-block"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          ¿Es proveedor o contratista de gobierno?\n        ")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"proveedor","inline":true,"label":"1"},model:{value:(_vm.model.proveedor_contratista_gobierno),callback:function ($$v) {_vm.$set(_vm.model, "proveedor_contratista_gobierno", $$v)},expression:"model.proveedor_contratista_gobierno"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"proveedor","inline":true,"label":"2"},model:{value:(_vm.model.proveedor_contratista_gobierno),callback:function ($$v) {_vm.$set(_vm.model, "proveedor_contratista_gobierno", $$v)},expression:"model.proveedor_contratista_gobierno"}},[_vm._v("NO")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('proveedor'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Sectora al que pertenece:\n        ")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Sector","filterable":""},model:{value:(_vm.model.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.model, "sector_industria_id", $$v)},expression:"model.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.muestraCampos)?_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n         Aclaraciones / observaciones\n        ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.observaciones),expression:"model.observaciones"}],staticClass:"form-control",attrs:{"type":"text","name":"observaciones","placeholder":"Aclaraciones / observaciones"},domProps:{"value":(_vm.model.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "observaciones", $event.target.value)}}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[_vm._m(1)]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])])]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"id":"tbl_exp","responsive":"","hover":"","items":_vm.list_dependientes,"items-per-page":5,"headers":_vm.headers,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.tipo_relacion_dep_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getTipoRel(item.tipo_relacion_dep_id)))])]}},{key:"item.nombres",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getNombre(item)))])]}}],null,false,2499141610)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('legend',[_vm._v("Datos del cónyuge, concubina, concubinario y/o dependientes económicos"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ikxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿Actúa a nombre de otra persona física o moral como representante? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.representacion),expression:"info.representacion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Datos de la representación")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Señalar quien tiene la representación "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.representante),expression:"info.representante",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"representante","label":"1"},model:{value:(_vm.form_item.representante),callback:function ($$v) {_vm.$set(_vm.form_item, "representante", $$v)},expression:"form_item.representante"}},[_vm._v("Declarante")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"representante","label":"2"},model:{value:(_vm.form_item.representante),callback:function ($$v) {_vm.$set(_vm.form_item, "representante", $$v)},expression:"form_item.representante"}},[_vm._v("Pareja")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"representante","label":"3"},model:{value:(_vm.form_item.representante),callback:function ($$v) {_vm.$set(_vm.form_item, "representante", $$v)},expression:"form_item.representante"}},[_vm._v("Dependiente Económico")])],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('representante')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de representación "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo),expression:"info.tipo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tipo","label":"1"},model:{value:(_vm.form_item.tipo_representacion_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_representacion_id", $$v)},expression:"form_item.tipo_representacion_id"}},[_vm._v("Representante")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tipo","label":"2"},model:{value:(_vm.form_item.tipo_representacion_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_representacion_id", $$v)},expression:"form_item.tipo_representacion_id"}},[_vm._v("Representado")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])],1),_vm._v(" "),(_vm.form_item.tipo_representacion_id == 5)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique),expression:"form_item.especifique"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de inicio de la representación "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fecha),expression:"info.fecha",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"fecha","type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.form_item.fecha),callback:function ($$v) {_vm.$set(_vm.form_item, "fecha", $$v)},expression:"form_item.fecha"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('fecha')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre de la parte representada "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre),expression:"info.nombre",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre),expression:"form_item.nombre"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre","placeholder":"Nombre de la parte representada"},domProps:{"value":(_vm.form_item.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc),expression:"info.rfc",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc),expression:"form_item.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc')))]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.validaciones.rfc),expression:"validaciones.rfc"}],staticClass:"text-danger"},[_vm._v(" El formato de la CURP no es válido, verifica la información ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Representante / Representado "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.representado),expression:"info.representado",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"representado","label":"1"},model:{value:(_vm.form_item.representado),callback:function ($$v) {_vm.$set(_vm.form_item, "representado", $$v)},expression:"form_item.representado"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"representado","label":"2"},model:{value:(_vm.form_item.representado),callback:function ($$v) {_vm.$set(_vm.form_item, "representado", $$v)},expression:"form_item.representado"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('representado')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿Recibe remuneración por su representación? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.remunerado),expression:"info.remunerado",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"remuneracion","label":"1"},model:{value:(_vm.form_item.remuneracion),callback:function ($$v) {_vm.$set(_vm.form_item, "remuneracion", $$v)},expression:"form_item.remuneracion"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"remuneracion","label":"2"},model:{value:(_vm.form_item.remuneracion),callback:function ($$v) {_vm.$set(_vm.form_item, "remuneracion", $$v)},expression:"form_item.remuneracion"}},[_vm._v("NO")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('remuneracion')))])],1),_vm._v(" "),(_vm.form_item.remuneracion=='1')?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Monto mensual neto de su representación "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.monto),expression:"info.monto",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-input-number',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:0'),expression:"'required|decimal:0'"}],attrs:{"name":"monto","controls-position":"right","min":0},model:{value:(_vm.form_item.monto),callback:function ($$v) {_vm.$set(_vm.form_item, "monto", $$v)},expression:"form_item.monto"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('monto')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector productivo al que pertenece")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"sector","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.form_item, "sector_industria_id", $$v)},expression:"form_item.sector_industria_id"}},_vm._l((_vm.sectores_industria),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('sector')))])],1),_vm._v(" "),_c('legend',[_vm._v("Lugar donde se ubica "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.lugar),expression:"info.lugar",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" País ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"pais","filterable":"","placeholder":"País"},model:{value:(_vm.form_item.pais_id),callback:function ($$v) {_vm.$set(_vm.form_item, "pais_id", $$v)},expression:"form_item.pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('pais')))])],1),_vm._v(" "),(_vm.form_item.pais_id==150)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" Entidad Federativa ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"entidad","filterable":"","placeholder":"Entidad"},model:{value:(_vm.form_item.entidad_federativa_id),callback:function ($$v) {_vm.$set(_vm.form_item, "entidad_federativa_id", $$v)},expression:"form_item.entidad_federativa_id"}},_vm._l((_vm.entidades),function(option){return _c('el-option',{key:option.nom_ent,staticClass:"select-default",attrs:{"value":option.id,"label":option.nom_ent}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('entidad')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.representante",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterDeclarante(item.representante)))])]}},{key:"item.tipo_representacion_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipoRepresentante(item.tipo_representacion_id)))])]}},{key:"item.representado",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipoPersona(item.representado)))])]}},{key:"item.remuneracion",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterBool(item.remuneracion)))])]}},{key:"item.sector_industria_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterSector(item.sector_industria_id)))])]}},{key:"item.monto",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("$"+_vm._s(_vm._f("currency")(item.monto)))])]}}],null,false,1611084185)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("REPRESENTACIÓN (HASTA LOS ÚLTIMOS 2 AÑOS) ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de la representación de la pareja o dependientes económicos no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J373":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JD1w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JK9A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JLF3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SolTransferencias_vue__ = __webpack_require__("Tn5V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c6d50d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SolTransferencias_vue__ = __webpack_require__("CNTz");
function injectStyle (ssrContext) {
  __webpack_require__("Ib5s")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SolTransferencias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c6d50d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SolTransferencias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JOhr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      ip_id: null,
      add_item: false,
      edit_item: null,
      tipo: '',
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,
      tipoinst: [],
      tipobienen: [],

      plazos: [],
      actividades: [],
      sectores: null,
      n_domicilio: null,

      entidadFed: null,
      municipios: null,
      localidades: null,
      localidad: null,

      isnum: null,
      suma3: 0,

      plantilla: {
        ingreso_anual_neto: ""
      },
      item_entes22: {
        ant_suma_12: 0,
        ant_actividad_comercial_cantidad: 0,
        ant_actividad_financiera_cantidad: 0,
        ant_servicios_profecionales_cantidad: 0,
        ant_arrendamientos_cantidad: 0,
        ant_ingreso_anual_cantidad: 0,
        ant_ingreso_anual_conyugue_cantidad: 0,
        ant_neto_conyugue_cantidad: 0,
        acciones: "",
        bandera: '0',
        rfc_quien_adquirio: "",
        ingreso_bruto_anual: "",
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: "",
        entidad_federativa_id: "",
        municipio_id: "",
        localidad_id: "",
        colonia: "",
        cp: "",
        numExt: "",
        numInt: "",
        vialidad_nom_vial: "",
        vialidad_tipo_vial: "",
        observaciones: ""
      },
      list_entes: [],
      fields_list: [{
        key: "acciones",
        label: "Acciones",
        tdClass: "text-center"
      }, {
        key: "nombre_denominacion_razon_social",
        label: "Denominación o razón social",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "rfc",
        label: "RFC",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "curp",
        label: "CURP",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "sector_industria_id",
        label: "Sector",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "tipo_actividad_servicio_id",
        label: "Tipo de actividad ",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "descripcion_actividad_servicio",
        label: "Descripción de la actividad",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "ingreso_bruto_anual",
        label: "Ingreso bruto anual ",
        tdClass: "text-right",
        formatter: 'emptyFields'
      }, {
        key: "moneda_id",
        label: "Moneda",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "duracion_frecuencia",
        label: "Duración / Frecuencia",
        tdClass: "text-center",
        formatter: 'emptyFields'
      }, {
        key: "unidad_temporal_id",
        label: "Unidad temporal",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "fecha_transaccion",
        label: "Fecha de transacción",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "observaciones",
        label: "Observaciones",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "pais_id",
        label: "País",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "entidad_federativa_id",
        label: "Entidad federativa",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "municipio_id",
        label: "Municipio",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "localidad_id",
        label: "Localidad",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "colonia",
        label: "Colonia",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "vialidad_tipo_vial",
        label: "Tipo vialidad",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "vialidad_nom_vial",
        label: "Nombre vialidad",
        tdClass: "text-left",
        formatter: 'emptyFields'
      }, {
        key: "cp",
        label: "CP",
        tdClass: "text-right",
        formatter: 'emptyFields'
      }, {
        key: "numExt",
        label: "Número exterior",
        tdClass: "text-right",
        formatter: 'emptyFields'
      }, {
        key: "numInt",
        label: "Número interior",
        tdClass: "text-right",
        formatter: 'emptyFields'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vee_validate__["c" /* mapFields */])(['ant_sub_12']), {
    calculo1: function calculo1() {

      var a = parseInt(this.item_entes22.ant_sub_12);
      var b = parseInt(this.item_entes22.ant_actividad_comercial_cantidad);
      var c = parseInt(this.item_entes22.ant_actividad_financiera_cantidad);
      var d = parseInt(this.item_entes22.ant_servicios_profecionales_cantidad);
      var e = parseInt(this.item_entes22.ant_arrendamientos_cantidad);
      var g = parseInt(this.item_entes22.ant_otros_cantidad);

      var suma = b + c + d + e + g;

      if (isNaN(suma)) {
        return 0;
      }
      return suma;
    },
    calculo2: function calculo2() {
      var a = parseInt(this.item_entes22.ant_sub_12);
      var b = parseInt(this.item_entes22.ant_actividad_comercial_cantidad);
      var c = parseInt(this.item_entes22.ant_actividad_financiera_cantidad);
      var d = parseInt(this.item_entes22.ant_servicios_profecionales_cantidad);
      var e = parseInt(this.item_entes22.ant_arrendamientos_cantidad);
      var g = parseInt(this.item_entes22.ant_otros_cantidad);

      var suma = a + b + c + d + e + g;

      if (isNaN(suma)) {
        return 0;
      }
      return suma;
    },
    calculo3: function calculo3() {
      var suma = 0;

      var a = parseInt(this.item_entes22.ant_sub_12);
      if (isNaN(a)) {
        a = 0;
      }
      var b = parseInt(this.item_entes22.ant_actividad_comercial_cantidad);
      if (isNaN(b)) {
        b = 0;
      }
      var c = parseInt(this.item_entes22.ant_actividad_financiera_cantidad);
      if (isNaN(c)) {
        c = 0;
      }
      var d = parseInt(this.item_entes22.ant_servicios_profecionales_cantidad);
      if (isNaN(d)) {
        d = 0;
      }
      var e = parseInt(this.item_entes22.ant_arrendamientos_cantidad);
      if (isNaN(e)) {
        e = 0;
      }
      var f = parseInt(this.item_entes22.ant_neto_conyugue_cantidad);
      if (isNaN(f)) {
        f = 0;
      }
      var g = parseInt(this.item_entes22.ant_otros_cantidad);
      if (isNaN(g)) {
        g = 0;
      }

      suma = a + b + c + d + e + f + g;

      if (isNaN(suma)) {
        return 0;
      }

      return suma;
    },
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.item_entes22.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.item_entes22.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  }),
  watch: {

    list_entes: {
      handler: function handler() {
        if (this.list_entes) {
          this.setLocalidades();
        }
      },
      deep: true
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_entes22.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_entes22.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_entes22.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_entes22.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_entes22.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_entes22.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_entes22.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_entes22.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_entes22.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_entes22.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    },
    'item_entes22.ant_sub_12': function item_entes22Ant_sub_12() {
      this.calcula_totales2();
    },
    'item_entes22.ant_actividad_comercial_cantidad': function item_entes22Ant_actividad_comercial_cantidad() {
      this.calcula_totales2();
    },
    'item_entes22.ant_actividad_financiera_cantidad': function item_entes22Ant_actividad_financiera_cantidad() {
      this.calcula_totales2();
    },
    'item_entes22.ant_servicios_profecionales_cantidad': function item_entes22Ant_servicios_profecionales_cantidad() {
      this.calcula_totales2();
    },
    'item_entes22.ant_arrendamientos_cantidad': function item_entes22Ant_arrendamientos_cantidad() {
      this.calcula_totales2();
    },
    'item_entes22.ant_neto_declarante': function item_entes22Ant_neto_declarante() {
      this.calcula_totales2();
    },
    'item_entes22.ant_neto_conyugue_cantidad': function item_entes22Ant_neto_conyugue_cantidad() {
      this.calcula_totales2();
    }
  },
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    calcula_totales2: function calcula_totales2(evt) {
      var sub12 = 0;
      var sub22 = 0;
      var unoydos2 = 0;
      var segundasuma22 = 0;

      sub12 = parseInt(this.item_entes22.ant_sub_12);
      sub22 = parseInt(this.item_entes22.ant_actividad_comercial_cantidad) + parseInt(this.item_entes22.ant_actividad_financiera_cantidad) + parseInt(this.item_entes22.ant_servicios_profecionales_cantidad) + parseInt(this.item_entes22.ant_arrendamientos_cantidad);
      unoydos2 = parseInt(sub12) + parseInt(sub22);
      this.item_entes22.ant_sub_22 = sub22;
      this.item_entes22.ant_suma_12 = unoydos2;
      this.suma3 = unoydos2;

      segundasuma22 = parseInt(this.item_entes22.ant_neto_declarante) + parseInt(this.item_entes22.ant_neto_conyugue_cantidad);
      this.item_entes22.ant_suma_32 = segundasuma22;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getTipoInstrumento: function getTipoInstrumento() {
      var resp = " ";
      if (this.tipoinst) {
        this.tipoinst.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {},
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem55: function addItem55() {
      var _this = this;

      if (this.item_entes22) {
        this.item_entes22.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post("sueldos_otros", this.item_entes22).then(function (response) {
          _this.StepOk("Guardado");
          if (_this.edit_item === undefined || _this.edit_item === null) {
            _this.item_entes22 = response.data.sueldos;
          } else {
            _this.list_entes.splice(_this.edit_item.index, 1, _this.item_entes22);
            _this.edit_item.item._rowVariant = "";
          }
          _this.showItem();
          _this.initItem();
          _this.edit_item = null;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW("Hay campos sin completar");
      }
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_entes22 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_entes[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_entes[indice].id !== null) {
        var item = this.list_entes[indice];

        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("sueldos_otros/" + item.id).then(function (response) {
            _this2.list_entes.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_entes22.pais_id ? this.item_entes22.pais_id : 150;
      this.n_domicilio.entidadF = this.item_entes22.entidad_federativa_id ? this.item_entes22.entidad_federativa_id : '';
      this.n_domicilio.municipio = this.item_entes22.municipio_id ? this.item_entes22.municipio_id : '';
      this.n_domicilio.localidad = this.item_entes22.localidad_id ? this.item_entes22.localidad_id : '';
      this.n_domicilio.cp = this.item_entes22.cp ? this.item_entes22.cp : '';
      this.n_domicilio.colonia = this.item_entes22.colonia ? this.item_entes22.colonia : '';
      this.n_domicilio.vialidad = this.item_entes22.vialidad_tipo_vial ? this.item_entes22.vialidad_tipo_vial : '';
      this.n_domicilio.vialidad_nombre = this.item_entes22.vialidad_nom_vial ? this.item_entes22.vialidad_nom_vial : '';
      this.n_domicilio.ext = this.item_entes22.numExt ? this.item_entes22.numExt : '';
      this.n_domicilio.int = this.item_entes22.numInt ? this.item_entes22.numInt : '';
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      this.list_entes.forEach(function (item) {
        if (item.localidad_id) {
          _this3.$http.get('localidades/localidad/' + item.localidad_id).then(function (response) {
            _this3.localidades.push(response.data.localidad);
          }, function (error) {
            _this3.Err(error);
          });
        }
      });
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  },
  created: function created() {
    var _this4 = this;

    this.tipo = this.getKey('tipo_dec');
    this.ip_id = this.getId();
    this.initItem();

    this.$http.get("sueldos_otros/" + this.ip_id).then(function (response) {
      if (response.data.respuesta.sueldos != null) {
        _this4.item_entes22 = response.data.respuesta.sueldos;
        _this4.plantilla = response.data.respuesta.plantilla;
        console.log(response.data.respuesta);

        if (Number(_this4.item_entes22.ant_sub_12) > 0) {
          _this4.item_entes22.bandera = '1';
        }
      }
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });

    this.$http.get("cat_unidad_medida_plazo").then(function (response) {
      _this4.plazos = response.data.unidades;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_actividad").then(function (response) {
      _this4.actividades = response.data.actividad;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_instrumentos").then(function (response) {
      _this4.tipoinst = response.data.instrumentos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_bien_enajenacion").then(function (response) {
      _this4.tipobienen = response.data.bienes;
    }, function (error) {
      _this4.Err(error);
    });

    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
  },

  filters: {
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
});

/***/ }),

/***/ "JTc9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JXfo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JYw5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JZbM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Cumplimiento2_vue__ = __webpack_require__("4SKm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5abf64d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Cumplimiento2_vue__ = __webpack_require__("VK88");
function injectStyle (ssrContext) {
  __webpack_require__("/5hs")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Cumplimiento2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5abf64d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Cumplimiento2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jh78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Historico_vue__ = __webpack_require__("+vyg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e3dccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Historico_vue__ = __webpack_require__("PWlT");
function injectStyle (ssrContext) {
  __webpack_require__("FP3N")
  __webpack_require__("0bCk")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Historico_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e3dccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Historico_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JhHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__ = __webpack_require__("16wy");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__ = __webpack_require__("/h5N");
function injectStyle (ssrContext) {
  __webpack_require__("51Y3")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "JqGv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KD5d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KElW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('v-card',[_c('v-list',{attrs:{"three-line":""}},[_vm._l((_vm.notificaciones),function(item,index){return [_c('v-divider',{key:index,attrs:{"inset":""}}),_vm._v(" "),_c('v-list-item',{key:item.creaed_at},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"innerHTML":_vm._s(item.texto)}}),_vm._v(" "),_c('v-list-item-subtitle',{domProps:{"innerHTML":_vm._s(item.texto_desc)}})],1),_vm._v(" "),_c('v-list-item-icon',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.leida(item.id)}}},[_c('v-icon',{attrs:{"color":"blue darken-3"}},[_vm._v("remove_red_eye")])],1)],1)]})],2)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Notificaciones")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KIM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Activos_vue__ = __webpack_require__("kqqt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_53500026_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Activos_vue__ = __webpack_require__("RXtq");
function injectStyle (ssrContext) {
  __webpack_require__("inqE")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Activos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_53500026_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Activos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KNgp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{ref:"wizard",attrs:{"error-color":"#EB5E28","color":"#1e94fd","title":"Aclaraciones","subtitle":""}},[_c('div',[_c('b-tabs',{attrs:{"content-class":""}},[_c('b-tab',{staticClass:"tab-cont rounded-bottom",attrs:{"title":"Subir aclaraciones","active":"","lazy":""}},[_c('aclaraciones',{ref:"Aclaraciones"})],1)],1)],1),_vm._v(" "),_c('button',{staticClass:"d-none",attrs:{"slot":"next"},slot:"next"},[_vm._v("Siguiente")]),_vm._v(" "),_c('button',{staticClass:"d-none",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Siguientes")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kfnl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ktg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",function(){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]}),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",function(){return [_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KyzE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L4gl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "L8Bq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Deudas_vue__ = __webpack_require__("nbRV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_229c45fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Deudas_vue__ = __webpack_require__("Gju0");
function injectStyle (ssrContext) {
  __webpack_require__("Gv4n")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Deudas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_229c45fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Deudas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LIgc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_correcciones","responsive":"","hover":"","items":_vm.list_usuarios,"fields":_vm.fields_list,"per-page":_vm.perPage,"current-page":_vm.currentPage,"show-empty":"","filter":_vm.filter},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm"},on:{"click":row.toggleDetails}},[_c('i',{staticClass:"ti-search"})])]}},{key:"row-details",fn:function(row){return [_c('div',{staticClass:"row p-4"},[_c('div',{staticClass:" col-12"},[_c('div',{staticClass:"card "},[_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(" Motivo ")]),_vm._v(": "+_vm._s(row.item.motivo)+"\n                          ")]),_vm._v(" "),_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(" Cambios revisados por ")]),_vm._v(": "+_vm._s(row.item.usuario.Nombre+' '+row.item.usuario.Paterno+' '+row.item.usuario.Materno)+"\n                          ")]),_vm._v(" "),_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(" Cambio ")]),_vm._v(": "+_vm._s(_vm.getStatus(row.item.status))+"\n                          ")]),_vm._v(" "),_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(" Observaciones ")]),_vm._v(":"+_vm._s((row.item.observaciones))+"\n                          ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Datos originales")]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((row.item.origen),function(value,key){return _c('li',{key:key,staticClass:"list-group-item"},[_c('strong',[_vm._v(_vm._s(key.replace("_", " ")))]),_vm._v(" : "+_vm._s(_vm.returnValueKey(value,key)))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Datos actualizados")]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((row.item.cambio),function(value,key){return _c('li',{key:key,staticClass:"list-group-item"},[_c('strong',[_vm._v(_vm._s(key.replace("_", " ")))]),_vm._v(" : "+_vm._s(_vm.returnValueKey(value,key)))])}),0)])])])])]}},{key:"tipo_id",fn:function(row){return [_vm._v("\n                  "+_vm._s(_vm.getTipoUsuarios(row.item.tipo_id)))]}},{key:"encargo.ente_publico_id",fn:function(row){return [_vm._v("\n                  "+_vm._s(_vm.getDependencias(row.item.encargo.ente_publico_id)))]}},{key:"usuarios.nombres usuarios.primer_apellido usuarios.segundo_apellido",fn:function(row){return [_vm._v("\n                  "+_vm._s(row.item.usuarios.nombres)+" "+_vm._s(row.item.usuarios.primer_apellido)+" "+_vm._s(row.item.usuarios.segundo_apellido))]}}],null,false,1403356910)},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-mb-12"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"first-text":"<<","prev-text":"<","next-text":">","last-text":">>","aria-controls":"tbl_correcciones"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-mb-12 col-12"},[_c('p',{staticClass:"category"},[_vm._v("Mostrando "),_c('b',[_vm._v(_vm._s(_vm.from + 1))]),_vm._v(" a "),_c('b',[_vm._v(_vm._s(_vm.to))]),_vm._v(" de "),_c('b',[_vm._v(_vm._s(_vm.total))]),_vm._v(" registros")])])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Correciones ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LfAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Búsqueda de Servidores Públicos ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 espacio"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',[_vm._v("Búsqueda por nombre o RFC:")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.busqueda),expression:"model.busqueda"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre o RFC","aria-label":"Buscar:","aria-describedby":"basic-addon2"},domProps:{"value":(_vm.model.busqueda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "busqueda", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":_vm.busqueda}},[_vm._v("Buscar")])])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"offset-md-6 col-sm-6 col-md-6 col-lg-6"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),(_vm.declarantes)?_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_movimientos","responsive":"","hover":"","items":_vm.list_funcionarios,"fields":_vm.fields_list,"per-page":_vm.perPage,"current-page":_vm.currentPage,"show-empty":"","filter":_vm.filter},on:{"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"id":'d'+row.item.id,"variant":"info","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.declaraciones(row.item)}}},[_c('i',{staticClass:"fa fa-file"})])]}}],null,false,3500346675)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-mb-8 col-8"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"first-text":"<<","prev-text":"<","next-text":">","last-text":">>","aria-controls":"tbl_movimientos"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.declaracionesT)?_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_declaraciones","responsive":"","hover":"","items":_vm.list_declaraciones,"fields":_vm.fields_list2,"per-page":_vm.perPage,"current-page":_vm.currentPage,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"id":'d'+row.item.id,"variant":"info","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(row.item)}}},[_c('i',{staticClass:"fa fa-file-pdf"})])]}}],null,false,1033036923)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar-default"},[_c('div',{staticClass:"row mr-3 ml-3 pt-3 mb-3 barra"},[_c('div',{staticClass:"logo"},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":"static/img/background/icon_logo.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"dnet-txt",attrs:{"src":"static/img/background/declaranet_txt.png","alt":""}})]),_vm._v(" "),_c('h2',{staticClass:" simple-text logo-normal ml-3 m-0 "})]),_vm._v(" "),_c('div',{staticClass:"col-6 text-align-right"},[_c('div',{staticClass:"nombre"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lvs1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('div',[_c('legend',[_vm._v("Experiencia Laboral")]),_vm._v(" "),_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_vm._v("Incorporar al menos los cinco últimos empleos no contando el actual")]),_vm._v(" "),(_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Ámbito / sector en el que laboraste ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","width":"100%","name":"ambitoexp","placeholder":"Ámbitos"},model:{value:(_vm.modelexp.ambito_id),callback:function ($$v) {_vm.$set(_vm.modelexp, "ambito_id", $$v)},expression:"modelexp.ambito_id"}},_vm._l((_vm.ambitos),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('ambitoexp'))+"\n          ")])],1)]),_vm._v(" "),(_vm.modelexp.ambito_id == 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Nivel/Orden de Gobierno ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Nivel"},model:{value:(_vm.modelexp.nivel_gobierno_id),callback:function ($$v) {_vm.$set(_vm.modelexp, "nivel_gobierno_id", $$v)},expression:"modelexp.nivel_gobierno_id"}},_vm._l((_vm.niveles),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Ambito público\n          ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Poder"},model:{value:(_vm.modelexp.poder_ente_id),callback:function ($$v) {_vm.$set(_vm.modelexp, "poder_ente_id", $$v)},expression:"modelexp.poder_ente_id"}},_vm._l((_vm.poderes),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Nombre del ente público / nombre de la empresa, sociedad o asociación ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.modelexp.nombre_institucion),expression:"modelexp.nombre_institucion"}],staticClass:"form-control",attrs:{"type":"text","name":"nombreins","placeholder":"Nombre del ente público / nombre de la empresa, sociedad o asociación"},domProps:{"value":(_vm.modelexp.nombre_institucion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelexp, "nombre_institucion", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('nombreins'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" RFC ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:13'),expression:"'required|max:13'"},{name:"model",rawName:"v-model",value:(_vm.modelexp.rfc),expression:"modelexp.rfc"}],staticClass:"form-control rfc",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.modelexp.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelexp, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('unidadadm'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Área de adscripcion/area ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.modelexp.unidad_administrativa),expression:"modelexp.unidad_administrativa"}],staticClass:"form-control",attrs:{"type":"text","name":"unidadadm","placeholder":"Área de adscripcion/area"},domProps:{"value":(_vm.modelexp.unidad_administrativa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelexp, "unidad_administrativa", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('unidadadm'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Empleo, Cargo o comisión/Puesto ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.modelexp.cargo_puesto),expression:"modelexp.cargo_puesto"}],staticClass:"form-control",attrs:{"type":"text","name":"cargopuesto","placeholder":"Cargo/Puesto"},domProps:{"value":(_vm.modelexp.cargo_puesto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelexp, "cargo_puesto", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('cargopuesto'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" Especifique funcion principal ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"multiple":"","name":"funcionespp","width":"100%","filterable":"","placeholder":"Funciones Principales"},model:{value:(_vm.model_funciones),callback:function ($$v) {_vm.model_funciones=$$v},expression:"model_funciones"}},_vm._l((_vm.funciones),function(option,i){return _c('el-option',{key:'fun'+i,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('funcionespp'))+"\n          ")])],1),_vm._v(" "),(_vm.modelexp.funcionesp ==13)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Otras funciones: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelexp.otras_funciones),expression:"modelexp.otras_funciones"}],staticClass:"form-control",attrs:{"type":"text","name":"cargopuesto","placeholder":"Otras funciones"},domProps:{"value":(_vm.modelexp.otras_funciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelexp, "otras_funciones", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" Sector al que pertenece: ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Sector","name":"sectorexp","filterable":""},model:{value:(_vm.modelexp.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.modelexp, "sector_industria_id", $$v)},expression:"modelexp.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('sectorexp'))+"\n          ")])],1),_vm._v(" "),(_vm.modelexp.sector_industria_id ==11)?_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Otro Sector ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelexp.otro_sector),expression:"modelexp.otro_sector"}],staticClass:"form-control",attrs:{"type":"text","name":"otroSector","placeholder":"Otro Sector"},domProps:{"value":(_vm.modelexp.otro_sector)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelexp, "otro_sector", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Fecha de ingreso ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"picker-options":_vm.fechaIngresoOptions,"name":"fechaingreso","type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.modelexp.fecha_ingreso),callback:function ($$v) {_vm.$set(_vm.modelexp, "fecha_ingreso", $$v)},expression:"modelexp.fecha_ingreso"}})],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('fechaingreso'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Fecha de salida ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"picker-options":_vm.fechaSalidaOptions,"name":"fechasalida","type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.modelexp.fecha_salida),callback:function ($$v) {_vm.$set(_vm.modelexp, "fecha_salida", $$v)},expression:"modelexp.fecha_salida"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:" col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Aclaraciones y observaciones")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelexp.observaciones),expression:"modelexp.observaciones"}],staticClass:"form-control",attrs:{"type":"text","name":"observaciones","placeholder":"Aclaraciones y observaciones"},domProps:{"value":(_vm.modelexp.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelexp, "observaciones", $event.target.value)}}})])])]),_vm._v(" "),_c('domicilio',{attrs:{"vista":false,"titulo":"/Ubicación del Cargo"},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[_vm._m(0)]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])])],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"id":"tbl_exp","headers":_vm.headers,"items":_vm.list_experiencia,"items-per-page":10},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete mr-2",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.ambito_id",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.getAmbito(item.ambito_id)))]}},{key:"item.nivel_gobierno_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getNivel(item.nivel_gobierno_id)))])]}},{key:"item.poder_ente_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getPoder(item.poder_ente_id)))])]}},{key:"item.nombre_institucion",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.nombre_institucion))])]}},{key:"item.unidad_administrativa",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.unidad_administrativa))])]}},{key:"item.sector_industria_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getSector(item.sector_industria_id)))])]}},{key:"item.jerarquia_rango",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.jerarquia_rango))])]}},{key:"item.cargo_puesto",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.cargo_puesto))])]}},{key:"item.fecha_ingreso",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.fecha_ingreso))])]}},{key:"item.fecha_salida",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.fecha_salida))])]}},{key:"item.direccion_pais_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getPais(item.direccion_pais_id)))])]}},{key:"item.direccion_entidad_federativa_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getEntidad(item.direccion_entidad_federativa_id)))])]}},{key:"item.direccion_municipio_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getMunicipio(item.direccion_municipio_id)))])]}},{key:"item.direccion_cp",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.direccion_cp))])]}},{key:"item.direccion_numext",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.direccion_numext))])]}},{key:"item.direccion_numint",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.direccion_numint))])]}}],null,false,2668513778)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("9DQD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e260789a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("R3t2");
function injectStyle (ssrContext) {
  __webpack_require__("qMVV")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e260789a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9zv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[(_vm.cargando)?_c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{attrs:{"id":"loader"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('a',{staticClass:"btn btn-wd btn-info pull-right",attrs:{"target":"_blanc","href":_vm.$rootUrl+'/PlantillaCargaIngresos.xlsx',"alt":"Plantilla XLSX"}},[_vm._m(1),_vm._v("\n                Descargar Plantilla\n              ")])])]),_vm._v(" "),_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveComprobante.apply(null, arguments)}}},[_c('table',{staticClass:"table"},[_c('tbody',[(_vm.getKey('permisos').includes(5))?_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v(" Dependencia")]),_vm._v(" "),_c('td',[_c('el-select',{staticClass:"select-default",attrs:{"name":"ente_publico_id","placeholder":"Seleccione una opción","filterable":""},model:{value:(_vm.ente_publico_id),callback:function ($$v) {_vm.ente_publico_id=$$v},expression:"ente_publico_id"}},_vm._l((_vm.entes),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.ente_publico_id || _vm.getKey('permisos').includes(5)===false )?_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Seleccionar el archivo excel")]),_vm._v(" "),_c('td',[_c('input',{ref:"xlsx",staticClass:"form-control",attrs:{"id":"xlsx","accept":".xlsx","required":"","type":"file"},on:{"change":function($event){return _vm.addFile('xlsx')}}})])]):_vm._e(),_vm._v(" "),(_vm.grupo!=0 && _vm.xlsx!=0)?_c('tr',[_c('td',{attrs:{"colspan":"2","align":"center"}},[_c('button',{ref:"btnSave",staticClass:"btn btn-primary"},[_c('i',{staticClass:"fa fa-send"}),_vm._v(" Guardar")])])]):_vm._e()])])]),_vm._v(" "),(Object.entries(_vm.incorrectos).length > 0 )?_c('h3',{staticClass:"bg-info text-white",attrs:{"align":"center"}},[_vm._v("\n            Los siguientes registros cuentan con errores, favor de corregirlos y volver a cargar la plantilla. No se ha cargado ningún registro.\n          ")]):_vm._e(),_vm._v(" "),(Object.entries(_vm.incorrectos).length > 0 )?_c('b-table',{attrs:{"id":"tbl_incorrectos","responsive":"","hover":"","items":_vm.incorrectos,"fields":_vm.fields_list},scopedSlots:_vm._u([{key:"Renglon",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Renglon))])])]}},{key:"Columna",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Columna))])])]}},{key:"Nombre",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Nombre))])])]}},{key:"RFC",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.RFC))])])]}},{key:"Mensaje",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Mensaje))])])]}}],null,false,3672104190)},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2):_vm._e(),_vm._v(" "),(_vm.correctos>0)?_c('table',{staticClass:"table"},[_vm._m(2),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('label',{staticStyle:{"color":"#212529"}},[_vm._v("\n                    "+_vm._s(this.correctos)+" registros han sido importados correctamente\n                  ")])])])])]):_vm._e()],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8"},[_c('legend',[_vm._v("Importar padrón de servidores públicos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("El archivo se importó correctamente")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MHIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("Fbn6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_51bb775f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("QyJ7");
function injectStyle (ssrContext) {
  __webpack_require__("BcA1")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_51bb775f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N4Wg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("LFO0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("3FKk");


var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'FontAwesomeIcon', __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]), _components),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: {
      default: null
    },
    removeLink: {
      default: null
    }
  },
  data: function data() {
    return {
      children: [],
      collapsed: false
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventBus", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_rate_css__ = __webpack_require__("ujQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_rate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_rate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_rate__ = __webpack_require__("2EuX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_rate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_rate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuestorage__ = __webpack_require__("Tqen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuestorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuestorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__("SgNW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__("cDS/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notifyjs__ = __webpack_require__("3xNa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_js__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Modal_component_vue__ = __webpack_require__("XXpw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Rating_component_vue__ = __webpack_require__("9aQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_es__ = __webpack_require__("ivQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_sweetalert2__ = __webpack_require__("JBb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_progressbar__ = __webpack_require__("pEK1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_es__ = __webpack_require__("kp13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale__ = __webpack_require__("3j08");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_bootstrap_vue__ = __webpack_require__("p3Al");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_numeric__ = __webpack_require__("+Kv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_analytics__ = __webpack_require__("VHcL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__plugins_vuetify__ = __webpack_require__("8kY9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_themify_icons__ = __webpack_require__("vciC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__("cY4Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios__ = __webpack_require__("cRLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__fortawesome_fontawesome_svg_core__ = __webpack_require__("1nTp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__fortawesome_free_solid_svg_icons__ = __webpack_require__("DXWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__fortawesome_free_brands_svg_icons__ = __webpack_require__("rP5E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__fortawesome_free_regular_svg_icons__ = __webpack_require__("WbmH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__fortawesome_vue_fontawesome__ = __webpack_require__("3FKk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__gloablComponents__ = __webpack_require__("iXuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__mixin__ = __webpack_require__("90m7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__mixinCatalogs__ = __webpack_require__("BFX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_jquery_dist_jquery_min_js__ = __webpack_require__("NfUK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_jquery_dist_jquery_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_jquery_dist_jquery_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("bvor");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("8zQz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_bootstrap_dist_js_bootstrap_min_js__ = __webpack_require__("XACz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_bootstrap_dist_js_bootstrap_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_bootstrap_dist_js_bootstrap_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__assets_css_global_css__ = __webpack_require__("J373");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__assets_css_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__assets_css_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_UIComponents_CurrencyNumber_vue__ = __webpack_require__("899R");





























var eventBus = new __WEBPACK_IMPORTED_MODULE_3_vue___default.a();

var config_validate = {
    aria: true,
    classes: true,
    delay: 0,
    dictionary: null,
    errorBagName: "errors",
    events: "input|blur",
    fieldsBagName: "veeFields",
    i18n: null,
    i18nRootKey: "validations",
    inject: true,
    locale: "es",
    validity: false,
    useConstraintAttrs: true
};




























__WEBPACK_IMPORTED_MODULE_26__fortawesome_fontawesome_svg_core__["a" /* dom */].watch();
__WEBPACK_IMPORTED_MODULE_26__fortawesome_fontawesome_svg_core__["b" /* library */].add(__WEBPACK_IMPORTED_MODULE_27__fortawesome_free_solid_svg_icons__["a" /* fas */], __WEBPACK_IMPORTED_MODULE_28__fortawesome_free_brands_svg_icons__["a" /* fab */], __WEBPACK_IMPORTED_MODULE_29__fortawesome_free_regular_svg_icons__["a" /* far */]);

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.component("currency", __WEBPACK_IMPORTED_MODULE_46__components_UIComponents_CurrencyNumber_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.component("font-awesome-icon", __WEBPACK_IMPORTED_MODULE_30__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.mixin(__WEBPACK_IMPORTED_MODULE_35__mixin__["a" /* mix */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.mixin(__WEBPACK_IMPORTED_MODULE_36__mixinCatalogs__["a" /* mixCat */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.component("app-modal", __WEBPACK_IMPORTED_MODULE_11__components_Modal_component_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.component("rating", __WEBPACK_IMPORTED_MODULE_12__components_Rating_component_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_32__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_31__gloablComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_vue_numeric___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_33__components_UIComponents_SidebarPlugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_rate___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vuestorage___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.component(__WEBPACK_IMPORTED_MODULE_23_vue_themify_icons__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_progressbar___default.a, {
    color: "rgb(249, 185, 0)",
    failedColor: "red",
    height: "4px"
});

__WEBPACK_IMPORTED_MODULE_10_vee_validate__["a" /* Validator */].localize("es", __WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_es___default.a);

var isCurp = function isCurp(curp) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var re = /^[A-Z][A,E,I,O,U,X][A-Z]{2}[0-9]{2}[0-1][0-9][0-3][0-9][M,H][A-Z]{2}[B,C,D,F,G,H,J,K,L,M,N,Ñ,P,Q,R,S,T,V,W,X,Y,Z]{3}[0-9,A-Z][0-9]$/;

    var validado = curp.match(re);

    if (!validado) {
        return false;
    }
    return true;
};

var isRfc = function isRfc(rfc) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var re = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]?[A-Z,0-9]?[0-9,A-Z]?$/;

    var validado = rfc.match(re);

    if (!validado) {
        return false;
    }
    return true;
};

__WEBPACK_IMPORTED_MODULE_10_vee_validate__["a" /* Validator */].extend("rfc", {
    getMessage: function getMessage(field) {
        return "El formato de la RFC no es válido, verifica la información.";
    },
    validate: isRfc
});

__WEBPACK_IMPORTED_MODULE_10_vee_validate__["a" /* Validator */].extend("curp", {
    getMessage: function getMessage(field) {
        return "El formato de la CURP no es válido, verifica la información.";
    },
    validate: isCurp
});

__WEBPACK_IMPORTED_MODULE_10_vee_validate__["a" /* Validator */].extend("uppercase", {
    getMessage: function getMessage(field) {
        return "Este campo requiere utilizar solo mayusculas y números.";
    },
    validate: function validate(value) {
        if (value.match(/^[A-Z0-9]*$/)) {
            return true;
        } else {
            return false;
        }
    }
});

var dictionary = {
    es: {
        messages: {
            _default: function _default() {
                return "El campo no es válido";
            },
            required: function required() {
                return "El campo es obligatorio";
            },
            numeric: function numeric() {
                return "El campo debe ser número";
            }
        }
    }
};

__WEBPACK_IMPORTED_MODULE_10_vee_validate__["a" /* Validator */].localize(__WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_es___default.a);


__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vee_validate__["b" /* default */], config_validate);
__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_es___default.a);

var ruta = "https://declaranet.irapuato.gob.mx" || 'http://localhost:8000';
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.http.options.root = ruta + '/index.php/api/';
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$rootUrl = ruta;
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$apiUrl = __WEBPACK_IMPORTED_MODULE_3_vue___default.a.http.options.root;

var TotalLoads = 0;
var TotalLoadsDone = 0;

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.http.interceptors.push(function (request) {
    var token = localStorage.getItem("app-token-declaranet");
    var auth = "Bearer " + (token ? token : "");
    request.headers.set("Authorization", auth);

    this.$Progress.start();

    TotalLoads++;

    return function (response) {
        TotalLoadsDone++;
        if (TotalLoadsDone == TotalLoads) {
            this.$Progress.finish();

            TotalLoads = 0;
            TotalLoadsDone = 0;
        }
    };
});

window.$ = window.jQuery = __webpack_require__("REt9");

var router = new __WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_34__routes_routes__["a" /* default */],
    linkActiveClass: "active"
});

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_vue_analytics___default.a, {
    id: "UA-140095545-1",
    router: router
});

router.beforeEach(function (to, from, next) {
    var ip_id = localStorage.getItem("app-token-declaranet");

    if (to.path !== "/login" && to.path !== "/busqueda" && !to.path.includes("/recuperapass") && !ip_id) {
        next("/login");
    } else {
        next();
    }
});

new __WEBPACK_IMPORTED_MODULE_3_vue___default.a({
    router: router,
    vuetify: __WEBPACK_IMPORTED_MODULE_22__plugins_vuetify__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_9__store_js__["a" /* default */],
    el: "#app",
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_18__App_vue__["a" /* default */]);
    }
});

/***/ }),

/***/ "NUVx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Realiza actividades empresariales ?\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre, denominación o razón social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.nombre_denominacion_razon_social),expression:"item_actividades.nombre_denominacion_razon_social"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre, denominación o razón social de quien se adquirió el inmueble:"},domProps:{"value":(_vm.item_actividades.nombre_denominacion_razon_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "nombre_denominacion_razon_social", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.rfc),expression:"item_actividades.rfc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RFC"},domProps:{"value":(_vm.item_actividades.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "rfc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("CURP (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.curp),expression:"item_actividades.curp"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CURP"},domProps:{"value":(_vm.item_actividades.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "curp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector / Industria (si aplica)")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "sector_industria_id", $$v)},expression:"item_actividades.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de actividad o servicio que produjo el ingreso")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.tipo_actividad_servicio_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "tipo_actividad_servicio_id", $$v)},expression:"item_actividades.tipo_actividad_servicio_id"}},_vm._l((_vm.actividades),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Descripción de la actividad que produce el ingreso")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.descripcion_actividad_servicio),expression:"item_actividades.descripcion_actividad_servicio"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción de la actividad"},domProps:{"value":(_vm.item_actividades.descripcion_actividad_servicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "descripcion_actividad_servicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 customCurrency"},[_c('label',{staticClass:"control-label"},[_vm._v("Ingreso bruto anual recibido por la actividad")]),_vm._v(" "),_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{staticClass:"text-right",attrs:{"type":"number","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.item_actividades.ingreso_bruto_anual),callback:function ($$v) {_vm.$set(_vm.item_actividades, "ingreso_bruto_anual", $$v)},expression:"item_actividades.ingreso_bruto_anual"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.item_actividades.moneda_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "moneda_id", $$v)},expression:"item_actividades.moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.item_actividades.moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Duración o frecuencia ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.duracion_frecuencia),expression:"item_actividades.duracion_frecuencia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Frecuencia"},domProps:{"value":(_vm.item_actividades.duracion_frecuencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "duracion_frecuencia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Unidad temporal")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.unidad_temporal_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "unidad_temporal_id", $$v)},expression:"item_actividades.unidad_temporal_id"}},_vm._l((_vm.plazos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.item_actividades.unidad_temporal_id == 4)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de transacción")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.item_actividades.fecha_transaccion),callback:function ($$v) {_vm.$set(_vm.item_actividades, "fecha_transaccion", $$v)},expression:"item_actividades.fecha_transaccion"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones / Comentarios")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.observaciones),expression:"item_actividades.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Observaciones / Comentarios"},domProps:{"value":(_vm.item_actividades.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":""},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_actividades","responsive":"","hover":"","items":_vm.list_actividades,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.entidad_federativa_id)))]}},{key:"localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.localidad_id))+"\n            ")]}},{key:"municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.municipio_id)))]}},{key:"pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_id)))]}},{key:"sector_industria_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSector(row.item.sector_industria_id)))]}},{key:"tipo_actividad_servicio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getActividad(row.item.tipo_actividad_servicio_id)))]}},{key:"ingreso_bruto_anual",fn:function(row){return [_vm._v(_vm._s((_vm.getSignoDos(row.item.moneda_id)))+"\n              "+_vm._s(_vm._f("currency")(row.item.ingreso_bruto_anual)))]}},{key:"moneda_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getMoneda(row.item.moneda_id)))]}},{key:"unidad_temporal_id",fn:function(row){return [_vm._v(_vm._s(_vm.getUnidades(row.item.unidad_temporal_id)))]}}],null,false,2722672800)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Sueldos y salarios por otros empleos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NUwg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Plantilla_vue__ = __webpack_require__("/4iE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0720550_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Plantilla_vue__ = __webpack_require__("cwZj");
function injectStyle (ssrContext) {
  __webpack_require__("lNTZ")
  __webpack_require__("o8l8")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Plantilla_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0720550_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Plantilla_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ni3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_CronAnual_vue__ = __webpack_require__("XlZn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7165b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_CronAnual_vue__ = __webpack_require__("1HUJ");
function injectStyle (ssrContext) {
  __webpack_require__("qOqc")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_CronAnual_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7165b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_CronAnual_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nn4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[(this.getKey('tipo_dec') === 'Anual')?_c('label',{staticClass:"control-label"},[_vm._v("\n    INGRESOS NETOS DEL DECLARANTE, PAREJA Y/O DEPENDIENTES ECONÓMICOS (ENTREL EL 1 DE ENERO Y EL 31 DE DICIEMBRE DEL AÑO INMEDIATO ANTERIOR)\n  ")]):_vm._e(),_vm._v(" "),(this.getKey('tipo_dec') === 'Final')?_c('label',{staticClass:"control-label"},[_vm._v("\n    INGRESOS NETOS DEL AÑO EN CURSO A LA FECHA DE CONCLUSIÓN DEL EMPLEO, CARGO O COMISIÓN DEL DECLARANTE, PAREJA Y/O DEPENDIENTES ECONÓMICOS\n  ")]):_vm._e(),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(this.getKey('tipo_dec') === 'Inicial')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          ¿TE DESEMPEÑASTE COMO SERVIDOR PÚBLICO OBLIGADO A PRESENTAR DECLARACIÓN DE SITUACIÓN PATRIMONIAL EN EL AÑO INMEDIATO ANTERIOR?\n        ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.item_entes22.bandera),callback:function ($$v) {_vm.$set(_vm.item_entes22, "bandera", $$v)},expression:"item_entes22.bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.item_entes22.bandera),callback:function ($$v) {_vm.$set(_vm.item_entes22, "bandera", $$v)},expression:"item_entes22.bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.item_entes22.bandera == '1' || this.getKey('tipo_dec') === 'Anual' || this.getKey('tipo_dec') === 'Final')?_c('div',[(this.getKey('tipo_dec') === 'Inicial')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Inicio del periodo")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"name":"fecha_inicio_periodo","type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.item_entes22.fecha_inicio_periodo),callback:function ($$v) {_vm.$set(_vm.item_entes22, "fecha_inicio_periodo", $$v)},expression:"item_entes22.fecha_inicio_periodo"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fin del periodo")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"name":"fecha_fin_periodo","type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.item_entes22.fecha_fin_periodo),callback:function ($$v) {_vm.$set(_vm.item_entes22, "fecha_fin_periodo", $$v)},expression:"item_entes22.fecha_fin_periodo"}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',[_vm._v("I.Ingresos netos recibidos durante el tiempo en el que se desempeño como servidor público en el año inmediato anterior.")]),_vm._v(" "),(this.plantilla != null)?_c('div',{staticClass:"col-md-10 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n       Te compartimos el "),_c('b',[_vm._v("monto de tus ingresos")]),_vm._v(" "),_c('strong',[_vm._v(" $ "+_vm._s(_vm._f("formatPrice")(this.plantilla.ingreso_anual_neto))+" ")]),_vm._v(", proporcionado por el área de Recursos Humanos: si es correcta, registra la cantidad en el "),_c('b',[_vm._v("punto I")]),_vm._v(", de existir error captura el monto correspondiente.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-10 form-group"},[(this.getKey('tipo_dec') === 'Final')?_c('label',{staticClass:"control-label"},[_vm._v("\n          I. Remuneración neta del año en curso a la fecha de conclusión del empleo, cargo o comisión del declarante por su cargo publico(por concepto de sueldos, honorarios, compensaciones, bonos, aguinaldos y otras prestaciones)(cantidades netas después de impuestos)\n        ")]):_c('label',{staticClass:"control-label"},[_vm._v("\n          I. Remuneración neta del declarante, recibida durante el perdiodo que se desempeño como servidor público en el año inmediato anteior (por concepto de sueldos, honorarios, compensaciones, bonos, aguinaldos y otras prestaciones)(cantidades netas después de impuestos)\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 form-group"},[_c('currency',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1|min_value:1'),expression:"'required|min:1|min_value:1'"}],staticStyle:{"text-align":"right"},attrs:{"name":"ant_sub_12","sign":"","aria-required":"true","aria-invalid":"true"},model:{value:(_vm.item_entes22.ant_sub_12),callback:function ($$v) {_vm.$set(_vm.item_entes22, "ant_sub_12", $$v)},expression:"item_entes22.ant_sub_12"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('ant_sub_12')))])],1),_vm._v(" "),_c('p',[_vm._v("II. Otros ingresos anuales netos del declarante (suma del II.1 al II.5).")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          II. 1 Por actividad industrial, comercial y/o comercial (Deduzca impuestos)\n          Especifica nombre o razón social y tipo de negocio\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes22.ant_actividad_comercial),expression:"item_entes22.ant_actividad_comercial"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.item_entes22.ant_actividad_comercial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes22, "ant_actividad_comercial", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes22.tiponegocio),expression:"item_entes22.tiponegocio"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Tipo de negocio"},domProps:{"value":(_vm.item_entes22.tiponegocio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes22, "tiponegocio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('currency',{attrs:{"name":"ant_actividad_comercial_cantidad","sign":""},model:{value:(_vm.item_entes22.ant_actividad_comercial_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes22, "ant_actividad_comercial_cantidad", $$v)},expression:"item_entes22.ant_actividad_comercial_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('ant_actividad_comercial_cantidad')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        II. 2 Por actividad financiera (rendimientoso ganancias) (Después de impuestos)\n      ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group"},[_vm._v("\n          Tipo de instrumento que generó el rendimiento o ganancia\n          "),_c('el-select',{staticClass:"select-default",attrs:{"width":"100%","name":"ant_actividad_financiera"},model:{value:(_vm.item_entes22.ant_actividad_financiera),callback:function ($$v) {_vm.$set(_vm.item_entes22, "ant_actividad_financiera", $$v)},expression:"item_entes22.ant_actividad_financiera"}},_vm._l((_vm.tipoinst),function(option){return _c('el-option',{key:option.id,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),(_vm.item_entes22.ant_actividad_financiera ==7)?_c('div',[_c('label',{staticClass:"control-label"},[_vm._v("\n              Otro Sector\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes22.otro_ant_actividad_financiera),expression:"item_entes22.otro_ant_actividad_financiera"}],staticClass:"form-control",attrs:{"type":"text","name":"otroSector","placeholder":"Otro tipo de instrumento"},domProps:{"value":(_vm.item_entes22.otro_ant_actividad_financiera)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes22, "otro_ant_actividad_financiera", $event.target.value)}}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('currency',{attrs:{"name":"ant_actividad_financiera_cantidad","sign":""},model:{value:(_vm.item_entes22.ant_actividad_financiera_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes22, "ant_actividad_financiera_cantidad", $$v)},expression:"item_entes22.ant_actividad_financiera_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('ant_actividad_financiera_cantidad')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        II. 3 Por servicios profesionales, consejos, y/o asesorías Especifica el tipo de servicio y el contratante (Después de impuestos)\n      ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes22.ant_servicios_profecionales),expression:"item_entes22.ant_servicios_profecionales"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Tipo de servicio prestado"},domProps:{"value":(_vm.item_entes22.ant_servicios_profecionales)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes22, "ant_servicios_profecionales", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('currency',{attrs:{"name":"ant_servicios_profecionales_cantidad","sign":""},model:{value:(_vm.item_entes22.ant_servicios_profecionales_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes22, "ant_servicios_profecionales_cantidad", $$v)},expression:"item_entes22.ant_servicios_profecionales_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('ant_servicios_profecionales_cantidad')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        II. 4 Por enajenación de bienes (Después de impuestos)\n      ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group"},[_c('el-select',{staticClass:"select-default",attrs:{"width":"100%","name":"cat_tipo_bien_enajenacion"},model:{value:(_vm.item_entes22.tipo_bien_enajenacion),callback:function ($$v) {_vm.$set(_vm.item_entes22, "tipo_bien_enajenacion", $$v)},expression:"item_entes22.tipo_bien_enajenacion"}},_vm._l((_vm.tipobienen),function(option){return _c('el-option',{key:option.id,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('currency',{attrs:{"name":"ant_arrendamientos_cantidad","sign":""},model:{value:(_vm.item_entes22.ant_arrendamientos_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes22, "ant_arrendamientos_cantidad", $$v)},expression:"item_entes22.ant_arrendamientos_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('ant_arrendamientos_cantidad')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        II. 5 Otros ingresos no considerados a los anteriores (Después de impuestos)\n      ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes22.otros_ingresos),expression:"item_entes22.otros_ingresos"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción"},domProps:{"value":(_vm.item_entes22.otros_ingresos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes22, "otros_ingresos", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('currency',{attrs:{"name":"ant_otros_cantidad","sign":""},model:{value:(_vm.item_entes22.ant_otros_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes22, "ant_otros_cantidad", $$v)},expression:"item_entes22.ant_otros_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('ant_otros_cantidad')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group",staticStyle:{"text-align":"right"}},[_vm._v("\n          Subtotal:\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('currency',{attrs:{"sign":"","readonly":""},model:{value:(_vm.calculo1),callback:function ($$v) {_vm.calculo1=$$v},expression:"calculo1"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group",staticStyle:{"text-align":"right"}},[_vm._v("\n          Suma Remuneración anual y Subtotal:\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('currency',{attrs:{"name":"ant_arrendamientos_cantidad","sign":"","readonly":""},model:{value:(_vm.calculo2),callback:function ($$v) {_vm.calculo2=$$v},expression:"calculo2"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        A. INGRESO ANUAL NETO DEL DECLARANTE\n      ")]),_vm._v(" "),_c('currency',{attrs:{"sign":"","readonly":""},model:{value:(_vm.item_entes22.ant_suma_12),callback:function ($$v) {_vm.$set(_vm.item_entes22, "ant_suma_12", $$v)},expression:"item_entes22.ant_suma_12"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('ant_neto_declarante')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        B. INGRESO ANUAL NETO DEL CÓNYUGE CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS (DEDUZCA IMPUESTOS)\n        ESPECIFICA\n      ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes22.ant_neto_conyugue),expression:"item_entes22.ant_neto_conyugue"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción"},domProps:{"value":(_vm.item_entes22.ant_neto_conyugue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes22, "ant_neto_conyugue", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('currency',{attrs:{"name":"ant_neto_conyugue_cantidad","sign":""},model:{value:(_vm.item_entes22.ant_neto_conyugue_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes22, "ant_neto_conyugue_cantidad", $$v)},expression:"item_entes22.ant_neto_conyugue_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('ant_neto_conyugue_cantidad')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group",staticStyle:{"text-align":"right"}},[_vm._v("\n          C. TOTAL DE INGRESOS ANUALES NETOS DEL DECLARANTE, CÓNYUGE, CONCUBINA O CONCUBINARIO\n          Y/O DEPENDIENTES ECONÓMICOS:\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('currency',{attrs:{"sign":"","readonly":""},model:{value:(_vm.calculo3),callback:function ($$v) {_vm.calculo3=$$v},expression:"calculo3"}})],1)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"control-label",attrs:{"for":""}},[_vm._v("Requisite cantidades libres de impuestos, "),_c('strong',[_vm._v("SIN CENTAVOS Y SIN CEROS A LA IZQUIERDA.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NnYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"card col-md-6"},[_c('div',{staticClass:"card-content form-group"},[_c('h4',{staticClass:"card-title"},[_vm._v("Reporte de Declaraciones")]),_vm._v(" "),_c('label',[_vm._v("Declaración ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"declaracion","placeholder":"Declaracion"},model:{value:(_vm.model.tipo_declaracion),callback:function ($$v) {_vm.$set(_vm.model, "tipo_declaracion", $$v)},expression:"model.tipo_declaracion"}},_vm._l((_vm.tiposDeclaracion),function(option){return _c('el-option',{key:option.tipo_declaracion,staticClass:"select-default",attrs:{"value":option.id,"label":option.tipo_declaracion}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.getKey('permisos').includes(14))?_c('div',[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Año")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.model.periodo),callback:function ($$v) {_vm.$set(_vm.model, "periodo", $$v)},expression:"model.periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-md-offset-3"},[_c('button',{staticClass:"btn btn-success btn-wd pull-right",on:{"click":_vm.getDeclarantes}},[_vm._v("\n                        Buscar\n                ")])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),_c('circle-chart-card',{attrs:{"percentage":_vm.avance,"title":_vm.dependenciaT,"avance":_vm.avanced,"total":_vm.totald,"description":_vm.model.periodo}})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title text-center"},[_vm._v("Declaraciones Realizadas")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.list_declarantes,"meta":_vm.meta,"fields":_vm.cumplidos_campos,"worksheet":"Cumplidos","name":"Cumplidos.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                    Descargar Reporte\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-table',{attrs:{"id":"tbla_dec","responsive":"","hover":"","items":_vm.list_declarantes,"fields":_vm.fields_list,"per-page":_vm.perPage,"current-page":_vm.currentPage,"show-empty":"","filter":_vm.filter},on:{"filtered":_vm.onFiltered}},[_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-mb-8 col-8"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"first-text":"<<","prev-text":"<","next-text":">","last-text":">>","aria-controls":"tbla_dec"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-mb-12 col-12"},[_c('p',{staticClass:"category"},[_vm._v("Mostrando "),_c('b',[_vm._v(_vm._s(_vm.from + 1))]),_vm._v(" a "),_c('b',[_vm._v(_vm._s(_vm.to))]),_vm._v(" de "),_c('b',[_vm._v(_vm._s(_vm.total))]),_vm._v(" registros")])]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title text-center"},[_vm._v("Declaraciones Faltantes")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.list_declarantes2,"meta":_vm.meta,"fields":_vm.faltantes_campos,"worksheet":"Faltantes","name":"Faltantes.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                    Descargar Reporte\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter2),callback:function ($$v) {_vm.filter2=$$v},expression:"filter2"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-table',{attrs:{"id":"tbla_dec2","responsive":"","hover":"","items":_vm.list_declarantes2,"fields":_vm.fields_list2,"per-page":_vm.perPage2,"current-page":_vm.currentPage2,"show-empty":"","filter":_vm.filter2},on:{"filtered":_vm.onFiltered2}},[_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-mb-8 col-8"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{attrs:{"total-rows":_vm.rows2,"per-page":_vm.perPage2,"first-text":"<<","prev-text":"<","next-text":">","last-text":">>","aria-controls":"tbla_dec2"},model:{value:(_vm.currentPage2),callback:function ($$v) {_vm.currentPage2=$$v},expression:"currentPage2"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-mb-12 col-12"},[_c('p',{staticClass:"category"},[_vm._v("Mostrando "),_c('b',[_vm._v(_vm._s(_vm.from2 + 1))]),_vm._v(" a "),_c('b',[_vm._v(_vm._s(_vm.to2))]),_vm._v(" de "),_c('b',[_vm._v(_vm._s(_vm.total2))]),_vm._v(" registros")])]),_vm._v(" "),_c('br')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O+mI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"}],staticClass:"form-control",attrs:{"type":"text","min":"0"},domProps:{"value":(_vm.displayValue)},on:{"blur":function($event){_vm.isInputActive = false},"focus":function($event){_vm.isInputActive = true},"keyup":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OLMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Notificaciones_vue__ = __webpack_require__("jjFe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e801387_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Notificaciones_vue__ = __webpack_require__("KElW");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Notificaciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e801387_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Notificaciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OO8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_PrestamoComodato_vue__ = __webpack_require__("QlL4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_65abbd8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_PrestamoComodato_vue__ = __webpack_require__("VFZP");
function injectStyle (ssrContext) {
  __webpack_require__("+iyP")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_PrestamoComodato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_65abbd8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_PrestamoComodato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OP2K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OU5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Declaración de posible conflicto de interés\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Operación")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.tipo_operacion_id),expression:"membresiasValidations.tipo_operacion_id"}],staticClass:"select-default",attrs:{"filterable":"","placeholder":"Seleccione una opción","name":"tipo_operacion_id"},model:{value:(_vm.item_membresias.tipo_operacion_id),callback:function ($$v) {_vm.$set(_vm.item_membresias, "tipo_operacion_id", $$v)},expression:"item_membresias.tipo_operacion_id"}},_vm._l((_vm.operaciones),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_operacion_id.invalid),expression:"tipo_operacion_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('tipo_operacion_id'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre de la empresa, sociedad o persona física")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.nombre_institucion),expression:"membresiasValidations.nombre_institucion"},{name:"model",rawName:"v-model",value:(_vm.item_membresias.nombre_institucion),expression:"item_membresias.nombre_institucion"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_institucion","placeholder":"Nombre de la institución"},domProps:{"value":(_vm.item_membresias.nombre_institucion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_membresias, "nombre_institucion", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombre_institucion.invalid),expression:"nombre_institucion.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('nombre_institucion'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Inscripcion en el registro público u otro dato que permita su identificación (En su caso)")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.registro_publico),expression:"membresiasValidations.registro_publico"},{name:"model",rawName:"v-model",value:(_vm.item_membresias.registro_publico),expression:"item_membresias.registro_publico"}],staticClass:"form-control",attrs:{"type":"text","name":"registro_publico","placeholder":"Inscripción en el registro público"},domProps:{"value":(_vm.item_membresias.registro_publico)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_membresias, "registro_publico", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.registro_publico.invalid),expression:"registro_publico.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('registro_publico'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Sociedad en la que se participa o con la que se contrata (en su caso)")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.tipo_sociedad_id),expression:"membresiasValidations.tipo_sociedad_id"}],staticClass:"select-default",attrs:{"filterable":"","placeholder":"Seleccione una opción","name":"tipo_sociedad_id"},model:{value:(_vm.item_membresias.tipo_sociedad_id),callback:function ($$v) {_vm.$set(_vm.item_membresias, "tipo_sociedad_id", $$v)},expression:"item_membresias.tipo_sociedad_id"}},_vm._l((_vm.sociedades),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_sociedad_id.invalid),expression:"tipo_sociedad_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('tipo_sociedad_id'))+"\n          ")])],1),_vm._v(" "),( _vm.item_membresias.tipo_sociedad_id == 4)?_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.tipo_sociedad_especificar),expression:"membresiasValidations.tipo_sociedad_especificar"},{name:"model",rawName:"v-model",value:(_vm.item_membresias.tipo_sociedad_especificar),expression:"item_membresias.tipo_sociedad_especificar"}],staticClass:"form-control",attrs:{"type":"text","name":"tipo_sociedad_especificar","placeholder":"Especificar"},domProps:{"value":(_vm.item_membresias.tipo_sociedad_especificar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_membresias, "tipo_sociedad_especificar", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_sociedad_especificar.invalid),expression:"tipo_sociedad_especificar.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('tipo_sociedad_especificar'))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Antigüedad en la participación o convenio (Años)")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.antiguedad),expression:"membresiasValidations.antiguedad"},{name:"model",rawName:"v-model",value:(_vm.item_membresias.antiguedad),expression:"item_membresias.antiguedad"}],staticClass:"form-control",attrs:{"type":"number","name":"antiguedad","placeholder":"Inscripción en el registro público"},domProps:{"value":(_vm.item_membresias.antiguedad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_membresias, "antiguedad", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.antiguedad.invalid),expression:"antiguedad.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('antiguedad'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Responsable del posible conflicto de interés")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.tipo_responsable_id),expression:"membresiasValidations.tipo_responsable_id"}],staticClass:"select-default",attrs:{"filterable":"","placeholder":"Seleccione una opción","name":"tipo_responsable_id"},model:{value:(_vm.item_membresias.tipo_responsable_id),callback:function ($$v) {_vm.$set(_vm.item_membresias, "tipo_responsable_id", $$v)},expression:"item_membresias.tipo_responsable_id"}},_vm._l((_vm.responsables),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_responsable_id.invalid),expression:"tipo_responsable_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('tipo_responsable_id'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de constitución de la sociedad")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.fecha_inicio),expression:"membresiasValidations.fecha_inicio"}],attrs:{"type":"date","name":"fecha_inicio","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.item_membresias.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.item_membresias, "fecha_inicio", $$v)},expression:"item_membresias.fecha_inicio"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.fecha_inicio.invalid),expression:"fecha_inicio.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('fecha_inicio'))+"\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector / Industria ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.sector_industria_id),expression:"membresiasValidations.sector_industria_id"}],staticClass:"select-default",attrs:{"placeholder":"Seleccione una opción","filterable":"","name":"sector_industria_id"},model:{value:(_vm.item_membresias.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.item_membresias, "sector_industria_id", $$v)},expression:"item_membresias.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.sector_industria_id.invalid),expression:"sector_industria_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('sector_industria_id'))+"\n          ")])],1),_vm._v(" "),( _vm.item_membresias.sector_industria_id == 11)?_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especificar sector industria")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.especificar_sector_industria),expression:"membresiasValidations.especificar_sector_industria"},{name:"model",rawName:"v-model",value:(_vm.item_membresias.especificar_sector_industria),expression:"item_membresias.especificar_sector_industria"}],staticClass:"form-control",attrs:{"type":"text","name":"especificar_sector_industria","placeholder":"Especificar"},domProps:{"value":(_vm.item_membresias.especificar_sector_industria)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_membresias, "especificar_sector_industria", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de participación o contrato")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.tipo_participacion),expression:"membresiasValidations.tipo_participacion"},{name:"model",rawName:"v-model",value:(_vm.item_membresias.tipo_participacion),expression:"item_membresias.tipo_participacion"}],staticClass:"form-control",attrs:{"type":"text","name":"tipo_participacion","placeholder":"Inscripción en el registro público"},domProps:{"value":(_vm.item_membresias.tipo_participacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_membresias, "tipo_participacion", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_participacion.invalid),expression:"tipo_participacion.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('tipo_participacion'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Inicio de participación o contrato:\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.participacion),expression:"membresiasValidations.participacion"}],attrs:{"name":"participacion","inline":true,"label":"1"},model:{value:(_vm.item_membresias.participacion),callback:function ($$v) {_vm.$set(_vm.item_membresias, "participacion", $$v)},expression:"item_membresias.participacion"}},[_vm._v("Antes del servicio público")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.membresiasValidations.participacion),expression:"membresiasValidations.participacion"}],attrs:{"name":"participacion","inline":true,"label":"2"},model:{value:(_vm.item_membresias.participacion),callback:function ($$v) {_vm.$set(_vm.item_membresias, "participacion", $$v)},expression:"item_membresias.participacion"}},[_vm._v("Después del servicio público")])],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.participacion.invalid),expression:"participacion.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('participacion'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones / Comentarios")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_membresias.observaciones),expression:"item_membresias.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Observaciones / Comentarios"},domProps:{"value":(_vm.item_membresias.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_membresias, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":"de la institución"},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Guardar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_metales","responsive":"","hover":"","items":_vm.list_membresias,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"domicilio_entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.domicilio_entidad_federativa_id)))]}},{key:"domicilio_localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.domicilio_localidad_id))+"\n            ")]}},{key:"domicilio_municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.domicilio_municipio_id)))]}},{key:"domicilio_pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.domicilio_pais_id)))]}},{key:"pais_registro_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_registro_id)))]}},{key:"sector_industria_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSector(row.item.sector_industria_id)))]}},{key:"tipo_operacion_id",fn:function(row){return [_vm._v(_vm._s(_vm.getOperacion(row.item.tipo_operacion_id)))]}},{key:"tipo_sociedad_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSociedad(row.item.tipo_sociedad_id)))]}},{key:"tipo_responsable_id",fn:function(row){return [_vm._v(_vm._s(_vm.getResponsables(row.item.tipo_responsable_id))+"\n            ")]}},{key:"participacion",fn:function(row){return [_vm._v(_vm._s(_vm.getParticipacion(row.item.participacion)))]}},{key:"fecha_inicio",fn:function(row){return [_vm._v(_vm._s(row.item.fecha_inicio))]}}],null,false,352128624)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Posibles conflictos de intereses por participaciones económicas o financieras del declarante, cónyuge, concubina, concubinario y/o\n          dependientes económicos.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OWb5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OeuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Reporte de Movimientos")]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.getKey('permisos').includes(17))?_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Dependencia")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"ente_publico_id"},model:{value:(_vm.model.dependencia),callback:function ($$v) {_vm.$set(_vm.model, "dependencia", $$v)},expression:"model.dependencia"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Seleccione el movimiento a consultar")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Selecciona una opción"},model:{value:(_vm.model.tipomov),callback:function ($$v) {_vm.$set(_vm.model, "tipomov", $$v)},expression:"model.tipomov"}},_vm._l((_vm.movimientos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.value,"label":option.label}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                           Desde\n                       ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"name":"fecha_inicio","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.model, "fecha_inicio", $$v)},expression:"model.fecha_inicio"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                           Hasta\n                       ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"name":"fecha_fin","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_fin),callback:function ($$v) {_vm.$set(_vm.model, "fecha_fin", $$v)},expression:"model.fecha_fin"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pull-right"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success pull-right",on:{"click":_vm.getBitacora}},[_vm._v("\n                               Buscar\n                       ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.list_bitacora,"meta":_vm.meta,"fields":_vm.faltantes_campos,"worksheet":"Movimientos","name":"Movimientos.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                   Descargar Reporte\n               ")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_bitacora,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.usuario",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getNombre(item.usuario)))])]}}])})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oiwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AltaPersonal_vue__ = __webpack_require__("cvgq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SolTransferencias_vue__ = __webpack_require__("JLF3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {}
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["TabContent"],
    Altas: __WEBPACK_IMPORTED_MODULE_2__AltaPersonal_vue__["a" /* default */],
    Transferencias: __WEBPACK_IMPORTED_MODULE_3__SolTransferencias_vue__["a" /* default */]
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      var permiso = [3];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    }
  },
  created: function created() {
    this.checkPermissions();
  }
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("uZT/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("Hg2S");
function injectStyle (ssrContext) {
  __webpack_require__("+njH")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Or6+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ListaCorrecciones_vue__ = __webpack_require__("+uue");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d5e192_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ListaCorrecciones_vue__ = __webpack_require__("aKIg");
function injectStyle (ssrContext) {
  __webpack_require__("cHUH")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ListaCorrecciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d5e192_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ListaCorrecciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ow0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BitacoraC_vue__ = __webpack_require__("S3vQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d315cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BitacoraC_vue__ = __webpack_require__("SrEd");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BitacoraC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d315cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BitacoraC_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P38u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("s/F+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("yrbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'circle-chart-card',
  props: {
    color: {
      type: String,
      default: 'red'
    },
    percentage: {
      type: Number,
      default: 0
    },
    title: String,
    description: String,
    total: String,
    avance: String
  },
  data: function data() {
    return {
      chartId: 'no-id',
      chart: null
    };
  },

  methods: {
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    renderChart: function renderChart(EasyPieChart) {
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 6,
        size: 160,
        scaleColor: false,
        trackColor: 'rgba(255,255,255,.25)',
        barColor: '#FFFFFF',
        animate: { duration: 2000, enabled: true }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var EasyPieChart;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "e0Qk"));

            case 3:
              EasyPieChart = _context.sent;

              _this.renderChart(EasyPieChart);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    percentage: function percentage(newVal) {
      if (this.chart) {
        this.chart.update(newVal);
      }
    }
  }
});

/***/ }),

/***/ "P6FX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PNmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Permisos_vue__ = __webpack_require__("gKFo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea7e8b32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Permisos_vue__ = __webpack_require__("6PUv");
function injectStyle (ssrContext) {
  __webpack_require__("zTke")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Permisos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea7e8b32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Permisos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PSUj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ListaMovimientos_vue__ = __webpack_require__("DsGN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5fbb47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ListaMovimientos_vue__ = __webpack_require__("eu9w");
function injectStyle (ssrContext) {
  __webpack_require__("draM")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ListaMovimientos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5fbb47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ListaMovimientos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PTcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formularios_Intereses_EmpresasSoc_vue__ = __webpack_require__("aMZf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formularios_Intereses_Decisiones_vue__ = __webpack_require__("+O+u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Formularios_Intereses_InteresesEmpresas_vue__ = __webpack_require__("WbPs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Formularios_Intereses_Membresias_vue__ = __webpack_require__("feTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Formularios_Intereses_Apoyos_vue__ = __webpack_require__("nwE3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Formularios_Intereses_Representacion_vue__ = __webpack_require__("hTv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Formularios_Intereses_Fideicomisos_vue__ = __webpack_require__("jGtE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Formularios_Intereses_ClientesPrincipales_vue__ = __webpack_require__("nO5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Formularios_Intereses_BeneficiosPrivados_vue__ = __webpack_require__("3RWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["TabContent"],
    EmpresasSoc: __WEBPACK_IMPORTED_MODULE_2__Formularios_Intereses_EmpresasSoc_vue__["a" /* default */],
    Decisiones: __WEBPACK_IMPORTED_MODULE_3__Formularios_Intereses_Decisiones_vue__["a" /* default */],
    InteresesEmp: __WEBPACK_IMPORTED_MODULE_4__Formularios_Intereses_InteresesEmpresas_vue__["a" /* default */],
    Membresias: __WEBPACK_IMPORTED_MODULE_5__Formularios_Intereses_Membresias_vue__["a" /* default */],
    Apoyos: __WEBPACK_IMPORTED_MODULE_6__Formularios_Intereses_Apoyos_vue__["a" /* default */],
    Representacion: __WEBPACK_IMPORTED_MODULE_7__Formularios_Intereses_Representacion_vue__["a" /* default */],
    Fideicomisos: __WEBPACK_IMPORTED_MODULE_8__Formularios_Intereses_Fideicomisos_vue__["a" /* default */],
    ClientesPrincipales: __WEBPACK_IMPORTED_MODULE_9__Formularios_Intereses_ClientesPrincipales_vue__["a" /* default */],
    BeneficiosPrivados: __WEBPACK_IMPORTED_MODULE_10__Formularios_Intereses_BeneficiosPrivados_vue__["a" /* default */]
  },
  watch: {
    $route: "checkPermissions"
  },
  methods: {
    cancelAll: function cancelAll() {
      var tab = this.$refs.wizard.tabs[this.$refs.wizard.activeTabIndex].$children;
      tab[0].cancelEdit();
    },
    checkPermissions: function checkPermissions() {
      if (!(this.getKey("role") == 0)) {
        localStorage.clear();
        this.$router.push("/login");
        this.$router.go();
      }
    },
    siguente: function siguente() {
      this.checkPermissions();
      this.$router.push("ingresos");
    }
  },
  created: function created() {
    this.checkPermissions();
  },
  mounted: function mounted() {
    this.$refs.wizard.activateAll();
  }
});

/***/ }),

/***/ "PWlT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"col-md-12 form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-0"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",staticStyle:{"line-height":"25px"},attrs:{"href":_vm.$rootUrl+'/declaraciones_fiscales/'+item.file,"variant":"primary","target":"_blank"}},[_c('i',{staticClass:"far fa-file-pdf"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",class:(_vm.hideButtons(item.created_at) != _vm.currentYear)?'btn-secondary':'btn-danger',attrs:{"variant":"danger","disabled":_vm.hideButtons(item.created_at) != _vm.currentYear},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.anio",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.checkAnio(item)))])]}},{key:"item.patrimonial",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargaResumen(item.id)}}},[_c('i',{staticClass:"far fa-file-pdf"})])]}},{key:"item.acuse",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargaAcuse(item.id)}}},[_c('i',{staticClass:"far fa-file-pdf"})])]}},{key:"item.entidad",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.entidadHistorico(item.datos_encargo_actual)))])]}},{key:"item.fiscal",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargaFiscal(item.declaracion_fiscal)}}},[_c('i',{staticClass:"far fa-file-pdf"})])]}}])})],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row m-3"},[_c('legend',{staticClass:"mb-0"},[_vm._v("Historial de declaraciones")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PXpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Declaraciones modificadas.")]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"offset-md-6 col-sm-6 col-md-6 col-lg-6"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_movimientos","responsive":"","hover":"","items":_vm.list_bitacora,"fields":_vm.fields_list,"per-page":_vm.perPage,"current-page":_vm.currentPage,"show-empty":"","filter":_vm.filter},on:{"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"id",fn:function(row){return [_vm._v(_vm._s(row.item.id))]}},{key:"rfc",fn:function(row){return [_vm._v(_vm._s(row.item.rfc))]}},{key:"nombres",fn:function(row){return [_vm._v(_vm._s(row.item.nombres))]}}])},[_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-mb-8 col-8"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"first-text":"<<","prev-text":"<","next-text":">","last-text":">>","aria-controls":"tbl_movimientos"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-mb-12 col-12"},[_c('p',{staticClass:"category"},[_vm._v("Mostrando "),_c('b',[_vm._v(_vm._s(_vm.from + 1))]),_vm._v(" a "),_c('b',[_vm._v(_vm._s(_vm.to))]),_vm._v(" de "),_c('b',[_vm._v(_vm._s(_vm.total))]),_vm._v(" registros")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PaBg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ActividadEconomica_vue__ = __webpack_require__("bZxL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_765303d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ActividadEconomica_vue__ = __webpack_require__("I3Ow");
function injectStyle (ssrContext) {
  __webpack_require__("c7fY")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ActividadEconomica_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_765303d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ActividadEconomica_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pn1p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿ Tiene bienes muebles ? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.bienes),expression:"info.bienes",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de bien "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_bien),expression:"info.tipo_bien",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"tipos_mueble","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.tipo_bien_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_bien_id", $$v)},expression:"form_item.tipo_bien_id"}},_vm._l((_vm.tipos_mueble),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipos_mueble')))])],1),_vm._v(" "),(_vm.form_item.tipo_bien_id == 6)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique_bien),expression:"form_item.especifique_bien"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique_bien","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique_bien)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique_bien", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique_bien')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Descripción general del bien "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.descripcion),expression:"info.descripcion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.descripcion),expression:"form_item.descripcion"}],staticClass:"form-control",attrs:{"type":"text","name":"descripcion","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "descripcion", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('descripcion')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Titular del bien "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.titular),expression:"info.titular",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción","name":"titular"},model:{value:(_vm.form_item.titular_id),callback:function ($$v) {_vm.$set(_vm.form_item, "titular_id", $$v)},expression:"form_item.titular_id"}},_vm._l((_vm.titular_adeudo),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('titular')))])],1),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tercero "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tercero),expression:"info.tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"1"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"2"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tercero')))])],1):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre del tercero o terceros "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_tercero),expression:"info.nombre_tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_tercero),expression:"form_item.nombre_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_tercero","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.form_item.nombre_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_tercero')))])]):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC del tercero "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_tercero),expression:"info.rfc_tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('uppercase|max:13'),expression:"'uppercase|max:13'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_tercero),expression:"form_item.rfc_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_tercero","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_tercero')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Transmisor "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.transmisor),expression:"info.transmisor",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"transmisor","label":"1"},model:{value:(_vm.form_item.transmisor),callback:function ($$v) {_vm.$set(_vm.form_item, "transmisor", $$v)},expression:"form_item.transmisor"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"transmisor","label":"2"},model:{value:(_vm.form_item.transmisor),callback:function ($$v) {_vm.$set(_vm.form_item, "transmisor", $$v)},expression:"form_item.transmisor"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('transmisor')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre o razón social del transmisor "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_transmisor),expression:"info.nombre_transmisor",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_transmisor),expression:"form_item.nombre_transmisor"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_transmisor","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.form_item.nombre_transmisor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_transmisor", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_transmisor')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC del transmisor "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_transmisor),expression:"info.rfc_transmisor",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('uppercase|max:13'),expression:"'uppercase|max:13'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_transmisor),expression:"form_item.rfc_transmisor"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_transmisor","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_transmisor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_transmisor", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_transmisor')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Relación del transmisor de la propiedad con el titular "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.relacion),expression:"info.relacion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"relacion","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.relacion_persona_adquirio_id),callback:function ($$v) {_vm.$set(_vm.form_item, "relacion_persona_adquirio_id", $$v)},expression:"form_item.relacion_persona_adquirio_id"}},_vm._l((_vm.transmisores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('relacion')))])],1),_vm._v(" "),(_vm.form_item.relacion_persona_adquirio_id == 20)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.relacion_especificar),expression:"form_item.relacion_especificar"}],staticClass:"form-control",attrs:{"type":"text","name":"relacion_especificar","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.relacion_especificar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "relacion_especificar", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('relacion_especificar')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Forma de adquisición "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.forma_adquisicion),expression:"info.forma_adquisicion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"forma_adquisicion","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.forma_adquisicion_id),callback:function ($$v) {_vm.$set(_vm.form_item, "forma_adquisicion_id", $$v)},expression:"form_item.forma_adquisicion_id"}},_vm._l((_vm.adquisiciones),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forma_adquisicion')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Forma de pago "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.forma_pago),expression:"info.forma_pago",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"forma_pago","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.forma_pago),callback:function ($$v) {_vm.$set(_vm.form_item, "forma_pago", $$v)},expression:"form_item.forma_pago"}},_vm._l((_vm.pagos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forma_pago')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6 "},[_c('label',{staticClass:"control-label"},[_vm._v("Valor de adquisición del bien mueble "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.precio_adquisicion_valor+' '+_vm.info.precio_adquisicion_moneda_id),expression:"info.precio_adquisicion_valor+' '+info.precio_adquisicion_moneda_id",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"customCurrency"},[_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"text-right",attrs:{"name":"precio_adquisicion_valor","type":"number","min":"0","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.form_item.precio_adquisicion_valor),callback:function ($$v) {_vm.$set(_vm.form_item, "precio_adquisicion_valor", $$v)},expression:"form_item.precio_adquisicion_valor"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.form_item.precio_adquisicion_moneda_id),callback:function ($$v) {_vm.$set(_vm.form_item, "precio_adquisicion_moneda_id", $$v)},expression:"form_item.precio_adquisicion_moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.form_item.precio_adquisicion_moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('precio_adquisicion_valor')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de Adquisición del bien mueble "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fecha_adquisicion),expression:"info.fecha_adquisicion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],attrs:{"name":"fecha_adquisicion","type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.form_item.fecha_adquisicion),callback:function ($$v) {_vm.$set(_vm.form_item, "fecha_adquisicion", $$v)},expression:"form_item.fecha_adquisicion"}})],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('fecha_adquisicion')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("En caso de baja del mueble incluir motivo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.motivo_baja),expression:"info.motivo_baja",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","name":"motivo_baja","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.motivo_baja),callback:function ($$v) {_vm.$set(_vm.form_item, "motivo_baja", $$v)},expression:"form_item.motivo_baja"}},_vm._l((_vm.bajas_inmueble),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.form_item.motivo_baja == 4)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique_baja),expression:"form_item.especifique_baja"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique_baja","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique_baja)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique_baja", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique_baja')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(!_vm.edit_item )?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(3)])]),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.titular_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.titular_id,_vm.titular_adeudo)))])]}},{key:"item.tipo_bien_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.tipo_bien_id,_vm.tipos_mueble)))])]}},{key:"item.motivo_baja",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.motivo_baja,_vm.bajas_inmueble)))])]}}],null,false,1932564853)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("BIENES MUEBLES (SITUACIÓN ACTUAL)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de bienes declarados a nombre la pareja, dependientes económicos y/o terceros o que sean en copropiedad con el declarante no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Bienes del declarante, pareja y/o dependientes económicos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pno7":
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),

/***/ "Pufn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('legend',[_vm._v("Información general")]),_vm._v(" "),_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_vm._v("Los datos personales (curp, correo personal, números telefónicos, estado civil, domicilio, observaciones) recabados serán protegidos.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Nombre(s)\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.nombres),expression:"model.nombres"}],staticClass:"form-control",attrs:{"type":"text","name":"nombres","placeholder":"Nombre(s)","disabled":""},domProps:{"value":(_vm.model.nombres)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nombres", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombres')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n           Primer Apellido\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.primer_apellido),expression:"model.primer_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"primer_apellido","placeholder":"Primer Apellido ","disabled":""},domProps:{"value":(_vm.model.primer_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "primer_apellido", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('primer_apellido'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n           Segundo Apellido\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.segundo_apellido),expression:"model.segundo_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"segundo_apellido","placeholder":"Segundo Apellido","disabled":""},domProps:{"value":(_vm.model.segundo_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "segundo_apellido", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            CURP\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|curp'),expression:"'required|uppercase|curp'"},{name:"model",rawName:"v-model",value:(_vm.model.curp),expression:"model.curp"}],staticClass:"form-control",attrs:{"type":"text","name":"curp","placeholder":"CURP","disabled":""},domProps:{"value":(_vm.model.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "curp", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('curp')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            RFC con homoclave:\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.model.rfc),expression:"model.rfc"}],staticClass:"form-control",staticStyle:{"width":"250px"},attrs:{"type":"text","name":"rfc","placeholder":"RFC","disabled":""},domProps:{"value":(_vm.model.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Correo electrónico institucional\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.correo_electronico_laboral),expression:"model.correo_electronico_laboral"}],staticClass:"form-control",attrs:{"type":"text","name":"correo_electronico_laboral","placeholder":"Correo Laboral"},domProps:{"value":(_vm.model.correo_electronico_laboral)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "correo_electronico_laboral", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('correo_electronico_laboral'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Correo electrónico personal/alterno\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.correo_electronico_personal),expression:"model.correo_electronico_personal"}],staticClass:"form-control",attrs:{"type":"text","name":"correo_electronico_personal","placeholder":"Correo Personal"},domProps:{"value":(_vm.model.correo_electronico_personal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "correo_electronico_personal", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('correo_electronico_personal'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Número telefónico de casa\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.telefono_particular),expression:"model.telefono_particular"}],staticClass:"form-control",attrs:{"type":"text","name":"telefono_particular","placeholder":"Número telefónico de casa"},domProps:{"value":(_vm.model.telefono_particular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "telefono_particular", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('telefono_particular'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Teléfono celular personal\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.telefono_celular),expression:"model.telefono_celular"}],staticClass:"form-control",attrs:{"type":"text","name":"telefono_celular","placeholder":"Teléfono celular personal"},domProps:{"value":(_vm.model.telefono_celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "telefono_celular", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-8 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                Estado Civil\n            ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Estado Civil","filterable":"","name":"edocivil"},model:{value:(_vm.model.estado_civil_id),callback:function ($$v) {_vm.$set(_vm.model, "estado_civil_id", $$v)},expression:"model.estado_civil_id"}},_vm._l((_vm.estadosCi),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('edocivil'))+"\n            ")])],1),_vm._v(" "),(_vm.model.estado_civil_id == 1)?_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Régimen matrimonial\n            ")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Régimen matrimonial","filterable":""},model:{value:(_vm.model.regimen_matrimonial_id),callback:function ($$v) {_vm.$set(_vm.model, "regimen_matrimonial_id", $$v)},expression:"model.regimen_matrimonial_id"}},_vm._l((_vm.regimenMat),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              País de nacimiento\n          ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"País","filterable":"","name":"pais_nacimiento_id"},model:{value:(_vm.model.pais_nacimiento_id),callback:function ($$v) {_vm.$set(_vm.model, "pais_nacimiento_id", $$v)},expression:"model.pais_nacimiento_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('pais_nacimiento_id'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Nacionalidad\n            ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","multiple":"","filterable":"","placeholder":"Nacionalidades","name":"nac"},model:{value:(_vm.model.nac),callback:function ($$v) {_vm.$set(_vm.model, "nac", $$v)},expression:"model.nac"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('nac'))+"\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.mostrarCampos)?_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Fecha de Nacimiento\n            ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"fecha_nacimiento","format":"dd/MM/yyyy","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_nacimiento),callback:function ($$v) {_vm.$set(_vm.model, "fecha_nacimiento", $$v)},expression:"model.fecha_nacimiento"}})],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('fecha_nacimiento'))+"\n            ")])]):_vm._e(),_vm._v(" "),(_vm.mostrarCampos)?_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            No. Identificación:\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.numero_identificacion_oficial),expression:"model.numero_identificacion_oficial"}],staticClass:"form-control",attrs:{"type":"text","name":"numero_identificacion_oficial","placeholder":"Número de Identificación Oficial"},domProps:{"value":(_vm.model.numero_identificacion_oficial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numero_identificacion_oficial", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\nAclaraciones y observaciones          ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.aclaraciones),expression:"model.aclaraciones"}],staticClass:"form-control",attrs:{"type":"text","name":"aclaraciones","placeholder":"Aclaraciones y observaciones"},domProps:{"value":(_vm.model.aclaraciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "aclaraciones", $event.target.value)}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('domicilio',{ref:"Domicilio",model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PvgY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("kDzH");










var _components;


/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), _components),
  props: ["data"],
  data: function data() {
    return {
      ip_id: 1,

      add_item: false,
      edit_item: null,
      bandera: '0',
      form_item: {},
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Participación en empresas',
        value: 'participante',
        align: 'center'
      }, {
        text: 'Nombre de la empresa',
        value: 'nombre_empresa_sociedad_asociacion',
        align: 'center'
      }, {
        text: 'RFC de la empresa',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Tipo de participación',
        value: 'naturaleza_vinculo',
        align: 'center'
      }, {
        text: 'Porcentaje de participación',
        value: 'porcentaje_participacion',
        align: 'center'
      }, {
        text: '¿Recibe remuneración por su participación?',
        value: 'remuneracion',
        align: 'center'
      }, {
        text: 'Monto mensual neto',
        value: 'monto',
        align: 'center'
      }, {
        text: 'Sector',
        value: 'sector_industria_id',
        align: 'center'
      }],
      info: {
        participacion: 'El Declarante deberá señalar si tiene o no participación en empresas, sociedades o asociaciones, tales como socio, accionista, comisario, representante, apoderado, colaborador, beneficiario u otro, especifique. Deberá reportar hasta los últimos dos años.',
        participante: 'Señalar quien tiene participación en la empresa sociedad o asociación.',
        nombre: 'Señalar el nombre o razón social completo de la empresa, sociedad o asociación, tal y como aparece en el documento legal en el que participe.',
        rfc: 'Proporcionar los 12 dígitos del registro de la empresa, sociedad o asociación en la cual participa.',
        porcentaje: 'Indicar el porcentaje de participación en la empresa, sociedad o asociación.',
        tipo_participacion: 'Seleccionar de la lista desplegable una de las siguientes opciones: socio, accionista, comisario, representante, apoderado, colaborador, beneficiario u otro, especifique.',
        remuneracion: 'Señalar sí o no.',
        monto: 'Especificar el monto mensual neto, sin centavos, que percibe por su participación.',
        sector: 'Elegir el sector al que pertenece la empresa, sociedad o asociación. En caso de señalar otro, especifique.',
        lugar: 'Indicar si se encuentra en México, debiendo señalar entidad federativa o en el extranjero, debiendo señalar el país donde se localiza.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },

  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
      if (!this.form_item.domicilio_pais_id) {
        this.form_item.domicilio_pais_id = 150;
      }
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = null;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("empresasasc", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
          _this.$el.querySelector("[aria-invalid=true]").scrollIntoView({
            block: "center",
            behavior: "smooth"
          });
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = item;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.edit_item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("empresasasc/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');

    this.$http.get("empresasasc").then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    }, function (error) {
      _this3.Err(error);
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();

    this.form_item.domicilio_pais_id = 150;
  }
});

/***/ }),

/***/ "QHVm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar-default"},[_c('div',{staticClass:"row mr-3 ml-3 pt-3 mb-3 barra"},[_c('div',{staticClass:"navbar-minimize col-1"},[_c('button',{staticClass:"btn btn-fill btn-icon",on:{"click":_vm.minimizeSidebar}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'})])]),_vm._v(" "),_c('div',{staticClass:"navbar-header col-4"},[_c('a',{staticClass:"navbar-brand"},[_vm._v(_vm._s(this.$route.name))])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"nombre"},[_c('p',{staticClass:"text-muted ente"},[_vm._v(_vm._s(this.ente))])])]),_vm._v(" "),_c('div',{staticClass:"col-1"},[_c('drop-down',{attrs:{"tag":"li","title":"5 Notificaitons","icon":"ti-bell"}},[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"slot":"title","href":"javascript:void(0)","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5")]),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n            Notifications\n            "),_c('b',{staticClass:"caret"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 3")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 4")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another notification")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-1"},[_c('v-btn',{staticClass:"ml-2 mr-2",attrs:{"outlined":"","color":"white","small":""},on:{"click":function($event){$event.preventDefault();return _vm.cerrarSesion.apply(null, arguments)}}},[_vm._v("\n        Cerrar Sesión\n      ")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nombre"},[_c('h5',[_vm._v("Busqueda")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QQVk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QiIu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QlL4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      ip_id: 1,
      add_item: false,
      edit_item: false,
      bandera: "0",
      search: '',
      form_item: {},
      table_list: [],
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Inmueble / Vehiculo',
        value: 'tipo_bien',
        align: 'center'
      }, {
        text: 'Tipo de bien',
        value: 'tipo_inmueble_id',
        align: 'center'
      }],
      info: {
        prestamos: 'Para la declaración de inicio reportar la situación de préstamo o comodato por terceros a la fecha de ingreso al empleo, cargo o comisión. ' + 'Para la declaración de modificación reportar la situación de préstamo o comodato por terceros del año inmediato anterior. ' + 'Para la declaración de conclusión reportar la situación de préstamo o comodato por terceros a la fecha de conclusión del empleo, cargo o comisión. ' + 'En este apartado se deberá indicar si existe algún bien (inmueble, vehículo) prestado por un tercero y que el Declarante use.',
        tipo_bien: 'Indicar el bien que le haya sido prestado.',
        tipo_inmueble: 'Elegir alguna de las siguientes opciones: casa, departamento, edificio, local comercial, bodega, palco, rancho, terreno, otro (especifique).',
        tipo_vehiculo: 'Seleccionar el tipo de vehículo del listado desplegable: automóvil/motocicleta, aeronave, barco/yate, otro, especifique.',
        marca: 'Elegir la marca del catálogo desplegable.',
        modelo: 'Señalar el modelo del vehículo, de acuerdo a la marca. (Ejemplo marca Volkswagen, modelo Jetta).',
        anio: 'Indicar el año del vehículo.',
        serie: 'Proporcionar el número de serie o registro que aparece en la factura y/o en su caso, tarjeta de circulación.',
        titular: 'Seleccionar si es persona física o persona moral.',
        nombre: 'Deberá proporcionar el nombre completo y/o razón social del propietario del bien prestado y usado por el Declarante.',
        rfc: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
        relacion: 'Indicar que tipo de relación existe en entre el dueño del bien prestado y el Declarante.',
        lugar: 'Indicar si se encuentra registrado en México o en el extranjero. Señalando la entidad federativa o país según corresponda.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      },

      n_domicilio: {
        pais_id: 150,
        entidadF: 11,
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      }
    };
  },

  watch: {
    n_domicilio: {
      handler: function handler(val, oldVal) {
        if (this.n_domicilio) {
          this.form_item.pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
          this.form_item.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.form_item.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.form_item.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.form_item.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.form_item.vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.form_item.vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.form_item.numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.form_item.numint = this.n_domicilio.int ? this.n_domicilio.int : "";
          this.form_item.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    editDomicilio: function editDomicilio() {
      if (this.form_item) {
        this.n_domicilio.pais_id = this.form_item.pais ? this.form_item.pais : 150;
        this.n_domicilio.entidadF = this.form_item.entidad_federativa_id ? this.form_item.entidad_federativa_id : "";
        this.n_domicilio.municipio = this.form_item.municipio_id ? this.form_item.municipio_id : "";
        this.n_domicilio.localidad = this.form_item.localidad_id ? this.form_item.localidad_id : "";
        this.n_domicilio.cp = this.form_item.cp ? this.form_item.cp : "";
        this.n_domicilio.vialidad_nombre = this.form_item.vialidad_nombre ? this.form_item.vialidad_nombre : "";
        this.n_domicilio.vialidad = this.form_item.vialidad_tipo ? this.form_item.vialidad_tipo : "";
        this.n_domicilio.ext = this.form_item.numext ? this.form_item.numext : "";
        this.n_domicilio.int = this.form_item.numint ? this.form_item.numint : "";
        this.n_domicilio.colonia = this.form_item.colonia ? this.form_item.colonia : "";
      }
    },
    initDomicilio: function initDomicilio() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: 11,
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
    },
    showItem: function showItem() {
      this.add_item = true;
      if (!this.form_item.pais_id) {
        this.form_item.pais_id = 150;
      }
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.initDomicilio();
      this.edit_item = false;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.checkDomicilio();
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("prcomodato", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");

              if (!_this.edit_item) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
          _this.scrolling();
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = true;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
      this.editDomicilio();
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("prcomodato/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    checkDomicilio: function checkDomicilio() {
      if (this.form_item.tipo_bien == '1') {
        this.form_item.tipo_vehiculo_id = null;
        this.form_item.marca = null;
        this.form_item.modelo = null;
        this.form_item.anio = null;
        this.form_item.numero_serie = null;
        this.form_item.titular_tipo = null;
        this.form_item.nombre_titular = null;
        this.form_item.rfc = null;
        this.form_item.relacion_titular = null;

        if (this.n_domicilio) {
          this.form_item.pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
          this.form_item.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.form_item.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.form_item.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.form_item.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.form_item.vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.form_item.vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.form_item.numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.form_item.numint = this.n_domicilio.int ? this.n_domicilio.int : "";
          this.form_item.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
        }
      } else {
        this.form_item.tipo_inmueble_id = null;
        this.form_item.municipio_id = null;
        this.form_item.localidad_id = null;
        this.form_item.cp = null;
        this.form_item.numext = null;
        this.form_item.numint = null;
        this.form_item.colonia = null;
        this.form_item.vialidad_nombre = null;
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');

    this.$http.get("prcomodato").then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();
    this.form_item.pais_id = 150;
  }
});

/***/ }),

/***/ "QpmF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");












var _components;





/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a), _components),
  data: function data() {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        periodo: '2020'
      },
      rol: '',
      filter: null,
      currentPage: 1,
      dependencias: {},
      perPage: 50,
      periodos: [],
      rows: null,
      tiposDeclaracion: [],
      list_cumplimiento: {},

      filtro_usuarios: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Id',
        value: 'id',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Correo Laboral',
        value: 'correo',
        align: 'center'
      }],

      propsToSearch: ['rfc', 'nombres'],
      tableColumns: [{
        prop: 'id',
        label: 'Dec',
        minWidth: 150,
        vif: false
      }, {
        prop: 'rfc',
        label: 'RFC',
        minWidth: 150,
        vif: true
      }, {
        prop: 'nombres',
        label: 'Nombre',
        minWidth: 100,
        vif: true
      }]
    };
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_cumplimiento.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_cumplimiento.length;
        return this.pagedData;
      }
      var result = this.list_cumplimiento.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_cumplimiento.length;

      return this.list_cumplimiento.length;
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [1];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getTipoDeclaracion: function getTipoDeclaracion() {
      var _this2 = this;

      var v = this;
      this.$http.get("tiposDeclaracion").then(function (response) {
        _this2.tiposDeclaracion = response.data.tipoDeclaracion;
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getPeriodos: function getPeriodos() {
      var _this3 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this3.periodos = response.data.periodos;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    getDeclaracionesR: function getDeclaracionesR() {
      var _this4 = this;

      this.$http.post("ldeclaracionesrep", this.model).then(function (response) {
        _this4.list_cumplimiento = response.data.declarantes;
      }, function (error) {
        _this4.StepError(error);
      });
    },
    getDependencias: function getDependencias() {
      var _this5 = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this5.dependencias = response.data.entes_publicos;
        _this5.dependencias.unshift({
          'codigo': 'T',
          'id': 0,
          'valor': 'Todas'
        });
      }, function (error) {
        _this5.StepError(error);
      });
    }
  },
  created: function created() {
    this.model.periodo = new Date().getFullYear();
    this.getDependencias();
    this.getTipoDeclaracion();
    this.getPeriodos();
    this.rol = this.getKey('role');
    this.checkPermissions();
  }
});

/***/ }),

/***/ "Qry8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formularios_Pasivos_Deudas_vue__ = __webpack_require__("L8Bq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formularios_Pasivos_PrestamoComodato_vue__ = __webpack_require__("OO8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {}
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["TabContent"],
    Deudas: __WEBPACK_IMPORTED_MODULE_2__Formularios_Pasivos_Deudas_vue__["a" /* default */],
    Prestamo: __WEBPACK_IMPORTED_MODULE_3__Formularios_Pasivos_PrestamoComodato_vue__["a" /* default */]
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    cancelAll: function cancelAll() {
      var tab = this.$refs.wizard.tabs[this.$refs.wizard.activeTabIndex].$children;
      tab[0].cancelEdit();
    },
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    siguente: function siguente() {
      this.$router.push('fiscal');
    }
  },
  created: function created() {
    this.checkPermissions();
  },
  mounted: function mounted() {
    this.$refs.wizard.activateAll();
  }
});

/***/ }),

/***/ "QyJ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R3t2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('vue-progress-bar'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('v-app',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("6P6z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7181bdc9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("j5fh");
function injectStyle (ssrContext) {
  __webpack_require__("0981")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7181bdc9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RQeg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),(this.getKey('tipo_dec') === 'Final')?_c('legend',[_vm._v("Datos del encargo que concluye.")]):_vm._e(),_vm._v(" "),(this.getKey('tipo_dec') != 'Final')?_c('legend',[_vm._v("Datos del encargo actual.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.mostrarCampos)?_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Nivel/Orden de Gobierno:\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.nivel_orden),expression:"modelValidations.nivel_orden"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Nivel","name":"nivel_orden"},model:{value:(_vm.model.nivel_gobierno_id),callback:function ($$v) {_vm.$set(_vm.model, "nivel_gobierno_id", $$v)},expression:"model.nivel_gobierno_id"}},_vm._l((_vm.niveles),function(option){return _c('el-option',{key:option.codigo,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nivel_orden.invalid),expression:"nivel_orden.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('nivel_orden'))+"\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.mostrarCampos)?_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Ámbito público\n        ")]),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.poder),expression:"modelValidations.poder"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Poder","name":"poder"},model:{value:(_vm.model.poder_juridico_id),callback:function ($$v) {_vm.$set(_vm.model, "poder_juridico_id", $$v)},expression:"model.poder_juridico_id"}},_vm._l((_vm.poderes),function(option){return _c('el-option',{key:option.codigo,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.poder.invalid),expression:"poder.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('poder'))+"\n      ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Nombre del ente público\n      ")]),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.ente),expression:"modelValidations.ente"}],staticClass:"select-default",attrs:{"disabled":"","clearable":"","filterable":"","name":"ente","placeholder":"Nombre del ente público","disabled":""},model:{value:(_vm.model.ente_publico_id),callback:function ($$v) {_vm.$set(_vm.model, "ente_publico_id", $$v)},expression:"model.ente_publico_id"}},_vm._l((_vm.entes),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.ente.invalid),expression:"ente.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('ente'))+"\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Área\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.area),expression:"modelValidations.area"},{name:"model",rawName:"v-model",value:(_vm.model.area_adscripcion),expression:"model.area_adscripcion"}],staticClass:"form-control",attrs:{"type":"text","name":"area","placeholder":"Area de adscripción","disabled":""},domProps:{"value":(_vm.model.area_adscripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "area_adscripcion", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.area.invalid),expression:"area.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('area'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Empleo, Cargo o Comisión\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.nombre_cargo),expression:"modelValidations.nombre_cargo"},{name:"model",rawName:"v-model",value:(_vm.model.empleo_cargo_comision),expression:"model.empleo_cargo_comision"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_cargo","placeholder":"Nombre del Cargo","disabled":""},domProps:{"value":(_vm.model.empleo_cargo_comision)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "empleo_cargo_comision", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombre_cargo.invalid),expression:"nombre_cargo.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('nombre_cargo'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Está contratado por honorarios?\n      ")]),_c('br'),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.honorarios),expression:"modelValidations.honorarios"}],attrs:{"name":"honorarios","label":"1"},model:{value:(_vm.model.contratado_honorarios),callback:function ($$v) {_vm.$set(_vm.model, "contratado_honorarios", $$v)},expression:"model.contratado_honorarios"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.honorarios),expression:"modelValidations.honorarios"}],attrs:{"name":"honorarios","label":"2"},model:{value:(_vm.model.contratado_honorarios),callback:function ($$v) {_vm.$set(_vm.model, "contratado_honorarios", $$v)},expression:"model.contratado_honorarios"}},[_vm._v("NO")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.honorarios.invalid),expression:"honorarios.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('honorarios'))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Nivel del empleo, cargo o comisión\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.nivel),expression:"modelValidations.nivel"},{name:"model",rawName:"v-model",value:(_vm.model.nivel_encargo),expression:"model.nivel_encargo"}],staticClass:"form-control",attrs:{"type":"text","name":"nivel","placeholder":"Nivel","disabled":""},domProps:{"value":(_vm.model.nivel_encargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nivel_encargo", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nivel.invalid),expression:"nivel.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('nivel'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Especifique funcion principal:\n      ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.funciones),expression:"modelValidations.funciones"}],staticClass:"select-default",attrs:{"clearable":"","multiple":"","width":"100%","name":"funciones","placeholder":"Multiple Select"},model:{value:(_vm.model.funcionesp),callback:function ($$v) {_vm.$set(_vm.model, "funcionesp", $$v)},expression:"model.funcionesp"}},_vm._l((_vm.funciones_p),function(option){return _c('el-option',{key:option.codigo,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.funciones.invalid),expression:"funciones.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('funciones'))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Otras funciones:\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.otras_funciones),expression:"model.otras_funciones"}],staticClass:"form-control",attrs:{"type":"text","name":"cargopuesto","placeholder":"Otras funciones"},domProps:{"value":(_vm.model.otras_funciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "otras_funciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Fecha de toma de Posesión del empleo, cargo o comisión\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.toma_posesion),expression:"modelValidations.toma_posesion"}],attrs:{"disabled":_vm.deshabilitado(),"name":"toma_posesion","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","picker-options":_vm.opciones,"type":"date","placeholder":"Selecciona"},model:{value:(_vm.model.fecha_posesion),callback:function ($$v) {_vm.$set(_vm.model, "fecha_posesion", $$v)},expression:"model.fecha_posesion"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.toma_posesion.invalid),expression:"toma_posesion.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('toma_posesion'))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Teléfono Laboral\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.telefono_laboral_numero),expression:"model.telefono_laboral_numero"}],staticClass:"form-control",attrs:{"type":"text","name":"curp","placeholder":"Teléfono Laboral"},domProps:{"value":(_vm.model.telefono_laboral_numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "telefono_laboral_numero", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Ext\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.telefono_laboral_extension),expression:"model.telefono_laboral_extension"}],staticClass:"form-control",attrs:{"type":"text","name":"curp","placeholder":"Teléfono Laboral"},domProps:{"value":(_vm.model.telefono_laboral_extension)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "telefono_laboral_extension", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":" del empleo, cargo o comisión "},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[_c('div',[_c('br'),_vm._v(" "),_c('legend',[_vm._v("Datos del encargo.")]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.mostrarCampos)?_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Nivel/Orden de Gobierno:\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.nivel_orden2),expression:"modelValidations2.nivel_orden2"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Nivel","name":"nivel_orden2"},model:{value:(_vm.model2.nivel_gobierno_id),callback:function ($$v) {_vm.$set(_vm.model2, "nivel_gobierno_id", $$v)},expression:"model2.nivel_gobierno_id"}},_vm._l((_vm.niveles),function(option){return _c('el-option',{key:option.codigo,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nivel_orden2.invalid),expression:"nivel_orden2.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('nivel_orden2'))+"\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.mostrarCampos)?_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Ámbito público\n              ")]),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.poder2),expression:"modelValidations2.poder2"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Poder","name":"poder2"},model:{value:(_vm.model2.poder_juridico_id),callback:function ($$v) {_vm.$set(_vm.model2, "poder_juridico_id", $$v)},expression:"model2.poder_juridico_id"}},_vm._l((_vm.poderes),function(option){return _c('el-option',{key:option.codigo,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.poder2.invalid),expression:"poder2.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('poder2'))+"\n            ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Nombre del ente público\n            ")]),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.ente2),expression:"modelValidations2.ente2"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"ente2","placeholder":"Nombre del ente público","disabled":false},model:{value:(_vm.model2.ente_publico_id),callback:function ($$v) {_vm.$set(_vm.model2, "ente_publico_id", $$v)},expression:"model2.ente_publico_id"}},_vm._l((_vm.entes),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.ente2.invalid),expression:"ente2.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('ente2'))+"\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Área\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.area2),expression:"modelValidations2.area2"},{name:"model",rawName:"v-model",value:(_vm.model2.area_adscripcion),expression:"model2.area_adscripcion"}],staticClass:"form-control",attrs:{"type":"text","name":"area2","placeholder":"Area de adscripción"},domProps:{"value":(_vm.model2.area_adscripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model2, "area_adscripcion", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.area2.invalid),expression:"area2.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('area2'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Empleo, Cargo o Comisión\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.nombre_cargo2),expression:"modelValidations2.nombre_cargo2"},{name:"model",rawName:"v-model",value:(_vm.model2.empleo_cargo_comision),expression:"model2.empleo_cargo_comision"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_cargo2","placeholder":"Nombre del Cargo"},domProps:{"value":(_vm.model2.empleo_cargo_comision)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model2, "empleo_cargo_comision", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombre_cargo.invalid),expression:"nombre_cargo.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('nombre_cargo2'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              ¿ Está contratado por honorarios?\n            ")]),_c('br'),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.honorarios2),expression:"modelValidations2.honorarios2"}],attrs:{"name":"honorarios2","label":"1"},model:{value:(_vm.model2.contratado_honorarios),callback:function ($$v) {_vm.$set(_vm.model2, "contratado_honorarios", $$v)},expression:"model2.contratado_honorarios"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.honorarios2),expression:"modelValidations2.honorarios2"}],attrs:{"name":"honorarios2","label":"2"},model:{value:(_vm.model2.contratado_honorarios),callback:function ($$v) {_vm.$set(_vm.model2, "contratado_honorarios", $$v)},expression:"model2.contratado_honorarios"}},[_vm._v("NO")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.honorarios2.invalid),expression:"honorarios2.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('honorarios2'))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Nivel del empleo, cargo o comisión\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.nivel2),expression:"modelValidations2.nivel2"},{name:"model",rawName:"v-model",value:(_vm.model2.nivel_encargo),expression:"model2.nivel_encargo"}],staticClass:"form-control",attrs:{"type":"text","name":"nivel2","placeholder":"Nivel"},domProps:{"value":(_vm.model2.nivel_encargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model2, "nivel_encargo", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nivel.invalid),expression:"nivel.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('nivel2'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Especifique funcion principal:\n            ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.funciones2),expression:"modelValidations2.funciones2"}],staticClass:"select-default",attrs:{"clearable":"","multiple":"","width":"100%","name":"funciones2","placeholder":"Multiple Select"},model:{value:(_vm.model2.funciones),callback:function ($$v) {_vm.$set(_vm.model2, "funciones", $$v)},expression:"model2.funciones"}},_vm._l((_vm.funciones_p),function(option){return _c('el-option',{key:option.codigo,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.funciones2.invalid),expression:"funciones2.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('funciones2'))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                Otras funciones:\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model2.otras_funciones),expression:"model2.otras_funciones"}],staticClass:"form-control",attrs:{"type":"text","name":"cargopuesto","placeholder":"Otras funciones"},domProps:{"value":(_vm.model2.otras_funciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model2, "otras_funciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Fecha de toma de Posesión del empleo, cargo o comisión\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations2.toma_posesion2),expression:"modelValidations2.toma_posesion2"}],attrs:{"name":"toma_posesion2","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","picker-options":_vm.opciones,"type":"date","placeholder":"Selecciona"},model:{value:(_vm.model2.fecha_posesion),callback:function ($$v) {_vm.$set(_vm.model2, "fecha_posesion", $$v)},expression:"model2.fecha_posesion"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.toma_posesion2.invalid),expression:"toma_posesion2.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('toma_posesion2'))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Teléfono Laboral\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model2.telefono_laboral_numero),expression:"model2.telefono_laboral_numero"}],staticClass:"form-control",attrs:{"type":"text","name":"tellab2","placeholder":"Teléfono Laboral"},domProps:{"value":(_vm.model2.telefono_laboral_numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model2, "telefono_laboral_numero", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Ext\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model2.telefono_laboral_extension),expression:"model2.telefono_laboral_extension"}],staticClass:"form-control",attrs:{"type":"text","name":"telext2","placeholder":"Teléfono Laboral"},domProps:{"value":(_vm.model2.telefono_laboral_extension)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model2, "telefono_laboral_extension", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":" del empleo, cargo o comisión "},model:{value:(_vm.n_domicilio2),callback:function ($$v) {_vm.n_domicilio2=$$v},expression:"n_domicilio2"}})],1)]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("¿CUENTA CON OTRO EMPLEO, CARGO O COMISIÓN EN EL SERVICIO PÚBLICO DISTINTO AL DECLARADO? ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RXtq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{ref:"wizard",attrs:{"error-color":"#EB5E28","color":"#1e94fd","title":"Activos","subtitle":""},on:{"on-complete":_vm.siguente,"on-change":_vm.cancelAll}},[_c('tab-content',{attrs:{"title":"Bienes Inmuebles (Situación actual)","icon":"ti-home"}},[_c('bienes-inmuebles',{ref:"BienesInmuebles"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Vehículos (Situación actual)","icon":"ti-car"}},[_c('bienes-muebles',{ref:"BienesMuebles"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Bienes Muebles (Situación actual)","icon":"ti-money"}},[_c('bienes-muebles-n-r',{ref:"BienesMueblesNR"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Inversiones, cuentas bancarias y otro tipo de valores / activos (Situación actual)","icon":"ti-stats-up"}},[_c('inversiones',{ref:"Inversiones"})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Atrás")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v("Siguiente")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Siguiente")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RZuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("Dhe7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("zHPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("s/F+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("yrbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_browser_downloads__ = __webpack_require__("oqf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_browser_downloads___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_browser_downloads__);









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'export-excel',
    props: {
        type: {
            type: String,
            default: "xls"
        },

        data: {
            type: Array,
            required: false,
            default: null
        },

        fields: {
            type: Object,
            required: false
        },

        exportFields: {
            type: Object,
            required: false
        },

        defaultValue: {
            type: String,
            required: false,
            default: ""
        },

        title: {
            default: null
        },

        footer: {
            default: null
        },

        name: {
            type: String,
            default: "data.xls"
        },
        fetch: {
            type: Function
        },
        meta: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        worksheet: {
            type: String,
            default: "Sheet1"
        },

        beforeGenerate: {
            type: Function
        },

        beforeFinish: {
            type: Function
        }
    },
    computed: {
        idName: function idName() {
            var now = new Date().getTime();
            return "export_" + now;
        },
        downloadFields: function downloadFields() {
            if (this.fields !== undefined) return this.fields;

            if (this.exportFields !== undefined) return this.exportFields;
        }
    },
    methods: {
        generate: function generate() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                var data, json;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(typeof _this.beforeGenerate === 'function')) {
                                    _context.next = 3;
                                    break;
                                }

                                _context.next = 3;
                                return _this.beforeGenerate();

                            case 3:
                                data = _this.data;

                                if (!(typeof _this.fetch === 'function' || !data)) {
                                    _context.next = 8;
                                    break;
                                }

                                _context.next = 7;
                                return _this.fetch();

                            case 7:
                                data = _context.sent;

                            case 8:
                                if (!(!data || !data.length)) {
                                    _context.next = 10;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 10:
                                json = _this.getProcessedJson(data, _this.downloadFields);

                                if (!(_this.type === "html")) {
                                    _context.next = 15;
                                    break;
                                }

                                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name.replace(".xls", ".html"), "text/html"));

                            case 15:
                                if (!(_this.type === "csv")) {
                                    _context.next = 17;
                                    break;
                                }

                                return _context.abrupt("return", _this.export(_this.jsonToCSV(json), _this.name.replace(".xls", ".csv"), "application/csv"));

                            case 17:
                                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name, "application/vnd.ms-excel"));

                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        export: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(data, filename, mime) {
                var blob;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                blob = this.base64ToBlob(data, mime);

                                if (!(typeof this.beforeFinish === 'function')) {
                                    _context2.next = 4;
                                    break;
                                }

                                _context2.next = 4;
                                return this.beforeFinish();

                            case 4:
                                __WEBPACK_IMPORTED_MODULE_5_browser_downloads___default()(blob, filename, mime);

                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _export(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return _export;
        }(),
        jsonToXLS: function jsonToXLS(data) {
            var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>br {mso-data-placement: same-cell;}</style></head><body><table>${table}</table></body></html>';
            var xlsData = "<thead>";
            var colspan = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data[0]).length;
            var _self = this;

            if (this.title != null) {
                xlsData += this.parseExtraData(this.title, '<tr><th colspan="' + colspan + '">${data}</th></tr>');
            }

            xlsData += "<tr>";
            for (var key in data[0]) {
                xlsData += "<th>" + key + "</th>";
            }
            xlsData += "</tr>";
            xlsData += "</thead>";

            xlsData += "<tbody>";
            data.map(function (item, index) {
                xlsData += "<tr>";
                for (var _key in item) {
                    xlsData += "<td>" + _self.valueReformattedForMultilines(item[_key]) + "</td>";
                }
                xlsData += "</tr>";
            });
            xlsData += "</tbody>";

            if (this.footer != null) {
                xlsData += "<tfoot>";
                xlsData += this.parseExtraData(this.footer, '<tr><td colspan="' + colspan + '">${data}</td></tr>');
                xlsData += "</tfoot>";
            }

            return xlsTemp.replace("${table}", xlsData).replace("${worksheet}", this.worksheet);
        },
        jsonToCSV: function jsonToCSV(data) {
            var csvData = [];

            if (this.title != null) {
                csvData.push(this.parseExtraData(this.title, "${data}\r\n"));
            }

            for (var key in data[0]) {
                csvData.push(key);
                csvData.push(",");
            }
            csvData.pop();
            csvData.push("\r\n");

            data.map(function (item) {
                for (var _key2 in item) {
                    var escapedCSV = '=\"' + item[_key2] + '\"';
                    if (escapedCSV.match(/[,"\n]/)) {
                        escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
                    }
                    csvData.push(escapedCSV);
                    csvData.push(",");
                }
                csvData.pop();
                csvData.push("\r\n");
            });

            if (this.footer != null) {
                csvData.push(this.parseExtraData(this.footer, "${data}\r\n"));
            }
            return csvData.join("");
        },
        getProcessedJson: function getProcessedJson(data, header) {
            var keys = this.getKeys(data, header);
            var newData = [];
            var _self = this;
            data.map(function (item, index) {
                var newItem = {};
                for (var label in keys) {
                    var property = keys[label];
                    newItem[label] = _self.getValue(property, item);
                }
                newData.push(newItem);
            });

            return newData;
        },
        getKeys: function getKeys(data, header) {
            if (header) {
                return header;
            }

            var keys = {};
            for (var key in data[0]) {
                keys[key] = key;
            }
            return keys;
        },
        parseExtraData: function parseExtraData(extraData, format) {
            var parseData = "";
            if (Array.isArray(extraData)) {
                for (var i = 0; i < extraData.length; i++) {
                    parseData += format.replace("${data}", extraData[i]);
                }
            } else {
                parseData += format.replace("${data}", extraData);
            }
            return parseData;
        },
        getValue: function getValue(key, item) {
            var field = (typeof key === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(key)) !== "object" ? key : key.field;
            var indexes = typeof field !== "string" ? [] : field.split(".");
            var value = this.defaultValue;

            if (!field) value = item;else if (indexes.length > 1) value = this.getValueFromNestedItem(item, indexes);else value = this.parseValue(item[field]);

            if (key.hasOwnProperty('callback')) value = this.getValueFromCallback(value, key.callback);

            return value;
        },
        valueReformattedForMultilines: function valueReformattedForMultilines(value) {
            if (typeof value == "string") return value.replace(/\n/ig, "<br/>");else return value;
        },
        getValueFromNestedItem: function getValueFromNestedItem(item, indexes) {
            var nestedItem = item;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(indexes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var index = _step.value;

                    if (nestedItem) nestedItem = nestedItem[index];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return this.parseValue(nestedItem);
        },
        getValueFromCallback: function getValueFromCallback(item, callback) {
            if (typeof callback !== "function") return this.defaultValue;
            var value = callback(item);
            return this.parseValue(value);
        },
        parseValue: function parseValue(value) {
            return value || value === 0 || typeof value === 'boolean' ? value : this.defaultValue;
        },
        base64ToBlob: function base64ToBlob(data, mime) {
            var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
            var bstr = atob(base64);
            var n = bstr.length;
            var u8arr = new Uint8ClampedArray(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        }
    } });

/***/ }),

/***/ "RaeL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rg6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("32Wh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      rol: null,
      loading: true,
      cargando: true,
      tiempo: '',
      options: {},
      wizardModel: {},
      incorrectos: [],
      sinIngresos: [],
      correctos: 0,
      grupo: 2,
      xlsx: 0,
      simplificadafl: false,
      entes: null,
      ente_publico_id: null,
      simplificada: '0',
      fields_list: [{
        key: "Renglon",
        label: "Renglon",
        tdClass: "text-left"
      }, {
        key: "Columna",
        label: "Columna(s)",
        tdClass: "text-left"
      }, {
        key: "RFC",
        label: "RFC",
        tdClass: "text-left"
      }, {
        key: "Mensaje",
        label: "Mensaje",
        tdClass: "text-left",
        formatter: "emptyFields"
      }],
      totalItems: 0,
      listSize: {
        itemsPerPageOptions: [10, 25, 50, 100]
      },
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      headers: [{
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'dependencia',
        align: 'left'
      }]
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__["FormWizard"]
  },
  watch: {
    search: function search(val) {
      if (val.length >= 4 || val.length == 0) this.getSinIngresos();
    },

    '$route': 'checkPermissions',
    'grupo': function grupo(val) {
      if (val == 3) {
        this.simplificada = '1';
        this.simplificadafl = true;
      } else this.simplificadafl = false;
    },
    'simplificada': function simplificada(val) {
      if (val == '1') this.grupo = 3;else this.grupo = 2;
    }
  },
  methods: {
    uppercase: function uppercase() {
      this.search = this.search.toUpperCase();
    },
    checkPermissions: function checkPermissions() {
      var permiso = [5];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getSinIngresos: function getSinIngresos(e) {
      var _this = this;

      var sortDesc = false;
      if (e) {
        sortDesc = e.sortDesc[0];
        console.log(sortDesc);
      }
      var params = {
        params: {
          page: this.pagination.page,
          itemsPerPage: this.pagination.itemsPerPage,
          search: this.search,
          sortDesc: sortDesc
        }
      };

      this.$http.get("sueldos_otros_rfc", params).then(function (response) {
        var lista_ = response.data.lista;

        _this.sinIngresos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(lista_.data));

        _this.totalItems = Number(lista_.total);
        _this.pagination.page = Number(lista_.current_page);
        _this.pagination.pagelength = Number(lista_.last_page);

        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.StepError(error);
      });
    },
    saveComprobante: function saveComprobante() {
      var _this2 = this;

      var preg = "";

      this.Ask(preg + "¿Desea continuar?", function () {
        _this2.cargando = true;
        _this2.loadButton(_this2.$refs.btnSave);
        var formData = new FormData();
        formData.append("ente_publico_id", _this2.ente_publico_id);
        formData.append("xlsx", _this2.xlsx);

        _this2.$http.post("ExcelIngresos", formData).then(function (response) {
          _this2.onReady();
          _this2.incorrectos = response.data.incorrectos;
          _this2.correctos = response.data.correctos;
          _this2.tiempo = response.data.tiempo;
          _this2.cargando = false;
        }, function (error) {
          _this2.onReady();
          _this2.cargando = false;
          _this2.Err(error);
        });
      });
    },
    addFile: function addFile(tipo) {
      this.xlsx = this.$refs.xlsx.files[0];
    },
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.datosPersonales.model, this.$refs.firstStep.model, this.$refs.DatosCurriculares.model, this.$refs.DatosConyuge.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()("Good job!", "You clicked the finish button!", "success");
    }
  },
  created: function created() {
    this.checkPermissions();

    this.rol = this.getKey("grupo");

    this.cargando = false;
  }
});

/***/ }),

/***/ "RuSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 No Encontrada")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("La página a la que intentas acceder no existe o no tienes permiso para verda, regresa a la página anterior.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RunB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S3vQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");














var _components;





/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), _components),
  data: function data() {
    var _ref;

    return _ref = {
      model: { tipo_declaracion: '', dependencia_id: '', periodo: '' },
      dependencias: {},
      rol: '',
      filter: null,
      currentPage: 1,
      perPage: 50,
      periodos: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'model', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'rows', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tiposDeclaracion', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'list_bitacora', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'filtro_usuarios', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pagination', {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      total: 0
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'searchQuery', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fields_list', [{
      text: 'RFC',
      align: 'center',
      sortable: false,
      value: 'rfc',
      class: 'text-center td-small'
    }, {
      text: 'Nombres',
      align: 'center',
      sortable: false,
      value: 'nombres',
      class: 'text-center td-small'
    }, {
      text: 'Dependencia',
      align: 'center',
      sortable: false,
      value: 'dependencia',
      class: 'text-center td-small'
    }, {
      text: 'Usuario',
      align: 'center',
      sortable: false,
      value: 'usuario',
      class: 'text-center td-small'
    }, {
      text: 'Consulta',
      align: 'center',
      sortable: false,
      value: 'fecha',
      class: 'text-center td-small'
    }]), _ref;
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_bitacora.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_bitacora.length;
        return this.pagedData;
      }
      var result = this.list_bitacora.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_bitacora.length;

      return this.list_bitacora.length;
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [1];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getBitacora: function getBitacora() {
      var _this2 = this;

      this.$http.get("bitacora/" + this.model.fecha_inicio + '/' + this.model.fecha_fin).then(function (response) {
        var v = _this2;
        v.list_bitacora = [];
        $.each(response.data.bitacora, function (key, value) {
          v.list_bitacora.push({ 'rfc': value.declarante.rfc,
            'nombres': value.declarante.nombres + ' ' + value.declarante.primer_apellido + ' ' + value.declarante.segundo_apellido,
            'dependencia': value.declarante.encargo.ente.valor,
            'usuario': value.usuario.Nombre + ' ' + value.usuario.Paterno + ' ' + value.usuario.Materno,
            'fecha': value.created_at
          });
        });
      }, function (error) {
        _this2.StepError(error);
      });
    }
  },
  created: function created() {
    this.rol = this.getKey('role');
    this.checkPermissions();
  }
});

/***/ }),

/***/ "SQ/5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("kDzH");










var _components;


/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), _components),
  props: ["data"],
  data: function data() {
    return {
      ip_id: null,
      add_item: false,
      edit_item: null,
      bandera: '0',
      form_item: {},
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Tipo de vehículo',
        value: 'tipo_bien_id',
        align: 'center'
      }, {
        text: 'Titular del vehículo',
        value: 'titular_id',
        align: 'center'
      }, {
        text: 'Marca',
        value: 'marca',
        align: 'center'
      }, {
        text: 'Modelo',
        value: 'modelo',
        align: 'center'
      }, {
        text: 'Aclaraciones / Observaciones',
        value: 'observaciones',
        align: 'center'
      }],
      info: {
        vehiculos: 'Para la declaración de inicio reportar la situación de los vehículos a la fecha de ingreso al empleo, cargo o comisión. Para la declaración de modificación reportar la situación de los vehículos del año inmediato anterior. Para la declaración de conclusión reportar la situación de los vehículos a la fecha de conclusión del empleo, cargo o comisión.',
        tipo_vehiculo: 'Seleccionar el tipo de vehículo del listado desplegable: automóvil/motocicleta, aeronave, barco/yate, otro, especifique.',
        titular: 'Seleccionar alguna de las opciones del catálogo desplegable.',
        tercero: 'En caso de copropiedad con un tercero, seleccionar si es persona física o persona moral.',
        nombre_tercero: 'En caso de copropiedad, escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
        rfc_tercero: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
        transmisor: 'Seleccionar si es persona física o persona moral.',
        nombre_denominacion_adquirio: 'Escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
        rfc_quien_adquirio: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
        relacion: 'Elegir del catálogo qué relación tiene el titular del vehículo con el transmisor.',
        marca: 'Elegir la marca del catálogo desplegable.',
        modelo: 'Señalar el modelo del vehículo, de acuerdo a la marca. (Ejemplo marca Volkswagen, modelo Jetta).',
        anio: 'Indicar el año del vehículo.',
        numero_serie: 'Proporcionar el número de serie o registro que aparece en la factura y/o en su caso, tarjeta de circulación.',
        forma_adquisicion: 'Seleccionar alguna de las opciones del catálogo.',
        forma_pago: 'Seleccionar la forma en que realizó el pago para adquirir el vehículo, en caso de que no haya pagado por el mismo, indicará no aplica.',
        precio_adquisicion_valor: 'Proporcionar el monto de adquisición, conforme al documento con el que se acredita la propiedad.',
        precio_adquisicion_moneda_id: 'Seleccionar la moneda relativa al valor de adquisición.',
        fecha_adquisicion: 'Señalar la fecha de adquisición del vehículo, conforme al documento con el que se acredita la propiedad.',
        motivo_baja: 'Elegir la razón por la cual se da de baja: venta, donación, siniestro, otro. Especifique.',
        lugar: 'Indicar si se encuentra registrado en México o en el extranjero. Señalando la entidad federativa o país según corresponda.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },


  computed: {
    terceros: function terceros() {
      if (this.form_item) {
        if (this.form_item.titular_id) {
          var arr = [3, 4, 5, 8, 10, 13, 15, 18, 19, 24, 25];
          return arr.includes(this.form_item.titular_id);
        }
      }
      return false;
    },
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.form_item.precio_adquisicion_moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.form_item.precio_adquisicion_moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      if (!this.form_item.lugar_registro_pais_id) {
        this.form_item.lugar_registro_pais_id = 150;
      }
      this.form_item.precio_adquisicion_moneda_id = 97;
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = false;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("bienes_muebles_registrados", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");

              if (!_this.edit_item) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
          _this.scrolling();
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = true;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("bienes_muebles_registrados/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');
    this.$http.get("bienes_muebles_registrados/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();
    this.form_item.pais_id = 150;
  }
});

/***/ }),

/***/ "SWlE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SYUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      operaciones: null,
      sociedades: null,
      responsables: null,
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: "0",
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      sectores: null,
      n_domicilio: null,
      naturalezas: [],
      instituciones: [],
      pagado: null,
      entidadFed: null,
      municipios: null,
      localidades: null,
      localidad: null,
      paises: null,
      isnum: null,

      item_membresias: {},
      list_membresias: [],
      membresiasValidations: {
        tipo_operacion_id: {
          required: true
        },
        nombre_institucion: {
          required: true
        },
        registro_publico: {
          required: true
        },
        tipo_sociedad_id: {
          required: true
        },
        antiguedad: {
          required: true
        },
        tipo_responsable_id: {
          required: true
        },
        sector_industria_id: {
          required: true
        },
        fecha_inicio: {
          required: true
        },

        especificar_tipo_institucion: {
          required: true
        },
        especificar_sector_industria: {
          required: true
        },
        tipo_participacion: {
          required: true
        },
        participacion: {
          required: true
        },
        tipo_sociedad_especificar: {
          required: true
        }
      },
      fields_list: [{
        key: "acciones",
        label: "Acciones",
        tdClass: "text-center"
      }, {
        key: "tipo_operacion_id",
        label: "Tipo de Operación",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "nombre_institucion",
        label: "Nombre de la empresa",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "registro_publico",
        label: "Inscripción en el registro público",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "tipo_sociedad_id",
        label: "Tipo de Sociedad",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "antiguedad",
        label: "Antigüedad en la participación",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "tipo_responsable_id",
        label: "Responsable",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "fecha_inicio",
        label: "Fecha de constitución",
        tdClass: "text-center",
        formatter: "emptyFields"
      }, {
        key: "sector_industria_id",
        label: "Sector/Industria",
        tdClass: "text-center",
        formatter: "emptyFields"
      }, {
        key: "especificar_sector_industria",
        label: "Especifique",
        tdClass: "text-center",
        formatter: "emptyFields"
      }, {
        key: "tipo_participacion",
        label: "Tipo de Participación",
        tdClass: "text-center",
        formatter: "emptyFields"
      }, {
        key: "participacion",
        label: "Inicio de participación",
        tdClass: "text-center",
        formatter: "emptyFields"
      }, {
        key: "observaciones",
        label: "Observaciones / Comentarios",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_pais_id",
        label: "Pais",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_entidad_federativa_id",
        label: "Entidad federativa",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_municipio_id",
        label: "Municipio",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_localidad_id",
        label: "Localidad",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_colonia",
        label: "Colonia",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_vialidad_tipo",
        label: "Tipo vialidad",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_vialidad_nombre",
        label: "Nombre vialidad",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_cp",
        label: "CP",
        tdClass: "text-right",
        formatter: "emptyFields"
      }, {
        key: "domicilio_numext",
        label: "Número Exterior",
        tdClass: "text-right",
        formatter: "emptyFields"
      }, {
        key: "domicilio_numint",
        label: "Número Interior",
        tdClass: "text-right",
        formatter: "emptyFields"
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vee_validate__["c" /* mapFields */])(["tipo_operacion_id", "nombre_institucion", "registro_publico", "tipo_sociedad_id", "antiguedad", "tipo_responsable_id", "sector_industria_id", "tipo_participacion", "fecha_inicio", "especificar_tipo_institucion", "especificar_sector_industria", "participacion", "tipo_sociedad_especificar"])),
  watch: {
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_membresias.domicilio_pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_membresias.domicilio_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_membresias.domicilio_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_membresias.domicilio_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_membresias.domicilio_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_membresias.domicilio_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_membresias.domicilio_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_membresias.domicilio_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_membresias.domicilio_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_membresias.domicilio_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    },
    list_membresias: {
      handler: function handler() {
        if (this.list_membresias) {
          this.setLocalidades();
          if (this.list_membresias.length == 0) {
            this.bandera = "0";
          } else {
            this.bandera = "1";
          }
        }
      },
      deep: true
    },
    item_membresias: {
      handler: function handler() {
        if (this.item_membresias) {
          this.pagado = "" + this.item_membresias.pagado;
        }
      },
      deep: true
    },
    pagado: function pagado() {
      this.item_membresias.pagado = this.pagado;
    }
  },
  methods: {
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === "string" || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return "-";
      }
    },
    getTipo: function getTipo(index) {
      var resp = " ";
      if (this.instituciones) {
        this.instituciones.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getBool: function getBool(index) {
      var resp = "No";
      if (index == 1 || index == "1") {
        resp = "Si";
        return resp;
      }
      return resp;
    },
    getParticipacion: function getParticipacion(index) {
      var resp = "No";
      if (index == 1) {
        resp = "Antes del servicio público";
        return resp;
      } else {
        resp = "Después del servicio público";
        return resp;
      }
      return resp;
    },
    getNaturaleza: function getNaturaleza(index) {
      var resp = " ";
      if (this.naturalezas) {
        this.naturalezas.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getOperacion: function getOperacion(index) {
      var resp = " ";
      if (this.operaciones) {
        this.operaciones.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getSociedad: function getSociedad(index) {
      var resp = " ";
      if (this.sociedades) {
        this.sociedades.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getResponsables: function getResponsables(index) {
      var resp = " ";
      if (this.responsables) {
        this.responsables.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: "",
        municipio: "",
        localidad: "",
        cp: "",
        colonia: "",
        vialidad: "",
        vialidad_nombre: "",
        ext: "",
        int: ""
      };
      this.item_membresias = {
        acciones: "",
        tipo_institucion_id: "",
        nombre_institucion: "",
        naturaleza_membresia_id: "",
        sector_industria_id: "",
        puesto_rol: "",
        fecha_inicio: "",
        pagado: "",
        observaciones: "",
        domicilio_pais_id: 150,
        domicilio_entidad_federativa_id: "",
        domicilio_municipio_id: "",
        domicilio_localidad_id: "",
        domicilio_colonia: "",
        domicilio_cp: "",
        domicilio_numext: "",
        domicilio_numint: "",
        domicilio_vialidad_nombre: "",
        domicilio_vialidad_tipo: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.item_membresias) {
            _this.item_membresias.ip_id = _this.ip_id;
            _this.loadButton(_this.$refs.btnSave);
            _this.$http.post("membresias", _this.item_membresias).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.list_membresias.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.membresia));
              } else {
                _this.list_membresias.splice(_this.edit_item.index, 1, _this.item_membresias);
                _this.edit_item.item._rowVariant = "";
              }
              _this.initItem();
              _this.showItem();
              _this.edit_item = null;
            }, function (error) {
              _this.StepW(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_membresias = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_membresias[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_membresias[indice].id !== null) {
        var item = this.list_membresias[indice];
        this.list_membresias.splice(indice, 1);
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("membresias/" + item.id).then(function (response) {
            _this2.list_membresias.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_membresias.domicilio_pais_id ? this.item_membresias.domicilio_pais_id : 150;
      this.n_domicilio.entidadF = this.item_membresias.domicilio_entidad_federativa_id ? this.item_membresias.domicilio_entidad_federativa_id : "";
      this.n_domicilio.municipio = this.item_membresias.domicilio_municipio_id ? this.item_membresias.domicilio_municipio_id : "";
      this.n_domicilio.localidad = this.item_membresias.domicilio_localidad_id ? this.item_membresias.domicilio_localidad_id : "";
      this.n_domicilio.cp = this.item_membresias.domicilio_cp ? this.item_membresias.domicilio_cp : "";
      this.n_domicilio.colonia = this.item_membresias.domicilio_colonia ? this.item_membresias.domicilio_colonia : "";
      this.n_domicilio.vialidad = this.item_membresias.domicilio_vialidad_tipo ? this.item_membresias.domicilio_vialidad_tipo : "";
      this.n_domicilio.vialidad_nombre = this.item_membresias.domicilio_vialidad_nombre ? this.item_membresias.domicilio_vialidad_nombre : "";
      this.n_domicilio.ext = this.item_membresias.domicilio_numext ? this.item_membresias.domicilio_numext : "";
      this.n_domicilio.int = this.item_membresias.domicilio_numint ? this.item_membresias.domicilio_numint : "";
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      if (this.list_membresias) {
        this.list_membresias.forEach(function (item) {
          if (item.domicilio_localidad_id) {
            _this3.$http.get("localidades/localidad/" + item.domicilio_localidad_id).then(function (response) {
              _this3.localidades.push(response.data.localidad);
            }, function (error) {
              _this3.Err(error);
            });
          }
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, "");
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("membresias/" + this.ip_id).then(function (response) {
      _this4.list_membresias = response.data.membresias;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_institucion").then(function (response) {
      _this4.instituciones = response.data.institucion;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_naturaleza_membresia").then(function (response) {
      _this4.naturalezas = response.data.naturalezaMembresia;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_operacion_interes").then(function (response) {
      _this4.operaciones = response.data.tipos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_sociedad").then(function (response) {
      _this4.sociedades = response.data.tipos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_titular").then(function (response) {
      _this4.responsables = response.data.titulares;
    }, function (error) {
      _this4.Err(error);
    });
    if (this.data) {}
  }
});

/***/ }),

/***/ "SZCX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_PlantillaIngresos_vue__ = __webpack_require__("Rg6v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a6a63d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_PlantillaIngresos_vue__ = __webpack_require__("78GY");
function injectStyle (ssrContext) {
  __webpack_require__("zl2A")
  __webpack_require__("9SJ6")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_PlantillaIngresos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a6a63d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_PlantillaIngresos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SdDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Premios_vue__ = __webpack_require__("rLga");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d27b975_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Premios_vue__ = __webpack_require__("s9LD");
function injectStyle (ssrContext) {
  __webpack_require__("ETVs")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Premios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d27b975_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Premios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SrEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Bitácora de consultas")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                            Desde\n                        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"name":"fecha_inicio","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.model, "fecha_inicio", $$v)},expression:"model.fecha_inicio"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                            Hasta\n                        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"name":"fecha_fin","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_fin),callback:function ($$v) {_vm.$set(_vm.model, "fecha_fin", $$v)},expression:"model.fecha_fin"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success",on:{"click":_vm.getBitacora}},[_vm._v("\n                                Buscar\n                        ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"offset-md-6 col-sm-6 col-md-6 col-lg-6"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.fields_list,"items":_vm.list_bitacora,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"edit mr-2",attrs:{"id":'d'+item.id,"variant":"success","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item)}}},[_c('i',{staticClass:"ti-download"})]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'d'+item.id,"title":"Descargar Declaración"}}),_vm._v(" "),_c('b-button',{staticClass:"edit mr-2",attrs:{"id":'r'+item.id,"variant":"danger","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.reactivar(item)}}},[_c('i',{staticClass:"ti-unlock"})]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'r'+item.id,"title":"Reactivar declaración"}})]}}])})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_InicioLayout_vue__ = __webpack_require__("whdn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Pages_Login_vue__ = __webpack_require__("WI53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Pages_Busqueda_vue__ = __webpack_require__("XJLz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Pages_CambiaPass_vue__ = __webpack_require__("1huq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Pages_RecuperaPass_vue__ = __webpack_require__("99u0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Pages_Notificaciones_vue__ = __webpack_require__("OLMR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Forms_InfPersonal_vue__ = __webpack_require__("UIFg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Forms_Intereses_vue__ = __webpack_require__("fylz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Forms_Ingresos_vue__ = __webpack_require__("qbDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Forms_Pasivos_vue__ = __webpack_require__("xgBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Forms_Fiscal_vue__ = __webpack_require__("dUCi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Forms_Aclaraciones_vue__ = __webpack_require__("1Q+l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Forms_Activos_vue__ = __webpack_require__("KIM4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Forms_Historico_vue__ = __webpack_require__("Jh78");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Forms_Plantilla_vue__ = __webpack_require__("NUwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Forms_PlantillaIngresos_vue__ = __webpack_require__("SZCX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Forms_PlantillaBajas_vue__ = __webpack_require__("f3MI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Forms_Movimientos_vue__ = __webpack_require__("tZI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Forms_Altas_vue__ = __webpack_require__("btkt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Forms_Observaciones_vue__ = __webpack_require__("xRX4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Forms_Resumen_vue__ = __webpack_require__("Dg23");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Forms_Enviada_vue__ = __webpack_require__("fic4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Forms_Usuarios_vue__ = __webpack_require__("j+qR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Forms_Permisos_vue__ = __webpack_require__("PNmi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Reportes_Declaraciones_vue__ = __webpack_require__("2cpp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Reportes_Omisos_vue__ = __webpack_require__("FGOB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Reportes_Declaraciones2_vue__ = __webpack_require__("5mre");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Reportes_Cumplimiento_vue__ = __webpack_require__("wObG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Reportes_Cumplimiento2_vue__ = __webpack_require__("JZbM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Reportes_Tablero_vue__ = __webpack_require__("CDCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Reportes_Tablero2_vue__ = __webpack_require__("WrlU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Reportes_TableroDec_vue__ = __webpack_require__("/7XH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Reportes_ListDeclaraciones_vue__ = __webpack_require__("3bdD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_Reportes_HistoricoDeclaraciones_vue__ = __webpack_require__("8rWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Reportes_RepDeclaraciones_vue__ = __webpack_require__("r5QN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Reportes_Verificacion_vue__ = __webpack_require__("pIzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_Reportes_CronAnual_vue__ = __webpack_require__("Ni3Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Reportes_ListDeclaraciones2_vue__ = __webpack_require__("iHK7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Reportes_RepDeclaraciones2_vue__ = __webpack_require__("1EEh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_Reportes_RepConflictoInteres_vue__ = __webpack_require__("r72d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_Reportes_RepBajasDefuncion_vue__ = __webpack_require__("2eYp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Reportes_BitacoraB_vue__ = __webpack_require__("8hMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Reportes_Movimientos_vue__ = __webpack_require__("fuBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_Alertas_BitacoraC_vue__ = __webpack_require__("Ow0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_Alertas_Modificadas_vue__ = __webpack_require__("csbv");































































var formsMenu = {
  path: '/forms',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/forms/infPersonal',
  children: [{
    path: 'infPersonal',
    name: 'Información Personal',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Forms_InfPersonal_vue__["a" /* default */]
  }, {
    path: 'intereses',
    name: 'Intereses',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Forms_Intereses_vue__["a" /* default */]
  }, {
    path: 'ingresos',
    name: 'Ingresos',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Forms_Ingresos_vue__["a" /* default */]
  }, {
    path: 'activos',
    name: 'Activos',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Forms_Activos_vue__["a" /* default */]
  }, {
    path: 'pasivos',
    name: 'Pasivos',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Forms_Pasivos_vue__["a" /* default */]
  }, {
    path: 'fiscal',
    name: 'Fiscal',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Forms_Fiscal_vue__["a" /* default */]
  }, {
    path: 'aclaraciones',
    name: 'Aclaraciones',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Forms_Aclaraciones_vue__["a" /* default */]
  }, {
    path: 'resumen',
    name: 'Resumen',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Forms_Resumen_vue__["a" /* default */]
  }, {
    path: 'observaciones',
    name: 'Observaciones',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Forms_Observaciones_vue__["a" /* default */]
  }, {
    path: 'enviada',
    name: 'Enviada',
    component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Forms_Enviada_vue__["a" /* default */]
  }, {
    path: 'tablero',
    name: 'Tablero Inicial',
    component: __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Reportes_TableroDec_vue__["a" /* default */]
  }, {
    path: 'historico',
    name: 'Histórico',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Forms_Historico_vue__["a" /* default */]
  }]
};
var adminMenu = {
  path: '/admin',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/admin/plantilla',
  children: [{
    path: 'plantilla',
    name: 'Plantilla',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Forms_Plantilla_vue__["a" /* default */]
  }, {
    path: 'plantilla_ingresos',
    name: 'Plantilla de Ingresos',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Forms_PlantillaIngresos_vue__["a" /* default */]
  }, {
    path: 'plantilla_bajas',
    name: 'Plantilla para bajas',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Forms_PlantillaBajas_vue__["a" /* default */]
  }, {
    path: 'movimientos',
    name: 'Movimientos',
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Forms_Movimientos_vue__["a" /* default */]
  }, {
    path: 'usuarios',
    name: 'Usuarios',
    component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Forms_Usuarios_vue__["a" /* default */]
  }, {
    path: 'permisos',
    name: 'Permisos',
    component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Forms_Permisos_vue__["a" /* default */]
  }, {
    path: 'altapersonal',
    name: 'Alta Personal',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Forms_Altas_vue__["a" /* default */]
  }, {
    path: 'tablero',
    name: 'Tablero',
    component: __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Reportes_Tablero_vue__["a" /* default */]
  }, {
    path: 'notificaciones',
    name: 'Notificaciones',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Pages_Notificaciones_vue__["a" /* default */]
  }, {
    path: 'tablero2',
    name: 'Tablero2',
    component: __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Reportes_Tablero2_vue__["a" /* default */]
  }, {
    path: 'cronanual',
    name: 'Activación Anual',
    component: __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_Reportes_CronAnual_vue__["a" /* default */]
  }]
};

var reportesMenu = {
  path: '/reportes',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/reportes/declaraciones',
  children: [{
    path: 'declaraciones',
    name: 'Declaraciones',
    component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Reportes_Declaraciones_vue__["a" /* default */]
  }, {
    path: 'omisos',
    name: 'Omisos',
    component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Reportes_Omisos_vue__["a" /* default */]
  }, {
    path: 'declaraciones2',
    name: 'Declaraciones2',
    component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Reportes_Declaraciones2_vue__["a" /* default */]
  }, {
    path: 'cumplimiento',
    name: 'Cumplimiento',
    component: __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Reportes_Cumplimiento_vue__["a" /* default */]
  }, {
    path: 'cumplimiento2',
    name: 'Cumplimiento2',
    component: __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Reportes_Cumplimiento2_vue__["a" /* default */]
  }, {
    path: 'ldeclaraciones',
    name: 'Lista de Declaraciones',
    component: __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Reportes_ListDeclaraciones_vue__["a" /* default */]
  }, {
    path: 'hdecl',
    name: 'Historico de Declaraciones',
    component: __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_Reportes_HistoricoDeclaraciones_vue__["a" /* default */]
  }, {
    path: 'verificacion',
    name: 'Verificación',
    component: __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Reportes_Verificacion_vue__["a" /* default */]
  }, {
    path: 'RepDeclaraciones',
    name: 'Reporte de Declaraciones',
    component: __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Reportes_RepDeclaraciones_vue__["a" /* default */]
  }, {
    path: 'movimientos',
    name: 'Reporte de Movimientos',
    component: __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Reportes_Movimientos_vue__["a" /* default */]
  }, {
    path: 'reporteDeclaraciones',
    name: 'Reporte Declaraciones',
    component: __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Reportes_ListDeclaraciones2_vue__["a" /* default */]
  }, {
    path: 'reporteDeclaraciones2',
    name: 'No de Declaraciones',
    component: __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Reportes_RepDeclaraciones2_vue__["a" /* default */]
  }, {
    path: 'reporteConflictoInt',
    name: 'Reporte Conflicto de Interés ',
    component: __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_Reportes_RepConflictoInteres_vue__["a" /* default */]
  }, {
    path: 'reporteBajasDefuncion',
    name: 'Reporte Bajas por defunción ',
    component: __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_Reportes_RepBajasDefuncion_vue__["a" /* default */]
  }, {
    path: 'reporteAccesosBalanza',
    name: 'Reporte Accesos a Balanza ',
    component: __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Reportes_BitacoraB_vue__["a" /* default */]
  }]
};
var alertas = {
  path: '/alertas',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/alertas/bitacora',
  children: [{
    path: '/alertas/bitacora',
    name: 'Bitácora de Consulta',
    component: __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_Alertas_BitacoraC_vue__["a" /* default */]
  }, {
    path: '/alertas/modificadas',
    name: 'Declaraciones Modificadas',
    component: __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_Alertas_Modificadas_vue__["a" /* default */]
  }]
};

var loginPage = {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */]
};

var busqueda = {
  path: '/busqueda',
  name: 'Busqueda',
  component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Pages_Busqueda_vue__["a" /* default */]
};

var cambiaPass = {
  path: '/update',
  name: 'Update',
  component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Pages_CambiaPass_vue__["a" /* default */]
};

var recuperaPass = {
  path: '/recuperapass/:user?/:upass?',
  name: 'Recupera',
  component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Pages_RecuperaPass_vue__["a" /* default */],
  props: true
};

var routes = [formsMenu, loginPage, adminMenu, reportesMenu, cambiaPass, recuperaPass, busqueda, alertas, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T54D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("GjgZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f88473_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("cFIM");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f88473_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TAk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Transferencias_vue__ = __webpack_require__("E5OV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1be652a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Transferencias_vue__ = __webpack_require__("t5eK");
function injectStyle (ssrContext) {
  __webpack_require__("ce+6")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Transferencias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1be652a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Transferencias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TX6m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ta4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Domicilio_vue__ = __webpack_require__("G/Yq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a872036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Domicilio_vue__ = __webpack_require__("wx0c");
function injectStyle (ssrContext) {
  __webpack_require__("v8eh")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Domicilio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a872036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Domicilio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TjUS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TkYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading_bar),expression:"loading_bar"}],staticClass:"row p-3 pt-0"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"cyan"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"card col-md-6"},[_c('div',{staticClass:"card-content form-group"},[_c('h4',{staticClass:"card-title"},[_vm._v("Reporte de Declaraciones")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v("Estatus")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"estatus","placeholder":"Estatus"},model:{value:(_vm.model.estatus),callback:function ($$v) {_vm.$set(_vm.model, "estatus", $$v)},expression:"model.estatus"}},_vm._l((_vm.estatus),function(option){return _c('el-option',{key:option.estatus,staticClass:"select-default",attrs:{"value":option.id,"label":option.estatus}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v("Declaración ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"declaracion","placeholder":"Declaracion"},model:{value:(_vm.model.tipo_declaracion),callback:function ($$v) {_vm.$set(_vm.model, "tipo_declaracion", $$v)},expression:"model.tipo_declaracion"}},_vm._l((_vm.tiposDeclaracion),function(option){return _c('el-option',{key:option.tipo_declaracion,staticClass:"select-default",attrs:{"value":option.id,"label":option.tipo_declaracion}})}),1)],1)]),_vm._v(" "),(_vm.getKey('permisos').includes(14))?_c('div',[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Año")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.model.periodo),callback:function ($$v) {_vm.$set(_vm.model, "periodo", $$v)},expression:"model.periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Tipo de Reporte")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"reporte","placeholder":"Tipo de reporte"},model:{value:(_vm.model.tipo_reporte),callback:function ($$v) {_vm.$set(_vm.model, "tipo_reporte", $$v)},expression:"model.tipo_reporte"}},_vm._l((_vm.tiposReporte),function(option){return _c('el-option',{key:option.tipo_reporte,staticClass:"select-default",attrs:{"value":option.id,"label":option.tipo_reporte}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-md-offset-3"},[_c('button',{staticClass:"btn btn-success btn-wd pull-right",attrs:{"disabled":_vm.loading_bar},on:{"click":_vm.getDeclarantes}},[_vm._v("\n          "+_vm._s(_vm.loading_bar? 'Buscando datos':'Buscar')+"\n        ")])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),_c('circle-chart-card',{attrs:{"percentage":_vm.avance,"title":_vm.dependenciaT,"avance":_vm.avanced,"total":_vm.totald,"description":_vm.model.periodo}})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[(_vm.model.tipo_reporte != 2 )?_c('div',{staticClass:"card-content"},[(_vm.model.tipo_declaracion<4)?_c('h4',{staticClass:"card-title text-center"},[_vm._v("Declaraciones Realizadas")]):_vm._e(),_vm._v(" "),(_vm.model.tipo_declaracion==4)?_c('h4',{staticClass:"card-title text-center"},[_vm._v("Con Conflicto")]):_vm._e(),_vm._v(" "),(_vm.model.tipo_declaracion==5)?_c('h4',{staticClass:"card-title text-center"},[_vm._v("Con Declaración fiscal")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.list_declarantes,"meta":_vm.meta,"fields":_vm.cumplidos_campos,"worksheet":"Cumplidos","name":_vm.nombreC}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n            Descargar Reporte\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_declarantes,"items-per-page":5,"search":_vm.filter,"fixed-header":true}})],1)]),_vm._v(" "),_c('br')]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card"},[(_vm.model.tipo_reporte != 1)?_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title text-center"},[_vm._v("Declaraciones Faltantes")]),_vm._v(" "),(_vm.model.tipo_declaracion==4)?_c('h4',{staticClass:"card-title text-center"},[_vm._v("Sin Conflicto")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.list_declarantes2,"meta":_vm.meta,"fields":_vm.faltantes_campos,"worksheet":"Faltantes","name":_vm.nombreF}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n            Descargar Reporte\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter2),callback:function ($$v) {_vm.filter2=$$v},expression:"filter2"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers2,"items":_vm.list_declarantes2,"items-per-page":5,"search":_vm.filter2,"fixed-header":true}})],1)]),_vm._v(" "),_c('br')]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tn5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");
















__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a),
  props: ["data"],
  data: function data() {
    return {
      movimiento: {},
      options: [{
        id: 1,
        label: "foo"
      }, {
        id: 3,
        label: "bar"
      }, {
        id: 2,
        label: "baz"
      }],
      currentPage: 1,
      perPage: 50,
      rows: 0,
      rol: "",
      filter: null,
      id: 1,
      add_item: false,
      edit_item: null,
      tipos: null,
      dependencias: null,
      usuarios: null,
      item_usuarios: {},
      list_usuarios: [],
      expanded: [],
      singleExpand: true,
      headers: [{
        text: 'Acciones',
        value: 'acciones',
        align: 'center'
      }, {
        text: 'Fecha',
        value: 'updated_at ',
        align: 'center'

      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombre',
        align: 'center'
      }],
      fields_list: [{
        key: "acciones",
        label: "Acciones",
        thClass: "td-small",
        tdClass: "text-center td-small"
      }, {
        key: "updated_at",
        label: "Fecha",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: function formatter(value) {
          if (value) return __WEBPACK_IMPORTED_MODULE_9_moment___default()(String(value)).format('DD/MM/YYYY');else return '';
        }
      }, {
        key: "rfc",
        label: "RFC",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: "emptyFields"
      }, {
        key: "nombre",
        label: "Nombre",
        tdClass: "text-left",
        formatter: "emptyFields"
      }]
    };
  },

  computed: {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_usuarios.length;

      return this.list_usuarios.length;
    },

    fullName: {
      get: function get() {
        return this.item_usuarios.nombres + " " + this.item_usuarios.primer_apellido + " " + this.item_usuarios.segundo_apellido;
      },
      set: function set(newValue) {
        var m = newValue.match(/(\S*)\s+(.*)/);

        this.nombres = m[1];
        this.primer_apellido = m[2];
        this.segundo_apellido = m[3];
      }
    }
  },
  methods: {
    formato: function formato(fecha) {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(String(value)).format('DD/MM/YYYY');
    },
    returnValueKey: function returnValueKey(v, k) {
      return v;
    },
    initItem: function initItem() {
      this.item_usuarios = {
        acciones: "",
        nombres: "",
        Paterno: "",
        Materno: "",
        User: "",
        Password: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    removeItem: function removeItem(item) {
      var _this = this;

      if (item.id !== null) {
        this.Ask("¿Deseas cancelar la solicitud?", function () {
          _this.$http.delete("solicitudes/" + item.id).then(function (response) {
            var index = _this.list_usuarios.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this.list_usuarios.splice(index, 1);
            _this.StepOk('Solicitud Cancelada');
          }, function (error) {
            _this.Err(error);
          });
        });
      }
    },
    getStatus: function getStatus(status) {
      if (status === 0) {
        return "Solicitado";
      }
      if (status === 2) {
        return "Aprobado";
      } else {
        return "Rechazado";
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.initItem();

    this.$http.get("getSolicitudes").then(function (response) {
      var v = _this2;
      $.each(response.data.solicitudes, function (key, value) {
        v.list_usuarios.push({
          'updated_at': value.updated_at,
          'rfc': value.declarante.rfc,
          'id': value.id,
          'status': value.status,
          'usuario': value.usuario,
          'nombre': value.declarante.nombres + ' ' + value.declarante.primer_apellido + ' ' + value.declarante.segundo_apellido,
          'datos_actuales': {
            'dependencia': value.dependencia_origen.valor,
            'rfc': value.datos_actuales.rfc,
            'curp': value.datos_actuales.curp,
            'nombres': value.datos_actuales.nombres,
            'primer_apellido': value.datos_actuales.primer_apellido,
            'segundo_apellido': value.datos_actuales.segundo_apellido,
            'area_adscripcion': value.datos_actuales.area_adscripcion,
            'correo_laboral': value.datos_actuales.correo_laboral,
            'cargo': value.datos_actuales.empleo_cargo_comision,
            'toma_posesion': value.datos_actuales.fecha_posesion,
            'nivel_encargo': value.datos_actuales.nivel_encargo
          },
          'datos_cambio': {
            'dependencia': value.dependencia_destino.valor,
            'rfc': value.datos_cambio.rfc,
            'curp': value.datos_cambio.curp,
            'nombres': value.datos_cambio.nombres,
            'primer_apellido': value.datos_cambio.primer_apellido,
            'segundo_apellido': value.datos_cambio.segundo_apellido,
            'area_adscripcion': value.datos_cambio.area_adscripcion,
            'correo_laboral': value.datos_cambio.correo_laboral,
            'cargo': value.datos_cambio.empleo_cargo_comision,
            'toma_posesion': value.datos_cambio.fecha_posesion,
            'nivel_encargo': value.datos_cambio.nivel_encargo

          }
        });
      });
    }, function (error) {
      _this2.Err(error);
    });
  }
});

/***/ }),

/***/ "TtKX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UHWF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");














var _components;





/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), _components),
  data: function data() {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        dependencia_id1: '',
        periodo: ''
      },
      rol: '',
      filter: null,
      currentPage: 1,
      dependencias: {},
      perPage: 50,
      periodos: [],
      rows: null,
      tiposDeclaracion: [],
      list_cumplimiento: [],

      filtro_usuarios: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      faltantes_campos: {
        'ID': 'id',
        'RFC': 'rfc',
        'NOMBRE': 'nombres',
        'DEPENDENCIA': 'entidad',
        'CORREO LABORAL': 'correo'
      },
      no_declaraciones: {
        'Dependencia': 'dependencia',
        'Total Iniciales': 'r_iniciales',
        'Total Anuales': 'r_anuales',
        'Total Finales': 'r_finales'
      },
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Id',
        value: 'id',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: ''
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: ''
      }, {
        text: 'Correo Laboral',
        value: 'correo',
        align: ''
      }],
      headers2: [{
        text: 'Dependencia',
        align: '',
        value: 'dependencia'
      }, {
        text: 'Total Iniciales',
        value: 't_inicial',
        align: 'center'
      }, {
        text: 'Total Anuales',
        value: 't_anual',
        align: 'center'
      }, {
        text: 'Total Finales',
        value: 't_final',
        align: 'center'
      }],
      headers3: [{
        text: 'Dependencia',
        align: '',
        value: 'ente'
      }, {
        text: 'Total declaraciones',
        value: 'total',
        align: 'center'
      }, {
        text: 'Tipo',
        value: 'tipo',
        align: 'center'
      }],
      propsToSearch: ['rfc', 'nombres'],
      tableColumns: [{
        prop: 'id',
        label: 'Dec',
        minWidth: 150,
        vif: false
      }, {
        prop: 'rfc',
        label: 'RFC',
        minWidth: 150,
        vif: true
      }, {
        prop: 'nombres',
        label: 'Nombre',
        minWidth: 100,
        vif: true
      }]
    };
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_cumplimiento.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_cumplimiento.length;
        return this.pagedData;
      }
      var result = this.list_cumplimiento.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_cumplimiento.length;

      return this.list_cumplimiento.length;
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [1];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getTipoDeclaracion: function getTipoDeclaracion() {
      var _this2 = this;

      var v = this;
      this.$http.get("tiposDeclaracion").then(function (response) {
        _this2.tiposDeclaracion = response.data.tipoDeclaracion;
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getPeriodos: function getPeriodos() {
      var _this3 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this3.periodos = response.data.periodos;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    getDeclaracionesR: function getDeclaracionesR() {
      var _this4 = this;

      this.model.estatus = 0;
      this.model.tipo_declaracion = 4;
      this.model.periodo = new Date().getFullYear();


      this.$http.post("repndeclaraciones", this.model).then(function (response) {
        _this4.list_cumplimiento = [];
        response.data.forEach(function (value, key) {
          var obj = {
            dependencia: value.dependencia ? value.dependencia : '',
            cumplidos: value.cumplidos ? value.cumplidos : 0,
            obligados_iniciales: value.obligados_iniciales ? value.obligados_iniciales : 0,
            obligados_anuales: value.obligados_anuales ? value.obligados_anuales : 0,
            obligados_finales: value.obligados_finales ? value.obligados_finales : 0,
            r_iniciales: value.r_iniciales ? value.r_iniciales : 0,
            r_anuales: value.r_anuales ? value.r_anuales : 0,
            r_finales: value.r_finales ? value.r_finales : 0,
            l_inicial: 0,
            l_anual: 0,
            l_final: 0
          };

          if (value.obligados_iniciales > 0 && value.r_iniciales > 0) {
            obj.l_inicial = value.r_iniciales * 100 / value.obligados_iniciales;
          }
          if (value.obligados_anuales > 0 && value.r_anuales > 0) {
            obj.l_anual = value.r_anuales * 100 / value.obligados_anuales;
          }
          if (value.obligados_finales > 0 && value.r_finales > 0) {
            obj.l_final = value.r_finales * 100 / value.obligados_finales;
          }

          _this4.list_cumplimiento.push(obj);
        });
      }, function (error) {
        _this4.StepError(error);
      });
    },
    getDependencias: function getDependencias() {
      var _this5 = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this5.dependencias = response.data.entes_publicos;
        _this5.dependencias.unshift({
          'codigo': 'T',
          'id': 0,
          'valor': 'Todas'
        });
      }, function (error) {
        _this5.StepError(error);
      });
    },
    descargar: function descargar(row) {
      var url = this.$apiUrl + 'getDeclaracion/pdf/' + row.id + '/' + this.getKey('uid');
      window.open(url, '_blank');
    }
  },
  created: function created() {
    this.getDependencias();
    this.getTipoDeclaracion();

    this.rol = this.getKey('role');
    this.checkPermissions();
  }
});

/***/ }),

/***/ "UIFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_InfPersonal_vue__ = __webpack_require__("IeF3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_12667216_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_InfPersonal_vue__ = __webpack_require__("xwvh");
function injectStyle (ssrContext) {
  __webpack_require__("Ez/C")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_InfPersonal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_12667216_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_InfPersonal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UV0G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿ Tiene fideicomisos ? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fideicomisos),expression:"info.fideicomisos",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Datos del fideicomiso")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Participación en fideicomisos "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.participante),expression:"info.participante",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"participante","label":"1"},model:{value:(_vm.form_item.participante),callback:function ($$v) {_vm.$set(_vm.form_item, "participante", $$v)},expression:"form_item.participante"}},[_vm._v("Declarante")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"participante","label":"2"},model:{value:(_vm.form_item.participante),callback:function ($$v) {_vm.$set(_vm.form_item, "participante", $$v)},expression:"form_item.participante"}},[_vm._v("Pareja")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"participante","label":"3"},model:{value:(_vm.form_item.participante),callback:function ($$v) {_vm.$set(_vm.form_item, "participante", $$v)},expression:"form_item.participante"}},[_vm._v("Dependiente Económico")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('participante')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de fideicomiso "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_fideicomiso_id),expression:"info.tipo_fideicomiso_id",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"tipo_fideicomiso","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.tipo_fideicomiso_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_fideicomiso_id", $$v)},expression:"form_item.tipo_fideicomiso_id"}},_vm._l((_vm.tipos_fideicomisos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo_fideicomiso')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de participación "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_participacion_id),expression:"info.tipo_participacion_id",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"tipo_participacion","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.tipo_participacion_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_participacion_id", $$v)},expression:"form_item.tipo_participacion_id"}},_vm._l((_vm.tipos_fideicomisos_part),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo_participacion')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC del fideicomiso "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_fideicomiso),expression:"info.rfc_fideicomiso",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_fideicomiso),expression:"form_item.rfc_fideicomiso"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_fideicomiso","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_fideicomiso)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_fideicomiso", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_fideicomiso')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fideicomitente "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fideicomitente),expression:"info.fideicomitente",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"fideicomitente","label":"1"},model:{value:(_vm.form_item.fideicomitente),callback:function ($$v) {_vm.$set(_vm.form_item, "fideicomitente", $$v)},expression:"form_item.fideicomitente"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"fideicomitente","label":"2"},model:{value:(_vm.form_item.fideicomitente),callback:function ($$v) {_vm.$set(_vm.form_item, "fideicomitente", $$v)},expression:"form_item.fideicomitente"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('fideicomitente')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre o razón social del fideicomitente "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_fideicomitente),expression:"info.nombre_fideicomitente",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_fideicomitente),expression:"form_item.nombre_fideicomitente"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_fideicomitente","placeholder":"Nombre o razón social del otorgante "},domProps:{"value":(_vm.form_item.nombre_fideicomitente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_fideicomitente", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_fideicomitente')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_fideicomitente),expression:"info.rfc_fideicomitente",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_fideicomitente),expression:"form_item.rfc_fideicomitente"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_fideicomitente","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_fideicomitente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_fideicomitente", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_fideicomitente')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre o razón social del fiduciario "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_fiduciario),expression:"info.nombre_fiduciario",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_fiduciario),expression:"form_item.nombre_fiduciario"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_fiduciario","placeholder":"Nombre o razón social del otorgante "},domProps:{"value":(_vm.form_item.nombre_fiduciario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_fiduciario", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_fiduciario')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_fiduciario),expression:"info.rfc_fiduciario",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_fiduciario),expression:"form_item.rfc_fiduciario"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_fiduciario","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_fiduciario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_fiduciario", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_fiduciario')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fideicomisario "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fideicomisario),expression:"info.fideicomisario",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"fideicomisario","label":"1"},model:{value:(_vm.form_item.fideicomisario),callback:function ($$v) {_vm.$set(_vm.form_item, "fideicomisario", $$v)},expression:"form_item.fideicomisario"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"fideicomisario","label":"2"},model:{value:(_vm.form_item.fideicomisario),callback:function ($$v) {_vm.$set(_vm.form_item, "fideicomisario", $$v)},expression:"form_item.fideicomisario"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('fideicomisario')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre o razón social del fideicomisario "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_fideicomisario),expression:"info.nombre_fideicomisario",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_fideicomisario),expression:"form_item.nombre_fideicomisario"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_fideicomisario","placeholder":"Nombre o razón social del otorgante "},domProps:{"value":(_vm.form_item.nombre_fideicomisario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_fideicomisario", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_fideicomisario')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_fideicomisario),expression:"info.rfc_fideicomisario",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_fideicomisario),expression:"form_item.rfc_fideicomisario"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_fideicomisario","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_fideicomisario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_fideicomisario", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_fideicomisario')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector productivo al que pertenece "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.sector),expression:"info.sector",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"sector","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.form_item, "sector_industria_id", $$v)},expression:"form_item.sector_industria_id"}},_vm._l((_vm.sectores_industria),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('sector')))])],1),_vm._v(" "),_c('legend',[_vm._v("¿Dónde se localiza el fideicomiso? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.lugar),expression:"info.lugar",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" País ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"pais","filterable":"","placeholder":"País"},model:{value:(_vm.form_item.pais_id),callback:function ($$v) {_vm.$set(_vm.form_item, "pais_id", $$v)},expression:"form_item.pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('pais')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.participante",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterDeclarante(item.participante)))])]}},{key:"item.tipo_fideicomiso_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipofideicomiso(item.tipo_fideicomiso_id)))])]}},{key:"item.tipo_participacion_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipoFideicomisoPart(item.tipo_participacion_id)))])]}},{key:"item.otorgante",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipoPersona(item.otorgante)))])]}},{key:"item.sector_industria_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterSector(item.sector_industria_id)))])]}}],null,false,796563131)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("FIDEICOMISOS (HASTA LOS ÚLTIMOS 2 AÑOS) ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de la participación en fideicomisos de la pareja o dependientes económicos no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UmAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid card card-content p-3"},[_c('legend',[_vm._v("Verificar el estado del servidor público ( RFC ):")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control text-uppercase",attrs:{"type":"text","placeholder":"Buscar"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}}),_vm._v(" "),(_vm.busqueda)?_c('small',{staticClass:"text-danger"},[_vm._v("La búsqueda requiere un mínimo de 10 letras")]):_vm._e()]),_vm._v(" "),(_vm.txtemp)?_c('div',{staticClass:"coloremp",domProps:{"innerHTML":_vm._s(_vm.txtemp)}}):_vm._e(),_vm._v(" "),(Object.keys(_vm.uTemp).length !== 0)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_vm._v("\n      "+_vm._s(_vm.uTemp.nombres)+" "+_vm._s(_vm.uTemp.primer_apellido)+" "+_vm._s(_vm.uTemp.segundo_apellido)+", "+_vm._s(_vm.uTemp.rfc)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-12 font-weight-bolder"},[_vm._v("\n      "+_vm._s(_vm.uTemp.fecha_termino?'Usuario con baja':'Usuario activo')+" en "+_vm._s(_vm.uTemp.ente)+"\n    ")]),_vm._v(" "),(!_vm.uTemp.fecha_termino)?_c('div',{staticClass:"col-12 text-danger"},[_c('v-alert',{staticClass:"mt-3 p-2",attrs:{"color":"orange"}},[_vm._v("\n        El servidor público actualmente se encuentra Activo. Verifique esta información con el usuario ya que debe solicitar la baja antes de crear el alta del usuario.\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.uTemp.fecha_termino !=null)?_c('div',{staticClass:"col-12 mb-3"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.copyData()}}},[_vm._m(0)])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.pendientes)?_c('div',[_c('legend',[_vm._v("Información general del Servidor Público")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Nombre(s)\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.nombres),expression:"modelValidations.nombres"},{name:"model",rawName:"v-model",value:(_vm.model.nombres),expression:"model.nombres"}],staticClass:"form-control",attrs:{"type":"text","name":"nombres","placeholder":"Nombre(s)"},domProps:{"value":(_vm.model.nombres)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nombres", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombres.invalid),expression:"nombres.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('nombres'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Apellido Paterno\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.primer_apellido),expression:"modelValidations.primer_apellido"},{name:"model",rawName:"v-model",value:(_vm.model.primer_apellido),expression:"model.primer_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"primer_apellido","placeholder":"Apellido Paterno"},domProps:{"value":(_vm.model.primer_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "primer_apellido", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.primer_apellido.invalid),expression:"primer_apellido.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('primer_apellido'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Apellido Materno\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.segundo_apellido),expression:"model.segundo_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"segundo_apellido","placeholder":"Apellido Materno"},domProps:{"value":(_vm.model.segundo_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "segundo_apellido", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          CURP\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.curp),expression:"modelValidations.curp"},{name:"model",rawName:"v-model",value:(_vm.model.curp),expression:"model.curp"}],staticClass:"form-control",attrs:{"type":"text","name":"curp","placeholder":"CURP"},domProps:{"value":(_vm.model.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "curp", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.curp.invalid),expression:"curp.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('curp'))+"\n        ")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.validaciones.curp),expression:"validaciones.curp"}],staticClass:"text-danger"},[_vm._v("\n          El formato de la CURP no es válido, verifica la información\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          RFC:\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.rfc),expression:"modelValidations.rfc"},{name:"model",rawName:"v-model",value:(_vm.model.rfc),expression:"model.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.model.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.rfc.invalid),expression:"rfc.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('rfc'))+"\n        ")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.validaciones.rfc),expression:"validaciones.rfc"}],staticClass:"text-danger"},[_vm._v("\n          El formato del RFC no es válido, verifica la información\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Fecha de Nacimiento\n        ")]),_vm._v(" "),_c('div',{staticClass:"form-group m-0"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.fecha_nacimiento),expression:"modelValidations.fecha_nacimiento"}],attrs:{"name":"fecha_nacimiento","format":"dd/MM/yyyy","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_nacimiento),callback:function ($$v) {_vm.$set(_vm.model, "fecha_nacimiento", $$v)},expression:"model.fecha_nacimiento"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.fecha_nacimiento.invalid),expression:"fecha_nacimiento.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('fecha_nacimiento'))+"\n        ")])])]),_vm._v(" "),_c('legend',[_vm._v("Datos de la declaracion")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Tipo de declaración\n        ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"simplificada","placeholder":"Tipo de declaración"},model:{value:(_vm.model.simplificada),callback:function ($$v) {_vm.$set(_vm.model, "simplificada", $$v)},expression:"model.simplificada"}},_vm._l((_vm.tipos),function(option){return _c('el-option',{key:option.id,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('simplificada'))+"\n        ")])],1),_vm._v(" "),(Object.keys(_vm.uTemp).length === 0)?_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Declaración a realizar\n        ")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"tipo_dec","placeholder":"Tipo declaración"},model:{value:(_vm.model.tipo_dec),callback:function ($$v) {_vm.$set(_vm.model, "tipo_dec", $$v)},expression:"model.tipo_dec"}},_vm._l((_vm.tipo_declaracion),function(option){return _c('el-option',{key:option.id+'tipo',staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('tipo_dec'))+"\n        ")])],1):_vm._e(),_vm._v(" "),(Object.keys(_vm.uTemp).length === 0)?_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Periodo\n        ")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.model.periodo),callback:function ($$v) {_vm.$set(_vm.model, "periodo", $$v)},expression:"model.periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('periodo'))+"\n        ")])],1):_vm._e()]),_vm._v(" "),_c('legend',[_vm._v("Datos del encargo actual del Servidor Público.")]),_vm._v(" "),(_vm.getKey('permisos').includes(17))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Ente público\n        ")]),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.ente),expression:"modelValidations.ente"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"ente","placeholder":"Ente"},model:{value:(_vm.model.ente_publico_id),callback:function ($$v) {_vm.$set(_vm.model, "ente_publico_id", $$v)},expression:"model.ente_publico_id"}},_vm._l((_vm.entes),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.ente.invalid),expression:"ente.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('ente'))+"\n        ")])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Nombre del Empleo, Cargo o Comisión\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.nombre_cargo),expression:"modelValidations.nombre_cargo"},{name:"model",rawName:"v-model",value:(_vm.model.empleo_cargo_comision),expression:"model.empleo_cargo_comision"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_cargo","placeholder":"Nombre del Cargo"},domProps:{"value":(_vm.model.empleo_cargo_comision)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "empleo_cargo_comision", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombre_cargo.invalid),expression:"nombre_cargo.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('nombre_cargo'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Contrato por honorarios.\n        ")]),_c('br'),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.honorarios),expression:"modelValidations.honorarios"}],attrs:{"name":"honorarios","label":"1"},model:{value:(_vm.model.contratado_honorarios),callback:function ($$v) {_vm.$set(_vm.model, "contratado_honorarios", $$v)},expression:"model.contratado_honorarios"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.honorarios),expression:"modelValidations.honorarios"}],attrs:{"name":"honorarios","label":"2"},model:{value:(_vm.model.contratado_honorarios),callback:function ($$v) {_vm.$set(_vm.model, "contratado_honorarios", $$v)},expression:"model.contratado_honorarios"}},[_vm._v("NO")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.honorarios.invalid),expression:"honorarios.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('honorarios'))+"\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Área\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.area),expression:"modelValidations.area"},{name:"model",rawName:"v-model",value:(_vm.model.area_adscripcion),expression:"model.area_adscripcion"}],staticClass:"form-control",attrs:{"type":"text","name":"area","placeholder":"Area de adscripción"},domProps:{"value":(_vm.model.area_adscripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "area_adscripcion", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.area.invalid),expression:"area.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('area'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Fecha de toma de Posesión\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.toma_posesion),expression:"modelValidations.toma_posesion"}],attrs:{"name":"toma_posesion","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","picker-options":_vm.opciones,"type":"date","placeholder":"Selecciona"},model:{value:(_vm.model.fecha_posesion),callback:function ($$v) {_vm.$set(_vm.model, "fecha_posesion", $$v)},expression:"model.fecha_posesion"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.toma_posesion.invalid),expression:"toma_posesion.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('toma_posesion'))+"\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Nivel\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.nivel),expression:"modelValidations.nivel"},{name:"model",rawName:"v-model",value:(_vm.model.nivel_encargo),expression:"model.nivel_encargo"}],staticClass:"form-control",attrs:{"type":"text","name":"nivel","placeholder":"Nivel"},domProps:{"value":(_vm.model.nivel_encargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nivel_encargo", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nivel.invalid),expression:"nivel.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('nivel'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Teléfono Laboral\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.telefono_laboral_numero),expression:"model.telefono_laboral_numero"}],staticClass:"form-control",attrs:{"type":"text","name":"curp","placeholder":"Teléfono Laboral"},domProps:{"value":(_vm.model.telefono_laboral_numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "telefono_laboral_numero", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Ext\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.telefono_laboral_extension),expression:"model.telefono_laboral_extension"}],staticClass:"form-control",attrs:{"type":"text","name":"curp","placeholder":"Teléfono Laboral"},domProps:{"value":(_vm.model.telefono_laboral_extension)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "telefono_laboral_extension", $event.target.value)}}})])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.mostrarCampos)?_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Correo Electrónico Laboral\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.correo_laboral),expression:"modelValidations.correo_laboral"},{name:"model",rawName:"v-model",value:(_vm.model.correo_laboral),expression:"model.correo_laboral"}],staticClass:"form-control",attrs:{"type":"text","name":"correo_laboral","placeholder":"Correo Laboral"},domProps:{"value":(_vm.model.correo_laboral)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "correo_laboral", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.correo_laboral.invalid),expression:"correo_laboral.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('correo_laboral'))+"\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          RFC Patron:\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.rfc_patron),expression:"modelValidations.rfc_patron"},{name:"model",rawName:"v-model",value:(_vm.model.rfc_patron),expression:"model.rfc_patron"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_patron","placeholder":"RFC del Patron"},domProps:{"value":(_vm.model.rfc_patron)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "rfc_patron", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.rfc.invalid),expression:"rfc.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('rfc_patron'))+"\n        ")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.validaciones.rfc_patron),expression:"validaciones.rfc_patron"}],staticClass:"text-danger"},[_vm._v("\n          El formato del RFC no es válido, verifica la información\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Correo Electrónico Laboral\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.correo_laboral),expression:"modelValidations.correo_laboral"},{name:"model",rawName:"v-model",value:(_vm.model.correo_laboral),expression:"model.correo_laboral"}],staticClass:"form-control",attrs:{"type":"text","name":"correo_laboral","placeholder":"Correo Laboral"},domProps:{"value":(_vm.model.correo_laboral)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "correo_laboral", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.correo_laboral.invalid),expression:"correo_laboral.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('correo_laboral'))+"\n        ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('domicilio',{ref:"Domicilio",attrs:{"titulo":"/Ubicación del Cargo"},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('button',{staticClass:"btn btn-info btn-wd pull-right",on:{"click":_vm.guardar}},[_vm._m(1),_vm._v("\n          GUARDAR\n        ")])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"far fa-copy"}),_vm._v(" Copiar datos del usuario\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-save"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UnLW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");














var _components;





/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), _components),
  data: function data() {
    var _ref;

    return _ref = {
      model: { tipo_declaracion: '', dependencia_id: '', periodo: '' },
      dependencias: {},
      rol: '',
      filter: null,
      currentPage: 1,
      perPage: 50,
      periodos: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'model', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'rows', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tiposDeclaracion', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'list_bitacora', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'filtro_usuarios', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pagination', {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      total: 0
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'searchQuery', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fields_list', [{
      key: "rfc",
      label: "RFC",
      thClass: "td-small",
      tdClass: "text-center td-small"
    }, {
      key: "nombres",
      label: "Nombres",
      thClass: "td-small",
      tdClass: "text-center td-small"
    }, {
      key: "dependencia",
      label: "Dependencia",
      thClass: "td-small",
      tdClass: "text-center td-small"
    }, {
      key: "tipodeclaracion",
      label: "Tipo",
      thClass: "td-small",
      tdClass: "text-center td-small"
    }, {
      key: "usuario",
      label: "Usuario",
      thClass: "td-small",
      tdClass: "text-left td-small"
    }, {
      key: "fecha",
      label: "Fecha",
      thClass: "td-small",
      tdClass: "text-left td-small"
    }]), _ref;
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_bitacora.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_bitacora.length;
        return this.pagedData;
      }
      var result = this.list_bitacora.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_bitacora.length;

      return this.list_bitacora.length;
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [1];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getModificadas: function getModificadas() {
      var _this2 = this;

      this.$http.get("getModificadas").then(function (response) {
        var v = _this2;
        v.list_bitacora = [];

        $.each(response.data.declaraciones, function (key, value) {

          v.list_bitacora.push({ 'rfc': value.declarante[0].rfc,
            'nombres': value.declarante[0].nombres + ' ' + value.declarante[0].primer_apellido + ' ' + value.declarante[0].segundo_apellido,
            'dependencia': value.declarante[0].encargo.ente.valor,
            'usuario': value.usuario.Nombre + ' ' + value.usuario.Paterno + ' ' + value.usuario.Materno,
            'fecha': value.created_at,
            'tipodeclaracion': value.tipo_dec.tipo_declaracion
          });
        });
      }, function (error) {
        _this2.StepError(error);
      });
    }
  },
  created: function created() {
    this.rol = this.getKey('role');
    this.checkPermissions();
    this.getModificadas();
  }
});

/***/ }),

/***/ "UoZB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uz+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");











var _components;






/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), _components),
  data: function data() {
    return {
      loadBitacora: true,
      loadCorreccion: false,
      correccion: {
        id: null,
        ip_id: null,
        declaracion_id: null,
        dependencia_orgen: null,
        dependencia_orgen_id: null,
        dependencia_destino_id: null,
        periodo: null,
        tipo_declaracion_id: null,
        observaciones: null
      },
      intDialogVisible: false,
      tipo_declaracion: [{
        'id': 1,
        'valor': 'Inicial'
      }, {
        'id': 2,
        'valor': 'Anual'
      }, {
        'id': 3,
        'valor': 'Final'
      }],

      loading: false,
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        periodo: '2020'
      },
      dependencias: {},
      filtrainici: false,
      inicialeslst: [{
        'id': 1,
        'valor': 'A-B',
        'cve': '1'
      }, {
        'id': 2,
        'valor': 'C-D',
        'cve': '2'
      }, {
        'id': 3,
        'valor': 'E-F',
        'cve': '3'
      }, {
        'id': 4,
        'valor': 'G-H',
        'cve': '4'
      }, {
        'id': 5,
        'valor': 'I-J',
        'cve': '5'
      }, {
        'id': 6,
        'valor': 'K-L',
        'cve': '1'
      }, {
        'id': 7,
        'valor': 'M-N',
        'cve': '2'
      }, {
        'id': 8,
        'valor': 'Ñ-O',
        'cve': '3'
      }, {
        'id': 9,
        'valor': 'P-Q',
        'cve': '4'
      }, {
        'id': 10,
        'valor': 'R-S',
        'cve': '5'
      }, {
        'id': 11,
        'valor': 'T-U',
        'cve': '3'
      }, {
        'id': 12,
        'valor': 'V-W',
        'cve': '4'
      }, {
        'id': 13,
        'valor': 'X-Z',
        'cve': '5'
      }],
      rol: '',
      filter: '',
      iniciales: '',
      nombre: '',
      activo: null,
      alta: '',
      baja: '',
      filter2: '',
      shhistorico: false,
      shlista: true,
      currentPage: 1,
      table_list: [],
      justificados: [],
      perPage: 50,
      periodos: [],
      rows: null,
      tiposDeclaracion: [{
        'id': 1,
        'tipo_declaracion': 'Inicial'
      }, {
        'id': 2,
        'tipo_declaracion': 'Anual'
      }, {
        'id': 3,
        'tipo_declaracion': 'Final'
      }],
      list_cumplimiento: [],

      filtro_usuarios: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      headers2: [{
        text: 'Año',
        value: 'periodo',
        align: 'center',
        class: ''
      }, {
        text: 'Tipo',
        value: 'Tipo_Dec',
        align: 'center',
        class: ''
      }, {
        text: 'Declaración Patrimonial',
        value: 'patrimonial',
        align: 'center',
        class: ''
      }, {
        text: 'Declaración fiscal',
        value: 'fiscal',
        align: 'center',
        class: ''
      }, {
        text: 'Acuse',
        value: 'acuse',
        align: 'center',
        class: ''
      }, {
        text: 'Aclaraciones',
        value: 'aclaraciones',
        align: 'center',
        class: ''
      }, {
        text: 'Entidad / Dependencia',
        value: 'entidad',
        align: 'center',
        class: '',
        width: "200px"
      }, {
        text: 'Cargo',
        value: 'cargo',
        align: 'center',
        class: ''
      }, {
        text: 'Fecha Posesion',
        value: 'posesion',
        align: 'center',
        class: ''
      }, {
        text: 'Fecha Presentación',
        value: 'presentacion',
        align: 'center',
        class: ''
      }],
      headers3: [{
        text: 'Año',
        value: 'periodo',
        align: 'center',
        class: '',
        width: "200px"
      }, {
        text: 'Tipo',
        value: 'Tipo_Dec',
        align: 'center',
        class: ''
      }, {
        text: 'Acuse',
        value: 'acuse',
        align: 'center',
        class: ''
      }, {
        text: 'Entidad / Dependencia',
        value: 'entidad',
        align: 'center',
        class: ''
      }, {
        text: 'Cargo',
        value: 'cargo',
        align: 'center',
        class: ''
      }, {
        text: 'Fecha Posesion',
        value: 'posesion',
        align: 'center',
        class: ''
      }, {
        text: 'Fecha Presentación',
        value: 'presentacion',
        align: 'center',
        class: ''
      }],
      headers4: [{
        text: 'Año',
        value: 'periodo',
        align: 'center',
        class: ''
      }, {
        text: 'Tipo Declaracion',
        value: 'tipo_declaracion',
        align: 'center',
        class: '',
        width: "200px"
      }, {
        text: 'Entidad/Dependencia',
        value: 'valor',
        align: 'center',
        class: ''
      }],
      headers: [{
        text: 'Histórico',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Área',
        value: 'area',
        align: 'center'
      }, {
        text: 'Cargo',
        value: 'cargo',
        align: 'center'
      }],

      propsToSearch: ['rfc', 'nombres'],
      tableColumns: [{
        prop: 'id',
        label: 'Dec',
        minWidth: 150,
        vif: false
      }, {
        prop: 'rfc',
        label: 'RFC',
        minWidth: 150,
        vif: true
      }, {
        prop: 'nombres',
        label: 'Nombre',
        minWidth: 100,
        vif: true
      }]
    };
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    dateFormat2: function dateFormat2(date) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date, 'DD-MM-YYYY').format('DD/MM/YYYY');
    },
    checkPermissions: function checkPermissions() {
      var permiso = [1, 25];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getEntidad: function getEntidad(item) {
      return JSON.parse(item.datos_encargo_actual)[0].ente.valor;
    },
    getFechaPos: function getFechaPos(item) {
      return this.dateFormat2(JSON.parse(item.datos_encargo_actual)[0].fecha_posesion);
    },
    getCargo: function getCargo(item) {
      return JSON.parse(item.datos_encargo_actual)[0].empleo_cargo_comision;
    },
    getDependencias: function getDependencias() {
      var _this = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this.dependencias = response.data.entes_publicos;
        _this.dependencias.unshift({
          'codigo': 'T',
          'id': 0,
          'valor': 'Todas'
        });
      }, function (error) {
        _this.StepError(error);
      });
    },
    getPeriodos: function getPeriodos() {
      var _this2 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this2.periodos = response.data.periodos;
      }, function (error) {
        _this2.StepError(error);
      });
    },
    descargaFiscal: function descargaFiscal(file) {
      var obj = JSON.parse(file);
      if (obj[0]) {
        var url = this.$rootUrl + '/declaraciones_fiscales/' + obj[0].file;
        window.open(url, '_blank');
      } else {
        this.StepW("No tiene declaración fiscal");
      }
    },
    descargaAclaracion: function descargaAclaracion(file) {
      var obj = JSON.parse(file);
      if (obj[0]) {
        var url = this.$rootUrl + '/declaraciones_aclaraciones/' + obj[0].file;
        window.open(url, '_blank');
      } else {
        this.StepW("No tiene aclaraciones");
      }
    },
    traeiniciales: function traeiniciales() {
      var _this3 = this;

      this.loading = true;
      this.coloremp = 'info';
      this.txtemp = 'Buscando...';
      this.filtro_usuarios = [];
      this.list_declarantes2 = [];
      var desde = void 0;
      var hasta = void 0;
      if (this.iniciales == 1) {
        desde = 'A';
        hasta = 'C';
      }
      if (this.iniciales == 2) {
        desde = 'C';
        hasta = 'E';
      }
      if (this.iniciales == 3) {
        desde = 'E';
        hasta = 'G';
      }
      if (this.iniciales == 4) {
        desde = 'G';
        hasta = 'I';
      }
      if (this.iniciales == 5) {
        desde = 'I';
        hasta = 'K';
      }
      if (this.iniciales == 6) {
        desde = 'K';
        hasta = 'M';
      }
      if (this.iniciales == 7) {
        desde = 'M';
        hasta = 'O';
      }
      if (this.iniciales == 8) {
        desde = 'O';
        hasta = 'P';
      }
      if (this.iniciales == 9) {
        desde = 'P';
        hasta = 'R';
      }
      if (this.iniciales == 10) {
        desde = 'R';
        hasta = 'T';
      }
      if (this.iniciales == 11) {
        desde = 'T';
        hasta = 'V';
      }
      if (this.iniciales == 12) {
        desde = 'V';
        hasta = 'X';
      }
      if (this.iniciales == 13) {
        desde = 'X';
        hasta = 'ZZ';
      }

      this.$http.get("hdeclaraciones/" + this.model.dependencia_id + '/' + desde + '/' + hasta).then(function (response) {
        _this3.loading = false;
        _this3.list_cumplimiento = [];
        response.data.declarantes.forEach(function (value, key) {
          _this3.list_cumplimiento.push({
            'id': value.id,
            'rfc': value.rfc,
            'nombres': value.nombre,
            'entidad': value.entidad,
            'area': value.area,
            'cargo': value.cargo,
            'activo': value.activo,
            'alta': value.alta,
            'baja': value.baja
          });
        });
        _this3.filtro_usuarios = _this3.list_cumplimiento;
      }, function (error) {
        _this3.loading = false;
        _this3.StepError(error);
      });
    },
    getDeclaraciones: function getDeclaraciones() {
      var _this4 = this;

      this.loading = true;
      this.filtrainici = false;
      var dec = 0;
      this.filtro_usuarios = [];
      dec = this.getServid(this.model.dependencia_id);
      if (dec <= 10000) {
        this.$http.post("hdeclaraciones", this.model).then(function (response) {
          _this4.loading = false;
          _this4.list_cumplimiento = [];

          response.data.declarantes.forEach(function (value, key) {

            _this4.list_cumplimiento.push({
              'id': value.id,
              'rfc': value.rfc,
              'nombres': value.nombre,
              'entidad': value.entidad,
              'area': value.area,
              'cargo': value.cargo,
              'activo': value.activo,
              'alta': value.alta,
              'baja': value.baja
            });
          });
          _this4.filtro_usuarios = _this4.list_cumplimiento;
        }, function (error) {
          _this4.loading = false;
          _this4.StepError(error);
        });
      } else {
        this.Ask2("La dependencia tiene más de 10 mil declarantes, ¿desea realizar filtrado por RFC?", function () {
          _this4.filtrainici = true;
        }, function () {
          _this4.StepInfo("El proceso puede tardar varios minutos.");
          _this4.$http.post("hdeclaraciones", _this4.model).then(function (response) {
            _this4.loading = false;
            _this4.list_cumplimiento = [];
            response.data.declarantes.forEach(function (value, key) {
              _this4.list_cumplimiento.push({
                'id': value.id,
                'rfc': value.rfc,
                'nombres': value.nombre,
                'entidad': value.entidad,
                'area': value.area,
                'cargo': value.cargo,
                'activo': value.activo,
                'alta': value.alta,
                'baja': value.baja
              });
            });
            _this4.filtro_usuarios = _this4.list_cumplimiento;
          }, function (error) {
            _this4.loading = false;
            _this4.StepError(error);
          });
        });
      }
    },
    descargar: function descargar(row) {
      var _this5 = this;

      this.Ask("¿Desea descargar ésta declaración?", function () {
        var cargando = _this5.$swal({
          showConfirmButton: false,
          type: "warning",
          title: _this5.texto,
          text: 'Esta información es confidencial y tu acceso ha sido registrado por políticas de seguridad',
          showCloseButton: _this5.close
        });

        _this5.$http.get(_this5.$apiUrl + 'getDeclaracionComp/pdf/' + row.declaracion_id + "/" + _this5.getKey('uid'), {
          responseType: 'arraybuffer'
        }).then(function (response) {
          _this5.downloadFile(response, 'Declaración');
        }, function (error) {
          _this5.StepError(error);
        });
      });
    },
    descargaAcuse: function descargaAcuse(row) {
      var _this6 = this;

      this.$http.get(this.$apiUrl + 'getAcuseAdmin/' + row.declaracion_id, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this6.downloadFile(response, 'Acuse');
      }, function (error) {
        _this6.StepError(error);
      });
    },
    downloadFile: function downloadFile(response, filename) {
      var newBlob = new Blob([response.body], {
        type: 'application/pdf'
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      var data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = data;
      link.download = filename + '.pdf';
      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    historico: function historico(row) {
      var _this7 = this;

      this.shlista = false;
      this.shhistorico = true;
      this.nombre = row.rfc;
      this.activo = row.activo;
      this.alta = this.dateFormat(row.alta);
      this.baja = null;
      if (row.baja) {
        this.baja = this.dateFormat(row.baja);
      }
      this.$http.get("historicolst/" + row.id).then(function (response) {
        _this7.table_list = response.data.response;
        _this7.justificados = response.data.justificados;
      }, function (error) {
        _this7.Err(error);
      });
    },
    historico2: function historico2(id) {
      var _this8 = this;

      this.$http.get("historicolst/" + id).then(function (response) {
        _this8.table_list = response.data.response;
        _this8.justificados = response.data.justificados;
      }, function (error) {
        _this8.Err(error);
      });
    },
    editBitacora: function editBitacora(item) {
      var _this9 = this;

      this.$validator.pause();
      this.correccion = {
        id: null,
        ip_id: null,
        declaracion_id: null,
        dependencia_orgen: null,
        dependencia_orgen_id: null,
        dependencia_destino_id: null,
        periodo: null,
        tipo_declaracion_id: null,
        observaciones: null
      };

      var ente = JSON.parse(item.datos_encargo_actual)[0].ente;

      this.correccion.ip_id = item.ip_id;
      this.correccion.declaracion_id = item.declaracion_id;
      this.correccion.dependencia_orgen_id = ente.id;
      this.correccion.dependencia_orgen = ente.valor;

      var bitacoraItem = {
        ip_id: item.ip_id,
        declaracion_id: item.declaracion_id
      };

      this.intDialogVisible = true;
      this.modalTitle = "Editar declaración";

      this.loadBitacora = true;
      this.$http.post("bitacoracorreccion_consulta", bitacoraItem).then(function (response) {
        _this9.loadBitacora = false;
        _this9.correccion.id = response.data.bitacora.id;
        _this9.correccion.tipo_declaracion_id = response.data.bitacora.tipo_declaracion_id;
        _this9.correccion.periodo = response.data.bitacora.periodo;

        _this9.$validator.resume();
      }, function (error) {
        _this9.Err(error);
      });
    },
    makeCorrection: function makeCorrection() {
      var _this10 = this;

      this.valida().then(function (response) {
        if (response) {
          _this10.loadCorreccion = true;

          _this10.$http.post("bitacoracorreccion", _this10.correccion).then(function (response) {
            _this10.StepOk("Guardado");
            _this10.loadCorreccion = false;
            _this10.intDialogVisible = false;
            _this10.historico2(_this10.correccion.ip_id);
          }, function (error) {
            _this10.loadCorreccion = false;
            _this10.StepW(error);
          });
        } else {
          _this10.StepW("Hay campos sin completar");
        }
      });
    },
    valida: function valida() {
      return this.$validator.validateAll();
    },
    regresar: function regresar() {
      this.shlista = true;
      this.shhistorico = false;
    },
    getServid: function getServid(index) {
      var a = 0;
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            a = item.declarantes_count;
          }
        });
      }
      return a;
    }
  },
  created: function created() {
    var _this11 = this;

    this.getDependencias();

    this.model.dependencia_id = this.getKey("ente_publico_id");

    this.$http.get("cat/dec").then(function (response) {
      _this11.dependencias = response.data.entes_publicos;
      _this11.getDeclaraciones();
    }, function (error) {
      _this11.Err(error);
    });

    this.getPeriodos();
    this.rol = this.getKey('role');

    this.checkPermissions();
  }
});

/***/ }),

/***/ "V2pR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VFZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿Tiene préstamo o comodato por terceros? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.prestamos),expression:"info.prestamos",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Tipo de bien "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_bien),expression:"info.tipo_bien",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_c('br'),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"Tipo","label":"1"},model:{value:(_vm.form_item.tipo_bien),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_bien", $$v)},expression:"form_item.tipo_bien"}},[_vm._v("Inmueble ")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"Tipo","label":"2"},model:{value:(_vm.form_item.tipo_bien),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_bien", $$v)},expression:"form_item.tipo_bien"}},[_vm._v("Vehiculo ")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('Tipo')))])],1),_vm._v(" "),(_vm.form_item.tipo_bien =='1')?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de inmueble "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_inmueble),expression:"info.tipo_inmueble",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"inmueble","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.tipo_inmueble_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_inmueble_id", $$v)},expression:"form_item.tipo_inmueble_id"}},_vm._l((_vm.tipos_inmuebles),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('inmueble')))])],1):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_bien =='2')?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de vehiculo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_vehiculo),expression:"info.tipo_vehiculo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"mueble","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.tipo_vehiculo_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_vehiculo_id", $$v)},expression:"form_item.tipo_vehiculo_id"}},_vm._l((_vm.tipos_vehiculos),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('mueble')))])],1):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_inmueble_id == 4 || _vm.form_item.tipo_vehiculo_id == 5)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique),expression:"form_item.especifique"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique')))])]):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_bien =='2')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Marca "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.marca),expression:"info.marca",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.marca),expression:"form_item.marca"}],staticClass:"form-control",attrs:{"type":"text","name":"marca","placeholder":"Marca"},domProps:{"value":(_vm.form_item.marca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "marca", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('marca')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Model "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.modelo),expression:"info.modelo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.modelo),expression:"form_item.modelo"}],staticClass:"form-control",attrs:{"type":"text","name":"modelo","placeholder":"Modelo"},domProps:{"value":(_vm.form_item.modelo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "modelo", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('modelo')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Año "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.anio),expression:"info.anio",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.anio),expression:"form_item.anio"}],staticClass:"form-control",attrs:{"type":"text","name":"año","placeholder":"Año"},domProps:{"value":(_vm.form_item.anio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "anio", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('año')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Número de Serie "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.serie),expression:"info.serie",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.numero_serie),expression:"form_item.numero_serie"}],staticClass:"form-control",attrs:{"type":"text","name":"serie","placeholder":"Número de Serie o Registro"},domProps:{"value":(_vm.form_item.numero_serie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "numero_serie", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('serie')))])]),_vm._v(" "),_c('legend',[_vm._v("Datos del dueño\n          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" Dueño o titular "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.titular),expression:"info.titular",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_c('br'),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"titular","label":"1"},model:{value:(_vm.form_item.titular_tipo),callback:function ($$v) {_vm.$set(_vm.form_item, "titular_tipo", $$v)},expression:"form_item.titular_tipo"}},[_vm._v(" Persona Física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"titular","label":"2"},model:{value:(_vm.form_item.titular_tipo),callback:function ($$v) {_vm.$set(_vm.form_item, "titular_tipo", $$v)},expression:"form_item.titular_tipo"}},[_vm._v(" Persona Moral")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('titular')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre del Dueño o Titular "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre),expression:"info.nombre",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_titular),expression:"form_item.nombre_titular"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre","placeholder":"Nombre del Dueño o Titular"},domProps:{"value":(_vm.form_item.nombre_titular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_titular", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc),expression:"info.rfc",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc),expression:"form_item.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Relación con el dueño o titular "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.relacion),expression:"info.relacion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.relacion_titular),expression:"form_item.relacion_titular"}],staticClass:"form-control",attrs:{"type":"text","name":"relacion","placeholder":"Relación con el dueño o titular"},domProps:{"value":(_vm.form_item.relacion_titular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "relacion_titular", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('relacion')))])]),_vm._v(" "),_c('legend',[_vm._v("Donde se encuentra registrado "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.lugar),expression:"info.lugar",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" País ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"pais","filterable":"","placeholder":"País"},model:{value:(_vm.form_item.pais_id),callback:function ($$v) {_vm.$set(_vm.form_item, "pais_id", $$v)},expression:"form_item.pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('pais')))])],1),_vm._v(" "),(_vm.form_item.pais_id==150)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" Entidad Federativa ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"entidad","filterable":"","placeholder":"Entidad"},model:{value:(_vm.form_item.entidad_federativa_id),callback:function ($$v) {_vm.$set(_vm.form_item, "entidad_federativa_id", $$v)},expression:"form_item.entidad_federativa_id"}},_vm._l((_vm.entidades),function(option){return _c('el-option',{key:option.nom_ent,staticClass:"select-default",attrs:{"value":option.id,"label":option.nom_ent}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('entidad')))])],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.form_item.tipo_bien =='1')?_c('domicilio',{attrs:{"vista":false,"titulo":"/ Ubicación del Inmueble"},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.aclaraciones),expression:"form_item.aclaraciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.aclaraciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "aclaraciones", $event.target.value)}}})])],1),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(!_vm.edit_item )?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.tipo_bien",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipoBien(item.tipo_bien)))])]}},{key:"item.tipo_inmueble_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("\n                "+_vm._s(item.tipo_inmueble_id?_vm.filterInmueble(item.tipo_inmueble_id):'')+_vm._s(item.tipo_vehiculo_id?_vm.filterMueble(item.tipo_vehiculo_id):'')+"\n              ")])]}}],null,false,2039453033)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("PRÉSTAMO O COMODATO POR TERCEROS (SITUACIÓN ACTUAL)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Datos del bien")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VK88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Reporte de Cumplimiento")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 form-group"},[_c('label',[_vm._v("Estatus")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"estatus","placeholder":"Estatus"},model:{value:(_vm.model.estatus),callback:function ($$v) {_vm.$set(_vm.model, "estatus", $$v)},expression:"model.estatus"}},_vm._l((_vm.estatus),function(option){return _c('el-option',{key:option.estatus,staticClass:"select-default",attrs:{"value":option.id,"label":option.estatus}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Declaración ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"declaracion","placeholder":"Declaracion"},model:{value:(_vm.model.tipo_declaracion),callback:function ($$v) {_vm.$set(_vm.model, "tipo_declaracion", $$v)},expression:"model.tipo_declaracion"}},_vm._l((_vm.tiposDeclaracion),function(option){return _c('el-option',{key:option.tipo_declaracion,staticClass:"select-default",attrs:{"value":option.id,"label":option.tipo_declaracion}})}),1)],1),_vm._v(" "),(_vm.getKey('permisos').includes(16))?_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Año")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.model.periodo),callback:function ($$v) {_vm.$set(_vm.model, "periodo", $$v)},expression:"model.periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success pull-right",on:{"click":_vm.getCumplimiento}},[_vm._v("\n        Buscar\n      ")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),(_vm.mostrar)?_c('div',[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title text-center"},[_vm._v("Cumplimiento")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.json_data,"meta":_vm.json_meta,"fields":_vm.json_fields,"worksheet":"My Worksheet","name":"Cumplimiento.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n              Descargar Reporte\n            ")]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Buscar","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('el-table',{staticClass:"table-striped table-responsive",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":"","row-class-name":_vm.tableRowClassName}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"class-name":column.class}})}),1)],1)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VLq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("s/F+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("yrbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_StatsCard2_vue__ = __webpack_require__("ARNM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chartist_plugin_tooltips__ = __webpack_require__("pZqB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chartist_plugin_tooltips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_chartist_plugin_tooltips__);











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    StatsCard2: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_StatsCard2_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      $Chartist: null,
      globales: false,
      obligados: '',
      min: 0,
      max: 0,
      faltantes: '',
      porcentaje: 0,
      declaraciones: '',
      plugins: null,
      rinicial: 0,
      ranual: 0,
      rfinal: 0,
      obligadosIn: 0,
      obligadosAn: 0,
      obligadosFi: 0,
      faltantesIn: 0,
      faltantesAn: 0,
      faltantesFi: 0
    };
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') != 0)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    initStockChart: function initStockChart() {
      var _this = this;

      var dataStock = {
        labels: [],
        series: [[]]

      };
      var optionsStock = {
        lineSmooth: false,
        axisY: {
          offset: 40,
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return '' + value;
          }
        },
        low: this.min,
        height: '260px',
        high: this.max,
        classNames: {
          point: 'ct-point ct-green',
          line: 'ct-line ct-green'
        },
        plugins: [this.$Chartist.plugins.tooltip()]
      };
      var temp = [];
      this.$http.get("semana").then(function (response) {
        $.each(response.data, function (key, value) {
          dataStock.labels.push(value.date);
          temp.push(value.total);
        });
        dataStock.series[0] = temp;
        dataStock.labels.reverse();
        dataStock.series[0].reverse();
        _this.$Chartist.Line('#chartStock', dataStock, optionsStock);
      }, function (error) {
        _this.StepError(error);
      });
    },
    switchGlobales: function switchGlobales() {
      this.globales = !this.globales;
      this.getDatos();
    },
    getDatos: function getDatos() {
      var _this2 = this;

      var obj = {
        dependencia_id: this.globales ? 0 : this.getKey('ente_publico_id'),
        estatus: 3,
        periodo: new Date().getFullYear(),
        tipo_declaracion: 4 };
      this.$http.post('repcumplimiento', obj).then(function (response) {

        var sumStart = {
          cumplidos: 0,
          faltantes: 0,
          faltantes_iniciales: 0,
          faltantes_anuales: 0,
          faltantes_finales: 0,
          obligados_iniciales: 0,
          obligados_anuales: 0,
          obligados_finales: 0,
          r_iniciales: 0,
          r_anuales: 0,
          r_finales: 0,
          obligados: 0,
          individual: 0,
          total: 0
        };
        var result = response.data.reduce(function (sum, current) {

          sum.cumplidos += current.cumplidos;
          sum.faltantes += current.faltantes;
          sum.faltantes_iniciales += current.faltantes_iniciales;
          sum.faltantes_anuales += current.faltantes_anuales;
          sum.faltantes_finales += current.faltantes_finales;
          sum.obligados_iniciales += current.obligados_iniciales;
          sum.obligados_anuales += current.obligados_anuales;
          sum.obligados_finales += current.obligados_finales;
          sum.r_iniciales += current.r_iniciales;
          sum.r_anuales += current.r_anuales;
          sum.r_finales += current.r_finales;
          sum.obligados += current.obligados;
          sum.individual += current.individual;
          sum.total += current.total;
          return sum;
        }, sumStart);

        _this2.faltantes = _this2.group1k(result.faltantes);
        _this2.declaraciones = _this2.group1k(result.cumplidos);
        _this2.obligados = _this2.group1k(result.obligados);
        _this2.porcentaje = parseFloat(result.total.toString().substring(0, 5));

        _this2.rinicial = _this2.group1k(result.r_iniciales);
        _this2.ranual = _this2.group1k(result.r_anuales);
        _this2.rfinal = _this2.group1k(result.r_finales);

        _this2.faltantesIn = _this2.group1k(result.faltantes_iniciales);
        _this2.faltantesAn = _this2.group1k(result.faltantes_anuales);
        _this2.faltantesFi = _this2.group1k(result.faltantes_finales);

        _this2.obligadosIn = _this2.group1k(result.obligados_iniciales);
        _this2.obligadosAn = _this2.group1k(result.obligados_anuales);
        _this2.obligadosFi = _this2.group1k(result.obligados_finales);
      }, function (error) {
        _this2.StepError(error);
      });
    },
    cumplimiento: function cumplimiento() {
      this.$router.push('/reportes/cumplimiento');
    }
  },
  created: function created() {
    this.checkPermissions();
    this.getDatos();
    if (this.getKey('permisos').includes(18)) {
      this.min = 10;
      this.max = 5000;
    } else {
      this.min = 0;
      this.max = 500;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "c83R"));

            case 2:
              Chartist = _context.sent;

              _this3.$Chartist = Chartist;
              _this3.initStockChart();
              _this3.plugins = [_this3.$Chartist.plugins.tooltip()];

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),

/***/ "VQwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Realiza errendamiento ?\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre, denominación o razón social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.nombre_denominacion_razon_social),expression:"item_actividades.nombre_denominacion_razon_social"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre, denominación o razón social de quien se adquirió el inmueble:"},domProps:{"value":(_vm.item_actividades.nombre_denominacion_razon_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "nombre_denominacion_razon_social", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.rfc),expression:"item_actividades.rfc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RFC"},domProps:{"value":(_vm.item_actividades.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "rfc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("CURP (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.curp),expression:"item_actividades.curp"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CURP"},domProps:{"value":(_vm.item_actividades.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "curp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector / Industria (si aplica)")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "sector_industria_id", $$v)},expression:"item_actividades.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de actividad o servicio que produjo el ingreso")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.tipo_actividad_servicio_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "tipo_actividad_servicio_id", $$v)},expression:"item_actividades.tipo_actividad_servicio_id"}},_vm._l((_vm.actividades),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Descripción del tipo de arrendamiento que produce el ingreso")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.descripcion_actividad_servicio),expression:"item_actividades.descripcion_actividad_servicio"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción de la actividad"},domProps:{"value":(_vm.item_actividades.descripcion_actividad_servicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "descripcion_actividad_servicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 customCurrency"},[_c('label',{staticClass:"control-label"},[_vm._v("Ingreso bruto anual recibido por el arrendamiento")]),_vm._v(" "),_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{staticClass:"text-right",attrs:{"type":"number","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.item_actividades.ingreso_bruto_anual),callback:function ($$v) {_vm.$set(_vm.item_actividades, "ingreso_bruto_anual", $$v)},expression:"item_actividades.ingreso_bruto_anual"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.item_actividades.moneda_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "moneda_id", $$v)},expression:"item_actividades.moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.item_actividades.moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Duración o frecuencia ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.duracion_frecuencia),expression:"item_actividades.duracion_frecuencia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Frecuencia"},domProps:{"value":(_vm.item_actividades.duracion_frecuencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "duracion_frecuencia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Unidad temporal")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.unidad_temporal_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "unidad_temporal_id", $$v)},expression:"item_actividades.unidad_temporal_id"}},_vm._l((_vm.plazos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.item_actividades.unidad_temporal_id == 4)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de transacción")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.item_actividades.fecha_transaccion),callback:function ($$v) {_vm.$set(_vm.item_actividades, "fecha_transaccion", $$v)},expression:"item_actividades.fecha_transaccion"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones / Comentarios")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.observaciones),expression:"item_actividades.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Observaciones / Comentarios"},domProps:{"value":(_vm.item_actividades.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":""},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_actividades","responsive":"","hover":"","items":_vm.list_actividades,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.entidad_federativa_id)))]}},{key:"localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.localidad_id))+"\n            ")]}},{key:"municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.municipio_id)))]}},{key:"pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_id)))]}},{key:"sector_industria_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSector(row.item.sector_industria_id)))]}},{key:"tipo_actividad_servicio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getActividad(row.item.tipo_actividad_servicio_id)))]}},{key:"ingreso_bruto_anual",fn:function(row){return [_vm._v(_vm._s((_vm.getSignoDos(row.item.moneda_id)))+"\n              "+_vm._s(_vm._f("currency")(row.item.ingreso_bruto_anual)))]}},{key:"moneda_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getMoneda(row.item.moneda_id)))]}},{key:"unidad_temporal_id",fn:function(row){return [_vm._v(_vm._s(_vm.getUnidades(row.item.unidad_temporal_id)))]}}],null,false,2722672800)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Arrendamiento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VVNl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vv8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Enajenacion_vue__ = __webpack_require__("uEx6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df580ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Enajenacion_vue__ = __webpack_require__("45qv");
function injectStyle (ssrContext) {
  __webpack_require__("JD1w")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Enajenacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df580ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Enajenacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WFzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__ = __webpack_require__("P38u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_208cf8e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__ = __webpack_require__("nj3t");
function injectStyle (ssrContext) {
  __webpack_require__("QQVk")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_208cf8e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WI53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("l1bq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf16cac6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("drw5");
function injectStyle (ssrContext) {
  __webpack_require__("RaeL")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf16cac6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WMHG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WRLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Domicilio_vue__ = __webpack_require__("Ta4m");



















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a),
  props: ["data"],
  data: function data() {
    return {
      movimiento: {},
      options: [{
        id: 1,
        label: "foo"
      }, {
        id: 3,
        label: "bar"
      }, {
        id: 2,
        label: "baz"
      }],
      currentPage: 1,
      perPage: 50,
      validarp: false,
      rows: 0,
      rol: "",
      filter: null,
      id: 1,
      add_item: false,
      edit_item: null,
      tipos: null,
      n_domicilio: null,
      dependencias: null,
      usuarios: null,
      item_usuarios: {},
      list_usuarios: [],
      item_usuariosValidations: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        rfc: {
          required: true
        },
        curp: {
          required: true
        },
        nombres: {
          required: true
        },
        primer_apellido: {
          required: true
        },
        segundo_apellido: {
          required: true
        },
        ente_publico_id: {
          required: true
        },
        direccion_cargo: {
          required: true
        },
        nivel: {
          required: true
        },
        area_adscripcion: {
          required: true
        },
        honorarios: {
          required: true
        },
        AG172: {
          required: true
        },
        fecha_inicio: {
          required: true
        },
        tipo_baja: {
          required: true
        },
        termina: {
          required: true
        },
        inicia: {
          required: true
        },
        tipo_lic: {
          required: true
        },
        observaciones: {
          required: true
        },
        empleo_cargo_comision: {
          required: true
        }
      }, "observaciones", {
        required: true
      }),
      fields_list: [{
        key: "acciones",
        label: "Acciones",
        thClass: "td-small",
        tdClass: "text-center td-small"
      }, {
        key: "updated_at",
        label: "Fecha",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: function formatter(value) {
          if (value) return __WEBPACK_IMPORTED_MODULE_10_moment___default()(String(value)).format('DD/MM/YYYY');else return '';
        }
      }, {
        key: "usuarios.rfc",
        label: "RFC",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: "emptyFields"
      }, {
        key: "usuarios.nombres usuarios.primer_apellido usuarios.segundo_apellido",
        label: "Nombre",
        tdClass: "text-left",
        formatter: "emptyFields"
      }],
      selects: {
        simple: "",
        movimientos: [{
          value: "1",
          label: "Desactivar servidor"
        }, {
          value: "2",
          label: "Crear baja "
        }, {
          value: "3",
          label: "Crear licencia"
        }, {
          value: "4",
          label: "Crear promoción"
        }, {
          value: "5",
          label: "Realizar corrección"
        }, {
          value: "6",
          label: "Cambiar contraseña"
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vee_validate__["c" /* mapFields */])(["rfc", "curp", "nombres", "primer_apellido", "segundo_apellido", "ente_publico_id", "direccion_cargo", "nivel", "area_adscripcion", "honorarios", "AG172", "Password", "Confirmar", "fecha_inicio", "tipo_baja", "termina", "inicia", "tipo_lic", "observaciones", "empleo_cargo_comision"]), {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_usuarios.length;

      return this.list_usuarios.length;
    },

    fullName: {
      get: function get() {
        return this.item_usuarios.nombres + " " + this.item_usuarios.primer_apellido + " " + this.item_usuarios.segundo_apellido;
      },
      set: function set(newValue) {
        var m = newValue.match(/(\S*)\s+(.*)/);

        this.nombres = m[1];
        this.primer_apellido = m[2];
        this.segundo_apellido = m[3];
      }
    }
  }),
  methods: {
    formato: function formato(fecha) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(String(value)).format('DD/MM/YYYY');
    },
    returnValueKey: function returnValueKey(v, k) {
      var resp = "";
      if (k == "dependencia") {
        resp = this.getDependencias(v);
      } else if (k == "honorarios") {
        resp = v == 0 ? "NO" : "SI";
      } else {
        resp = v;
      }
      return resp;
    },
    initItem: function initItem() {
      var _this = this;

      this.item_usuarios = {
        acciones: "",
        nombres: "",
        Paterno: "",
        Materno: "",
        User: "",
        Password: ""
      };
      this.$http.get("cat_ente_publico").then(function (response) {
        _this.dependencias = response.data.entes_publicos;
      }, function (error) {
        _this.Err(error);
      });
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUsuario: function getUsuario(index) {
      var resp = " ";
      if (this.usuarios) {
        this.usuarios.forEach(function (item) {
          if (item.id == index) {
            resp = item.Nombre + " " + item.Paterno + " " + item.Materno;
            return resp;
          }
        });
      }
      return resp;
    },
    getStatus: function getStatus(status) {
      if (status === 1) {
        return "Aprobado";
      } else {
        return "Rechazado";
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.initItem();
    if (this.getKey('permisos').includes(19)) {
      this.validarp = true;
    }
    this.$http.get("historial").then(function (response) {
      _this2.list_usuarios = response.data.usuarios;
    }, function (error) {
      _this2.Err(error);
    });
  }
});

/***/ }),

/***/ "WW+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ThemifyIcon_vue__ = __webpack_require__("bNdE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c11436_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ThemifyIcon_vue__ = __webpack_require__("ygZ9");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ThemifyIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c11436_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ThemifyIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WbPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_InteresesEmpresas_vue__ = __webpack_require__("y1Gp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2377d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_InteresesEmpresas_vue__ = __webpack_require__("Xu2A");
function injectStyle (ssrContext) {
  __webpack_require__("OWb5")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_InteresesEmpresas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2377d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_InteresesEmpresas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WhAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Correcciones_vue__ = __webpack_require__("ewvW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d8ab08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Correcciones_vue__ = __webpack_require__("6mlm");
function injectStyle (ssrContext) {
  __webpack_require__("gBSR")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Correcciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d8ab08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Correcciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WkJy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WlYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Inactivos_vue__ = __webpack_require__("gi0y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e837d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Inactivos_vue__ = __webpack_require__("7Hg1");
function injectStyle (ssrContext) {
  __webpack_require__("CQa9")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Inactivos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e837d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Inactivos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WrlU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Tablero2_vue__ = __webpack_require__("0doD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3750c682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Tablero2_vue__ = __webpack_require__("gyHc");
function injectStyle (ssrContext) {
  __webpack_require__("Y4QB")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Tablero2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3750c682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Tablero2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XJLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Busqueda_vue__ = __webpack_require__("2I78");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ad72be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Busqueda_vue__ = __webpack_require__("LfAP");
function injectStyle (ssrContext) {
  __webpack_require__("nEeR")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Busqueda_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ad72be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Busqueda_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XXpw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_component_vue__ = __webpack_require__("2auz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2229d74f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_component_vue__ = __webpack_require__("/cqK");
function injectStyle (ssrContext) {
  __webpack_require__("b7lh")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2229d74f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XYFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      ip_id: null,
      add_item: false,
      edit_item: null,
      bandera: '0',
      form_item: {},
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Tipo de inmueble',
        value: 'tipo_bien_id',
        align: 'center'
      }, {
        text: 'Titular del inmueble',
        value: 'titular_id',
        align: 'center'
      }, {
        text: 'Fecha de Adquisición',
        value: 'fecha_adquisicion',
        align: 'center'
      }, {
        text: 'Datos del registro público de la propiedad',
        value: 'numero_registro_publico',
        align: 'center'
      }, {
        text: 'Aclaraciones / Observaciones',
        value: 'observaciones',
        align: 'center'
      }],
      info: {
        inmuebles: 'Reportar aquellos bienes que conforme a la normatividad aplicable se consideran inmuebles. Para la declaración de inicio reportar la situación de los bienes inmuebles a la fecha de ingreso al empleo, cargo o comisión. Para la declaración de modificación reportar la situación de los bienes inmuebles del año inmediato anterior. Para la declaración de conclusión reportar la situación de los bienes inmuebles a la fecha de conclusión del empleo, cargo o comisión.',
        tipo_bien_id: 'Seleccionar el tipo de bien inmueble que se declara: casa, departamento, edificio, local comercial, bodega, palco, rancho, terreno y otro, especifique.',
        titular_id: 'Seleccionar alguna de las opciones del catálogo desplegable.',
        porcentaje_propiedad: 'En caso de que el Declarante sea el único dueño deberá poner el cien por ciento, de no ser así señalará el porcentaje_propiedad que le corresponda, de acuerdo a la escritura o contrato.',
        superficie_terreno: 'Señalar en metros cuadrados la superficie total del terreno.',
        superficie_construccion: 'Señalar en metros cuadrados la superficie total de construcción.',
        tercero: 'En caso de copropiedad con un tercero, seleccionar si es persona física o persona moral.',
        nombre_tercero: 'En caso de copropiedad, escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
        rfc_tercero: 'En caso de personas físicas proporcionar los trece dígitos. En el caso de personas morales establecer los doce dígitos.',
        forma_adquisicion_id: 'Seleccionar alguna de las opciones del catálogo.',
        forma_pago: 'Seleccionar la forma en que realizó el pago para adquirir el inmueble, en caso de que no haya pagado por el mismo, indicará no aplica.',
        transmisor: 'Seleccionar si es persona física o persona moral.',
        nombre_denominacion_quien_adquirio: 'Escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
        rfc_quien_adquirio: 'En caso de personas físicas señalar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
        relacion: 'Seleccionar alguna de las opciones del catálogo desplegable y en caso de seleccionar otro especificar.',
        valor_adquisicion: 'Proporcionar el monto de adquisición, conforme al documento con el que se acredita la compra del bien inmueble.',
        valor_conforme: 'Seleccionar si fue conforme a escritura pública, conforme a sentencia o contrato.',
        fecha_adquisicion: 'Señalar la fecha de adquisición del inmueble, conforme al documento con el que se acredita la propiedad.',
        tipo_moneda: 'Seleccionar la moneda relativa al valor de adquisición.',
        numero_registro_publico: 'Señalar el número de escritura pública, folio real o cualquier dato que lo identifique.',
        motivo_baja: 'Elegir la razón por la cual se da de baja venta, donación, siniestro u otro. Especifique.',
        lugar: 'Proporcionar los datos relativos al lugar donde se ubica el inmueble declarado. Seleccionando si es en México o en el extranjero. En caso de seleccionar México, proporcionar los siguientes datos: calle, número exterior, número interior (si aplica), colonia o localidad, municipio o alcaldía, entidad federativa y código postal. En caso de seleccionar extranjero, proporcionar los siguientes datos: calle, número exterior, número interior (si aplica), ciudad/localidad, estado o provincia, país, código postal.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      },

      n_domicilio: {
        pais_id: 150,
        entidadF: 11,
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      }
    };
  },


  computed: {
    terceros: function terceros() {
      if (this.form_item) {
        if (this.form_item.titular_id) {
          var arr = [3, 4, 5, 8, 10, 13, 15, 18, 19, 24, 25];
          return arr.includes(this.form_item.titular_id);
        }
      }
      return false;
    },
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.form_item.precio_adquisicion_moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.form_item.precio_adquisicion_moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {
    n_domicilio: {
      handler: function handler(val, oldVal) {
        if (this.n_domicilio) {
          this.form_item.domicilio_bien_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
          this.form_item.domicilio_bien_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.form_item.domicilio_bien_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.form_item.domicilio_bien_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.form_item.domicilio_bien_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.form_item.domicilio_bien_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.form_item.domicilio_bien_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.form_item.domicilio_bien_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.form_item.domicilio_bien_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
          this.form_item.domicilio_bien_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
        }
      },
      immediate: true,
      deep: true
    }

  },
  methods: {
    editDomicilio: function editDomicilio() {
      if (this.form_item) {
        this.n_domicilio.pais_id = this.form_item.pais ? this.form_item.pais : 150;
        this.n_domicilio.entidadF = this.form_item.domicilio_bien_entidad_federativa_id ? this.form_item.domicilio_bien_entidad_federativa_id : "";
        this.n_domicilio.municipio = this.form_item.domicilio_bien_municipio_id ? this.form_item.domicilio_bien_municipio_id : "";
        this.n_domicilio.localidad = this.form_item.domicilio_bien_localidad_id ? this.form_item.domicilio_bien_localidad_id : "";
        this.n_domicilio.cp = this.form_item.domicilio_bien_cp ? this.form_item.domicilio_bien_cp : "";
        this.n_domicilio.vialidad_nombre = this.form_item.domicilio_bien_vialidad_nombre ? this.form_item.domicilio_bien_vialidad_nombre : "";
        this.n_domicilio.vialidad = this.form_item.domicilio_bien_vialidad_tipo ? this.form_item.domicilio_bien_vialidad_tipo : "";
        this.n_domicilio.ext = this.form_item.domicilio_bien_numext ? this.form_item.domicilio_bien_numext : "";
        this.n_domicilio.int = this.form_item.domicilio_bien_numint ? this.form_item.domicilio_bien_numint : "";
        this.n_domicilio.colonia = this.form_item.domicilio_bien_colonia ? this.form_item.domicilio_bien_colonia : "";
      }
    },
    initDomicilio: function initDomicilio() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: 11,
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
    },
    showItem: function showItem() {
      this.add_item = true;
      if (!this.form_item.domicilio_bien_pais_id) {
        this.form_item.domicilio_bien_pais_id = 150;
      }
      this.form_item.precio_adquisicion_moneda_id = 97;
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.initDomicilio();
      this.edit_item = false;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("bienes_inmuebles", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");

              if (!_this.edit_item) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
          _this.scrolling();
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = true;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
      this.editDomicilio();
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("bienes_inmuebles/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    checkDomicilio: function checkDomicilio() {
      if (this.n_domicilio) {
        this.form_item.domicilio_bien_pais_id = this.n_domicilio.pais;
        this.form_item.domicilio_bien_entidad_federativa_id = this.n_domicilio.entidadF;
        this.form_item.domicilio_bien_municipio_id = this.n_domicilio.municipio;
        this.form_item.domicilio_bien_localidad_id = this.n_domicilio.localidad;
        this.form_item.domicilio_bien_cp = this.n_domicilio.cp;
        this.form_item.domicilio_bien_vialidad_nombre = this.n_domicilio.vialidad_nombre;
        this.form_item.domicilio_bien_vialidad_tipo = this.n_domicilio.vialidad;
        this.form_item.domicilio_bien_numext = this.n_domicilio.ext;
        this.form_item.domicilio_bien_numint = this.n_domicilio.int;
        this.form_item.domicilio_bien_colonia = this.n_domicilio.colonia;
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');

    this.$http.get("bienes_inmuebles/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();
    this.form_item.domicilio_bien_pais_id = 150;
  }
});

/***/ }),

/***/ "XcOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Arrendamiento_vue__ = __webpack_require__("iWfd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a95248d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Arrendamiento_vue__ = __webpack_require__("VQwW");
function injectStyle (ssrContext) {
  __webpack_require__("p7eG")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Arrendamiento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a95248d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Arrendamiento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XfDT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",function(){return [_vm._v("\n        Download "+_vm._s(_vm.name)+"\n    ")]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XlZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("s/F+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("zHPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("yrbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_excel_export__ = __webpack_require__("VdFE");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      overlay: false,
      periodos: [],
      dependencias: [],
      directorios: [],
      active: [],
      open: [],
      search: '',
      caseSensitive: false,
      loaddata: false,
      fileInfo: {},
      headers: [{
        text: 'RFC',
        align: 'center',
        sortable: false,
        value: 'rfc'
      }],
      dataExcelRegistro: [],
      dataExcelSinMovimientos: [],
      dataExcelErrores: [],
      meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      campos_excel: {
        'RFC': 'rfc'
      },
      file_name: ''
    };
  },

  watch: {
    '$route': 'checkPermissions'
  },
  computed: {
    items: function items() {
      return [{
        name: 'Arbol de Actualización',
        children: this.directorios
      }];
    },
    filter: function filter() {
      return this.caseSensitive ? function (item, search, textKey) {
        return item[textKey].indexOf(search) > -1;
      } : undefined;
    },
    selected: function selected() {
      if (!this.active.length) return undefined;

      var id = this.active[0];

      return true;
    }
  },
  methods: {
    removeslash: function removeslash(item) {
      return item.split("/")[1];
    },

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    dateFormat2: function dateFormat2(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'DD-MM-YYYY').format('DD/MM/YYYY');
    },
    dateFormat3: function dateFormat3(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
    },
    checkPermissions: function checkPermissions() {
      var permiso = [27];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getDependencias: function getDependencias() {
      var _this = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this.dependencias = response.data.entes_publicos;
        _this.dependencias.unshift({
          'codigo': 'T',
          'id': 0,
          'valor': 'Todas'
        });
      }, function (error) {
        _this.StepError(error);
      });
    },
    getPeriodos: function getPeriodos() {
      var _this2 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this2.periodos = response.data.periodos;
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getDirectorios: function getDirectorios() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.$http.get("cron_directories").then(function (response) {
                  _this3.directorios = response.data.directorios;
                  var temp = [];
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.directorios).forEach(function (t, i) {

                    var children = [];

                    _this3.directorios[t].forEach(function (c, j) {
                      children.push({
                        id: i + '_' + j,
                        name: c.replaceAll('cron/', '')
                      });
                    });

                    temp.push({
                      id: i,
                      name: t,
                      children: children
                    });
                  });
                  _this3.directorios = temp;
                }, function (error) {
                  _this3.StepError(error);
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getJsonFile: function getJsonFile(file) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var f;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.fileInfo = {};
                _this4.file_name = '';
                _this4.dataExcelRegistro = [];
                _this4.dataExcelSinMovimientos = [];
                _this4.dataExcelErrores = [];
                if (file[0]) {
                  f = file[0];

                  if (f.name) {
                    if (f.name.includes('.json')) {
                      _this4.loaddata = true;
                      _this4.$http.post("cron_file", f).then(function (response) {
                        _this4.loaddata = false;
                        _this4.file_name = f.name.match(/([^\/]+)(?=\.\w+$)/)[0];

                        _this4.fileInfo = response.data.json;

                        _this4.dataExcelRegistro = _this4.fileInfo.registros;
                        _this4.dataExcelSinMovimientos = _this4.fileInfo.sinMovimientos;
                        _this4.dataExcelErrores = _this4.fileInfo.errores;
                      }, function (error) {
                        _this4.StepError(error);
                        _this4.loaddata = false;
                      });
                    }
                  }
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    runCron: function runCron() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.overlay = true;

                _this5.$http.get("set_tipo_dec_").then(function (response) {
                  _this5.overlay = false;

                  var resp = response.data.response;
                  var str = 'Tiempo de espera ' + resp.tiempo + ', Total de declaraciones asignadas: ' + resp.total;
                  _this5.getDirectorios();
                  _this5.OK(str);
                }, function (error) {
                  _this5.overlay = false;
                  _this5.StepError(error);
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    }
  },
  created: function created() {
    this.getDependencias();
    this.getPeriodos();
    this.getDirectorios();
    this.rol = this.getKey('role');
    this.checkPermissions();
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "Xu2A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Tiene empresas, sociedades o asociaciones ?\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            ¿ Estas de acuerdo en hacer pública la información de tu posible conflicto de interés ?\n          ")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.es_publica),expression:"item_empresasValidations.es_publica"}],attrs:{"name":"es_publica","inline":true,"label":"1"},model:{value:(_vm.item_empresas.es_publica),callback:function ($$v) {_vm.$set(_vm.item_empresas, "es_publica", $$v)},expression:"item_empresas.es_publica"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.es_publica),expression:"item_empresasValidations.es_publica"}],attrs:{"name":"es_publica","inline":true,"label":"2"},model:{value:(_vm.item_empresas.es_publica),callback:function ($$v) {_vm.$set(_vm.item_empresas, "es_publica", $$v)},expression:"item_empresas.es_publica"}},[_vm._v("No")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.es_publica.invalid),expression:"es_publica.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('es_publica'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Operación")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.tipo_operacion_id),expression:"item_empresasValidations.tipo_operacion_id"}],staticClass:"select-default",attrs:{"filterable":"","placeholder":"Seleccione una opción","name":"tipo_operacion_id"},model:{value:(_vm.item_empresas.tipo_operacion_id),callback:function ($$v) {_vm.$set(_vm.item_empresas, "tipo_operacion_id", $$v)},expression:"item_empresas.tipo_operacion_id"}},_vm._l((_vm.operaciones),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_operacion_id.invalid),expression:"tipo_operacion_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('tipo_operacion_id'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre de la empresa, sociedad o asociación")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.nombre_empresa_sociedad_asociacion),expression:"item_empresasValidations.nombre_empresa_sociedad_asociacion"},{name:"model",rawName:"v-model",value:(_vm.item_empresas.nombre_empresa_sociedad_asociacion),expression:"item_empresas.nombre_empresa_sociedad_asociacion"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_empresa_sociedad_asociacion","placeholder":"Nombre de la empresa"},domProps:{"value":(_vm.item_empresas.nombre_empresa_sociedad_asociacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_empresas, "nombre_empresa_sociedad_asociacion", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombre_empresa_sociedad_asociacion.invalid),expression:"nombre_empresa_sociedad_asociacion.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('nombre_empresa_sociedad_asociacion'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Frecuencia Anual")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.frecuencia_anual_id),expression:"item_empresasValidations.frecuencia_anual_id"}],staticClass:"select-default",attrs:{"filterable":"","placeholder":"Seleccione una opción","name":"frecuencia_anual_id"},model:{value:(_vm.item_empresas.frecuencia_anual_id),callback:function ($$v) {_vm.$set(_vm.item_empresas, "frecuencia_anual_id", $$v)},expression:"item_empresas.frecuencia_anual_id"}},_vm._l((_vm.frecuencias),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.frecuencia_anual_id.invalid),expression:"frecuencia_anual_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('frecuencia_anual_id'))+"\n          ")])],1),_vm._v(" "),( _vm.item_empresas.frecuencia_anual_id == 6)?_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Especificar frecuencia anual")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.frecuencia_anual_especificar),expression:"item_empresasValidations.frecuencia_anual_especificar"},{name:"model",rawName:"v-model",value:(_vm.item_empresas.frecuencia_anual_especificar),expression:"item_empresas.frecuencia_anual_especificar"}],staticClass:"form-control",attrs:{"type":"text","name":"frecuencia_anual_especificar","placeholder":"Especificar"},domProps:{"value":(_vm.item_empresas.frecuencia_anual_especificar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_empresas, "frecuencia_anual_especificar", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.frecuencia_anual_especificar.invalid),expression:"frecuencia_anual_especificar.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('frecuencia_anual_especificar'))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de persona Juridica")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.persona_juridica),expression:"item_empresasValidations.persona_juridica"}],staticClass:"select-default",attrs:{"filterable":"","placeholder":"Seleccione una opción","name":"persona_juridica"},model:{value:(_vm.item_empresas.persona_juridica),callback:function ($$v) {_vm.$set(_vm.item_empresas, "persona_juridica", $$v)},expression:"item_empresas.persona_juridica"}},_vm._l((_vm.personas),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.persona_juridica.invalid),expression:"persona_juridica.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('persona_juridica'))+"\n          ")])],1),_vm._v(" "),( _vm.item_empresas.persona_juridica == 8)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.otra_persona_juridica),expression:"item_empresasValidations.otra_persona_juridica"},{name:"model",rawName:"v-model",value:(_vm.item_empresas.otra_persona_juridica),expression:"item_empresas.otra_persona_juridica"}],staticClass:"form-control",attrs:{"type":"text","name":"otra_persona_juridica","placeholder":"Especificar"},domProps:{"value":(_vm.item_empresas.otra_persona_juridica)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_empresas, "otra_persona_juridica", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.otra_persona_juridica.invalid),expression:"otra_persona_juridica.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('otra_persona_juridica'))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Responsable del posible conflicto de interés")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.responsable_conflicto),expression:"item_empresasValidations.responsable_conflicto"}],staticClass:"select-default",attrs:{"filterable":"","placeholder":"Seleccione una opción","name":"responsable_conflicto"},model:{value:(_vm.item_empresas.responsable_conflicto),callback:function ($$v) {_vm.$set(_vm.item_empresas, "responsable_conflicto", $$v)},expression:"item_empresas.responsable_conflicto"}},_vm._l((_vm.responsables),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.responsable_conflicto.invalid),expression:"responsable_conflicto.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('responsable_conflicto'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Naturaleza del vínculo")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.naturaleza_vinculo),expression:"item_empresasValidations.naturaleza_vinculo"}],staticClass:"select-default",attrs:{"filterable":"","placeholder":"Seleccione una opción","name":"naturaleza_vinculo"},model:{value:(_vm.item_empresas.naturaleza_vinculo),callback:function ($$v) {_vm.$set(_vm.item_empresas, "naturaleza_vinculo", $$v)},expression:"item_empresas.naturaleza_vinculo"}},_vm._l((_vm.naturalezas),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.naturaleza_vinculo.invalid),expression:"naturaleza_vinculo.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('naturaleza_vinculo'))+"\n          ")])],1),_vm._v(" "),( _vm.item_empresas.naturaleza_vinculo == 3)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.naturaleza_vinculo_especificar),expression:"item_empresasValidations.naturaleza_vinculo_especificar"},{name:"model",rawName:"v-model",value:(_vm.item_empresas.naturaleza_vinculo_especificar),expression:"item_empresas.naturaleza_vinculo_especificar"}],staticClass:"form-control",attrs:{"type":"text","name":"otra_persona_juridica","placeholder":"Especificar"},domProps:{"value":(_vm.item_empresas.naturaleza_vinculo_especificar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_empresas, "naturaleza_vinculo_especificar", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.naturaleza_vinculo_especificar.invalid),expression:"naturaleza_vinculo_especificar.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('naturaleza_vinculo_especificar'))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Antigüedad del Vinculo (Años)")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.antiguedad_vinculo),expression:"item_empresasValidations.antiguedad_vinculo"},{name:"model",rawName:"v-model",value:(_vm.item_empresas.antiguedad_vinculo),expression:"item_empresas.antiguedad_vinculo"}],staticClass:"form-control",attrs:{"type":"number","name":"antiguedad_vinculo","placeholder":"Antigüedad del vinculo"},domProps:{"value":(_vm.item_empresas.antiguedad_vinculo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_empresas, "antiguedad_vinculo", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.antiguedad_vinculo.invalid),expression:"antiguedad_vinculo.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('antiguedad_vinculo'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Participación en la dirección o administración:\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.participacion),expression:"item_empresasValidations.participacion"}],attrs:{"name":"participacion","inline":true,"label":"1"},model:{value:(_vm.item_empresas.participacion),callback:function ($$v) {_vm.$set(_vm.item_empresas, "participacion", $$v)},expression:"item_empresas.participacion"}},[_vm._v("Antes del servicio público")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.participacion),expression:"item_empresasValidations.participacion"}],attrs:{"name":"participacion","inline":true,"label":"2"},model:{value:(_vm.item_empresas.participacion),callback:function ($$v) {_vm.$set(_vm.item_empresas, "participacion", $$v)},expression:"item_empresas.participacion"}},[_vm._v("Después del servicio público")])],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.participacion.invalid),expression:"participacion.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('participacion'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de colaboración o aporte")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.tipo_colaboracion),expression:"item_empresasValidations.tipo_colaboracion"}],staticClass:"select-default",attrs:{"filterable":"","placeholder":"Seleccione una opción","name":"tipo_colaboracion"},model:{value:(_vm.item_empresas.tipo_colaboracion),callback:function ($$v) {_vm.$set(_vm.item_empresas, "tipo_colaboracion", $$v)},expression:"item_empresas.tipo_colaboracion"}},_vm._l((_vm.colaboraciones),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_colaboracion.invalid),expression:"tipo_colaboracion.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('tipo_colaboracion'))+"\n          ")])],1),_vm._v(" "),( _vm.item_empresas.tipo_colaboracion == 5)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.item_empresasValidations.tipo_colaboracion_especificar),expression:"item_empresasValidations.tipo_colaboracion_especificar"},{name:"model",rawName:"v-model",value:(_vm.item_empresas.tipo_colaboracion_especificar),expression:"item_empresas.tipo_colaboracion_especificar"}],staticClass:"form-control",attrs:{"type":"text","name":"tipo_colaboracion_especificar","placeholder":"Especificar"},domProps:{"value":(_vm.item_empresas.tipo_colaboracion_especificar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_empresas, "tipo_colaboracion_especificar", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_colaboracion_especificar.invalid),expression:"tipo_colaboracion_especificar.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('tipo_colaboracion_especificar'))+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":"del bien"},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Guardar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_metales","responsive":"","hover":"","items":_vm.list_empresas,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"domicilio_entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.domicilio_entidad_federativa_id)))]}},{key:"domicilio_localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.domicilio_localidad_id))+"\n            ")]}},{key:"domicilio_municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.domicilio_municipio_id)))]}},{key:"domicilio_pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.domicilio_pais_id)))]}},{key:"pais_registro_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_registro_id)))]}},{key:"tipo_operacion_id",fn:function(row){return [_vm._v(_vm._s(_vm.getOperacion(row.item.tipo_operacion_id)))]}},{key:"frecuencia_anual_id",fn:function(row){return [_vm._v(_vm._s(_vm.getFrecuencia(row.item.frecuencia_anual_id)))]}},{key:"persona_juridica",fn:function(row){return [_vm._v(_vm._s(_vm.getPersonas(row.item.persona_juridica)))]}},{key:"responsable_conflicto",fn:function(row){return [_vm._v(_vm._s(_vm.getResponsables(row.item.responsable_conflicto)))]}},{key:"naturaleza_vinculo",fn:function(row){return [_vm._v(_vm._s(_vm.getNaturalezas(row.item.naturaleza_vinculo)))]}},{key:"actividad_economica",fn:function(row){return [_vm._v(_vm._s(_vm.getBool(row.item.actividad_economica)))]}},{key:"participacion",fn:function(row){return [_vm._v(_vm._s(_vm.getParticipacion(row.item.participacion)))]}},{key:"tipo_colaboracion",fn:function(row){return [_vm._v(_vm._s(_vm.getColaboraciones(row.item.tipo_colaboracion)))]}}],null,false,1213430784)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Empresas, Sociedades o Asociaciones ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y3d/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y4QB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YF0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("l+io");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Formularios_Ingresos_SueldosSalarios_vue__ = __webpack_require__("ID6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Formularios_Ingresos_SueldosSalariosOtros_vue__ = __webpack_require__("6Mai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Formularios_Ingresos_ActividadProfesional_vue__ = __webpack_require__("ZRe7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Formularios_Ingresos_ActividadEmpresarial_vue__ = __webpack_require__("6QVO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Formularios_Ingresos_ActividadEconomica_vue__ = __webpack_require__("PaBg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Formularios_Ingresos_Arrendamiento_vue__ = __webpack_require__("XcOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Formularios_Ingresos_Intereses_vue__ = __webpack_require__("jzdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Formularios_Ingresos_Premios_vue__ = __webpack_require__("SdDo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Formularios_Ingresos_Enajenacion_vue__ = __webpack_require__("Vv8W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Formularios_Ingresos_OtrosIngresos_vue__ = __webpack_require__("mBkS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);

















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {}
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__["TabContent"],
    SueldosSalarios: __WEBPACK_IMPORTED_MODULE_4__Formularios_Ingresos_SueldosSalarios_vue__["a" /* default */],
    SueldosSalariosOtros: __WEBPACK_IMPORTED_MODULE_5__Formularios_Ingresos_SueldosSalariosOtros_vue__["a" /* default */],
    ActividadProfesional: __WEBPACK_IMPORTED_MODULE_6__Formularios_Ingresos_ActividadProfesional_vue__["a" /* default */],
    ActividadEmpresarial: __WEBPACK_IMPORTED_MODULE_7__Formularios_Ingresos_ActividadEmpresarial_vue__["a" /* default */],
    ActividadEconomica: __WEBPACK_IMPORTED_MODULE_8__Formularios_Ingresos_ActividadEconomica_vue__["a" /* default */],
    Arrendamiento: __WEBPACK_IMPORTED_MODULE_9__Formularios_Ingresos_Arrendamiento_vue__["a" /* default */],
    Intereses: __WEBPACK_IMPORTED_MODULE_10__Formularios_Ingresos_Intereses_vue__["a" /* default */],
    Premios: __WEBPACK_IMPORTED_MODULE_11__Formularios_Ingresos_Premios_vue__["a" /* default */],
    Enajenacion: __WEBPACK_IMPORTED_MODULE_12__Formularios_Ingresos_Enajenacion_vue__["a" /* default */],
    OtrosIngresos: __WEBPACK_IMPORTED_MODULE_13__Formularios_Ingresos_OtrosIngresos_vue__["a" /* default */]
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    addItem: function addItem() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$refs.SueldosSalarios.valida().then(function (response) {
          _this.item_entes = _this.$refs.SueldosSalarios.item_entes;
          console.log(response);
          if (response) {
            _this.item_entes.ip_id = _this.ip_id;
            _this.loadButton(_this.$refs.btnSave);
            _this.$http.post('sueldos_publicos', _this.item_entes).then(function (response) {
              _this.StepOk('Guardado');

              return resolve(true);
            }, function (error) {
              _this.StepW(error);
            });
          } else return resolve(false);
        });
      });
    },
    addItem55: function addItem55() {
      var _this2 = this;

      this.item_entes22 = this.$refs.SueldosSalariosOtros.item_entes22;
      var v = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$refs.SueldosSalariosOtros.validate().then(function (response) {

          if (response) {

            _this2.item_entes22.ip_id = _this2.ip_id;

            _this2.$http.post("sueldos_otros", _this2.item_entes22).then(function (response) {
              _this2.StepOk("Guardado");

              return resolve(true);
            }, function (error) {
              _this2.StepW(error);
            });
          } else {
            _this2.StepW("Hay campos sin completar");
            return reject(false);
          }
        }).catch(function (e) {
          reject(false);
        });
      });
    },
    siguente: function siguente() {
      var simplificada = this.getKey('simplificada');
      if (simplificada == '1') {
        this.$router.push('fiscal');
      } else {
        this.$router.push('activos');
      }
    },
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.datosPersonales.model, this.$refs.firstStep.model, this.$refs.DatosCurriculares.model, this.$refs.DatosConyuge.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('Good job!', 'You clicked the finish button!', 'success');
    }
  },
  created: function created() {
    this.checkPermissions();
  }
});

/***/ }),

/***/ "YQix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YYqw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ymfc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1kT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{ref:"wizard",attrs:{"error-color":"#EB5E28","color":"#1e94fd","title":"Pasivos","subtitle":""},on:{"on-complete":_vm.siguente,"on-change":_vm.cancelAll}},[_c('tab-content',{attrs:{"title":"Adeudos / Pasivos (Situación actual)","icon":"ti-user"}},[_c('deudas',{ref:"Deudas"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Préstamo o Comodato por terceros (Situación actual)","icon":"ti-user"}},[_c('prestamo',{ref:"Prestamo"})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v(" Atrás ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v(" Siguiente ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"finish"},slot:"finish"},[_vm._v(" Siguiente")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("y0Yb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("5yFB");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZRe7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ActividadProfesional_vue__ = __webpack_require__("mXm/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_14012cff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ActividadProfesional_vue__ = __webpack_require__("cNav");
function injectStyle (ssrContext) {
  __webpack_require__("EwoZ")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ActividadProfesional_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_14012cff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ActividadProfesional_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZiqW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZwRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card card-wizard"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.comentarios),expression:"model.comentarios"}],staticClass:"form-control",attrs:{"row":"15","placeholder":"Éste campo es opcional."},domProps:{"value":(_vm.model.comentarios)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "comentarios", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-md-offset-3 container-fluid text-center"},[_c('button',{staticClass:"btn btn-wd btn-success",attrs:{"type":"button"},on:{"click":_vm.guardar}},[_vm._m(1),_vm._v("\n        Guardar y Continuar\n      ")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br')])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"text-center"}),_vm._v(" "),_c('h4',{staticClass:"title text-center"},[_vm._v("Observaciones y/o Aclaraciones.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-save"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a/Ze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "aKIg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 pull-right"},[_c('label',[_vm._v("Buscar:")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1),_vm._v(" "),_c('div',{staticClass:"col-6  d-flex align-items-end justify-content-end"},[(_vm.lista_correcciones2.length > 0)?_c('export-excel',{staticClass:"btn btn-wd btn-success pull-right",attrs:{"data":_vm.lista_correcciones2,"meta":_vm.meta,"fields":_vm.lista_campos,"worksheet":"Correcciones","name":"Correcciones_declaraciones.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                Descargar\n              ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-app',[_c('v-data-table',{attrs:{"headers":_vm.headers,"search":_vm.filter,"custom-filter":_vm.customFilter,"items":_vm.lista_correcciones,"single-select":"","item-key":"id","show-expand":"","expanded":_vm.expanded},on:{"update:expanded":function($event){_vm.expanded=$event},"click:row":_vm.rowClick},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})])],1)]}},{key:"item.rfc",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.servidor.rfc)+" ")])]}},{key:"item.nombres",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.servidor.nombres + ' '+ item.servidor.primer_apellido +' '+item.servidor.segundo_apellido)+" ")])]}},{key:"item.area",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.encargo.area_adscripcion))])]}},{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm._f("dateFormat")(item.created_at)))])]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('v-card',{key:item.id,staticClass:"p-1 m-0",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"p-1"},[_c('h3',{staticClass:"text-h5 mb-2 mt-2"},[_vm._v("\n                            "+_vm._s(item.servidor.nombres + ' '+ item.servidor.primer_apellido +' '+item.servidor.segundo_apellido)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"blue--text mb-2"},[_vm._v("\n                            "+_vm._s(item.servidor.rfc)+"\n                          ")])]),_vm._v(" "),_c('v-divider',{staticClass:"m-0 p-0 mb-2"}),_vm._v(" "),_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[(item.origen)?_c('v-col',{staticClass:"m-0 p-1 pb-3 border-bottom",attrs:{"cols":"6"}},[_c('legend',{staticClass:"h4 pl-0 mb-3 mt-0"},[_vm._v(" Corrección Origen:")]),_vm._v(" "),_vm._l((item.origen),function(value,key){return _c('div',{key:key,staticClass:"m-0 p-0 pb-2  text-wrap"},[(key === 'datos_encargo_actual')?_c('div',[_c('strong',[_vm._v(_vm._s(key.replace("_", " "))+":")]),_vm._v(" "),_vm._l((_vm.flatData(value, 'ente')),function(value_2,key_2){return _c('div',{key:key_2+'2',staticClass:" text-wrap"},[_c('b',[_vm._v(_vm._s(key_2))]),_vm._v(" : "+_vm._s(value_2)+"\n                                ")])})],2):_vm._e()])})],2):_vm._e(),_vm._v(" "),(item.cambio)?_c('v-col',{staticClass:"m-0 p-1 pb-3 border-bottom border-left",attrs:{"cols":"6"}},[_c('legend',{staticClass:"h4 pl-3 mb-3 mt-0"},[_vm._v(" Corrección Cambio:")]),_vm._v(" "),_vm._l((item.cambio),function(value,key){return _c('div',{key:key,staticClass:"m-0 p-0 pl-3 text-wrap",attrs:{"cols":"6"}},[(key === 'datos_encargo_actual')?_c('div',[_c('strong',[_vm._v(_vm._s(key.replace("_", " "))+":")]),_vm._v(" "),_vm._l((_vm.flatData(value, 'ente')),function(value_2,key_2){return _c('div',{key:key_2+'2',staticClass:" text-wrap"},[_c('b',[_vm._v(_vm._s(key_2))]),_vm._v(" : "+_vm._s(value_2)+"\n                                ")])})],2):_vm._e()])})],2):_vm._e()],1),_vm._v(" "),_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[(item.origen)?_c('v-col',{staticClass:"m-0 p-1 pb-3 border-bottom",attrs:{"cols":"6"}},[_c('legend',{staticClass:"h4 pl-0 mb-3 mt-0"},[_vm._v(" Corrección Declaración Origen:")]),_vm._v(" "),_vm._l((item.orgen_declaracion),function(value,key){return _c('div',{key:key,staticClass:"m-0 p-0 text-wrap",attrs:{"cols":"6"}},[(key === 'Tipo_Dec')?_c('div',[_c('strong',[_vm._v(_vm._s(key.replace("_", " "))+":")]),_vm._v(" "+_vm._s(value)+"\n                              ")]):_vm._e(),_vm._v(" "),(key === 'periodo')?_c('div',[_c('strong',[_vm._v(_vm._s(key.replace("_", " "))+":")]),_vm._v(" "+_vm._s(value)+"\n                              ")]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(item.cambio)?_c('v-col',{staticClass:"m-0 p-1 pb-3 border-bottom border-left",attrs:{"cols":"6"}},[_c('legend',{staticClass:"h4 pl-3 mb-3 mt-0"},[_vm._v(" Corrección Declaración Cambio:")]),_vm._v(" "),_vm._l((item.cambio_declaracion),function(value,key){return _c('div',{key:key,staticClass:"m-0 p-0 pl-3 text-wrap",attrs:{"cols":"6"}},[(key === 'Tipo_Dec')?_c('div',[_c('strong',[_vm._v(_vm._s(key.replace("_", " "))+":")]),_vm._v(" "+_vm._s(value)+"\n                              ")]):_vm._e(),_vm._v(" "),(key === 'periodo')?_c('div',[_c('strong',[_vm._v(_vm._s(key.replace("_", " "))+":")]),_vm._v(" "+_vm._s(value)+"\n                              ")]):_vm._e()])})],2):_vm._e()],1),_vm._v(" "),_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[_c('v-col',{staticClass:" m-0 p-1",attrs:{"tag":"strong","cols":"12"}},[_vm._v(" Observaciones: ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 pb-3 border-bottom",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.observaciones? item.observaciones :'Sin observaciones.'))])],1),_vm._v(" "),(item.usuario)?_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[_c('v-col',{staticClass:" m-0 p-1 ",attrs:{"tag":"strong","cols":"12"}},[_vm._v(" Datos del creador del movimiento: ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 ",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.usuario.Nombre + ' '+ item.usuario.Paterno +' '+item.usuario.Materno))]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 ",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.usuario.User)+" ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 pb-3",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.getDependencias(item.usuario.ID_Dependencia))+" ")])],1):_vm._e(),_vm._v(" "),(item.aprobacion)?_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[_c('v-col',{staticClass:" m-0 p-1 ",attrs:{"tag":"strong","cols":"12"}},[_vm._v(" Datos de aprobación: ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 ",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.aprobacion.Nombre + ' '+ item.aprobacion.Paterno +' '+item.aprobacion.Materno))]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 ",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.aprobacion.User)+" ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 pb-3",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.getDependencias(item.aprobacion.ID_Dependencia))+" ")])],1):_vm._e()],1)],1)]}}])})],1)],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Listado de Correcciones ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aMZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_EmpresasSoc_vue__ = __webpack_require__("QDCC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_420a825c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_EmpresasSoc_vue__ = __webpack_require__("rFcm");
function injectStyle (ssrContext) {
  __webpack_require__("feV+")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_EmpresasSoc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_420a825c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_EmpresasSoc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b+YB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formularios_Aclaraciones_Aclaraciones_vue__ = __webpack_require__("mf5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["FormWizard"],
    Aclaraciones: __WEBPACK_IMPORTED_MODULE_2__Formularios_Aclaraciones_Aclaraciones_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  watch: {
    '$route': 'checkP'
  },
  methods: {},
  created: function created() {},
  mounted: function mounted() {
    this.$refs.wizard.activateAll();
  }
});

/***/ }),

/***/ "b7lh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bNdE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themify_icons_themify_icons_css__ = __webpack_require__("DaS8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themify_icons_themify_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__themify_icons_themify_icons_css__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ti-icon",
  props: ["icon"]
});

/***/ }),

/***/ "bZxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    var _ref;

    return _ref = {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,
      monedas: [],
      plazos: [],
      actividades: [],
      sectores: null,
      n_domicilio: null
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "monedas", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "entidadFed", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "municipios", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidades", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidad", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "paises", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isnum", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "item_actividades", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "list_actividades", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fields_list", [{
      key: "acciones",
      label: "Acciones",
      tdClass: "text-center"
    }, {
      key: "nombre_denominacion_razon_social",
      label: "Denominación o razón social",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "rfc",
      label: "RFC",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "curp",
      label: "CURP",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "sector_industria_id",
      label: "Sector",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "tipo_actividad_servicio_id",
      label: "Tipo de actividad ",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "descripcion_actividad_servicio",
      label: "Descripción de la actividad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "ingreso_bruto_anual",
      label: "Ingreso bruto anual ",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "moneda_id",
      label: "Moneda",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "duracion_frecuencia",
      label: "Duración / Frecuencia",
      tdClass: "text-center",
      formatter: 'emptyFields'
    }, {
      key: "unidad_temporal_id",
      label: "Unidad temporal",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "fecha_transaccion",
      label: "Fecha de transacción",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "observaciones",
      label: "Observaciones",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "pais_id",
      label: "País",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "entidad_federativa_id",
      label: "Entidad federativa",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "municipio_id",
      label: "Municipio",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "localidad_id",
      label: "Localidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "colonia",
      label: "Colonia",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_tipo_vial",
      label: "Tipo vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_nom_vial",
      label: "Nombre vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "cp",
      label: "CP",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numExt",
      label: "Número exterior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numInt",
      label: "Número interior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }]), _ref;
  },

  computed: {
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.item_actividades.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.item_actividades.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {
    list_actividades: {
      handler: function handler() {
        if (this.list_actividades) {
          this.setLocalidades();
          if (this.list_actividades.length == 0) {
            this.bandera = '0';
          } else {
            this.bandera = '1';
          }
        }
      },
      deep: true
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_actividades.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_actividades.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_actividades.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_actividades.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_actividades.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_actividades.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_actividades.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_actividades.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_actividades.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_actividades.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    }
  },
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMoneda: function getMoneda(index) {
      var resp = "";
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getActividad: function getActividad(index) {
      var resp = " ";
      if (this.sectores) {
        this.actividades.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUnidades: function getUnidades(index) {
      var resp = " ";
      if (this.plazos) {
        this.plazos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: '',
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
      this.item_actividades = {
        acciones: "",
        rfc_quien_adquirio: "",
        ingreso_bruto_anual: "",
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: "",
        entidad_federativa_id: "",
        municipio_id: "",
        localidad_id: "",
        colonia: "",
        cp: "",
        numExt: "",
        numInt: "",
        vialidad_nom_vial: "",
        vialidad_tipo_vial: "",
        observaciones: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      if (this.item_actividades) {
        this.item_actividades.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post("actividades_economicas", this.item_actividades).then(function (response) {
          _this.StepOk("Guardado");
          if (_this.edit_item === undefined || _this.edit_item === null) {
            _this.list_actividades.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.actividad));
          } else {
            _this.list_actividades.splice(_this.edit_item.index, 1, _this.item_actividades);
            _this.edit_item.item._rowVariant = "";
          }
          _this.showItem();
          _this.initItem();
          _this.edit_item = null;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW("Hay campos sin completar");
      }
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_actividades = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_actividades[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_actividades[indice].id !== null) {
        var item = this.list_actividades[indice];

        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("actividades_economicas/" + item.id).then(function (response) {
            _this2.list_actividades.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_actividades.pais_id ? this.item_actividades.pais_id : 150;
      this.n_domicilio.entidadF = this.item_actividades.entidad_federativa_id ? this.item_actividades.entidad_federativa_id : '';
      this.n_domicilio.municipio = this.item_actividades.municipio_id ? this.item_actividades.municipio_id : '';
      this.n_domicilio.localidad = this.item_actividades.localidad_id ? this.item_actividades.localidad_id : '';
      this.n_domicilio.cp = this.item_actividades.cp ? this.item_actividades.cp : '';
      this.n_domicilio.colonia = this.item_actividades.colonia ? this.item_actividades.colonia : '';
      this.n_domicilio.vialidad = this.item_actividades.vialidad_tipo_vial ? this.item_actividades.vialidad_tipo_vial : '';
      this.n_domicilio.vialidad_nombre = this.item_actividades.vialidad_nom_vial ? this.item_actividades.vialidad_nom_vial : '';
      this.n_domicilio.ext = this.item_actividades.numExt ? this.item_actividades.numExt : '';
      this.n_domicilio.int = this.item_actividades.numInt ? this.item_actividades.numInt : '';
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      this.list_actividades.forEach(function (item) {
        if (item.localidad_id) {
          _this3.$http.get('localidades/localidad/' + item.localidad_id).then(function (response) {
            _this3.localidades.push(response.data.localidad);
          }, function (error) {
            _this3.Err(error);
          });
        }
      });
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("actividades_economicas/" + this.ip_id).then(function (response) {
      _this4.list_actividades = response.data.actividades;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_unidad_medida_plazo").then(function (response) {
      _this4.plazos = response.data.unidades;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_actividad").then(function (response) {
      _this4.actividades = response.data.actividad;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("monedas").then(function (response) {
      _this4.monedas = response.data.monedas;
      var temp = "97";
      _this4.monedas.forEach(function (item) {
        if (item.codigo == "MXN") {
          temp = item.id;
        }
      });
      _this4.item_actividades.moneda_id = temp;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "bc6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[(_vm.status_dec=0)?_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("No anexaste el acuse de la declaración fiscal, agregalo aquí:")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[(_vm.obligado=='SI')?_c('div',{staticClass:"col-md-12"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[(_vm.add_item)?_c('div',[_c('div',{staticClass:"row m-3"},[_c('div',{staticClass:"col-md-12 form-group",staticStyle:{"text-align":"left"}},[_vm._v("\n                  Seleccione archivo en formato PDF\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 custom-file"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"xlsx",staticClass:"custom-file-input",attrs:{"id":"xlsx","accept":".pdf","name":"file","type":"file"},on:{"change":function($event){return _vm.addFile('xlsx')}}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":"xlsx"}},[_vm._v("Archivo seleccionado: "+_vm._s(_vm.xlsx ? _vm.xlsx.name : ''))]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('file')))])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(!_vm.edit_item )?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"row justify-content-end ml-3 mr-3"},[(!_vm.add_item && _vm.fileExist)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(4)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargaFiscal(item.file)}}},[_c('i',{staticClass:"far fa-file-pdf"})]),_vm._v(" "),_c('br')],1)]}},{key:"item.anio",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterAnio(item.created_at)))])]}},{key:"item.file",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("Declaración fiscal "+_vm._s(_vm.filterAnio(item.created_at)))])]}},{key:"item.fecha",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat3(item.created_at)))])]}}])})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"12px"}},[(_vm.status_dec=1)?_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",on:{"click":function($event){return _vm.siguente()}}},[_vm._v("Siguiente")])]):_vm._e(),_vm._v(" "),(_vm.status_dec=0)?_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next"},[_vm._v("Enviar")])]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning"},[_c('span',[_vm._v("De acuerdo a la información capturada, usted está obligado a cargar su acuse de declaración fiscal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row m-3"},[_c('legend',[_vm._v("Cargar acuse de la declaración fiscal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row "},[_c('hr',{staticClass:" bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bk6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),(this.getKey('status_dec') == 0)?_c('div',{staticClass:"col-md-12"},[_vm._m(2),_vm._v(" "),(this.getKey('status_dec') == 0)?_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_vm._v("\n          ¿Tienes alguna aclaración que hacer sobre tu declaracion patrimonial?, "),_c('a',{staticClass:"alert-link",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.aclaraciones}},[_vm._v(" agrégala aquí.")])]):_vm._e(),_vm._v(" "),(!_vm.hasfiscal)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n          Si omitiste anexar el acuse de presentación de la declaración fiscal, "),_c('a',{staticClass:"alert-link",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.fiscal}},[_vm._v(" agrégalo aquí.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success",on:{"click":_vm.irHistorico}},[_vm._v("Consultar Historial")])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(this.getKey('status_dec') == 1)?_c('div',{staticClass:"col-md-12"},[_vm._l((this.getKey('tipo_dec_list')),function(dec,i){return _c('div',{key:i,staticClass:"alert alert-warning"},[_c('span',[_vm._v(" Tienes una declaración "),_c('b',[_vm._v(_vm._s(_vm.tipoD(dec.tipo_dec_id)))]),_vm._v(" pendiente del "),_c('b',[_vm._v(_vm._s(dec.periodo))]),_vm._v(" en "),_c('b',[_vm._v(_vm._s(_vm.getDep(dec.ente_publico_id)))])])])}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-wd",on:{"click":_vm.irLlenado}},[_vm._v("Ir a llenado")])])],2):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"col-md-12"},[_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Bienvenido")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Declaración Patrimonial")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_c('span',[_vm._v("No tienes declaraciones pendientes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":"#exampleModalLong"}},[_vm._v("\n            Consulta el aviso de privacidad\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalLong","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLongTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v("AVISO DE PRIVACIDAD SIMPLIFICADO ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',{staticStyle:{"text-align":"right"}},[_c('b',[_vm._v("CONTRALORIA MUNICIPAL DE IRAPUATO\n                    ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('b',[_vm._v("\n                      AVISO DE PRIVACIDAD SIMPLIFICADO\n                      "),_c('br'),_vm._v("DECLARACIONES PATRIMONIALES\n                    ")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n                      I. Denominación y domicilio del responsable.\n                    ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                    La "),_c('strong',[_vm._v("Dirección de Auditoría")]),_vm._v(", dependiente de la Contraloría Municipal de Irapuato, Guanajuato, con domicilio ubicado en Avenida \n                    Álvaro Obregón no. 100, 4to piso Zona Centro, C.P. 36500 en el municipio de Irapuato Guanajuato, es la "),_c('strong',[_vm._v("Responsable")]),_vm._v(" del tratamiento \n                    y resguardo de los datos personales que nos proporcione, siendo el "),_c('strong',[_vm._v("Sujeto Obligado")]),_vm._v(" el Municipio de Irapuato, Guanajuato, los cuales \n                    serán protegidos conforme a lo dispuesto por la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados y la \n                    Ley de Protección de Datos Personales en Posesión de Sujetos Obligados para el Estado de Guanajuato.\n                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n                      II. Finalidad del tratamiento de los datos personales.\n                    ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                    Los datos personales solicitados anteriormente, serán utilizados para:\n                    "),_c('ul',{staticStyle:{"padding":"1rem"}},[_c('li',[_vm._v("Generar en el sistema DECLARANET IRAPUATO el alta de la persona servidora pública.")]),_vm._v(" "),_c('li',[_vm._v("Integrar la información correspondiente a declaraciones patrimoniales y de intereses del personal \n                        que labora en la Administración Pública Municipal centralizada y descentralizada.")]),_vm._v(" "),_c('li',[_vm._v("Cumplir con las obligaciones de transparencia, en específico lo relacionado con las declaraciones \n                        patrimoniales.")]),_vm._v(" "),_c('li',[_vm._v("Dar seguimiento a la presentación de la declaración patrimonial y de intereses, para la detección \n                        e los servidores públicos que omitieron presentarla.")]),_vm._v(" "),_c('li',[_vm._v("Verificar de manera aleatoria el contenido de las declaraciones patrimoniales, de conflicto de \n                        intereses y constancias de presentación de declaración fiscal de las personas servidores públicas, \n                        que obren en el sistema declaración patrimonial, así como de la evolución del patrimonio de los \n                        servidores públicos.")])])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n                      III. Transferencia de datos personales.\n                    ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                    Se informa que no se realizarán transferencias de datos personales, salvo aquéllas que sean necesarias para atender \n                    requerimientos de información de una autoridad competente, que estén debidamente fundados y motivados, ni tampoco se \n                    realizarán transferencias adicionales, salvo que se actualice alguno de los casos establecidos en el artículo 19 de \n                    la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados para el Estado de Guanajuato.\n                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n                      IV. Negativa para el tratamiento de sus datos personales.\n                    ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                    Podrá manifestar la negativa del tratamiento de sus datos personales para finalidades y transferencias de los datos que \n                    requieren el consentimiento del titular directamente en las instalaciones de la Unidad de Transparencia del "),_c('strong',[_vm._v("Sujeto Obligado")]),_vm._v(", \n                    siendo este el municipio de Irapuato, Guanajuato, con domicilio ubicado en Calle Hidalgo No.77 Barrio de Santiaguito, \n                    Zona Centro, C.P. 36500, en el municipio de Irapuato, Guanajuato, (CAM) o bien, comunicarse al número telefónico \n                    462 6069 999 extensión 1431, de lunes a viernes en un horario de 08:30 a 16:00 horas, así como a través del correo electrónico: \n                    "),_c('strong',[_vm._v("transparencia.irapuato@irapuato.gob.mx")]),_vm._v(".\n                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n                      Cabe mencionar que el no compartir datos, no impide recibir el servicio.\n                    ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right"}},[_c('b',[_vm._v("\n                      Fecha de elaboración\n                    ")]),_c('br'),_vm._v("\n                    17 de febrero de 2025\n                  ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right"}},[_c('b',[_vm._v("\n                      Última actualización del aviso de privacidad.\n                    ")]),_c('br'),_vm._v("\n                    12 de marzo de 2026.\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Cerrar")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_c('span',[_vm._v("La fecha limíte para presentar tu declaración ha expirado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-wd"},[_vm._v("Solicitar prórroga")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "btkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Altas_vue__ = __webpack_require__("Oiwr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_269bed2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Altas_vue__ = __webpack_require__("wjcp");
function injectStyle (ssrContext) {
  __webpack_require__("JYw5")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Altas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_269bed2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Altas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bvor":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("o1ya");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0012b22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("TtKX");
function injectStyle (ssrContext) {
  __webpack_require__("DQoI")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0012b22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c7fY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cD8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"error-color":"#EB5E28","color":"#1e94fd","title":"Movimientos del padrón","subtitle":""}},[_c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Consulta general","active":"","lazy":""}},[_c('consulta',{ref:"Consulta"})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Movimientos","lazy":""}},[_c('lista',{ref:"Lista"})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Licencias","lazy":""}},[_c('licencias',{ref:"Licencias"})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"VoBo. Correcciones","lazy":""}},[_c('correcciones',{ref:"Correcciones"})],1),_vm._v(" "),((_vm.rol == 1))?_c('b-tab',{attrs:{"title":"Declaraciones","lazy":""}},[_c('lista-correcciones',{ref:"Declaraciones"})],1):_vm._e(),_vm._v(" "),((_vm.rol == 1))?_c('b-tab',{attrs:{"title":"Transferencias","lazy":""}},[_c('transferencias',{ref:"Transferencias"})],1):_vm._e(),_vm._v(" "),_c('b-tab',{attrs:{"title":"Servidores inactivos","lazy":""}},[_c('inactivos',{ref:"Inactivos"})],1)],1)],1),_vm._v(" "),_c('button',{staticClass:"d-none",attrs:{"slot":"next"},slot:"next"},[_vm._v("Siguiente")]),_vm._v(" "),_c('button',{staticClass:"d-none",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Siguientes")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cFIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cHUH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cNav":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Realiza actividades profesionales ?\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre, denominación o razón social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.nombre_denominacion_razon_social),expression:"item_actividades.nombre_denominacion_razon_social"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre, denominación o razón social de quien se adquirió el inmueble:"},domProps:{"value":(_vm.item_actividades.nombre_denominacion_razon_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "nombre_denominacion_razon_social", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.rfc),expression:"item_actividades.rfc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RFC"},domProps:{"value":(_vm.item_actividades.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "rfc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("CURP (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.curp),expression:"item_actividades.curp"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CURP"},domProps:{"value":(_vm.item_actividades.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "curp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector / Industria (si aplica)")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "sector_industria_id", $$v)},expression:"item_actividades.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de actividad o servicio que produjo el ingreso")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.tipo_actividad_servicio_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "tipo_actividad_servicio_id", $$v)},expression:"item_actividades.tipo_actividad_servicio_id"}},_vm._l((_vm.actividades),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Descripción de la actividad que produce el ingreso")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.descripcion_actividad_servicio),expression:"item_actividades.descripcion_actividad_servicio"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción de la actividad"},domProps:{"value":(_vm.item_actividades.descripcion_actividad_servicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "descripcion_actividad_servicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 customCurrency"},[_c('label',{staticClass:"control-label"},[_vm._v("Ingreso bruto anual recibido por la actividad")]),_vm._v(" "),_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{staticClass:"text-right",attrs:{"type":"number","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.item_actividades.ingreso_bruto_anual),callback:function ($$v) {_vm.$set(_vm.item_actividades, "ingreso_bruto_anual", $$v)},expression:"item_actividades.ingreso_bruto_anual"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.item_actividades.moneda_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "moneda_id", $$v)},expression:"item_actividades.moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.item_actividades.moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Duración o frecuencia ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.duracion_frecuencia),expression:"item_actividades.duracion_frecuencia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Frecuencia"},domProps:{"value":(_vm.item_actividades.duracion_frecuencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "duracion_frecuencia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Unidad temporal")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_actividades.unidad_temporal_id),callback:function ($$v) {_vm.$set(_vm.item_actividades, "unidad_temporal_id", $$v)},expression:"item_actividades.unidad_temporal_id"}},_vm._l((_vm.plazos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.item_actividades.unidad_temporal_id == 4)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de transacción")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.item_actividades.fecha_transaccion),callback:function ($$v) {_vm.$set(_vm.item_actividades, "fecha_transaccion", $$v)},expression:"item_actividades.fecha_transaccion"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones / Comentarios")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_actividades.observaciones),expression:"item_actividades.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Observaciones / Comentarios"},domProps:{"value":(_vm.item_actividades.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_actividades, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":""},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_actividades","responsive":"","hover":"","items":_vm.list_actividades,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.entidad_federativa_id)))]}},{key:"localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.localidad_id))+"\n            ")]}},{key:"municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.municipio_id)))]}},{key:"pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_id)))]}},{key:"sector_industria_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSector(row.item.sector_industria_id)))]}},{key:"tipo_actividad_servicio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getActividad(row.item.tipo_actividad_servicio_id)))]}},{key:"ingreso_bruto_anual",fn:function(row){return [_vm._v(_vm._s((_vm.getSignoDos(row.item.moneda_id)))+"\n              "+_vm._s(_vm._f("currency")(row.item.ingreso_bruto_anual)))]}},{key:"moneda_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getMoneda(row.item.moneda_id)))]}},{key:"unidad_temporal_id",fn:function(row){return [_vm._v(_vm._s(_vm.getUnidades(row.item.unidad_temporal_id)))]}}],null,false,2722672800)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Actividad profesional")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cUnQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSuperior_vue__ = __webpack_require__("qT/J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb69a2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSuperior_vue__ = __webpack_require__("QHVm");
function injectStyle (ssrContext) {
  __webpack_require__("YQix")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSuperior_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb69a2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSuperior_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cY4Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cYKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("Histórico de Declaraciones")]),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition"},scopedSlots:_vm._u([{key:"default",fn:function(dialog){return [_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),(_vm.loadBitacora)?_c('v-card-text',{staticClass:"border-top"},[_c('v-card-subtitle',[_vm._v("Espere por favor...")]),_vm._v(" "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"primary"}})],1):_c('v-card-text',{staticClass:"border-top"},[_c('v-row',{staticClass:"pt-3"},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',[_c('label',{staticClass:"font-weight-bold"},[_vm._v("Dependencia Origen")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(" "+_vm._s(_vm.correccion.dependencia_orgen))])])])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('div',[_c('label',{staticClass:"font-weight-bold"},[_vm._v("Dependencia Destino")]),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia_cambio","placeholder":"Dependencia"},model:{value:(_vm.correccion.dependencia_destino_id),callback:function ($$v) {_vm.$set(_vm.correccion, "dependencia_destino_id", $$v)},expression:"correccion.dependencia_destino_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('dependencia_cambio'))+"\n                    ")])],1)]),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('div',[_c('label',{staticClass:"font-weight-bold"},[_vm._v("\n                      Tipo declaración\n                    ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"filterable":"","name":"tipo_dec","placeholder":"Tipo declaración"},model:{value:(_vm.correccion.tipo_declaracion_id),callback:function ($$v) {_vm.$set(_vm.correccion, "tipo_declaracion_id", $$v)},expression:"correccion.tipo_declaracion_id"}},_vm._l((_vm.tipo_declaracion),function(option){return _c('el-option',{key:option.id+'tipo',staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('tipo_dec'))+"\n                    ")])],1)]),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('div',[_c('label',{staticClass:"font-weight-bold"},[_vm._v("\n                      Periodo\n                    ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.correccion.periodo),callback:function ($$v) {_vm.$set(_vm.correccion, "periodo", $$v)},expression:"correccion.periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('periodo'))+"\n                    ")])],1)])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.correccion.observaciones),expression:"correccion.observaciones"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"observaciones","placeholder":"Motivos/Observaciones"},domProps:{"value":(_vm.correccion.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.correccion, "observaciones", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('observaciones'))+"\n                    ")])])])],1)],1),_vm._v(" "),(!_vm.loadBitacora)?_c('v-card-text',{staticClass:"border-top"},[_c('v-row',{staticClass:"pt-3"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"color":"success","loading":_vm.loadCorreccion,"disabled":_vm.loadCorreccion,"outlined":""},on:{"click":_vm.makeCorrection}},[_c('i',{staticClass:"fas fa-save mr-3"}),_vm._v(" Generar Correción")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-end border-top"},[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){dialog.value = false}}},[_vm._v("Cerrar")])],1)],1)]}}]),model:{value:(_vm.intDialogVisible),callback:function ($$v) {_vm.intDialogVisible=$$v},expression:"intDialogVisible"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shlista),expression:"shlista"}],staticClass:"row"},[(_vm.rol===4 || _vm.rol===5 || _vm.rol ===14)?_c('div'):_c('div',{staticClass:"col-md-8"},[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.filtrainici)?_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('label',[_vm._v("Filtra por inicial de RFC")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción"},on:{"change":_vm.traeiniciales},model:{value:(_vm.iniciales),callback:function ($$v) {_vm.iniciales=$$v},expression:"iniciales"}},_vm._l((_vm.inicialeslst),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.rol!=4)?_c('div',{staticClass:"col-md-4 pull-left"},[_c('button',{staticClass:"btn btn-fill btn-success",attrs:{"disabled":_vm.loading},on:{"click":_vm.getDeclaraciones}},[_vm._v("\n            "+_vm._s(_vm.loading ? 'Buscando...': 'Buscar')+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shlista),expression:"shlista"}]},[_c('br'),_vm._v(" "),_c('div',{staticClass:"offset-md-6 col-sm-6 col-md-6 col-lg-6"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.filtro_usuarios,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Ver histórico'),expression:"'Ver histórico'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.historico(item)}}},[_c('i',{staticClass:"fas fa-history"})])],1)]}},{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.dateFormat(item.fecha)))])]}}])}),_vm._v(" "),_c('v-data-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.shhistorico),expression:"shhistorico"}],attrs:{"headers":_vm.headers2,"items":_vm.table_list,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.periodo",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.periodo))])]}},{key:"item.patrimonial",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item.id)}}},[_c('i',{staticClass:"far fa-file-pdf"})])]}}])})],1)])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shhistorico),expression:"shhistorico"}],staticClass:"card-content"},[_c('button',{staticClass:"btn btn-fill btn-success pull-right",on:{"click":_vm.regresar}},[_vm._v("\n        Regresar\n      ")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-chip',{staticClass:"ma-2",attrs:{"color":"primary","label":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fas fa-user")]),_vm._v("\n            "+_vm._s(_vm.nombre)+"\n          ")],1),_vm._v(" "),_c('v-chip',{staticClass:"ma-2",attrs:{"color":"primary","label":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fas fa-calendar")]),_vm._v("\n            Fecha de Alta: "+_vm._s(_vm.alta)+"\n          ")],1),_vm._v(" "),(_vm.baja)?_c('v-chip',{staticClass:"ma-2",attrs:{"color":"red","label":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fas fa-calendar")]),_vm._v("\n            Baja: "+_vm._s(_vm.baja)+"\n          ")],1):_c('v-chip',{staticClass:"ma-2",attrs:{"color":"success","label":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fas fa-calendar")]),_vm._v("\n            ACTIVO\n          ")],1),_vm._v(" "),(_vm.rol!=4)?_c('v-data-table',{attrs:{"headers":_vm.headers2,"items":_vm.table_list,"items-per-page":5,"fixed-header":true},scopedSlots:_vm._u([{key:"item.periodo",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.periodo))])]}},{key:"item.patrimonial",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item)}}},[_c('i',{staticClass:"far fa-file-pdf"})])]}},{key:"item.fiscal",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargaFiscal(item.declaracion_fiscal)}}},[_c('i',{staticClass:"far fa-file-pdf"})])]}},{key:"item.acuse",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargaAcuse(item)}}},[_c('i',{staticClass:"far fa-file-pdf"})])]}},{key:"item.aclaraciones",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargaAclaracion(item.aclaraciones)}}},[_c('i',{staticClass:"fas fa-info"})])]}},{key:"item.entidad",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getEntidad(item)))])]}},{key:"item.posesion",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getFechaPos(item)))])]}},{key:"item.presentacion",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.dateFormat(item.created_at)))])]}},{key:"item.cargo",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getCargo(item)))])]}}],null,false,151172271)}):_c('v-data-table',{attrs:{"headers":_vm.headers3,"items":_vm.table_list,"items-per-page":5,"fixed-header":true},scopedSlots:_vm._u([{key:"item.periodo",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.periodo))])]}},{key:"item.acuse",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.descargaAcuse(item)}}},[_c('i',{staticClass:"far fa-file-pdf"})])]}},{key:"item.entidad",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getEntidad(item)))])]}},{key:"item.posesion",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getFechaPos(item)))])]}},{key:"item.presentacion",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.dateFormat(item.created_at)))])]}},{key:"item.cargo",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getCargo(item)))])]}}])}),_vm._v(" "),(_vm.justificados.length > 0)?_c('v-chip',{staticClass:"ma-2",attrs:{"color":"primary","label":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fas fa-user")]),_vm._v("\n            "+_vm._s("DECLARACIONES JUSTIFICADAS")+"\n          ")],1):_vm._e(),_vm._v(" "),(_vm.justificados.length > 0)?_c('v-data-table',{attrs:{"headers":_vm.headers4,"items":_vm.justificados,"items-per-page":5,"fixed-header":true}}):_vm._e()],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cZnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("kDzH");










var _components;


/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), _components),
  props: ["data"],
  data: function data() {
    return {
      validaciones: {
        rfc_parte: false
      },
      ip_id: 1,
      add_item: false,
      edit_item: null,
      pagado: null,
      bandera: '0',
      isnum: null,
      form_item: {},
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Representante',
        value: 'representante',
        align: 'center'
      }, {
        text: 'Tipo de representación',
        value: 'tipo_representacion_id',
        align: 'center'
      }, {
        text: 'Fecha de inicio',
        value: 'fecha',
        align: 'center'
      }, {
        text: 'Nombre de la parte representada',
        value: 'nombre',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Representante / Representado',
        value: 'representado',
        align: 'center'
      }, {
        text: 'Remuneración',
        value: 'representado',
        align: 'center'
      }, {
        text: 'Monto mensual neto',
        value: 'monto',
        align: 'center'
      }, {
        text: 'Sector',
        value: 'sector_industria_id',
        align: 'center'
      }],
      info: {
        representacion: 'Es cuando el Declarante actúa a nombre de otra persona física o moral (representante) o cuando una persona actúa a nombre del Declarante (representado). Deberá reportar hasta los últimos dos años.',
        representante: 'Señalar quien tiene la representación (representante o representado).',
        tipo: 'Indicar si es representante o representado.',
        fecha: 'Indicar la fecha en que comenzó la representación.',
        representado: 'Seleccionar si es persona física o persona moral.',
        nombre: 'Indicar el nombre o razón social completos de su representante o representado.',
        rfc: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del representante/representado.',
        remunerado: 'Indicar sí o no le pagan por representar a alguien.',
        monto: 'Especificar el monto mensual neto, sin centavos, que percibe por su representación.',
        lugar: 'Indicar si se encuentra en México, debiendo señalar entidad federativa; o en el extranjero, debiendo señalar el país donde se localiza.',
        sector: 'Elegir el sector al que pertenece.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
      if (!this.form_item.pais_id) {
        this.form_item.pais_id = 150;
      }
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = null;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("representacion", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = item;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.edit_item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("representacion/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');
    this.$http.get("representacion/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    }, function (error) {
      _this3.Err(error);
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();

    this.form_item.pais_id = 150;
  }
});

/***/ }),

/***/ "ce+6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "csbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Modificadas_vue__ = __webpack_require__("UnLW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_31447501_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Modificadas_vue__ = __webpack_require__("PXpD");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Modificadas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_31447501_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Modificadas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cvgq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_AltaPersonal_vue__ = __webpack_require__("xzrE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e22e1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_AltaPersonal_vue__ = __webpack_require__("UmAO");
function injectStyle (ssrContext) {
  __webpack_require__("EY+3")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_AltaPersonal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e22e1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_AltaPersonal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cwZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[(_vm.cargando)?_c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{attrs:{"id":"loader"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row "},[_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"row d-flex align-items-center m-0 p-0"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4 p-2"},[_c('a',{staticClass:"btn btn-wd btn-info pull-right",attrs:{"target":"_blanc","href":_vm.$rootUrl+'/plantillac.xlsx',"alt":"Plantilla XLSX"}},[_vm._m(1),_vm._v("\n                Descargar Plantilla\n              ")])])]),_vm._v(" "),_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveComprobante.apply(null, arguments)}}},[_c('table',{staticClass:"table"},[_c('tbody',[_vm._m(2),_vm._v(" "),(_vm.getKey('permisos').includes(5))?_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v(" Dependencia")]),_vm._v(" "),_c('td',[_c('el-select',{staticClass:"select-default",attrs:{"name":"ente_publico_id","placeholder":"Seleccione una opción","filterable":""},model:{value:(_vm.ente_publico_id),callback:function ($$v) {_vm.ente_publico_id=$$v},expression:"ente_publico_id"}},_vm._l((_vm.entes),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("\n                    Tipo de declaración\n                  ")]),_vm._v(" "),_c('td',[_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.simplificada),callback:function ($$v) {_vm.simplificada=$$v},expression:"simplificada"}},[_vm._v("Completa")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block no",attrs:{"label":"1"},model:{value:(_vm.simplificada),callback:function ($$v) {_vm.simplificada=$$v},expression:"simplificada"}},[_vm._v("Simplificada")])],1)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("\n                    Declaración a realizar\n                  ")]),_vm._v(" "),_c('td',[_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"tipo_dec","placeholder":"Tipo declaración"},model:{value:(_vm.tipo_dec),callback:function ($$v) {_vm.tipo_dec=$$v},expression:"tipo_dec"}},_vm._l((_vm.tipo_declaracion),function(option){return _c('el-option',{key:option.id+'tipo',staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("\n                    Periodo\n                  ")]),_vm._v(" "),_c('td',[_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.periodo),callback:function ($$v) {_vm.periodo=$$v},expression:"periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1)],1)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Seleccionar el grupo para cargar el padrón")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.grupo),expression:"grupo"}],staticClass:"select-default",attrs:{"name":"grupo","id":"grupo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.grupo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Grupo 1")]),_vm._v(" "),_c('option',{attrs:{"value":"2","selected":""}},[_vm._v("Grupo 2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Grupo 3")])])])]),_vm._v(" "),(_vm.ente_publico_id || _vm.getKey('permisos').includes(5)===false )?_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Seleccionar el archivo excel")]),_vm._v(" "),_c('td',[_c('input',{ref:"xlsx",staticClass:"form-control",attrs:{"id":"xlsx","accept":".xlsx","required":"","type":"file"},on:{"change":function($event){return _vm.addFile('xlsx')}}})])]):_vm._e(),_vm._v(" "),(_vm.grupo!=0 && _vm.xlsx!=0)?_c('tr',[_c('td',{attrs:{"colspan":"2","align":"center"}},[_c('button',{ref:"btnSave",staticClass:"btn btn-primary"},[_c('i',{staticClass:"fa fa-send"}),_vm._v(" Guardar")])])]):_vm._e()])])]),_vm._v(" "),(Object.entries(_vm.incorrectos).length > 0 )?_c('h3',{staticClass:"bg-info text-white",attrs:{"align":"center"}},[_vm._v("\n            Los siguientes registros cuentan con errores, favor de corregirlos y volver a cargar la plantilla. No se ha cargado ningún registro.\n          ")]):_vm._e(),_vm._v(" "),(Object.entries(_vm.incorrectos).length > 0 )?_c('b-table',{attrs:{"id":"tbl_incorrectos","responsive":"","hover":"","items":_vm.incorrectos,"fields":_vm.fields_list},scopedSlots:_vm._u([{key:"Renglon",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Renglon))])])]}},{key:"Columna",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Columna))])])]}},{key:"Nombre",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Nombre))])])]}},{key:"RFC",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.RFC))])])]}},{key:"Mensaje",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(data.item.Mensaje))])])]}}],null,false,3672104190)},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2):_vm._e(),_vm._v(" "),(_vm.correctos>0)?_c('table',{staticClass:"table"},[_vm._m(3),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('label',{staticStyle:{"color":"#212529"}},[_vm._v("\n                    "+_vm._s(this.correctos)+" registros han sido importados correctamente\n                  ")])])])])]):_vm._e()],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 p-0"},[_c('legend',[_vm._v("Importar padrón de servidores públicos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('div',{staticClass:"row m-0 p-0"},[_c('div',{staticClass:"col-12 m-0 p-0"},[_c('div',{staticClass:"alert alert-warning mb-0"},[_c('b',[_vm._v("Todos los servidores públicos serán cargados con los parámetros seleccionados, verifique que sean correctos.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("El archivo se importó correctamente")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dUCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Fiscal_vue__ = __webpack_require__("EYv4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c311f1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Fiscal_vue__ = __webpack_require__("bc6H");
function injectStyle (ssrContext) {
  __webpack_require__("8rzW")
  __webpack_require__("z+sU")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Fiscal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c311f1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Fiscal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dY1p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("s/F+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("yrbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_excel_export__ = __webpack_require__("VdFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TipoDec_component_vue__ = __webpack_require__("zP5n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);












var _components;












__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_excel_export__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'TipoDec', __WEBPACK_IMPORTED_MODULE_16__TipoDec_component_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      opciones: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      },
      intDialogVisible: false,
      isLoading: false,
      encargo: {},
      filter: '',
      iniciales: '',
      movimiento: {},
      tipobusqueda: '1',
      busquedarfc: '',
      meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      nombreC: '',
      coloremp: 'info',
      txtemp: 'Buscando',
      list_declarantes2: [],
      text: 'Acciones',
      align: 'center',
      sortable: false,
      value: 'acciones',
      class: '',
      cumplidos_campos: {
        'RFC': 'rfc',
        'Nombres': 'nombres',
        'Dependencia': 'dependencia',
        'Área': 'area',
        'Cargo': 'cargo',
        'Nivel': 'nivel',
        'Tipo de Declaración': 'simplificada',
        'Titular': 'titular',
        'Activo': 'activo'
      },
      filtrainici: false,
      tipo_declaracion: [{
        'id': 1,
        'valor': 'Inicial'
      }, {
        'id': 2,
        'valor': 'Anual'
      }, {
        'id': 3,
        'valor': 'Final'
      }],
      grupos: [{
        'id': 1,
        'valor': 'Grupo 1',
        'cve': 'g1'
      }, {
        'id': 2,
        'valor': 'Grupo 2',
        'cve': 'g2'
      }, {
        'id': 3,
        'valor': 'Grupo 3',
        'cve': 'g3'
      }],
      inicialeslst: [{
        'id': 1,
        'valor': 'A-B',
        'cve': '1'
      }, {
        'id': 2,
        'valor': 'C-D',
        'cve': '2'
      }, {
        'id': 3,
        'valor': 'E-F',
        'cve': '3'
      }, {
        'id': 4,
        'valor': 'G-H',
        'cve': '4'
      }, {
        'id': 5,
        'valor': 'I-J',
        'cve': '5'
      }, {
        'id': 6,
        'valor': 'K-L',
        'cve': '1'
      }, {
        'id': 7,
        'valor': 'M-O',
        'cve': '2'
      }, {
        'id': 8,
        'valor': 'P-Q',
        'cve': '3'
      }, {
        'id': 9,
        'valor': 'R-S',
        'cve': '4'
      }, {
        'id': 10,
        'valor': 'T-U',
        'cve': '5'
      }, {
        'id': 11,
        'valor': 'V-W',
        'cve': '3'
      }, {
        'id': 12,
        'valor': 'X-Z',
        'cve': '4'
      }],
      currentPage: 1,
      perPage: 30,
      rol: "",
      id: 1,
      rows: null,
      add_item: false,
      edit_item: null,
      tipos: null,
      n_domicilio: null,
      dependencias: null,
      filtro: "",
      filtrorfc: '',
      tipo_mov: null,
      form_item: {},
      list_usuarios: [],
      filtro_usuarios: [],
      origen: {},
      form_itemValidations: {
        rfc: {
          required: true
        },
        curp: {
          required: true
        },
        correo_laboral: {
          required: true
        },
        grupo: {
          required: true
        },
        nombres: {
          required: true
        },
        primer_apellido: {
          required: true
        },
        segundo_apellido: {
          required: true
        },
        ente_publico_id: {
          required: true
        },
        direccion_cargo: {
          required: true
        },
        nivel: {
          required: true
        },
        area_adscripcion: {
          required: true
        },
        honorarios: {
          required: true
        },
        AG172: {
          required: true
        },
        fecha_termino: {
          required: true
        },
        motivo: {
          required: true
        },
        tipo_baja: {
          required: true
        },
        inicia: {
          required: true
        },
        termina: {
          required: true
        },
        tipo_licencia: {
          required: true
        },
        fecha_posesion: {
          required: true
        },
        tipo_dec_id: {
          required: true
        }
      },
      campos_busqueda: ['rfc', 'nombres', 'primer_apellido', 'segundo_apellido'],
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'ente',
        align: 'center'
      }, {
        text: 'Área',
        value: 'area',
        align: 'center'
      }, {
        text: 'Cargo Funcional',
        value: 'cargo',
        align: 'center'
      }, {
        text: 'Nivel',
        value: 'nivel',
        align: 'center'
      }, {
        text: 'Tipo de declaración',
        value: 'simplificada',
        align: 'center'
      }, {
        text: 'Titular',
        value: 'titular',
        align: 'center'
      }, {
        text: 'Activo',
        value: 'activo',
        align: 'center'
      }],
      fields_list: [{
        key: "acciones",
        label: "Acciones",
        thClass: "td-small",
        tdClass: "text-center td-small"
      }, {
        key: "rfc",
        label: "RFC",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: "emptyFields"
      }, {
        key: "nombres primer_apellido segundo_apellido",
        label: "Nombre",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "encargo.ente_publico_id",
        label: "Dependencia",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "area",
        label: "Área",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "cargo",
        label: "Cargo Funcional",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "encargo.nivel_encargo",
        label: "Nivel",
        thClass: "td-small",
        tdClass: "text-center td-small",
        formatter: "emptyFields"
      }, {
        key: "grupo_id",
        label: "Grupo",
        thClass: "td-small",
        tdClass: "text-center td-small",
        formatter: "emptyFields",
        sortable: true
      }],
      selects: {
        simple: "",
        movimientos: [{
          value: "0",
          label: "Desactivar servidor"
        }, {
          value: "2",
          label: "Crear baja "
        }, {
          value: "4",
          label: "Crear licencia"
        }, {
          value: "3",
          label: "Crear promoción"
        }, {
          value: "5",
          label: "Realizar corrección"
        }, {
          value: "6",
          label: "Cambiar contraseña"
        }, {
          value: "7",
          label: "Eliminar del Padrón"
        }, {
          value: "9",
          label: "Justificar Declaración"
        }],
        movimientos2: [{
          value: "2",
          label: "Crear baja "
        }, {
          value: "4",
          label: "Crear licencia"
        }, {
          value: "3",
          label: "Crear promoción"
        }, {
          value: "5",
          label: "Realizar corrección"
        }, {
          value: "6",
          label: "Cambiar contraseña"
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vee_validate__["c" /* mapFields */])(["rfc", "curp", "correo_laboral", "grupo", "nombres", "primer_apellido", "segundo_apellido", "ente_publico_id", "direccion_cargo", "nivel", "area_adscripcion", "honorarios", "AG172", "Password", "Confirmar", "fecha_termino", "fecha_posesion", "motivo", "tipo_baja", "inicia", "termina", "tipo_licencia", "tipo_dec"]), {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_usuarios.length;

      return this.list_usuarios.length;
    },
    busqueda: function busqueda() {
      if (this.filter.length >= 1 && this.filter.length < 4) {
        return true;
      } else {
        return false;
      }
    }
  }),
  watch: {
    busquedarfc: {
      handler: function handler() {
        this.filter = '';
        this.$refs.busqrfc.refresh();
      },
      deep: true
    },
    filter: function filter(val) {
      var _this = this;

      this.coloremp = 'info';
      this.txtemp = 'Buscando...';
      if (val && val.length >= 4) {
        this.filtro_usuarios = [];
        this.$http.get("infpersonal/rfc/" + val).then(function (response) {
          _this.filtro_usuarios = response.data.usuarios;
          if (response.data.usuarios.length == 0) {
            _this.coloremp = 'danger';
            _this.txtemp = 'No encontrado';
          }
        }, function (error) {
          _this.Err(error);
        });
      } else {
        this.filtro_usuarios = this.list_usuarios;
      }
    },

    'form_item.titular': {
      handler: function handler() {
        var _this2 = this;

        if (this.form_item.encargo) {
          if (this.form_item.titular === '1') {
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
              title: 'Titular',
              showCancelButton: true,
              confirmButtonClass: 'btn btn-success btn-fill',
              cancelButtonClass: 'btn btn-danger btn-fill',
              confirmButtonText: 'SI',
              cancelButtonText: 'NO',
              html: '¿Deseas marcarlo como titular?',
              buttonsStyling: false
            }).then(function () {}).catch(function (e) {
              _this2.form_item.titular = '2';
            });
          } else {
            this.form_item.titular = '2';
          }
        }
      },
      deep: true
    },
    'form_item.simplificada': function form_itemSimplificada(val) {
      if (val == '1') this.form_item.grupo_id = 3;
    },
    'form_item.grupo_id': function form_itemGrupo_id(val) {
      if (val == 3) this.form_item.simplificada = '1';else this.form_item.simplificada = '0';
    }

  },

  methods: {
    getEncargo: function getEncargo(ip_id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                _this3.encargo = {
                  titular: '2'
                };
                _context.next = 3;
                return _this3.$http.get("encargo/" + ip_id).then(function (response) {
                  _this3.encargo = response.data.informacion;
                }, function (error) {
                  _this3.StepError(error);
                  console.log(error);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    showTipoDec: function showTipoDec(item) {
      this.intDialogVisible = true;
      this.modalTitle = "Lista de tipos de declaraciones";
      this.modalData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item);
      this.modalComponent = __WEBPACK_IMPORTED_MODULE_16__TipoDec_component_vue__["a" /* default */];
    },
    simplif: function simplif(val) {
      if (val == 1) return "SIMPLIFICADA";else return "COMPLETA";
    },
    titular: function titular(val) {
      if (val == 1) return "SI";else return "NO";
    },
    activo: function activo(val) {
      if (val) return "NO";else return "SI";
    },
    traeiniciales: function traeiniciales() {
      var _this4 = this;

      this.coloremp = 'info';
      this.txtemp = 'Buscando...';
      this.filtro_usuarios = [];
      this.list_declarantes2 = [];
      var desde = void 0;
      var hasta = void 0;
      if (this.iniciales == 1) {
        desde = 'A';
        hasta = 'B';
      }
      if (this.iniciales == 2) {
        desde = 'C';
        hasta = 'D';
      }
      if (this.iniciales == 3) {
        desde = 'E';
        hasta = 'F';
      }
      if (this.iniciales == 4) {
        desde = 'G';
        hasta = 'H';
      }
      if (this.iniciales == 5) {
        desde = 'I';
        hasta = 'J';
      }
      if (this.iniciales == 6) {
        desde = 'K';
        hasta = 'L';
      }
      if (this.iniciales == 7) {
        desde = 'M';
        hasta = 'O';
      }
      if (this.iniciales == 8) {
        desde = 'P';
        hasta = 'Q';
      }
      if (this.iniciales == 9) {
        desde = 'R';
        hasta = 'S';
      }
      if (this.iniciales == 10) {
        desde = 'T';
        hasta = 'U';
      }
      if (this.iniciales == 11) {
        desde = 'V';
        hasta = 'W';
      }
      if (this.iniciales == 12) {
        desde = 'X';
        hasta = 'Z';
      }


      this.$http.get("infpersonal/limite/" + this.filtro + '/' + desde + '/' + hasta).then(function (response) {
        _this4.list_usuarios = response.data.usuarios;
        _this4.filtro_usuarios = _this4.list_usuarios;
        if (response.data.usuarios.length == 0) {
          _this4.coloremp = 'danger';
          _this4.txtemp = 'Sin resultados';
        } else {
          response.data.usuarios.forEach(function (value, key) {
            _this4.list_declarantes2.push({
              'rfc': value.rfc,
              'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
              'dependencia': value.ente,
              'area': value.area,
              'cargo': value.cargo,
              'nivel': value.nivel,
              'simplificada': _this4.simplif(value.simplificada),
              'titular': _this4.titular(value.titular),
              'activo': _this4.activo(value.fecha_termino)
            });
          });
        }
      }, function (error) {
        _this4.Err(error);
      });
    },
    traetodo: function traetodo() {
      var _this5 = this;

      this.coloremp = 'info';
      this.txtemp = 'Buscando...';
      this.filtrainici = false;
      this.isLoading = true;
      this.filtro_usuarios = [];
      this.list_declarantes2 = [];
      var dec = 0;
      dec = this.getServid(this.filtro);
      if (dec <= 10000) {
        this.$http.get("infpersonal/usuarios/" + this.filtro).then(function (response) {
          _this5.list_usuarios = response.data.usuarios;
          _this5.filtro_usuarios = _this5.list_usuarios;
          _this5.isLoading = false;
          if (response.data.usuarios.length == 0) {
            _this5.coloremp = 'danger';
            _this5.txtemp = 'Sin resultados';
          } else {
            response.data.usuarios.forEach(function (value, key) {
              _this5.list_declarantes2.push({
                'rfc': value.rfc,
                'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'dependencia': value.ente,
                'area': value.area,
                'cargo': value.cargo,
                'nivel': value.nivel,
                'simplificada': _this5.simplif(value.simplificada),
                'titular': _this5.titular(value.titular),
                'activo': _this5.activo(value.fecha_termino)
              });
            });
          }
        }, function (error) {
          _this5.isLoading = false;
          _this5.Err(error);
        });
      } else {
        this.Ask2("La dependencia tiene más de 10 mil declarantes, ¿desea realizar filtrado por RFC?", function () {
          _this5.filtrainici = true;
        }, function () {
          _this5.filtro_usuarios = [];
          _this5.StepInfo("El proceso puede tardar varios minutos.");
          _this5.$http.get("infpersonal/usuarios/" + _this5.filtro).then(function (response) {
            _this5.isLoading = false;
            _this5.list_usuarios = response.data.usuarios;
            _this5.filtro_usuarios = _this5.list_usuarios;
            if (response.data.usuarios.length == 0) {
              _this5.coloremp = 'danger';
              _this5.txtemp = 'Sin resultados';
            } else {
              response.data.usuarios.forEach(function (value, key) {
                _this5.list_declarantes2.push({
                  'rfc': value.rfc,
                  'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                  'dependencia': value.ente,
                  'area': value.area,
                  'cargo': value.cargo,
                  'nivel': value.nivel,
                  'simplificada': _this5.simplif(value.simplificada),
                  'titular': _this5.titular(value.titular),
                  'activo': _this5.activo(value.fecha_termino)
                });
              });
            }
          }, function (error) {
            _this5.isLoading = false;
            _this5.Err(error);
          });
        });
      }
    },
    buscargeneral: function buscargeneral() {
      this.busquedarfc = '';
      this.$refs.busqrfc.refresh();
    },
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    initItem: function initItem() {
      this.tipo_mov = null;
      this.form_item = {
        acciones: "",
        nombres: "",
        Paterno: "",
        Materno: "",
        User: "",
        Password: "",
        motivo: "",
        titular: '2',
        encargo: {
          titular: '2'
        }
      };
    },
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.origen = {};
      this.initItem();

      this.edit_item = null;
      this.$validator.pause();
    },
    eliminaPadron: function eliminaPadron() {},
    addItem: function addItem() {
      var _this6 = this;

      if (this.tipo_mov === '7') {
        this.Ask("¿Estás seguro de eliminarlo?", function () {
          _this6.$http.delete("infpersonal/" + _this6.edit_item.id).then(function (response) {
            if (response.data.declarante) {
              _this6.StepOk("eliminado");
              _this6.edit_item = null;
              _this6.filtrorfc = "";
              _this6.search = "";
              _this6.traetodo();
              _this6.cancelEdit();
            } else {
              _this6.StepW("El declarante no puede ser eliminado, ya que ya presentó su declaración patrimonial");
            }
          }, function (error) {
            _this6.Err(error);
          });
        });
      } else {
        this.$validator.validateAll().then(function (response) {
          if (response) {
            if (_this6.form_item) {
              _this6.loadButton(_this6.$refs.btnSave);
              _this6.form_item.tipo_mov = _this6.tipo_mov;

              _this6.form_item.origen = _this6.origen;
              _this6.form_item.cambio = _this6.origenCambio();

              _this6.$http.post("servidores", _this6.form_item).then(function (response) {
                _this6.StepOk("Guardado");
                if (!_this6.edit_item) {
                  _this6.list_usuarios.unshift(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response.data.response));
                } else {

                  _this6.filtro_usuarios = _this6.list_usuarios;
                }

                _this6.initItem();
                _this6.traetodo();
                _this6.showItem();
                _this6.cancelEdit();
                _this6.edit_item = null;
              }, function (error) {
                _this6.StepError(error);
              });
            }
          } else {
            _this6.StepW("Hay campos sin completar");
          }
        });
      }
    },
    editItem: function editItem(indice, i) {
      var _this7 = this;

      this.showItem();
      this.edit_item = indice;

      if (!this.edit_item.encargo) {
        this.edit_item.encargo = {
          titular: '2'
        };
      }

      this.form_item = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.edit_item);

      this.form_item.fecha_posesion = __WEBPACK_IMPORTED_MODULE_17_moment___default()(String(this.form_item.fecha_posesion)).format('DD-MM-YYYY');

      this.getEncargo(indice.id).then(function (result) {
        _this7.form_item.encargo = _this7.encargo;
      });

      this.origen = this.origenCambio();

      this.form_item.password = "";

      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    restore: function restore(item) {
      var _this8 = this;

      this.AskMessage("¿Desea la reactivación de este usuario?", "Observaciones: ", "Reactivar", function (msg) {

        var params = {
          params: {
            id: item.id,
            observaciones: msg
          }
        };
        _this8.$http.get("cancelarbaja", params).then(function (response) {
          _this8.traetodo();
          _this8.StepOk("Usuario reactivado");
        }, function (error) {
          _this8.Err(error);
        });
      });
    },
    resetpass: function resetpass(item) {
      var _this9 = this;

      this.Ask("¿Desea restablecer la contraseña de este usuario?", function () {
        _this9.$http.post("infpersonal/resetpass", item).then(function (response) {
          _this9.StepOk("Contraseña actualizada");
        }, function (error) {
          _this9.Err(error);
        });
      });
    },
    origenCambio: function origenCambio() {
      var o = {
        rfc: this.form_item.rfc,
        curp: this.form_item.curp,
        grupo_id: this.form_item.grupo_id,
        correo_electronico_laboral: this.form_item.correo_electronico_laboral,
        nombres: this.form_item.nombres,
        primer_apellido: this.form_item.primer_apellido,
        segundo_apellido: this.form_item.segundo_apellido,
        dependencia: this.form_item.ente_publico_id,
        cargo: this.form_item.cargo,
        honorarios: this.form_item.contratado_honorarios,
        nivel: this.form_item.nivel,
        area: this.form_item.area,
        titular: this.form_item.titular,
        fecha_posesion: this.form_item.fecha_posesion,
        simplificada: this.form_item.simplificada,
        tipo_dec_id: this.form_item.tipo_dec_id
      };
      return o;
    },
    removeItem: function removeItem(indice) {
      var _this10 = this;

      if (this.list_usuarios[indice].id !== null) {
        var item = this.list_usuarios[indice];
        this.Ask("Desea borrar este registro", function () {
          _this10.$http.delete("usuarios/" + item.id).then(function (response) {
            _this10.list_usuarios.splice(indice, 1);
          }, function (error) {
            _this10.Err(error);
          });
        });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getServid: function getServid(index) {
      var a = 0;
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            a = item.declarantes_count;
          }
        });
      }
      return a;
    },
    filterdepoendencia: function filterdepoendencia(id) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == id) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    }
  },
  created: function created() {
    var _this11 = this;

    this.initItem();
    this.filtro = this.getKey("ente_publico_id");
    this.rol = this.getKey('role');

    if (this.rol == 1) {
      this.selects.movimientos.push({
        value: "11",
        label: "Transferencia"
      });
    }

    this.$http.get("cat/dec").then(function (response) {
      _this11.dependencias = response.data.entes_publicos;
      _this11.traetodo();
    }, function (error) {
      _this11.Err(error);
    });
  }
});

/***/ }),

/***/ "dZ4V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dbHI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);









__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      simplificada: '',
      ip_id: null,
      fecha: '',
      hora: '',
      enviando: false,
      texto: 'Enviando Declaración',
      close: false,
      dpersonales: {
        nombres: ''
      },
      encargo: {
        dependencia: '',
        cargo: ''
      },
      intereses: {
        empresas: [],
        tomaDecisiones: [],
        beneficiosPubl: [],
        reprActiva: [],
        clientesPrinc: [],
        beneficiosPriv: [],
        fideicomisos: []
      },
      pasivos: {
        deudas: [],
        prestamo: []
      },
      curriculares: {},
      experiencia: {},
      ingresos: null,
      activos: {
        inmuebles: [],
        bmuebles: [],
        bmueblesnr: [],
        inversiones: []
      },
      sueldos: null,
      fiscal: null,
      dependientes: []
    };
  },
  created: function created() {
    this.simplificada = this.getKey('simplificada');

    this.checkPermissions();
    this.ip_id = this.getId();
    this.fechaHora();
    this.getResumen();
  },

  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    fechaHora: function fechaHora() {

      var fecha = new Date();
      var options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      };
      var options2 = {
        hour: 'numeric',
        minute: 'numeric'
      };

      this.fecha = fecha.toLocaleDateString("es-ES", options);
      this.hora = fecha.getHours() + ':' + fecha.getMinutes() + ' hrs';
    },
    getResumen: function getResumen() {
      var _this = this;

      this.$http.get('getResumen/' + this.ip_id).then(function (response) {
        _this.dpersonales = response.data.resumen.dpersonales;
        _this.encargo = response.data.resumen.dencargo;
        _this.dependientes = response.data.resumen.dependientes;
        _this.intereses = response.data.resumen.intereses;
        _this.ingresos = response.data.resumen.ingresos;
        _this.activos = response.data.resumen.activos;
        _this.pasivos = response.data.resumen.pasivos;
        _this.fiscal = response.data.resumen.fiscal;
        _this.experiencia = response.data.resumen.experiencia;
        _this.curriculares = response.data.resumen.curriculares;

        if (!_this.activos.bmueblesnr) {
          _this.activos.bmueblesnr = [];
        }
      }, function (error) {
        _this.StepError(error);
      });
    },
    enviar: function enviar() {
      var _this2 = this;

      this.Ask("Esta apunto de enviar su declaración " + this.getKey('tipo_dec').toLowerCase() + "  " + this.getKey('periodo') + ", ¿Desea continuar?", function () {
        var cargando = _this2.$swal({
          showConfirmButton: false,
          type: "info",
          title: _this2.texto,
          text: 'No cierre la ventana, se le redireccionará automáticamente',
          showCloseButton: _this2.close
        });

        _this2.enviando = true;

        _this2.$http.get('savedeclaracion/' + _this2.ip_id).then(function (response) {
          if (response.data.data == 'Correcto') {
            _this2.setSession(response.data);
            _this2.$router.push('enviada');
            _this2.$router.go();
          } else _this2.Err(response.data);
        });
      });
    }
  }
});

/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("7kBt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("Ktg0");
function injectStyle (ssrContext) {
  __webpack_require__("JXfo")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dqBf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuSuperior_vue__ = __webpack_require__("cUnQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__MenuSuperior_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "draM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "drw5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container h-100 p-5 position-absolute login-container"},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-md-10 col-sm-10 offset-md-1 offset-sm-1 overflow-hidden rounded bg-white shadows d-flex p-0"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mt-5 mb-5 mr-auto ml-auto "},[_c('form',{attrs:{"method":"#","action":"#"}},[(_vm.recupera_vista)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"d-flex campo"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"field mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rfc_recupera),expression:"rfc_recupera"}],staticClass:"rfc",attrs:{"type":"text","name":"rfc_recupera","id":"rfc_recupera","placeholder":"RFC"},domProps:{"value":(_vm.rfc_recupera)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rfc_recupera=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mr-auto",attrs:{"for":"email"}},[_vm._v("RFC")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex campo mb-4"}),_vm._v(" "),_c('div',{staticClass:"text-center mb-3"},[_c('button',{staticClass:"btn btn-login",attrs:{"type":"button"},on:{"click":function($event){return _vm.recupera_pass()}}},[_vm._v("Recuperar")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.recupera_pass_cancel_vista}},[_vm._v("Regresar a login")])])]):_c('div',[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"d-flex campo"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"field mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.correo),expression:"correo"}],staticClass:"rfc",attrs:{"type":"email","name":"email","id":"email","placeholder":"RFC"},domProps:{"value":(_vm.correo)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login()},"input":function($event){if($event.target.composing){ return; }_vm.correo=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mr-auto",attrs:{"for":"email"}},[_vm._v("RFC")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex campo mb-4"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"field mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass),expression:"pass"}],attrs:{"type":"password","name":"password","id":"password","placeholder":"CONTRASEÑA"},domProps:{"value":(_vm.pass)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login()},"input":function($event){if($event.target.composing){ return; }_vm.pass=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mr-auto",attrs:{"for":"password"}},[_vm._v("Contraseña")])])]),_vm._v(" "),_c('div',{staticClass:"text-center mb-3"},[_c('button',{staticClass:"btn btn-login",attrs:{"type":"button"},on:{"click":function($event){return _vm.login()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login()}}},[_vm._v("Iniciar\n                  sesión")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.recupera_pass_vista}},[_vm._v("¿ Olvidaste tu contraseña ?")])])])])])]),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"alert alert-danger  col-8 offset-2"},[_c('h3',{staticClass:"text-center"},[_vm._v("Error cargando sesión")])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"m-4 text-justify",staticStyle:{"padding-top":"200px"}},[_vm._v("Bienvenido al sistema de declaración de situación\n              patrimonial y de intereses para servidores públicos del Poder Ejecutivo del Estado de Guanajuato.")])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"login-img",staticStyle:{"background-image":"url(static/img/background/bg_login_1.png)"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{staticClass:"d-logo mb-3",attrs:{"src":"static/img/background/declaranet_logo.png","alt":"declaraNet"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon mt-auto mr-2 mb-2"},[_c('i',{staticClass:"fas fa-user align-text-bottom"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{staticClass:"d-logo mb-3",attrs:{"src":"static/img/background/declaranet_logo.png","alt":"declaraNet"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon mt-auto mr-2 mb-2"},[_c('i',{staticClass:"fas fa-user align-text-bottom"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon mt-auto mr-2 mb-2"},[_c('i',{staticClass:"fas fa-unlock-alt"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("+QDo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a6b2acc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("yu8p");
function injectStyle (ssrContext) {
  __webpack_require__("Kfnl")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a6b2acc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eNX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    var _ref;

    return _ref = {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,
      monedas: [],
      plazos: [],
      actividades: [],
      sectores: null,
      n_domicilio: null
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "monedas", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "entidadFed", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "municipios", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidades", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidad", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "paises", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isnum", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "item_intereses", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "list_intereses", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fields_list", [{
      key: "acciones",
      label: "Acciones",
      tdClass: "text-center"
    }, {
      key: "nombre_denominacion_razon_social",
      label: "Denominación o razón social",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "rfc",
      label: "RFC",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "curp",
      label: "CURP",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "sector_industria_id",
      label: "Sector",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "tipo_actividad_servicio_id",
      label: "Tipo de actividad ",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "descripcion_actividad_servicio",
      label: "Descripción de la actividad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "ingreso_bruto_anual",
      label: "Ingreso bruto anual ",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "moneda_id",
      label: "Moneda",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "duracion_frecuencia",
      label: "Duración / Frecuencia",
      tdClass: "text-center",
      formatter: 'emptyFields'
    }, {
      key: "unidad_temporal_id",
      label: "Unidad temporal",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "fecha_transaccion",
      label: "Fecha de transacción",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "observaciones",
      label: "Observaciones",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "pais_id",
      label: "País",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "entidad_federativa_id",
      label: "Entidad federativa",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "municipio_id",
      label: "Municipio",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "localidad_id",
      label: "Localidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "colonia",
      label: "Colonia",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_tipo_vial",
      label: "Tipo vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_nom_vial",
      label: "Nombre vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "cp",
      label: "CP",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numExt",
      label: "Número exterior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numInt",
      label: "Número interior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }]), _ref;
  },

  computed: {
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.item_intereses.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.item_intereses.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {
    list_intereses: {
      handler: function handler() {
        if (this.list_intereses) {
          this.setLocalidades();
          if (this.list_intereses.length == 0) {
            this.bandera = '0';
          } else {
            this.bandera = '1';
          }
        }
      },
      deep: true
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_intereses.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_intereses.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_intereses.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_intereses.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_intereses.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_intereses.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_intereses.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_intereses.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_intereses.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_intereses.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    }
  },
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMoneda: function getMoneda(index) {
      var resp = "";
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getActividad: function getActividad(index) {
      var resp = " ";
      if (this.sectores) {
        this.actividades.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUnidades: function getUnidades(index) {
      var resp = " ";
      if (this.plazos) {
        this.plazos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: '',
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
      this.item_intereses = {
        acciones: "",
        rfc_quien_adquirio: "",
        ingreso_bruto_anual: "",
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: "",
        entidad_federativa_id: "",
        municipio_id: "",
        localidad_id: "",
        colonia: "",
        cp: "",
        numExt: "",
        numInt: "",
        vialidad_nom_vial: "",
        vialidad_tipo_vial: "",
        observaciones: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      if (this.item_intereses) {
        this.item_intereses.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post("intereses", this.item_intereses).then(function (response) {
          _this.StepOk("Guardado");
          if (_this.edit_item === undefined || _this.edit_item === null) {
            _this.list_intereses.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.actividad));
          } else {
            _this.list_intereses.splice(_this.edit_item.index, 1, _this.item_intereses);
            _this.edit_item.item._rowVariant = "";
          }
          _this.showItem();
          _this.initItem();
          _this.edit_item = null;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW("Hay campos sin completar");
      }
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_intereses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_intereses[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_intereses[indice].id !== null) {
        var item = this.list_intereses[indice];

        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("intereses/" + item.id).then(function (response) {
            _this2.list_intereses.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_intereses.pais_id ? this.item_intereses.pais_id : 150;
      this.n_domicilio.entidadF = this.item_intereses.entidad_federativa_id ? this.item_intereses.entidad_federativa_id : '';
      this.n_domicilio.municipio = this.item_intereses.municipio_id ? this.item_intereses.municipio_id : '';
      this.n_domicilio.localidad = this.item_intereses.localidad_id ? this.item_intereses.localidad_id : '';
      this.n_domicilio.cp = this.item_intereses.cp ? this.item_intereses.cp : '';
      this.n_domicilio.colonia = this.item_intereses.colonia ? this.item_intereses.colonia : '';
      this.n_domicilio.vialidad = this.item_intereses.vialidad_tipo_vial ? this.item_intereses.vialidad_tipo_vial : '';
      this.n_domicilio.vialidad_nombre = this.item_intereses.vialidad_nom_vial ? this.item_intereses.vialidad_nom_vial : '';
      this.n_domicilio.ext = this.item_intereses.numExt ? this.item_intereses.numExt : '';
      this.n_domicilio.int = this.item_intereses.numInt ? this.item_intereses.numInt : '';
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      this.list_intereses.forEach(function (item) {
        if (item.localidad_id) {
          _this3.$http.get('localidades/localidad/' + item.localidad_id).then(function (response) {
            _this3.localidades.push(response.data.localidad);
          }, function (error) {
            _this3.Err(error);
          });
        }
      });
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("intereses/" + this.ip_id).then(function (response) {
      _this4.list_intereses = response.data.actividades;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_unidad_medida_plazo").then(function (response) {
      _this4.plazos = response.data.unidades;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_actividad").then(function (response) {
      _this4.actividades = response.data.actividad;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("monedas").then(function (response) {
      _this4.monedas = response.data.monedas;
      var temp = "97";
      _this4.monedas.forEach(function (item) {
        if (item.codigo == "MXN") {
          temp = item.id;
        }
      });
      _this4.item_intereses.moneda_id = temp;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "eQG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "eu9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',[_c('div',{staticClass:"row"},[(this.rol==1)?_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('label',[_vm._v("Filtra por dependencia:")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","disabled":_vm.isLoading},on:{"change":_vm.getmovimientos},model:{value:(_vm.filtro),callback:function ($$v) {_vm.filtro=$$v},expression:"filtro"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 pull-right"},[_c('label',[_vm._v("Buscar:")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1),_vm._v(" "),_c('div',{staticClass:"col-6  d-flex align-items-end justify-content-end"},[(_vm.lista_movimientos2.length > 0)?_c('export-excel',{staticClass:"btn btn-wd btn-success pull-right",attrs:{"data":_vm.lista_movimientos2,"meta":_vm.meta,"fields":_vm.lista_campos,"worksheet":"Movimientos","name":"Movimientos.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                Descargar\n              ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-app',[_c('v-data-table',{attrs:{"headers":_vm.headers,"search":_vm.filter,"custom-filter":_vm.customFilter,"items":_vm.lista_movimientos,"single-select":"","item-key":"id","show-expand":"","expanded":_vm.expanded},on:{"update:expanded":function($event){_vm.expanded=$event},"click:row":_vm.rowClick},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})])],1)]}},{key:"item.tipo_mov",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"alert  mb-0 p-1 alert-info"},[_c('b',[_vm._v(" "+_vm._s(_vm.setMovimiento(item.tipo_mov)))])])]}},{key:"item.rfc",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.servidor.rfc)+" ")])]}},{key:"item.nombres",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.servidor.nombres + ' '+ item.servidor.primer_apellido +' '+item.servidor.segundo_apellido)+" ")])]}},{key:"item.area",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.encargo.area_adscripcion))])]}},{key:"item.inicia",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm._f("dateFormat")(item.inicia)))])]}},{key:"item.termina",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm._f("dateFormat")(item.termina)))])]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('v-card',{key:item.id,staticClass:"p-1 m-0",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"p-1"},[_c('h3',{staticClass:"text-h5 mb-2 mt-2"},[_vm._v("\n                            "+_vm._s(item.servidor.nombres + ' '+ item.servidor.primer_apellido +' '+item.servidor.segundo_apellido)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"blue--text mb-2"},[_vm._v("\n                            "+_vm._s(item.servidor.rfc)+"\n                          ")])]),_vm._v(" "),_c('v-divider',{staticClass:"m-0 p-0 mb-2"}),_vm._v(" "),_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[_c('v-col',{staticClass:" m-0 p-1",attrs:{"tag":"strong","cols":"12"}},[_vm._v(" Movimiento: ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 pb-3 font-weight-bold border-bottom",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.setMovimiento(item.tipo_mov))+" "+_vm._s((item.tipo_mov == 2)?'/ '+ item.tipo_baja:''))])],1),_vm._v(" "),(item.origen)?_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[(item.origen)?_c('v-col',{staticClass:" m-0 p-1",attrs:{"tag":"strong","cols":"12"}},[_vm._v(" Movimiento Origen / Cambio: ")]):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 pb-3 border-bottom",attrs:{"cols":"6"}},[_c('v-row',{staticClass:"p-3"},[_c('v-col',{staticClass:"m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("RFC :")]),_vm._v(" "+_vm._s(item.origen.rfc? item.origen.rfc:'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("CURP :")]),_vm._v(" "+_vm._s(item.origen.curp? item.origen.curp:'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Correo electrónico laboral :")]),_vm._v(" "+_vm._s(item.origen.correo_electronico_laboral? item.origen.correo_electronico_laboral:'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Nombre :")]),_vm._v(" "+_vm._s(item.origen.nombres + ' '+ item.origen.primer_apellido +' '+item.origen.segundo_apellido)+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Dependencia :")]),_vm._v(" "+_vm._s(item.origen.dependencia?_vm.getDependencias(item.origen.dependencia):'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Cargo :")]),_vm._v(" "+_vm._s(item.origen.cargo?item.origen.cargo:'')+"\n                              ")]),_vm._v(" "),(item.origen.honorarios)?_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Honorarios :")]),_vm._v(" "+_vm._s(item.origen.honorarios == 2? 'No': 'Si')+"\n                              ")]):_vm._e(),_vm._v(" "),(item.origen.contratado_honorarios)?_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Honorarios :")]),_vm._v(" "+_vm._s(item.origen.contratado_honorarios == 2? 'No': 'Si')+"\n                              ")]):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Nivel :")]),_vm._v(" "+_vm._s(item.origen.nivel ? item.origen.nivel: '')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Área :")]),_vm._v(" "+_vm._s(item.origen.area ? item.origen.area: '')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Titular :")]),_vm._v(" "+_vm._s(item.origen.titular ? (item.origen.titular == 2? 'No': 'Si'):'No')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Fecha posesion :")]),_vm._v(" "+_vm._s(item.origen.fecha_posesion ? item.origen.fecha_posesion :'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Fecha termino :")]),_vm._v(" "+_vm._s(item.origen.fecha_termino ? item.origen.fecha_termino :'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Simplificada :")]),_vm._v(" "+_vm._s(item.origen.simplificada == '0' || item.origen.simplificada == 0 ? 'No':'Si')+"\n                              ")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 pb-3 border-bottom border-left",attrs:{"cols":"6"}},[_c('v-row',{staticClass:"p-3"},[_c('v-col',{staticClass:"m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("RFC :")]),_vm._v(" "+_vm._s(item.cambio.rfc? item.cambio.rfc:'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("CURP :")]),_vm._v(" "+_vm._s(item.cambio.curp? item.cambio.curp:'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Correo electrónico laboral :")]),_vm._v(" "+_vm._s(item.cambio.correo_electronico_laboral? item.cambio.correo_electronico_laboral:'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Nombre :")]),_vm._v(" "+_vm._s(item.cambio.nombres + ' '+ item.cambio.primer_apellido +' '+item.cambio.segundo_apellido)+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Dependencia :")]),_vm._v(" "+_vm._s(item.cambio.dependencia?_vm.getDependencias(item.cambio.dependencia):'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Cargo :")]),_vm._v(" "+_vm._s(item.cambio.cargo?item.cambio.cargo:'')+"\n                              ")]),_vm._v(" "),(item.cambio.honorarios)?_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Honorarios :")]),_vm._v(" "+_vm._s(item.cambio.honorarios == 2? 'No': 'Si')+"\n                              ")]):_vm._e(),_vm._v(" "),(item.cambio.contratado_honorarios)?_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Honorarios :")]),_vm._v(" "+_vm._s(item.cambio.contratado_honorarios == 2? 'No': 'Si')+"\n                              ")]):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Nivel :")]),_vm._v(" "+_vm._s(item.cambio.nivel ? item.cambio.nivel: '')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Área :")]),_vm._v(" "+_vm._s(item.cambio.area ? item.cambio.area: '')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Titular :")]),_vm._v(" "+_vm._s(item.cambio.titular ? (item.cambio.titular == 2? 'No': 'Si'):'No')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Fecha posesion :")]),_vm._v(" "+_vm._s(item.cambio.fecha_posesion ? item.cambio.fecha_posesion :'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Fecha termino :")]),_vm._v(" "+_vm._s(item.cambio.fecha_termino ? item.cambio.fecha_termino :'')+"\n                              ")]),_vm._v(" "),_c('v-col',{staticClass:" m-0 p-0",attrs:{"cols":"12"}},[_c('strong',{staticClass:"pl-4 pr-1"},[_vm._v("Simplificada :")]),_vm._v(" "+_vm._s(item.cambio.simplificada == '0' || item.cambio.simplificada == 0 ? 'No':'Si')+"\n                              ")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[_c('v-col',{staticClass:" m-0 p-1",attrs:{"tag":"strong","cols":"12"}},[_vm._v(" Observaciones: ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 pb-3 border-bottom",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.motivo? item.motivo :'Sin observaciones.'))])],1),_vm._v(" "),(item.usuario)?_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[_c('v-col',{staticClass:" m-0 p-1 ",attrs:{"tag":"strong","cols":"12"}},[_vm._v(" Datos del creador del movimiento: ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 ",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.usuario.Nombre + ' '+ item.usuario.Paterno +' '+item.usuario.Materno))]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 ",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.usuario.User)+" ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 pb-3",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.getDependencias(item.usuario.ID_Dependencia))+" ")])],1):_vm._e(),_vm._v(" "),(item.aprobacion)?_c('v-row',{staticClass:"text-left m-0 pt-2 pb-2"},[_c('v-col',{staticClass:" m-0 p-1 ",attrs:{"tag":"strong","cols":"12"}},[_vm._v(" Datos de aprobación: ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 ",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.aprobacion.Nombre + ' '+ item.aprobacion.Paterno +' '+item.aprobacion.Materno))]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 ",attrs:{"cols":"12"}},[_vm._v(_vm._s(item.aprobacion.User)+" ")]),_vm._v(" "),_c('v-col',{staticClass:"m-0 p-1 pb-3",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.getDependencias(item.aprobacion.ID_Dependencia))+" ")])],1):_vm._e()],1)],1)]}}])})],1)],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Listado de Movimientos\n\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ewvW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("Dhe7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Domicilio_vue__ = __webpack_require__("Ta4m");




















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a),
  props: ["data"],
  data: function data() {
    return {
      movimiento: {},
      options: [{
        id: 1,
        label: "foo"
      }, {
        id: 3,
        label: "bar"
      }, {
        id: 2,
        label: "baz"
      }],
      currentPage: 1,
      perPage: 50,
      validarp: false,
      rows: 0,
      rol: "",
      filter: null,
      id: 1,
      add_item: false,
      edit_item: null,
      tipos: null,
      n_domicilio: null,
      dependencias: null,
      usuarios: null,
      item_usuarios: {},
      list_usuarios: [],
      item_usuariosValidations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
        rfc: {
          required: true
        },
        curp: {
          required: true
        },
        nombres: {
          required: true
        },
        primer_apellido: {
          required: true
        },
        segundo_apellido: {
          required: true
        },
        ente_publico_id: {
          required: true
        },
        direccion_cargo: {
          required: true
        },
        nivel: {
          required: true
        },
        area_adscripcion: {
          required: true
        },
        honorarios: {
          required: true
        },
        AG172: {
          required: true
        },
        fecha_inicio: {
          required: true
        },
        tipo_baja: {
          required: true
        },
        termina: {
          required: true
        },
        inicia: {
          required: true
        },
        tipo_lic: {
          required: true
        },
        observaciones: {
          required: true
        },
        empleo_cargo_comision: {
          required: true
        }
      }, "observaciones", {
        required: true
      }),
      expanded: [],
      singleExpand: true,
      headers: [{
        text: 'Expandir',
        value: 'data-table-expand'
      }, {
        text: "Fecha",
        value: "created_at",
        align: "center"
      }, {
        text: "RFC",
        value: "rfc",
        align: "center"
      }, {
        text: "Nombre",
        value: "nombres",
        align: "center"
      }],
      fields_list: [{
        key: "acciones",
        label: "Acciones",
        thClass: "td-small",
        tdClass: "text-center td-small"
      }, {
        key: "created_at",
        label: "Fecha",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: function formatter(value) {
          if (value) return __WEBPACK_IMPORTED_MODULE_11_moment___default()(String(value)).format("DD/MM/YYYY");else return "";
        }
      }, {
        key: "usuarios.rfc",
        label: "RFC",
        thClass: "td-medium",
        tdClass: "text-center td-medium",
        formatter: "emptyFields"
      }, {
        key: "usuarios.nombres usuarios.primer_apellido usuarios.segundo_apellido",
        label: "Nombre",
        tdClass: "text-left",
        formatter: "emptyFields"
      }],
      selects: {
        simple: "",
        movimientos: [{
          value: "1",
          label: "Desactivar servidor"
        }, {
          value: "2",
          label: "Crear baja "
        }, {
          value: "3",
          label: "Crear licencia"
        }, {
          value: "4",
          label: "Crear promoción"
        }, {
          value: "5",
          label: "Realizar corrección"
        }, {
          value: "6",
          label: "Cambiar contraseña"
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["c" /* mapFields */])(["rfc", "curp", "nombres", "primer_apellido", "segundo_apellido", "ente_publico_id", "direccion_cargo", "nivel", "area_adscripcion", "honorarios", "AG172", "Password", "Confirmar", "fecha_inicio", "tipo_baja", "termina", "inicia", "tipo_lic", "observaciones", "fecha_posesion", "empleo_cargo_comision"]), {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_usuarios.length;

      return this.list_usuarios.length;
    },

    fullName: {
      get: function get() {
        return this.item_usuarios.nombres + " " + this.item_usuarios.primer_apellido + " " + this.item_usuarios.segundo_apellido;
      },
      set: function set(newValue) {
        var m = newValue.match(/(\S*)\s+(.*)/);

        this.nombres = m[1];
        this.primer_apellido = m[2];
        this.segundo_apellido = m[3];
      }
    }
  }),
  methods: {
    formato: function formato(fecha) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(fecha, 'DD/MM/YYYY').format('DD/MM/YYYY');
    },
    returnValueKey: function returnValueKey(v, k) {
      var resp = "";
      if (k == "dependencia") {
        resp = this.getDependencias(v);
      } else if (k == "honorarios") {
        console.log(typeof v === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(v));
        resp = v == 1 ? "HONORARIOS" : "BASE";
      } else if (k == "fecha_posesion") {
        resp = this.formato(v);
      } else if (k == "titular") {
        resp = v == 0 ? "NO" : "SI";
      } else if (k == "simplificada") {
        resp = v == '0' ? "NO" : "SI";
      } else {
        resp = v;
      }
      return resp;
    },
    initItem: function initItem() {
      this.item_usuarios = {
        acciones: "",
        nombres: "",
        Paterno: "",
        Materno: "",
        User: "",
        Password: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    validar: function validar(item) {
      var _this = this;

      this.movimiento.id = item.id;
      this.$http.post("aplicaCambio", this.movimiento).then(function (response) {
        if (response.data.error) _this.StepW("El servidor público tiene una declaración pendiente, no se puede realizar el cambio");else _this.StepOk("Cambio Realizado");


        _this.$http.get("servidores/correcciones").then(function (response) {
          _this.list_usuarios = response.data.usuarios;

          _this.movimiento.id = null;
          _this.movimiento.observaciones = "";
        }, function (error) {
          _this.Err(error);
        });
      }, function (error) {
        _this.StepError(error);
      });
    },
    rechazar: function rechazar(item) {
      var _this2 = this;

      this.movimiento.id = item.id;

      this.$http.post("rechazar", this.movimiento).then(function (response) {
        _this2.StepOk("Cambio Rechazado");


        _this2.$http.get("servidores/correcciones").then(function (response) {
          _this2.list_usuarios = response.data.usuarios;

          _this2.movimiento.id = null;
          _this2.movimiento.observaciones = "";
        }, function (error) {
          _this2.Err(error);
        });
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUsuario: function getUsuario(index) {
      var resp = " ";
      if (this.usuarios) {
        this.usuarios.forEach(function (item) {
          if (item.id == index) {
            resp = item.Nombre + " " + item.Paterno + " " + item.Materno;
            return resp;
          }
        });
      }
      return resp;
    }
  },
  created: function created() {
    var _this3 = this;

    this.initItem();
    if (this.getKey("permisos").includes(19)) {
      this.validarp = true;
    }
    this.$http.get("servidores/correcciones").then(function (response) {
      _this3.list_usuarios = response.data.usuarios;
    }, function (error) {
      _this3.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this3.dependencias = response.data.entes_publicos;
    }, function (error) {
      _this3.Err(error);
    });
    this.$http.get("usuarios").then(function (response) {
      _this3.usuarios = response.data.usuarios;
    }, function (error) {
      _this3.Err(error);
    });
  }
});

/***/ }),

/***/ "f+wu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_DatosConyuge_vue__ = __webpack_require__("7/DJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d4d1a4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_DatosConyuge_vue__ = __webpack_require__("IjRN");
function injectStyle (ssrContext) {
  __webpack_require__("TX6m")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_DatosConyuge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d4d1a4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_DatosConyuge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f3MI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_PlantillaBajas_vue__ = __webpack_require__("7apm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2611352b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_PlantillaBajas_vue__ = __webpack_require__("M9zv");
function injectStyle (ssrContext) {
  __webpack_require__("zv8+")
  __webpack_require__("dZ4V")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_PlantillaBajas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2611352b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_PlantillaBajas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f7oI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 pt-0"},[_c('div',{staticClass:"card col-12 m-0"},[_c('div',{staticClass:"card-content form-group d-flex justify-content-between m-0 p-0"},[_c('h4',{staticClass:"card-title mb-2 mt-2"},[_vm._v("Mostrar tableros: "),_c('strong',[_vm._v(_vm._s((_vm.globales)? 'Locales':'Globales'))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success",on:{"click":_vm.switchGlobales}},[_vm._v("\n            Cambiar\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-sm-4 text-center"},[_c('stats-card2',[_c('div',{staticClass:"icon-big text-center icon-info",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-users"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Obligados")]),_vm._v("\n          "+_vm._s(_vm.obligados)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"inicial"},slot:"inicial"},[_c('p',[_vm._v(_vm._s(_vm.obligadosIn))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"anual"},slot:"anual"},[_c('p',[_vm._v(_vm._s(_vm.obligadosAn))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"final"},slot:"final"},[_c('p',[_vm._v(_vm._s(_vm.obligadosFi))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-4 text-center"},[_c('stats-card2',[_c('div',{staticClass:"icon-big text-center icon-success",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-file"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Declaraciones")]),_vm._v("\n          "+_vm._s(_vm.declaraciones)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"inicial"},slot:"inicial"},[_c('p',[_vm._v(_vm._s(this.rinicial))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"anual"},slot:"anual"},[_c('p',[_vm._v(_vm._s(this.ranual))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"final"},slot:"final"},[_c('p',[_vm._v(_vm._s(this.rfinal))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-4 text-center"},[_c('stats-card2',[_c('div',{staticClass:"icon-big text-center icon-danger",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-users"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Faltantes")]),_vm._v("\n          "+_vm._s(_vm.faltantes)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"inicial"},slot:"inicial"},[_c('p',[_vm._v(_vm._s(_vm.faltantesIn))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"anual"},slot:"anual"},[_c('p',[_vm._v(_vm._s(_vm.faltantesAn))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"final"},slot:"final"},[_c('p',[_vm._v(_vm._s(_vm.faltantesFi))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4",on:{"click":_vm.cumplimiento}},[_c('circle-chart-card',{attrs:{"percentage":_vm.porcentaje,"title":"Avance Global","avance":_vm.declaraciones,"total":_vm.obligados,"description":""},on:{"click":_vm.cumplimiento}})],1)]),_vm._v(" "),(this.getKey('permisos').includes(19))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-sm-4 "},[_c('a',{attrs:{"href":'#/alertas/bitacora'}},[_c('stats-card',[_c('div',{staticClass:"icon-big text-left icon-info",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-book"})]),_vm._v(" "),_c('div',{staticClass:"numbers titulos",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Bitácora")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Declaraciones Consultadas")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-4 text-center"},[_c('a',{attrs:{"href":'#/admin/movimientos'}},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center icon-warning",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-check-double"})]),_vm._v(" "),_c('div',{staticClass:"numbers titulos",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Vo.Bo. Correcciones")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Aprobar Correcciones")])])])],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card card-circle-chart"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Declaraciones por día")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Se muestra la última semana")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartStock"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fJjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  props: ["data"],
  data: function data() {
    return {
      filter: null,
      list_servidores: [],
      headers: [{
        text: 'Nombre completo',
        value: 'nombres',
        align: 'left'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'encargo.ente.valor',
        align: 'left'
      }, {
        text: 'Fecha de baja',
        value: 'fecha',
        align: 'center'
      }]
    };
  },

  methods: {
    buscaServ: function buscaServ(value, search, item) {},
    getNombre: function getNombre(item) {
      var resp = (item.nombres || '') + " " + (item.primer_apellido || '') + " " + (item.segundo_apellido || '');

      return resp;
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get("getBajasDefuncion").then(function (response) {

      _this.list_servidores = response.data.usuarios;
      console.log(_this.list_servidores);
    }, function (error) {
      _this.Err(error);
    });

    this.$http.get("cat_ente_publico").then(function (response) {
      _this.dependencias = response.data.entes_publicos;
    }, function (error) {
      _this.Err(error);
    });
  }
});

/***/ }),

/***/ "fLAN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag__);









var _components;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input_number___default.a), _components),
  props: ['data'],
  data: function data() {
    return {
      numero: 0,
      ip_id: null,
      add_item: false,
      edit_item: null,
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,

      plazos: [],
      isnum: null,

      item_entes: {
        sub_1: 0,
        sub_11: 0,
        razon_social_cantidad: 0,
        actividad_financiera_cantidad: 0,
        servicios_profecionales_cantidad: 0,
        arrendamiento_cantidad: 0,
        neto_conyugue_cantidad: 0,
        acciones: '',
        ente_publico_id: '',
        rfc_quien_adquirio: '',
        ingreso_bruto_anual: '',
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        observaciones: '',
        bandera: '0'
      },
      fields_list: [{
        key: 'acciones',
        label: 'Acciones',
        tdClass: 'text-center'
      }, {
        key: 'ente_publico_id',
        label: 'Ente Públic',
        tdClass: 'text-left',
        formatter: 'emptyFields'
      }, {
        key: 'rfc',
        label: 'RFC',
        tdClass: 'text-left',
        formatter: 'emptyFields'
      }, {
        key: 'ingreso_bruto_anual',
        label: 'Ingreso bruto anual ',
        tdClass: 'text-right',
        formatter: 'emptyFields'
      }, {
        key: 'moneda_id',
        label: 'Moneda',
        tdClass: 'text-left',
        formatter: 'emptyFields'
      }, {
        key: 'duracion_frecuencia',
        label: 'Duración / Frecuencia',
        tdClass: 'text-right',
        formatter: 'emptyFields'
      }, {
        key: 'unidad_temporal_id',
        label: 'Unidad temporal',
        tdClass: 'text-left',
        formatter: 'emptyFields'
      }, {
        key: 'fecha_transaccion',
        label: 'Fecha de transacción',
        tdClass: 'text-left',
        formatter: 'emptyFields'
      }, {
        key: 'observaciones',
        label: 'Observaciones',
        tdClass: 'text-left',
        formatter: 'emptyFields'
      }]
    };
  },

  computed: {
    getSigno: function getSigno() {
      var signo = '$';
      var val = this.item_entes.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    calcula_totales1: function calcula_totales1() {

      var sub1 = 0;
      var sub2 = 0;
      var unoydos = 0;
      var segundasuma2 = 0;

      var a = parseInt(this.item_entes.razon_social_cantidad);

      var b = parseInt(this.item_entes.actividad_financiera_cantidad);
      var c = parseInt(this.item_entes.servicios_profecionales_cantidad);
      var d = parseInt(this.item_entes.arrendamiento_cantidad);
      var e = parseInt(this.item_entes.arrendamiento_cantidad);

      sub1 = e;
      sub2 = a + b + c + d;
      unoydos = parseInt(sub1) + parseInt(sub2);


      if (isNaN(sub2)) {
        return 0;
      }

      return sub2;
    },
    calcula_totales2: function calcula_totales2() {

      var sub1 = 0;
      var sub2 = 0;
      var unoydos = 0;
      var segundasuma2 = 0;

      sub1 = parseInt(this.item_entes.sub_1);
      sub2 = parseInt(this.item_entes.razon_social_cantidad) + parseInt(this.item_entes.actividad_financiera_cantidad) + parseInt(this.item_entes.servicios_profecionales_cantidad) + parseInt(this.item_entes.arrendamiento_cantidad);
      unoydos = parseInt(sub1) + parseInt(sub2);

      if (sub2 > 1) {} else {
        sub2 = "Corrija las cantidades";
      }
      if (unoydos > 1) {} else {
        unoydos = "Corrija las cantidades";
      }

      if (isNaN(unoydos)) {
        return 0;
      }

      return unoydos;
    },
    calcula_totales3: function calcula_totales3() {
      var segundasuma2 = 0;
      segundasuma2 = parseInt(this.calcula_totales2) + parseInt(this.item_entes.neto_conyugue_cantidad);

      if (isNaN(segundasuma2)) {
        return 0;
      }
      return segundasuma2;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = 'MXN';
      var val = this.item_entes.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {},
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '97';

      var signo = '$';
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getEnte: function getEnte(index) {
      var resp = ' ';
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMoneda: function getMoneda(index) {
      var resp = '';
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
          }
        });
      }
      return resp;
    },
    getUnidades: function getUnidades(index) {
      var resp = ' ';
      if (this.plazos) {
        this.plazos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    addItem: function addItem() {
      var _this = this;

      console.log(1111);
      if (this.item_entes) {
        this.item_entes.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post('sueldos_publicos', this.item_entes).then(function (response) {
          _this.StepOk('Guardado');

          _this.item_entes = response.data.sueldos;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW('Hay campos sin completar');
      }
    },
    valida: function valida() {
      return this.$validator.validateAll();
    }
  },
  created: function created() {
    var _this2 = this;

    this.ip_id = this.getId();

    this.$http.get('sueldos_publicos/' + this.ip_id).then(function (response) {
      if (response.data.sueldos != null) {
        _this2.item_entes = response.data.sueldos;
      }
    }, function (error) {
      _this2.Err(error);
    });
    this.$http.get('cat_ente_publico').then(function (response) {
      _this2.entes = response.data.entes_publicos;
    }, function (error) {
      _this2.Err(error);
    });
    this.$http.get('cat_unidad_medida_plazo').then(function (response) {
      _this2.plazos = response.data.unidades;
    }, function (error) {
      _this2.Err(error);
    });
  }
});

/***/ }),

/***/ "feTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Membresias_vue__ = __webpack_require__("SYUd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_93d8c35a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Membresias_vue__ = __webpack_require__("OU5+");
function injectStyle (ssrContext) {
  __webpack_require__("jwfX")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Membresias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_93d8c35a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Membresias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "feV+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fic4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Enviada_vue__ = __webpack_require__("0gvV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d61554f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Enviada_vue__ = __webpack_require__("6b8M");
function injectStyle (ssrContext) {
  __webpack_require__("gPdJ")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Enviada_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d61554f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Enviada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fuBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Movimientos_vue__ = __webpack_require__("IQfv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4ae23fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Movimientos_vue__ = __webpack_require__("OeuY");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Movimientos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4ae23fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Movimientos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fylz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Intereses_vue__ = __webpack_require__("PTcn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e71708a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Intereses_vue__ = __webpack_require__("oOWQ");
function injectStyle (ssrContext) {
  __webpack_require__("UoZB")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Intereses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e71708a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Intereses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g4Qj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"info"},[_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.toggleMenu}},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClosed),expression:"!isClosed"}],staticClass:"nav"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("Mp")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("My Profile")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("Ep")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("Edit Profile")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("S")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("Settings")])])])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n        Chet Faker\n        "),_c('b',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gBSR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gJ8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("LFO0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  data: function data() {
    return {
      isClosed: true
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isClosed = !this.isClosed;
    }
  }
});

/***/ }),

/***/ "gKFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_transfer_css__ = __webpack_require__("QiIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_transfer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_transfer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_transfer__ = __webpack_require__("xu7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_transfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_transfer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__("kDzH");















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_transfer___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  props: ["data"],
  data: function data() {
    return {
      perPage: 10,
      rows: null,
      currentPage: 1,
      filter: null,
      ip_id: 1,
      add_item: false,
      edit_item: null,
      permiso: [],
      item_permisos: {},
      list_permisos: [],
      list_cat_permisos: [],
      item_permisosValidations: {
        Rol: {
          required: true
        }
      },

      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: '',
        width: 150
      }, {
        text: 'Rol',
        value: 'Rol',
        align: 'center'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vee_validate__["c" /* mapFields */])(["Rol"]), {
    pagedData: function pagedData() {
      return this.list_permisos.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_permisos.length;
        return this.pagedData;
      }
      var result = this.list_permisos.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_permisos.length;
      return this.list_permisos.length;
    }
  }),
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      var permiso = [9];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    initItem: function initItem() {
      this.item_permisos = {
        acciones: "",
        Rol: "",
        Permisos: []
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
      if (this.add_item) {
        this.$validator.resume();
      } else {
        this.$validator.pause();
      }
    },
    cancelEdit: function cancelEdit() {
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this2 = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this2.item_permisos) {
            _this2.loadButton(_this2.$refs.btnSave);
            _this2.$http.post("permisos", _this2.item_permisos).then(function (response) {
              _this2.StepOk("Guardado");
              if (_this2.edit_item === undefined || _this2.edit_item === null) {
                _this2.list_permisos.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response.data.permiso));
              } else {
                var index = _this2.list_permisos.map(function (u) {
                  return u.id;
                }).indexOf(response.data.permiso.id);
                _this2.list_permisos.splice(index, 1, response.data.permiso);
              }
              _this2.initItem();
              _this2.showItem();
              _this2.edit_item = null;
            }, function (error) {
              _this2.StepError(error);
            });
          }
        } else {
          _this2.StepError("Hay campos sin completar", 2000);
        }
      });
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_permisos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.edit_item);

      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this3 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this3.$http.delete("permisos/" + item.id).then(function (response) {
            _this3.StepOk('Permiso Eliminado');
            var index = _this3.list_permisos.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this3.list_permisos.splice(index, 1);
          }, function (error) {
            _this3.Err(error);
          });
        });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },
  created: function created() {
    var _this4 = this;

    this.checkPermissions();
    this.initItem();
    this.$http.get("permisos").then(function (response) {
      _this4.list_permisos = response.data.permisos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("permisos/catalogo").then(function (response) {
      _this4.list_cat_permisos = response.data.catpermisos;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "gPdJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gi0y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Domicilio_vue__ = __webpack_require__("Ta4m");



















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a),
  props: ["data"],
  data: function data() {
    return {
      options: [{
        id: 1,
        label: "foo"
      }, {
        id: 3,
        label: "bar"
      }, {
        id: 2,
        label: "baz"
      }],
      filter: null,

      currentPage: 1,
      perPage: 50,
      rol: "",
      rows: null,
      id: 1,
      add_item: false,
      edit_item: null,
      tipos: null,
      n_domicilio: null,
      dependencias: null,
      item_usuarios: {},
      list_usuarios: [],
      item_usuariosValidations: {
        rfc: {
          required: true
        },
        nombres: {
          required: true
        },
        primer_apellido: {
          required: true
        },
        segundo_apellido: {
          required: true
        },
        ente_publico_id: {
          required: true
        },
        direccion_cargo: {
          required: true
        },
        nivel: {
          required: true
        },
        area_adscripcion: {
          required: true
        },
        honorarios: {
          required: true
        },
        AG172: {
          required: true
        },
        fecha_inicio: {
          required: true
        },
        tipo_baja: {
          required: true
        },
        termina: {
          required: true
        },
        inicia: {
          required: true
        },
        tipo_lic: {
          required: true
        },
        observaciones: {
          required: true
        },
        empleo_cargo_comision: {
          required: true
        }
      },
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Usuario que realizo la desactivación',
        value: 'nombreUsuario',
        align: 'center'
      }, {
        text: 'Fecha de desactivación',
        value: 'inicia',
        align: 'center'
      }, {
        text: 'Motivo',
        value: 'motivo',
        align: 'center'
      }],
      selects: {
        simple: "",
        movimientos: [{
          value: "1",
          label: "Desactivar servidor"
        }, {
          value: "2",
          label: "Crear baja "
        }, {
          value: "3",
          label: "Crear licencia"
        }, {
          value: "4",
          label: "Crear promoción"
        }, {
          value: "5",
          label: "Realizar corrección"
        }, {
          value: "6",
          label: "Cambiar contraseña"
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vee_validate__["c" /* mapFields */])(["rfc", "nombres", "primer_apellido", "segundo_apellido", "ente_publico_id", "direccion_cargo", "nivel", "area_adscripcion", "honorarios", "AG172", "Password", "Confirmar", "fecha_inicio", "tipo_baja", "termina", "inicia", "tipo_lic", "observaciones", "empleo_cargo_comision"]), {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_usuarios.length;

      return this.list_usuarios.length;
    },

    fullName: {
      get: function get() {
        return this.item_usuarios.nombres + " " + this.item_usuarios.primer_apellido + " " + this.item_usuarios.segundo_apellido;
      },
      set: function set(newValue) {
        var m = newValue.match(/(\S*)\s+(.*)/);

        this.nombres = m[1];
        this.primer_apellido = m[2];
        this.segundo_apellido = m[3];
      }
    }
  }),
  methods: {
    initItem: function initItem() {
      this.item_usuarios = {
        acciones: "",
        nombres: "",
        Paterno: "",
        Materno: "",
        User: "",
        Password: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.item_usuarios) {
            _this.loadButton(_this.$refs.btnSave);
            _this.$http.post("usuarios", _this.item_usuarios).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.list_usuarios.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.usuario));
              } else {
                _this.list_usuarios.splice(_this.edit_item.index, 1, _this.item_usuarios);
                _this.edit_item.item._rowVariant = "";
              }
              _this.initItem();
              _this.showItem();
              _this.edit_item = null;
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_usuarios = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_usuarios[this.edit_item.index]);
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    reactivar: function reactivar(item) {
      var _this2 = this;

      this.Ask("¿Desea reactivar este usuario?", function () {
        _this2.$http.post("usuario/reactivar", item).then(function (response) {
          _this2.StepOk("Usuario activado correctamente");
        }, function (error) {
          _this2.Err(error);
        });
      });
    },
    removeItem: function removeItem(indice) {
      var _this3 = this;

      if (this.list_usuarios[indice].id !== null) {
        var item = this.list_usuarios[indice];
        this.list_usuarios.splice(indice, 1);
        this.Ask("Desea borrar este registro", function () {
          _this3.$http.delete("usuarios/" + item.id).then(function (response) {
            _this3.list_usuarios.splice(indice, 1);
          }, function (error) {
            _this3.Err(error);
          });
        });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDependencias: function getDependencias(index) {
      var resp = " ";
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    buscaPers: function buscaPers(value, search, item) {
      if (typeof value === 'string') {
        var nombre = ((item.usuarios.nombres || '') + ' ' + (item.usuarios.primer_apellido || '') + ' ' + (item.usuarios.segundo_apellido || '')).toLowerCase();
        var user = (item.usuarios.rfc || '').toLowerCase();
        return nombre.indexOf(search) !== -1 || user.indexOf(search) !== -1;
      }
      return false;
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();
    this.rol = this.getKey("role");
    if (this.rol == 4) {
      this.filtro = this.getKey("ente_publico_id");
    }

    this.$http.get("servidoresinactivos").then(function (response) {
      _this4.list_usuarios = response.data.usuarios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.dependencias = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "gyHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-sm-4 text-center"},[_c('stats-card2',[_c('div',{staticClass:"icon-big text-center icon-info",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-users"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Obligados")]),_vm._v("\n          "+_vm._s(_vm.obligados)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"inicial"},slot:"inicial"},[_c('p',[_vm._v(_vm._s(_vm.obligadosIn))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"anual"},slot:"anual"},[_c('p',[_vm._v(_vm._s(_vm.obligadosAn))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"final"},slot:"final"},[_c('p',[_vm._v(_vm._s(_vm.obligadosFi))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-4 text-center"},[_c('stats-card2',[_c('div',{staticClass:"icon-big text-center icon-success",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-file"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Declaraciones")]),_vm._v("\n          "+_vm._s(_vm.declaraciones)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"inicial"},slot:"inicial"},[_c('p',[_vm._v(_vm._s(this.rinicial))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"anual"},slot:"anual"},[_c('p',[_vm._v(_vm._s(this.ranual))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"final"},slot:"final"},[_c('p',[_vm._v(_vm._s(this.rfinal))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-4 text-center"},[_c('stats-card2',[_c('div',{staticClass:"icon-big text-center icon-danger",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-users"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Faltantes")]),_vm._v("\n          "+_vm._s(_vm.faltantes)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"inicial"},slot:"inicial"},[_c('p',[_vm._v(_vm._s(_vm.faltantesIn))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"anual"},slot:"anual"},[_c('p',[_vm._v(_vm._s(_vm.faltantesAn))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"final"},slot:"final"},[_c('p',[_vm._v(_vm._s(_vm.faltantesFi))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4",on:{"click":_vm.cumplimiento}},[_c('circle-chart-card',{attrs:{"percentage":_vm.porcentaje,"title":"Avance Global","avance":_vm.declaraciones,"total":_vm.obligados,"description":""},on:{"click":_vm.cumplimiento}})],1)]),_vm._v(" "),(this.getKey('permisos').includes(19))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-sm-4 "},[_c('a',{attrs:{"href":'#/alertas/bitacora'}},[_c('stats-card',[_c('div',{staticClass:"icon-big text-left icon-info",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-book"})]),_vm._v(" "),_c('div',{staticClass:"numbers titulos",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Bitácora")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Declaraciones Consultadas")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-4 text-center"},[_c('a',{attrs:{"href":'#/admin/movimientos'}},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center icon-warning",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-check-double"})]),_vm._v(" "),_c('div',{staticClass:"numbers titulos",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Vo.Bo. Correcciones")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Aprobar Correcciones")])])])],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card card-circle-chart"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Declaraciones por día")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Se muestra la última semana")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartStock"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hSiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("No de Declaraciones")]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.rol!=4)?_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Desde")]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"name":"fecha_inicio","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.model, "fecha_inicio", $$v)},expression:"model.fecha_inicio"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Hasta")]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"name":"fecha_fin","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_fin),callback:function ($$v) {_vm.$set(_vm.model, "fecha_fin", $$v)},expression:"model.fecha_fin"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-fill btn-success ",staticStyle:{"text-align":"left"},on:{"click":_vm.getDeclaracionesR}},[_vm._v("\n                Buscar\n              ")])])])])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('export-excel',{staticClass:"btn btn-wd btn-success",attrs:{"data":_vm.list_cumplimiento,"meta":_vm.meta,"fields":_vm.no_declaraciones,"worksheet":"Resumén declaraciones","name":"Resumén declaraciones.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n              Descargar Reporte\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers2,"items":_vm.list_cumplimiento,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Descargar Declaración'),expression:"'Descargar Declaración'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item)}}},[_c('i',{staticClass:"ti-download"})])],1)]}},{key:"item.t_inicial",fn:function(ref){
var item = ref.item;
return [_c('v-progress-circular',{attrs:{"rotate":360,"size":70,"width":5,"value":item.l_inicial,"color":"teal"}},[_c('strong',[_vm._v(_vm._s(item.r_iniciales))])])]}},{key:"item.t_anual",fn:function(ref){
var item = ref.item;
return [_c('v-progress-circular',{attrs:{"rotate":360,"size":70,"width":5,"value":item.l_anual,"color":"teal"}},[_c('strong',[_vm._v(_vm._s(item.r_anuales))])])]}},{key:"item.t_final",fn:function(ref){
var item = ref.item;
return [_c('v-progress-circular',{attrs:{"rotate":360,"size":70,"width":5,"value":item.l_final,"color":"teal"}},[_c('strong',[_vm._v(_vm._s(item.r_finales))])])]}}])})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hTv3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Representacion_vue__ = __webpack_require__("cZnO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_082df4f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Representacion_vue__ = __webpack_require__("Ikxu");
function injectStyle (ssrContext) {
  __webpack_require__("DoFW")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Representacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_082df4f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Representacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iCjR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_DatosPersonales_vue__ = __webpack_require__("+ZXX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_86eeac40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_DatosPersonales_vue__ = __webpack_require__("Pufn");
function injectStyle (ssrContext) {
  __webpack_require__("zREl")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_DatosPersonales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_86eeac40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_DatosPersonales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iHK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ListDeclaraciones2_vue__ = __webpack_require__("DtR0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b03be226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ListDeclaraciones2_vue__ = __webpack_require__("t455");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ListDeclaraciones2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b03be226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ListDeclaraciones2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iSCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"error-color":"#EB5E28","color":"#1e94fd","title":"Ingresos","subtitle":""},on:{"on-complete":_vm.siguente}},[(this.getKey('tipo_dec') === 'Inicial')?_c('tab-content',{attrs:{"before-change":_vm.addItem,"title":"Ingresos netos del declarante, pareja y/o dependientes económicos (situación actual)","icon":"ti-user"}},[_c('sueldos-salarios',{ref:"SueldosSalarios"})],1):_vm._e(),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.addItem55,"title":"Situación patrimonial año anterior","icon":"ti-user"}},[_c('sueldos-salarios-otros',{ref:"SueldosSalariosOtros"})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Atrás")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v("Siguiente")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Siguientes")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iWfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    var _ref;

    return _ref = {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,
      monedas: [],
      plazos: [],
      actividades: [],
      sectores: null,
      n_domicilio: null
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "monedas", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "entidadFed", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "municipios", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidades", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidad", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "paises", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isnum", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "item_actividades", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "list_actividades", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fields_list", [{
      key: "acciones",
      label: "Acciones",
      tdClass: "text-center"
    }, {
      key: "nombre_denominacion_razon_social",
      label: "Denominación o razón social",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "rfc",
      label: "RFC",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "curp",
      label: "CURP",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "sector_industria_id",
      label: "Sector",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "tipo_actividad_servicio_id",
      label: "Tipo de actividad ",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "descripcion_actividad_servicio",
      label: "Descripción de la actividad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "ingreso_bruto_anual",
      label: "Ingreso bruto anual ",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "moneda_id",
      label: "Moneda",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "duracion_frecuencia",
      label: "Duración / Frecuencia",
      tdClass: "text-center",
      formatter: 'emptyFields'
    }, {
      key: "unidad_temporal_id",
      label: "Unidad temporal",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "fecha_transaccion",
      label: "Fecha de transacción",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "observaciones",
      label: "Observaciones",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "pais_id",
      label: "País",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "entidad_federativa_id",
      label: "Entidad federativa",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "municipio_id",
      label: "Municipio",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "localidad_id",
      label: "Localidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "colonia",
      label: "Colonia",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_tipo_vial",
      label: "Tipo vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_nom_vial",
      label: "Nombre vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "cp",
      label: "CP",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numExt",
      label: "Número exterior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numInt",
      label: "Número interior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }]), _ref;
  },

  computed: {
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.item_actividades.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.item_actividades.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {
    list_actividades: {
      handler: function handler() {
        if (this.list_actividades) {
          this.setLocalidades();
          if (this.list_actividades.length == 0) {
            this.bandera = '0';
          } else {
            this.bandera = '1';
          }
        }
      },
      deep: true
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_actividades.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_actividades.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_actividades.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_actividades.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_actividades.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_actividades.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_actividades.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_actividades.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_actividades.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_actividades.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    }
  },
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMoneda: function getMoneda(index) {
      var resp = "";
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getActividad: function getActividad(index) {
      var resp = " ";
      if (this.sectores) {
        this.actividades.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUnidades: function getUnidades(index) {
      var resp = " ";
      if (this.plazos) {
        this.plazos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: '',
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
      this.item_actividades = {
        acciones: "",
        rfc_quien_adquirio: "",
        ingreso_bruto_anual: "",
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: "",
        entidad_federativa_id: "",
        municipio_id: "",
        localidad_id: "",
        colonia: "",
        cp: "",
        numExt: "",
        numInt: "",
        vialidad_nom_vial: "",
        vialidad_tipo_vial: "",
        observaciones: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      if (this.item_actividades) {
        this.item_actividades.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post("arrendamientos", this.item_actividades).then(function (response) {
          _this.StepOk("Guardado");
          if (_this.edit_item === undefined || _this.edit_item === null) {
            _this.list_actividades.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.actividad));
          } else {
            _this.list_actividades.splice(_this.edit_item.index, 1, _this.item_actividades);
            _this.edit_item.item._rowVariant = "";
          }
          _this.showItem();
          _this.initItem();
          _this.edit_item = null;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW("Hay campos sin completar");
      }
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_actividades = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_actividades[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_actividades[indice].id !== null) {
        var item = this.list_actividades[indice];

        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("arrendamientos/" + item.id).then(function (response) {
            _this2.list_actividades.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_actividades.pais_id ? this.item_actividades.pais_id : 150;
      this.n_domicilio.entidadF = this.item_actividades.entidad_federativa_id ? this.item_actividades.entidad_federativa_id : '';
      this.n_domicilio.municipio = this.item_actividades.municipio_id ? this.item_actividades.municipio_id : '';
      this.n_domicilio.localidad = this.item_actividades.localidad_id ? this.item_actividades.localidad_id : '';
      this.n_domicilio.cp = this.item_actividades.cp ? this.item_actividades.cp : '';
      this.n_domicilio.colonia = this.item_actividades.colonia ? this.item_actividades.colonia : '';
      this.n_domicilio.vialidad = this.item_actividades.vialidad_tipo_vial ? this.item_actividades.vialidad_tipo_vial : '';
      this.n_domicilio.vialidad_nombre = this.item_actividades.vialidad_nom_vial ? this.item_actividades.vialidad_nom_vial : '';
      this.n_domicilio.ext = this.item_actividades.numExt ? this.item_actividades.numExt : '';
      this.n_domicilio.int = this.item_actividades.numInt ? this.item_actividades.numInt : '';
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      this.list_actividades.forEach(function (item) {
        if (item.localidad_id) {
          _this3.$http.get('localidades/localidad/' + item.localidad_id).then(function (response) {
            _this3.localidades.push(response.data.localidad);
          }, function (error) {
            _this3.Err(error);
          });
        }
      });
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("arrendamientos/" + this.ip_id).then(function (response) {
      _this4.list_actividades = response.data.actividades;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_unidad_medida_plazo").then(function (response) {
      _this4.plazos = response.data.unidades;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_actividad").then(function (response) {
      _this4.actividades = response.data.actividad;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("monedas").then(function (response) {
      _this4.monedas = response.data.monedas;
      var temp = "97";
      _this4.monedas.forEach(function (item) {
        if (item.codigo == "MXN") {
          temp = item.id;
        }
      });
      _this4.item_actividades.moneda_id = temp;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "iXuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");






var GlobalComponents = {
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "ifEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Recibió otros ingresos ?\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre, denominación o razón social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_ingresos.nombre_denominacion_razon_social),expression:"item_ingresos.nombre_denominacion_razon_social"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre, denominación o razón social de quien se adquirió el inmueble:"},domProps:{"value":(_vm.item_ingresos.nombre_denominacion_razon_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_ingresos, "nombre_denominacion_razon_social", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_ingresos.rfc),expression:"item_ingresos.rfc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RFC"},domProps:{"value":(_vm.item_ingresos.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_ingresos, "rfc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("CURP (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_ingresos.curp),expression:"item_ingresos.curp"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CURP"},domProps:{"value":(_vm.item_ingresos.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_ingresos, "curp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector / Industria (si aplica)")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_ingresos.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.item_ingresos, "sector_industria_id", $$v)},expression:"item_ingresos.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de actividad o servicio que produjo el ingreso")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_ingresos.tipo_actividad_servicio_id),callback:function ($$v) {_vm.$set(_vm.item_ingresos, "tipo_actividad_servicio_id", $$v)},expression:"item_ingresos.tipo_actividad_servicio_id"}},_vm._l((_vm.actividades),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Descripción de la actividad / situación que produce el ingreso")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_ingresos.descripcion_actividad),expression:"item_ingresos.descripcion_actividad"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción de la actividad"},domProps:{"value":(_vm.item_ingresos.descripcion_actividad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_ingresos, "descripcion_actividad", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 customCurrency"},[_c('label',{staticClass:"control-label"},[_vm._v("Ingreso bruto anual recibido por la actividad que produjo el ingreso")]),_vm._v(" "),_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{staticClass:"text-right",attrs:{"type":"number","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.item_ingresos.ingreso_bruto_anual),callback:function ($$v) {_vm.$set(_vm.item_ingresos, "ingreso_bruto_anual", $$v)},expression:"item_ingresos.ingreso_bruto_anual"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.item_ingresos.moneda_id),callback:function ($$v) {_vm.$set(_vm.item_ingresos, "moneda_id", $$v)},expression:"item_ingresos.moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.item_ingresos.moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Duración o frecuencia ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_ingresos.duracion_frecuencia),expression:"item_ingresos.duracion_frecuencia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Frecuencia"},domProps:{"value":(_vm.item_ingresos.duracion_frecuencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_ingresos, "duracion_frecuencia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Unidad temporal")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_ingresos.unidad_temporal_id),callback:function ($$v) {_vm.$set(_vm.item_ingresos, "unidad_temporal_id", $$v)},expression:"item_ingresos.unidad_temporal_id"}},_vm._l((_vm.plazos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.item_ingresos.unidad_temporal_id == 4)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de transacción")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.item_ingresos.fecha_transaccion),callback:function ($$v) {_vm.$set(_vm.item_ingresos, "fecha_transaccion", $$v)},expression:"item_ingresos.fecha_transaccion"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones / Comentarios")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_ingresos.observaciones),expression:"item_ingresos.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Observaciones / Comentarios"},domProps:{"value":(_vm.item_ingresos.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_ingresos, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":""},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_ingresos","responsive":"","hover":"","items":_vm.list_ingresos,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.entidad_federativa_id)))]}},{key:"localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.localidad_id))+"\n            ")]}},{key:"municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.municipio_id)))]}},{key:"pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_id)))]}},{key:"sector_industria_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSector(row.item.sector_industria_id)))]}},{key:"tipo_actividad_servicio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getActividad(row.item.tipo_actividad_servicio_id)))]}},{key:"ingreso_bruto_anual",fn:function(row){return [_vm._v(_vm._s((_vm.getSignoDos(row.item.moneda_id)))+"\n              "+_vm._s(_vm._f("currency")(row.item.ingreso_bruto_anual)))]}},{key:"moneda_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getMoneda(row.item.moneda_id)))]}},{key:"unidad_temporal_id",fn:function(row){return [_vm._v(_vm._s(_vm.getUnidades(row.item.unidad_temporal_id)))]}}],null,false,2722672800)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Otros ingresos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ij53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("gJ8B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea8347b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("g4Qj");
function injectStyle (ssrContext) {
  __webpack_require__("1TUu")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea8347b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("Kbm6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "inqE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j+qR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__ = __webpack_require__("8b7g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f964920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__ = __webpack_require__("+4gK");
function injectStyle (ssrContext) {
  __webpack_require__("2+a/")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f964920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j5fh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo",on:{"click":_vm.tablero}},[_c('a',{staticClass:"simple-text logo-mini"},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_c('ul',{class:_vm.navClasses},[_vm._t("links",function(){return _vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{key:link.name + index,staticClass:"ml-3 mt-3 mr-3 mw parent",attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return (_vm.checaPermisos(subLink.permiso))?_c('sidebar-item',{key:subLink.name + index,staticClass:"col-12 d-inline-block-flex p-2",attrs:{"link":subLink}}):_vm._e()}),1)})})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:" simple-text logo-normal ml-3 m-0 "},[_c('img',{staticClass:"dnet-txt",attrs:{"src":"static/img/background/declaranet_txt.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jCiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('br'),_c('br'),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:" card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|regex:^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$|min:8'),expression:"'required|regex:^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$|min:8'"},{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",staticClass:"form-control",attrs:{"required":"","name":"password","type":"password","placeholder":"Contraseña"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password_cofirmation"}},[_vm._v("Confirma la Contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:password'),expression:"'required|confirmed:password'"}],staticClass:"form-control",attrs:{"required":"","name":"password_confirmation","type":"password","placeholder":"Confirma la contraseña","data-vv-as":"password"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.any()),expression:"errors.any()"}],staticClass:"alert alert-danger"},[(_vm.errors.has('password'))?_c('div',[_vm._v("\n                        La contraseña debe ser alfanumérica y de 8 caracteres mínimo\n                      ")]):_vm._e(),_vm._v(" "),(_vm.errors.has('password_confirmation'))?_c('div',[_c('span',{staticClass:"texto"},[_vm._v("Las contraseñas no coinciden")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"button","disabled":_vm.errors.any()},on:{"click":function($event){$event.preventDefault();return _vm.actualiza()}}},[_vm._v("Actualizar")])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"text-center col-md-12"},[_c('img',{staticClass:"d-logo mb-3",attrs:{"src":"static/img/background/declaranet_logo.png","alt":"declaraNet"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 "},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-success"},[_c('i',{staticClass:"ti ti-user"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Actualiza tu contraseña")]),_vm._v("\n                  Como medida de seguridad, el primer paso será cambiar tu contraseña\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jEOz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      table_list: [],
      form_item: {},
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Tipo de Inversión',
        value: 'tipo_inversion_id',
        align: 'center'
      }, {
        text: 'Titular',
        value: 'titular_id',
        align: 'center'
      }, {
        text: 'Número de cuenta, contrato o póliza',
        value: 'numero_cuenta',
        align: 'center'
      }, {
        text: 'Institución o razón social',
        value: 'nombre_institucion',
        align: 'center'
      }],
      info: {
        inversiones: 'Para la declaración de inicio reportar la situación de las inversiones, cuentas bancarias y otro tipo de valores a la fecha de ingreso al empleo, cargo o comisión. Para la declaración de modificación reportar la situación de las inversiones, cuentas bancarias y otro tipo de valores del año inmediato anterior. Para la declaración de conclusión reportar la situación de las inversiones, cuentas bancarias y otro tipo de valores a la fecha de conclusión del empleo, cargo o comisión. El Declarante reportara toda la información relacionada con sus inversiones, cuentas bancarias o algún otro tipo de valor que forme parte de sus activos.',
        tipo_inversion: 'Elegir del catálogo la inversión, la cuenta o el valor a reportar, dependiendo la elección deberá señalar número de cuenta, número de contrato o número de póliza.',
        titular: 'Seleccionar alguna de las opciones del catálogo desplegable.',
        tercero: 'En caso de copropiedad con un tercero, seleccionar si es persona física o persona moral.',
        nombre_tercero: 'En caso de señalar copropiedad, escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
        rfc_tercero: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
        bancaria: 'Seleccionar cualquiera de las siguientes opciones: cuenta de nómina, cuenta de ahorro, cuenta de cheques, cuenta maestra, cuenta eje y depósito a plazos.',
        fondo: 'Seleccionar cualquiera de las siguientes opciones: sociedades de inversión, inversiones financieras en el extranjero.',
        organizaciones: 'Seleccionar cualquiera de las siguientes opciones: acciones o cajas de ahorro.',
        monedas_metales: 'Seleccionar cualquiera de las siguientes opciones: centenarios, divisas, moneda nacional, onzas troy, criptomonedas.',
        seguros: 'Seleccionar cualquiera de las siguientes opciones: seguro de separación individualizado, seguro de inversión y seguro de vida.',
        valores: 'Seleccionar cualquiera de las siguientes opciones: acciones y derivados, aceptaciones bancarias, bonos gubernamentales, papel comercial.',
        afores: 'Seleccionar cualquiera de las siguientes opciones: afores, fideicomisos, certificados de la tesorería, préstamos a favor de un tercero.',
        nombre_institucion: 'Señalar el nombre de la institución donde se encuentran registradas las inversiones cuentas o valores.',
        frc_institucion: 'Señalar los doce dígitos correspondientes. (Si aplica).',
        cuenta: 'Señalar el número de cuenta, contrato, póliza o cualquier dato que permita su identificación.',
        monto_original: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda.',
        moneda_id: 'Deberá seleccionar la moneda relativa a la cuenta.',
        lugar: 'Indicar si se encuentra en México o en el extranjero, debiendo señalar el país donde se localiza.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },

  computed: {
    terceros: function terceros() {
      if (this.form_item) {
        if (this.form_item.titular_id) {
          var arr = [3, 4, 5, 8, 10, 13, 15, 18, 19, 24, 25];
          return arr.includes(this.form_item.titular_id);
        }
      }
      return false;
    },
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.form_item.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.form_item.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      if (!this.form_item.domicilio_institucion_pais_id) {
        this.form_item.domicilio_institucion_pais_id = 150;
      }
      this.form_item.moneda_id = 97;
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = false;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("inversiones_cuentas_valores", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");

              if (!_this.edit_item) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
          _this.scrolling();
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = true;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("inversiones_cuentas_valores/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    checkDomicilio: function checkDomicilio() {
      if (this.n_domicilio) {
        this.form_item.domicilio_institucion_pais_id = this.n_domicilio.pais;
        this.form_item.entidad_federativa_id = this.n_domicilio.entidadF;
        this.form_item.municipio_id = this.n_domicilio.municipio;
        this.form_item.localidad_id = this.n_domicilio.localidad;
        this.form_item.cp = this.n_domicilio.cp;
        this.form_item.vialidad_nombre = this.n_domicilio.vialidad_nombre;
        this.form_item.vialidad_tipo = this.n_domicilio.vialidad;
        this.form_item.numext = this.n_domicilio.ext;
        this.form_item.numint = this.n_domicilio.int;
        this.form_item.colonia = this.n_domicilio.colonia;
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');
    this.$http.get("inversiones_cuentas_valores/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();
    this.form_item.domicilio_institucion_pais_id = 150;
  }
});

/***/ }),

/***/ "jGtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Fideicomisos_vue__ = __webpack_require__("3+PJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5348f345_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Fideicomisos_vue__ = __webpack_require__("UV0G");
function injectStyle (ssrContext) {
  __webpack_require__("PvgY")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Fideicomisos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5348f345_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Fideicomisos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jj2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "jjFe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");











var _components;






/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), _components),
  data: function data() {
    return {
      items: [{
        avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
        title: 'Brunch this weekend?',
        subtitle: "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?"
      }, { divider: true, inset: true }, {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
        title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
        subtitle: "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend."
      }, { divider: true, inset: true }, {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
        title: 'Oui oui',
        subtitle: "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?"
      }, { divider: true, inset: true }, {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
        title: 'Birthday gift',
        subtitle: "<span class='text--primary'>Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?"
      }, { divider: true, inset: true }, {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
        title: 'Recipe to try',
        subtitle: "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos."
      }],
      notificaciones: []
    };
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      var permiso = [22, 23, 24];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      }) && this.getKey('role') != '0') {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getNotificaciones: function getNotificaciones() {
      var _this = this;

      this.$http.get("notificaciones").then(function (response) {
        _this.notificaciones = response.data.notificaciones;
        console.log(_this.notificaciones);
      }, function (error) {
        _this.StepError(error);
      });
    },
    leida: function leida(id) {
      var _this2 = this;

      var permiso = [24];
      if (this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        this.$http.get("notificaciones/" + id).then(function (response) {
          _this2.getNotificaciones();
        }, function (error) {
          _this2.StepError(error);
        });
      } else {
        this.$http.delete("notificaciones/" + id).then(function (response) {
          _this2.getNotificaciones();
        }, function (error) {
          _this2.StepError(error);
        });
      }
    }
  },
  created: function created() {
    this.rol = this.getKey('role');
    this.checkPermissions();
    this.getNotificaciones();
  }
});

/***/ }),

/***/ "jwfX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jzdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Intereses_vue__ = __webpack_require__("eNX3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_26321074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Intereses_vue__ = __webpack_require__("sQJH");
function injectStyle (ssrContext) {
  __webpack_require__("xQl+")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Intereses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_26321074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Intereses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k17A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('br'),_c('br'),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row ocultar",attrs:{"id":"formResetPass"}},[_c('div',{staticClass:"col-md-6 "},[_c('div',{staticClass:"media"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Actualiza tu contraseña")]),_vm._v(" "),(_vm.nombre != '')?_c('p',{staticStyle:{"text-transform":"capitalize"}},[_vm._v("Hola, "+_vm._s(_vm._f("lowercase")(_vm.nombre))+"!")]):_vm._e(),_vm._v("\n                  Como medida de seguridad, el primer paso será cambiar tu contraseña\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:" card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|regex:^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$|min:8'),expression:"'required|regex:^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$|min:8'"},{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",staticClass:"form-control",attrs:{"required":"","name":"password","type":"password","placeholder":"Contraseña"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password_cofirmation"}},[_vm._v("Confirma la Contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:password'),expression:"'required|confirmed:password'"}],staticClass:"form-control",attrs:{"required":"","name":"password_confirmation","type":"password","placeholder":"Confirma la contraseña","data-vv-as":"password"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.any()),expression:"errors.any()"}],staticClass:"alert alert-danger"},[(_vm.errors.has('password'))?_c('div',[_vm._v("\n                        La contraseña debe ser alfanumérica y de 8 caracteres mínimo\n                      ")]):_vm._e(),_vm._v(" "),(_vm.errors.has('password_confirmation'))?_c('div',[_c('span',{staticClass:"texto"},[_vm._v("Las contraseñas no coinciden")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"button","disabled":_vm.errors.any()},on:{"click":function($event){$event.preventDefault();return _vm.actualiza()}}},[_vm._v("Actualizar")])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"text-center col-md-12"},[_c('img',{staticClass:"d-logo mb-3",attrs:{"src":"static/img/background/declaranet_logo.png","alt":"declaraNet"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-success"},[_c('i',{staticClass:"ti ti-user"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k2FP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("a/Ze");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("MHIl");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kqqt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formularios_Activos_BienesInmuebles_vue__ = __webpack_require__("FeKx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formularios_Activos_BienesMuebles_vue__ = __webpack_require__("lUpH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Formularios_Activos_BienesMueblesNR_vue__ = __webpack_require__("E5Hk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Formularios_Activos_Inversiones_vue__ = __webpack_require__("EXZ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {}
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["TabContent"],
    BienesInmuebles: __WEBPACK_IMPORTED_MODULE_2__Formularios_Activos_BienesInmuebles_vue__["a" /* default */],
    BienesMuebles: __WEBPACK_IMPORTED_MODULE_3__Formularios_Activos_BienesMuebles_vue__["a" /* default */],
    BienesMueblesNR: __WEBPACK_IMPORTED_MODULE_4__Formularios_Activos_BienesMueblesNR_vue__["a" /* default */],
    Inversiones: __WEBPACK_IMPORTED_MODULE_5__Formularios_Activos_Inversiones_vue__["a" /* default */]
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    cancelAll: function cancelAll() {
      var tab = this.$refs.wizard.tabs[this.$refs.wizard.activeTabIndex].$children;
      tab[0].cancelEdit();
    },
    siguente: function siguente() {
      this.$router.push('pasivos');
    }
  },
  created: function created() {
    this.checkPermissions();
  },
  mounted: function mounted() {
    this.$refs.wizard.activateAll();
  }
});

/***/ }),

/***/ "kzbf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__("kDzH");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip_id: null,
      password: '',
      able: false,
      passwordConfirm: ''
    };
  },

  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    actualiza: function actualiza() {
      var _this = this;

      if (this.password != '') {
        this.$http.post('updatePass/' + this.password).then(function (response) {
          _this.setSession(response.data);
          console.log(_this.getKey('status_dec'));
          if (_this.getKey('status_dec') == 1) {
            _this.$router.push('/forms/tablero');
          } else {
            _this.$router.push('/forms/enviada');
            localStorage.setItem('std', 0);
          }

          _this.$router.go();
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.Err("El campo no puede estar vacío");
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  },
  created: function created() {
    this.ip_id = this.getId();
  }
});

/***/ }),

/***/ "l1bq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      correo: '',
      rfc_recupera: '',
      pass: '',
      recupera_vista: 0
    };
  },

  methods: {
    recupera_pass: function recupera_pass() {
      var _this = this;

      this.$http.get('recupera_pass/' + this.rfc_recupera).then(function (response) {
        if (response.data.message) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: 'Error',
            text: 'RFC no encontrado',
            type: 'error'
          });
        }
        if (response.data.email) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: 'Info',

            html: 'Se enviara un correo electrónico con su contraseña a la siguiente dirección: <strong>' + response.data.email + '</strong>. Si este correo no le pertenece o no lo reconoce favor de comunicarse con el administrador del sistema.',

            type: 'info',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
          });
        }
      }, function (error) {
        _this.StepW(error);
      });
    },
    recupera_pass_cancel_vista: function recupera_pass_cancel_vista() {
      this.recupera_vista = 0;
    },
    recupera_pass_vista: function recupera_pass_vista() {
      this.recupera_vista = 1;
    },
    login: function login() {
      var _this2 = this;

      if (localStorage.getItem('app-token-declaranet')) {
        console.log('ok');
        this.checkedlog = Math.random();
        localStorage.clear();
      } else {
        this.$http.post('login', { usuario: this.correo, pass: this.pass }).then(function (response) {
          if (response.data.message) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
              title: 'Verifica',
              text: 'La información es incorrecta',
              type: 'warning'
            });
          } else {
            _this2.setSession(response.data);
            _this2.checkedlog = Math.random();
            if (response.data.pr) {
              if (_this2.getKey('movimiento') == 0) {
                __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
                  title: 'VERIFICA',
                  text: 'Estimado servidor público, por el momento este usuario esta inactivo consulta con tu área de recursos humanos.',
                  type: 'warning'
                });
              } else {
                _this2.$router.push('/update');
              }
            } else {
              if (_this2.getKey('role') != 0) {
                _this2.$router.push('/admin/tablero');
              } else {
                if (_this2.getKey('movimiento') == 0) {
                  __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
                    title: 'VERIFICA',
                    text: 'Estimado servidor público, por el momento este usuario esta inactivo consulta con tu área de recursos humanos.',
                    type: 'warning'
                  });
                } else {
                    if (_this2.getKey('status_dec') == 1) {
                      _this2.$router.push('/forms/infPersonal');
                    } else {
                      _this2.$router.push('/forms/enviada');
                      localStorage.setItem('std', 0);
                    }
                    _this2.checkCatalogs();
                    _this2.$router.push('/forms/tablero');
                  }
              }
            }
          }
        }, function (error) {
          _this2.loading = false;
          _this2.Err(error);
        });
      }
    }
  },
  created: function created() {

    if (navigator.userAgent.includes && (navigator.userAgent.toUpperCase().includes('TLSv1.2 ECDHE-RSA-AES128-GCM-SHA256') || navigator.userAgent.toUpperCase().includes('TLSv1.2 ECDHE-RSA-AES256-GCM-SHA384') || navigator.userAgent.includes('Version/12.1 Safari/605.1.15'))) {
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        title: 'Alerta',
        text: 'Detectamos que estás usando un navegador no compatible, por favor usa Chrome o Mozilla',
        type: 'warning'
      });
    }
    if (this.checkedlog) {
      this.checkedlog = Math.random();
      localStorage.clear();
    }
  }
});

/***/ }),

/***/ "lNTZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lUpH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BienesMuebles_vue__ = __webpack_require__("SQ/5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7233ff3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BienesMuebles_vue__ = __webpack_require__("vio/");
function injectStyle (ssrContext) {
  __webpack_require__("4x0F")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_BienesMuebles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7233ff3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_BienesMuebles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lcZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-12 mb-3 text-center"},[_c('h3',{staticClass:"m-1"},[_vm._v("Califica el sistema")]),_vm._v(" "),_c('el-rate',{model:{value:(_vm.data.rate),callback:function ($$v) {_vm.$set(_vm.data, "rate", $$v)},expression:"data.rate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.observaciones),expression:"data.observaciones"}],staticClass:"form-control bg-white",attrs:{"placeholder":"Observaciones"},domProps:{"value":(_vm.data.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data, "observaciones", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3 d-flex justify-content-center"},[_c('button',{staticClass:"text-center btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal","disabled":(_vm.data.rate != 0)?false:true},on:{"click":_vm.send}},[_vm._v("Enviar")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lfMN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "losD":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "mCAw",
	"./af.js": "mCAw",
	"./ar": "Qnbu",
	"./ar-dz": "wQ9+",
	"./ar-dz.js": "wQ9+",
	"./ar-kw": "GOng",
	"./ar-kw.js": "GOng",
	"./ar-ly": "ur28",
	"./ar-ly.js": "ur28",
	"./ar-ma": "GJpw",
	"./ar-ma.js": "GJpw",
	"./ar-ps": "HMxF",
	"./ar-ps.js": "HMxF",
	"./ar-sa": "msQm",
	"./ar-sa.js": "msQm",
	"./ar-tn": "QWx1",
	"./ar-tn.js": "QWx1",
	"./ar.js": "Qnbu",
	"./az": "OmHK",
	"./az.js": "OmHK",
	"./be": "vxIc",
	"./be.js": "vxIc",
	"./bg": "MXll",
	"./bg.js": "MXll",
	"./bm": "4Jo/",
	"./bm.js": "4Jo/",
	"./bn": "q3h0",
	"./bn-bd": "3rr0",
	"./bn-bd.js": "3rr0",
	"./bn.js": "q3h0",
	"./bo": "QCdV",
	"./bo.js": "QCdV",
	"./br": "IIFO",
	"./br.js": "IIFO",
	"./bs": "zQix",
	"./bs.js": "zQix",
	"./ca": "Vy5Q",
	"./ca.js": "Vy5Q",
	"./cs": "pa73",
	"./cs.js": "pa73",
	"./cv": "mGGY",
	"./cv.js": "mGGY",
	"./cy": "MfNp",
	"./cy.js": "MfNp",
	"./da": "ZUXn",
	"./da.js": "ZUXn",
	"./de": "Ua4b",
	"./de-at": "FFGI",
	"./de-at.js": "FFGI",
	"./de-ch": "WjSt",
	"./de-ch.js": "WjSt",
	"./de.js": "Ua4b",
	"./dv": "rNIS",
	"./dv.js": "rNIS",
	"./el": "QBOh",
	"./el.js": "QBOh",
	"./en-au": "6cl0",
	"./en-au.js": "6cl0",
	"./en-ca": "RUPB",
	"./en-ca.js": "RUPB",
	"./en-gb": "55LC",
	"./en-gb.js": "55LC",
	"./en-ie": "n2M6",
	"./en-ie.js": "n2M6",
	"./en-il": "LKLu",
	"./en-il.js": "LKLu",
	"./en-in": "7YSY",
	"./en-in.js": "7YSY",
	"./en-nz": "31pW",
	"./en-nz.js": "31pW",
	"./en-sg": "FtGx",
	"./en-sg.js": "FtGx",
	"./eo": "Djdb",
	"./eo.js": "Djdb",
	"./es": "lPS+",
	"./es-do": "/93R",
	"./es-do.js": "/93R",
	"./es-mx": "LISF",
	"./es-mx.js": "LISF",
	"./es-us": "HMWX",
	"./es-us.js": "HMWX",
	"./es.js": "lPS+",
	"./et": "w4Ej",
	"./et.js": "w4Ej",
	"./eu": "GsJe",
	"./eu.js": "GsJe",
	"./fa": "8KcV",
	"./fa.js": "8KcV",
	"./fi": "/W3k",
	"./fi.js": "/W3k",
	"./fil": "3Fw0",
	"./fil.js": "3Fw0",
	"./fo": "VKzE",
	"./fo.js": "VKzE",
	"./fr": "na3A",
	"./fr-ca": "W+OR",
	"./fr-ca.js": "W+OR",
	"./fr-ch": "AcXd",
	"./fr-ch.js": "AcXd",
	"./fr.js": "na3A",
	"./fy": "5tOq",
	"./fy.js": "5tOq",
	"./ga": "9yNy",
	"./ga.js": "9yNy",
	"./gd": "yau+",
	"./gd.js": "yau+",
	"./gl": "8RbZ",
	"./gl.js": "8RbZ",
	"./gom-deva": "/3Xl",
	"./gom-deva.js": "/3Xl",
	"./gom-latn": "ZRMZ",
	"./gom-latn.js": "ZRMZ",
	"./gu": "0ThR",
	"./gu.js": "0ThR",
	"./he": "nZxk",
	"./he.js": "nZxk",
	"./hi": "1Hgm",
	"./hi.js": "1Hgm",
	"./hr": "pMtw",
	"./hr.js": "pMtw",
	"./hu": "K+Bq",
	"./hu.js": "K+Bq",
	"./hy-am": "6C2N",
	"./hy-am.js": "6C2N",
	"./id": "efTX",
	"./id.js": "efTX",
	"./is": "tren",
	"./is.js": "tren",
	"./it": "ZIl9",
	"./it-ch": "1C8g",
	"./it-ch.js": "1C8g",
	"./it.js": "ZIl9",
	"./ja": "/yMT",
	"./ja.js": "/yMT",
	"./jv": "GkPv",
	"./jv.js": "GkPv",
	"./ka": "gSIj",
	"./ka.js": "gSIj",
	"./kk": "iVlB",
	"./kk.js": "iVlB",
	"./km": "NOsM",
	"./km.js": "NOsM",
	"./kn": "I8Ml",
	"./kn.js": "I8Ml",
	"./ko": "IcKm",
	"./ko.js": "IcKm",
	"./ku": "KkcH",
	"./ku-kmr": "lV2Y",
	"./ku-kmr.js": "lV2Y",
	"./ku.js": "KkcH",
	"./ky": "YOt9",
	"./ky.js": "YOt9",
	"./lb": "0j/n",
	"./lb.js": "0j/n",
	"./lo": "T9zp",
	"./lo.js": "T9zp",
	"./lt": "g+lf",
	"./lt.js": "g+lf",
	"./lv": "6Clp",
	"./lv.js": "6Clp",
	"./me": "R+Ou",
	"./me.js": "R+Ou",
	"./mi": "OpoE",
	"./mi.js": "OpoE",
	"./mk": "ajTF",
	"./mk.js": "ajTF",
	"./ml": "WKpT",
	"./ml.js": "WKpT",
	"./mn": "AjkR",
	"./mn.js": "AjkR",
	"./mr": "zEHP",
	"./mr.js": "zEHP",
	"./ms": "AkRI",
	"./ms-my": "DSsE",
	"./ms-my.js": "DSsE",
	"./ms.js": "AkRI",
	"./mt": "6JVy",
	"./mt.js": "6JVy",
	"./my": "WxtM",
	"./my.js": "WxtM",
	"./nb": "c8be",
	"./nb.js": "c8be",
	"./ne": "k5XK",
	"./ne.js": "k5XK",
	"./nl": "d4wU",
	"./nl-be": "J1JU",
	"./nl-be.js": "J1JU",
	"./nl.js": "d4wU",
	"./nn": "3df9",
	"./nn.js": "3df9",
	"./oc-lnc": "IfvP",
	"./oc-lnc.js": "IfvP",
	"./pa-in": "bDo5",
	"./pa-in.js": "bDo5",
	"./pl": "SjKL",
	"./pl.js": "SjKL",
	"./pt": "VmO7",
	"./pt-br": "eKtN",
	"./pt-br.js": "eKtN",
	"./pt.js": "VmO7",
	"./ro": "ZwMP",
	"./ro.js": "ZwMP",
	"./ru": "Nkck",
	"./ru.js": "Nkck",
	"./sd": "6rHi",
	"./sd.js": "6rHi",
	"./se": "xjAv",
	"./se.js": "xjAv",
	"./si": "jlAV",
	"./si.js": "jlAV",
	"./sk": "Tlvf",
	"./sk.js": "Tlvf",
	"./sl": "k99j",
	"./sl.js": "k99j",
	"./sq": "5nMm",
	"./sq.js": "5nMm",
	"./sr": "X1WW",
	"./sr-cyrl": "l4vP",
	"./sr-cyrl.js": "l4vP",
	"./sr.js": "X1WW",
	"./ss": "GtRf",
	"./ss.js": "GtRf",
	"./sv": "riyl",
	"./sv.js": "riyl",
	"./sw": "kgT8",
	"./sw.js": "kgT8",
	"./ta": "K9qr",
	"./ta.js": "K9qr",
	"./te": "QrmC",
	"./te.js": "QrmC",
	"./tet": "2eJA",
	"./tet.js": "2eJA",
	"./tg": "KEwn",
	"./tg.js": "KEwn",
	"./th": "2WF3",
	"./th.js": "2WF3",
	"./tk": "uQ8+",
	"./tk.js": "uQ8+",
	"./tl-ph": "6gV9",
	"./tl-ph.js": "6gV9",
	"./tlh": "GXjm",
	"./tlh.js": "GXjm",
	"./tr": "q3Y/",
	"./tr.js": "q3Y/",
	"./tzl": "pUvX",
	"./tzl.js": "pUvX",
	"./tzm": "7iew",
	"./tzm-latn": "TqSm",
	"./tzm-latn.js": "TqSm",
	"./tzm.js": "7iew",
	"./ug-cn": "7pby",
	"./ug-cn.js": "7pby",
	"./uk": "Vres",
	"./uk.js": "Vres",
	"./ur": "fzp4",
	"./ur.js": "fzp4",
	"./uz": "ZqEW",
	"./uz-latn": "0+1E",
	"./uz-latn.js": "0+1E",
	"./uz.js": "ZqEW",
	"./vi": "O+YH",
	"./vi.js": "O+YH",
	"./x-pseudo": "Q80Y",
	"./x-pseudo.js": "Q80Y",
	"./yo": "ezHV",
	"./yo.js": "ezHV",
	"./zh-cn": "JXJ4",
	"./zh-cn.js": "JXJ4",
	"./zh-hk": "eiOV",
	"./zh-hk.js": "eiOV",
	"./zh-mo": "qgB4",
	"./zh-mo.js": "qgB4",
	"./zh-tw": "moAe",
	"./zh-tw.js": "moAe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "losD";

/***/ }),

/***/ "lviy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('dateFormat', function (value) {
  var onlyDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (value) {
    if (onlyDate) return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(value)).format('DD-MM-YYYY');else return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(value)).format('DD-MM-YYYY HH:mm');
  }
  return ' ';
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('timeFormat', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(value)).format('HH:mm');
  }
  return ' ';
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('year', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(value)).year().toString();
  }
  return ' ';
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('text', function (value, max) {
  if (value) {
    var len = max ? max : 100;
    return value.substr(0, len) + (value.length > len ? "..." : "");
  }
  return ' ';
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('string', function (value) {
  if (value) {
    return value + '';
  }
  return ' ';
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('uppercase', function (value) {
  if (value) {
    return value.toUpperCase();
  }
  return ' ';
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('lowercase', function (value) {
  if (value) {
    return value.toLowerCase();
  }
  return ' ';
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('currency', function (value) {
  if (value) {
    var val = (value / 1).toFixed(2).replace(',', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return ' -';
});

/***/ }),

/***/ "lyMx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mBkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_OtrosIngresos_vue__ = __webpack_require__("1s+0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1892fa5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_OtrosIngresos_vue__ = __webpack_require__("ifEL");
function injectStyle (ssrContext) {
  __webpack_require__("t4Go")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_OtrosIngresos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1892fa5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_OtrosIngresos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mX1+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mXm/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    var _ref;

    return _ref = {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,
      monedas: [],
      plazos: [],
      actividades: [],
      sectores: null,
      n_domicilio: null
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "monedas", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "entidadFed", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "municipios", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidades", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidad", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "paises", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isnum", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "item_actividades", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "list_actividades", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fields_list", [{
      key: "acciones",
      label: "Acciones",
      tdClass: "text-center"
    }, {
      key: "nombre_denominacion_razon_social",
      label: "Denominación o razón social",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "rfc",
      label: "RFC",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "curp",
      label: "CURP",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "sector_industria_id",
      label: "Sector",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "tipo_actividad_servicio_id",
      label: "Tipo de actividad ",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "descripcion_actividad_servicio",
      label: "Descripción de la actividad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "ingreso_bruto_anual",
      label: "Ingreso bruto anual ",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "moneda_id",
      label: "Moneda",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "duracion_frecuencia",
      label: "Duración / Frecuencia",
      tdClass: "text-center",
      formatter: 'emptyFields'
    }, {
      key: "unidad_temporal_id",
      label: "Unidad temporal",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "fecha_transaccion",
      label: "Fecha de transacción",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "observaciones",
      label: "Observaciones",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "pais_id",
      label: "País",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "entidad_federativa_id",
      label: "Entidad federativa",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "municipio_id",
      label: "Municipio",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "localidad_id",
      label: "Localidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "colonia",
      label: "Colonia",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_tipo_vial",
      label: "Tipo vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_nom_vial",
      label: "Nombre vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "cp",
      label: "CP",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numExt",
      label: "Número exterior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numInt",
      label: "Número interior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }]), _ref;
  },

  computed: {
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.item_actividades.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.item_actividades.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {
    list_actividades: {
      handler: function handler() {
        if (this.list_actividades) {
          this.setLocalidades();
          if (this.list_actividades.length == 0) {
            this.bandera = '0';
          } else {
            this.bandera = '1';
          }
        }
      },
      deep: true
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_actividades.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_actividades.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_actividades.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_actividades.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_actividades.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_actividades.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_actividades.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_actividades.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_actividades.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_actividades.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    }
  },
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMoneda: function getMoneda(index) {
      var resp = "";
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getActividad: function getActividad(index) {
      var resp = " ";
      if (this.sectores) {
        this.actividades.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUnidades: function getUnidades(index) {
      var resp = " ";
      if (this.plazos) {
        this.plazos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: '',
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
      this.item_actividades = {
        acciones: "",
        rfc_quien_adquirio: "",
        ingreso_bruto_anual: "",
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: "",
        entidad_federativa_id: "",
        municipio_id: "",
        localidad_id: "",
        colonia: "",
        cp: "",
        numExt: "",
        numInt: "",
        vialidad_nom_vial: "",
        vialidad_tipo_vial: "",
        observaciones: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      if (this.item_actividades) {
        this.item_actividades.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post("actividades_profecionales", this.item_actividades).then(function (response) {
          _this.StepOk("Guardado");
          if (_this.edit_item === undefined || _this.edit_item === null) {
            _this.list_actividades.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.actividad));
          } else {
            _this.list_actividades.splice(_this.edit_item.index, 1, _this.item_actividades);
            _this.edit_item.item._rowVariant = "";
          }
          _this.showItem();
          _this.initItem();
          _this.edit_item = null;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW("Hay campos sin completar");
      }
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_actividades = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_actividades[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_actividades[indice].id !== null) {
        var item = this.list_actividades[indice];

        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("actividades_profecionales/" + item.id).then(function (response) {
            _this2.list_actividades.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_actividades.pais_id ? this.item_actividades.pais_id : 150;
      this.n_domicilio.entidadF = this.item_actividades.entidad_federativa_id ? this.item_actividades.entidad_federativa_id : '';
      this.n_domicilio.municipio = this.item_actividades.municipio_id ? this.item_actividades.municipio_id : '';
      this.n_domicilio.localidad = this.item_actividades.localidad_id ? this.item_actividades.localidad_id : '';
      this.n_domicilio.cp = this.item_actividades.cp ? this.item_actividades.cp : '';
      this.n_domicilio.colonia = this.item_actividades.colonia ? this.item_actividades.colonia : '';
      this.n_domicilio.vialidad = this.item_actividades.vialidad_tipo_vial ? this.item_actividades.vialidad_tipo_vial : '';
      this.n_domicilio.vialidad_nombre = this.item_actividades.vialidad_nom_vial ? this.item_actividades.vialidad_nom_vial : '';
      this.n_domicilio.ext = this.item_actividades.numExt ? this.item_actividades.numExt : '';
      this.n_domicilio.int = this.item_actividades.numInt ? this.item_actividades.numInt : '';
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      this.list_actividades.forEach(function (item) {
        if (item.localidad_id) {
          _this3.$http.get('localidades/localidad/' + item.localidad_id).then(function (response) {
            _this3.localidades.push(response.data.localidad);
          }, function (error) {
            _this3.Err(error);
          });
        }
      });
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("actividades_profecionales/" + this.ip_id).then(function (response) {
      _this4.list_actividades = response.data.actividades;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_unidad_medida_plazo").then(function (response) {
      _this4.plazos = response.data.unidades;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_actividad").then(function (response) {
      _this4.actividades = response.data.actividad;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("monedas").then(function (response) {
      _this4.monedas = response.data.monedas;
      var temp = "97";
      _this4.monedas.forEach(function (item) {
        if (item.codigo == "MXN") {
          temp = item.id;
        }
      });
      _this4.item_actividades.moneda_id = temp;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "mf5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Aclaraciones_vue__ = __webpack_require__("HKXU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_25092632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Aclaraciones_vue__ = __webpack_require__("/R45");
function injectStyle (ssrContext) {
  __webpack_require__("xSWu")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Aclaraciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_25092632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Aclaraciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "miw9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_DatosCurriculares_vue__ = __webpack_require__("B27g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb31b5da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_DatosCurriculares_vue__ = __webpack_require__("u9j9");
function injectStyle (ssrContext) {
  __webpack_require__("xsqu")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_DatosCurriculares_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb31b5da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_DatosCurriculares_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mvdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_StatsCard2_vue__ = __webpack_require__("ARNM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_chartist_plugin_tooltips__ = __webpack_require__("pZqB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_chartist_plugin_tooltips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_chartist_plugin_tooltips__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_chartist__ = __webpack_require__("c83R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_chartist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_google_charts__ = __webpack_require__("/yvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");











var _components;


















/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'FormWizard', __WEBPACK_IMPORTED_MODULE_19_vue_form_wizard__["FormWizard"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'TabContent', __WEBPACK_IMPORTED_MODULE_19_vue_form_wizard__["TabContent"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'StatsCard', __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'StatsCard2', __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_StatsCard2_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CircleChartCard', __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GChart', __WEBPACK_IMPORTED_MODULE_18_vue_google_charts__["GChart"]), _components),
  data: function data() {
    return {
      $Chartist: null,
      chartData: [["Años", "Activos", "Pasivos"], ["2019", 0, 0]],
      chartOptions: {
        chart: {
          title: 'Gráfica de evolución de ingresos y egresos'
        },
        width: "90%",
        height: 500,
        title: "Gráfica de evolución de ingresos y egresos",
        series: {
          0: {
            color: "#68B3C8"
          },
          1: {
            color: "#7AC29A"
          }
        },
        pointSize: 8
      },
      porcentaje: 0,
      declaraciones: '',
      obligados: '',
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        periodo: '2020'
      },
      min: 0,
      max: 0,
      dependencias: {},
      rol: '',
      filter: '',
      nombre: '',
      activo: null,
      alta: '',
      baja: '',
      entidad: '',
      filter2: '',
      graf_load: '',
      datacollection: null,
      loading_bar: false,
      shhistorico: false,
      shlista: true,
      balanza: false,
      currentPage: 1,
      grafica: [],
      table_list: [],
      table_list1: [],
      ingresos: [],
      informacion_personal: [],
      encargo: {},
      bienes_inmuebles: [],
      bienes_muebles_no_registrables: [],
      bienes_muebles_registrables: [],
      pasivos_deudas: [],
      totalpendiente: [],
      datos_encargo_actual: [],
      datosDeclaracion: [],
      spublicos: [],
      spublicosant: [],
      totalingresos: [],
      totalingresosant: [],
      dato: [],
      otross: [],
      binmuebles: [],
      totalbinmuebles: [],
      bmuebles: [],
      totalbmuebles: [],
      bmueblesnr: [],
      totalbmueblesnr: [],
      inversioness: [],
      totalinversiones: [],
      pasivos: [],
      inversionesad: [],
      totalmontooriginal: [],
      totalpasivos: [],
      totalactivos: [],
      totalactivosant: [],
      totalbalanza: [],
      totalbalanzaant: [],
      perPage: 50,
      periodos: [],
      rows: null,
      tiposDeclaracion: [{
        'id': 1,
        'tipo_declaracion': 'Inicial'
      }, {
        'id': 2,
        'tipo_declaracion': 'Anual'
      }, {
        'id': 3,
        'tipo_declaracion': 'Final'
      }],
      list_cumplimiento: [],
      expanded: [],
      singleExpand: true,
      filtro_usuarios: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      headers3: [{
        text: '',
        value: 'name',
        align: 'center',
        class: ''
      }, {
        text: 'DECLARANTE',
        value: 'calories',
        align: 'center',
        class: '',
        width: "200px"
      },, {
        text: 'CONYUGUE',
        value: 'fat',
        align: 'center',
        class: '',
        width: "200px"
      }, {
        text: 'CORRESPONSABLES',
        value: 'carbs',
        align: 'center',
        class: '',
        width: "200px"
      }],
      desserts: [{
        name: 'Sueldos',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      }, {
        name: 'Honorarios',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      }, {
        name: 'Otros',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      }, {
        name: 'Inmuebles',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      }, {
        name: 'Muebles',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      }, {
        name: 'Vehiculos',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      }, {
        name: 'Iversiones',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      }, {
        name: 'Adeudos',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      }],
      headers2: [{
        text: 'Ver Balanza',
        align: 'left',
        sortable: false,
        value: 'acciones',
        class: '',
        width: "100px"
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Tipo',
        value: 'Tipo_Dec',
        align: 'right',
        class: ''
      }, {
        text: 'Fecha de Presentación',
        value: 'anio',
        align: 'center',
        class: '',
        width: "200px"
      }],
      headers: [{
        text: 'Ver',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Cargo',
        value: 'cargo',
        align: 'center'
      }],

      propsToSearch: ['rfc', 'nombres'],
      tableColumns: [{
        prop: 'id',
        label: 'Dec',
        minWidth: 150,
        vif: false
      }, {
        prop: 'rfc',
        label: 'RFC',
        minWidth: 150,
        vif: true
      }, {
        prop: 'nombres',
        label: 'Nombre',
        minWidth: 100,
        vif: true
      }]
    };
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    openCity: function openCity(evt, cityName) {
      var i, tabcontent, tablinks;

      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " active";
    },

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_20_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    dateFormat2: function dateFormat2(date) {
      return __WEBPACK_IMPORTED_MODULE_20_moment___default()(date, 'DD-MM-YYYY').format('DD/MM/YYYY');
    },
    dateFormat3: function dateFormat3(date) {
      return __WEBPACK_IMPORTED_MODULE_20_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
    },
    checkPermissions: function checkPermissions() {
      var permiso = [1];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getEntidad: function getEntidad(item) {
      return JSON.parse(item.datos_encargo_actual)[0].ente.valor;
    },
    getFechaPos: function getFechaPos(item) {
      return this.dateFormat2(JSON.parse(item.datos_encargo_actual)[0].fecha_posesion);
    },
    getCargo: function getCargo(item) {
      return JSON.parse(item.datos_encargo_actual)[0].empleo_cargo_comision;
    },
    getDependencias: function getDependencias() {
      var _this = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this.dependencias = response.data.entes_publicos;
        _this.dependencias.unshift({
          'codigo': 'T',
          'id': 0,
          'valor': 'Todas'
        });
        _this.model.dependencia_id = _this.getKey('ente_publico_id');
      }, function (error) {
        _this.StepError(error);
      });
    },
    getPeriodos: function getPeriodos() {
      var _this2 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this2.periodos = response.data.periodos;
      }, function (error) {
        _this2.StepError(error);
      });
    },
    descargaFiscal: function descargaFiscal(file) {
      var obj = JSON.parse(file);
      if (obj[0]) {
        var url = this.$rootUrl + '/declaraciones_fiscales/' + obj[0].file;
        window.open(url, '_blank');
      } else {
        this.StepW("No tiene declaración fiscal");
      }
    },
    getDeclaraciones: function getDeclaraciones() {
      var _this3 = this;

      this.loading_bar = true;
      this.filtro_usuarios = [];
      this.$http.post("hdeclaraciones", this.model).then(function (response) {
        _this3.list_cumplimiento = [];
        response.data.declarantes.forEach(function (value, key) {
          _this3.list_cumplimiento.push({
            'id': value.id,
            'rfc': value.rfc,
            'nombres': value.nombre,
            'entidad': value.entidad,
            'area': value.area,
            'cargo': value.cargo,
            'activo': value.activo,
            'alta': value.alta,
            'baja': value.baja
          });
          _this3.loading_bar = false;
        });
        _this3.filtro_usuarios = _this3.list_cumplimiento;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    descargar: function descargar(row) {
      var _this4 = this;

      this.$http.get(this.$rootUrl + 'getDeclaracion1/pdf/' + row.declaracion_id + "/" + this.getKey('uid'), {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this4.downloadFile(response, 'Declaración');
      }, function (error) {
        _this4.StepError(error);
      });
    },
    downloadFile: function downloadFile(response, filename) {
      var newBlob = new Blob([response.body], {
        type: 'application/pdf'
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      var data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = data;
      link.download = filename + '.pdf';
      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    historico: function historico(row) {
      var _this5 = this;

      this.shlista = false;
      this.shhistorico = true;
      this.balanza = false;
      this.nombre = row.rfc;
      this.activo = row.activo;
      this.alta = this.dateFormat(row.alta);
      this.baja = this.dateFormat(row.baja);
      this.entidad = row.entidad;
      this.table_list = [];
      this.$http.get("historicolst/" + row.id).then(function (response) {
        _this5.table_list = response.data.response;
      }, function (error) {
        _this5.Err(error);
      });
    },
    historico1: function historico1(row) {
      var _this6 = this;

      this.shlista = false;
      this.shhistorico = false;
      this.balanza = true;

      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        title: 'Alerta',
        text: 'Esta información es confidencial y tu acceso ha sido registrado por políticas de seguridad.',
        type: 'warning',
        confirmButtonClass: 'btn btn-success btn-fill',
        buttonsStyling: false
      });
      this.chartData = [["Años", "Activos", "Pasivos"], ["2019", 0, 0]];
      this.resetTableData();
      this.$http.get("generaleslst/" + row.declaracion_id).then(function (response) {
        _this6.datosDeclaracion = response.data.datosDeclaracion;
        _this6.informacion_personal = response.data.dpersonales;
        _this6.datos_encargo_actual = response.data.dencargo;
        _this6.spublicos = response.data.spublicos;
        _this6.spublicosant = response.data.spublicosant;
        _this6.totalingresos = response.data.totalingresos;
        _this6.totalingresosant = response.data.totalingresosant;
        _this6.otross = response.data.otross;
        _this6.binmuebles = response.data.binmuebles;
        _this6.totalbinmuebles = response.data.totalbinmuebles;
        _this6.bmuebles = response.data.bmuebles;
        _this6.totalbmuebles = response.data.totalbmuebles;
        _this6.bmueblesnr = response.data.bmueblesnr;
        _this6.totalbmueblesnr = response.data.totalbmueblesnr;
        _this6.inversioness = response.data.inversiones;
        _this6.totalinversiones = response.data.totalinversiones;
        _this6.pasivos = response.data.pasivos;
        _this6.totalpendiente = response.data.totalpendiente;
        _this6.inversionesad = response.data.inversionesad;
        _this6.totalmontooriginal = response.data.totalmontooriginal;
        _this6.totalpasivos = response.data.totalpasivos;
        _this6.totalactivos = response.data.totalactivos;
        _this6.totalactivosant = response.data.totalactivosant;
        _this6.totalbalanza = response.data.totalbalanza;
        _this6.totalbalanzaant = response.data.totalbalanzaant;
        _this6.grafica = response.data.grafica;
        _this6.max = response.data.max;

        _this6.fillData();
      }, function (error) {
        _this6.Err(error);
      });
    },
    resetTableData: function resetTableData() {
      this.datosDeclaracion = [];
      this.informacion_personal = [];
      this.datos_encargo_actual = [];
      this.spublicos = [];
      this.spublicosant = [];
      this.totalingresos = [];
      this.totalingresosant = [];
      this.otross = [];
      this.binmuebles = [];
      this.totalbinmuebles = [];
      this.bmuebles = [];
      this.totalbmuebles = [];
      this.bmueblesnr = [];
      this.totalbmueblesnr = [];
      this.inversioness = [];
      this.totalinversiones = [];
      this.pasivos = [];
      this.totalpendiente = [];
      this.inversionesad = [];
      this.totalmontooriginal = [];
      this.totalpasivos = [];
      this.totalactivos = [];
      this.totalactivosant = [];
      this.totalbalanza = [];
      this.totalbalanzaant = [];
      this.grafica = [];
      this.max = [];
    },
    regresar: function regresar(row) {
      this.shlista = true;
      this.shhistorico = false;
      this.balanza = false;
    },
    regresar1: function regresar1(row) {
      this.shlista = false;
      this.shhistorico = true;
      this.balanza = false;
    },
    fillData: function fillData() {

      this.chartData = [["Años", "Activos", "Pasivos"], ["2019", 0, 0]];

      var datos = [['Años', 'Activos', 'Pasivos']];

      this.grafica.forEach(function (d) {
        datos.push([d.anio.toString(), d.activos, d.pasivos]);
      });
      this.chartData = datos;
    },
    getDatos: function getDatos() {
      var _this7 = this;

      this.$http.get("tableroGlobales").then(function (response) {
        _this7.faltantes = _this7.group1k(response.data.faltantes);
        _this7.declaraciones = _this7.group1k(response.data.declaraciones);
        _this7.obligados = _this7.group1k(response.data.declarantes);
        _this7.porcentaje = parseFloat(response.data.porcentaje.toString().substring(0, 5));
        _this7.rinicial = _this7.group1k(response.data.dinic);
        _this7.rfinal = _this7.group1k(response.data.dfin);
        _this7.ranual = _this7.group1k(response.data.danu);
        _this7.faltantesIn = _this7.group1k(response.data.decIni - response.data.dinic);
        _this7.faltantesAn = _this7.group1k(response.data.decAn - response.data.danu);
        _this7.faltantesFi = _this7.group1k(response.data.decFin - response.data.dfin);
        _this7.obligadosIn = _this7.group1k(response.data.decIni);
        _this7.obligadosAn = _this7.group1k(response.data.decAn);
        _this7.obligadosFi = _this7.group1k(response.data.decFin);
      }, function (error) {
        _this7.StepError(error);
      });
    },
    cumplimiento: function cumplimiento() {
      this.$router.push('/reportes/cumplimiento');
    },
    getEstadosC: function getEstadosC(index) {
      var resp = " ";
      if (this.estadosCi) {
        this.estadosCi.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            console.log(resp);
            return resp;
          }
        });
      }
    },
    getEstados: function getEstados(index) {
      var resp = " ";
      if (this.estados) {
        this.estados.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            console.log(resp);
            return resp;
          }
        });
      }
    },
    getCiudades: function getCiudades(index) {
      var resp = " ";
      if (this.ciudades) {
        this.ciudades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            console.log(resp);
            return resp;
          }
        });
      }
    }
  },
  created: function created() {
    var _this8 = this;

    this.getDependencias();
    this.getPeriodos();
    this.rol = this.getKey('role');
    this.checkPermissions();

    this.$http.get('edocivil').then(function (response) {
      _this8.estadosCi = response.data.estadoCivil;
    }, function (error) {
      _this8.Err(error);
      console.log(error);
    });

    this.$http.get('entidadFed').then(function (response) {
      _this8.estados = response.data.entidadfed;
    }, function (error) {
      _this8.Err(error);
      console.log(error);
    });

    this.$http.get('municipios').then(function (response) {
      _this8.ciudades = response.data.municipios;
    }, function (error) {
      _this8.Err(error);
      console.log(error);
    });
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "nEeR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nO5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesPrincipales_vue__ = __webpack_require__("ykVy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_61da80be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesPrincipales_vue__ = __webpack_require__("30hj");
function injectStyle (ssrContext) {
  __webpack_require__("P6FX")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesPrincipales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_61da80be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesPrincipales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nV12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition"},scopedSlots:_vm._u([{key:"default",fn:function(dialog){return [_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),_c('v-card-text',{staticClass:"border-top"},[_c(_vm.modalComponent,{key:'tipo_dec'+_vm.modalData.id,tag:"component",attrs:{"data":_vm.modalData}})],1),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-end border-top"},[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){dialog.value = false}}},[_vm._v("Cerrar")])],1)],1)]}}]),model:{value:(_vm.intDialogVisible),callback:function ($$v) {_vm.intDialogVisible=$$v},expression:"intDialogVisible"}}),_vm._v(" "),_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),(_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('h5',{staticClass:"ml-3 mb-4"},[_vm._v("Acciones a realizar en: "),_c('strong',[_vm._v(_vm._s(_vm.form_item.nombres+" "+_vm.form_item.primer_apellido+' '+ _vm.form_item.segundo_apellido))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.getKey('permisos').includes(17))?_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Seleccione el movimiento a realizar")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Selecciona una opción"},model:{value:(_vm.tipo_mov),callback:function ($$v) {_vm.tipo_mov=$$v},expression:"tipo_mov"}},_vm._l((_vm.selects.movimientos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.value,"label":option.label}})}),1)],1):_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Seleccione el movimiento a realizar")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Selecciona una opción"},model:{value:(_vm.tipo_mov),callback:function ($$v) {_vm.tipo_mov=$$v},expression:"tipo_mov"}},_vm._l((_vm.selects.movimientos2),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.value,"label":option.label}})}),1)],1)]),_vm._v(" "),(_vm.tipo_mov == 0)?_c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Seguro que desea desactivar este registro?")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.motivo),expression:"form_item.motivo"},{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.motivo),expression:"form_itemValidations.motivo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Motivos/Observaciones"},domProps:{"value":(_vm.form_item.motivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "motivo", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.motivo.invalid),expression:"motivo.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('motivo'))+"\n                ")])])])]):_vm._e(),_vm._v(" "),(_vm.tipo_mov ==2)?_c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Seguro que desea dar de baja este registro?")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de baja")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.fecha_termino),expression:"form_itemValidations.fecha_termino"}],attrs:{"picker-options":_vm.opciones,"type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha","name":"fecha_termino"},model:{value:(_vm.form_item.fecha_termino),callback:function ($$v) {_vm.$set(_vm.form_item, "fecha_termino", $$v)},expression:"form_item.fecha_termino"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.fecha_termino.invalid),expression:"fecha_termino.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('fecha_termino'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de baja")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.tipo_baja),expression:"form_itemValidations.tipo_baja"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"tipo_baja","placeholder":"Selecciona una opción"},model:{value:(_vm.form_item.tipo_baja),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_baja", $$v)},expression:"form_item.tipo_baja"}},[_c('el-option',{attrs:{"value":"Normal"}}),_vm._v(" "),_c('el-option',{attrs:{"value":"Por defunción"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_baja.invalid),expression:"tipo_baja.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('tipo_baja'))+"\n                ")])],1)])]):_vm._e(),_vm._v(" "),(_vm.tipo_mov == 4)?_c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v(" Crear licencia")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de inicio")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.inicia),expression:"form_itemValidations.inicia"}],attrs:{"type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","name":"inicia","placeholder":"Seleccione fecha"},model:{value:(_vm.form_item.inicia),callback:function ($$v) {_vm.$set(_vm.form_item, "inicia", $$v)},expression:"form_item.inicia"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicia.invalid),expression:"inicia.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('inicia'))+"\n                  ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de Fin")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.termina),expression:"form_itemValidations.termina"}],attrs:{"type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","name":"termina","placeholder":"Seleccione fecha"},model:{value:(_vm.form_item.termina),callback:function ($$v) {_vm.$set(_vm.form_item, "termina", $$v)},expression:"form_item.termina"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.termina.invalid),expression:"termina.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('termina'))+"\n                  ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de licencia")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.tipo_licencia),expression:"form_itemValidations.tipo_licencia"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"tipo_licencia","placeholder":"Selecciona una opción"},model:{value:(_vm.form_item.tipo_licencia),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_licencia", $$v)},expression:"form_item.tipo_licencia"}},[_c('el-option',{attrs:{"value":"Médica"}}),_vm._v(" "),_c('el-option',{attrs:{"value":"Trabajo"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipo_licencia.invalid),expression:"tipo_licencia.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('tipo_licencia'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.motivo),expression:"form_item.motivo"},{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.motivo),expression:"form_itemValidations.motivo"}],staticClass:"form-control",attrs:{"type":"text","name":"motivo","placeholder":"Motivos/Observaciones"},domProps:{"value":(_vm.form_item.motivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "motivo", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.motivo.invalid),expression:"motivo.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('motivo'))+"\n                ")])])])]):_vm._e(),_vm._v(" "),(_vm.tipo_mov == 3)?_c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v(" Crear Promoción")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre(s)")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.nombres),expression:"form_itemValidations.nombres"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombres),expression:"form_item.nombres"}],staticClass:"form-control",attrs:{"type":"text","name":"nombres","readonly":"","placeholder":"Nombre(s)"},domProps:{"value":(_vm.form_item.nombres)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombres", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombres.invalid),expression:"nombres.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('nombres'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Apellido Paterno")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.primer_apellido),expression:"form_itemValidations.primer_apellido"},{name:"model",rawName:"v-model",value:(_vm.form_item.primer_apellido),expression:"form_item.primer_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"primer_apellido","readonly":"","placeholder":"Especificar"},domProps:{"value":(_vm.form_item.primer_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "primer_apellido", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.primer_apellido.invalid),expression:"primer_apellido.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('primer_apellido'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Apellido Materno")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.segundo_apellido),expression:"form_item.segundo_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"segundo_apellido","readonly":"","placeholder":"Especificar"},domProps:{"value":(_vm.form_item.segundo_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "segundo_apellido", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Cargo funcional")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.direccion_cargo),expression:"form_itemValidations.direccion_cargo"},{name:"model",rawName:"v-model",value:(_vm.form_item.cargo),expression:"form_item.cargo"}],staticClass:"form-control",attrs:{"type":"text","name":"direccion_cargo","placeholder":"Cargo"},domProps:{"value":(_vm.form_item.cargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "cargo", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.direccion_cargo.invalid),expression:"direccion_cargo.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('direccion_cargo'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Área de adscripción")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.area_adscripcion),expression:"form_itemValidations.area_adscripcion"},{name:"model",rawName:"v-model",value:(_vm.form_item.area),expression:"form_item.area"}],staticClass:"form-control",attrs:{"type":"text","name":"area_adscripcion","placeholder":"Área de adscripción"},domProps:{"value":(_vm.form_item.area)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "area", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.area_adscripcion.invalid),expression:"area_adscripcion.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('area_adscripcion'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nivel tabular")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.nivel),expression:"form_itemValidations.nivel"},{name:"model",rawName:"v-model",value:(_vm.form_item.nivel),expression:"form_item.nivel"}],staticClass:"form-control",attrs:{"type":"text","name":"nivel","placeholder":"Nivel tabular"},domProps:{"value":(_vm.form_item.nivel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nivel", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nivel.invalid),expression:"nivel.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('nivel'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de término del cargo anterior")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.fecha_termino),expression:"form_itemValidations.fecha_termino"}],attrs:{"type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha","name":"fecha_termino"},model:{value:(_vm.form_item.fecha_termino),callback:function ($$v) {_vm.$set(_vm.form_item, "fecha_termino", $$v)},expression:"form_item.fecha_termino"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.fecha_termino.invalid),expression:"fecha_termino.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('fecha_termino'))+"\n                  ")])],1)])])]):_vm._e(),_vm._v(" "),(_vm.tipo_mov == 5)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre(s)")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.nombres),expression:"form_itemValidations.nombres"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombres),expression:"form_item.nombres"}],staticClass:"form-control",attrs:{"type":"text","name":"nombres","placeholder":"Nombre(s)"},domProps:{"value":(_vm.form_item.nombres)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombres", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nombres.invalid),expression:"nombres.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('nombres'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Apellido Paterno")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.primer_apellido),expression:"form_itemValidations.primer_apellido"},{name:"model",rawName:"v-model",value:(_vm.form_item.primer_apellido),expression:"form_item.primer_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"primer_apellido","placeholder":"Especificar"},domProps:{"value":(_vm.form_item.primer_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "primer_apellido", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.primer_apellido.invalid),expression:"primer_apellido.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('primer_apellido'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Apellido Materno")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.segundo_apellido),expression:"form_item.segundo_apellido"}],staticClass:"form-control",attrs:{"type":"text","name":"segundo_apellido","placeholder":"Especificar"},domProps:{"value":(_vm.form_item.segundo_apellido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "segundo_apellido", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.rfc),expression:"form_itemValidations.rfc"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc),expression:"form_item.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.rfc.invalid),expression:"rfc.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('rfc'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("CURP")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.curp),expression:"form_itemValidations.curp"},{name:"model",rawName:"v-model",value:(_vm.form_item.curp),expression:"form_item.curp"}],staticClass:"form-control",attrs:{"type":"text","name":"curp","placeholder":"CURP"},domProps:{"value":(_vm.form_item.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "curp", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.curp.invalid),expression:"curp.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('curp'))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Dependencia")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.ente_publico_id),expression:"form_itemValidations.ente_publico_id"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"ente_publico_id"},model:{value:(_vm.form_item.ente_publico_id),callback:function ($$v) {_vm.$set(_vm.form_item, "ente_publico_id", $$v)},expression:"form_item.ente_publico_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.ente_publico_id.invalid),expression:"ente_publico_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('ente_publico_id'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Correo Electrónico Laboral\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.correo_laboral),expression:"form_itemValidations.correo_laboral"},{name:"model",rawName:"v-model",value:(_vm.form_item.correo_electronico_laboral),expression:"form_item.correo_electronico_laboral"}],staticClass:"form-control",attrs:{"type":"text","name":"correo_laboral","placeholder":"Correo Laboral"},domProps:{"value":(_vm.form_item.correo_electronico_laboral)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "correo_electronico_laboral", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.correo_laboral.invalid),expression:"correo_laboral.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('correo_laboral'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Empleo, Cargo o Comisión")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.direccion_cargo),expression:"form_itemValidations.direccion_cargo"},{name:"model",rawName:"v-model",value:(_vm.form_item.cargo),expression:"form_item.cargo"}],staticClass:"form-control",attrs:{"type":"text","name":"direccion_cargo","placeholder":"Dirección"},domProps:{"value":(_vm.form_item.cargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "cargo", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.direccion_cargo.invalid),expression:"direccion_cargo.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('direccion_cargo'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Contrato por honorarios")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.honorarios),expression:"form_itemValidations.honorarios"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","name":"honorarios"},model:{value:(_vm.form_item.contratado_honorarios),callback:function ($$v) {_vm.$set(_vm.form_item, "contratado_honorarios", $$v)},expression:"form_item.contratado_honorarios"}},[_c('el-option',{attrs:{"value":1,"label":"Si"}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":"No"}})],1),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.honorarios.invalid),expression:"honorarios.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('honorarios'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Nivel del Encargo")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.nivel),expression:"form_itemValidations.nivel"},{name:"model",rawName:"v-model",value:(_vm.form_item.nivel),expression:"form_item.nivel"}],staticClass:"form-control",attrs:{"type":"text","name":"nivel","placeholder":"Nivel tabular"},domProps:{"value":(_vm.form_item.nivel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nivel", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nivel.invalid),expression:"nivel.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('nivel'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Área de adscripción")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.area_adscripcion),expression:"form_itemValidations.area_adscripcion"},{name:"model",rawName:"v-model",value:(_vm.form_item.area),expression:"form_item.area"}],staticClass:"form-control",attrs:{"type":"text","name":"area_adscripcion","placeholder":"Área de adscripción"},domProps:{"value":(_vm.form_item.area)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "area", $event.target.value)}}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.area_adscripcion.invalid),expression:"area_adscripcion.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('area_adscripcion'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Fecha de toma de Posesión del empleo, cargo o comisión\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.fecha_posesion),expression:"form_itemValidations.fecha_posesion"}],attrs:{"value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","name":"fecha_posesion","picker-options":_vm.opciones,"type":"date","placeholder":"Selecciona"},model:{value:(_vm.form_item.fecha_posesion),callback:function ($$v) {_vm.$set(_vm.form_item, "fecha_posesion", $$v)},expression:"form_item.fecha_posesion"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.fecha_posesion.invalid),expression:"fecha_posesion.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('fecha_posesion'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Titular de la dependencia o entidad\n                ")]),_vm._v(" "),_c('p-radio',{attrs:{"name":"titular","label":"1"},model:{value:(_vm.form_item.titular),callback:function ($$v) {_vm.$set(_vm.form_item, "titular", $$v)},expression:"form_item.titular"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{attrs:{"name":"titular","label":"2"},model:{value:(_vm.form_item.titular),callback:function ($$v) {_vm.$set(_vm.form_item, "titular", $$v)},expression:"form_item.titular"}},[_vm._v("NO")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Tipo\n                ")]),_vm._v(" "),_c('p-radio',{attrs:{"name":"simp","label":"0"},model:{value:(_vm.form_item.simplificada),callback:function ($$v) {_vm.$set(_vm.form_item, "simplificada", $$v)},expression:"form_item.simplificada"}},[_vm._v("Completa")]),_vm._v(" "),_c('p-radio',{attrs:{"name":"simp","label":"1"},model:{value:(_vm.form_item.simplificada),callback:function ($$v) {_vm.$set(_vm.form_item, "simplificada", $$v)},expression:"form_item.simplificada"}},[_vm._v("Simplificada")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Motivo de corrección")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.motivo),expression:"form_item.motivo"},{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.motivo),expression:"form_itemValidations.motivo"}],staticClass:"form-control",attrs:{"type":"text","name":"motivo","placeholder":"Motivo de corrección"},domProps:{"value":(_vm.form_item.motivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "motivo", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.motivo.invalid),expression:"motivo.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('motivo'))+"\n                ")])])])]):_vm._e(),_vm._v(" "),(_vm.tipo_mov == 6)?_c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v(" Modificar contraseña")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|regex:^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$|min:8'),expression:"'required|regex:^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$|min:8'"},{name:"model",rawName:"v-model",value:(_vm.form_item.password),expression:"form_item.password"}],ref:"Password",staticClass:"form-control",attrs:{"type":"password","name":"Password","placeholder":"*****"},domProps:{"value":(_vm.form_item.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Confirmar contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:Password'),expression:"'required|confirmed:Password'"},{name:"model",rawName:"v-model",value:(_vm.form_item.Confirmar),expression:"form_item.Confirmar"}],staticClass:"form-control",attrs:{"type":"password","name":"Confirmar","placeholder":"*****"},domProps:{"value":(_vm.form_item.Confirmar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "Confirmar", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.any()),expression:"errors.any()"}],staticClass:"alert alert-danger ml-3"},[(_vm.errors.has('Password'))?_c('div',[_vm._v("\n                  La contraseña debe ser alfanumérica y de 8 caracteres mínimo\n                ")]):_vm._e(),_vm._v(" "),(_vm.errors.has('Confirmar'))?_c('div',[_c('span',{staticClass:"texto"},[_vm._v("Las contraseñas no coinciden")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.tipo_mov == 7)?_c('div',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.tipo_mov == 8)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Hacer declaración publica\n                ")]),_c('br'),_vm._v(" "),_c('p-radio',{attrs:{"name":"honorarios","label":"1"},model:{value:(_vm.form_item.publica),callback:function ($$v) {_vm.$set(_vm.form_item, "publica", $$v)},expression:"form_item.publica"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{attrs:{"name":"honorarios","label":"2"},model:{value:(_vm.form_item.publica),callback:function ($$v) {_vm.$set(_vm.form_item, "publica", $$v)},expression:"form_item.publica"}},[_vm._v("NO")])],1)])]):_vm._e(),_vm._v(" "),(_vm.tipo_mov == 9)?_c('div',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Razón de justificación")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.motivo),expression:"form_item.motivo"},{name:"validate",rawName:"v-validate",value:(_vm.form_itemValidations.motivo),expression:"form_itemValidations.motivo"}],staticClass:"form-control",attrs:{"type":"text","name":"motivo","placeholder":"Motivo de justificación"},domProps:{"value":(_vm.form_item.motivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "motivo", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.motivo.invalid),expression:"motivo.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('motivo'))+"\n                ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[(_vm.tipo_mov)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n              ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n              ")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(3)])]),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[(_vm.getKey('permisos').includes(17))?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('p-radio',{staticClass:"d-inline-block",attrs:{"name":"conest","label":"1"},model:{value:(_vm.tipobusqueda),callback:function ($$v) {_vm.tipobusqueda=$$v},expression:"tipobusqueda"}},[_vm._v("Dependencia")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"name":"conest","label":"2"},model:{value:(_vm.tipobusqueda),callback:function ($$v) {_vm.tipobusqueda=$$v},expression:"tipobusqueda"}},[_vm._v("General")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.list_declarantes2.length>0)?_c('export-excel',{staticClass:"btn btn-wd btn-success pull-right",attrs:{"data":_vm.list_declarantes2,"meta":_vm.meta,"fields":_vm.cumplidos_campos,"worksheet":"Padron","name":"Padron.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                  Descargar\n                ")]):_vm._e()],1),_vm._v(" "),(_vm.tipobusqueda=='2')?_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('label',[_vm._v("Buscar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Buscar"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}}),_vm._v(" "),(_vm.busqueda)?_c('small',{staticClass:"text-danger"},[_vm._v("La búsqueda requiere un mínimo de 4 letras")]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.tipobusqueda=='1')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('label',[_vm._v("Filtra por dependencia:")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción","disabled":_vm.isLoading},on:{"change":_vm.traetodo},model:{value:(_vm.filtro),callback:function ($$v) {_vm.filtro=$$v},expression:"filtro"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.filtrainici)?_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('label',[_vm._v("Filtra por inicial de RFC")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción"},on:{"change":_vm.traeiniciales},model:{value:(_vm.iniciales),callback:function ($$v) {_vm.iniciales=$$v},expression:"iniciales"}},_vm._l((_vm.inicialeslst),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('label',[_vm._v("Buscar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Buscar"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.getKey('permisos').includes(17))?_c('div',{staticClass:"row"},[(_vm.filtrainici)?_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('label',[_vm._v("Filtra por inicial de RFC")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Seleccione una opción"},on:{"change":_vm.traeiniciales},model:{value:(_vm.iniciales),callback:function ($$v) {_vm.iniciales=$$v},expression:"iniciales"}},_vm._l((_vm.inicialeslst),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('label',[_vm._v("Buscar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Buscar"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[(_vm.list_declarantes2.length>0)?_c('export-excel',{staticClass:"btn btn-wd btn-success pull-right",attrs:{"data":_vm.list_declarantes2,"meta":_vm.meta,"fields":_vm.cumplidos_campos,"worksheet":"Padron","name":"Padron.xls"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-file-excel"})]),_vm._v("\n                Descargar\n              ")]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"}),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.filtro_usuarios,"search":_vm.search,"items-per-page":5,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[((_vm.rol == 1))?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Tipo declaración'),expression:"'Tipo declaración'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"warning"},on:{"click":function($event){$event.preventDefault();return _vm.showTipoDec(item)}}},[_c('i',{staticClass:"fas fa-project-diagram"})]):_vm._e(),_vm._v(" "),(item.fecha_termino != null)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Reactivar usuario'),expression:"'Reactivar usuario'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"danger","disable":(_vm.rol != 1)},on:{"click":function($event){$event.preventDefault();return _vm.restore(item)}}},[_c('i',{staticClass:"fas fa-history"})]):_vm._e(),_vm._v(" "),(item.fecha_termino == null)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Editar datos de usuario'),expression:"'Editar datos de usuario'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"success","disabled":(_vm.edit_item != null) || (item.fecha_termino != null)},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]):_vm._e(),_vm._v(" "),(_vm.getKey('permisos').includes(4))?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Resetear contraseña'),expression:"'Resetear contraseña'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.resetpass(item)}}},[_c('i',{staticClass:"fas fa-key"})]):_vm._e()],1)]}},{key:"item.nombres",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.nombres + ' '+ item.primer_apellido +' '+item.segundo_apellido)+" ")])]}},{key:"item.ente",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.ente))])]}},{key:"item.area",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.area))])]}},{key:"item.cargo",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.cargo))])]}},{key:"item.nivel",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.nivel))])]}},{key:"item.simplificada",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.simplif(item.simplificada)))])]}},{key:"item.titular",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.titular(item.titular)))])]}},{key:"item.activo",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.activo(item.fecha_termino)))])]}},{key:"no-data",fn:function(){return [_c('v-alert',{attrs:{"value":true,"color":_vm.coloremp}},[_vm._v("\n                    "+_vm._s(_vm.txtemp)+"\n                  ")])]},proxy:true}],null,false,2803553374)})],1)])]):_vm._e()])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Consulta General ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v(" Eliminar del Padrón")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Justificar declaración\n                ")]),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nbRV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util__ = __webpack_require__("EwX8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_util__);










var _components;




/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],

  data: function data() {
    return {
      ip_id: 1,
      add_item: false,
      edit_item: false,
      bandera: '0',
      search: '',
      form_item: {},
      table_list: [],
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Titular del adeudo',
        value: 'titular',
        align: 'center'
      }, {
        text: 'Tipo de adeudo',
        value: 'cat_tipo_adeudo_id',
        align: 'center'
      }, {
        text: 'Número de identificador_deuda o contrato',
        value: 'identificador_deuda',
        align: 'center'
      }, {
        text: 'Fecha de adquisición',
        value: 'fecha_adeudo',
        align: 'center'
      }, {
        text: 'Monto original ',
        value: 'monto_original',
        align: 'center'
      }, {
        text: 'Saldo insoluto',
        value: 'saldo_pendiente',
        align: 'center'

      }, {
        text: 'Nombre, Institución o razón social ',
        value: 'nombre_acreedor',
        align: 'center'
      }],
      info: {
        adeudos: 'Para la declaración de inicio reportar la situación de adeudos/pasivos a la fecha de ingreso al empleo, cargo o comisión. Para la declaración de modificación reportar la situación de adeudos/pasivos del año inmediato anterior. Para la declaración de conclusión reportar la situación de adeudos/pasivos a la fecha de conclusión del empleo, cargo o comisión. El Declarante reportará la información sobre cualquier tipo de deuda y por cada una de ellas.',
        titular: 'Seleccionar alguna de las opciones del catálogo desplegable. En caso de señalar codeudor deberá indicar el nombre del tercero o terceros.',
        tercero: 'En caso de ser codeudor con un tercero, seleccionar si es persona física o persona moral.',
        nombre: 'En caso de señalar codeudor, escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
        rfc: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
        tipo_adeudo: 'Seleccionar cualquiera de las siguientes opciones: crédito hipotecario, crédito automotriz, crédito personal, tarjeta de crédito bancaria, tarjeta de crédito departamental y préstamo personal, otros. Se entenderá por crédito personal, aquel obtenido ante una institución de crédito o bancaria. Se entenderá por préstamo personal, aquel obtenido a través de un familiar, amigo y/o conocido del Declarante.',
        identificador_deuda: 'Señalar el número de contrato, identificador_deuda o cualquier dato que permita su identificación, en caso de préstamo personal se indicará no aplica.',
        fecha: ' Indicar la fecha en que adquirió el adeudo.',
        monto_original: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda. El monto_original a reportar será el inicial al adeudo.',
        cat_tipo_moneda_id: 'Seleccionar la moneda relativa al adeudo.',
        saldo_pendiente: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda.',
        otorgante: 'Seleccionar si es persona física o persona moral.',
        nombre_acreedor: 'Señalar el nombre de la institución donde contrajo la deuda.',
        rfc_acreedor: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
        lugar: 'Indicar si se encuentra en México o en el extranjero, debiendo señalar el país donde se localiza.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }

    };
  },

  computed: {
    terceros: function terceros() {
      if (this.form_item) {
        if (this.form_item.titular) {
          var arr = [3, 4, 5, 8, 10, 13, 15, 18, 19, 24, 25];
          return arr.includes(this.form_item.titular);
        }
      }
      return false;
    },
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.form_item.cat_tipo_moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.form_item.cat_tipo_moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {},
  methods: {
    getVMonto: function getVMonto() {
      if (this.form_item.cat_tipo_adeudo_id == 5) return '';else return 'required|min:1';
    },
    showItem: function showItem() {
      this.add_item = true;
      if (!this.form_item.domicilio_acreedor_cat_pais_id) {
        this.form_item.domicilio_acreedor_cat_pais_id = 150;
      }
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = false;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("deudas", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");

              if (!_this.edit_item) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
          _this.scrolling();
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = true;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("deudas/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');

    this.$http.get("deudas/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    }, function (error) {
      _this3.Err(error);
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();
    this.form_item.domicilio_acreedor_cat_pais_id = 150;
  }
});

/***/ }),

/***/ "nj3t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back card card-circle-chart"},[_c('div',{staticClass:"card-header text-center"},[_c('h5',{staticClass:"card-title color2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description color2"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{ref:"chart",staticClass:"chart-circle",attrs:{"data-percent":_vm.percentage}},[_vm._v(_vm._s(_vm.percentage)+"%")])]),_vm._v(" "),_c('div',{staticClass:"card-header text-center"},[_c('h3',{staticClass:"card-title color2"},[_vm._v(_vm._s(_vm.avance)+"/"+_vm._s(_vm.total))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nwE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Apoyos_vue__ = __webpack_require__("qf/D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ccb7194_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Apoyos_vue__ = __webpack_require__("FJKp");
function injectStyle (ssrContext) {
  __webpack_require__("Cp7P")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Apoyos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ccb7194_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Apoyos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o1ya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "o8l8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oOWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{ref:"wizard",attrs:{"error-color":"#EB5E28","color":"#1e94fd","title":"Intereses","subtitle":""},on:{"on-complete":_vm.siguente,"on-change":_vm.cancelAll}},[_c('tab-content',{attrs:{"title":"Participación en empresas, sociedades, asociaciones (Hasta los últimos 2 años)","icon":"ti-briefcase"}},[_c('empresas-soc',{ref:"EmpresasSoc"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"¿Participa en la toma de decisiones de alguna de estas instituciones? (Hasta los últimos 2 años)","icon":"ti-comment-alt"}},[_c('decisiones',{ref:"Decisiones"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Apoyos o beneficios públicos (Hasta los últimos 2 años)","icon":"ti-money"}},[_c('apoyos',{ref:"Apoyos"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Representación (Hasta los últimos 2 años)","icon":"ti-user"}},[_c('representacion',{ref:"Representacion"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Clientes Principales (Hasta los 2 últimos años)","icon":"ti-agenda"}},[_c('clientes-principales',{ref:"ClientesPrincipales"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Beneficios Privados (Hasta los últimos 2 años)","icon":"ti-world"}},[_c('beneficios-privados',{ref:"BeneficiosPrivados"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Fideicomisos (Hasta los últimos 2 años)","icon":"ti-bookmark-alt"}},[_c('fideicomisos',{ref:"Fideicomisos"})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v(" Atrás ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v(" Siguiente ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"finish"},slot:"finish"},[_vm._v(" Siguiente")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("uaGE");



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== "production";

var state = {
  entidades: [],
  paises: [],
  monedas: [],
  beneficiarios: [],
  tipos_instituciones: [],
  tipos_beneficios: [],
  tipos_apoyos: [],
  tipos_fideicomisos: [],
  tipos_fideicomisos_part: [],
  tipos_participaciones: [],
  nivel_gobierno: [],
  sectores_industria: [],
  tipos_representacion: [],
  tipos_vehiculos: [],
  tipos_inmuebles: [],
  tipos_mueble: [],
  titular_adeudo: [],
  tipos_adeudos: [],
  adquisiciones: [],
  relaciones: [],
  transmisores: [],
  pagos: [],
  valores_inmueble: [],
  bajas_inmueble: [],
  inversiones: [],
  inv_bancarias: [],
  inv_fondos: [],
  inv_organizaciones: [],
  inv_monedas: [],
  inv_seguros: [],
  inv_valores: [],
  inv_afores: []
};
var actions = {
  getEntidades: function getEntidades(_ref, data) {
    var commit = _ref.commit,
        state = _ref.state;

    commit("setEntidades", data);
  },
  getPaises: function getPaises(_ref2, data) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit("setPaises", data);
  },
  getTipoInstitucion: function getTipoInstitucion(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit("setTipoInstitucion", data);
  },
  getTipoApoyos: function getTipoApoyos(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit("setTipoApoyos", data);
  },
  getNivelGobierno: function getNivelGobierno(_ref5, data) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit("setNivelGobierno", data);
  },
  getSectoresIndustria: function getSectoresIndustria(_ref6, data) {
    var commit = _ref6.commit,
        state = _ref6.state;

    commit("setSectoresIndustria", data);
  },
  getTipoRepresentacion: function getTipoRepresentacion(_ref7, data) {
    var commit = _ref7.commit,
        state = _ref7.state;

    commit("setTipoRepresentacion", data);
  },
  getTipoBeneficio: function getTipoBeneficio(_ref8, data) {
    var commit = _ref8.commit,
        state = _ref8.state;

    commit("setTipoBeneficio", data);
  },
  getMonedas: function getMonedas(_ref9, data) {
    var commit = _ref9.commit,
        state = _ref9.state;

    commit("setMonedas", data);
  },
  getTipoFideicomiso: function getTipoFideicomiso(_ref10, data) {
    var commit = _ref10.commit,
        state = _ref10.state;

    commit("setTipoFideicomiso", data);
  },
  getTipoFideicomisoPart: function getTipoFideicomisoPart(_ref11, data) {
    var commit = _ref11.commit,
        state = _ref11.state;

    commit("setTipoFideicomisoPart", data);
  },
  getTipoParticipaciones: function getTipoParticipaciones(_ref12, data) {
    var commit = _ref12.commit,
        state = _ref12.state;

    commit("setTipoParticipaciones", data);
  },
  getBeneficiario: function getBeneficiario(_ref13, data) {
    var commit = _ref13.commit,
        state = _ref13.state;

    commit("setBeneficiario", data);
  },
  getTipoVehiculo: function getTipoVehiculo(_ref14, data) {
    var commit = _ref14.commit,
        state = _ref14.state;

    commit("setTipoVehiculo", data);
  },
  getTipoInmueble: function getTipoInmueble(_ref15, data) {
    var commit = _ref15.commit,
        state = _ref15.state;

    commit("setTipoInmueble", data);
  },
  getTitularAdeudo: function getTitularAdeudo(_ref16, data) {
    var commit = _ref16.commit,
        state = _ref16.state;

    commit("setTitularAdeudo", data);
  },
  getTipoAdeudo: function getTipoAdeudo(_ref17, data) {
    var commit = _ref17.commit,
        state = _ref17.state;

    commit("setTipoAdeudo", data);
  },
  getAdquisiciones: function getAdquisiciones(_ref18, data) {
    var commit = _ref18.commit,
        state = _ref18.state;

    commit("setAdquisiciones", data);
  },
  getRelaciones: function getRelaciones(_ref19, data) {
    var commit = _ref19.commit,
        state = _ref19.state;

    commit("setRelaciones", data);
  },
  getPagos: function getPagos(_ref20, data) {
    var commit = _ref20.commit,
        state = _ref20.state;

    commit("setPagos", data);
  },
  getValorInmueble: function getValorInmueble(_ref21, data) {
    var commit = _ref21.commit,
        state = _ref21.state;

    commit("setValorInmueble", data);
  },
  getBajaInmueble: function getBajaInmueble(_ref22, data) {
    var commit = _ref22.commit,
        state = _ref22.state;

    commit("setBajaInmueble", data);
  },
  getTransmisor: function getTransmisor(_ref23, data) {
    var commit = _ref23.commit,
        state = _ref23.state;

    commit("setTransmisor", data);
  },
  getMueble: function getMueble(_ref24, data) {
    var commit = _ref24.commit,
        state = _ref24.state;

    commit("setMueble", data);
  },
  getInversiones: function getInversiones(_ref25, data) {
    var commit = _ref25.commit,
        state = _ref25.state;

    commit("setInversiones", data);
  },
  getInvBancaria: function getInvBancaria(_ref26, data) {
    var commit = _ref26.commit,
        state = _ref26.state;

    commit("setInvBancaria", data);
  },
  getInvFondos: function getInvFondos(_ref27, data) {
    var commit = _ref27.commit,
        state = _ref27.state;

    commit("setInvFondos", data);
  },
  getInvOrganizaciones: function getInvOrganizaciones(_ref28, data) {
    var commit = _ref28.commit,
        state = _ref28.state;

    commit("setInvOrganizaciones", data);
  },
  getInvMoneda: function getInvMoneda(_ref29, data) {
    var commit = _ref29.commit,
        state = _ref29.state;

    commit("setInvMoneda", data);
  },
  getInvSeguros: function getInvSeguros(_ref30, data) {
    var commit = _ref30.commit,
        state = _ref30.state;

    commit("setInvSeguros", data);
  },
  getInvValores: function getInvValores(_ref31, data) {
    var commit = _ref31.commit,
        state = _ref31.state;

    commit("setInvValores", data);
  },
  getInvAfores: function getInvAfores(_ref32, data) {
    var commit = _ref32.commit,
        state = _ref32.state;

    commit("setInvAfores", data);
  }
};

var mutations = {
  setEntidades: function setEntidades(state, catalogData) {
    state.entidades = catalogData;
  },
  setPaises: function setPaises(state, catalogData) {
    state.paises = catalogData;
  },
  setTipoInstitucion: function setTipoInstitucion(state, catalogData) {
    state.tipos_instituciones = catalogData;
  },
  setTipoApoyos: function setTipoApoyos(state, catalogData) {
    state.tipos_apoyos = catalogData;
  },
  setNivelGobierno: function setNivelGobierno(state, catalogData) {
    state.nivel_gobierno = catalogData;
  },
  setSectoresIndustria: function setSectoresIndustria(state, catalogData) {
    state.sectores_industria = catalogData;
  },
  setTipoRepresentacion: function setTipoRepresentacion(state, catalogData) {
    state.tipos_representacion = catalogData;
  },
  setTipoBeneficio: function setTipoBeneficio(state, catalogData) {
    state.tipos_beneficios = catalogData;
  },
  setMonedas: function setMonedas(state, catalogData) {
    state.monedas = catalogData;
  },
  setTipoFideicomiso: function setTipoFideicomiso(state, catalogData) {
    state.tipos_fideicomisos = catalogData;
  },
  setTipoFideicomisoPart: function setTipoFideicomisoPart(state, catalogData) {
    state.tipos_fideicomisos_part = catalogData;
  },
  setTipoParticipaciones: function setTipoParticipaciones(state, catalogData) {
    state.tipos_participaciones = catalogData;
  },
  setBeneficiario: function setBeneficiario(state, catalogData) {
    state.beneficiarios = catalogData;
  },
  setTipoVehiculo: function setTipoVehiculo(state, catalogData) {
    state.tipos_vehiculos = catalogData;
  },
  setTipoInmueble: function setTipoInmueble(state, catalogData) {
    state.tipos_inmuebles = catalogData;
  },
  setTitularAdeudo: function setTitularAdeudo(state, catalogData) {
    state.titular_adeudo = catalogData;
  },
  setTipoAdeudo: function setTipoAdeudo(state, catalogData) {
    state.tipos_adeudos = catalogData;
  },
  setAdquisiciones: function setAdquisiciones(state, catalogData) {
    state.adquisiciones = catalogData;
  },
  setRelaciones: function setRelaciones(state, catalogData) {
    state.relaciones = catalogData;
  },
  setPagos: function setPagos(state, catalogData) {
    state.pagos = catalogData;
  },
  setValorInmueble: function setValorInmueble(state, catalogData) {
    state.valores_inmueble = catalogData;
  },
  setBajaInmueble: function setBajaInmueble(state, catalogData) {
    state.bajas_inmueble = catalogData;
  },
  setTransmisor: function setTransmisor(state, catalogData) {
    state.transmisores = catalogData;
  },
  setMueble: function setMueble(state, catalogData) {
    state.tipos_mueble = catalogData;
  },
  setInversiones: function setInversiones(state, catalogData) {
    state.inversiones = catalogData;
  },
  setInvBancaria: function setInvBancaria(state, catalogData) {
    state.inv_bancarias = catalogData;
  },
  setInvFondos: function setInvFondos(state, catalogData) {
    state.inv_fondos = catalogData;
  },
  setInvOrganizaciones: function setInvOrganizaciones(state, catalogData) {
    state.inv_organizaciones = catalogData;
  },
  setInvMoneda: function setInvMoneda(state, catalogData) {
    state.inv_monedas = catalogData;
  },
  setInvSeguros: function setInvSeguros(state, catalogData) {
    state.inv_seguros = catalogData;
  },
  setInvValores: function setInvValores(state, catalogData) {
    state.inv_valores = catalogData;
  },
  setInvAfores: function setInvAfores(state, catalogData) {
    state.inv_afores = catalogData;
  }
};

var getters = {
  getMexico: function getMexico(state) {
    return state.paises.find(function (todo) {
      return todo.id === 150;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
}));

/***/ }),

/***/ "osWK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("32Wh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_excel_export__ = __webpack_require__("VdFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");

























__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);

__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_excel_export__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    PPagination: __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: 0,
        periodo: '',
        estatus: 1
      },
      dependencias: {},
      rol: '',
      periodos: [],
      mostrar: false,
      tiposDeclaracion: [{
        'id': 1,
        'tipo_declaracion': 'Inicial'
      }, {
        'id': 2,
        'tipo_declaracion': 'Anual'
      }, {
        'id': 3,
        'tipo_declaracion': 'Final'
      }, {
        'id': 4,
        'tipo_declaracion': 'Todas'
      }],
      estatus: [{
        'id': 1,
        'estatus': 'Activos'
      }, {
        'id': 2,
        'estatus': 'Bajas'
      }, {
        'id': 3,
        'estatus': 'Todos'
      }],
      list_cumplimiento: [],
      json_fields: {
        'Dependencia': 'dependencia',
        'Obligados': 'obligados',
        'Cumplidos': 'cumplidos',
        'Individual': 'individual',
        'Faltantes': 'faltante',
        'Total': 'total'
      },
      json_data: [],
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      pagination: {
        perPage: 15,
        currentPage: 1,
        perPageOptions: [15, 30, 45, 60],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['rfc', 'nombres', 'cargo'],
      tableColumns: [{
        prop: 'dependencia',
        label: 'Dependencia',
        minWidth: 200,
        class: 'text-left'
      }, {
        prop: 'obligados',
        label: 'Obligados',
        minWidth: 70,
        class: 'text-right'
      }, {
        prop: 'cumplidos',
        label: 'Cumplidos',
        minWidth: 70,
        class: 'text-right'
      }, {
        prop: 'faltante',
        label: 'Faltantes',
        minWidth: 75,
        class: 'text-right'
      }, {
        prop: 'individual',
        label: '% Individual',
        minWidth: 70,
        class: 'text-right'
      }, {
        prop: 'total',
        label: 'Total',
        minWidth: 75,
        class: 'text-right'
      }],
      tableColumnsReset: []
    };
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_cumplimiento;
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_cumplimiento.length;
        return this.pagedData;
      }
      var result = this.list_cumplimiento.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    }
  },
  created: function created() {
    this.tableColumnsReset = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.tableColumns));
    this.checkPermissions();
    this.getDependencias();
    this.getTipoDeclaracion();
    this.getPeriodos();
    this.rol = this.getKey('role');
    if (this.getKey('permisos').includes(16)) {
      this.model = {
        tipo_declaracion: 2,
        dependencia_id: 0,
        periodo: new Date().getFullYear(),
        estatus: 3
      };
    }
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      var permiso = [12, 16];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      if (row.dependencia === "TOTAL") return 'text-right totales';else return 'text-right';
    },
    getDependencias: function getDependencias() {
      var _this2 = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this2.dependencias = response.data.entes_publicos;
        _this2.dependencias.push({
          'codigo': 'T',
          'id': 0,
          'valor': 'TODAS'
        });
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getTipoDeclaracion: function getTipoDeclaracion() {},
    getPeriodos: function getPeriodos() {
      var _this3 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this3.periodos = response.data.periodos;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    getCumplimiento: function getCumplimiento() {
      var _this4 = this;

      if (!this.getKey('permisos').includes(16)) this.model.dependencia_id = this.getKey('ente_publico_id');

      var url = void 0;

      if (this.model.estatus == 1) url = "cumplimientoAct";else if (this.model.estatus == 2) url = "cumplimientoBj";else url = "cumplimiento";

      this.$http.post('repcumplimiento', this.model).then(function (response) {
        _this4.tableColumns = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this4.tableColumnsReset));
        _this4.mostrar = true;
        var v = _this4;
        v.list_cumplimiento = [];
        if (_this4.model.tipo_declaracion == 4) {
          var newCols = [{
            prop: 'faltantes_iniciales',
            label: 'Faltantes Iniciales',
            minWidth: 75,
            class: 'text-right'
          }, {
            prop: 'faltantes_anuales',
            label: 'Faltantes Anuales ',
            minWidth: 75,
            class: 'text-right'
          }, {
            prop: 'faltantes_finales',
            label: 'Faltantes Finales',
            minWidth: 75,
            class: 'text-right'
          }];

          var index = _this4.tableColumns.map(function (u) {
            return u.prop;
          }).indexOf('faltante');

          _this4.tableColumns.splice.apply(_this4.tableColumns, [index + 1, 0].concat(newCols));
        }

        var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, {} && {
          dependencia: 'Dependencia'
        }, {} && {
          obligados: 'Obligados'
        }, {} && {
          cumplidos: 'Cumplidos'
        }, {} && {
          faltante: 'Faltante'
        }, _this4.model.tipo_declaracion == 4 && {
          faltantes_iniciales: 'Faltantes Iniciales'
        }, _this4.model.tipo_declaracion == 4 && {
          faltantes_anuales: 'Faltantes Anuales'
        }, _this4.model.tipo_declaracion == 4 && {
          faltantes_finales: 'Faltantes Finales'
        }, {} && {
          individual: '% Individual'
        }, {} && {
          total: '% Total'
        });

        var obj2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, {} && {
          Dependencia: 'dependencia'
        }, {} && {
          Obligados: 'obligados'
        }, {} && {
          Cumplidos: 'cumplidos'
        }, {} && {
          Faltantes: 'faltante'
        }, _this4.model.tipo_declaracion == 4 && {
          'Faltantes Iniciales': 'faltantes_iniciales'
        }, _this4.model.tipo_declaracion == 4 && {
          'Faltantes Anuales': 'faltantes_anuales'
        }, _this4.model.tipo_declaracion == 4 && {
          'Faltantes Finales': 'faltantes_finales'
        }, {} && {
          Individual: 'individual'
        }, {} && {
          Total: 'total'
        });

        v.list_cumplimiento.push(obj);
        v.json_fields = obj2;

        $.each(response.data, function (key, value) {
          var child = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, {} && {
            dependencia: value.dependencia
          }, {} && {
            obligados: v.group1k(value.obligados)
          }, {} && {
            cumplidos: v.group1k(value.cumplidos)
          }, {} && {
            faltante: v.group1k(value.faltantes)
          }, _this4.model.tipo_declaracion == 4 && {
            faltantes_iniciales: v.group1k(value.faltantes_iniciales)
          }, _this4.model.tipo_declaracion == 4 && {
            faltantes_anuales: v.group1k(value.faltantes_anuales)
          }, _this4.model.tipo_declaracion == 4 && {
            faltantes_finales: v.group1k(value.faltantes_finales)
          }, {} && {
            individual: v.group1k(parseFloat(value.individual.toString().substring(0, 5))) + " %"

          }, {} && {
            total: v.group1k(parseFloat(value.total.toString().substring(0, 4))) + " %"

          });

          v.list_cumplimiento.push(child);
          v.json_data.push(child);
        });

        var sumStart = {
          cumplidos: 0,
          faltantes: 0,
          faltantes_iniciales: 0,
          faltantes_anuales: 0,
          faltantes_finales: 0,
          obligados_iniciales: 0,
          obligados_anuales: 0,
          obligados_finales: 0,
          r_iniciales: 0,
          r_anuales: 0,
          r_finales: 0,
          obligados: 0,
          individual: 0,
          total: 0
        };
        var result = response.data.reduce(function (sum, current) {

          sum.cumplidos += current.cumplidos;
          sum.faltantes += current.faltantes;
          sum.obligados += current.obligados;
          sum.individual += current.total;
          sum.total += current.total;

          sum.faltantes_iniciales += current.faltantes_iniciales > 0 ? current.faltantes_iniciales : 0;
          sum.faltantes_anuales += current.faltantes_anuales > 0 ? current.faltantes_anuales : 0;
          sum.faltantes_finales += current.faltantes_finales > 0 ? current.faltantes_finales : 0;
          sum.obligados_iniciales += current.obligados_iniciales > 0 ? current.obligados_iniciales : 0;
          sum.obligados_anuales += current.obligados_anuales > 0 ? current.obligados_anuales : 0;
          sum.obligados_finales += current.obligados_finales > 0 ? current.obligados_finales : 0;
          sum.r_iniciales += current.r_iniciales > 0 ? current.r_iniciales : 0;
          sum.r_anuales += current.r_anuales > 0 ? current.r_anuales : 0;
          sum.r_finales += current.r_finales > 0 ? current.r_finales : 0;

          return sum;
        }, sumStart);

        result.cumplidos = _this4.group1k(result.cumplidos);
        result.obligados = _this4.group1k(result.obligados);
        result.faltante = _this4.group1k(result.faltantes);

        if (result.faltantes_iniciales) {
          result.faltantes_iniciales = _this4.group1k(result.faltantes_iniciales);
          result.faltantes_anuales = _this4.group1k(result.faltantes_anuales);
          result.faltantes_finales = _this4.group1k(result.faltantes_finales);
          result.obligados_iniciales = _this4.group1k(result.obligados_iniciales);
          result.obligados_anuales = _this4.group1k(result.obligados_anuales);
          result.obligados_finales = _this4.group1k(result.obligados_finales);
          result.r_iniciales = _this4.group1k(result.r_iniciales);
          result.r_anuales = _this4.group1k(result.r_anuales);
          result.r_finales = _this4.group1k(result.r_finales);
        }

        result.total = _this4.group1k(parseFloat(result.total.toString().substring(0, 5))) + " %";
        result.individual = _this4.group1k(parseFloat(result.individual.toString().substring(0, 5))) + " %";

        result.dependencia = "Totales";
        v.list_cumplimiento.push(result);
        v.json_data.push(result);
      }, function (error) {
        _this4.StepError(error);
      });
    }
  }
});

/***/ }),

/***/ "p5X9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p7eG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pIzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Verificacion_vue__ = __webpack_require__("mvdL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b6f606_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Verificacion_vue__ = __webpack_require__("BqYN");
function injectStyle (ssrContext) {
  __webpack_require__("WkJy")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Verificacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b6f606_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Verificacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pXQN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);









__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip_id: null,
      model: {}
    };
  },
  created: function created() {
    this.checkPermissions();
    this.ip_id = this.getId();
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    guardar: function guardar() {
      var _this = this;

      this.$http.post('observaciones', this.model).then(function (response) {
        _this.$router.push("resumen");
      }, function (error) {
        _this.StepError(error);
      });
    }
  }
});

/***/ }),

/***/ "qMVV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qOqc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qT/J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeNotifications: false,
      nombre: '',
      ente: ''
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    cerrarSesion: function cerrarSesion() {
      localStorage.clear();
      __WEBPACK_IMPORTED_MODULE_0__main__["eventBus"].$emit('cerro');
      this.$router.push('/login');
    },
    abreSubM: function abreSubM() {
      var v = this;
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        component: {
          template: '\n            <div @click="cerrarSesion" href="javascript:void(0)"  >\n              Cerrar Sesi\xF3n\n            </div>',
          methods: {
            cerrarSesion: function cerrarSesion() {
              localStorage.clear();
              __WEBPACK_IMPORTED_MODULE_0__main__["eventBus"].$emit('cerro');
              v.$router.push('/login');
            }
          }
        },
        icon: 'ti-lock',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
        timeout: 150000
      });
    }
  },
  created: function created() {
    this.nombre = this.getKey('nombre');
    this.ente = this.getKey('ente');
  }
});

/***/ }),

/***/ "qbDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Ingresos_vue__ = __webpack_require__("YF0P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f37cd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Ingresos_vue__ = __webpack_require__("iSCj");
function injectStyle (ssrContext) {
  __webpack_require__("k2FP")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Ingresos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f37cd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Ingresos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qf/D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      search: '',
      ip_id: 1,
      add_item: false,
      edit_item: null,
      niveles: [],
      apoyos: [],
      bandera: "0",
      isnum: null,

      form_item: {},
      table_list: [],
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Beneficiario',
        value: 'beneficiario',
        align: 'center'
      }, {
        text: 'Nombre del programa',
        value: 'programa',
        align: 'center'
      }, {
        text: 'Nombre de la institución',
        value: 'institucion_otorgante',
        align: 'center'
      }, {
        text: 'Nivel u orden de gobierno',
        value: 'nivel_orden_gobierno_id',
        align: 'center'
      }, {
        text: 'Tipo de apoyo',
        value: 'tipo_apoyo_id',
        align: 'center'
      }, {
        text: 'Monto aproximado del apoyo mensual',
        value: 'monto',
        align: 'center'
      }],
      info: {
        apoyo: 'Es la contribución monetaria o en especie que otorga un Ente Público al Declarante, cónyuge o Pareja y/o dependiente económico. El apoyo en especie refiere a cualquier contribución, utilizando bienes, servicios o beneficios de naturaleza diferente al dinero. Deberá reportar hasta los últimos dos años.',
        beneficiario: 'Son las personas que reciben el apoyo o beneficio público. De las opciones del catálogo indicar quien o quienes son los beneficiarios, señalar las veces que sean necesarias.',
        programa: 'Proporcionar el nombre del programa por el cual recibe el apoyo o beneficio público.',
        institucion: 'Señalar el nombre de la institución que le esté dando el apoyo.',
        nivel: 'Seleccionar el orden de gobierno por medio del cual recibe el apoyo o beneficio público: federal, estatal o municipal/alcaldía.',
        tipo: 'Seleccionar del listado desplegable: subsidio (Ayuda económica que una persona recibe de un organismo oficial para satisfacer una necesidad determinada), servicio (Actividad o asistencia de un Ente Público, en favor del Declarante), Obra (materiales o servicios a favor del Declarante para construcción), otro, especifique.',
        forma: 'Señalar si el apoyo recibido es monetario o en especie.',
        monto: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda. Indicar cantidad mensual del apoyo, si este no fuera mensual, realizar la operación aritmética a efecto de establecer la cantidad como lo solicita el formato.',
        especificar_tipo: '(Otro) Especifique tipo de apoyo',
        especificar_apoyo: 'En caso de haber seleccionado en especie deberá describir en qué consiste el apoyo o beneficio.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = null;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("apoyos", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = item;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.edit_item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("apoyos/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');
    this.$http.get("apoyos/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    }, function (error) {
      _this3.Err(error);
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();
  }
});

/***/ }),

/***/ "r5QN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RepDeclaraciones_vue__ = __webpack_require__("QpmF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a3652b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RepDeclaraciones_vue__ = __webpack_require__("Hpgc");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RepDeclaraciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a3652b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RepDeclaraciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r72d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RepConflictoInteres_vue__ = __webpack_require__("+VGi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_211bab26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RepConflictoInteres_vue__ = __webpack_require__("9lTz");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_RepConflictoInteres_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_211bab26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_RepConflictoInteres_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rFcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿Tiene participación en empresas, sociedades o asociaciones ? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.participacion),expression:"info.participacion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Datos del participante")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Señalar quien participa "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.participante),expression:"info.participante",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"participante","label":"1"},model:{value:(_vm.form_item.participante),callback:function ($$v) {_vm.$set(_vm.form_item, "participante", $$v)},expression:"form_item.participante"}},[_vm._v("Declarante")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"participante","label":"2"},model:{value:(_vm.form_item.participante),callback:function ($$v) {_vm.$set(_vm.form_item, "participante", $$v)},expression:"form_item.participante"}},[_vm._v("Pareja")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"participante","label":"3"},model:{value:(_vm.form_item.participante),callback:function ($$v) {_vm.$set(_vm.form_item, "participante", $$v)},expression:"form_item.participante"}},[_vm._v("Dependiente Económico")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('participante')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre de la empresa, sociedad o asociación "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre),expression:"info.nombre",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_empresa_sociedad_asociacion),expression:"form_item.nombre_empresa_sociedad_asociacion"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre","placeholder":"Nombre de la Empresa, Sociedad o Asociación"},domProps:{"value":(_vm.form_item.nombre_empresa_sociedad_asociacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_empresa_sociedad_asociacion", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc),expression:"info.rfc",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc),expression:"form_item.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Porcentaje de participación de acuerdo a escritura "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.porcentaje),expression:"info.porcentaje",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-input-number',{directives:[{name:"validate",rawName:"v-validate",value:('required|between:1,100'),expression:"'required|between:1,100'"}],attrs:{"name":"porcentaje","controls-position":"right","step":5,"min":0,"max":100},model:{value:(_vm.form_item.porcentaje_participacion),callback:function ($$v) {_vm.$set(_vm.form_item, "porcentaje_participacion", $$v)},expression:"form_item.porcentaje_participacion"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('porcentaje')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Participación "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_participacion),expression:"info.tipo_participacion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"tipo_participacion","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.naturaleza_vinculo),callback:function ($$v) {_vm.$set(_vm.form_item, "naturaleza_vinculo", $$v)},expression:"form_item.naturaleza_vinculo"}},_vm._l((_vm.tipos_participaciones),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo_participacion')))])],1),_vm._v(" "),(_vm.form_item.naturaleza_vinculo == 8)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.naturaleza_vinculo_especificar),expression:"form_item.naturaleza_vinculo_especificar"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.naturaleza_vinculo_especificar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "naturaleza_vinculo_especificar", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("¿Recibe remuneración por su participación? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.remuneracion),expression:"info.remuneracion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"remuneracion","label":"1"},model:{value:(_vm.form_item.remuneracion),callback:function ($$v) {_vm.$set(_vm.form_item, "remuneracion", $$v)},expression:"form_item.remuneracion"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"remuneracion","label":"2"},model:{value:(_vm.form_item.remuneracion),callback:function ($$v) {_vm.$set(_vm.form_item, "remuneracion", $$v)},expression:"form_item.remuneracion"}},[_vm._v("NO")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('remuneracion')))])],1),_vm._v(" "),(_vm.form_item.remuneracion == '1')?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Monto mensual neto "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.monto),expression:"info.monto",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-input-number',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:0'),expression:"'required|decimal:0'"}],attrs:{"name":"monto","controls-position":"right","min":0},model:{value:(_vm.form_item.monto),callback:function ($$v) {_vm.$set(_vm.form_item, "monto", $$v)},expression:"form_item.monto"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('monto')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector productivo al que pertenece "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.sector),expression:"info.sector",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Sector","filterable":"","name":"sector"},model:{value:(_vm.form_item.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.form_item, "sector_industria_id", $$v)},expression:"form_item.sector_industria_id"}},_vm._l((_vm.sectores_industria),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.errors.first('sector'))+"\n          ")])],1),_vm._v(" "),_c('legend',[_vm._v("Lugar donde se ubica "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.lugar),expression:"info.lugar",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" País ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"pais","filterable":"","placeholder":"País"},model:{value:(_vm.form_item.domicilio_pais_id),callback:function ($$v) {_vm.$set(_vm.form_item, "domicilio_pais_id", $$v)},expression:"form_item.domicilio_pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('pais')))])],1),_vm._v(" "),(_vm.form_item.domicilio_pais_id==150)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" Entidad Federativa ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"entidad","filterable":"","placeholder":"Entidad"},model:{value:(_vm.form_item.domicilio_entidad_federativa_id),callback:function ($$v) {_vm.$set(_vm.form_item, "domicilio_entidad_federativa_id", $$v)},expression:"form_item.domicilio_entidad_federativa_id"}},_vm._l((_vm.entidades),function(option){return _c('el-option',{key:option.nom_ent,staticClass:"select-default",attrs:{"value":option.id,"label":option.nom_ent}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('entidad')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.participante",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterDeclarante(item.participante)))])]}},{key:"item.naturaleza_vinculo",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipoParticipacion(item.naturaleza_vinculo)))])]}},{key:"item.remuneracion",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterBool(item.remuneracion)))])]}},{key:"item.sector_industria_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterSector(item.sector_industria_id)))])]}},{key:"item.monto",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("$"+_vm._s(_vm._f("currency")(item.monto)))])]}},{key:"item.porcentaje_participacion",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.porcentaje_participacion)+" %")])]}}],null,false,3059983244)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("PARTICIPACIÓN EN EMPRESAS, SOCIEDADES O ASOCIACIONES (HASTA LOS ULTIMOS 2 AÑOS) ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de la pareja o dependientes económicos no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rIxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("n5kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("TjUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formularios_Movimientos_Movimientos_vue__ = __webpack_require__("B8af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Formularios_Movimientos_Licencias_vue__ = __webpack_require__("At0/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Formularios_Movimientos_ListaMovimientos_vue__ = __webpack_require__("PSUj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Formularios_Movimientos_ListaCorrecciones_vue__ = __webpack_require__("Or6+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Formularios_Movimientos_Correcciones_vue__ = __webpack_require__("WhAi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Formularios_Movimientos_HCorrecciones_vue__ = __webpack_require__("4wA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Formularios_Movimientos_Transferencias_vue__ = __webpack_require__("TAk9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Formularios_Movimientos_Inactivos_vue__ = __webpack_require__("WlYt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {},
      rol: null
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["TabContent"],
    Consulta: __WEBPACK_IMPORTED_MODULE_3__Formularios_Movimientos_Movimientos_vue__["a" /* default */],
    Licencias: __WEBPACK_IMPORTED_MODULE_4__Formularios_Movimientos_Licencias_vue__["a" /* default */],
    Lista: __WEBPACK_IMPORTED_MODULE_5__Formularios_Movimientos_ListaMovimientos_vue__["a" /* default */],
    ListaCorrecciones: __WEBPACK_IMPORTED_MODULE_6__Formularios_Movimientos_ListaCorrecciones_vue__["a" /* default */],
    Correcciones: __WEBPACK_IMPORTED_MODULE_7__Formularios_Movimientos_Correcciones_vue__["a" /* default */],
    HCorrecciones: __WEBPACK_IMPORTED_MODULE_8__Formularios_Movimientos_HCorrecciones_vue__["a" /* default */],
    Transferencias: __WEBPACK_IMPORTED_MODULE_9__Formularios_Movimientos_Transferencias_vue__["a" /* default */],
    Inactivos: __WEBPACK_IMPORTED_MODULE_10__Formularios_Movimientos_Inactivos_vue__["a" /* default */]
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions: function checkPermissions() {
      var permiso = [4];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.datosPersonales.model, this.$refs.firstStep.model, this.$refs.DatosCurriculares.model, this.$refs.DatosConyuge.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()("Good job!", "You clicked the finish button!", "success");
    },
    siguente: function siguente() {
      this.$router.push("ingresos");
    }
  },
  created: function created() {
    this.rol = this.getKey('role');
    this.checkPermissions();
  }
});

/***/ }),

/***/ "rLga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    var _ref;

    return _ref = {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,
      monedas: [],
      plazos: [],
      actividades: [],
      sectores: null,
      n_domicilio: null
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "monedas", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "entidadFed", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "municipios", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidades", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidad", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "paises", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isnum", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "item_premios", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "list_premios", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fields_list", [{
      key: "acciones",
      label: "Acciones",
      tdClass: "text-center"
    }, {
      key: "nombre_denominacion_razon_social",
      label: "Denominación o razón social",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "rfc",
      label: "RFC",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "curp",
      label: "CURP",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "sector_industria_id",
      label: "Sector",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "tipo_actividad_servicio_id",
      label: "Tipo de actividad ",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "descripcion_premio",
      label: "Descripción del tipo de premio",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "ingreso_bruto_anual",
      label: "Ingreso bruto anual ",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "moneda_id",
      label: "Moneda",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "duracion_frecuencia",
      label: "Duración / Frecuencia",
      tdClass: "text-center",
      formatter: 'emptyFields'
    }, {
      key: "unidad_temporal_id",
      label: "Unidad temporal",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "fecha_transaccion",
      label: "Fecha de transacción",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "observaciones",
      label: "Observaciones",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "pais_id",
      label: "País",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "entidad_federativa_id",
      label: "Entidad federativa",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "municipio_id",
      label: "Municipio",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "localidad_id",
      label: "Localidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "colonia",
      label: "Colonia",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_tipo_vial",
      label: "Tipo vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_nom_vial",
      label: "Nombre vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "cp",
      label: "CP",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numExt",
      label: "Número exterior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numInt",
      label: "Número interior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }]), _ref;
  },

  computed: {
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.item_premios.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.item_premios.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {
    list_premios: {
      handler: function handler() {
        if (this.list_premios) {
          this.setLocalidades();
          if (this.list_premios.length == 0) {
            this.bandera = '0';
          } else {
            this.bandera = '1';
          }
        }
      },
      deep: true
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_premios.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_premios.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_premios.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_premios.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_premios.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_premios.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_premios.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_premios.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_premios.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_premios.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    }
  },
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMoneda: function getMoneda(index) {
      var resp = "";
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getActividad: function getActividad(index) {
      var resp = " ";
      if (this.sectores) {
        this.actividades.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUnidades: function getUnidades(index) {
      var resp = " ";
      if (this.plazos) {
        this.plazos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: '',
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
      this.item_premios = {
        acciones: "",
        rfc_quien_adquirio: "",
        ingreso_bruto_anual: "",
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: "",
        entidad_federativa_id: "",
        municipio_id: "",
        localidad_id: "",
        colonia: "",
        cp: "",
        numExt: "",
        numInt: "",
        vialidad_nom_vial: "",
        vialidad_tipo_vial: "",
        observaciones: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      if (this.item_premios) {
        this.item_premios.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post("premios", this.item_premios).then(function (response) {
          _this.StepOk("Guardado");
          if (_this.edit_item === undefined || _this.edit_item === null) {
            _this.list_premios.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.actividad));
          } else {
            _this.list_premios.splice(_this.edit_item.index, 1, _this.item_premios);
            _this.edit_item.item._rowVariant = "";
          }
          _this.showItem();
          _this.initItem();
          _this.edit_item = null;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW("Hay campos sin completar");
      }
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_premios = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_premios[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_premios[indice].id !== null) {
        var item = this.list_premios[indice];

        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("premios/" + item.id).then(function (response) {
            _this2.list_premios.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_premios.pais_id ? this.item_premios.pais_id : 150;
      this.n_domicilio.entidadF = this.item_premios.entidad_federativa_id ? this.item_premios.entidad_federativa_id : '';
      this.n_domicilio.municipio = this.item_premios.municipio_id ? this.item_premios.municipio_id : '';
      this.n_domicilio.localidad = this.item_premios.localidad_id ? this.item_premios.localidad_id : '';
      this.n_domicilio.cp = this.item_premios.cp ? this.item_premios.cp : '';
      this.n_domicilio.colonia = this.item_premios.colonia ? this.item_premios.colonia : '';
      this.n_domicilio.vialidad = this.item_premios.vialidad_tipo_vial ? this.item_premios.vialidad_tipo_vial : '';
      this.n_domicilio.vialidad_nombre = this.item_premios.vialidad_nom_vial ? this.item_premios.vialidad_nom_vial : '';
      this.n_domicilio.ext = this.item_premios.numExt ? this.item_premios.numExt : '';
      this.n_domicilio.int = this.item_premios.numInt ? this.item_premios.numInt : '';
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      this.list_premios.forEach(function (item) {
        if (item.localidad_id) {
          _this3.$http.get('localidades/localidad/' + item.localidad_id).then(function (response) {
            _this3.localidades.push(response.data.localidad);
          }, function (error) {
            _this3.Err(error);
          });
        }
      });
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("premios/" + this.ip_id).then(function (response) {
      _this4.list_premios = response.data.actividades;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_unidad_medida_plazo").then(function (response) {
      _this4.plazos = response.data.unidades;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_actividad").then(function (response) {
      _this4.actividades = response.data.actividad;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("monedas").then(function (response) {
      _this4.monedas = response.data.monedas;
      var temp = "97";
      _this4.monedas.forEach(function (item) {
        if (item.codigo == "MXN") {
          temp = item.id;
        }
      });
      _this4.item_premios.moneda_id = temp;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "rhaJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rtTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__("kDzH");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    user: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    upass: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      ip_id: null,
      password: '',
      able: false,
      passwordConfirm: '',
      declarante: {},
      nombre: ''
    };
  },

  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    actualiza: function actualiza() {
      var _this = this;

      if (this.password != '') {
        this.$http.post('updatePass/' + this.password).then(function (response) {
          _this.setSession(response.data);
          console.log(_this.getKey('status_dec'));
          if (_this.getKey('status_dec') == 1) {
            _this.$router.push('/forms/tablero');
          } else {
            _this.$router.push('/forms/enviada');
            localStorage.setItem('std', 0);
          }

          _this.$router.go();
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.Err("El campo no puede estar vacío");
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  },
  created: function created() {
    var _this2 = this;

    this.$http.get("recupera_check_user/" + this.user + "/" + this.upass).then(function (response) {
      if (response.data.token) {
        var form = document.getElementById("formResetPass");
        form.classList.remove("ocultar");

        _this2.setSession(response.data);
        _this2.nombre = _this2.getKey('nombre');
      } else {
        setTimeout(function () {
          _this2.$router.push('/login');
          _this2.$router.go();
        }, 5000);
      }
    }, function (error) {
      _this2.StepError(error, 4000);
      setTimeout(function () {
        _this2.$router.push('/login');
        _this2.$router.go();
      }, 5000);
    });
  }
});

/***/ }),

/***/ "s5oc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_excel_export__ = __webpack_require__("VdFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");





















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_excel_export__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    PPagination: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      model: { tipo_declaracion: '', dependencia_id: '', periodo: '' },
      dependencias: {},
      rol: '',
      periodos: [],
      dependenciaT: '',
      mostrar: false,
      perPage: 5,
      rows: null,
      currentPage: 1,
      filter: null,
      perPage2: 5,
      rows2: null,
      currentPage2: 1,
      filter2: null,
      tiposDeclaracion: [],
      list_declarantes: [],
      list_declarantes2: [],
      avance: 0,
      avanced: '',
      totald: '',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      pagination2: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      searchQuery2: '',
      cumplidos_campos: {
        'RFC': 'rfc',
        'Nombres': 'nombres',
        'Dependencia': 'dependencia',
        'Cargo': 'cargo',
        'Fecha': 'fecha'
      },
      cumplidos_data: [],
      faltantes_campos: {
        'RFC': 'rfc',
        'Nombres': 'nombres',
        'Dependencia': 'dependencia',
        'Cargo': 'cargo',
        'Correo Personal': 'correo1',
        'Correo Laboral': 'correo2',
        'Teléfono Personal': 'tel1',
        'Teléfono Laboral': 'tel2'

      },
      faltantes_data: [],
      meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      fecha: '',
      propsToSearch: ['rfc', 'nombres', 'cargo'],
      propsToSearch2: ['rfc', 'nombres', 'cargo', 'correo1', 'correo2', 'tel1', 'tel2'],
      fields_list: [{ key: "rfc", label: "RFC", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "nombres", label: "Nombres", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "dependencia", label: "Dependencia", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "cargo", label: "Cargo", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "fecha", label: "Fecha", tdClass: 'cump text-left', thClass: 'cump text-center' }],
      fields_list2: [{ key: "rfc", label: "RFC", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "nombres", label: "Nombres", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "dependencia", label: "Dependencia", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "cargo", label: "Cargo", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "correo1", label: "Correo Personal", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "correo2", label: "Correo Laboral", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "tel1", label: "Tel Personal", tdClass: 'cump text-left', thClass: 'cump text-center' }, { key: "tel2", label: "Tel Laboral", tdClass: 'cump text-left', thClass: 'cump text-center' }]
    };
  },

  computed: {
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_declarantes.length;

      return this.list_declarantes.length;
    },
    to2: function to2() {
      var highBound = this.from2 + this.perPage2;
      if (this.total2 < highBound) {
        highBound = this.total2;
      }
      return highBound;
    },
    from2: function from2() {
      return this.perPage2 * (this.currentPage2 - 1);
    },
    total2: function total2() {
      this.rows2 = this.list_declarantes2.length;

      return this.list_declarantes2.length;
    }
  },
  created: function created() {
    this.checkPermissions();
    this.getDependencias();
    this.getTipoDeclaracion();
    this.getPeriodos();
    this.rol = this.getKey('role');
    var myDate = new Date();
    var mes = ('0' + (myDate.getMonth() + 1)).slice(-2);
    var dia = ('0' + myDate.getDate()).slice(-2);
    var anio = myDate.getFullYear();
    var fecha = dia + '/' + mes + '/' + anio;
  },

  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered2: function onFiltered2(filteredItems) {
      this.rows2 = filteredItems.length;
      this.currentPage2 = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [10, 14];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getDependencias: function getDependencias() {
      var _this = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this.dependencias = response.data.entes_publicos;
      }, function (error) {
        _this.StepError(error);
      });
    },

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    getTipoDeclaracion: function getTipoDeclaracion() {
      var _this2 = this;

      var v = this;
      this.$http.get("tiposDeclaracion").then(function (response) {
        _this2.tiposDeclaracion = response.data.tipoDeclaracion;
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getPeriodos: function getPeriodos() {
      var _this3 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this3.periodos = response.data.periodos;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    getDeclarantes: function getDeclarantes() {
      var _this4 = this;

      if (!this.getKey('permisos').includes(14)) this.model.dependencia_id = this.getKey('ente_publico_id');

      this.$http.post("getDeclarantes", this.model).then(function (response) {
        _this4.avance = Number(response.data.avance.toFixed(1));
        _this4.dependenciaT = response.data.entidad[0].valor;
        _this4.mostrar = true;
        var v = _this4;
        _this4.avanced = response.data.total.toString();
        _this4.totald = response.data.porcentaje.toString();
        v.list_declarantes = [];
        $.each(response.data.declarantes, function (key, value) {
          v.list_declarantes.push({ 'rfc': value.rfc,
            'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
            'dependencia': v.dependenciaT,
            'cargo': value.empleo_cargo_comision,
            'fecha': v.dateFormat(value.fecha_dec)
          });
        });
        v.list_declarantes2 = [];
        $.each(response.data.faltantes, function (key, value) {

          v.list_declarantes2.push({ 'rfc': value.rfc,
            'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
            'dependencia': v.dependenciaT,
            'cargo': value.encargo.empleo_cargo_comision,
            'correo1': value.correo_electronico_personal || '',
            'correo2': value.correo_electronico_laboral || '',
            'tel1': value.telefono_particular || '',
            'tel2': value.telefono_laboral || ''
          });
        });
      }, function (error) {
        _this4.StepError(error);
      });
    }
  }
});

/***/ }),

/***/ "s9LD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Recibió premios ?\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre, denominación o razón social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_premios.nombre_denominacion_razon_social),expression:"item_premios.nombre_denominacion_razon_social"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre, denominación o razón social de quien se adquirió el inmueble:"},domProps:{"value":(_vm.item_premios.nombre_denominacion_razon_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_premios, "nombre_denominacion_razon_social", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_premios.rfc),expression:"item_premios.rfc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RFC"},domProps:{"value":(_vm.item_premios.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_premios, "rfc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("CURP (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_premios.curp),expression:"item_premios.curp"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CURP"},domProps:{"value":(_vm.item_premios.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_premios, "curp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector / Industria (si aplica)")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_premios.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.item_premios, "sector_industria_id", $$v)},expression:"item_premios.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de actividad o servicio que produjo el ingreso")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_premios.tipo_actividad_servicio_id),callback:function ($$v) {_vm.$set(_vm.item_premios, "tipo_actividad_servicio_id", $$v)},expression:"item_premios.tipo_actividad_servicio_id"}},_vm._l((_vm.actividades),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Descripción del tipo de premio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_premios.descripcion_premio),expression:"item_premios.descripcion_premio"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción de la actividad"},domProps:{"value":(_vm.item_premios.descripcion_premio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_premios, "descripcion_premio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 customCurrency"},[_c('label',{staticClass:"control-label"},[_vm._v("Ingreso bruto anual recibido por el premio")]),_vm._v(" "),_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{staticClass:"text-right",attrs:{"type":"number","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.item_premios.ingreso_bruto_anual),callback:function ($$v) {_vm.$set(_vm.item_premios, "ingreso_bruto_anual", $$v)},expression:"item_premios.ingreso_bruto_anual"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.item_premios.moneda_id),callback:function ($$v) {_vm.$set(_vm.item_premios, "moneda_id", $$v)},expression:"item_premios.moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.item_premios.moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Duración o frecuencia ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_premios.duracion_frecuencia),expression:"item_premios.duracion_frecuencia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Frecuencia"},domProps:{"value":(_vm.item_premios.duracion_frecuencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_premios, "duracion_frecuencia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Unidad temporal")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_premios.unidad_temporal_id),callback:function ($$v) {_vm.$set(_vm.item_premios, "unidad_temporal_id", $$v)},expression:"item_premios.unidad_temporal_id"}},_vm._l((_vm.plazos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.item_premios.unidad_temporal_id == 4)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de transacción")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.item_premios.fecha_transaccion),callback:function ($$v) {_vm.$set(_vm.item_premios, "fecha_transaccion", $$v)},expression:"item_premios.fecha_transaccion"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones / Comentarios")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_premios.observaciones),expression:"item_premios.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Observaciones / Comentarios"},domProps:{"value":(_vm.item_premios.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_premios, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":""},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_premios","responsive":"","hover":"","items":_vm.list_premios,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.entidad_federativa_id)))]}},{key:"localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.localidad_id))+"\n            ")]}},{key:"municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.municipio_id)))]}},{key:"pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_id)))]}},{key:"sector_industria_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSector(row.item.sector_industria_id)))]}},{key:"tipo_actividad_servicio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getActividad(row.item.tipo_actividad_servicio_id)))]}},{key:"ingreso_bruto_anual",fn:function(row){return [_vm._v(_vm._s((_vm.getSignoDos(row.item.moneda_id)))+"\n              "+_vm._s(_vm._f("currency")(row.item.ingreso_bruto_anual)))]}},{key:"moneda_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getMoneda(row.item.moneda_id)))]}},{key:"unidad_temporal_id",fn:function(row){return [_vm._v(_vm._s(_vm.getUnidades(row.item.unidad_temporal_id)))]}}],null,false,2722672800)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Premios")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sQJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        ¿ Realiza errendamiento ?\n      ")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre, denominación o razón social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_intereses.nombre_denominacion_razon_social),expression:"item_intereses.nombre_denominacion_razon_social"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre, denominación o razón social de quien se adquirió el inmueble:"},domProps:{"value":(_vm.item_intereses.nombre_denominacion_razon_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_intereses, "nombre_denominacion_razon_social", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_intereses.rfc),expression:"item_intereses.rfc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"RFC"},domProps:{"value":(_vm.item_intereses.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_intereses, "rfc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("CURP (si aplica)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_intereses.curp),expression:"item_intereses.curp"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"CURP"},domProps:{"value":(_vm.item_intereses.curp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_intereses, "curp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector / Industria (si aplica)")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_intereses.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.item_intereses, "sector_industria_id", $$v)},expression:"item_intereses.sector_industria_id"}},_vm._l((_vm.sectores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de actividad o servicio que produjo el ingreso")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_intereses.tipo_actividad_servicio_id),callback:function ($$v) {_vm.$set(_vm.item_intereses, "tipo_actividad_servicio_id", $$v)},expression:"item_intereses.tipo_actividad_servicio_id"}},_vm._l((_vm.actividades),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Descripción del tipo de inversión que produce el ingreso")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_intereses.descripcion_actividad_servicio),expression:"item_intereses.descripcion_actividad_servicio"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción de la actividad"},domProps:{"value":(_vm.item_intereses.descripcion_actividad_servicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_intereses, "descripcion_actividad_servicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 customCurrency"},[_c('label',{staticClass:"control-label"},[_vm._v("Ingreso bruto anual recibido por los intereses")]),_vm._v(" "),_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{staticClass:"text-right",attrs:{"type":"number","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.item_intereses.ingreso_bruto_anual),callback:function ($$v) {_vm.$set(_vm.item_intereses, "ingreso_bruto_anual", $$v)},expression:"item_intereses.ingreso_bruto_anual"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.item_intereses.moneda_id),callback:function ($$v) {_vm.$set(_vm.item_intereses, "moneda_id", $$v)},expression:"item_intereses.moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.item_intereses.moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Duración o frecuencia ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_intereses.duracion_frecuencia),expression:"item_intereses.duracion_frecuencia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Frecuencia"},domProps:{"value":(_vm.item_intereses.duracion_frecuencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_intereses, "duracion_frecuencia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Unidad temporal")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.item_intereses.unidad_temporal_id),callback:function ($$v) {_vm.$set(_vm.item_intereses, "unidad_temporal_id", $$v)},expression:"item_intereses.unidad_temporal_id"}},_vm._l((_vm.plazos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.item_intereses.unidad_temporal_id == 4)?_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de transacción")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.item_intereses.fecha_transaccion),callback:function ($$v) {_vm.$set(_vm.item_intereses, "fecha_transaccion", $$v)},expression:"item_intereses.fecha_transaccion"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',{staticClass:"control-label"},[_vm._v("Observaciones / Comentarios")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_intereses.observaciones),expression:"item_intereses.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Observaciones / Comentarios"},domProps:{"value":(_vm.item_intereses.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_intereses, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('domicilio',{attrs:{"titulo":""},model:{value:(_vm.n_domicilio),callback:function ($$v) {_vm.n_domicilio=$$v},expression:"n_domicilio"}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n          ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('b-table',{attrs:{"id":"tbl_intereses","responsive":"","hover":"","items":_vm.list_intereses,"fields":_vm.fields_list,"show-empty":""},scopedSlots:_vm._u([{key:"acciones",fn:function(row){return [_c('b-button',{staticClass:"edit mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(row)}}},[_vm._v("\n                Editar "),_c('i',{staticClass:"fas fa-pencil-alt ml-2"})]),_vm._v(" "),_c('b-button',{staticClass:"delete mr-2",attrs:{"size":"sm","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(row.index)}}},[_vm._v("\n                Eliminar "),_c('i',{staticClass:"fas fa-trash-alt ml-2"})])]}},{key:"entidad_federativa_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getEntidad(row.item.entidad_federativa_id)))]}},{key:"localidad_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getLocalidad(row.item.localidad_id))+"\n            ")]}},{key:"municipio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getMunicipio(row.item.municipio_id)))]}},{key:"pais_id",fn:function(row){return [_vm._v(_vm._s(_vm.getPais(row.item.pais_id)))]}},{key:"sector_industria_id",fn:function(row){return [_vm._v(_vm._s(_vm.getSector(row.item.sector_industria_id)))]}},{key:"tipo_actividad_servicio_id",fn:function(row){return [_vm._v(_vm._s(_vm.getActividad(row.item.tipo_actividad_servicio_id)))]}},{key:"ingreso_bruto_anual",fn:function(row){return [_vm._v(_vm._s((_vm.getSignoDos(row.item.moneda_id)))+"\n              "+_vm._s(_vm._f("currency")(row.item.ingreso_bruto_anual)))]}},{key:"moneda_id",fn:function(row){return [_vm._v("\n              "+_vm._s(_vm.getMoneda(row.item.moneda_id)))]}},{key:"unidad_temporal_id",fn:function(row){return [_vm._v(_vm._s(_vm.getUnidades(row.item.unidad_temporal_id)))]}}],null,false,2722672800)},[_vm._v(" "),_c('template',{slot:"empty"},[_c('h5',[_vm._v("No existen registros")])])],2)],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Arrendamiento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "swa5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-md-center m-0 p-0"},[(_vm.rol == 1)?_c('div',{staticClass:"col-12 p-0 m-0"},[(_vm.showForm)?_c('div',{staticClass:"col-12 mt-0"},[_c('v-card',{staticClass:"mx-auto",attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("\n          Agregar tipo declaración\n        ")]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"row d-flex align-items-end"},[_c('div',{staticClass:"col-md-4 col-lg-4 col-sm-12 "},[_c('label',{staticClass:"control-label"},[_vm._v("\n                Tipo declaración\n              ")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"filterable":"","name":"tipo_dec","placeholder":"Tipo declaración"},model:{value:(_vm.formItem.tipo_dec),callback:function ($$v) {_vm.$set(_vm.formItem, "tipo_dec", $$v)},expression:"formItem.tipo_dec"}},_vm._l((_vm.tipo_declaracion),function(option){return _c('el-option',{key:option.id+'tipo',staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-lg-4 col-sm-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                Periodo\n              ")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"filterable":"","name":"periodo","placeholder":"Periodo"},model:{value:(_vm.formItem.periodo),callback:function ($$v) {_vm.$set(_vm.formItem, "periodo", $$v)},expression:"formItem.periodo"}},_vm._l((_vm.periodos),function(option){return _c('el-option',{key:option.year,staticClass:"select-default",attrs:{"value":option.year,"label":option.year}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-lg-4 col-sm-12"},[_c('label',{staticClass:"control-label"}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mr-2",on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_c('span',[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){$event.preventDefault();_vm.showForm = false}}},[_c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])])])])])],1)],1):_c('div',{staticClass:"col-12 mt-0"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[_vm._m(0)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12  pt-0 mt-0 d-flex justify-content-center"},[_c('v-data-table',{staticClass:"my-table",attrs:{"headers":_vm.headers,"items":_vm.utdeclaraciones,"items-per-page":5,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[(_vm.rol == 1)?_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"danger","disabled":item.declaracion_id != null},on:{"click":function($event){$event.preventDefault();return _vm.remove(item)}}},[_c('i',{staticClass:"fas fa-trash"})]):_vm._e(),_vm._v(" "),_c('br')],1)]}},{key:"item.pendiente",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"alert  mb-0 p-1",class:(item.declaracion_id)?'alert-info':'alert-warning'},[_c('b',[_vm._v(" "+_vm._s((item.declaracion_id)?'Realizada':'Pendiente'))])])]}},{key:"item.fecha_posesion",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("\n          "+_vm._s(_vm.dateFormat(item.fecha_posesion))+"\n        ")])]}},{key:"item.fecha_termino",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("\n          "+_vm._s(_vm.dateFormat(item.fecha_termino))+"\n        ")])]}},{key:"item.fecha_declaracion",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("\n          "+_vm._s(_vm.dateFormat(item.fecha_declaracion))+"\n        ")])]}},{key:"item.tipo_dec_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_c('b',[_vm._v(" "+_vm._s(_vm.tipoDecCat(item.tipo_dec_id)))])])]}}])})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t455":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"card-title"},[_vm._v("No de Declaraciones")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Declaración ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"declaracion","placeholder":"Declaracion"},model:{value:(_vm.model.tipo_declaracion),callback:function ($$v) {_vm.$set(_vm.model, "tipo_declaracion", $$v)},expression:"model.tipo_declaracion"}},_vm._l((_vm.tiposDeclaracion),function(option){return _c('el-option',{key:option.tipo_declaracion,staticClass:"select-default",attrs:{"value":option.id,"label":option.tipo_declaracion}})}),1)],1),_vm._v(" "),(_vm.rol!=4)?_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Dependencia ")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"dependencia","placeholder":"Dependencia"},model:{value:(_vm.model.dependencia_id),callback:function ($$v) {_vm.$set(_vm.model, "dependencia_id", $$v)},expression:"model.dependencia_id"}},_vm._l((_vm.dependencias),function(option){return _c('el-option',{key:option.valor,attrs:{"value":option.id,"label":option.valor}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Desde")]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"name":"fecha_inicio","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.model, "fecha_inicio", $$v)},expression:"model.fecha_inicio"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Hasta")]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"name":"fecha_fin","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Elige un día"},model:{value:(_vm.model.fecha_fin),callback:function ($$v) {_vm.$set(_vm.model, "fecha_fin", $$v)},expression:"model.fecha_fin"}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success pull-right",on:{"click":_vm.getDeclaracionesPorFecha}},[_vm._v("\n        Buscar\n      ")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"offset-md-6 col-sm-6 col-md-6 col-lg-6"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.filtro_usuarios,"items-per-page":5,"search":_vm.filter,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Descargar Declaración'),expression:"'Descargar Declaración'",modifiers:{"hover":true,"top":true}}],staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.descargar(item)}}},[_c('i',{staticClass:"ti-download"})])],1)]}},{key:"item.titular_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.titular_id,_vm.titular_adeudo)))])]}}])})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t4Go":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t5eK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('div',{staticClass:"vue-form-wizard md"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6 pull-right"},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-sm":"3"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"search","placeholder":"Buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_usuarios,"expanded":_vm.expanded,"search":_vm.filter,"single-expand":_vm.singleExpand},on:{"update:expanded":function($event){_vm.expanded=$event}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var expand = ref.expand;
var isExpanded = ref.isExpanded;
return [_c('tr',[_c('td',[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"primary"},on:{"click":function($event){return expand(!isExpanded)}}},[_c('i',{staticClass:"fas fa-search"})])],1),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(item.updated_at)+" ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(item.rfc)+" ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(item.nombre)+" ")])])]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('div',{staticClass:"row p-4"},[_c('div',{staticClass:" col-12"},[_c('div',{staticClass:"card "},[_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(" Cambio solicitado por ")]),_vm._v(": "+_vm._s(item.usuario.Nombre+' '+item.usuario.Paterno+' '+item.usuario.Materno)+"\n                          ")]),_vm._v(" "),_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(" Cambio ")]),_vm._v(": "+_vm._s(_vm.getStatus(item.status))+"\n                          ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Datos Actuales")]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((item.datos_actuales),function(value,key){return _c('li',{key:key,staticClass:"list-group-item"},[_c('strong',[_vm._v(_vm._s(key.replace("_", " ")))]),_vm._v(" : "+_vm._s(_vm.returnValueKey(value,key)))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Datos de Transferencia")]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((item.datos_cambio),function(value,key){return _c('li',{key:key,staticClass:"list-group-item"},[_c('strong',[_vm._v(_vm._s(key.replace("_", " ")))]),_vm._v(" : "+_vm._s(_vm.returnValueKey(value,key)))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.validar(item)}}},[_c('span',[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Validar\n                        ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.rechazar(item)}}},[_c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Rechazar\n                        ")])])])])])])]}}],null,false,3877509000)})],1)])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Solicitudes de transferencia de Personal")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tS/P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tZI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Movimientos_vue__ = __webpack_require__("rIxw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_013f15a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Movimientos_vue__ = __webpack_require__("cD8d");
function injectStyle (ssrContext) {
  __webpack_require__("+tTX")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Movimientos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_013f15a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Movimientos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tyH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('img',{attrs:{"src":"static/img/encabezado.png","alt":"declaraNet"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12 card card-wizard"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"text-center"}),_vm._v(" "),_c('p',{staticClass:"category text-right fechap"},[_vm._v(_vm._s(_vm.fecha))]),_vm._v(" "),_c('p',{staticClass:"category text-right"},[_vm._v(_vm._s(_vm.hora))])]),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('h5',{staticClass:"nombreUpc"},[_vm._v(_vm._s(this.dpersonales.nombres))])])]),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('h5',[_vm._v(_vm._s(this.encargo.dependencia))])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(this.dpersonales.nombres.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(this.dpersonales.curp))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(this.dpersonales.rfc))])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},_vm._l((_vm.curriculares),function(item,i){return _c('div',{key:'dc'+i},[_c('div',{staticClass:"mb-2",class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.grado))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.institucion))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.carrera))])])])}),0)]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},_vm._l((_vm.experiencia),function(item,i){return _c('div',{key:'elab'+i},[_c('div',{class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.ambito))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.institucion))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.unidad))])])])}),0)]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(this.encargo.dependencia.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(this.encargo.cargo.toUpperCase()))])])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.dependientes),function(dependiente,i){return _c('div',{key:'dep'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(dependiente.nombre.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(dependiente.relacion.toUpperCase()))])])}),_vm._v(" "),(_vm.dependientes.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.intereses.empresas),function(empresas,i){return _c('div',{key:'emp'+i},[_c('div',{class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.nombreEmpresa.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.naturaleza.toUpperCase()))])])])}),_vm._v(" "),(_vm.intereses.empresas.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.intereses.tomaDecisiones),function(empresas,i){return _c('div',{key:'emps'+i},[_c('div',{class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.nombre.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.puesto.toUpperCase()))])])])}),_vm._v(" "),(_vm.intereses.tomaDecisiones.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.intereses.beneficiosPubl),function(empresas,i){return _c('div',{key:'bene'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.programa.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.institucion.toUpperCase()))])])}),_vm._v(" "),(_vm.intereses.beneficiosPubl.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.intereses.reprActiva),function(empresas,i){return _c('div',{key:'repact'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.nombre.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.rfc.toUpperCase()))])])}),_vm._v(" "),(_vm.intereses.reprActiva.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.intereses.clientesPrinc),function(empresas,i){return _c('div',{key:'client'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.nombre.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.rfc.toUpperCase()))])])}),_vm._v(" "),(_vm.intereses.clientesPrinc.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.intereses.beneficiosPriv),function(empresas,i){return _c('div',{key:'int_bene'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.nombre.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.rfc.toUpperCase()))])])}),_vm._v(" "),(_vm.intereses.beneficiosPriv.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.intereses.fideicomisos),function(empresas,i){return _c('div',{key:'fidei'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.nombre.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(empresas.rfc.toUpperCase()))])])}),_vm._v(" "),(_vm.intereses.fideicomisos.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._m(14),_vm._v(" "),(_vm.ingresos)?_c('div',{staticStyle:{"margin-top":"12px"}},[(_vm.getKey('tipo_dec') =='Inicial')?_c('div',[_vm._m(15),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},_vm._l((_vm.ingresos.spublicos),function(sueldo,i){return _c('div',{key:'spub'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(sueldo.nombre))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v("$"+_vm._s(_vm._f("formatPrice")(sueldo.ingreso)))])])}),0)]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},_vm._l((_vm.ingresos.otros),function(sueldo,i){return _c('div',{key:'otros'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(sueldo.cat))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(sueldo.nombre))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v("$"+_vm._s(_vm._f("formatPrice")(sueldo.ingreso)))])])}),0),_vm._v(" "),(_vm.ingresos.otros.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},_vm._l((_vm.ingresos.spublicosant),function(sueldo,i){return _c('div',{key:'spubant'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(sueldo.nombre))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v("$"+_vm._s(_vm._f("formatPrice")(sueldo.ingreso)))])])}),0)]),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},_vm._l((_vm.ingresos.otrosant),function(sueldo,i){return _c('div',{key:'otrosant'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(sueldo.cat))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(sueldo.nombre))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v("$"+_vm._s(_vm._f("formatPrice")(sueldo.ingreso)))])])}),0),_vm._v(" "),(_vm.ingresos.otrosant.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()])]):_vm._e()])]),_vm._v(" "),(_vm.simplificada != '1')?_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.activos.inmuebles),function(item,i){return _c('div',{key:'inmu'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.tipoOperacion))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.naturaleza))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.domicilio))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v("$"+_vm._s(_vm._f("formatPrice")(item.padquisicion)))])])}),_vm._v(" "),(_vm.activos.inmuebles.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.activos.bmuebles),function(item,i){return _c('div',{key:'bmueb'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.tipoOperacion))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.tipoBien))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v("$"+_vm._s(_vm._f("formatPrice")(item.padquisicion)))])])}),_vm._v(" "),(_vm.activos.bmuebles.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.activos.mueblesnr),function(item,i){return _c('div',{key:'bmuesnr'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.tipoOperacion))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.tipoBien))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v("$"+_vm._s(_vm._f("formatPrice")(item.padquisicion)))])])}),_vm._v(" "),(_vm.activos.mueblesnr.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(23),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.activos.inversiones),function(item,i){return _c('div',{key:'inver'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.institucion))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v("$"+_vm._s(_vm._f("formatPrice")(item.monto)))])])}),_vm._v(" "),(_vm.activos.inversiones.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),(_vm.simplificada != '1')?_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.pasivos.deudas),function(item,i){return _c('div',{key:'deudas'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.identificador))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.acreedor))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v("$"+_vm._s(_vm._f("formatPrice")(item.saldo)))])])}),_vm._v(" "),(_vm.pasivos.deudas.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)]),_vm._v(" "),_vm._m(26),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._l((_vm.pasivos.prestamo),function(item,i){return _c('div',{key:'prestamo'+i,class:{btop:(i>0)}},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.tipo))]),_vm._v(" "),_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(item.tipoBien))])])}),_vm._v(" "),(_vm.pasivos.prestamo.length == 0)?_c('div',[_c('p',{staticClass:"datosOtros"},[_vm._v("NO")])]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_vm._m(27),_vm._v(" "),_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"datosOtros"},[_vm._v(_vm._s(_vm.fiscal))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 container-fluid"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center alert-warning"},[_c('h3',[_vm._v("Estás a punto de enviar la declaración "+_vm._s(this.getKey('tipo_dec').toLowerCase())+", una vez enviada, no podrás editar los datos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-md-offset-3 container-fluid text-center"},[_c('button',{staticClass:"btn btn-wd btn-success",attrs:{"refs":"btnEnviar","type":"button","disabled":_vm.enviando},on:{"click":_vm.enviar}},[_vm._m(28),_vm._v("\n        Enviar\n      ")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br')])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h4',{staticClass:"title text-center"},[_vm._v("Vista previa de la declaración patrimonial y de intereses")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Datos Personales")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Datos Curriculares")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Experiencia Laboral")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Datos del Encargo Actual")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Datos del cónyuge, concubina, concubinario y/o dependientes económicos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Intereses")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Empresas, Sociedades y Asociaciones")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Participación en Toma de Decisiones")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Beneficios Públicos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Representación")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Clientes Principales")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Beneficios Privados")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Fideicomisos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Ingresos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Sueldos y salarios públicos (situación actual)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Otros sueldos y salarios (situación actual)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Sueldos y salarios públicos (año inmediato anterior)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Otros sueldos y salarios (año inmediato anterior)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Activos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Bienes inmuebles")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Bienes muebles")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Bienes muebles no registrables")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Inversiones")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Pasivos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Adeudos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"categoria padd"},[_vm._v("Préstamo o Comodato")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col bk"},[_c('div',{staticClass:"categoria"},[_vm._v("Declaración fiscal")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-check"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u9j9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('legend',[_vm._v("Información curricular")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('p-radio',{staticClass:"d-inline-block",attrs:{"name":"conest","inline":true,"label":"1"},model:{value:(_vm.estudios_sn),callback:function ($$v) {_vm.estudios_sn=$$v},expression:"estudios_sn"}},[_vm._v("Con Estudios")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"name":"conest","inline":true,"label":"2"},model:{value:(_vm.estudios_sn),callback:function ($$v) {_vm.estudios_sn=$$v},expression:"estudios_sn"}},[_vm._v("Sin Estudios")])],1)])]),_vm._v(" "),(_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Nivel:\n          ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","name":"grado_maximo","placeholder":"Escolaridad"},model:{value:(_vm.model.grado_maximo_escolaridad_id),callback:function ($$v) {_vm.$set(_vm.model, "grado_maximo_escolaridad_id", $$v)},expression:"model.grado_maximo_escolaridad_id"}},_vm._l((_vm.gradoesc),function(option){return _c('el-option',{key:option.grado_escolaridad,staticClass:"select-default",attrs:{"filterable":"","value":option.id,"label":option.grado_escolaridad}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('grado_maximo'))+"\n          ")])],1)]),_vm._v(" "),(_vm.muestraCampos)?_c('div',{staticClass:"form-group col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Grado obtenido:\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.grado_obtenido),expression:"model.grado_obtenido"}],staticClass:"form-control",attrs:{"type":"text","name":"grado_obtenido","placeholder":"Grado Obtenido"},domProps:{"value":(_vm.model.grado_obtenido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "grado_obtenido", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('grado_obtenido'))+"\n        ")])]):_vm._e()]),_vm._v(" "),_c('h5',{staticClass:"text-left"},[_vm._v("Institución Educativa")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Institución\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.institucion_educativa),expression:"model.institucion_educativa"}],staticClass:"form-control",attrs:{"type":"text","name":"institucion_educativa","placeholder":"Nombre de la institución"},domProps:{"value":(_vm.model.institucion_educativa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "institucion_educativa", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Carrera o área de conocimiento:\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.carrera),expression:"model.carrera"}],staticClass:"form-control",attrs:{"type":"text","name":"carrera","placeholder":"Carrera o área de conocimiento"},domProps:{"value":(_vm.model.carrera)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "carrera", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Estatus\n        ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","filterable":"","placeholder":"Estatus","name":"estatus"},model:{value:(_vm.model.estatus_id),callback:function ($$v) {_vm.$set(_vm.model, "estatus_id", $$v)},expression:"model.estatus_id"}},_vm._l((_vm.estatusC),function(option){return _c('el-option',{key:option.codigo,staticClass:"select-default",attrs:{"value":option.id,"label":option.estatus}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('estatus'))+"\n        ")])],1),_vm._v(" "),(_vm.model.estatus_id >'1')?_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Documento Obtenido:\n        ")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","placeholder":"Documento","filterable":""},model:{value:(_vm.model.documento_obtenido_id),callback:function ($$v) {_vm.$set(_vm.model, "documento_obtenido_id", $$v)},expression:"model.documento_obtenido_id"}},_vm._l((_vm.documentos),function(option){return _c('el-option',{key:option.codigo,staticClass:"select-default",attrs:{"value":option.id,"label":option.documento}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.model.estatus_id >'1')?_c('div',{staticClass:"col-md-6 "},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Fecha de obtención del documento\n        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","name":"fecha_obtencion","picker-options":_vm.opciones,"type":"date","placeholder":"Selecciona"},model:{value:(_vm.model.fecha_obtencion),callback:function ($$v) {_vm.$set(_vm.model, "fecha_obtencion", $$v)},expression:"model.fecha_obtencion"}})],1),_vm._v(" "),(_vm.model.documento_obtenido_id =='6')?_c('div',{staticClass:"col-md-6 "},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Cédula Profesional\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.cedula_profesional),expression:"model.cedula_profesional"}],staticClass:"form-control",attrs:{"type":"text","name":"cedula_profesional","placeholder":"Cédula"},domProps:{"value":(_vm.model.cedula_profesional)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "cedula_profesional", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Ubicación\n          ")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"lugar","label":"1"},model:{value:(_vm.model.lugar_institucion_ext),callback:function ($$v) {_vm.$set(_vm.model, "lugar_institucion_ext", $$v)},expression:"model.lugar_institucion_ext"}},[_vm._v("México")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"lugar","label":"2"},model:{value:(_vm.model.lugar_institucion_ext),callback:function ($$v) {_vm.$set(_vm.model, "lugar_institucion_ext", $$v)},expression:"model.lugar_institucion_ext"}},[_vm._v("Extranjero")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('lugar'))+"\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:" col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Aclaraciones y observaciones")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.aclaraciones),expression:"model.aclaraciones"}],staticClass:"form-control",attrs:{"type":"text","name":"aclaraciones","placeholder":"Aclaraciones y observaciones"},domProps:{"value":(_vm.model.aclaraciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "aclaraciones", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[_vm._m(0)]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])])]):_vm._e(),_vm._v(" "),((_vm.estudios_sn ==1)&&!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list_escolaridad,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger","disabled":_vm.edit_item != null},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.grado_maximo_escolaridad_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.getGrado(item.grado_maximo_escolaridad_id)))])]}},{key:"item.carrera",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.carrera))])]}},{key:"item.cedula_profesional",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.cedula_profesional))])]}}],null,false,2349859500)})],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uEx6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    var _ref;

    return _ref = {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,
      monedas: [],
      plazos: [],
      actividades: [],
      sectores: null,
      n_domicilio: null
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "monedas", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "entidadFed", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "municipios", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidades", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidad", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "paises", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isnum", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "item_enajenaciones", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "list_enajenaciones", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fields_list", [{
      key: "acciones",
      label: "Acciones",
      tdClass: "text-center"
    }, {
      key: "nombre_denominacion_razon_social",
      label: "Denominación o razón social",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "rfc",
      label: "RFC",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "curp",
      label: "CURP",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "sector_industria_id",
      label: "Sector",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "tipo_actividad_servicio_id",
      label: "Tipo de actividad ",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "descripcion_bien",
      label: "Descripción del bien",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "ingreso_bruto_anual",
      label: "Ingreso bruto anual ",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "moneda_id",
      label: "Moneda",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "duracion_frecuencia",
      label: "Duración / Frecuencia",
      tdClass: "text-center",
      formatter: 'emptyFields'
    }, {
      key: "unidad_temporal_id",
      label: "Unidad temporal",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "fecha_transaccion",
      label: "Fecha de transacción",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "observaciones",
      label: "Observaciones",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "pais_id",
      label: "País",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "entidad_federativa_id",
      label: "Entidad federativa",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "municipio_id",
      label: "Municipio",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "localidad_id",
      label: "Localidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "colonia",
      label: "Colonia",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_tipo_vial",
      label: "Tipo vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_nom_vial",
      label: "Nombre vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "cp",
      label: "CP",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numExt",
      label: "Número exterior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numInt",
      label: "Número interior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }]), _ref;
  },

  computed: {
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.item_enajenaciones.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.item_enajenaciones.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {
    list_enajenaciones: {
      handler: function handler() {
        if (this.list_enajenaciones) {
          this.setLocalidades();
          if (this.list_enajenaciones.length == 0) {
            this.bandera = '0';
          } else {
            this.bandera = '1';
          }
        }
      },
      deep: true
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_enajenaciones.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_enajenaciones.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_enajenaciones.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_enajenaciones.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_enajenaciones.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_enajenaciones.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_enajenaciones.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_enajenaciones.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_enajenaciones.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_enajenaciones.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    }
  },
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMoneda: function getMoneda(index) {
      var resp = "";
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getActividad: function getActividad(index) {
      var resp = " ";
      if (this.sectores) {
        this.actividades.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUnidades: function getUnidades(index) {
      var resp = " ";
      if (this.plazos) {
        this.plazos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: '',
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
      this.item_enajenaciones = {
        acciones: "",
        rfc_quien_adquirio: "",
        ingreso_bruto_anual: "",
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: "",
        entidad_federativa_id: "",
        municipio_id: "",
        localidad_id: "",
        colonia: "",
        cp: "",
        numExt: "",
        numInt: "",
        vialidad_nom_vial: "",
        vialidad_tipo_vial: "",
        observaciones: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      if (this.item_enajenaciones) {
        this.item_enajenaciones.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post("enajenaciones", this.item_enajenaciones).then(function (response) {
          _this.StepOk("Guardado");
          if (_this.edit_item === undefined || _this.edit_item === null) {
            _this.list_enajenaciones.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.actividad));
          } else {
            _this.list_enajenaciones.splice(_this.edit_item.index, 1, _this.item_enajenaciones);
            _this.edit_item.item._rowVariant = "";
          }
          _this.showItem();
          _this.initItem();
          _this.edit_item = null;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW("Hay campos sin completar");
      }
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_enajenaciones = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_enajenaciones[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_enajenaciones[indice].id !== null) {
        var item = this.list_enajenaciones[indice];

        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("enajenaciones/" + item.id).then(function (response) {
            _this2.list_enajenaciones.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_enajenaciones.pais_id ? this.item_enajenaciones.pais_id : 150;
      this.n_domicilio.entidadF = this.item_enajenaciones.entidad_federativa_id ? this.item_enajenaciones.entidad_federativa_id : '';
      this.n_domicilio.municipio = this.item_enajenaciones.municipio_id ? this.item_enajenaciones.municipio_id : '';
      this.n_domicilio.localidad = this.item_enajenaciones.localidad_id ? this.item_enajenaciones.localidad_id : '';
      this.n_domicilio.cp = this.item_enajenaciones.cp ? this.item_enajenaciones.cp : '';
      this.n_domicilio.colonia = this.item_enajenaciones.colonia ? this.item_enajenaciones.colonia : '';
      this.n_domicilio.vialidad = this.item_enajenaciones.vialidad_tipo_vial ? this.item_enajenaciones.vialidad_tipo_vial : '';
      this.n_domicilio.vialidad_nombre = this.item_enajenaciones.vialidad_nom_vial ? this.item_enajenaciones.vialidad_nom_vial : '';
      this.n_domicilio.ext = this.item_enajenaciones.numExt ? this.item_enajenaciones.numExt : '';
      this.n_domicilio.int = this.item_enajenaciones.numInt ? this.item_enajenaciones.numInt : '';
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      this.list_enajenaciones.forEach(function (item) {
        if (item.localidad_id) {
          _this3.$http.get('localidades/localidad/' + item.localidad_id).then(function (response) {
            _this3.localidades.push(response.data.localidad);
          }, function (error) {
            _this3.Err(error);
          });
        }
      });
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("enajenaciones/" + this.ip_id).then(function (response) {
      _this4.list_enajenaciones = response.data.actividades;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_unidad_medida_plazo").then(function (response) {
      _this4.plazos = response.data.unidades;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_actividad").then(function (response) {
      _this4.actividades = response.data.actividad;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("monedas").then(function (response) {
      _this4.monedas = response.data.monedas;
      var temp = "97";
      _this4.monedas.forEach(function (item) {
        if (item.codigo == "MXN") {
          temp = item.id;
        }
      });
      _this4.item_enajenaciones.moneda_id = temp;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "uFJU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_EncargoActual_vue__ = __webpack_require__("uRWm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_49cb46eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_EncargoActual_vue__ = __webpack_require__("RQeg");
function injectStyle (ssrContext) {
  __webpack_require__("uOAU")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_EncargoActual_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_49cb46eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_EncargoActual_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uHgF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tipoDec: '',
      anio: ''
    };
  },
  created: function created() {
    this.tipoDec = this.getKey('tipo_dec');
    this.anio = this.getKey('periodo');
  }
});

/***/ }),

/***/ "uOAU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uRWm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Domicilio_vue__ = __webpack_require__("Ta4m");








var _components;





/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_8__Domicilio_vue__["a" /* default */]), _components),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["c" /* mapFields */])(["correo_laboral", "ente", "nombre_cargo", "nivel", "poder", "honorarios", "nivel_orden", "area", "toma_posesion", "sector", "funciones", "ambitoexp", "nombreins", "unidadadm", "jerarqexp", "fechaingreso", "sectorexp", "cargopuesto", "correo_laboral2", "ente2", "nombre_cargo2", "nivel2", "poder2", "honorarios2", "nivel_orden2", "area2", "toma_posesion2", "sector2", "funciones2", "ambitoexp2", "nombreins2", "unidadadm2", "jerarqexp2", "fechaingreso2", "sectorexp2", "cargopuesto2"])),
  data: function data() {
    var _ref;

    return _ref = {
      opciones: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      },
      add_item: false,

      mostrarCampos: false,
      ip_id: null,
      datePicker: "",
      poderes: {},
      niveles: {},
      funcionesArr: [],
      funcionesExpArr: [],
      list_experiencia: [],
      edit_item: null
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "add_item", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "entidadFed", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "municipios", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidades", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidad", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "entes", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "ambitos", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "funciones_p", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "sectores", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "bandera", '0'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "model", {
      fecha_posesion: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "model2", {
      contratado_honorarios: "2"
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "n_domicilio", {
      pais_id: 150,
      entidadF: 11,
      municipio: '',
      localidad: '',
      cp: '',
      colonia: '',
      vialidad: '',
      vialidad_nombre: '',
      ext: '',
      int: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "n_domicilio2", {
      pais_id: 150,
      entidadF: 11,
      municipio: '',
      localidad: '',
      cp: '',
      colonia: '',
      vialidad: '',
      vialidad_nombre: '',
      ext: '',
      int: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "modelValidations", {
      correo_laboral: {
        email: true
      },
      ente: {
        required: true
      },
      nombre_cargo: {
        required: true
      },
      nivel: {
        required: true
      },
      poder: {
        required: true
      },
      honorarios: {
        required: true
      },
      nivel_orden: {
        required: true
      },
      area: {
        required: true
      },
      toma_posesion: {
        required: true
      },
      sector: {
        required: true
      },
      funciones: {
        required: true
      }
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "modelValidations2", {
      correo_laboral2: {
        email: true
      },
      ente2: {
        required: true
      },
      nombre_cargo2: {
        required: true
      },
      nivel2: {
        required: true
      },
      poder2: {
        required: true
      },
      honorarios2: {
        required: true
      },
      nivel_orden2: {
        required: true
      },
      area2: {
        required: true
      },
      toma_posesion2: {
        required: true
      },
      sector2: {
        required: true
      },
      funciones2: {
        required: true
      }
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fields_list", ["acciones", {
      key: "ambito_id",
      label: "Ámbito",
      tdClass: "text-left"
    }, {
      key: "nivel_gobierno_id",
      label: "Nivel",
      tdClass: "text-left"
    }, {
      key: "poder_ente_id",
      label: "Poder Jurídico",
      tdClass: "text-left"
    }, {
      key: "nombre_institucion",
      label: "Nombre",
      tdClass: "text-left"
    }, {
      key: "unidad_administrativa",
      label: "Unidad",
      tdClass: "text-left"
    }, {
      key: "sector_industria_id",
      label: "Sector/Industria",
      tdClass: "text-left"
    }, {
      key: "jerarquia_rango",
      label: "Jerarquia",
      tdClass: "text-left"
    }, {
      key: "cargo_puesto",
      label: "Cargo/Puesto",
      tdClass: "text-left"
    }, {
      key: "fecha_ingreso",
      label: "Fecha Ingreso",
      tdClass: "text-left"
    }, {
      key: "fecha_salida",
      label: "Fecha Salida",
      tdClass: "text-left"
    }, {
      key: "direccion_pais_id",
      label: "País",
      tdClass: "text-left"
    }, {
      key: "direccion_entidad_federativa_id",
      label: "Entidad Federativa",
      tdClass: "text-left"
    }, {
      key: "direccion_municipio_id",
      label: "Municipio",
      tdClass: "text-left"
    }, {
      key: "direccion_cp",
      label: "CP",
      tdClass: "text-left"
    }, {
      key: "direccion_numext",
      label: "Num Ext",
      tdClass: "text-left"
    }, {
      key: "direccion_numint",
      label: "Num Int",
      tdClass: "text-left"
    }]), _ref;
  },
  mounted: function mounted() {
    this.checkCatalogs();
    this.mostrarCampos = 1;
  },
  created: function created() {
    this.ip_id = this.getId();
    this.getInfLaboral();
    this.getOtro();

    this.getEntes();
    this.getSectores();
    this.getPoderes();
    this.getNivelesG();
    this.getAmbitos();
    this.getFunciones();
  },


  watch: {
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.model.direccion_encargo_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
          this.model.direccion_encargo_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.model.direccion_encargo_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.model.direccion_encargo_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.model.direccion_encargo_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.model.direccion_vialidad_nombre = this.n_domicilio.vialidad_nombre;
          this.model.direccion_vialidad_tipo = this.n_domicilio.vialidad;
          this.model.direccion_encargo_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.model.direccion_encargo_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
          this.model.direccion_encargo_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.model.domicilio_obs = this.n_domicilio.domicilio_observaciones ? this.n_domicilio.domicilio_observaciones : "";
        }
      },
      deep: true
    },
    n_domicilio2: {
      handler: function handler() {
        if (this.n_domicilio2) {
          this.model2.direccion_encargo_pais_id = this.n_domicilio2.pais ? this.n_domicilio2.pais : 150;
          this.model2.direccion_encargo_entidad_federativa_id = this.n_domicilio2.entidadF ? this.n_domicilio2.entidadF : "";
          this.model2.direccion_encargo_municipio_id = this.n_domicilio2.municipio ? this.n_domicilio2.municipio : "";
          this.model2.direccion_encargo_localidad_id = this.n_domicilio2.localidad ? this.n_domicilio2.localidad : "";
          this.model2.direccion_encargo_cp = this.n_domicilio2.cp ? this.n_domicilio2.cp : "";
          this.model2.direccion_vialidad_nombre = this.n_domicilio2.vialidad_nombre;
          this.model2.direccion_vialidad_tipo = this.n_domicilio2.vialidad;
          this.model2.direccion_encargo_numext = this.n_domicilio2.ext ? this.n_domicilio2.ext : "";
          this.model2.direccion_encargo_numint = this.n_domicilio2.int ? this.n_domicilio2.int : "";
          this.model2.direccion_encargo_colonia = this.n_domicilio2.colonia ? this.n_domicilio2.colonia : "";
          this.model2.domicilio_obs = this.n_domicilio2.domicilio_observaciones ? this.n_domicilio2.domicilio_observaciones : "";
        }
      },
      deep: true
    }
  },
  methods: {
    deshabilitado: function deshabilitado() {
      if (this.getKey('ente_publico_id') == 35) return false;else return true;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    getAmbito: function getAmbito(index) {
      var resp = "";
      if (this.ambitos) {
        this.ambitos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getPoder: function getPoder(index) {
      var resp = "";
      if (this.poderes) {
        this.poderes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getNivel: function getNivel(index) {
      var resp = "";
      if (this.niveles) {
        this.niveles.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = "";
      if (this.sectores && index) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.limpiaCampos();
      this.showItem();
      this.edit_item = null;
    },
    getInfLaboral: function getInfLaboral() {
      var _this = this;

      var v = this;
      this.$http.get("encargoAct/" + this.ip_id).then(function (response) {
        if (response.data.informacion != null) {
          _this.model = response.data.informacion;
          _this.model.contratado_honorarios = String(_this.model.contratado_honorarios);
          $.each(response.data.informacion.funcionesp, function (key, value) {
            v.funcionesArr.push(value.funcion_id);
          });
          _this.model.funcionesp = v.funcionesArr;
        }
        _this.editDomicilio();
      }, function (error) {
        _this.StepError(error);
        console.log(error);
      });
    },
    getOtro: function getOtro() {
      var _this2 = this;

      var v = this;
      this.$http.get("otroEncargo/" + this.ip_id).then(function (response) {
        if (response.data.otroenc.length > 0) {
          _this2.model2 = response.data.otroenc[0];
          _this2.model2.contratado_honorarios = String(_this2.model2.contratado_honorarios);
          _this2.bandera = '1';
        }

        _this2.editDomicilio2();
      }, function (error) {
        _this2.StepError(error);
        console.log(error);
      });
    },
    getEntes: function getEntes() {
      var _this3 = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this3.entes = response.data.entes_publicos;
      }, function (error) {
        _this3.StepError(error);
        console.log(error);
      });
    },
    editDomicilio: function editDomicilio() {
      if (this.model) {
        this.n_domicilio = {
          'pais_id': this.model.direccion_encargo_pais_id,
          'entidadF': this.model.direccion_encargo_entidad_federativa_id,
          'municipio': this.model.direccion_encargo_municipio_id,
          'colonia': this.model.direccion_encargo_colonia,
          'cp': this.model.direccion_encargo_cp,
          'localidad': this.model.direccion_encargo_localidad_id,
          'ext': this.model.direccion_encargo_numext,
          'int': this.model.direccion_encargo_numint,
          'vialidad': this.model.direccion_vialidad_tipo,
          'vialidad_nombre': this.model.direccion_vialidad_nombre,
          'domicilio_observaciones': this.model.domicilio_obs
        };
      }
    },
    editDomicilio2: function editDomicilio2() {
      if (this.model2) {
        this.n_domicilio2 = {
          'pais_id': this.model2.direccion_encargo_pais_id,
          'entidadF': this.model2.direccion_encargo_entidad_federativa_id,
          'municipio': this.model2.direccion_encargo_municipio_id,
          'colonia': this.model2.direccion_encargo_colonia,
          'cp': this.model2.direccion_encargo_cp,
          'localidad': this.model2.direccion_encargo_localidad_id,
          'ext': this.model2.direccion_encargo_numext,
          'int': this.model2.direccion_encargo_numint,
          'vialidad': this.model2.direccion_vialidad_tipo,
          'vialidad_nombre': this.model2.direccion_vialidad_nombre,
          'domicilio_observaciones': this.model2.domicilio_obs
        };
      }
    },
    getSafe: function getSafe(fn, defaultVal) {
      try {
        return fn();
      } catch (e) {
        return defaultVal;
      }
    },
    showInput: function showInput() {
      var _this4 = this;

      this.tags.inputVisible = true;
      this.$nextTick(function () {
        _this4.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tags.inputValue;
      if (inputValue) {
        this.tags.dynamicTags.push(inputValue);
      }
      this.tags.inputVisible = false;
      this.tags.inputValue = "";
    },
    getPoderes: function getPoderes() {
      var _this5 = this;

      this.$http.get("poderJuridico").then(function (response) {
        _this5.poderes = response.data.poderJuridico;
      }, function (error) {
        _this5.StepError(error);
        console.log(error);
      });
    },
    getNivelesG: function getNivelesG() {
      var _this6 = this;

      this.$http.get("nivelGobierno").then(function (response) {
        _this6.niveles = response.data.nivelGobierno;
      }, function (error) {
        _this6.StepError(error);
        console.log(error);
      });
    },
    getAmbitos: function getAmbitos() {
      var _this7 = this;

      this.$http.get("ambitos").then(function (response) {
        _this7.ambitos = response.data.ambitos;
      }, function (error) {
        _this7.StepError(error);
        console.log(error);
      });
    },
    getSectores: function getSectores() {
      var _this8 = this;

      this.$http.get("cat_sector_industria").then(function (response) {
        _this8.sectores = response.data.sectores;
      }, function (error) {
        _this8.StepError(error);
        console.log(error);
      });
    },
    getFunciones: function getFunciones() {
      var _this9 = this;

      this.$http.get("funcPrinc").then(function (response) {
        _this9.funciones_p = response.data.funciones;
      }, function (error) {
        _this9.StepError(error);
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "uZH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12 align-self-end"},[_c('currency',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1|numeric'),expression:"'required|min:1|numeric'"}],attrs:{"name":"sub_1","sign":""},model:{value:(_vm.item_entes.sub_1),callback:function ($$v) {_vm.$set(_vm.item_entes, "sub_1", $$v)},expression:"item_entes.sub_1"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('remuneración anual')))])],1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes.razon_social),expression:"item_entes.razon_social"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción"},domProps:{"value":(_vm.item_entes.razon_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes, "razon_social", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('actividad industrial y/o comercial')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 align-self-end"},[_c('currency',{attrs:{"sign":""},model:{value:(_vm.item_entes.razon_social_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes, "razon_social_cantidad", $$v)},expression:"item_entes.razon_social_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('cantidad actividad industrial')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes.actividad_financiera),expression:"item_entes.actividad_financiera"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción"},domProps:{"value":(_vm.item_entes.actividad_financiera)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes, "actividad_financiera", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('actividad_financiera')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 align-self-end"},[_c('currency',{attrs:{"sign":""},model:{value:(_vm.item_entes.actividad_financiera_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes, "actividad_financiera_cantidad", $$v)},expression:"item_entes.actividad_financiera_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('actividad_financiera_cantidad')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes.servicios_profecionales),expression:"item_entes.servicios_profecionales"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción"},domProps:{"value":(_vm.item_entes.servicios_profecionales)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes, "servicios_profecionales", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('servicios_profecionales')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 align-self-end"},[_c('currency',{attrs:{"sign":""},model:{value:(_vm.item_entes.servicios_profecionales_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes, "servicios_profecionales_cantidad", $$v)},expression:"item_entes.servicios_profecionales_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('servicios_profecionales_cantidad')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes.arrendamiento),expression:"item_entes.arrendamiento"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción"},domProps:{"value":(_vm.item_entes.arrendamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes, "arrendamiento", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('arrendamiento')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 align-self-end"},[_c('currency',{attrs:{"sign":""},model:{value:(_vm.item_entes.arrendamiento_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes, "arrendamiento_cantidad", $$v)},expression:"item_entes.arrendamiento_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('arrendamiento_cantidad')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8 align-self-end",staticStyle:{"text-align":"right"}},[_vm._v("\n      SUBTOTAL\n    ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 align-self-end"},[_c('label'),_vm._v(" "),_c('currency',{attrs:{"sign":"","readonly":""},model:{value:(_vm.calcula_totales1),callback:function ($$v) {_vm.calcula_totales1=$$v},expression:"calcula_totales1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8 align-self-end",staticStyle:{"text-align":"right"}},[_vm._v("\n      Suma de subtotal y remuneración mensual\n    ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 align-self-end"},[_c('label'),_vm._v(" "),_c('currency',{attrs:{"sign":"","readonly":""},model:{value:(_vm.calcula_totales2),callback:function ($$v) {_vm.calcula_totales2=$$v},expression:"calcula_totales2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12 align-self-end"},[_c('currency',{attrs:{"sign":"","readonly":""},model:{value:(_vm.calcula_totales2),callback:function ($$v) {_vm.calcula_totales2=$$v},expression:"calcula_totales2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_entes.neto_conyugue),expression:"item_entes.neto_conyugue"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Descripción"},domProps:{"value":(_vm.item_entes.neto_conyugue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item_entes, "neto_conyugue", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('neto_conyugue')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 align-self-end"},[_c('currency',{attrs:{"sign":""},model:{value:(_vm.item_entes.neto_conyugue_cantidad),callback:function ($$v) {_vm.$set(_vm.item_entes, "neto_conyugue_cantidad", $$v)},expression:"item_entes.neto_conyugue_cantidad"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('neto_conyugue_cantidad')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 align-self-end"},[_c('label',{attrs:{"for":""}},[_vm._v("SUMA DE A Y B")]),_vm._v(" "),_c('currency',{attrs:{"sign":"","readonly":""},model:{value:(_vm.calcula_totales3),callback:function ($$v) {_vm.calcula_totales3=$$v},expression:"calcula_totales3"}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n        REMUNERACIÓN MENSUAL NETA DEL DECLARANTE, POR EL CARGO QUE OCUPA, ASÍ COMO\n        EL INGRESO DEL CÓNYUGE, CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":""}},[_vm._v("\n        (Nota: Si sus ingresos percibidos son o fueron en el extranjero, las cifras se anotarán en pesos mexicanos, mencionando en el apartado para observaciones el tipo de moneda que corresponda y la fecha que se utilizó para el tipo de cambio)\n        "),_c('br')]),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":""}},[_vm._v("Requisite cantidades libres de impuestos, "),_c('strong',[_vm._v("SIN CENTAVOS Y SIN CEROS A LA IZQUIERDA.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('p',[_vm._v(" I. Remuneración mensual neta del declarante por su cargo público (deduzca impuestos) (por concepto de sueldos, honorarios, compensaciones, bonos, aguinaldos y otras prestaciones)\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('p',[_vm._v("\n        II. Otros ingresos mensuales netos del declarante (suma del II.1 al II.4)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('p',[_vm._v("\n        II. 1 Por actividad industrial y/o comercial\n        Especifica nombre o razón social y tipo de negocio (Deduzca impuestos)\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('p',[_vm._v("\n        II. 2 Por actividad financiera (rendimientos de contratos bancarios o de valores) (Deduzca impuestos)\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('p',[_vm._v("II. 3 Por servicios profesionales, participación en consejos, consultorías o asesorías Especifica el tipo de servicio y el contratante (Deduzca impuestos)\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('p',[_vm._v("II. 4 Otros (arrendamientos, regalías, sorteos, concursos, donaciones, etc.) Especifica (Deduzca impuestos)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-8"},[_c('p',[_vm._v("A. INGRESO MENSUAL NETO DEL DECLARANTE\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('p',[_vm._v("B. INGRESO MENSUAL NETO DEL CÓNYUGE CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS (DEDUZCA IMPUESTOS) ESPECIFICA\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-8"},[_c('p',[_vm._v("C. TOTAL DE INGRESO MENSUAL NETO DEL DECLARANTE, CÓNYUGE, CONCUBINA, CONCUBINARIO\n        Y/O DEPENDIENTES ECONÓMICOS\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uZT/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "ujQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v3Mv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeNotifications: false,
      nombre: '',
      lngth: 0,
      ente: '',
      menu: false,
      notificaciones: []
    };
  },

  watch: {
    '$route': 'getNotificaciones'
  },
  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    cerrarSesion: function cerrarSesion() {
      localStorage.clear();
      __WEBPACK_IMPORTED_MODULE_0__main__["eventBus"].$emit('cerro');
      this.$router.push('/login');
    },
    abreSubM: function abreSubM() {
      var v = this;
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        component: {
          template: '\n            <div @click="cerrarSesion" href="javascript:void(0)"  >\n              Cerrar Sesi\xF3n\n            </div>',
          methods: {
            cerrarSesion: function cerrarSesion() {
              localStorage.clear();
              __WEBPACK_IMPORTED_MODULE_0__main__["eventBus"].$emit('cerro');
              v.$router.push('/login');
            }
          }
        },
        icon: 'ti-lock',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
        timeout: 150000
      });
    },
    getNotificaciones: function getNotificaciones() {
      var _this = this;

      this.$http.get("notificaciones").then(function (response) {

        _this.notificaciones = response.data.notificaciones;
        _this.lngth = _this.notificaciones.length;
        _this.notificaciones = _this.notificaciones.slice(0, 5);
      }, function (error) {
        _this.StepError(error);
      });
    },
    leida: function leida(id) {
      var _this2 = this;

      this.$http.delete("notificaciones/" + id).then(function (response) {
        _this2.getNotificaciones();
      }, function (error) {
        _this2.StepError(error);
      });
    },
    irNot: function irNot() {
      this.$router.push('/admin/notificaciones');
    }
  },
  created: function created() {
    this.nombre = this.getKey('nombre');
    this.ente = this.getKey('ente');
    this.getNotificaciones();
  }
});

/***/ }),

/***/ "v8eh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vKxx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vLLw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("eQG/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3888ef0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("0mUJ");
function injectStyle (ssrContext) {
  __webpack_require__("KD5d")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3888ef0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3888ef0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vern":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vio/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿ Tiene vehículos, aeronaves y/o embarcaciones ? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.vehiculos),expression:"info.vehiculos",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de vehículo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_vehiculo),expression:"info.tipo_vehiculo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"tipos_vehiculos","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.tipo_bien_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_bien_id", $$v)},expression:"form_item.tipo_bien_id"}},_vm._l((_vm.tipos_vehiculos),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipos_vehiculos')))])],1),_vm._v(" "),(_vm.form_item.tipo_bien_id == 5)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.tipo_bien_especificar),expression:"form_item.tipo_bien_especificar"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique_inmueble","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.tipo_bien_especificar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "tipo_bien_especificar", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique_inmueble')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Titular del vehículo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.titular),expression:"info.titular",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción","name":"titular"},model:{value:(_vm.form_item.titular_id),callback:function ($$v) {_vm.$set(_vm.form_item, "titular_id", $$v)},expression:"form_item.titular_id"}},_vm._l((_vm.titular_adeudo),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('titular')))])],1),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tercero "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tercero),expression:"info.tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"1"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"tercero","label":"2"},model:{value:(_vm.form_item.tercero),callback:function ($$v) {_vm.$set(_vm.form_item, "tercero", $$v)},expression:"form_item.tercero"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tercero')))])],1):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre del tercero o terceros "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_tercero),expression:"info.nombre_tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_tercero),expression:"form_item.nombre_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_tercero","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.form_item.nombre_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_tercero')))])]):_vm._e(),_vm._v(" "),(_vm.terceros)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC del tercero "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_tercero),expression:"info.rfc_tercero",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('uppercase|max:13'),expression:"'uppercase|max:13'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_tercero),expression:"form_item.rfc_tercero"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_tercero","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_tercero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_tercero", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_tercero')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Transmisor "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.transmisor),expression:"info.transmisor",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"transmisor","label":"1"},model:{value:(_vm.form_item.transmisor),callback:function ($$v) {_vm.$set(_vm.form_item, "transmisor", $$v)},expression:"form_item.transmisor"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"transmisor","label":"2"},model:{value:(_vm.form_item.transmisor),callback:function ($$v) {_vm.$set(_vm.form_item, "transmisor", $$v)},expression:"form_item.transmisor"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('transmisor')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre o razón social del transmisor "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre_denominacion_adquirio),expression:"info.nombre_denominacion_adquirio",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre_denominacion_adquirio),expression:"form_item.nombre_denominacion_adquirio"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre_denominacion_adquirio","placeholder":"Nombre o razón social"},domProps:{"value":(_vm.form_item.nombre_denominacion_adquirio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre_denominacion_adquirio", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre_denominacion_adquirio')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC del transmisor "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc_quien_adquirio),expression:"info.rfc_quien_adquirio",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('uppercase|max:13'),expression:"'uppercase|max:13'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc_quien_adquirio),expression:"form_item.rfc_quien_adquirio"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc_quien_adquirio","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc_quien_adquirio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc_quien_adquirio", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc_quien_adquirio')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Relación del transmisor de la propiedad con el titular "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.relacion),expression:"info.relacion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"relacion","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.relacion_persona_adquirio_id),callback:function ($$v) {_vm.$set(_vm.form_item, "relacion_persona_adquirio_id", $$v)},expression:"form_item.relacion_persona_adquirio_id"}},_vm._l((_vm.transmisores),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('relacion')))])],1),_vm._v(" "),(_vm.form_item.relacion_persona_adquirio_id == 20)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.relacion_especificar),expression:"form_item.relacion_especificar"}],staticClass:"form-control",attrs:{"type":"text","name":"relacion_especificar","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.relacion_especificar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "relacion_especificar", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('relacion_especificar')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Marca "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.marca),expression:"info.marca",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.marca),expression:"form_item.marca"}],staticClass:"form-control",attrs:{"type":"text","name":"marca","placeholder":"Marca"},domProps:{"value":(_vm.form_item.marca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "marca", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('marca')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Modelo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.modelo),expression:"info.modelo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.modelo),expression:"form_item.modelo"}],staticClass:"form-control",attrs:{"type":"text","name":"modelo","placeholder":"Modelo"},domProps:{"value":(_vm.form_item.modelo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "modelo", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('modelo')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Año "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.anio),expression:"info.anio",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"},{name:"model",rawName:"v-model",value:(_vm.form_item.anio),expression:"form_item.anio"}],staticClass:"form-control",attrs:{"type":"text","name":"año","placeholder":"Año"},domProps:{"value":(_vm.form_item.anio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "anio", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('año')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Número de serie o registro "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.numero_serie),expression:"info.numero_serie",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.numero_serie),expression:"form_item.numero_serie"}],staticClass:"form-control",attrs:{"type":"text","name":"serie","placeholder":"Número de Serie o Registro"},domProps:{"value":(_vm.form_item.numero_serie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "numero_serie", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('serie')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Forma de adquisición "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.forma_adquisicion),expression:"info.forma_adquisicion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"forma_adquisicion","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.forma_adquisicion),callback:function ($$v) {_vm.$set(_vm.form_item, "forma_adquisicion", $$v)},expression:"form_item.forma_adquisicion"}},_vm._l((_vm.adquisiciones),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forma_adquisicion')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Forma de pago "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.forma_pago),expression:"info.forma_pago",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"select-default",attrs:{"clearable":"","name":"forma_pago","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.forma_pago),callback:function ($$v) {_vm.$set(_vm.form_item, "forma_pago", $$v)},expression:"form_item.forma_pago"}},_vm._l((_vm.pagos),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forma_pago')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6 "},[_c('label',{staticClass:"control-label"},[_vm._v("Valor de adquisición del vehículo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.precio_adquisicion_valor+' '+_vm.info.precio_adquisicion_moneda_id),expression:"info.precio_adquisicion_valor+' '+info.precio_adquisicion_moneda_id",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"customCurrency"},[_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"text-right",attrs:{"name":"precio_adquisicion_valor","type":"number","min":"0","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.form_item.precio_adquisicion_valor),callback:function ($$v) {_vm.$set(_vm.form_item, "precio_adquisicion_valor", $$v)},expression:"form_item.precio_adquisicion_valor"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.form_item.precio_adquisicion_moneda_id),callback:function ($$v) {_vm.$set(_vm.form_item, "precio_adquisicion_moneda_id", $$v)},expression:"form_item.precio_adquisicion_moneda_id"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.form_item.precio_adquisicion_moneda_id = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('precio_adquisicion_valor')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de Adquisición "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fecha_adquisicion),expression:"info.fecha_adquisicion",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],attrs:{"name":"fecha_adquisicion","type":"date","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Seleccione fecha"},model:{value:(_vm.form_item.fecha_adquisicion),callback:function ($$v) {_vm.$set(_vm.form_item, "fecha_adquisicion", $$v)},expression:"form_item.fecha_adquisicion"}})],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('fecha_adquisicion')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("En caso de baja del vehículo incluir motivo "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.motivo_baja),expression:"info.motivo_baja",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","name":"motivo_baja","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.motivo_baja),callback:function ($$v) {_vm.$set(_vm.form_item, "motivo_baja", $$v)},expression:"form_item.motivo_baja"}},_vm._l((_vm.bajas_inmueble),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1)],1),_vm._v(" "),(_vm.form_item.motivo_baja == 4)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique_baja),expression:"form_item.especifique_baja"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique_baja","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique_baja)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique_baja", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique_baja')))])]):_vm._e(),_vm._v(" "),_c('legend',[_vm._v("Lugar donde se ubica "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.lugar),expression:"info.lugar",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" País ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"pais","filterable":"","placeholder":"País"},model:{value:(_vm.form_item.lugar_registro_pais_id),callback:function ($$v) {_vm.$set(_vm.form_item, "lugar_registro_pais_id", $$v)},expression:"form_item.lugar_registro_pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('pais')))])],1),_vm._v(" "),(_vm.form_item.lugar_registro_pais_id==150)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" Entidad Federativa ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"entidad","filterable":"","placeholder":"Entidad"},model:{value:(_vm.form_item.lugar_registro_entidad_id),callback:function ($$v) {_vm.$set(_vm.form_item, "lugar_registro_entidad_id", $$v)},expression:"form_item.lugar_registro_entidad_id"}},_vm._l((_vm.entidades),function(option){return _c('el-option',{key:option.nom_ent,staticClass:"select-default",attrs:{"value":option.id,"label":option.nom_ent}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('entidad')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(!_vm.edit_item )?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(3)])]),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.titular_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.titular_id,_vm.titular_adeudo)))])]}},{key:"item.tipo_bien_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterCatalog(item.tipo_bien_id,_vm.tipos_vehiculos)))])]}}],null,false,4266931830)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("VEHÍCULOS (SITUACIÓN ACTUAL) ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de vehículos declarados a nombre la pareja, dependientes económicos y/o terceros o que sean en copropiedad con el declarante no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('legend',[_vm._v("Vehículos, aeronaves y/o embarcaciones")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "viuf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    var _ref;

    return _ref = {
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: '0',
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      entes: null,
      monedas: [],
      plazos: [],
      actividades: [],
      sectores: null,
      n_domicilio: null
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "monedas", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "entidadFed", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "municipios", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidades", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "localidad", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "paises", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isnum", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "item_actividades", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "list_actividades", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fields_list", [{
      key: "acciones",
      label: "Acciones",
      tdClass: "text-center"
    }, {
      key: "nombre_denominacion_razon_social",
      label: "Denominación o razón social",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "rfc",
      label: "RFC",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "curp",
      label: "CURP",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "sector_industria_id",
      label: "Sector",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "tipo_actividad_servicio_id",
      label: "Tipo de actividad ",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "descripcion_actividad_servicio",
      label: "Descripción de la actividad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "ingreso_bruto_anual",
      label: "Ingreso bruto anual ",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "moneda_id",
      label: "Moneda",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "duracion_frecuencia",
      label: "Duración / Frecuencia",
      tdClass: "text-center",
      formatter: 'emptyFields'
    }, {
      key: "unidad_temporal_id",
      label: "Unidad temporal",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "fecha_transaccion",
      label: "Fecha de transacción",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "observaciones",
      label: "Observaciones",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "pais_id",
      label: "País",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "entidad_federativa_id",
      label: "Entidad federativa",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "municipio_id",
      label: "Municipio",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "localidad_id",
      label: "Localidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "colonia",
      label: "Colonia",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_tipo_vial",
      label: "Tipo vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "vialidad_nom_vial",
      label: "Nombre vialidad",
      tdClass: "text-left",
      formatter: 'emptyFields'
    }, {
      key: "cp",
      label: "CP",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numExt",
      label: "Número exterior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }, {
      key: "numInt",
      label: "Número interior",
      tdClass: "text-right",
      formatter: 'emptyFields'
    }]), _ref;
  },

  computed: {
    getSigno: function getSigno() {
      var signo = "$";
      var val = this.item_actividades.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    getCodigoMoneda: function getCodigoMoneda() {
      var codigo = "MXN";
      var val = this.item_actividades.moneda_id;
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          codigo = item.codigo;
        }
      });
      return codigo;
    }
  },
  watch: {
    list_actividades: {
      handler: function handler() {
        if (this.list_actividades) {
          this.setLocalidades();
          if (this.list_actividades.length == 0) {
            this.bandera = '0';
          } else {
            this.bandera = '1';
          }
        }
      },
      deep: true
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_actividades.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_actividades.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_actividades.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_actividades.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_actividades.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_actividades.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_actividades.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_actividades.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_actividades.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_actividades.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    }
  },
  methods: {
    getSignoDos: function getSignoDos() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "97";

      var signo = "$";
      this.monedas.forEach(function (item) {
        if (item.id == val) {
          signo = item.signo;
        }
      });
      return signo;
    },
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return '-';
      }
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMoneda: function getMoneda(index) {
      var resp = "";
      if (this.monedas) {
        this.monedas.forEach(function (item) {
          if (item.id == index) {
            resp = item.moneda;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getActividad: function getActividad(index) {
      var resp = " ";
      if (this.sectores) {
        this.actividades.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getUnidades: function getUnidades(index) {
      var resp = " ";
      if (this.plazos) {
        this.plazos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: '',
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
      this.item_actividades = {
        acciones: "",
        rfc_quien_adquirio: "",
        ingreso_bruto_anual: "",
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: "",
        entidad_federativa_id: "",
        municipio_id: "",
        localidad_id: "",
        colonia: "",
        cp: "",
        numExt: "",
        numInt: "",
        vialidad_nom_vial: "",
        vialidad_tipo_vial: "",
        observaciones: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      if (this.item_actividades) {
        this.item_actividades.ip_id = this.ip_id;
        this.loadButton(this.$refs.btnSave);
        this.$http.post("actividades_empresariales", this.item_actividades).then(function (response) {
          _this.StepOk("Guardado");
          if (_this.edit_item === undefined || _this.edit_item === null) {
            _this.list_actividades.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.actividad));
          } else {
            _this.list_actividades.splice(_this.edit_item.index, 1, _this.item_actividades);
            _this.edit_item.item._rowVariant = "";
          }
          _this.showItem();
          _this.initItem();
          _this.edit_item = null;
        }, function (error) {
          _this.StepError(error);
        });
      } else {
        this.StepW("Hay campos sin completar");
      }
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_actividades = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_actividades[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_actividades[indice].id !== null) {
        var item = this.list_actividades[indice];

        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("actividades_empresariales/" + item.id).then(function (response) {
            _this2.list_actividades.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_actividades.pais_id ? this.item_actividades.pais_id : 150;
      this.n_domicilio.entidadF = this.item_actividades.entidad_federativa_id ? this.item_actividades.entidad_federativa_id : '';
      this.n_domicilio.municipio = this.item_actividades.municipio_id ? this.item_actividades.municipio_id : '';
      this.n_domicilio.localidad = this.item_actividades.localidad_id ? this.item_actividades.localidad_id : '';
      this.n_domicilio.cp = this.item_actividades.cp ? this.item_actividades.cp : '';
      this.n_domicilio.colonia = this.item_actividades.colonia ? this.item_actividades.colonia : '';
      this.n_domicilio.vialidad = this.item_actividades.vialidad_tipo_vial ? this.item_actividades.vialidad_tipo_vial : '';
      this.n_domicilio.vialidad_nombre = this.item_actividades.vialidad_nom_vial ? this.item_actividades.vialidad_nom_vial : '';
      this.n_domicilio.ext = this.item_actividades.numExt ? this.item_actividades.numExt : '';
      this.n_domicilio.int = this.item_actividades.numInt ? this.item_actividades.numInt : '';
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      this.list_actividades.forEach(function (item) {
        if (item.localidad_id) {
          _this3.$http.get('localidades/localidad/' + item.localidad_id).then(function (response) {
            _this3.localidades.push(response.data.localidad);
          }, function (error) {
            _this3.Err(error);
          });
        }
      });
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("actividades_empresariales/" + this.ip_id).then(function (response) {
      _this4.list_actividades = response.data.actividades;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_ente_publico").then(function (response) {
      _this4.entes = response.data.entes_publicos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_unidad_medida_plazo").then(function (response) {
      _this4.plazos = response.data.unidades;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_actividad").then(function (response) {
      _this4.actividades = response.data.actividad;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("monedas").then(function (response) {
      _this4.monedas = response.data.monedas;
      var temp = "97";
      _this4.monedas.forEach(function (item) {
        if (item.codigo == "MXN") {
          temp = item.id;
        }
      });
      _this4.item_actividades.moneda_id = temp;
    }, function (error) {
      _this4.Err(error);
    });
  }
});

/***/ }),

/***/ "wElS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wF53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Domicilio_vue__ = __webpack_require__("Ta4m");








var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'Domicilio', __WEBPACK_IMPORTED_MODULE_8__Domicilio_vue__["a" /* default */]), _components),

  data: function data() {
    var fechatemp = void 0;
    return {
      fechaIngresoOptions: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      },
      fechaSalidaOptions: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      },

      ip_id: null,
      datePicker: '',
      poderes: [],
      niveles: [],
      funcionesArr: [],
      funcionesExpArr: [],
      list_experiencia: [],
      edit_item: false,
      add_item: false,
      entidadFed: null,
      municipios: null,
      localidades: null,
      localidad: null,
      entes: [],
      ambitos: [],
      funciones: [],
      sectores: [],
      model: {},
      modelexp: {},
      model_funciones: [],
      n_domicilio: {},

      modelExp: {
        ambitoexp: {
          required: true
        },
        nombreins: {
          required: true
        },
        unidadadm: {
          required: true
        },
        jerarqexp: {
          required: true
        },
        cargopuesto: {
          required: true
        },
        fecha_ingreso: {
          required: true
        }
      },
      headers: [{
        value: "acciones",
        text: "Acciones",
        align: "center",
        sortable: true
      }, {
        value: "ambito_id",
        text: "Ámbito",
        align: "text-left"
      }, {
        value: "nivel_gobierno_id",
        text: "Nivel",
        align: "text-left"
      }, {
        value: "poder_ente_id",
        text: "Poder Jurídico",
        align: "text-left"
      }, {
        value: "nombre_institucion",
        text: "Nombre",
        align: "text-left"
      }, {
        value: "unidad_administrativa",
        text: "Unidad",
        align: "text-left"
      }, {
        value: "sector_industria_id",
        text: "Sector/Industria",
        align: "text-left"
      }, {
        value: "jerarquia_rango",
        text: "Jerarquia",
        align: "text-left"
      }, {
        value: "cargo_puesto",
        text: "Cargo/Puesto",
        align: "text-left"
      }, {
        value: "fecha_ingreso",
        text: "Fecha Ingreso",
        align: "text-left"
      }, {
        value: "fecha_salida",
        text: "Fecha Salida",
        align: "text-left"
      }, {
        value: "direccion_pais_id",
        text: "País",
        align: "text-left"
      }, {
        value: "direccion_entidad_federativa_id",
        text: "Entidad Federativa",
        align: "text-left"
      }, {
        value: "direccion_municipio_id",
        text: "Municipio",
        align: "text-left"
      }]

    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getFunciones();

    this.ip_id = this.getId();
    this.getSectores();
    this.getPoderes();
    this.getNivelesG();
    this.getAmbitos();
    this.getExperiencia();
    this.getEntes();
    this.$http.get("entidadFed").then(function (response) {
      _this.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this.Err(error);
    });

    this.$http.get("municipios").then(function (response) {
      _this.municipios = response.data.municipios;
    }, function (error) {
      _this.Err(error);
    });
  },

  watch: {
    model_funciones: function model_funciones(val) {
      this.modelexp.funcionesp = val;
    },
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.modelexp.direccion_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
          this.modelexp.direccion_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.modelexp.direccion_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.modelexp.direccion_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.modelexp.direccion_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.modelexp.direccion_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.modelexp.direccion_numext = this.n_domicilio.ext;
          this.modelexp.direccion_numint = this.n_domicilio.int;
          this.modelexp.direccion_localidad_id = this.n_domicilio.localidad;
          this.modelexp.direccion_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
        }
      },
      deep: true
    }
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getAmbito: function getAmbito(index) {
      var resp = "";
      if (this.ambitos) {
        this.ambitos.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getPoder: function getPoder(index) {
      var resp = "";
      if (this.poderes) {
        this.poderes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getNivel: function getNivel(index) {
      var resp = "";
      if (this.niveles) {
        this.niveles.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = "";
      if (this.sectores && index) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    cancelEdit: function cancelEdit() {
      this.limpiaCampos();
      this.edit_item = false;
      this.add_item = false;
      this.model_funciones = [];
      this.$validator.pause();
    },
    getExperiencia: function getExperiencia() {
      var _this2 = this;

      var v = this;
      this.$http.get('expLaboral/' + this.ip_id).then(function (response) {
        _this2.list_experiencia = response.data.experiencia;
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getEntes: function getEntes() {
      var _this3 = this;

      var v = this;
      this.$http.get('cat_ente_publico').then(function (response) {
        _this3.entes = response.data.entes_publicos;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    getSafe: function getSafe(fn, defaultVal) {
      try {
        return fn();
      } catch (e) {
        return defaultVal;
      }
    },
    addItem: function addItem() {
      var _this4 = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          _this4.loadButton(_this4.$refs.btnSave);
          _this4.$http.put('expLaboral/' + _this4.ip_id, _this4.modelexp).then(function (response) {
            _this4.StepOk("Guardado");

            if (!_this4.edit_item) {
              _this4.list_experiencia.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.registro));
            } else {
              var index = _this4.list_experiencia.map(function (u) {
                return u.id;
              }).indexOf(response.data.registro.id);
              _this4.list_experiencia.splice(index, 1, response.data.registro);
            }

            _this4.cancelEdit();
          }, function (error) {
            _this4.StepError(error);
          });
        } else {
          _this4.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(item) {
      this.limpiaCampos();
      this.showItem();
      this.edit_item = true;

      this.modelexp = item;

      var v = this;

      this.model_funciones = this.modelexp.funciones.map(function (obj) {
        return obj.funcion_id;
      });

      this.editDomicilio();

      $(".main-panel").animate({
        scrollTop: 1300
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this5 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this5.$http.delete("expLaboral/" + item.id).then(function (response) {
            var index = _this5.list_experiencia.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this5.list_experiencia.splice(index, 1);
            _this5.StepOk('Registro eliminado');
          }, function (error) {
            _this5.Err(error);
          });
        });
      }
    },
    limpiaCampos: function limpiaCampos() {
      this.funcionesArr = [], this.funcionesExpArr = [], this.modelexp = {
        ambito_id: '',
        nivel_gobierno_id: '',
        poder_ente_id: '',
        nombre_institucion: '',
        unidad_administrativa: '',
        sector_industria_id: '',
        jerarquia_rango: '',
        cargo_puesto: '',
        fecha_ingreso: '',
        fecha_salida: '',
        funcionesp: [],
        otras_funciones: ''
      };
      this.n_domicilio = {
        pais: 150,
        entidadF: '',
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      };
    },
    editDomicilio: function editDomicilio() {
      var v = this;
      this.n_domicilio = {
        'pais_id': v.modelexp.direccion_pais_id,
        'entidadF': v.modelexp.direccion_entidad_federativa_id,
        'municipio': v.modelexp.direccion_municipio_id,
        'colonia': v.modelexp.direccion_colonia,
        'cp': v.modelexp.direccion_cp,
        'localidad': v.modelexp.direccion_localidad_id,
        'ext': v.modelexp.direccion_numext,
        'int': v.modelexp.direccion_numint,
        'vialidad': v.modelexp.direccion_vialidad_tipo,
        'vialidad_nombre': v.modelexp.direccion_vialidad_nombre
      };
    },
    showInput: function showInput() {
      var _this6 = this;

      this.tags.inputVisible = true;
      this.$nextTick(function () {
        _this6.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tags.inputValue;
      if (inputValue) {
        this.tags.dynamicTags.push(inputValue);
      }
      this.tags.inputVisible = false;
      this.tags.inputValue = '';
    },
    getPoderes: function getPoderes() {
      var _this7 = this;

      this.$http.get('poderJuridico').then(function (response) {
        _this7.poderes = response.data.poderJuridico;
      }, function (error) {
        _this7.StepError(error);
      });
    },
    getNivelesG: function getNivelesG() {
      var _this8 = this;

      this.$http.get('nivelGobierno').then(function (response) {
        _this8.niveles = response.data.nivelGobierno;
      }, function (error) {
        _this8.StepError(error);
      });
    },
    getAmbitos: function getAmbitos() {
      var _this9 = this;

      this.$http.get('ambitos').then(function (response) {
        _this9.ambitos = response.data.ambitos;
      }, function (error) {
        _this9.StepError(error);
      });
    },
    getSectores: function getSectores() {
      var _this10 = this;

      this.$http.get('cat_sector_industria').then(function (response) {
        _this10.sectores = response.data.sectores;
      }, function (error) {
        _this10.StepError(error);
      });
    },
    getFunciones: function getFunciones() {
      var _this11 = this;

      this.$http.get('funcPrinc').then(function (response) {
        _this11.funciones = response.data.funciones;
      }, function (error) {
        _this11.StepError(error);
      });
    }
  }
});

/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("EXM4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("0hPu");
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wObG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Cumplimiento_vue__ = __webpack_require__("osWK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_91c774e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Cumplimiento_vue__ = __webpack_require__("H13J");
function injectStyle (ssrContext) {
  __webpack_require__("/ObX")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Cumplimiento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_91c774e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Cumplimiento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "whdn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_InicioLayout_vue__ = __webpack_require__("dqBf");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_500f741c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_InicioLayout_vue__ = __webpack_require__("xcBc");
function injectStyle (ssrContext) {
  __webpack_require__("p5X9")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_InicioLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_500f741c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_InicioLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "wjcp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"error-color":"#EB5E28","color":"#1e94fd","title":"Alta de Servidor Público","subtitle":""}},[_c('div',[_c('altas',{ref:"Altas"})],1),_vm._v(" "),_c('button',{staticClass:"d-none",attrs:{"slot":"next"},slot:"next"},[_vm._v("Siguiente")]),_vm._v(" "),_c('button',{staticClass:"d-none",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Siguientes")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wx0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Domicilio "+_vm._s(_vm.titulo)+"\n      "),(_vm.popover != '')?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.popover),expression:"popover",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Se encuentra en")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"data-vv-name":"lugarv","name":"lugarv","label":"1"},model:{value:(_vm.lugar),callback:function ($$v) {_vm.lugar=$$v},expression:"lugar"}},[_vm._v("México")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"data-vv-name":"lugarv","name":"lugarv","label":"2"},model:{value:(_vm.lugar),callback:function ($$v) {_vm.lugar=$$v},expression:"lugar"}},[_vm._v("Extranjero")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('lugarv')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre de la Calle")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.domicilio.vialidad_nombre),expression:"domicilio.vialidad_nombre"}],staticClass:"form-control",attrs:{"name":"vialidadv","data-vv-name":"vialidadv","type":"text","placeholder":"Nombre de la vía"},domProps:{"value":(_vm.domicilio.vialidad_nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.domicilio, "vialidad_nombre", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('vialidadv')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-2"},[_c('label',{staticClass:"control-label"},[_vm._v("No. Ext.")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.domicilio.ext),expression:"domicilio.ext"}],staticClass:"form-control",attrs:{"data-vv-name":"extv","type":"text","name":"extv","placeholder":"Número Exterior."},domProps:{"value":(_vm.domicilio.ext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.domicilio, "ext", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('extv')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-2"},[_c('label',{staticClass:"control-label"},[_vm._v("No. Int.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.domicilio.int),expression:"domicilio.int"}],staticClass:"form-control",attrs:{"data-vv-name":"int","type":"text","name":"int","placeholder":"Número Interior."},domProps:{"value":(_vm.domicilio.int)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.domicilio, "int", $event.target.value)}}})]),_vm._v(" "),(_vm.lugar == '1')?_c('div',{staticClass:"form-group col-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Entidad Federativa")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","data-vv-name":"entidadv","name":"entidadv","filterable":"","placeholder":"Entidad"},on:{"change":_vm.getMunicipios},model:{value:(_vm.domicilio.entidadF),callback:function ($$v) {_vm.$set(_vm.domicilio, "entidadF", $$v)},expression:"domicilio.entidadF"}},_vm._l((_vm.entidades),function(option){return _c('el-option',{key:option.nom_ent,staticClass:"select-default",attrs:{"value":option.id,"label":option.nom_ent}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('entidadv')))])],1):_vm._e(),_vm._v(" "),(_vm.lugar == '1')?_c('div',{staticClass:"form-group col-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Municipio / Alcaldia")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"municipiov","disabled":!_vm.municipios,"data-vv-name":"municipiov","filterable":"","placeholder":"Municipio"},on:{"change":_vm.getLocalidades},model:{value:(_vm.domicilio.municipio),callback:function ($$v) {_vm.$set(_vm.domicilio, "municipio", $$v)},expression:"domicilio.municipio"}},_vm._l((_vm.municipios),function(option){return _c('el-option',{key:option.nom_mun,staticClass:"select-default",attrs:{"value":option.id,"label":option.nom_mun}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('municipiov')))])],1):_vm._e(),_vm._v(" "),(_vm.lugar == '1')?_c('div',{staticClass:"form-group col-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Colonia / Localidad")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.domicilio.colonia),expression:"domicilio.colonia"}],staticClass:"form-control",attrs:{"name":"coloniav","data-vv-name":"coloniav","type":"text","placeholder":"Colonia"},domProps:{"value":(_vm.domicilio.colonia)},on:{"change":function($event){return _vm.$emit('change', $event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.domicilio, "colonia", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('coloniav')))])]):_vm._e(),_vm._v(" "),(_vm.lugar == '2')?_c('div',{staticClass:"form-group col-4"},[_c('label',{staticClass:"control-label"},[_vm._v("País")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"paisv","data-vv-name":"paisv","filterable":"","placeholder":"País"},model:{value:(_vm.domicilio.pais_id),callback:function ($$v) {_vm.$set(_vm.domicilio, "pais_id", $$v)},expression:"domicilio.pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('paisv')))])],1):_vm._e(),_vm._v(" "),(_vm.lugar == '2')?_c('div',{staticClass:"form-group col-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Estado / Provincia")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.domicilio.estadoproviencia),expression:"domicilio.estadoproviencia"}],staticClass:"form-control",attrs:{"name":"estadoprovienciav","data-vv-name":"estadoprovienciav","type":"text","placeholder":"Estado/Provincia"},domProps:{"value":(_vm.domicilio.estadoproviencia)},on:{"change":function($event){return _vm.$emit('change', $event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.domicilio, "estadoproviencia", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('estadoproviencia')))])]):_vm._e(),_vm._v(" "),(_vm.lugar == '2')?_c('div',{staticClass:"form-group col-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Ciudad / Localidad")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.domicilio.colonia),expression:"domicilio.colonia"}],staticClass:"form-control",attrs:{"name":"coloniav","data-vv-name":"coloniav","type":"text","placeholder":"Colonia"},domProps:{"value":(_vm.domicilio.colonia)},on:{"change":function($event){return _vm.$emit('change', $event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.domicilio, "colonia", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('coloniav')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-4"},[_c('label',{staticClass:"control-label"},[_vm._v("CP")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|integer'),expression:"'required|integer'"},{name:"model",rawName:"v-model",value:(_vm.domicilio.cp),expression:"domicilio.cp"}],staticClass:"form-control",attrs:{"name":"cpv","data-vv-name":"cpv","maxlength":"5","type":"text","placeholder":"Código Postal"},domProps:{"value":(_vm.domicilio.cp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.domicilio, "cp", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('cpv')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"display":"none"}},[(_vm.lugar == '1')?_c('div',{staticClass:"form-group col-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Localidad")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"clearable":"","name":"localidadv","data-vv-name":"localidadv","filterable":"","placeholder":"Localidad"},model:{value:(_vm.domicilio.localidad),callback:function ($$v) {_vm.$set(_vm.domicilio, "localidad", $$v)},expression:"domicilio.localidad"}},_vm._l((_vm.localidades),function(option){return _c('el-option',{key:option.cve_loc,staticClass:"select-default",attrs:{"value":option.id,"label":option.nom_loc}})}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Víalidad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.domicilio.vialidad),expression:"domicilio.vialidad"}],staticClass:"form-control",attrs:{"name":"tvialidadv","data-vv-name":"tvialidadv","type":"text","placeholder":"(Calle, Avenida, Bulevar, Callejón)"},domProps:{"value":(_vm.domicilio.vialidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.domicilio, "vialidad", $event.target.value)}}})])]),_vm._v(" "),(_vm.vista)?_c('div',{staticClass:"form-group col-12"},[_c('label',[_vm._v("Aclaraciones y observaciones del domicilio")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.domicilio.domicilio_observaciones),expression:"domicilio.domicilio_observaciones"}],staticClass:"form-control",attrs:{"type":"text","name":"domicilio_observaciones","placeholder":"Aclaraciones y observaciones"},domProps:{"value":(_vm.domicilio.domicilio_observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.domicilio, "domicilio_observaciones", $event.target.value)}}})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xIGm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("kDzH");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_9__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      bandera: '0',
      ip_id: 1,
      add_item: false,
      edit_item: null,
      search: '',
      form_item: {},
      table_list: [],
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Participante',
        value: 'participante',
        align: 'center'
      }, {
        text: 'Nombre de la institución',
        value: 'nombre',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Puesto/rol',
        value: 'puesto',
        align: 'center'
      }, {
        text: 'Fecha',
        value: 'fecha',
        align: 'center'
      }],
      info: {
        decisiones: 'Refiere a la condición de pertenencia formal del declarante a alguna institución (Asociación Civil, Consejo y/o Junta, Organizaciones Benéficas, Partidos Políticos, Gremios/Sindicatos u otros) y que cuente con poder de decisión en ella. Deberá reportar hasta los últimos dos años.',
        participante: 'Señalar quien tiene participación en la empresa sociedad o asociación.',
        tipo: 'Señalar del catálogo, alguna de las siguientes: organizaciones de la sociedad civil, organizaciones benéficas, partidos políticos, gremios/sindicatos, otro, especifique.',
        fecha: 'Señalar la fecha en que inicio funciones en la institución u organización.',
        nombre: 'Proporcionar la denominación o razón social de la institución, tal y como se encuentra registrada formalmente.',
        rfc: 'Proporcionar los 12 dígitos del registro de la institución.',
        puesto: 'Indicar el cargo o función que ejerce el Declarante.',
        remunerado: 'Indicar sí o no.',
        monto: 'Especificar el monto mensual neto, sin centavos que percibe por su participación.',
        lugar: 'Indicar si se encuentra en México, debiendo señalar entidad federativa; o en el extranjero, debiendo señalar el país donde se localiza.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
      if (!this.form_item.pais_id) {
        this.form_item.pais_id = 150;
      }
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = null;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("toma_decisiones", _this.form_item).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = item;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.edit_item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("toma_decisiones/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');
    this.$http.get("toma_decisiones/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();

    this.form_item.pais_id = 150;
  }
});

/***/ }),

/***/ "xQl+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xRX4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Observaciones_vue__ = __webpack_require__("pXQN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_193a3748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Observaciones_vue__ = __webpack_require__("ZwRO");
function injectStyle (ssrContext) {
  __webpack_require__("z0Ta")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Observaciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_193a3748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Observaciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xSWu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xYbJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");












var _components;






/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a), _components),
  data: function data() {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        periodo: '2021'
      },
      dependencias: {},
      rol: '',
      filter: null,
      currentPage: 1,
      perPage: 50,
      periodos: [],
      rows: null,
      tiposDeclaracion: [{
        'id': 1,
        'tipo_declaracion': 'Inicial'
      }, {
        'id': 2,
        'tipo_declaracion': 'Anual'
      }, {
        'id': 3,
        'tipo_declaracion': 'Final'
      }],
      list_cumplimiento: [],

      filtro_usuarios: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Fecha de presentación',
        value: 'id',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Correo Laboral',
        value: 'correo',
        align: 'center'
      }],
      headers2: [{
        text: 'Fecha de presentación',
        value: 'id',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Correo Laboral',
        value: 'correo',
        align: 'center'
      }],

      propsToSearch: ['rfc', 'nombres'],
      tableColumns: [{
        prop: 'id',
        label: 'Dec',
        minWidth: 150,
        vif: false
      }, {
        prop: 'rfc',
        label: 'RFC',
        minWidth: 150,
        vif: true
      }, {
        prop: 'nombres',
        label: 'Nombre',
        minWidth: 100,
        vif: true
      }]
    };
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_cumplimiento.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_cumplimiento.length;
        return this.pagedData;
      }
      var result = this.list_cumplimiento.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_cumplimiento.length;

      return this.list_cumplimiento.length;
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    checkPermissions: function checkPermissions() {
      var permiso = [1, 25];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getDependencias: function getDependencias() {
      var _this2 = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this2.dependencias = response.data.entes_publicos;
        _this2.dependencias.unshift({
          'codigo': 'T',
          'id': 0,
          'valor': 'Todas'
        });
      }, function (error) {
        _this2.StepError(error);
      });
    },
    getTipoDeclaracion: function getTipoDeclaracion() {},
    getPeriodos: function getPeriodos() {
      var _this3 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        _this3.periodos = response.data.periodos;
      }, function (error) {
        _this3.StepError(error);
      });
    },
    getDeclaraciones: function getDeclaraciones() {
      var _this4 = this;

      this.$http.post("ldeclaraciones", this.model).then(function (response) {
        _this4.list_cumplimiento = [];
        response.data.declarantes.forEach(function (value, key) {
          _this4.list_cumplimiento.push({
            'id': value.decid,
            'fecha': value.fecha,
            'rfc': value.rfc,
            'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
            'entidad': value.ente,
            'correo': value.correo
          });
        });
        _this4.filtro_usuarios = _this4.list_cumplimiento;
      }, function (error) {
        _this4.StepError(error);
      });
    },
    descargar: function descargar(row) {
      var _this5 = this;

      this.Ask("¿Desea descargar ésta declaración?", function () {
        var cargando = _this5.$swal({
          showConfirmButton: false,
          type: "warning",
          title: _this5.texto,
          text: 'Esta información es confidencial y tu acceso ha sido registrado por políticas de seguridad',
          showCloseButton: _this5.close
        });
        _this5.$http.get(_this5.$apiUrl + 'getDeclaracion1/pdf/' + row.id + "/" + _this5.getKey('uid'), {
          responseType: 'arraybuffer'
        }).then(function (response) {
          _this5.downloadFile(response, 'Declaración');
        }, function (error) {
          _this5.StepError(error);
        });
      });
    },
    descargar1: function descargar1(row) {
      var _this6 = this;

      this.Ask("¿Desea descargar ésta declaración?", function () {
        var cargando = _this6.$swal({
          showConfirmButton: false,
          type: "warning",
          title: _this6.texto,
          text: 'Esta información es confidencial y tu acceso ha sido registrado por políticas de seguridad',
          showCloseButton: _this6.close
        });
        _this6.$http.get(_this6.$apiUrl + 'getDeclaracionComp/pdf/' + row.id + "/" + _this6.getKey('uid'), {
          responseType: 'arraybuffer'
        }).then(function (response) {
          _this6.downloadFile(response, 'Declaración');
        }, function (error) {
          _this6.StepError(error);
        });
      });
    },
    downloadFile: function downloadFile(response, filename) {
      var newBlob = new Blob([response.body], {
        type: 'application/pdf'
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      var data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = data;
      link.download = filename + '.pdf';
      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(data);
      }, 100);
    }
  },
  created: function created() {
    this.getDependencias();
    this.getTipoDeclaracion();
    this.getPeriodos();
    this.rol = this.getKey('role');
    this.checkPermissions();
  }
});

/***/ }),

/***/ "xcBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content'),_vm._v(" "),_c('content-footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xgBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Pasivos_vue__ = __webpack_require__("Qry8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d2bd15_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Pasivos_vue__ = __webpack_require__("Z1kT");
function injectStyle (ssrContext) {
  __webpack_require__("CjQB")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_Pasivos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d2bd15_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_Pasivos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xsqu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xwvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{ref:"wizard",attrs:{"error-color":"#EB5E28","color":"#1e94fd","title":"Información Personal","subtitle":"","finishButtonText":"Siguiente"},on:{"on-loading":_vm.setLoading}},[_c('tab-content',{attrs:{"title":"Información General","icon":"ti-user","before-change":_vm.guardaDatosPersonales}},[_c('datos-personales',{ref:"DatosPersonales"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Datos Curriculares","icon":"ti-book","before-change":_vm.guardaDatosCurric}},[_c('datos-curriculares',{ref:"DatosCurriculares"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Experiencia Laboral","icon":"ti-briefcase","before-change":_vm.guardaExperienciaLaboral}},[_c('experiencia-laboral',{ref:"ExperienciaLaboral"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Pareja y/o dependiente económico ","icon":"ti-user","before-change":_vm.terminaDependientes}},[_c('datos-conyuge',{ref:"DatosConyuge"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Encargo Actual","icon":"ti-briefcase","before-change":_vm.terminaActual}},[_c('encargo-actual',{ref:"EncargoActual"})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Atrás")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v("Siguiente")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Siguiente")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xzrE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("l+io");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Formularios_Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("VrZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);









var _components, _methods;






/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'Domicilio', __WEBPACK_IMPORTED_MODULE_9__Formularios_Domicilio_vue__["a" /* default */]), _components),
  inject: ['$validator'],

  data: function data() {
    var _ref;

    return _ref = {
      txtemp: '',
      coloremp: '',
      filter: '',
      uTemp: {},
      periodos: [],
      pendientes: false,
      mostrarCampos: false,
      transferencia: {},
      validaciones: {
        curp: false,
        rfc: false,
        rfc_patron: false
      },
      datePicker: '',
      ip_id: null,

      regexp: {
        mail: ''
      },
      n_domicilio: {
        pais_id: 150,
        entidadF: 11,
        municipio: '',
        localidad: '',
        cp: '',
        colonia: '',
        vialidad: '',
        vialidad_nombre: '',
        ext: '',
        int: ''
      },
      model: {
        area_adscripcion: '',
        contratado_honorarios: '2',
        correo_laboral: '',
        curp: '',
        direccion_encargo_colonia: '',
        direccion_encargo_cp: '',
        direccion_encargo_entidad_federativa_id: '',
        direccion_encargo_localidad_id: '',
        direccion_encargo_municipio_id: '',
        direccion_encargo_numext: '',
        direccion_encargo_numint: '',
        direccion_encargo_pais_id: 150,
        direccion_vialidad_nombre: '',
        direccion_vialidad_tipo: '',
        empleo_cargo_comision: '',
        ente_publico_id: '',
        fecha_nacimiento: '',
        fecha_posesion: '',
        simplificada: '',
        nivel_encargo: '',
        nombres: '',
        primer_apellido: '',
        rfc: '',
        rfc_patron: '',
        periodo: null,
        tipo_dec: 1,
        segundo_apellido: '',
        telefono_laboral_extension: '',
        telefono_laboral_numero: ''
      },
      opciones: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'mostrarCampos', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'ip_id', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'datePicker', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'edit_item', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'add_item', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'entidadFed', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'municipios', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'localidades', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'localidad', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'entes', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'ambitos', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'funciones_p', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'tipos', [{
      'id': 1,
      'valor': 'Simplificada'
    }, {
      'id': 0,
      'valor': 'Completa'
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'tipo_declaracion', [{
      'id': 1,
      'valor': 'Inicial'
    }, {
      'id': 2,
      'valor': 'Anual'
    }, {
      'id': 3,
      'valor': 'Final'
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'sectores', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'modelValidations', {

      tipo: {
        required: true
      },
      correo_laboral: {
        email: true
      },
      ente: {
        required: true
      },
      nombre_cargo: {
        required: true
      },
      nivel: {
        required: true
      },
      honorarios: {
        required: true
      },
      nivel_orden: {
        required: true
      },
      area: {
        required: true
      },
      toma_posesion: {
        required: true
      },
      nombres: {
        required: true
      },
      primer_apellido: {
        required: true
      },
      curp: {
        required: true,
        max: 18
      },
      rfc: {
        required: true,
        max: 13
      },
      rfc_patron: {
        max: 13
      },
      fecha_nacimiento: {
        required: true
      },
      correo_electronico_laboral: {
        email: true
      }
    }), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["c" /* mapFields */])(['nombres', 'primer_apellido', 'rfc', 'curp', 'fecha_nacimiento', 'correo_electronico_laboral', "correo_laboral", "ente", "nombre_cargo", "nivel", "honorarios", "area", "toma_posesion", "unidadadm", 'rfc_patron', 'tipo', 'tipo_dec', 'periodo']), {
    busqueda: function busqueda() {
      if (this.filter.length >= 1 && this.filter.length < 10) {
        return true;
      } else {
        return false;
      }
    }
  }),
  watch: {
    n_domicilio: {
      handler: function handler() {

        if (this.n_domicilio) {
          this.model.direccion_encargo_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
          this.model.direccion_encargo_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.model.direccion_encargo_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.model.direccion_encargo_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.model.direccion_encargo_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.model.direccion_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.model.direccion_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.model.direccion_encargo_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.model.direccion_encargo_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
          this.model.direccion_encargo_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.model.domicilio_observaciones = this.n_domicilio.domicilio_observaciones ? this.n_domicilio.domicilio_observaciones : "";
        }
      },
      deep: true
    },

    filter: function filter(val) {
      var _this = this;

      this.coloremp = 'info';
      this.uTemp = {};
      this.pendientes = false;
      if (val && val.length >= 10) {
        this.txtemp = 'Buscando...';
        this.uTemp = {};
        this.$http.get("infpersonal/altas/" + val).then(function (response) {

          if (response.data.usuarios.length == 0) {
            _this.coloremp = 'danger';
            _this.txtemp = 'No encontrado';
            _this.pendientes = true;
            _this.$validator.resume();
          } else {
            _this.txtemp = '';
            _this.uTemp = response.data.usuarios;

            if (_this.uTemp.fecha_termino != null) {
              _this.pendientes = true;
              _this.$validator.resume();
            } else {
              _this.pendientes = false;
            }
          }
        }, function (error) {
          _this.Err(error);
        });
      } else {
        this.txtemp = 'Buscando...';
        this.pendientes = false;
      }
    },


    '$route': 'checkPermissions'
  },
  methods: (_methods = {
    getPeriodos: function getPeriodos() {
      var _this2 = this;

      var v = this;
      this.$http.get("getPeriodos").then(function (response) {
        var anios = response.data.periodos;

        anios.forEach(function (y) {
          if (y.year) {
            _this2.periodos.push(y);
          }
        });
        _this2.model.periodo = _this2.periodos[0].year;
      }, function (error) {
        _this2.StepError(error);
      });
    },
    copyData: function copyData() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.model.nombres = _this3.uTemp.nombres;
        _this3.model.primer_apellido = _this3.uTemp.primer_apellido;
        _this3.model.segundo_apellido = _this3.uTemp.segundo_apellido;
        _this3.model.curp = _this3.uTemp.curp;
        _this3.model.rfc = _this3.uTemp.rfc;
        _this3.model.fecha_nacimiento = _this3.uTemp.fecha_nacimiento;
        _this3.model.simplificada = _this3.uTemp.simplificada;
        _this3.model.tipo_dec = 1;
        _this3.model.periodo = _this3.periodos[0].year;
      });
    },
    checkPermissions: function checkPermissions() {
      var permiso = [3];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    isTrue: function isTrue(currentValue) {
      return currentValue;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEnte: function getEnte(index) {
      var resp = " ";
      if (this.entes) {
        this.entes.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.limpiaCampos();
      this.showItem();
      this.edit_item = null;
    },
    getEntes: function getEntes() {
      var _this4 = this;

      var v = this;
      this.$http.get("cat_ente_publico").then(function (response) {
        _this4.entes = response.data.entes_publicos;
      }, function (error) {
        _this4.StepError(error);
        console.log(error);
      });
    },
    getSafe: function getSafe(fn, defaultVal) {
      try {
        return fn();
      } catch (e) {
        return defaultVal;
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'getError', function getError(fieldName) {
    return this.errors.first(fieldName);
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'validate', function validate() {
    var v = this;
    this.validaciones = {
      curp: false,
      rfc: false,
      rfc_patron: false
    };

    var validacurp = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!v.curpValida(v.getSafe(function () {
        return v.model.curp;
      }, ''))) {
        v.validaciones.curp = true;
        return reject(false);
      } else {
        return resolve(true);
      }
    });
    var validarfc = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!v.rfcValido(v.getSafe(function () {
        return v.model.rfc;
      }, ''))) {
        v.validaciones.rfc = true;
        return reject(false);
      } else {
        return resolve(true);
      }
    });
    var validarfcp = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      return resolve(true);
    });
    var dpersonales = this.$validator.validateAll();

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([dpersonales, validacurp, validarfc, validarfcp]);
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'getSafe', function getSafe(fn, defaultVal) {
    try {
      return fn();
    } catch (e) {
      return defaultVal;
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'guardar', function guardar() {
    var _this5 = this;

    if (!this.getKey('permisos').includes(17)) {
      this.model.ente_publico_id = this.getKey('ente_publico_id');
    }

    var v = this;
    this.validate().then(function (response) {
      if (response.every(_this5.isTrue)) {
        _this5.$http.post("infpersonal", _this5.model).then(function (response) {
          if (response.data.mensaje.id != 'Ok') {
            if (response.data.baja == "si") {
              __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                title: 'El RFC fué dado de baja con ésta información',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'SI',
                cancelButtonText: 'NO',
                html: '<b>RFC: </b>' + response.data.mensaje.rfc + '<br>' + '<b>CURP: </b>' + response.data.mensaje.curp + '<br>' + '<b>Dependencia:</b>' + response.data.mensaje.encargo.ente.valor + '<br>' + '<b>Cargo: </b>' + response.data.mensaje.encargo.empleo_cargo_comision + '<br>' + '¿Deseas crear el alta con los nuevos datos?',
                buttonsStyling: false
              }).then(function () {

                v.transferencia.ip_id = response.data.mensaje.id;
                v.transferencia.ente_publico_origen = response.data.mensaje.encargo.ente_publico_id;
                v.transferencia.ente_publico_destino = v.model.ente_publico_id;
                v.transferencia.datos_cambio = v.model;


                v.transferencia.datos_actuales = {
                  rfc: response.data.mensaje.rfc,
                  nombres: response.data.mensaje.nombres,
                  primer_apellido: response.data.mensaje.primer_apellido,
                  segundo_apellido: response.data.mensaje.segundo_apellido,
                  curp: response.data.mensaje.curp,
                  area_adscripcion: response.data.mensaje.encargo.area_adscripcion,
                  contratado_honorarios: response.data.mensaje.encargo.contratado_honorarios,
                  correo_laboral: response.data.mensaje.encargo.correo_laboral,
                  empleo_cargo_comision: response.data.mensaje.encargo.empleo_cargo_comision,
                  ente_publico_id: response.data.mensaje.encargo.ente_publico_id,
                  fecha_nacimiento: response.data.mensaje.fecha_nacimiento,
                  fecha_posesion: response.data.mensaje.encargo.fecha_posesion,
                  simplificada: response.data.mensaje.encargo.simplificada,
                  nivel_encargo: response.data.mensaje.encargo.nivel_encargo,
                  fecha_termino: response.data.mensaje.encargo.fecha_termino

                };

                v.$http.post("reabaja", v.transferencia).then(function (response) {
                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Alta',
                    text: 'Alta exitosa',
                    type: 'success',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    buttonsStyling: false
                  });

                  v.limpiaCampos();
                }, function (error) {
                  v.Err(error);
                });
              }).catch(function (e) {
                console.log("catch");
              });
            } else {
              _this5.StepW("Ya existe un registro con ese RFC o CURP en ésta dependencia");
            }
          } else {
            _this5.StepOk("Declarante Guardado");
            _this5.limpiaCampos();
          }
        }, function (error) {
          _this5.StepError(error);
        }).catch(function (e) {
          console.log(e);
        });
      }
    }).catch(function (e) {
      reject(false);
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'limpiaCampos', function limpiaCampos() {
    this.$validator.pause();
    this.filter = '';
    this.pendientes = false;
    this.uTemp = {};
    this.model = {
      area_adscripcion: '',
      contratado_honorarios: '2',
      correo_laboral: '',
      curp: '',
      direccion_encargo_colonia: '',
      direccion_encargo_cp: '',
      direccion_encargo_entidad_federativa_id: '',
      direccion_encargo_localidad_id: '',
      direccion_encargo_municipio_id: '',
      direccion_encargo_numext: '',
      direccion_encargo_numint: '',
      direccion_encargo_pais_id: 150,
      direccion_vialidad_nombre: '',
      direccion_vialidad_tipo: '',
      empleo_cargo_comision: '',
      ente_publico_id: '',
      fecha_nacimiento: '',
      fecha_posesion: '',
      simplificada: '',
      nivel_encargo: '',
      nombres: '',
      primer_apellido: '',
      rfc: '',
      rfc_patron: '',
      segundo_apellido: '',
      telefono_laboral_extension: '',
      telefono_laboral_numero: '',
      periodo: null,
      tipo_dec: 1
    };
    this.n_domicilio = {
      pais_id: 150,
      entidadF: 11,
      municipio: '',
      localidad: '',
      cp: '',
      colonia: '',
      vialidad: '',
      vialidad_nombre: '',
      ext: '',
      int: ''
    };
  }), _methods),
  created: function created() {
    this.getPeriodos();
    this.getKey('ente');
    this.checkPermissions();
    this.ip_id = this.getId();
    this.getEntes();
  },
  mounted: function mounted() {
    this.checkCatalogs();
  }
});

/***/ }),

/***/ "y0Yb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "y1Gp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("mX1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__ = __webpack_require__("yTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("kDzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Domicilio_vue__ = __webpack_require__("Ta4m");










var _components;




/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input_number___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_10__Domicilio_vue__["a" /* default */]), _components),
  props: ["data"],
  data: function data() {
    return {
      validaciones: {
        rfc: false
      },
      operaciones: null,
      frecuencias: null,
      personas: null,
      responsables: null,
      naturalezas: null,
      colaboraciones: null,
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: "0",
      sectores: null,
      n_domicilio: null,
      actividad_economica: null,
      monedas: [],
      entidadFed: null,
      municipios: null,
      localidades: null,
      localidad: null,
      paises: null,
      isnum: null,
      actividad: [{
        text: "Si",
        value: true
      }, {
        text: "No",
        value: false
      }],

      item_empresas: {},
      list_empresas: [],
      item_empresasValidations: {
        nombre_empresa_sociedad_asociacion: {
          required: true
        },
        tipo_operacion_id: {
          required: true
        },
        frecuencia_anual_id: {
          required: true
        },
        frecuencia_anual_especificar: {
          required: true
        },
        persona_juridica: {
          required: true
        },
        otra_persona_juridica: {
          required: true
        },
        responsable_conflicto: {
          required: true
        },
        naturaleza_vinculo: {
          required: true
        },
        naturaleza_vinculo_especificar: {
          required: true
        },
        antiguedad_vinculo: {
          required: true
        },
        participacion: {
          required: true
        },
        tipo_colaboracion: {
          required: true
        },
        tipo_colaboracion_especificar: {
          required: true
        },
        es_publica: {
          required: true
        }
      },
      fields_list: [{
        key: "acciones",
        label: "Acciones",
        tdClass: "text-center"
      }, {
        key: "tipo_operacion_id",
        label: "Tipo de Operación",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "nombre_empresa_sociedad_asociacion",
        label: "Nombre de la empresa",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "frecuencia_anual_id",
        label: "Frecuencia Anual",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "frecuencia_anual_especificar",
        label: "Otra (Especifique)",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "persona_juridica",
        label: "Tipo de persona jurídica",
        tdClass: "text-center",
        formatter: "emptyFields"
      }, {
        key: "otra_persona_juridica",
        label: "Otra (Especifique)",
        tdClass: "text-right",
        formatter: "emptyFields"
      }, {
        key: "responsable_conflicto",
        label: "Responsable del posible conflicto de interés",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "naturaleza_vinculo",
        label: "Naturaleza del vínculo",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "naturaleza_vinculo_especificar",
        label: "Otro-Especificar",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "antiguedad_vinculo",
        label: "Antigüedad del vínculo (Años)",
        tdClass: "text-right",
        formatter: "emptyFields"
      }, {
        key: "participacion",
        label: "Participación en la dirección",
        tdClass: "text-center",
        formatter: "emptyFields"
      }, {
        key: "tipo_colaboracion",
        label: "Tipo de colaboración o aporte",
        tdClass: "text-center",
        formatter: "emptyFields"
      }, {
        key: "tipo_colaboracion_especificar",
        label: "Otros aportes(especifica)",
        tdClass: "text-center",
        formatter: "emptyFields"
      }, {
        key: "domicilio_pais_id",
        label: "Pais",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_entidad_federativa_id",
        label: "Entidad federativa",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_municipio_id",
        label: "Municipio",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_localidad_id",
        label: "Localidad",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_colonia",
        label: "Colonia",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_vialidad_tipo",
        label: "Tipo vialidad",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_vialidad_nombre",
        label: "Nombre vialidad",
        tdClass: "text-left",
        formatter: "emptyFields"
      }, {
        key: "domicilio_cp",
        label: "CP",
        tdClass: "text-right",
        formatter: "emptyFields"
      }, {
        key: "domicilio_numext",
        label: "Número Exterior",
        tdClass: "text-right",
        formatter: "emptyFields"
      }, {
        key: "domicilio_numint",
        label: "Número Interior",
        tdClass: "text-right",
        formatter: "emptyFields"
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["c" /* mapFields */])(["nombre_empresa_sociedad_asociacion", "tipo_operacion_id", "frecuencia_anual_id", "frecuencia_anual_especificar", "persona_juridica", "otra_persona_juridica", "responsable_conflicto", "naturaleza_vinculo", "naturaleza_vinculo_especificar", "antiguedad_vinculo", "participacion", "tipo_colaboracion", "tipo_colaboracion_especificar", "es_publica"])),
  watch: {
    n_domicilio: {
      handler: function handler() {
        if (this.n_domicilio) {
          this.item_empresas.domicilio_pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
          this.item_empresas.domicilio_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
          this.item_empresas.domicilio_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
          this.item_empresas.domicilio_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
          this.item_empresas.domicilio_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
          this.item_empresas.domicilio_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          this.item_empresas.domicilio_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
          this.item_empresas.domicilio_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
          this.item_empresas.domicilio_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
          this.item_empresas.domicilio_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
        }
      },
      deep: true
    },
    list_empresas: {
      handler: function handler() {
        if (this.list_empresas) {
          this.setLocalidades();
          if (this.list_empresas.length == 0) {
            this.bandera = "0";
          } else {
            this.bandera = "1";
          }
        }
      },
      deep: true
    },
    item_empresas: {
      handler: function handler() {
        if (this.item_empresas) {
          this.actividad_economica = "" + this.item_empresas.actividad_economica;
        }
      },
      deep: true
    },
    actividad_economica: function actividad_economica() {
      this.item_empresas.actividad_economica = this.actividad_economica;
    }
  },
  methods: {
    emptyFields: function emptyFields(value) {
      if (value) {
        if (typeof value === "string" || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return "-";
      }
    },
    getBool: function getBool(index) {
      var resp = "No";
      if (index == 1 || index == "1") {
        resp = "Si";
        return resp;
      }
      return resp;
    },
    getParticipacion: function getParticipacion(index) {
      var resp = "No";
      if (index == 1) {
        resp = "Antes del servicio público";
        return resp;
      } else {
        resp = "Después del servicio público";
        return resp;
      }
      return resp;
    },
    getSector: function getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad: function getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad: function getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio: function getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais: function getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getOperacion: function getOperacion(index) {
      var resp = " ";
      if (this.operaciones) {
        this.operaciones.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getFrecuencia: function getFrecuencia(index) {
      var resp = " ";
      if (this.frecuencias) {
        this.frecuencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getPersonas: function getPersonas(index) {
      var resp = " ";
      if (this.personas) {
        this.personas.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getResponsables: function getResponsables(index) {
      var resp = " ";
      if (this.responsables) {
        this.responsables.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getNaturalezas: function getNaturalezas(index) {
      var resp = " ";
      if (this.naturalezas) {
        this.naturalezas.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getColaboraciones: function getColaboraciones(index) {
      var resp = " ";
      if (this.colaboraciones) {
        this.colaboraciones.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem: function initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: "",
        municipio: "",
        localidad: "",
        cp: "",
        colonia: "",
        vialidad: "",
        vialidad_nombre: "",
        ext: "",
        int: ""
      };
      this.item_empresas = {
        acciones: "",
        actividad_economica: "1",
        nombre_empresa_sociedad_asociacion: "",
        pais_registro_id: 150,
        fecha_constitucion: "",
        numero_registro: "",
        rfc: "",
        rol: "",
        sector_industria_id: "",
        porcentaje_participacion: 100,
        domicilio_pais_id: 150,
        domicilio_entidad_federativa_id: "",
        domicilio_municipio_id: "",
        domicilio_localidad_id: "",
        domicilio_colonia: "",
        domicilio_cp: "",
        domicilio_numext: "",
        domicilio_numint: "",
        domicilio_vialidad_nombre: "",
        domicilio_vialidad_tipo: ""
      };
    },
    showItem: function showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit: function cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.item_empresas) {
            _this.item_empresas.ip_id = _this.ip_id;
            _this.loadButton(_this.$refs.btnSave);
            _this.$http.post("empresas", _this.item_empresas).then(function (response) {
              _this.StepOk("Guardado");
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.list_empresas.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.empresa));
              } else {
                _this.list_empresas.splice(_this.edit_item.index, 1, _this.item_empresas);
                _this.edit_item.item._rowVariant = "";
              }
              _this.initItem();
              _this.showItem();
              _this.edit_item = null;
            }, function (error) {
              _this.StepW(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_empresas = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.list_empresas[this.edit_item.index]);
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(indice) {
      var _this2 = this;

      if (this.list_empresas[indice].id !== null) {
        var item = this.list_empresas[indice];
        this.list_empresas.splice(indice, 1);
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("empresas/" + item.id).then(function (response) {
            _this2.list_empresas.splice(indice, 1);
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();

      if (this.add_item) {
        this.validaciones = {
          rfc: false
        };
        if (!this.rfcValido(this.item_empresas.rfc)) {
          this.validaciones.rfc = true;
          return false;
        }
      }
    },
    editDomicilio: function editDomicilio() {
      this.n_domicilio.pais_id = this.item_empresas.domicilio_pais_id ? this.item_empresas.domicilio_pais_id : 150;
      this.n_domicilio.entidadF = this.item_empresas.domicilio_entidad_federativa_id ? this.item_empresas.domicilio_entidad_federativa_id : "";
      this.n_domicilio.municipio = this.item_empresas.domicilio_municipio_id ? this.item_empresas.domicilio_municipio_id : "";
      this.n_domicilio.localidad = this.item_empresas.domicilio_localidad_id ? this.item_empresas.domicilio_localidad_id : "";
      this.n_domicilio.cp = this.item_empresas.domicilio_cp ? this.item_empresas.domicilio_cp : "";
      this.n_domicilio.colonia = this.item_empresas.domicilio_colonia ? this.item_empresas.domicilio_colonia : "";
      this.n_domicilio.vialidad = this.item_empresas.domicilio_vialidad_tipo ? this.item_empresas.domicilio_vialidad_tipo : "";
      this.n_domicilio.vialidad_nombre = this.item_empresas.domicilio_vialidad_nombre ? this.item_empresas.domicilio_vialidad_nombre : "";
      this.n_domicilio.ext = this.item_empresas.domicilio_numext ? this.item_empresas.domicilio_numext : "";
      this.n_domicilio.int = this.item_empresas.domicilio_numint ? this.item_empresas.domicilio_numint : "";
    },
    setLocalidades: function setLocalidades() {
      var _this3 = this;

      this.localidades = [];
      if (this.list_empresas) {
        this.list_empresas.forEach(function (item) {
          if (item.domicilio_localidad_id) {
            _this3.$http.get("localidades/localidad/" + item.domicilio_localidad_id).then(function (response) {
              _this3.localidades.push(response.data.localidad);
            }, function (error) {
              _this3.Err(error);
            });
          }
        });
      }
    },
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, "");
    }
  },
  created: function created() {
    var _this4 = this;

    this.initItem();

    this.$http.get("empresas/" + this.ip_id).then(function (response) {
      _this4.list_empresas = response.data.empresas;
      _this4.setLocalidades();
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("entidadFed").then(function (response) {
      _this4.entidadFed = response.data.entidadfed;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("paises").then(function (response) {
      _this4.paises = response.data.pais;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("municipios").then(function (response) {
      _this4.municipios = response.data.municipios;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_sector_industria").then(function (response) {
      _this4.sectores = response.data.sectores;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_tipo_operacion_interes").then(function (response) {
      _this4.operaciones = response.data.tipos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_frecuencia_anual").then(function (response) {
      _this4.frecuencias = response.data.tipos;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("getPersonas").then(function (response) {
      _this4.personas = response.data.personas;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("cat_titular").then(function (response) {
      _this4.responsables = response.data.titulares;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("getNaturalezas").then(function (response) {
      _this4.naturalezas = response.data.naturalezas;
    }, function (error) {
      _this4.Err(error);
    });
    this.$http.get("getColaboraciones").then(function (response) {
      _this4.colaboraciones = response.data.colaboraciones;
    }, function (error) {
      _this4.Err(error);
    });
    if (this.data) {}
  }
});

/***/ }),

/***/ "y3hG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("¿Recibe alguna contribución monetaria o en especie de una persona física o moral? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.beneficios),expression:"info.beneficios",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_c('div',{staticClass:"row"},[_c('legend',[_vm._v("Datos de los beneficios privados")]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Señalar quien recibe los beneficios "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.beneficiario),expression:"info.beneficiario",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción","name":"beneficiario"},model:{value:(_vm.form_item.beneficiario),callback:function ($$v) {_vm.$set(_vm.form_item, "beneficiario", $$v)},expression:"form_item.beneficiario"}},_vm._l((_vm.beneficiarios),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('beneficiario')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Beneficio "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo_beneficio),expression:"info.tipo_beneficio",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","placeholder":"Seleccione una opción","name":"tipo"},model:{value:(_vm.form_item.tipo_beneficio),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_beneficio", $$v)},expression:"form_item.tipo_beneficio"}},_vm._l((_vm.tipos_beneficios),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])],1),_vm._v(" "),(_vm.form_item.tipo_beneficio == '4')?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique),expression:"form_item.especifique"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Otorgante "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.otorgante),expression:"info.otorgante",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"otorgante","label":"1"},model:{value:(_vm.form_item.otorgante),callback:function ($$v) {_vm.$set(_vm.form_item, "otorgante", $$v)},expression:"form_item.otorgante"}},[_vm._v("Persona física")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"otorgante","label":"2"},model:{value:(_vm.form_item.otorgante),callback:function ($$v) {_vm.$set(_vm.form_item, "otorgante", $$v)},expression:"form_item.otorgante"}},[_vm._v("Persona moral")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('otorgante')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre o razón social del otorgante "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre),expression:"info.nombre",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre),expression:"form_item.nombre"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre","placeholder":"Nombre o razón social del otorgante "},domProps:{"value":(_vm.form_item.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc),expression:"info.rfc",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc),expression:"form_item.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc')))]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.validaciones.rfc),expression:"validaciones.rfc"}],staticClass:"text-danger"},[_vm._v(" El formato de la CURP no es válido, verifica la información ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Forma de recepción del beneficio "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.forma),expression:"info.forma",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"forma","label":"1"},model:{value:(_vm.form_item.forma),callback:function ($$v) {_vm.$set(_vm.form_item, "forma", $$v)},expression:"form_item.forma"}},[_vm._v("Monetario")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"forma","label":"2"},model:{value:(_vm.form_item.forma),callback:function ($$v) {_vm.$set(_vm.form_item, "forma", $$v)},expression:"form_item.forma"}},[_vm._v("Especie")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forma')))])],1),_vm._v(" "),(_vm.form_item.forma == '2')?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique el beneficio "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.beneficio),expression:"info.beneficio",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.beneficio),expression:"form_item.beneficio"}],staticClass:"form-control",attrs:{"type":"text","name":"beneficio","placeholder":"Especifique el beneficio"},domProps:{"value":(_vm.form_item.beneficio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "beneficio", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('beneficio')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6 "},[_c('label',{staticClass:"control-label"},[_vm._v("Monto mensual aproximado del beneficio "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.monto+' '+_vm.info.tipo_moneda),expression:"info.monto+' '+info.tipo_moneda",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"customCurrency"},[_c('b-input-group',{attrs:{"size":"sm","prepend":_vm.getSigno}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:1'),expression:"'required|min:1'"}],staticClass:"text-right",attrs:{"name":"monto","type":"number","min":"0","placeholder":"0"},nativeOn:{"keyup":function($event){return _vm.isNumber.apply(null, arguments)}},model:{value:(_vm.form_item.monto),callback:function ($$v) {_vm.$set(_vm.form_item, "monto", $$v)},expression:"form_item.monto"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"right":"","split":"","text":_vm.getCodigoMoneda},model:{value:(_vm.form_item.tipo_moneda),callback:function ($$v) {_vm.$set(_vm.form_item, "tipo_moneda", $$v)},expression:"form_item.tipo_moneda"}},_vm._l((_vm.monedas),function(option){return _c('b-dropdown-item',{key:option.codigo,attrs:{"value":option.codigo},on:{"click":function($event){_vm.form_item.tipo_moneda = option.id}}},[_vm._v(_vm._s(option.moneda))])}),1)],1)],1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('monto')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Sector productivo al que pertenece "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.sector),expression:"info.sector",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"sector","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.sector_industria_id),callback:function ($$v) {_vm.$set(_vm.form_item, "sector_industria_id", $$v)},expression:"form_item.sector_industria_id"}},_vm._l((_vm.sectores_industria),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('sector')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(1)])]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.beneficiario",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterBeneficiario(item.beneficiario)))])]}},{key:"item.tipo_beneficio",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipoBeneficio(item.tipo_beneficio)))])]}},{key:"item.forma",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterForma(item.forma)))])]}},{key:"item.otorgante",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterTipoPersona(item.otorgante)))])]}},{key:"item.sector_industria_id",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterSector(item.sector_industria_id)))])]}},{key:"item.monto",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(" "+_vm._s(_vm._f("currency")(item.monto)))])]}},{key:"item.tipo_moneda",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(" "+_vm._s(_vm.filterTipoMoneda(item.tipo_moneda)))])]}}],null,false,81839025)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("BENEFICIOS PRIVADOS (HASTA LOS ÚLTIMOS 2 AÑOS) ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yPee":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yQnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.add_item)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿Tiene participación en la toma de decisiones de alguna de estas instituciones? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.decisiones),expression:"info.decisiones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"1"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("Si")]),_vm._v(" "),_c('p-radio',{staticClass:"d-inline-block",attrs:{"label":"0"},model:{value:(_vm.bandera),callback:function ($$v) {_vm.bandera=$$v},expression:"bandera"}},[_vm._v("No")])],1)]):_vm._e(),_vm._v(" "),(_vm.bandera == '1')?_c('div',[(_vm.add_item)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('legend',[_vm._v("¿Participa en la toma de decisiones de alguna institución? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.participante),expression:"info.participante",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"participante","label":"1"},model:{value:(_vm.form_item.participante),callback:function ($$v) {_vm.$set(_vm.form_item, "participante", $$v)},expression:"form_item.participante"}},[_vm._v("Declarante")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"participante","label":"2"},model:{value:(_vm.form_item.participante),callback:function ($$v) {_vm.$set(_vm.form_item, "participante", $$v)},expression:"form_item.participante"}},[_vm._v("Pareja")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"participante","label":"3"},model:{value:(_vm.form_item.participante),callback:function ($$v) {_vm.$set(_vm.form_item, "participante", $$v)},expression:"form_item.participante"}},[_vm._v("Dependiente Económico")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('participante')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de institución "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.tipo),expression:"info.tipo",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"tipo","filterable":"","placeholder":"Seleccione una opción"},model:{value:(_vm.form_item.tipon_id),callback:function ($$v) {_vm.$set(_vm.form_item, "tipon_id", $$v)},expression:"form_item.tipon_id"}},_vm._l((_vm.tipos_instituciones),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])],1),_vm._v(" "),(_vm.form_item.tipon_id == 5)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Especifique")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.especifique),expression:"form_item.especifique"}],staticClass:"form-control",attrs:{"type":"text","name":"especifique","placeholder":"Especifique"},domProps:{"value":(_vm.form_item.especifique)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "especifique", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('especifique')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nombre de la institución "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.nombre),expression:"info.nombre",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.nombre),expression:"form_item.nombre"}],staticClass:"form-control",attrs:{"type":"text","name":"nombre","placeholder":"Nombre de la Empresa, Sociedad o Asociación"},domProps:{"value":(_vm.form_item.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "nombre", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('nombre')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("RFC "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.rfc),expression:"info.rfc",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|uppercase|max:13|rfc'),expression:"'required|uppercase|max:13|rfc'"},{name:"model",rawName:"v-model",value:(_vm.form_item.rfc),expression:"form_item.rfc"}],staticClass:"form-control",attrs:{"type":"text","name":"rfc","placeholder":"RFC"},domProps:{"value":(_vm.form_item.rfc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "rfc", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('rfc')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Puesto / Rol "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.puesto),expression:"info.puesto",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.form_item.puesto),expression:"form_item.puesto"}],staticClass:"form-control",attrs:{"type":"text","name":"puesto","placeholder":"Puesto o rol"},domProps:{"value":(_vm.form_item.puesto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "puesto", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('puesto')))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Fecha de inicio de participación dentro de la institución "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.fecha),expression:"info.fecha",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"fecha","type":"date","placeholder":"Seleccione fecha","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},model:{value:(_vm.form_item.fecha),callback:function ($$v) {_vm.$set(_vm.form_item, "fecha", $$v)},expression:"form_item.fecha"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('fecha')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"}),_vm._v(" "),_c('div',{staticClass:"col-6 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" ¿Recibe remuneración por su participación? "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.remunerado),expression:"info.remunerado",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_c('br'),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"remuneracion","label":"1"},model:{value:(_vm.form_item.remuneracion),callback:function ($$v) {_vm.$set(_vm.form_item, "remuneracion", $$v)},expression:"form_item.remuneracion"}},[_vm._v("SI")]),_vm._v(" "),_c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"d-inline-block",attrs:{"name":"remuneracion","label":"2"},model:{value:(_vm.form_item.remuneracion),callback:function ($$v) {_vm.$set(_vm.form_item, "remuneracion", $$v)},expression:"form_item.remuneracion"}},[_vm._v("NO")]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('remuneracion')))])],1),_vm._v(" "),(_vm.form_item.remuneracion=='1')?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Monto mensual neto "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.monto),expression:"info.monto",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('el-input-number',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:0'),expression:"'required|decimal:0'"}],attrs:{"name":"monto","controls-position":"right","min":0},model:{value:(_vm.form_item.monto),callback:function ($$v) {_vm.$set(_vm.form_item, "monto", $$v)},expression:"form_item.monto"}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('monto')))])],1):_vm._e(),_vm._v(" "),_c('legend',[_vm._v("Lugar donde se ubica "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.lugar),expression:"info.lugar",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" País ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"pais","filterable":"","placeholder":"País"},model:{value:(_vm.form_item.pais_id),callback:function ($$v) {_vm.$set(_vm.form_item, "pais_id", $$v)},expression:"form_item.pais_id"}},_vm._l((_vm.paises),function(option){return _c('el-option',{key:option.valor,staticClass:"select-default",attrs:{"value":option.id,"label":option.valor}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('pais')))])],1),_vm._v(" "),(_vm.form_item.pais_id==150)?_c('div',{staticClass:"form-group col-6"},[_c('label',{staticClass:"control-label"},[_vm._v(" Entidad Federativa ")]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"select-default",attrs:{"clearable":"","name":"entidad","filterable":"","placeholder":"Entidad"},model:{value:(_vm.form_item.entidad_federativa_id),callback:function ($$v) {_vm.$set(_vm.form_item, "entidad_federativa_id", $$v)},expression:"form_item.entidad_federativa_id"}},_vm._l((_vm.entidades),function(option){return _c('el-option',{key:option.nom_ent,staticClass:"select-default",attrs:{"value":option.id,"label":option.nom_ent}})}),1),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('entidad')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Aclaraciones / Observaciones "),_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.info.observaciones),expression:"info.observaciones",modifiers:{"hover":true,"top":true}}],staticClass:"btn-popover"},[_c('i',{staticClass:"far fa-question-circle"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_item.observaciones),expression:"form_item.observaciones"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Aclaraciones / Observaciones"},domProps:{"value":(_vm.form_item.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form_item, "observaciones", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addItem()}}},[(_vm.edit_item == null)?_c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")]):_c('span',[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger ml-3",on:{"click":function($event){$event.preventDefault();return _vm.cancelEdit()}}},[_vm._m(2)])]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.add_item)?_c('div',[_c('div',{staticClass:"row justify-content-end m-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.showItem()}}},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('v-text-field',{staticClass:"col-4 offset-8",attrs:{"append-icon":"fa-search","placeholder":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.table_list,"items-per-page":5,"search":_vm.search,"fixed-header":true},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{staticClass:"btn-s edit mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.editItem(item)}}},[_c('i',{staticClass:"fas fa-pencil-alt"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"btn-s delete",attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item)}}},[_c('i',{staticClass:"fas fa-times"})])],1)]}},{key:"item.participante",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.filterDeclarante(item.participante)))])]}}],null,false,3319404486)})],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"col-12 alert alert-info mb-0"},[_c('legend',{staticClass:"m-0"},[_vm._v("¿PARTICIPA EN LA TOMA DE DECISIONES DE ALGUNA DE ESTAS INSTITUCIONES? (HASTA LOS ÚLTIMOS 2 AÑOS) ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 alert alert-info"},[_vm._v(" Todos los datos de la participación en alguna de estas instituciones de la pareja o dependientes económicos no serán públicos. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Cancelar ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('hr',{staticClass:"col-md-12 bg-info"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ySqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "sign"],
  data: function data() {
    return {
      isInputActive: false
    };
  },

  computed: {
    displayValue: {
      get: function get() {
        if (this.isInputActive) {
          if (this.value) {
            return this.value.toString();
          }
        } else {
          var sign_ = '$';
          var val = 0;
          if (this.sign) {
            sign_ = this.sign;
          }
          if (this.value) {
            val = this.value;
          }

          return sign_ + " " + parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
        }
      },
      set: function set(modifiedValue) {
        var newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""));

        if (isNaN(newValue)) {
          newValue = 0;
        }

        this.$emit('input', newValue);
      }
    }

  },
  methods: {
    isNumber: function isNumber(n) {
      n.target.value = n.target.value.replace(/[^\d.-]/g, '');
    }
  }
});

/***/ }),

/***/ "ygZ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:'ti-' + _vm.icon})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ykVy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("vvmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("2sub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag__ = __webpack_require__("JSKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Domicilio_vue__ = __webpack_require__("Ta4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__("kDzH");








var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, "Domicilio", __WEBPACK_IMPORTED_MODULE_7__Domicilio_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      validaciones: {
        rfc: false
      },
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: "0",
      form_item: {},
      table_list: [],
      search: '',
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Propietario',
        value: 'propietario',
        align: 'center'
      }, {
        text: 'Nombre de la empresa',
        value: 'nombre',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Cliente principal',
        value: 'tipo_persona',
        align: 'center'
      }, {
        text: 'Nombre o razón social del cliente',
        value: 'nombre_cliente',
        align: 'center'
      }, {
        text: 'RFC del cliente',
        value: 'rfc_cliente',
        align: 'center'
      }, {
        text: 'Sector productivo',
        value: 'sector_industria_id',
        align: 'center'
      }, {
        text: 'Monto mensual neto',
        value: 'monto',
        align: 'center'
      }],
      info: {
        clientes: 'En caso de tener alguna empresa, negocio o actividad lucrativa deberá señalar a sus clientes principales, siempre y cuando el beneficio o ganancia directa al Declarante supere mensualmente 250 Unidades de Medida y Actualización (UMA), refiriéndose al valor diario de ésta. Deberá reportar hasta los últimos dos años.',
        propietario: 'Señalar si es del Declarante, Pareja o dependiente económico.',
        nombre: 'Señalar nombre o razón social completos de la empresa o en su caso el servicio que proporciona.',
        rfc: 'Establecer los doce dígitos de la empresa. Proporcionar los dígitos completos del registro federal de contribuyentes.',
        tipo_persona: 'Seleccionar si es persona física o persona moral.',
        nombre_cliente: 'Indicar el nombre o razón social completos del cliente principal.',
        rfc_cliente: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del cliente principal.',
        sector: 'Elegir el sector al que pertenece.',
        monto: 'Deberá señalar el monto neto sin centavos, de la ganancia que le genera el cliente principal.',
        lugar: 'Indicar si se encuentra en México, debiendo señalar entidad federativa; o en el extranjero, debiendo señalar el país donde se localiza.',
        observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.'
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    showItem: function showItem() {
      this.add_item = true;
      this.$validator.resume();
      if (!this.form_item.pais_id) {
        this.form_item.pais_id = 150;
      }
    },
    cancelEdit: function cancelEdit() {
      this.add_item = false;
      this.form_item = {};
      this.edit_item = null;
      this.$validator.pause();
    },
    addItem: function addItem() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response) {
          if (_this.form_item) {
            _this.loadButton(_this.$refs.btnSave);
            _this.form_item.ip_id = _this.ip_id;
            _this.$http.post("clientes_principales", _this.form_item).then(function (response) {
              if (_this.edit_item === undefined || _this.edit_item === null) {
                _this.table_list.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.response));
              } else {
                var index = _this.table_list.map(function (u) {
                  return u.id;
                }).indexOf(response.data.response.id);
                _this.table_list.splice(index, 1, response.data.response);
              }
              _this.cancelEdit();
            }, function (error) {
              _this.StepError(error);
            });
          }
        } else {
          _this.StepW("Hay campos sin completar");
        }
      });
    },
    editItem: function editItem(item) {
      this.showItem();
      this.edit_item = item;
      this.form_item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.edit_item);
      $(".main-panel").animate({
        scrollTop: 100
      }, 500, "swing");
    },
    removeItem: function removeItem(item) {
      var _this2 = this;

      if (item.id !== null) {
        this.Ask("Desea borrar este registro", function () {
          _this2.$http.delete("clientes_principales/" + item.id).then(function (response) {
            var index = _this2.table_list.map(function (u) {
              return u.id;
            }).indexOf(item.id);
            _this2.table_list.splice(index, 1);
            _this2.StepOk('Registro eliminado');
          }, function (error) {
            _this2.Err(error);
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.ip_id = this.getKey('uid');
    this.$http.get("clientes_principales/" + this.ip_id).then(function (response) {
      _this3.table_list = response.data.response;
      if (_this3.table_list) {
        if (_this3.table_list.length > 0) {
          _this3.bandera = '1';
        }
      }
    }, function (error) {
      _this3.Err(error);
    });
  },
  mounted: function mounted() {
    this.checkCatalogs();

    this.form_item.pais_id = 150;
  }
});

/***/ }),

/***/ "yu8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.$sidebar.sidebarLinks}}),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('tipo-dec'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ywIa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("Ov2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("nfjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("vern");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("RC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("7Jul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("KfLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("JqGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("2xJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("V2pR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("071w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("6aVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("Y3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("MzQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("k28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__("VbQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);














var _components;






/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), _components),
  data: function data() {
    var _ref;

    return _ref = {
      model: { tipo_declaracion: '', dependencia_id: '', periodo: '' },
      dependencias: {},
      rol: '',
      filter: null,
      currentPage: 1,
      perPage: 50,
      periodos: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'model', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'rows', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tiposDeclaracion', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'list_bitacora', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'filtro_usuarios', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pagination', {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      total: 0
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'searchQuery', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fields_list', [{
      text: 'RFC',
      align: 'center',
      sortable: false,
      value: 'rfc',
      class: 'text-center td-small'
    }, {
      text: 'Nombres',
      align: 'center',
      sortable: false,
      value: 'nombres',
      class: 'text-center td-small'
    }, {
      text: 'Dependencia',
      align: 'center',
      sortable: false,
      value: 'dependencia',
      class: 'text-center td-small'
    }, {
      text: 'Tipo de Declaración consultada',
      align: 'center',
      sortable: false,
      value: 'tipo_declaracion',
      class: 'text-center td-small'
    }, {
      text: 'Fecha de Declaración consultada',
      align: 'center',
      sortable: false,
      value: 'fecha_declaracion',
      class: 'text-center td-small'

    }, {
      text: 'Usuario',
      align: 'center',
      sortable: false,
      value: 'usuario',
      class: 'text-center td-small'
    }, {
      text: 'Consulta',
      align: 'center',
      sortable: false,
      value: 'fecha',
      class: 'text-center td-small'
    }]), _ref;
  },

  computed: {
    pagedData: function pagedData() {
      return this.list_bitacora.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.list_bitacora.length;
        return this.pagedData;
      }
      var result = this.list_bitacora.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.rows = this.list_bitacora.length;

      return this.list_bitacora.length;
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    checkPermissions: function checkPermissions() {
      var permiso = [1];
      if (!this.getKey('permisos').some(function (r) {
        return permiso.includes(r);
      })) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      }
    },
    getBitacora: function getBitacora() {
      var _this2 = this;

      this.$http.get("bitacorab/" + this.model.fecha_inicio + '/' + this.model.fecha_fin).then(function (response) {
        var v = _this2;
        v.list_bitacora = [];
        $.each(response.data.bitacora, function (key, value) {
          v.list_bitacora.push({ 'rfc': value.declarante.rfc,
            'nombres': value.declarante.nombres + ' ' + value.declarante.primer_apellido + ' ' + value.declarante.segundo_apellido,
            'dependencia': value.declarante.encargo.ente.valor,
            'usuario': value.usuario.Nombre + ' ' + value.usuario.Paterno + ' ' + value.usuario.Materno,
            'fecha': value.created_at
          });
        });
      }, function (error) {
        _this2.StepError(error);
      });
    },

    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  },
  created: function created() {
    this.rol = this.getKey('role');
    this.checkPermissions();
  }
});

/***/ }),

/***/ "z+sU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z0Ta":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zP5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_TipoDec_component_vue__ = __webpack_require__("EdBk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f891d9b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_TipoDec_component_vue__ = __webpack_require__("swa5");
function injectStyle (ssrContext) {
  __webpack_require__("Ymfc")
}
var normalizeComponent = __webpack_require__("q4ZX")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_script_index_0_TipoDec_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f891d9b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_vue_compiler_sfc_3_5_38_babel_core_6_26_3_supports_color_5_5_0_css_2032f58a3f37950ca5d333a581f11c52_node_modules_vue_loader_lib_selector_type_template_index_0_TipoDec_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zREl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zTke":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zl2A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zv8+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.29a47c9ce1e499a51082.js